var gg = Object.defineProperty;
var sg = Object.getPrototypeOf;
var ig = Reflect.get;
var Cn = (A) => {
  throw TypeError(A);
};
var Cg = (A, o, e) => o in A ? gg(A, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : A[o] = e;
var p = (A, o, e) => Cg(A, typeof o != "symbol" ? o + "" : o, e), ve = (A, o, e) => o.has(A) || Cn("Cannot " + e);
var q = (A, o, e) => (ve(A, o, "read from private field"), e ? e.call(A) : o.get(A)), SA = (A, o, e) => o.has(A) ? Cn("Cannot add the same private member more than once") : o instanceof WeakSet ? o.add(A) : o.set(A, e), iA = (A, o, e, t) => (ve(A, o, "write to private field"), t ? t.call(A, e) : o.set(A, e), e), we = (A, o, e) => (ve(A, o, "access private method"), e);
var ln = (A, o, e) => ig(sg(A), e, o);
import { DEFAULT_WOOCOMMERCE as lg, WoocommerceSchema as Bg } from "./wp/types/woocommerce.js";
import { useCustomMutation as eo, useApiUrl as jA, useInvalidate as kA, useList as Kg, useDelete as Qg, useInfiniteList as lr, useUpdate as wt, useDeleteMany as Fg, useCustom as cg } from "@refinedev/core";
import { jsx as C, jsxs as h, Fragment as k } from "react/jsx-runtime";
import "currency-symbol-map";
import { Empty as Vo, Form as j, Input as J, Switch as fg, Segmented as Ug, DatePicker as Ke, Spin as Br, Select as tA, Divider as ug, Button as D, Space as IA, message as AA, notification as Mo, Popconfirm as Kr, Tooltip as W, Typography as Qr, Result as Fr, Alert as to, Tabs as dg, Upload as Qe, Radio as yt, InputNumber as Eo, Checkbox as pg, Image as cr, Tag as fr } from "antd";
import qo from "dayjs";
import bt from "axios";
import { cn as Z, keyToWord as We, valueStringify as Ur, getTextContent as hg, renderHTML as Ht, getFileExtension as yo, isImageFile as Dt, isAudioFile as ur, isVideoFile as dr } from "./main/utils/common/index.js";
import { safeParse as mg } from "./main/utils/zod.js";
import { BooleanRadioButton as Pg } from "./main/components/BooleanRadioButton/index.js";
import "react-countdown";
/* empty css                */
/* empty css                */
import * as S from "react";
import { memo as x, useState as L, useContext as Nt, useEffect as $, createContext as pr, useRef as hr, useMemo as vg } from "react";
import { isNumber as Bn, isString as Kn, isNull as Qn, isUndefined as Fn, isBoolean as wg, uniqBy as mr, debounce as xt } from "lodash-es";
import "./main/components/SelectedRecord/index.js";
import "./main/components/Heading/index.js";
import "./wp/components/general/Upload/index.js";
import yg from "antd-img-crop";
import "./main/components/formItem/VideoLength/index.js";
import "./main/components/formItem/DoubleConfirmSwitch/index.js";
import { BlockNoteView as bg } from "@blocknote/mantine";
import { createReactBlockSpec as Fe, useCreateBlockNote as Hg, SuggestionMenuController as Dg, getDefaultReactSlashMenuItems as Ng, FormattingToolbarController as xg, FormattingToolbar as jg, BlockTypeSelect as kg, FileCaptionButton as Sg, FileReplaceButton as Rg, BasicTextStyleButton as so, TextAlignButton as ye, ColorStyleButton as Lg, NestBlockButton as Tg, UnnestBlockButton as Og, CreateLinkButton as Xg } from "@blocknote/react";
import { insertOrUpdateBlock as ce, BlockNoteSchema as zg, defaultBlockSpecs as Ig, getNearestBlockPos as Gg, filterSuggestionItems as Wg } from "@blocknote/core";
import { G as BA, F as Vg, M as Mg, a as Eg, b as qg, c as Jg } from "./index-DZ8sqWGp.js";
import { isLegacy as jt, toFlexAlign as Zg, getEditorHtml as Pr } from "./main/components/editor/BlockNote/utils/parse.js";
import { useEnv as bo } from "./main/components/EnvProvider/index.js";
import { PopconfirmDelete as vr } from "./main/components/PopconfirmDelete/index.js";
import "./main/components/WatchStatusTag/index.js";
import "./main/components/TrendIndicator/index.js";
import { SimpleModal as wr } from "./main/components/SimpleModal/index.js";
import { SimpleDrawer as yr } from "./main/components/SimpleDrawer/index.js";
import "./main/components/Portal/index.js";
import { useColor as Yg } from "./main/hooks/useColor.js";
import "react-highlight-words";
import "./refine/components/FilterTags/index.js";
import { useWindowSize as _g } from "@uidotdev/usehooks";
import { useSelect as br, DeleteButton as Hr } from "@refinedev/antd";
import { R as kt, f as $g } from "./index-DLqq4QAZ.js";
import "./refine/components/UpdateBoundItems/index.js";
import "./wp/components/formItem/FileUpload/index.js";
import { I as E } from "./AntdIcon-DR2yozD3.js";
import "./wp/components/product/ProductTotalSales/index.js";
import "./wp/components/product/ProductCat/index.js";
import { R as As } from "./index-COejjRVH.js";
import "./wp/components/user/UserAvatarUpload/index.js";
import { R as os } from "./index-D1PyB4Ka.js";
import { stringToBool as Fo } from "./wp/utils/woocommerce/index.js";
import { BOOLEAN_OPTIONS_REVERSE as es, PRODUCT_STATUS as ts } from "./wp/utils/wordpress/index.js";
import "./refine/components/UpdateGrantedUsers/index.js";
import { formatDatePickerValue as io, formatRangePickerValue as ns, parseDatePickerValue as rs, parseRangePickerValue as as } from "./main/utils/dayjs.js";
import { isVariation as gs, productKeyLabelMapper as oA, BACKORDERS as ss, PRODUCT_STOCK_STATUS as is, PRODUCT_DATE_FIELDS as Cs } from "./wp/utils/woocommerce/product.js";
import { generateSort as Jo } from "./refine/dataProvider/utils/generateSort.js";
import St from "query-string";
import { useAtom as Dr, atom as ls, useSetAtom as Bs } from "jotai";
import { useMediaLibraryModal as Nr } from "./refine/bunny/MediaLibraryModal/hooks/index.js";
import { getYoutubeVideoId as Ks, getVimeoVideoId as Qs, getVideoUrl as Fs, getEstimateUploadTimeInSeconds as cs } from "./main/utils/video.js";
import { useProps as Rt, MediaLibraryContext as fs } from "./refine/bunny/MediaLibrary/hooks/useProps.js";
import { C as xr, R as Lt } from "./index-DBElCiNo.js";
import { CheckIcon as Tt } from "./main/components/CheckIcon/index.js";
import { useOptions as Us } from "./refine/bunny/MediaLibrary/hooks/useOptions.js";
import { useSave as us } from "./refine/bunny/MediaLibrary/hooks/useSave.js";
import ds from "./refine/bunny/MediaLibrary/UploadVideo/index.js";
import { useMediaLibraryModal as ps } from "./wp/components/general/MediaLibraryModal/hooks/index.js";
import { useProps as Ot, MediaLibraryContext as hs } from "./wp/components/general/MediaLibrary/hooks/useProps.js";
import { ExtIcon as Xt } from "./main/components/ExtIcon/index.js";
import ms from "./wp/components/general/MediaLibrary/List/UploadFile/index.js";
import { R as Ps } from "./SearchOutlined-BV3iL0xn.js";
import vs from "./refine/components/ProductFilter/MobileFilter/index.js";
import { useSimpleDrawer as jr } from "./main/components/SimpleDrawer/hooks.js";
import { R as ws } from "./CloseCircleFilled-PXbhInq_.js";
import { R as fe } from "./DeleteOutlined-DKErSiw6.js";
import { Image as ys } from "./main/components/editor/BlockNote/CustomBlocks/MediaLibrary/Render/Image.js";
import { AltIcon as bs } from "./main/components/AltIcon/index.js";
import kr from "./main/components/formItem/VideoInput/Iframe.js";
import Hs from "./main/components/formItem/VideoInput/Code.js";
import { R as Ds } from "./InboxOutlined-LIC7h0yH.js";
import "./main/utils/api/index.js";
import { ActionButton as Ns } from "./main/components/ActionButton/index.js";
var xs = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, name: "align-center", theme: "outlined" };
function Ve() {
  return Ve = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, Ve.apply(this, arguments);
}
const js = (A, o) => /* @__PURE__ */ S.createElement(E, Ve({}, A, {
  ref: o,
  icon: xs
})), zt = /* @__PURE__ */ S.forwardRef(js);
process.env.NODE_ENV !== "production" && (zt.displayName = "AlignCenterOutlined");
var ks = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, name: "align-left", theme: "outlined" };
function Me() {
  return Me = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, Me.apply(this, arguments);
}
const Ss = (A, o) => /* @__PURE__ */ S.createElement(E, Me({}, A, {
  ref: o,
  icon: ks
})), It = /* @__PURE__ */ S.forwardRef(Ss);
process.env.NODE_ENV !== "production" && (It.displayName = "AlignLeftOutlined");
var Rs = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, name: "align-right", theme: "outlined" };
function Ee() {
  return Ee = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, Ee.apply(this, arguments);
}
const Ls = (A, o) => /* @__PURE__ */ S.createElement(E, Ee({}, A, {
  ref: o,
  icon: Rs
})), Gt = /* @__PURE__ */ S.forwardRef(Ls);
process.env.NODE_ENV !== "production" && (Gt.displayName = "AlignRightOutlined");
var Ts = { icon: function(o, e) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", fill: o } }, { tag: "path", attrs: { d: "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z", fill: e } }, { tag: "path", attrs: { d: "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z", fill: o } }] };
}, name: "check-circle", theme: "twotone" };
function qe() {
  return qe = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, qe.apply(this, arguments);
}
const Os = (A, o) => /* @__PURE__ */ S.createElement(E, qe({}, A, {
  ref: o,
  icon: Ts
})), Sr = /* @__PURE__ */ S.forwardRef(Os);
process.env.NODE_ENV !== "production" && (Sr.displayName = "CheckCircleTwoTone");
var Xs = { icon: function(o, e) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", fill: o } }, { tag: "path", attrs: { d: "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 01-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z", fill: e } }, { tag: "path", attrs: { d: "M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z", fill: o } }] };
}, name: "close-circle", theme: "twotone" };
function Je() {
  return Je = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, Je.apply(this, arguments);
}
const zs = (A, o) => /* @__PURE__ */ S.createElement(E, Je({}, A, {
  ref: o,
  icon: Xs
})), Rr = /* @__PURE__ */ S.forwardRef(zs);
process.env.NODE_ENV !== "production" && (Rr.displayName = "CloseCircleTwoTone");
var Is = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z" } }] }, name: "cloud", theme: "filled" };
function Ze() {
  return Ze = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, Ze.apply(this, arguments);
}
const Gs = (A, o) => /* @__PURE__ */ S.createElement(E, Ze({}, A, {
  ref: o,
  icon: Is
})), Lr = /* @__PURE__ */ S.forwardRef(Gs);
process.env.NODE_ENV !== "production" && (Lr.displayName = "CloudFilled");
var Ws = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 01-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 01140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0166.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z" } }] }, name: "cloud", theme: "outlined" };
function Ye() {
  return Ye = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, Ye.apply(this, arguments);
}
const Vs = (A, o) => /* @__PURE__ */ S.createElement(E, Ye({}, A, {
  ref: o,
  icon: Ws
})), Tr = /* @__PURE__ */ S.forwardRef(Vs);
process.env.NODE_ENV !== "production" && (Tr.displayName = "CloudOutlined");
var Ms = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" };
function _e() {
  return _e = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, _e.apply(this, arguments);
}
const Es = (A, o) => /* @__PURE__ */ S.createElement(E, _e({}, A, {
  ref: o,
  icon: Ms
})), Wt = /* @__PURE__ */ S.forwardRef(Es);
process.env.NODE_ENV !== "production" && (Wt.displayName = "ExclamationCircleFilled");
var qs = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 912H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h360c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8H184v656h656V520c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8v360c0 17.7-14.3 32-32 32zM770.87 199.13l-52.2-52.2a8.01 8.01 0 014.7-13.6l179.4-21c5.1-.6 9.5 3.7 8.9 8.9l-21 179.4c-.8 6.6-8.9 9.4-13.6 4.7l-52.4-52.4-256.2 256.2a8.03 8.03 0 01-11.3 0l-42.4-42.4a8.03 8.03 0 010-11.3l256.1-256.3z" } }] }, name: "export", theme: "outlined" };
function $e() {
  return $e = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, $e.apply(this, arguments);
}
const Js = (A, o) => /* @__PURE__ */ S.createElement(E, $e({}, A, {
  ref: o,
  icon: qs
})), Ho = /* @__PURE__ */ S.forwardRef(Js);
process.env.NODE_ENV !== "production" && (Ho.displayName = "ExportOutlined");
var Zs = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" };
function At() {
  return At = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, At.apply(this, arguments);
}
const Ys = (A, o) => /* @__PURE__ */ S.createElement(E, At({}, A, {
  ref: o,
  icon: Zs
})), Vt = /* @__PURE__ */ S.forwardRef(Ys);
process.env.NODE_ENV !== "production" && (Vt.displayName = "EyeOutlined");
var _s = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" };
function ot() {
  return ot = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, ot.apply(this, arguments);
}
const $s = (A, o) => /* @__PURE__ */ S.createElement(E, ot({}, A, {
  ref: o,
  icon: _s
})), Or = /* @__PURE__ */ S.forwardRef($s);
process.env.NODE_ENV !== "production" && (Or.displayName = "InfoCircleFilled");
var Ai = { icon: function(o, e) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", fill: o } }, { tag: "path", attrs: { d: "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", fill: e } }, { tag: "path", attrs: { d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z", fill: o } }] };
}, name: "info-circle", theme: "twotone" };
function et() {
  return et = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, et.apply(this, arguments);
}
const oi = (A, o) => /* @__PURE__ */ S.createElement(E, et({}, A, {
  ref: o,
  icon: Ai
})), Xr = /* @__PURE__ */ S.forwardRef(oi);
process.env.NODE_ENV !== "production" && (Xr.displayName = "InfoCircleTwoTone");
var ei = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M574 665.4a8.03 8.03 0 00-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 00-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 000 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 000 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 00-11.3 0L372.3 598.7a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z" } }] }, name: "link", theme: "outlined" };
function tt() {
  return tt = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, tt.apply(this, arguments);
}
const ti = (A, o) => /* @__PURE__ */ S.createElement(E, tt({}, A, {
  ref: o,
  icon: ei
})), zr = /* @__PURE__ */ S.forwardRef(ti);
process.env.NODE_ENV !== "production" && (zr.displayName = "LinkOutlined");
var ni = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z" } }] }, name: "setting", theme: "outlined" };
function nt() {
  return nt = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, nt.apply(this, arguments);
}
const ri = (A, o) => /* @__PURE__ */ S.createElement(E, nt({}, A, {
  ref: o,
  icon: ni
})), Ir = /* @__PURE__ */ S.forwardRef(ri);
process.env.NODE_ENV !== "production" && (Ir.displayName = "SettingOutlined");
var ai = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" } }] }, name: "star", theme: "filled" };
function rt() {
  return rt = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, rt.apply(this, arguments);
}
const gi = (A, o) => /* @__PURE__ */ S.createElement(E, rt({}, A, {
  ref: o,
  icon: ai
})), Gr = /* @__PURE__ */ S.forwardRef(gi);
process.env.NODE_ENV !== "production" && (Gr.displayName = "StarFilled");
var si = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z" } }] }, name: "star", theme: "outlined" };
function at() {
  return at = Object.assign ? Object.assign.bind() : function(A) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    }
    return A;
  }, at.apply(this, arguments);
}
const ii = (A, o) => /* @__PURE__ */ S.createElement(E, at({}, A, {
  ref: o,
  icon: si
})), Wr = /* @__PURE__ */ S.forwardRef(ii);
process.env.NODE_ENV !== "production" && (Wr.displayName = "StarOutlined");
const Ci = "data:image/jpeg;base64,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", wA = {
  placeholder: "搜尋",
  className: "at-w-full",
  allowClear: !0,
  showSearch: !0,
  mode: "multiple",
  optionRender: ({ value: A, label: o }) => /* @__PURE__ */ C(me, { name: o, id: A }),
  optionFilterProp: "label"
}, vf = {
  radioGroupProps: {
    size: "small"
  }
}, wf = {
  size: "small",
  rowKey: "id",
  bordered: !0,
  sticky: !0
}, yf = ({
  dataSource: A,
  dataIndex: o,
  dataFrom: e = "local",
  exactMatch: t = !1
}) => ({
  filters: e === "local" ? A.map((a) => ({
    text: a.label,
    value: ((a == null ? void 0 : a.value) || "").toString()
  })) : A.map((a) => ({
    text: (a == null ? void 0 : a[o]) || "",
    value: ((a == null ? void 0 : a[o]) || "").toString()
  })),
  onFilter: (a, g) => {
    switch (typeof g[o]) {
      case "string":
        return t ? ((g == null ? void 0 : g[o]) || "") === a : ((g == null ? void 0 : g[o]) || "").indexOf(a) === 0;
      case "number":
        return t ? ((g == null ? void 0 : g[o]) || "").toString() === a : ((g == null ? void 0 : g[o]) || "").toString().indexOf(a) === 0;
      case "boolean":
        return ((g == null ? void 0 : g[o]) || "").toString() === a;
      default:
        return !1;
    }
  }
}), bf = ({
  label: A = "商品"
}) => ({
  position: ["bottomCenter"],
  size: "default",
  showSizeChanger: !0,
  showQuickJumper: !0,
  showTitle: !0,
  showTotal: (o, e) => `目前顯示第 ${e == null ? void 0 : e[0]} ~ ${e == null ? void 0 : e[1]} 個 ${A}，總共有 ${o} 個 ${A}`
}), Hf = (A, o, e) => {
  const t = (A == null ? void 0 : A[o]) || [null, null], n = qo.isDayjs(t[0]) ? t[0].unix() : t[0], r = qo.isDayjs(t[1]) ? t[1].unix() : t[1], a = e[0], g = e[1];
  return {
    ...A,
    [a]: n,
    [g]: r,
    sale_date_range: void 0
  };
}, YA = Ci, Df = "https://placehold.co/480x270?text=%3CIMG%20/%3E", Nf = "https://picsum.photos/480/270", Zo = ({
  children: A = "LOADING...",
  className: o = "at-aspect-video",
  ...e
}) => /* @__PURE__ */ C(
  "div",
  {
    className: Z(
      "at-w-full at-bg-gray-200 at-animate-pulse at-rounded-lg at-relative at-mb-[10px] at-text-gray-500 at-flex at-items-center at-justify-center",
      o
    ),
    ...e,
    children: A
  }
), li = ({
  record: A,
  columns: o,
  editable: e = !1,
  className: t,
  actionButtonProps: n
}) => {
  const [r, a] = L(!1);
  if (!A) return /* @__PURE__ */ C(Vo, { image: Vo.PRESENTED_IMAGE_SIMPLE });
  const g = Object.entries(A).map(([i, l]) => {
    if (Bn(l) || Kn(l) || Qn(l) || Fn(l) || wg(l))
      return {
        key: i,
        title: We(i),
        dataIndex: i
      };
    if (Array.isArray(l) && (l || []).every(
      (B) => Bn(B) || Kn(B) || Qn(B) || Fn(B)
    ))
      return {
        key: i,
        title: We(i),
        dataIndex: i,
        render: (B, K, F) => e && r ? /* @__PURE__ */ C(
          j.Item,
          {
            className: "at-m-0",
            name: [i],
            initialValue: K == null ? void 0 : K[i],
            children: /* @__PURE__ */ C(J, {})
          }
        ) : B.join(", ")
      };
  }).filter((i) => !!i), s = (i, l) => {
    var F;
    const B = i == null ? void 0 : i.render, K = i == null ? void 0 : i.dataIndex;
    return B ? B(A == null ? void 0 : A[K], A, l, e) : e ? /* @__PURE__ */ h(k, { children: [
      !r && ((F = A == null ? void 0 : A[K]) == null ? void 0 : F.toString()),
      /* @__PURE__ */ C(
        j.Item,
        {
          className: "at-m-0",
          hidden: !r,
          name: [K],
          initialValue: A == null ? void 0 : A[K],
          children: /* @__PURE__ */ C(J, {})
        }
      )
    ] }) : Ur(A == null ? void 0 : A[K]);
  };
  return /* @__PURE__ */ h(k, { children: [
    e && /* @__PURE__ */ C("div", { className: "at-flex at-justify-end at-mb-4", children: /* @__PURE__ */ C(
      Ns,
      {
        onEdit: () => a(!0),
        onCancel: () => a(!1),
        canDelete: !1,
        ...n
      }
    ) }),
    /* @__PURE__ */ C(
      "table",
      {
        className: Z(
          "table table-xs table-vertical at-mb-4 [&_th]:at-text-left at-w-full",
          t
        ),
        children: /* @__PURE__ */ C("tbody", { children: (o || g).map((i, l) => /* @__PURE__ */ h("tr", { children: [
          /* @__PURE__ */ C("th", { children: /* @__PURE__ */ C("div", { children: i == null ? void 0 : i.title }) }),
          /* @__PURE__ */ C("td", { className: "at-break-all", children: s(i, l) })
        ] }, i == null ? void 0 : i.key)) })
      }
    )
  ] });
}, Bi = x(li), Ki = ({
  render: A,
  className: o = "w-full",
  ratio: e = "at-aspect-video",
  src: t = YA,
  loadingClassName: n = "text-xl text-gray-500 font-bold",
  ...r
}) => /* @__PURE__ */ h("div", { className: Z("at-relative", o, e), ...r, children: [
  A || /* @__PURE__ */ C(
    "img",
    {
      src: t,
      loading: "lazy",
      className: `at-relative at-z-10 at-w-full ${e} at-object-cover`
    }
  ),
  /* @__PURE__ */ C(
    "div",
    {
      className: `at-absolute at-z-[5] at-top-0 at-left-0 at-w-full ${e} at-bg-gray-200 at-animate-pulse at-flex at-items-center at-justify-center ${n}`,
      children: "LOADING..."
    }
  )
] }), Yo = x(
  Ki
), { Item: Qi } = j, Fi = ({ formItemProps: A, switchProps: o }) => /* @__PURE__ */ C(
  Qi,
  {
    getValueProps: (e) => Fo(e) ? { checked: !0 } : {},
    normalize: (e) => Fo(e) ? "yes" : "no",
    ...A,
    children: /* @__PURE__ */ C(fg, { ...o })
  }
), xf = x(Fi), { Item: ci } = j, fi = ({ formItemProps: A, segmentedProps: o }) => /* @__PURE__ */ C(ci, { ...A, children: /* @__PURE__ */ C(
  Ug,
  {
    block: !0,
    className: "at-w-full",
    options: es,
    ...o
  }
) }), jf = x(fi), Ui = (A) => /* @__PURE__ */ C(
  kr,
  {
    type: "youtube",
    formItemProps: A,
    getVideoId: Ks,
    getEmbedVideoUrl: (t) => t ? `https://www.youtube.com/embed/${t}` : "",
    getVideoUrl: (t, n) => n ? new URL(n).hostname === "youtu.be" ? `https://youtu.be/${t}` : `https://www.youtube.com/watch?v=${t}` : t ? `https://www.youtube.com/watch?v=${t}` : "",
    exampleUrl: "https://www.youtube.com/watch?v=fqcPIPczRVA"
  }
), ui = (A) => /* @__PURE__ */ C(
  kr,
  {
    type: "vimeo",
    formItemProps: A,
    getVideoId: Qs,
    getEmbedVideoUrl: (t) => t ? `https://player.vimeo.com/video/${t}?h=f741860ba7&color=a6a8a8&title=0&byline=0&portrait=0` : "",
    getVideoUrl: (t) => t ? `https://vimeo.com/${t}` : "",
    exampleUrl: "https://vimeo.com/900151069"
  }
);
function di(A) {
  return BA({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2m6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z" }, child: [] }] })(A);
}
function pi(A) {
  return BA({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z" }, child: [] }, { tag: "path", attr: { d: "M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z" }, child: [] }, { tag: "path", attr: { d: "M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06" }, child: [] }] })(A);
}
function hi(A) {
  return BA({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" }, child: [] }, { tag: "path", attr: { fillRule: "evenodd", d: "M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" }, child: [] }] })(A);
}
function mi(A) {
  return BA({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708z" }, child: [] }, { tag: "path", attr: { fillRule: "evenodd", d: "M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" }, child: [] }] })(A);
}
const { Item: CA } = j, { RangePicker: Pi } = Ke, vi = ({ searchFormProps: A }) => {
  const [o, e] = L(!1), t = A.form, n = () => {
    t.resetFields(), t.submit();
  }, { isLoading: r, ...a } = Nt(gt), { product_cats: g = [], product_tags: s = [], max_price: i, min_price: l } = a, { product_types: B } = ko(), K = B.map((Q) => Q.value === "simple" ? {
    ...Q,
    label: `${Q.label} (單選項商品)`
  } : Q.value === "variable" ? {
    ...Q,
    label: `${Q.label} (多選項商品)`
  } : Q).filter((Q) => {
    var f;
    return !gs((f = Q == null ? void 0 : Q.value) == null ? void 0 : f.toString());
  });
  $(() => {
    r || t.setFieldValue(["price_range"], [l, i]);
  }, [r]);
  const { selectProps: F } = br({
    resource: "users",
    optionLabel: "display_name",
    optionValue: "id",
    filters: [
      {
        field: "search",
        operator: "eq",
        value: ""
      }
    ],
    onSearch: (Q) => [
      {
        field: "search",
        operator: "eq",
        value: Q
      }
    ]
  });
  return /* @__PURE__ */ C(Br, { spinning: r, children: /* @__PURE__ */ h(
    j,
    {
      ...A,
      layout: "vertical",
      initialValues: yi,
      className: "antd-form-sm",
      children: [
        /* @__PURE__ */ h("div", { className: "at-grid at-grid-cols-2 xl:at-grid-cols-4 at-gap-x-4", children: [
          /* @__PURE__ */ C(CA, { name: ["s"], label: oA("s"), children: /* @__PURE__ */ C(J, { placeholder: "模糊搜尋", allowClear: !0 }) }),
          /* @__PURE__ */ C(CA, { name: ["type"], label: oA("type"), children: /* @__PURE__ */ C(
            tA,
            {
              ...wA,
              options: K,
              placeholder: "可多選"
            }
          ) }),
          /* @__PURE__ */ C(
            CA,
            {
              name: ["product_category_id"],
              label: oA("product_category_id"),
              children: /* @__PURE__ */ C(
                tA,
                {
                  ...wA,
                  options: g,
                  placeholder: "可多選"
                }
              )
            }
          ),
          /* @__PURE__ */ C(CA, { name: ["status"], label: oA("status"), children: /* @__PURE__ */ C(
            tA,
            {
              ...wA,
              options: ts,
              placeholder: "可多選"
            }
          ) })
        ] }),
        /* @__PURE__ */ C(ug, { plain: !0, className: "at-my-2", children: /* @__PURE__ */ C(
          D,
          {
            type: "link",
            onClick: () => {
              e(!o);
            },
            children: o ? /* @__PURE__ */ h(k, { children: [
              "隱藏篩選條件",
              " ",
              /* @__PURE__ */ C(mi, { className: "at-text-xs at-ml-2" })
            ] }) : /* @__PURE__ */ h(k, { children: [
              "顯示更多篩選條件",
              " ",
              /* @__PURE__ */ C(hi, { className: "at-text-xs at-ml-2" })
            ] })
          }
        ) }),
        /* @__PURE__ */ h(
          "div",
          {
            className: `at-grid-cols-2 xl:at-grid-cols-4 at-gap-x-4 ${o ? "at-grid" : "at-tw-hidden"}`,
            children: [
              /* @__PURE__ */ C(
                CA,
                {
                  name: ["product_tag_id"],
                  label: oA("product_tag_id"),
                  children: /* @__PURE__ */ C(
                    tA,
                    {
                      ...wA,
                      options: s,
                      placeholder: "可多選"
                    }
                  )
                }
              ),
              [
                "featured",
                "downloadable",
                "virtual",
                "sold_individually"
              ].map((Q) => /* @__PURE__ */ C(
                Pg,
                {
                  formItemProps: {
                    name: [Q],
                    label: oA(Q)
                  }
                },
                Q
              )),
              /* @__PURE__ */ C(
                CA,
                {
                  name: ["backorders"],
                  label: oA("backorders"),
                  children: /* @__PURE__ */ C(
                    tA,
                    {
                      ...wA,
                      options: ss,
                      placeholder: "可多選"
                    }
                  )
                }
              ),
              /* @__PURE__ */ C(
                CA,
                {
                  name: ["stock_status"],
                  label: oA("stock_status"),
                  children: /* @__PURE__ */ C(
                    tA,
                    {
                      ...wA,
                      options: is,
                      placeholder: "可多選"
                    }
                  )
                }
              ),
              /* @__PURE__ */ C(
                CA,
                {
                  name: ["date_created"],
                  label: oA("date_created"),
                  children: /* @__PURE__ */ C(
                    Pi,
                    {
                      placeholder: ["開始日期", "結束日期"],
                      className: "at-w-full"
                    }
                  )
                }
              ),
              /* @__PURE__ */ C(CA, { name: ["sku"], label: oA("sku"), children: /* @__PURE__ */ C(J, { placeholder: "模糊搜尋", allowClear: !0 }) }),
              /* @__PURE__ */ C(CA, { name: ["author"], label: oA("author"), children: /* @__PURE__ */ C(
                tA,
                {
                  ...wA,
                  ...F,
                  placeholder: "選擇作者",
                  mode: void 0
                }
              ) }),
              /* @__PURE__ */ C(CA, { name: ["include"], label: oA("include"), children: /* @__PURE__ */ C(tA, { mode: "tags", placeholder: "輸入商品 ID", allowClear: !0 }) })
            ]
          }
        ),
        /* @__PURE__ */ h("div", { className: "at-grid at-grid-cols-2 xl:at-grid-cols-4 at-gap-x-4 at-mt-4", children: [
          /* @__PURE__ */ C(
            D,
            {
              htmlType: "submit",
              type: "primary",
              className: "at-w-full",
              icon: /* @__PURE__ */ C(Ps, {}),
              children: "篩選"
            }
          ),
          /* @__PURE__ */ C(
            D,
            {
              type: "default",
              className: "at-w-full",
              onClick: n,
              icon: /* @__PURE__ */ C(os, {}),
              children: "重置"
            }
          )
        ] })
      ]
    }
  ) });
}, cn = x(vi), wi = {
  product_cats: [],
  product_tags: [],
  product_shipping_classes: [],
  product_brands: [],
  top_sales_products: [],
  max_price: 0,
  min_price: 0,
  isLoading: !1
}, yi = {
  status: [],
  featured: "",
  downloadable: "",
  virtual: "",
  sold_individually: ""
}, gt = pr(
  wi
), bi = ({ searchFormProps: A, options: o, mobileWidth: e = 810 }) => {
  const { width: t = 1920 } = _g();
  return (t ? t < e : !1) ? /* @__PURE__ */ C(vs, { children: /* @__PURE__ */ C(gt.Provider, { value: o, children: /* @__PURE__ */ C(cn, { searchFormProps: A }) }) }) : /* @__PURE__ */ C(gt.Provider, { value: o, children: /* @__PURE__ */ C(cn, { searchFormProps: A }) });
}, kf = x(bi), Hi = ({
  product_ids: A,
  meta_key: o,
  useSelectProps: e,
  selectProps: t,
  url: n,
  useCustomMutationParams: r,
  label: a = "",
  useInvalidateProp: g
}) => {
  const { selectProps: s, itemIds: i } = ag({
    selectProps: t,
    useSelectProps: e
  }), { mutate: l, isLoading: B } = eo(), K = jA(), F = kA(), Q = j.useFormInstance(), f = e.resource, c = () => {
    const { limit_type: U, limit_value: u, limit_unit: d } = Q.getFieldsValue();
    l(
      {
        url: n || `${K}/products/bind-items`,
        method: "post",
        values: {
          product_ids: A,
          item_ids: i,
          meta_key: o,
          limit_type: U,
          limit_value: u,
          limit_unit: d
        },
        config: {
          headers: {
            "Content-Type": "multipart/form-data;"
          }
        },
        ...r
      },
      {
        onSuccess: () => {
          AA.success({
            content: `綁定${a}成功！`,
            key: `bind-${f}`
          }), F({
            resource: "products",
            invalidates: ["list"],
            ...g
          });
        },
        onError: () => {
          AA.error({
            content: `綁定${a}失敗！`,
            key: `bind-${f}`
          });
        }
      }
    );
  };
  return /* @__PURE__ */ h(k, { children: [
    a && /* @__PURE__ */ C("label", { className: "tw-block mb-2", children: a }),
    /* @__PURE__ */ h(IA.Compact, { className: "w-full", children: [
      /* @__PURE__ */ C(tA, { ...s }),
      /* @__PURE__ */ h(
        D,
        {
          type: "primary",
          loading: B,
          disabled: !A.length || !i.length,
          onClick: c,
          children: [
            "綁定其他",
            a
          ]
        }
      )
    ] })
  ] });
}, Sf = x(Hi), Di = ({
  url: A,
  product_ids: o,
  item_ids: e,
  meta_key: t,
  onSettled: n,
  useCustomMutationParams: r,
  label: a = "",
  useInvalidateProp: g
}) => {
  const s = jA(), i = kA(), { mutate: l, isLoading: B } = eo(), K = () => {
    l(
      {
        url: A || `${s}/products/unbind-items`,
        method: "post",
        values: {
          product_ids: o,
          item_ids: e,
          meta_key: t
        },
        config: {
          headers: {
            "Content-Type": "multipart/form-data;"
          }
        },
        ...r
      },
      {
        onSuccess: () => {
          AA.success({
            content: "解除綁定成功！",
            key: "unbind-items"
          }), i({
            resource: "products",
            invalidates: ["list"],
            ...g
          });
        },
        onError: () => {
          AA.error({
            content: "解除綁定失敗！",
            key: "unbind-items"
          });
        },
        onSettled: () => {
          n == null || n();
        }
      }
    );
  };
  return /* @__PURE__ */ C(
    vr,
    {
      type: "button",
      popconfirmProps: {
        title: `確認解除這些商品的${a}綁定嗎?`,
        onConfirm: K
      },
      buttonProps: {
        children: "解除綁定",
        disabled: !o.length || !e.length,
        loading: B
      }
    }
  );
}, Rf = x(
  Di
), Ni = ({
  user_ids: A,
  selectProps: o,
  useSelectProps: e,
  url: t,
  useCustomMutationParams: n,
  label: r = "",
  hideLabel: a = !1,
  useInvalidateProp: g
}) => {
  const { selectProps: s, itemIds: i } = ag({
    selectProps: o,
    useSelectProps: e
  }), [l, B] = L(void 0), { mutate: K, isLoading: F } = eo(), Q = jA(), f = kA(), c = () => {
    K(
      {
        url: t || `${Q}/limit/grant-users`,
        method: "post",
        values: {
          user_ids: A,
          item_ids: i,
          expire_date: l ? l.unix() : 0
        },
        config: {
          headers: {
            "Content-Type": "multipart/form-data;"
          }
        },
        ...n
      },
      {
        onSuccess: () => {
          AA.success({
            content: "新增用戶成功！",
            key: "add-users"
          }), f({
            resource: "users",
            invalidates: ["list"],
            ...g
          });
        },
        onError: () => {
          AA.error({
            content: "新增用戶失敗！",
            key: "add-users"
          });
        }
      }
    );
  };
  return /* @__PURE__ */ h(k, { children: [
    !a && /* @__PURE__ */ C("label", { className: "tw-block mb-2", children: r }),
    /* @__PURE__ */ h(IA.Compact, { className: "w-full", children: [
      /* @__PURE__ */ C(tA, { ...s }),
      /* @__PURE__ */ C(
        Ke,
        {
          placeholder: "留空為無期限",
          value: l,
          showTime: !0,
          format: "YYYY-MM-DD HH:mm",
          onChange: (U) => {
            B(U);
          }
        }
      ),
      /* @__PURE__ */ C(
        D,
        {
          type: "primary",
          loading: F,
          disabled: !A.length || !i.length,
          onClick: c,
          children: r
        }
      )
    ] })
  ] });
}, Lf = x(
  Ni
), xi = ({
  user_ids: A,
  item_ids: o,
  onSettled: e,
  url: t,
  useCustomMutationParams: n,
  label: r = "",
  useInvalidateProp: a
}) => {
  const g = jA(), s = kA(), { mutate: i, isLoading: l } = eo(), B = () => {
    i(
      {
        url: t || `${g}/limit/revoke-users`,
        method: "post",
        values: {
          user_ids: A,
          item_ids: o
        },
        config: {
          headers: {
            "Content-Type": "multipart/form-data;"
          }
        },
        ...n
      },
      {
        onSuccess: () => {
          AA.success({
            content: "撤銷用戶成功！",
            key: "remove-users"
          }), s({
            resource: "users",
            invalidates: ["list"],
            ...a
          });
        },
        onError: () => {
          AA.error({
            content: "撤銷用戶失敗！",
            key: "remove-users"
          });
        },
        onSettled: () => {
          e == null || e();
        }
      }
    );
  };
  return /* @__PURE__ */ C(
    vr,
    {
      type: "button",
      popconfirmProps: {
        title: `確認移除這些用戶的${r}權限嗎?`,
        onConfirm: B
      },
      buttonProps: {
        children: `移除${r}`,
        disabled: !A.length || !o.length,
        loading: l
      }
    }
  );
}, Tf = x(
  xi
), ji = Cs.map((A) => A.value);
function ki(A) {
  const { field: o } = A;
  return ji.includes(o) ? Si(A) : Ri(A);
}
function Si(A) {
  const { field: o, operator: e, value: t } = A;
  switch (e) {
    case "between":
      return {
        formattedField: o,
        formattedValue: ns(t).join("...")
      };
    case "gt":
      return {
        formattedField: o,
        formattedValue: `>${io(t)}`
      };
    case "gte":
      return {
        formattedField: o,
        formattedValue: `>=${io(t)}`
      };
    case "lt":
      return {
        formattedField: o,
        formattedValue: `<${io(t)}`
      };
    case "lte":
      return {
        formattedField: o,
        formattedValue: `<=${io(t)}`
      };
    case "eq":
      return {
        formattedField: o,
        formattedValue: io(t)
      };
    default:
      return {
        formattedField: o,
        formattedValue: t
      };
  }
}
function Ri(A) {
  const { field: o, operator: e, value: t } = A;
  switch (e) {
    case "ne":
      return {
        formattedField: o,
        formattedValue: `!${t}`
      };
    case "in":
    // because query-string help us to handle array values
    case "eq":
    default:
      return {
        formattedField: o,
        formattedValue: t
      };
  }
}
const Ao = (A) => {
  const o = {};
  return A && A.map((e) => {
    if (e.operator === "or" || e.operator === "and")
      throw new Error(
        `[@refinedev/simple-rest]: \`operator: ${e.operator}\` is not supported. You can create custom data provider. https://refine.dev/docs/api-reference/core/providers/data-provider/#creating-a-data-provider`
      );
    if ("field" in e) {
      const { formattedField: t, formattedValue: n } = ki(e);
      o[t] = n;
    }
  }), o;
}, { stringify: Co } = St, Of = (A, o = bt) => ({
  getList: async ({ resource: e, pagination: t, filters: n, sorters: r, meta: a }) => {
    var d;
    const g = `${A}/${e}`, { current: s = 1, pageSize: i = 10, mode: l = "server" } = t ?? {}, { headers: B, method: K } = a ?? {}, F = K ?? "get", Q = Ao(n), f = {};
    l === "server" && (f.page = s, f.itemsPerPage = i);
    const { data: c } = await o[F](
      `${g}?${Co(f)}&${Co(Q, { arrayFormat: "bracket" })}`,
      {
        headers: B
      }
    ), U = (c == null ? void 0 : c.totalItems) || ((d = c == null ? void 0 : c.items) == null ? void 0 : d.length) || 0;
    return {
      data: (c == null ? void 0 : c.items) || [],
      total: U
    };
  },
  getMany: async ({ resource: e, ids: t, meta: n }) => {
    const { headers: r, method: a } = n ?? {}, g = a ?? "get", { data: s } = await o[g](
      `${A}/${e}?${Co({ id: t }, { arrayFormat: "bracket" })}`,
      { headers: r }
    );
    return {
      data: s
    };
  },
  create: async ({ resource: e, variables: t, meta: n }) => {
    const r = `${A}/${e}`, { headers: a, method: g } = n ?? {}, s = g ?? "post", { data: i } = await o[s](r, t, {
      headers: a
    });
    return {
      data: i
    };
  },
  update: async ({ resource: e, id: t, variables: n, meta: r }) => {
    const a = `${A}/${e}/${t}`, { headers: g, method: s } = r ?? {}, i = s ?? "post", { data: l } = await o[i](a, n, {
      headers: g
    });
    return {
      data: l
    };
  },
  getOne: async ({ resource: e, id: t, meta: n }) => {
    const r = `${A}/${e}/${t}`, { headers: a, method: g } = n ?? {}, s = g ?? "get", { data: i } = await o[s](r, { headers: a });
    return {
      data: i
    };
  },
  deleteOne: async ({ resource: e, id: t, variables: n, meta: r }) => {
    const a = `${A}/${e}/${t}`, { headers: g, method: s } = r ?? {}, i = s ?? "delete";
    return {
      data: (await (o == null ? void 0 : o[i](a, {
        data: n,
        headers: g
      }))).data
    };
  },
  getApiUrl: () => A,
  custom: async ({
    url: e,
    method: t,
    filters: n,
    sorters: r,
    payload: a,
    query: g,
    headers: s
  }) => {
    let i = `${e}?`;
    if (r) {
      const K = Jo(r);
      i = `${i}&${K}`;
    }
    if (n) {
      const K = Ao(n);
      i = `${i}&${Co(K, { arrayFormat: "bracket" })}`;
    }
    g && (i = `${i}&${Co(g, { arrayFormat: "bracket" })}`), s && (o.defaults.headers = {
      ...o.defaults.headers,
      ...s
    });
    let l;
    switch (t) {
      case "put":
      case "post":
      case "patch":
        l = await o[t](e, a);
        break;
      case "delete":
        l = await o.delete(e, {
          data: a
        });
        break;
      default:
        l = await o.get(i);
        break;
    }
    const { data: B } = l;
    return Promise.resolve({ data: B });
  }
}), { stringify: lo } = St;
function KA(A) {
  return A().catch((o) => {
    var t, n;
    const e = ((n = (t = o == null ? void 0 : o.response) == null ? void 0 : t.data) == null ? void 0 : n.message) || (o == null ? void 0 : o.message) || o;
    return Promise.reject({
      message: e,
      statusCode: 500
    });
  });
}
const Xf = (A, o) => ({
  getList: async ({ resource: e, pagination: t, filters: n, sorters: r, meta: a }) => KA(async () => {
    const g = `${A}/${e}`, { current: s = 1, pageSize: i = 20, mode: l = "server" } = t ?? {}, { headers: B, method: K } = a ?? {}, F = K ?? "get", Q = Ao(n), f = {};
    l === "server" && (f.paged = s, f.posts_per_page = i);
    const c = Jo(r), { data: U, headers: u } = await o[F](
      `${g}?${lo(f)}&${lo(Q, { arrayFormat: "bracket" })}&${c}`,
      {
        headers: B
      }
    ), d = Number(u == null ? void 0 : u["x-wp-totalpages"]) || 1, P = Number(u == null ? void 0 : u["x-wp-total"]) || 1, v = Number(u == null ? void 0 : u["x-wp-currentpage"]) || 1;
    return {
      data: U,
      total: P,
      totalPages: d,
      currentPage: v
    };
  }),
  getMany: async ({ resource: e, ids: t, meta: n }) => KA(async () => {
    const { headers: r, method: a } = n ?? {}, g = a ?? "get", s = t.map((l) => `include[]=${l}`).join("&");
    return await o[g](
      `${A}/${e}?${s}`,
      { headers: r }
    );
  }),
  create: async ({ resource: e, variables: t, meta: n }) => KA(async () => {
    const r = `${A}/${e}`, { headers: a, method: g } = n ?? {};
    return await o[g ?? "post"](r, t, {
      headers: {
        "Content-Type": "multipart/form-data;",
        ...a
      }
    });
  }),
  createMany: async ({ resource: e, variables: t, meta: n }) => KA(async () => {
    const r = `${A}/${e}`, { headers: a, method: g } = n ?? {};
    return await o[g ?? "post"](r, t, {
      headers: {
        "Content-Type": "multipart/form-data;",
        ...a
      }
    });
  }),
  update: async ({ resource: e, id: t, variables: n, meta: r }) => KA(async () => {
    const a = `${A}/${e}/${t}`, { headers: g, method: s } = r ?? {};
    return await o[s ?? "post"](a, n, {
      headers: {
        "Content-Type": "multipart/form-data;",
        ...g
      }
    });
  }),
  updateMany: async ({ resource: e, ids: t, variables: n, meta: r }) => KA(async () => {
    const a = `${A}/${e}`, g = {
      ...n,
      ids: t,
      action: "update-many"
    }, { headers: s, method: i } = r ?? {};
    return await o[i ?? "post"](a, g, {
      headers: {
        "Content-Type": "multipart/form-data;",
        ...s
      }
    });
  }),
  getOne: async ({ resource: e, id: t, meta: n }) => KA(async () => {
    let r = `${A}/${e}/${t}?`;
    const { headers: a, method: g, variables: s = {} } = n ?? {}, i = g ?? "get";
    return s && (r = `${r}&${lo(s, { arrayFormat: "bracket" })}`), await o[i](r, { headers: a });
  }),
  deleteOne: async ({ resource: e, id: t, variables: n, meta: r }) => KA(async () => {
    const a = `${A}/${e}/${t}`, { headers: g, method: s } = r ?? {};
    return await o[s ?? "delete"](a, {
      data: n,
      headers: {
        "Content-Type": "multipart/form-data;",
        ...g
      }
    });
  }),
  deleteMany: async ({ resource: e, ids: t, variables: n, meta: r }) => KA(async () => {
    const a = `${A}/${e}`, { headers: g, method: s } = r ?? {};
    return await o[s ?? "delete"](a, {
      data: {
        ...n,
        ids: t
      },
      headers: {
        "Content-Type": "application/json;",
        ...g
      }
    });
  }),
  getApiUrl: () => A,
  custom: async ({
    url: e,
    method: t,
    filters: n,
    sorters: r,
    payload: a,
    query: g,
    headers: s
  }) => KA(async () => {
    let i = `${e}?`;
    if (r) {
      const B = Jo(r);
      i = `${i}&${B}`;
    }
    if (n) {
      const B = Ao(n);
      i = `${i}&${lo(B, { arrayFormat: "bracket" })}`;
    }
    g && (i = `${i}&${lo(g, { arrayFormat: "bracket" })}`), s && (o.defaults.headers = {
      "Content-Type": "multipart/form-data;",
      ...o.defaults.headers,
      ...s
    });
    let l;
    switch (t) {
      case "put":
      case "post":
      case "patch":
        l = await o[t](e, a);
        break;
      case "delete":
        l = await o.delete(e, {
          data: a
        });
        break;
      default:
        l = await o.get(i);
        break;
    }
    return Promise.resolve(l);
  })
}), zf = (A) => Mt(A).map((t) => ((t == null ? void 0 : t.field) === "date_created" && (t.operator = "between"), t));
function Mt(A) {
  return Object.keys(A).reduce((o, e) => (A[e] && o.push({
    field: e,
    operator: "eq",
    value: A[e]
  }), o), []);
}
function If(A) {
  return Mt(A);
}
const Gf = {
  confirmTitle: "確認刪除嗎?",
  confirmOkText: "確認",
  confirmCancelText: "取消",
  hideText: !0,
  type: "text"
}, Wf = {
  open: (A) => {
    var i;
    const { key: o, message: e, type: t, description: n } = A, r = t === "progress" ? "info" : t, a = (l) => {
      switch (l) {
        case "open":
          return {
            color: "#1677ff",
            icon: /* @__PURE__ */ C(
              Xr,
              {
                twoToneColor: "#1677ff",
                style: { transform: "scale(0.75)" }
              }
            )
          };
        case "success":
          return {
            color: "#52c41a",
            icon: /* @__PURE__ */ C(
              Sr,
              {
                twoToneColor: "#52c41a",
                style: { transform: "scale(0.75)" }
              }
            )
          };
        default:
          return {
            color: "#ff4d4f",
            icon: /* @__PURE__ */ C(
              Rr,
              {
                twoToneColor: "#ff4d4f",
                style: { transform: "scale(0.75)" }
              }
            )
          };
      }
    }, { color: g, icon: s } = a(r);
    (i = Mo) == null || i[r]({
      key: o,
      description: n,
      message: /* @__PURE__ */ C("span", { style: { color: g }, children: e }),
      showProgress: !0,
      pauseOnHover: !0,
      icon: s
    });
  },
  close: (A) => {
    Mo.destroy(A);
  }
}, Do = {
  successNotification: (A, o, e) => {
    var t;
    return {
      // @ts-ignore
      message: ((t = A == null ? void 0 : A.data) == null ? void 0 : t.message) || "成功",
      type: "success"
    };
  },
  errorNotification: (A, o, e) => ({
    // @ts-ignore
    message: hg((A == null ? void 0 : A.message) || "失敗"),
    type: "error"
  })
}, Li = (A) => {
  try {
    const { bunny_library_id: o } = FA(), e = A == null ? void 0 : A.queryOptions;
    return Kg({
      resource: `${o}/videos`,
      pagination: {
        pageSize: 50
      },
      dataProviderName: (A == null ? void 0 : A.dataProviderName) || "bunny-stream",
      queryOptions: {
        enabled: !!o,
        ...e
      }
    });
  } catch (o) {
    return console.error("❌", o), {
      data: [],
      isFetching: !1,
      isLoading: !1,
      isError: !0
    };
  }
};
function Ti(A) {
  return BA({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z" }, child: [] }] })(A);
}
function Et(A) {
  return BA({ attr: { viewBox: "0 0 640 512" }, child: [{ tag: "path", attr: { d: "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z" }, child: [] }] })(A);
}
const Oi = (A) => {
  const { bunny_library_id: o, bunny_stream_axios: e } = FA(), [t, n] = Dr(Vr), [r, a] = L([]);
  return { uploadProps: {
    customRequest: async (s) => {
      var B, K;
      const i = s == null ? void 0 : s.file, l = Fs(i);
      n((F) => [
        ...F,
        {
          key: i == null ? void 0 : i.uid,
          file: i,
          status: "active",
          videoId: "",
          isEncoding: !1,
          encodeProgress: 0,
          uploadProgress: 0,
          preview: l
        }
      ]);
      try {
        const F = await e.post(
          `/${o}/videos`,
          {
            title: (i == null ? void 0 : i.name) || "unknown name"
          }
        ), Q = ((B = F == null ? void 0 : F.data) == null ? void 0 : B.guid) || "unknown id";
        n((c) => c.map((U) => (U == null ? void 0 : U.key) === (i == null ? void 0 : i.uid) ? {
          ...U,
          videoId: Q
        } : U));
        const f = await e.put(
          `/${o}/videos/${Q}?enabledResolutions=720p%2C1080p`,
          i,
          {
            headers: {
              "Content-Type": "video/*"
            }
          }
        );
        (K = f == null ? void 0 : f.data) != null && K.success ? n((c) => c.map((U) => U.key === (i == null ? void 0 : i.uid) ? {
          ...U,
          uploadProgress: 100,
          isEncoding: !0
        } : U)) : n((c) => c.map((U) => U.key === (i == null ? void 0 : i.uid) ? {
          ...U,
          status: "exception"
        } : U));
      } catch {
        n((Q) => Q.map((f) => f.key === (i == null ? void 0 : i.uid) ? {
          ...f,
          status: "exception"
        } : f));
      }
    },
    onRemove: (s) => {
      a(r.filter((i) => i.uid !== s.uid));
    },
    listType: "text",
    itemRender: () => /* @__PURE__ */ C(k, {}),
    fileList: r,
    accept: "video/*",
    multiple: !0,
    // 是否支持多選文件，ie10+ 支持。按住 ctrl 多選文件
    // maxCount: 1, // 最大檔案數
    ...A
  }, fileList: r, setFileList: a };
}, { Search: Xi } = J, zi = ({
  setSearch: A,
  loading: o,
  ...e
}) => {
  const { selectedItems: t, setSelectedItems: n } = Rt(), { bunny_library_id: r } = FA(), [a, g] = L(""), [s, i] = L(!1), { mutate: l } = Qg(), B = kA(), K = () => {
    i(!0), t.forEach((F, Q) => {
      l(
        {
          dataProviderName: "bunny-stream",
          resource: `${r}/videos`,
          id: F.guid
          // mutationMode: 'undoable',
        },
        {
          onSuccess: () => {
            Q === t.length - 1 && (AA.success("影片已經全部刪除成功"), n([]));
          },
          onError: () => {
            AA.error(`影片 ${F.title} #${F.guid} 刪除失敗`);
          },
          onSettled: () => {
            i(!1), Q === t.length - 1 && B({
              dataProviderName: "bunny-stream",
              resource: `${r}/videos`,
              invalidates: ["list"]
            });
          }
        }
      );
    });
  };
  return /* @__PURE__ */ h("div", { className: "pc-media-library__tabs__filter at-flex at-items-center at-justify-between at-sticky at-backdrop-blur-sm at-z-50 at-top-0 at-py-2 at-mb-4", children: [
    /* @__PURE__ */ C(
      Xi,
      {
        placeholder: "搜尋關鍵字，按 ENTER 也能搜",
        className: "at-w-[20rem]",
        value: a,
        onChange: (F) => g(F.target.value),
        allowClear: !0,
        onSearch: (F) => A(F),
        enterButton: !0,
        loading: o,
        ...e
      }
    ),
    /* @__PURE__ */ h("div", { className: "at-flex at-items-center at-gap-2", children: [
      /* @__PURE__ */ h("p", { className: "at-text-sm at-m-0 at-text-gray-500", children: [
        "已經選取 ",
        (t == null ? void 0 : t.length) ?? 0,
        " 個影片"
      ] }),
      /* @__PURE__ */ C(D, { onClick: () => n([]), children: "清空選取" }),
      /* @__PURE__ */ C(
        Kr,
        {
          title: "確定要刪除這些影片嗎？",
          onConfirm: K,
          okText: "刪除",
          cancelText: "取消",
          children: /* @__PURE__ */ h(
            D,
            {
              disabled: !(t != null && t.length),
              loading: s,
              type: "primary",
              danger: !0,
              children: [
                "批量刪除 ",
                t != null && t.length ? `(${t == null ? void 0 : t.length})` : ""
              ]
            }
          )
        }
      )
    ] })
  ] });
}, Ii = ({ item: A }) => {
  const { bunny_cdn_hostname: o, bunny_library_id: e } = FA(), { guid: t, videoLibraryId: n } = A, r = `<div style="position:relative;padding-top:56.25%;"><iframe src="https://iframe.mediadelivery.net/embed/${n}/${t}?autoplay=true&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style="border:0;position:absolute;top:0;height:100%;width:100%;" allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowfullscreen="true"></iframe></div>`, a = `https://dash.bunny.net/stream/${e}/library/videos?videoId=${t}&page=1&search=${t}#noscroll`;
  return /* @__PURE__ */ h(k, { children: [
    /* @__PURE__ */ C(
      Yo,
      {
        className: "at-w-full at-rounded-md at-overflow-hidden",
        loadingClassName: "at-text-sm at-text-gray-500 at-font-bold",
        src: `https://${o}/${t}/preview.webp`
      }
    ),
    /* @__PURE__ */ h("div", { className: "at-flex at-gap-4 at-my-4", children: [
      /* @__PURE__ */ C(xr, { text: r, children: /* @__PURE__ */ C(D, { type: "default", icon: /* @__PURE__ */ C(Lt, {}), iconPosition: "end", children: "複製 iframe 影片嵌入代碼" }) }),
      /* @__PURE__ */ C(W, { title: "前往 Bunny 頁面", children: /* @__PURE__ */ C(
        D,
        {
          type: "default",
          href: a,
          target: "_blank",
          className: "at-px-0 at-w-8",
          children: /* @__PURE__ */ C(Ho, {})
        }
      ) }),
      /* @__PURE__ */ C(W, { title: "刪除 Bunny 影片", children: /* @__PURE__ */ C(
        Hr,
        {
          hideText: !0,
          resource: `${e}/videos`,
          dataProviderName: "bunny-stream",
          recordItemId: t,
          confirmTitle: "確認刪除 Bunny 影片嗎?",
          confirmOkText: "確認",
          confirmCancelText: "取消"
        }
      ) })
    ] }),
    /* @__PURE__ */ C(Bi, { record: A })
  ] });
}, Gi = "preview.webp", { Text: Wi } = Qr, Vi = ({
  item: A,
  allItems: o,
  index: e
}) => {
  const { selectedItems: t, setSelectedItems: n, limit: r } = Rt(), { bunny_cdn_hostname: a } = FA(), [g, s] = L(A == null ? void 0 : A.thumbnailFileName), i = t == null ? void 0 : t.some(
    (B) => B.guid === A.guid
  );
  return /* @__PURE__ */ h("div", { className: "at-w-36 at-relative", children: [
    /* @__PURE__ */ C(
      Yo,
      {
        onClick: (B) => {
          var f;
          const K = t != null && t.length ? (f = t == null ? void 0 : t.slice(-1)) == null ? void 0 : f[0] : null, F = o.findIndex(
            (c) => c.guid === (K == null ? void 0 : K.guid)
          ), Q = F === -1 ? 0 : F;
          if (B.shiftKey && Q !== e) {
            n((c) => {
              const U = Math.min(Q, e), u = Math.max(Q, e), d = o.slice(U, u + 1);
              return mr([...c, ...d], "guid");
            });
            return;
          }
          if (i)
            n((c) => c.filter((U) => U.guid !== A.guid));
          else {
            if (r && t.length >= r) {
              AA.warning({
                key: "limit",
                content: `最多只能選取${r}個影片`
              }), n((c) => [...c.slice(1), A]);
              return;
            }
            n((c) => [...c, A]);
          }
        },
        onMouseEnter: () => {
          s(Gi);
        },
        onMouseLeave: () => {
          s(A == null ? void 0 : A.thumbnailFileName);
        },
        className: `at-rounded-md at-overflow-hidden at-cursor-pointer ${i ? "at-outline at-outline-4 at-outline-yellow-300 at-outline-offset-1" : ""}`,
        loadingClassName: "at-text-sm at-text-gray-500 at-font-bold",
        src: `https://${a}/${A.guid}/${g}`
      }
    ),
    /* @__PURE__ */ C(Wi, { className: "at-text-xs at-text-gray-800", ellipsis: !0, children: A.title }),
    i && /* @__PURE__ */ C("div", { className: "at-bg-white at-absolute at--top-2 at--right-2 at-z-30 at-size-6 at-rounded-full at-flex at-items-center at-justify-center", children: /* @__PURE__ */ C(Tt, { className: "at-size-5 [&_path]:at-fill-yellow-300" }) })
  ] });
}, fn = 50, Mi = () => {
  const { selectedItems: A } = Rt(), { bunny_library_id: o, bunny_stream_api_key: e, bunny_cdn_hostname: t } = FA(), [n, r] = L(""), {
    data: a,
    isError: g,
    hasNextPage: s,
    fetchNextPage: i,
    isFetchingNextPage: l,
    isFetching: B
  } = lr({
    dataProviderName: "bunny-stream",
    resource: `${o}/videos`,
    pagination: {
      pageSize: fn
    },
    filters: [
      {
        field: "search",
        operator: "eq",
        value: n
      }
    ],
    queryOptions: {
      enabled: !!o && !!e && !!t
    }
  }), K = [].concat(
    ...((a == null ? void 0 : a.pages) ?? []).map((Q) => (Q == null ? void 0 : Q.data) || [])
  ), F = B && !l;
  return g ? /* @__PURE__ */ C(
    Fr,
    {
      status: "error",
      title: "獲取影片失敗",
      subTitle: "Bunny Stream API 回應錯誤，請聯繫網站管理人員或稍候再嘗試"
    }
  ) : /* @__PURE__ */ h(k, { children: [
    /* @__PURE__ */ C(
      to,
      {
        message: "影片上傳中可以離開此頁，但不要「重新整理」頁面，「重新整理」會導致上傳中斷",
        banner: !0,
        className: "at-mb-8"
      }
    ),
    /* @__PURE__ */ C(
      zi,
      {
        setSearch: r,
        disabled: B,
        loading: F
      }
    ),
    /* @__PURE__ */ h("div", { className: "at-flex", children: [
      /* @__PURE__ */ h("div", { className: "at-flex-1", children: [
        /* @__PURE__ */ h("div", { className: "at-flex at-px-2 at-flex-wrap at-gap-4", children: [
          !F && K.map((Q, f) => /* @__PURE__ */ C(
            Vi,
            {
              item: Q,
              index: f,
              allItems: K
            },
            Q.guid
          )),
          (B || l) && new Array(fn).fill(0).map((Q, f) => /* @__PURE__ */ h("div", { className: "at-w-36", children: [
            /* @__PURE__ */ C(Zo, {}),
            /* @__PURE__ */ C(Zo, { className: "at-h-3 !at-p-0 at-rounded-sm", children: " " })
          ] }, f))
        ] }),
        !(K != null && K.length) && !B && /* @__PURE__ */ C(Vo, { className: "at-my-24", description: "找不到影片資料" }),
        s && /* @__PURE__ */ C("div", { className: "at-text-center at-mt-8", children: /* @__PURE__ */ C(
          D,
          {
            type: "link",
            onClick: () => i(),
            disabled: B,
            loading: l,
            children: "顯示更多"
          }
        ) })
      ] }),
      /* @__PURE__ */ C("div", { className: "at-w-[28rem]", children: (A == null ? void 0 : A.length) > 0 && /* @__PURE__ */ C(Ii, { item: A.slice(-1)[0] }) })
    ] })
  ] });
}, Ei = "data:image/jpeg;base64,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", qi = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD//gAXR2VuZXJhdGVkIGJ5IFNuaXBhc3Rl/9sAhAAKBwcIBwYKCAgICwoKCw4YEA4NDQ4dFRYRGCMfJSQiHyIhJis3LyYpNCkhIjBBMTQ5Oz4+PiUuRElDPEg3PT47AQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAOPB4ADAREAAhEBAxEB/8QBogAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoLEAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+foBAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKCxEAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDy+u84QoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPbfgv/AMihd/8AYQf/ANFx1zVviOml8J6DWJqFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACL0/E/zoAWgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAD0NAETMqKWYhVAySTgAUALQB8q13nCFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQB7b8F/+RQu/+wg//ouOuat8R00vhPQaxNQoAKACgAoAKACgAoAP5mgB4h9XOfagBfJH99v0/wAKADyR/fb9P8KADyR/fb9P8KADyR/fb9P8KADyR/fb9P8ACgA8kf32/T/CgA8kf32/T/CgA8kf32/T/CgA8kf32/T/AAoAPJH99v0/woAPJH99v0/woAPJH99v0/woAPJH99v0/wAKADyR/fb9P8KADyR/fb9P8KADyR/fb9P8KADyR/fb9P8ACgA8kf32/T/CgA8kf32/T/CgA8kf32/T/CgA8kf32/T/AAoAPJH99v0/woAPJH99v0/woAPJH99v0/woAPJH99v0/wAKADyR/fb9P8KADyR/fb9P8KAE8n/bb9KAGkFW2n/9dACUAFACL0/E/wA6AFoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAKV7rWk6bIIr7U7O1cjIWedUJH0JppN7CbS3K//AAlfhv8A6GDS/wDwMj/xp8suwuaPcP8AhK/Df/QwaX/4GR/40csuwc0e4f8ACV+G/wDoYNL/APAyP/Gjll2Dmj3D/hK/Df8A0MGl/wDgZH/jRyy7BzR7h/wlfhv/AKGDS/8AwMj/AMaOWXYOaPcP+Er8N/8AQwaX/wCBkf8AjRyy7BzR7h/wlfhv/oYNL/8AAyP/ABo5Zdg5o9w/4Svw3/0MGl/+Bkf+NHLLsHNHuH/CV+G/+hg0v/wMj/xo5Zdg5o9w/wCEr8N/9DBpf/gZH/jRyy7BzR7h/wAJX4b/AOhg0v8A8DI/8aOWXYOaPcP+Er8N/wDQwaX/AOBkf+NHLLsHNHuH/CV+G/8AoYNL/wDAyP8Axo5Zdg5o9w/4Svw3/wBDBpf/AIGR/wCNHLLsHNHuKninw7I6omvaYzMcBRdxkk/nRyy7BzR7if8ACV+G/wDoYNL/APAyP/Gjll2Dmj3D/hK/Df8A0MGl/wDgZH/jRyy7BzR7h/wlfhv/AKGDS/8AwMj/AMaOWXYOaPcsWWtaTqUpisNUs7qQDJWCdXIH0BpNNbjTT2LtIYhYDqQKADev94fnQAb1/vD86ADev94fnQAtABQAUAFABQAUAFABQAUAFABQAHoaAKd7ZJfRCKSWREzkhCBu+vFAD7W3FpAsKySSKv3S5BIHp0oA+Wq7zhCgDT0rQrnWLe4e0eMyW+0mJjgsDnkfl+tcGLx9PCTiqidpX1OqhhZ14ycN10Jrjw/JDoovQxFxE5Fxbt95Fzw2PSsqeYxlifZfZfwvo31XqaSwclR9p1W67LuY1eocIUAFABQAUAFABQAUAFABQAUAFABQA5EaRwiAsxOABSlJRV3sDdtTYtfD7SACRnLn+GMZxXjVc0d7U195zOv/ACoLnw+Y8iJ2Dj+CQYopZo72qL7gVfX3kY7o0blHUqw4INezGSkrrY6U7jaYBQAUAe2/Bf8A5FC7/wCwg/8A6LjrmrfEdNL4T0GsTUKACgAoAKACgAoAKAFX/WJ9f6GgCegAoArXOoWVmwW6vIIGboJZVUn8zVxpzl8KbIlOMfidieORJUEkbq6N0ZTkGpaadmUmnqhaQxaAIPtlr/z8w/8AfwVXJLsTzx7j/Oi/56p/30KVmO6F82P/AJ6L+dFmF0OpDCgAyPUUARfa7b/n4i/77FVyy7E8y7k1SUFADDKgON35DNOzFcTzk9T+Roswug85PU/kaLMLocrKwypzSGOoAKACgAoAKACgAoAKACgAoAil++v0P9KAGUAFACL0/E/zoAWgAoAKACgAJAGTwKAGQzw3EQlglSWM9HRgwP4im01uK9yCXVNPglMMt/bRyA4KPMoI/DNCTewNpbk8k0UUJmklRIwMl2YBQPrSGPBBGQcg0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQB81eMJpJ/GOsPK5dheyoCfRWIA/AACu2Hwo45fEzGqiQoAKACgAoAKACgAoAKACgAoAKACgAoAtaX/yFrP/AK7p/wChCk9hrcq0xBQAUAbPhCaSDxjo7xOUY3sSkj0ZgCPxBIqZ/Cyo/Ej6VriOwkgH7vPck5/OgCSgAoAQgEYIyDQBXTlB9KAFoAKACgAoAKACgAoAKACgAoAD0NAHPXFxOtzKBNIAHIADH1oAksJ5nvY1eV2BzkFiR0NAHzdXecJNaQx3F1HFLOsCOcGRhkLWdacoU3KMbtdO5pTipzUW7Lub+jeGNZZRqFpcrar/AMs5NxDOvqB6H3rxcbmuET9jVjzPqtNP+D6Hp4TL8RN89OVuz7mrBpmuXUzLqDRXFuEOyVMKwPTAIwR754PvXmVcVgqcE8PeMr7br57p+XU9fD0MTKq4Yqzilv1+VrW8+hy+s6dbadcLHb3qXOR8wXkofQkcV9FgcTVxEG6kHH9TwcdhqVCdqc+a/wCBm13nnhQAUAFABQAUAFAE9nb/AGq9hgyQJHAJHYd6GNHXXui2b6aYI4tpiVmjIJyD/XNZpu5bSscVWhmFABQBr+HbV7m7cxxtJIowqqMnnPb6CvJzSbUIwXX9DCu3ZJHoWiaRcrYPNGrWl8JSqySofuYH8J49ecV4iWhjGLt5jNd0i4+zQzeW91eux86WJCdw7cDgcYHShoJxdvM4DxDbGC6QuhR2BDKwwQR7fjXt5XNuEoPp+ptQbs0ZUewyL5hITPzFRzivWNy62mCINNLOv2bGY5V58z0AHr6+lK47FCmI9t+C/wDyKF3/ANhB/wD0XHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAKv+sT6/0NAE9AGH4v1iTRNAkuIDieRhFE390nPP4AGurCUVVqpPY5sVVdKndbnnOmeGdR8Rafc6jbzCaaOXaY5G+aQ4yTuPfnvXs1MTChNQasjyaeHnWi5p6lvwjql9oPiKPTLkSRxTSiKWF+NrHgNj64/Cs8XShWpOcd11Lw1SdKryPqerHpXgHuEX2y1/5+Yv++xVckuxPNHucx9juv8An2m/74NdvPHucXJLsXvtMH/PeP8A76FZcr7G3Mu5d8qT/nm35VldGlmXfPh/56p/30Kz5X2NOZdxn2u2/wCfiL/vsU+WXYXMu4n2iD/ntH/30KOV9iro5rzI/wC+v5122ZxXR11cB2kUzEAKO/WqihMztSuJraESRy2tvGP9ZNck7V9BjI6n3/OtoJN2ab9DObaV1+JVfUL99PivEjgt4/IMsrTZIz/dAyCM9cn24q+SCk4vUhSlKKast9en9PcLvUb+G3F4tvFHCsaMY5Ml5Gb+AYPB6DkHJNOMIOXLfrb/AIJLqS5OdK2l/wDgf13NYMVO4dutc7VzdMtVmWFABQAUAFABQAUAUr+4+ywSTeVJNsHEca5Zj6AVrTjzNIznLlTZQsbrUxOsOpWqKZQXRoMssf8AsMfX36H8s7TjTteD27mUJTvaaNqM5QVyvc6EMl++v0P9KQxlABQAi9PxP86AFoAKACgAoAwfGl9LaeHpLe1OLu/dbO3x13SHGfwGT+FOMVOag9nv6LVg5ckXPt+fT8Sl4UhXQNa1LwyuRAipd2YP9xhtcfg4/WtZS9pDm6ptfJ6r/IxjH2clHul960f36MzLRfDLeLfEp14aUXFzF5ZvvLyB5Qzjf2+lTC/sI27y/Mc7e3lftH8ig3lf8IF4sXTyx0dZiLA5JXHy79mf4d2cdutN35afPvdfdzKxULe0ny7W/GzuekWv/HpD/wBc1/lU1PjYqX8OPoiWoNAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA+ZvFX/I3az/1/wA//oxq7Y/Cjjl8TMqqJOr8V6VY2Gh+GZ7W3WKS8svMnYE/vGyOTU0HzYvke3u/je5TX7lS63ZueIPAmltretXCahDo2nac0CsDC0gG9ByMHJOe3vWUJtRTet219xrKCbSWnup/e3/kQw+B4NPsdeSUxaj/AKBDc6dcoCu4OxAIGeDx05onKfw2tLmS+9kqMY++37vLJ/cv0KN/8PRaW17FDrdvc6rp0AuLuwWJhsTAJw54YgEdqp1NOZL3b2uEaTb5er1t/XUSL4ffatBk1C01eOe4itTdPCls/lBR1Xzvulh6f/rpznyN9k7f8N3QUqftbJbs2PC/gDTYNZsoNav7ee8ntGuH0wxuCqlTtO8cEj0/nSqztGoo68vXs9CYQu4Nu13t3WpxXh7Rotc1Braa/SyRYy5cxtIzY7Ki8sfatXpFsjqkWfFXhebwteW0bT/aIbqETQyNE0bEejI3Kn2qKdS8mmtUaTp2infRnVt4Q03VfFfh+7sbVYdI1K1FzPGrEqnljMik9ucD8TS5vZyqKWy1Xo9v8xW54Qcd3o/Vb/rb0KjeH4/EmlW39j2ljbJe6zJDAwjYSJGEJ5bJyoAzjHWlFSXLzv7Lb+/+kgk03PkW0kvw/LqSv4N0n/hD73+y72DV706jFbRXKxtEUZiFKYJxjJ68g5qHOcp00tE2/u5W/wBC3BR577pL77lTVPhheWVo8lnffbJoJo4ZomtnhAZ2CjYzcOMkDIrSNTmkklo/61QnSaT7pX/plbVPASWVhfy2Wt29/d6VtN/bJEyeVnrtY8Ng9en9Kl1UrS6N2uHsn8L+K17eW5zWl/8AIWs/+u6f+hCtXsZrcq0xFxNKu5NIfVI4xJbRSiOUqwLRE9Cw6gHoD0yMelK6vYdtLhfaXd6bFbPdxiI3UfmxoWG/Z2JXqM9RnqOaE0wasWfCv/I3aN/1/wAH/oxaUvhY4/Ej6ZriOwkg/wBUPqf50AOLqHCFgGPIGeTQAeYnHzr8xwOepoAdQBVj+4PpQA6gAoAKACgAoAKACgAoAKACgAPQ0Ac1df8AH1N/vt/OgCXTf+P+P8f5GgD5xrvOEKAO41HVFv8AwxpptmlFrCVW9jgOHRVAH5d/TpXyOHwro46qqluZ3cG9m2fR1KqqYOMoPRNKSW9it/aM2l+D5lZ5Fa9mYWqyn5xEQBuP4cflW/1WGJzGLSVoJc1tubsZvFTpYOV2/ebUb72OQr6c8AKACgAoAKACgAoAKALNhemwuhcLEkjAEAN296GrjTsbUnilxAjKkTyN96Paw2/jnmo5SuY5+V/NleTaq7mJ2r0H0qyBlABQBs+F9W/sjV0n2q2QQAxwM4I/rXn5hRdSmpR3RlUTtddD1JPEulFFL3W1iBkeW/B/KvA5kZc8RJvE2mLBI0VwHkCkopjYbjjgdKXMgc4nlniTUxqmqvMAAMnODkZ719Bl9F06blLdmtJNK76mRXoGouTgDJwO1ACUAe2/Bf8A5FC7/wCwg/8A6LjrmrfEdNL4T0GsTUKACgAoAKACgAoAKAFX/WJ9f6GgCegDC8YaPJrWgSQQczxMJY1/vEA8fiCa6sJWVKqm9tjmxVJ1adlueeaR4pvvDmnXWnwWwS4klJMkvWM4wRt9eO/5V7NXDQrzU29DyqWIlRi4Jaljwnpd/r/iKPUbhpHihlEs07/xMOQoPc5A+g/CoxVWFGk4R3elisNTnVq876Hq56V8+e4ct9juv+faX/vg1388e5xcsux1NcB2nFfYL3/n0n/79mvS549zz+SXY7WvNPQMbyJv+eT/APfJrq5l3OblfYz/ALHdf8+0v/fBq+aPcnlfYs/Zrj/nhJ/3waz5l3NLMyvsF7/z6T/9+zXTzx7nPyS7HbV5p3kM4PDenWqixMpXUV3IUa0ukiIyGWSLzFYH2BByPrWsXHXmVzOSk/hdig2iXKw2kMN7F5VuS5SW3LK75zuwGHAJ4HQfgK2VWN22t/P/AIH4mTpS5VFPrd6b6377Etxp1/PeQ3Ivbb9yvyxvbMyh+7DDjn0znAqYzhFNWevn07bDlCcmtVp5de+5pYLYXqTWDdjZFusywoAKACgAoAKACgCnfRSTRSRxytC7D5ZF6qa1ptJptXM5ptWRnWMerS3fm37xwxQjYscRz5x/vn0HoK3m6SjaGt/w8jKCqOV5dPxNuMYQVyPc6EMl++v0P9KQxlABQAi9PxP86AFoAKACgAoA5nXfD8niLxLZR39ux0ezgeTKzbPMnY4A+UhhgZOferptR5pPfZfq/wBCZpy5Yrbd/p/mV5vCEWja1peq+H7SQvHMYrtGuWfdCwwT+8Y/dODgVUKju1LZr8d0ROmuW8d0/wDh/wACfTvDML+ItcvdU0q2mS5nja2kmjSQlQgBx1I5HtUxlakore7/AD0HKPNVcntZflqXfFmmz6h4Rv8ATtPgDzSw7IolIUdRxzgCpv7yb7r8zWNkmvJ/ka8ClLeNGGGVACPwpzd5NozppqCT7D6ksKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPmbxV/yN2s/wDX/P8A+jGrtj8KOOXxMyqok7Cx8ZaW+k2Flr3h8am+mAi1lW5MXy5yFYAcjj/61S01P2kNHp+Gw4tcnJLVf5mtaeLrDU9E8S32uwQztfXNuRYrP5bsg4Gw9flABzjt71DhywhFd3+X9ItTbqTk9rJL73/w/wCJnXXxFaUX0Vtpa28EtnFZ2qCbP2dYySCcj5jk+1HJJvmb15lL7ugOSceS3u2at67sdf8AxAtLiPULu20MW+r6nb/Z7q6NwWTbgAlUxwSB68YHWh09ORP3b3KjVs1N/Ev6uWp/ihHLZyp/ZM/nTWJs2UXxEEYK43JHtwD/APqzROnzc2u7uOjV9m4O3w/IbafEqyhu7XVLjw95+rQW32ZrgXZRWQDGdu0gHn/PYnTvzqOilv8A18jOEkuXmV3HYwfCPihPDU955lrJNHeQeSzwTeVLHznKPg4//VVzXNDl9H9xMXyz5vVfeL4t8Vr4nNhtsntVsofKG+4MzPz1LEA5qI0+Wbn3t+Fy5TvFR7X/ABLWlePJ9M8IXGgiyEkjrJHDdebgwpJjcAuOc4PcdaqrD2lv6vr/AEgpVHTv9/o7WGaJ44m0PTdOtILJXexvmu/MaTiQMhQpjHHBPOfwq5Lmab2s197uZx91NLq0/uVi7P49sLbTZLLQ9B+w77yO98x7oyfvFYNjGOnAHUVkqbUoO/w3+aaa/U1lU5uZ21lv99x2rfESO8RpbPT7uC7knSdmm1GSSKNlbdhY+BgkdD0/KnGDjJWeiG6vMnfdq39f195FqnjuyubLUxp2ifYr3WABezm4MgxnkKuBjPf61PstFG/up3/r0D2t3zNa2t+hy2l/8haz/wCu6f8AoQrV7GS3KtMRd0rV73Rbv7TZSBWKlHVlDJIp6qyngj2NJpPcabWxDeXlzqF5Ld3czzTzNueRzksaaVgbuXvCv/I3aN/1/wAH/oxamXwscfiR9M1xHYSQf6ofU/zoAgn0y0uL+K+ljLTQqVQ7iAAevH4mnd2sK3UrQ+HdMgS1RIWxaSGSLLnhic/j0H5U+Zhyo1KkZVj+4PpQA6gAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/wCP8f5GgD5xrvOEKALularcaReC4g2sCNrxuMq69wRXLi8JTxVPkn8n1TN6FedCXNH/AIcqO29y2AMnOB0FdKVlYxbuxtMQUAFABQAUAFABQAUAFABQAUAFABQAUAXYNVuoFChg6joHGa4quAo1Hdq3oZSpRYT6rdTqVLBFPUIMUUsBRpu6V/UI0oopV2moUAFABQB7b8F/+RQu/wDsIP8A+i465q3xHTS+E9BrE1CgAoAKACgAoAKACgBV/wBYn1/oaAJ6ACgCnc6Rpt5IJbrT7adx/FJErH9RWkatSKtGTRnKlCTvJJlmKKOCJYoY1jjUYVEUAD6AVDbbuy0klZD6QwoAKACgAoAKACgAoAKACgBOtADPJj/u/kTTuxWDyU9D+Zouwsg8lPQ/maLsLIcqKn3RikMdQAUAFABQAUAFABQAUAFABQBFL99fof6UAMoAKAEXp+J/nQAtABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQB4D4y8H6/F4q1GaLS7q5hubh5o5IIWkBDMW7A4Izjn0rrhOPKtTlnB3MT/hFvEP8A0AdT/wDAST/Cq5o9yeWXYP8AhFvEP/QB1P8A8BJP8KOaPcOWXYP+EW8Q/wDQB1P/AMBJP8KOaPcOWXYP+EW8Q/8AQB1P/wABJP8ACjmj3Dll2D/hFvEP/QB1P/wEk/wo5o9w5Zdg/wCEW8Q/9AHU/wDwEk/wo5o9w5Zdg/4RbxD/ANAHU/8AwEk/wo5o9w5Zdg/4RbxD/wBAHU//AAEk/wAKOaPcOWXYP+EW8Q/9AHU//AST/Cjmj3Dll2D/AIRbxD/0AdT/APAST/Cjmj3Dll2D/hFvEP8A0AdT/wDAST/Cjmj3Dll2D/hFvEP/AEAdT/8AAST/AAo5o9w5Zdg/4RbxD/0AdT/8BJP8KOaPcOWXYP8AhFvEP/QB1P8A8BJP8KOaPcOWXYs6b4Z1+PVLR30PUVVZkJY2kgAG4e1DlG241GV9it/wi3iH/oA6n/4CSf4Uc0e4uWXYP+EW8Q/9AHU//AST/Cjmj3Dll2D/AIRbxD/0AdT/APAST/Cjmj3Dll2Nvwb4P1+XxVp00ul3VtDbXCTSSXELRgBWDdwMk4xx61M5x5XqVCDue/VyHULHMiLtc4IJ7UAO+0Rf3v0NAB9oi/vfoaAA3EeODk+mKAI0GEAoAWgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/wCP8f5GgD5xrvOEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFABQAfzFADxN6oc+1AC+cP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAecP7jfp/jQAnnf7DfpQA0ks24/wD6qAEoAKAEXp+J/nQAtABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAYFABgelABgelABgelABgelABgelABgelABgelABgelABgelABgelABgelABgelABgelABgelABgelABgelABgelABgelABgUAFABgUAGB6UAGB6UAGB6UAFABQAUAFABQAUAFABQAUAFABQAHoaAOauv+Pqb/fb+dAEum/8f8f4/wAjQB85+W3qv/fQrvOEPLb1X/voUAHlt6r/AN9CgA8tvVf++hQAeW3qv/fQoAPLb1X/AL6FAB5beq/99CgA8tvVf++hQAeW3qv/AH0KADy29V/76FAB5beq/wDfQoAPLb1X/voUAHlt6r/30KADy29V/wC+hQAeW3qv/fQoAPLb1X/voUAHlt6r/wB9CgA8tvVf++hQAeW3qv8A30KADy29V/76FAB5beq/99CgA8tvVf8AvoUAHlt6r/30KADy29V/76FAHtnwYGPCF2OP+Qg/Q/8ATOOuat8R00vhPQKxNQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAarAA9ep7e9AC7h7/kaADcPf8AI0AG4e/5GgA3D3/I0AG4e/5GgA3D3/I0AG4e/wCRoANw9/yNABuHv+RoANw9/wAjQAbh7/kaADcPf8jQAbh7/kaADcPf8jQAbh7/AJGgA3D3/I0AG4e/5GgA3D3/ACNABuHv+RoANw9/yNABuHv+RoANw9/yNABuHv8AkaADcPf8jQAbh7/kaADcPf8AI0AG4e/5GgA3D3/I0AG4e/5GgA3D3/I0AG4e/wCRoANw9/yNABuHv+RoANw9/wAjQAbh7/kaADcPf8jQAbh7/kaADcPf8jQAbh7/AJGgA3D3/I0AG4e/5GgA3D3/ACNABuHv+RoANw9/yNABuHv+RoANw9/yNABuHv8AkaADcPf8jQAbh7/kaADcPf8AI0AG4e/5GgA3D3/I0AG4e/5GgA3D3/I0AG4e/wCRoANw9/yNABuHv+RoANw9/wAjQAbh7/kaADcPf8jQAbh7/kaADcPf8jQAbh7/AJGgA3D3/I0AG4e/5GgA3D3/ACNABuHv+RoANw9/yNABuHv+RoANw9/yNABuHv8AkaADcPf8jQAbh7/kaADcPf8AI0AG4e/5GgA3D3/I0AG4e/5GgA3D3/I0AG4e/wCRoANw9/yNABuHv+RoANw9/wAjQAbh7/kaADcPf8jQAbh7/kaADcPf8jQAbh7/AJGgA3D3/I0AG4e/5GgA3D3/ACNABuHv+RoANw9/yNABuHv+RoANw9/yNABuHv8AkaADcPf8jQAbh7/kaADcPf8AI0AG4e/5GgA3D3/I0AG4e/5GgA3D3/I0AG4e/wCRoANw9/yNABuHv+RoANw9/wAjQAbh7/kaADcPf8jQAbh7/kaADcPf8jQAbh7/AJGgA3D3/I0AG4e/5GgA3D3/ACNABuHv+RoANw9/yNABuHv+RoANw9/yNABuHv8AkaADcPf8jQAbh7/kaADcPf8AI0AG4e/5GgA3D3/I0AG4e/5GgA3D3/I0AG4e/wCRoANw9/yNABuHv+RoANw9/wAjQAbh7/kaADcPf8jQAbh7/kaADcPf8jQAbh7/AJGgA3D3/I0AG4e/5GgA3D3/ACNABuHv+RoANw9/yNABuHv+RoANw9/yNABuHv8AkaADcPf8jQAbh7/kaADcPf8AI0AG4e/5GgA3D3/I0AG4e/5GgA3D3/I0AG4e/wCRoANw9/yNABuHv+RoANw9/wAjQAbh7/kaADcPf8jQAbh7/kaADcPf8jQAbh7/AJGgA3D3/I0AG4e/5GgA3D3/ACNABuHv+RoANw9/yNAC0AFABQAUAFABQAHoaAOauv8Aj6m/32/nQBLpv/H/AB/j/I0AfONd5whQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAe2/Bf/kULv8A7CD/APouOuat8R00vhPQaxNQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoARen4n+dAC0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAAehoA5q6/4+pv99v50AS6b/wAf8f4/yNAHzjXecJoafZJKnnSjIz8opNjSND7NB/zwj/75FIoPs0H/ADwj/wC+BQAfZoP+eEf/AHwKAD7NB/zwj/74FAB9mg/54R/98CgA+zQf88I/++BQAfZoP+eEf/fAoAPs0H/PCP8A74FAB9mg/wCeEf8A3wKAD7NB/wA8I/8AvgUAH2aD/nhH/wB8CgA+zQf88I/++BQAfZoP+eEf/fAoAPs0H/PCP/vgUAH2aD/nhH/3wKAD7NB/zwj/AO+BQAfZoP8AnhH/AN8CgA+zQf8APCP/AL4FAB9mg/54R/8AfAoAPs0H/PCP/vgUAV7qwikjLRIEcDIxwDRcVjHqiT234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAi9PxP86AFoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/x9Tf77fzoAl03/AI/4/wAf5GgD5xrvOE29O/48Y/x/mallI2NOtYHgub26DNDbBf3anBkZugz2HHNS30KSJ/LsdTtLh7a1+yT26ebtEhZXUcHr0Io1Q9GZNMk1NN06C4sbi8uBPIsLBfLtwN3Pc5zgUpOyXmOKu35ET2EV1eLFpTvOrJvIkG0x+oY8D8aFfW4O2lhraTercQwCIO04zGUcMrjvgg4pp7g1YcdGvRLDGI0fz2KxskispI6jIOKE1sDVg/sW+85otke5E3yHzVxGM4+Y5wD7UXW4crLNtoMzi7jnVkmhiWSMB12sCeuemMe9JvTTuNLWz7GfeWNxYuizoBvXcjKwYMPYihNN2E01qV6YgoAKACgAoAKACgAoAKACgAoA5urIPbfgv/yKF3/2EH/9Fx1zVviOml8J6DWJqFABQAUAFABQAUAFABQAUAQ3dwLS2eYqX24AUHGSTgfzprUTKUep38xcR6Xkxttb9+vB9OlOy7iux1pqslxcLFLZmEOzIG8wN8y9RihoEy3eXkFhavc3L7IkxubBOMnHaklcbdiKXVbKDTl1CSbFswBV9pOc9OOtFnewXVrlmGVJ4UmjOUkUMpxjINIY6gAoAKACgAJwMntQBDa3cN5arc27F4mzg4Izj2ptWEncji1GCV4IyJI5J1ZkjkjKtgdc+lFguWqQwoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEXp+J/nQAtABQAUAFACqpc+gFAD/ACh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaADyh6mgA8oepoAPKHqaAEaIgZU59jQAwHNABQAUAFABQAUAFABQAUAFABQAHoaAOauv+Pqb/fb+dAEum/8AH/H+P8jQB8413nCbenf8eMf4/wAzUspGrp98tp5sU0PnW86gSJnB45BB7EVLVykzQtLzR0SayijuIBdJsa6lYMycg4wB93I5pNPcaaMeeIwTvEWVijFdyHIOO4NUSXtLa3SN2Goy2N0CNrjOxl9DgZ/pQ/IFbqav9s2Iv2DSrJ5lr5Ut00Hyu+c5K9x2qbXTXoXezV/P8SFr6we5tIbqa3mgiDsRFblI0Y9PQkdM8U7btb2FfZdL6lhNVsIfsStcwZhujI/kQMiKu0jjjn+dK2t/Jg9reaMy1uraW2v7OafyBcOHSUqSMgng4570Je7Fdv8AIba55PuSJcWFpbX9vFdvN5tuqKzKQGbPIHoPrRK7XzQo2T+TK1/dQz6Zp0Mb7pIUcSDB4y2RVP42/JEr4bebM6gAoAKACgAoAKACgAoAKACgAoA5urIPbfgv/wAihd/9hB//AEXHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAFABQBR1oZ0qUbd2SnGcZ+YU47iexQ0y0vCtwLe4+xIsxBh2CTBwO5qm0JJkGnxMmrws8YZvOlVpw3+sIB7dqHsJbl3xTzoE/+8n/oQpR3HLYwLmCYLc6SwPkWCy3APqpX5B+BJ/KrXcnyHX80b21vC6qjxWKPG8szqCcfwKvVqEDLFtCuq3EQvHkkB0xHIEhGWz1ODzSemwblZrsXOnafFdbWb7MziS4mdVJDEYAX7zcetO2oX0HwzpPFpb6vLMbQ2zbWDPgyhsDJXnOBR3sHa5CkkraTZLJJi0a4mErTswUnPyhyOfWjqLodD4f3f2VJ/pAnj8xvLZd2AvoC3JA55qJblx2KfhrVrAaTb2JuV+04YeXg5zkmnJO9xRatYzYjbPFop1CRxAYJhI24j+LuRziq72F2uS26G7Wwgd5jZveSrDl2BaLbwM9cdaWwEGszRxTXP2cLBNaMiR753MmBjlF6Bfc5poTNm0sob7XdSe43uYjHsG8gLlOTjpUt2SKSu2VtK+0XOowadMWK6UXMjE/fOcJ+nNN7X7gt7HT1mWFABQAUAFABQAUAFABQAUAFABQAUAFACL0/E/zoAWgAoAKACgCSH/Vj8aAJKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAK4+831NABQAUAFABQAUAFABQAUAFABQAHoaAOauv+Pqb/AH2/nQBLpv8Ax/x/j/I0AfONd5wmvpk6tAIc4Zc8eoqWUi7SGFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAEdxOtvEXY89h6mmBz9UQe2/Bf8A5FC7/wCwg/8A6LjrmrfEdNL4T0GsTUKACgAoAKACgAoAKACgAoAZNDHPE0UqhkYYINAFL+wdM/59v/H2/wAarmYuVEttpdlaS+bBAFcdDuJx+ZpXbCyLdIYUAFABQAUAVbyw+1sjrd3NuyAjMMmAfqCCKadhND7KyhsLRbaEHYuTljksTySaG7glYnpDCgAoAKACgAIyCM49xQBVsNOisBKUeSWSVt0kkrbmY9uabdxJWLVIYUAFABQAUAFABQAUAFABQAUAFABQAUAIvT8T/OgBaACgAoAD0oAkh/1Q/H+dAElABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/wCP8f5GgD5xrvOEUEg5BwaAJPtM/wDz3k/77NFhh9pn/wCe8n/fZosFw+0z/wDPeT/vs0WC4faZ/wDnvJ/32aLBcPtM/wDz3k/77NFguH2mf/nvJ/32aLBcPtM//PeT/vs0WC4faZ/+e8n/AH2aLBcPtM//AD3k/wC+zRYLh9pn/wCe8n/fZosFw+0z/wDPeT/vs0WC4faZ/wDnvJ/32aLBcPtM/wDz3k/77NFguH2mf/nvJ/32aLBcPtM//PeT/vs0WC4faZ/+e8n/AH2aLBcPtM//AD3k/wC+zRYLh9pn/wCe8n/fZosFw+0z/wDPeT/vs0WC4faZ/wDnvJ/32aLBcYzs5y7Fj6k5oENoA9t+C/8AyKF3/wBhB/8A0XHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAIvT8T/OgBaACgAoAD0oAkh/1Q/H+dAElABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/wCP8f5GgD5zzH/db/vr/wCtXecIZj/ut/31/wDWoAMx/wB1v++v/rUAGY/7rf8AfX/1qADMf91v++v/AK1ABmP+63/fX/1qADMf91v++v8A61ABmP8Aut/31/8AWoAMx/3W/wC+v/rUAGY/7rf99f8A1qADMf8Adb/vr/61ABmP+63/AH1/9agAzH/db/vr/wCtQAZj/ut/31/9agAzH/db/vr/AOtQAZj/ALrf99f/AFqADMf91v8Avr/61ABmP+63/fX/ANagAzH/AHW/76/+tQAZj/ut/wB9f/WoAMx/3W/76/8ArUAGY/7rf99f/WoAMx/3W/76/wDrUAGY/wC63/fX/wBagD2z4MY/4RC7wCB/aD9f+ucdc1b4jppfCegViahQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAi9PxP86AFoAKACgAPSgCSH/VD8f50ASUAFABQBieJvFVh4VtoZ76O4l89yqpboGbABLMQSOABzTguaXL/Xb9RSfLFyLeqaza6Toc2sSh5baGMSHygCzKcYxkgd/WlJOLs+9v0CDU1zLtf8LmTB45s2ubWK80rVdNS7YJDPd26rEzH7q7lY4J7ZrX2Tu4317GftVy81tO5q2WtW1/q+o6ZEkqzacYxKzAbW3ruG3nPT1AqFH3FPo219xo3aXL5XJdV1O30bSrnUrst5NtGXfaMk+w9z0qey7lJXItC1u18Q6WmoWiSxozMjRzKFdGU4IYAnB4q5wcbeZnCane3Q0agsKACgAoAKACgBGYKpY9AM0pOybGld2KGh6zb+INHg1S0SVIZ87VlADDBI5wSO3rWk4ODsyIyUr2L9Zt2V2UYnh3xHJ4j864h02WHTwSsF1JIp88hipwg5HI71o4Wim9+xPN77iun5m5UFBQAUAFABQBUg1O0udRutPilLXNoqNMm0jaHBK89DnB6U7Pl5hN2aXfUTS72a/shcXFjNYuWYeTMRuABIB4PfrQ1a2oX1a7FykMKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoATpRsBysnxAsiZpLLSNW1C0gYq95a2waLjrgkgsB3IFWoaJy0v3JcvecUrtdi5qHjHTLLSLHVIY7i/g1CVYrcWiBmdiDgYYj0I9c0ckufk67iU4uHP0E0/xjZXmpppt1Yahpd1NnyUv4PLE2OoVgSCR9afI2m072Dns1dWJbfxZptx4qufDY82O9t1DZdQEk4DYU5ySAe4HepjByg5rp/ww5SUZKL6lqLWrabxBPoipKLi3gWdmIGwqxwADnOfwpJXi5dnb8LjcrSUe6v8AjYZq+tvpUkaJo+pah5gJ3WcSuE9jlhQld2BuyuU9F8XQa3q9xpaaXqNpcWsYkl+1RIoTOMA4Y4J6gegNXye7zX02J5/eUbHQVmWFABQAUAYvifxRY+E9Pivb+G4ljllEQFuoZgcE55I4wDTiuaXKJu0bly71ezstFk1iSTNpHB5+5erLjIx7ntRNOD5Xve36BBqaTWz1IfDviC18TaSmp2cU0UTuyBZ1AYEHB4BP86qcHC1+pMJqd7dDUqCwoAKACgAoAKACgAoAKACgBrusaM7HCqMk+1JtJXY0m3ZFfTtRtdW0+G/spPMt513RvtK5H0PNXKLi7MiMlJXRaqSgoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv8AxN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/32/nQBLpv/AB/x/j/I0AfONd5whQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAe2/Bf/AJFC7/7CD/8AouOuat8R00vhPQaxNQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoARen4n+dAC0AFABQAHpQBJD/qh+P8AOgCSgAoAKAPONa1D+0vHl4raPf6pZadZtZ4tI1cLLKPnJyR/DxVwjelJ7c2i+X/BInK1SC35dfv2+VivFqM118GtVsbtZEu9MRrWVJBhgFI25H+6QPwqsR7zjNdWvvur/wCfzFQ93mh2T+5ptGxLpfiLxNYaZZXtrY2GnRPDNK6XDSyyBMEADaAueM1pJxjXc3um/vMopyoKC2aS+Ra8N/8AI+eLf9+1/wDRZrJf7vH1l+hrL+N8kVfiJfPJLpOhw2txefabgXFxBbqGdoYyCRgkdTj8qKP8Xm/lV/nsh1v4Tj/Np+rIPCeqS2/i3WrB9Ou7GO/H2+1gukCMWxiTGCRycGiSth3Z3cb/AHPb7mJP98m9FLT5r/gFXw/oOk634XTxNq+oTwanK7SS6j9qMbWxDkbRk7VAHGCO/wBKuT9k4qG2nzv3/IlL2vM5rW7+Vv6uXTpln4s8b6tZ62XurbT4IPslv5rKhDrlpPlIyc8Z/wDrVMfdpuS3u16W2Xz3HLWUY30tf18yt4j3Weh6No2l382q2lzfm3lY3oVnAyfJMo6DPHrxiiP7youZfZb9bdQl+7py5X1S9L9PIl0LStS0nV72K3tYdBsJrByYP7QE4ilz8soBwVHXPbilN81OSvr08vIcI8tSLS9fP/glDQrSLw/qekvqulXFvdXEoiTV7S/8+O+dh/y0BOdrdenpWt+ZuMdNHp6fqZNWXNLXXf1/QbrOmG21HVtX1XT5dXtVnaRNTsL8LNYIMYQISMFfb8azpyUYx1s+/fX+ka1I80npdW27WWv+Z6PDNHc6ZHPE7PHLCHRm6sCuQTWNdOKkn5l0WpKLXkeX6RarfeHvA1o8kkcctzchzG5UlfnyMjkZHHHrXXO3t9f5P0iYf8unb+dfmzc0zw9p1p4r1jw1FE/9kXFjFcNamVyqvuIJBzkZwO9YSk5UJSe8Xp91y3FQqxUesXf77fkc7pFtFpXwut72yL2c2pXi215dxyMGSLzmXI5wvHGR61vP3qsKb2dvnoS0oKrOO8b2/A6STSLLwl4v0GLQg8Cai0sd1b+czrKoTIcgk8g9/es4Sc3KMtrX9O337DnBQipR3ul633+4Z4F0SzbRZdalEkt6JLpI3eRsRpvYFVXOPU9M81jVk44dJdYq/wBxtTipYlt9JaHOx6Nb2vgLw/rsEtzHqcs8UJukuHDCN2KlQM4Awew9665P/aIw6Ssn56XOOP8Au8p9Y3a8rSOhtLOw8J+Pru2sTLa6e+jNd3CCRn+dZMb/AJiecZrDmcqM79Grfd0OnkSqQa3d0c/cRGxh0rXdN0i6s/PvoSup3eob7i6Rz0ZBkEEdie3StoJqrGm/Rr+v6uY1HenOa1trf5/0jpNB8P6VD8S9euI7XEtssEsTeY3ytIr7z15z79O1YqTWHsu7XySRrUinVTfVX+dzGsHe58L+GdJmnkisdR1G4jumRypcB3KxkjnDHj8KuylUin0hf52X5CqNxVRrT37fJmlJZQeG/Et5o+jl47C50aaeW18xmWJwSA4yTjPSspyc6NTm6bP9P1NIRUKtPl6vX/P9DLbQ7bT/AALofiW3knGrRm1IuTM5JVmClMZxtwcYx29zXU3bExh0bs/PQ5LXw059Unby1PVq4zsCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCjrcU82g6hFa5897aRY8ddxU4/WoqfCy6fxoyvA13ZN4F014JI1igtgs3IAR1Hz7vTnJrpxNudt7foc2HXu8vW7/ADMTXLjSrrTvC0+ixxpYya5EY/LiManl8kDA75+tOmpKslL+WX5BUcXSk13X5l/x+8co0SyiZTfyapC9ug+8ApyzfQDqaij/ABk10vf0t+pdb+DJd9vW5jXGiz6v4o8VPYyeVqVjPa3FlJ6SCI/KfZhwacJOFGM13l81pdCnFTqOD6pffrZlnwhrUev+O76/WMxSNpkSTRN1ikVyGU/Q1XKo0522ck16cpnzN1YKW6i0/XmOn8Ta4dD0wPBF9ovrlhDZ246yyHp+A6n2FYKLnJQju/w7s6G1FOUtl/VvmVtJ0iXwz4ZunB+1anIj3NxKeTNMQT+WeAPSnXmlG0NElp/mKjBud57t6/5fI4uTS7KD4dR+MYruc675az/bzcMWaQsAUIzgj+HGK3k3TqxhBaaad7/1cxglVhKU3rrr2texrpolp4k8cavFq8ckkAsrVmthKyKWIPJ2kE45/OoSUYzt/Np9yHdydO/WOv3mNJe6jb+CbXS4JZpojrj6eSbjy2aEM2E8z+HOAM+nFUv3kqbl1jd+b/r8hN+zVVR6SsvJaf18zc8M6Tf6R4qRYNLj0iwmt2860GoicOw+7IFPIPYkUcycZJu+1tNv+AHK1KLStvfXfT9C948gjuX8P28q7o5dWjRx6gq4NZUlzVGv7svyNKj5YXX80fzOatZLi9tLDwBOS0trqLR3JP8AFaxYkUn2YFQPpW8XzyjW7K7/AMS0M5rkjKkursvR6v5jtMmtB4DisbiO9ma91aaKK2s5RE07b2OxmOMIQOeayinJUkv5b/dcptRlVey5rffYbp8c+l6xr2mJpw0m2k0R7g2KXZnVXGRuz0Ukdh7U6j5qEm3ezX5DprlrwsrX/HXf9AfQ7XTfCXh3xHbSTrqm+zDXBmYlkbAKYzjbg4xjt9a2lJrE8nRuz+4wUb4eU+qV195oeILWz17xDqCRaLc6xJZIscr3F8ILe0JXPyAc5xyTg9K5otxpuadt9eun+R0ytKaha+2nTX9WZtndz67ofgzTNWu5TZag063TeYVM5jyI0ZuvP6/WuiUV7aWm0U0vPS7+W5hGTVG1/tWv5Xf57FtoIvDnjLV4tFZiLTQHkitzIXEL7shRnJx0OPesXJyoTb/mSv8AL9DZQiqsEvPT+u//AATN0/StUOl6brVjpawahI0UrarLq+43G4jcrKeCG6be1b+7Cqo9O3l/WtznfNOm5de/Z/1obsugWHiHxv4lh1NJJoIoLZliErIu7Y2GO0jJGOPrXNzOFByW93+SOmSUqsE9rfqc9HYxjwJo/ippbh9ZW6iQXbzuWCCUptxnGNo9P5mupu2IhFbStfzurnM1+4qS/lvbys7Gje2l34j8Wa5HdaIdWSylSKBH1E24tlK53KoHVuu72rnhpS5r2bb19DeprV5bXSS09SS6ttRuNC8JWeq3bNO2qeW80NwHZk2vj94vU7eM9fxrRcsq9/7r/JfmZyvGi1/eVv68iwnh3TdO8WaloFvE66XeaR9pltTM5XzBJjcCTkHj1rGU28PNveLVvLRm0IJVoW+1dPz2/wAzU+GWm2dl4Lsri2h2S3cYkmbcTvYEjPJ4/CtsQ3zcvTT8UjDDr3ebrr+DZ11c50hQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/wCP+P8AH+RoA+ca7zhCgB0cck0ixRI0kjnCqoyWPoBTAtXmkanpyK99p13aqxwrTwMgJ9sipUk3a5XK7XsU6ZIUAFABQBavNNvdPEBvLaSEXEYli3jG9T0IpXV3Hqh2dlLoyrTEFABQAUAFABQAUAFABQAUAFAEsdtPLDJNHBI8UWDI6oSqZ4GT2oGRUCCgAoA9t+C//IoXf/YQf/0XHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAFABQAUAcXZ6rd2cm5ZC6k5ZHOQa1aTM02jqNN1KPUoWdFKMhwynt+NZtWLTuQ+Ibqay0Wae3l8qRSuHwDjLAHrTirsUnZGUdVuoZrqK31Rb+NbN5fNCofKcdOV4P0NVbyFcvT61NZ2VvK9q0wMCySSmRUHTnGep9qnlux3sSDX7fFwzRsiw263Ckn/WIR2/HijlDmIZ/EqwkKLQs6xLJMplVSgIzgZ+8cdhT5Q5iZdbM95Hb2dm84kiSbfvChUY9Tn09KXL3C5q1JQUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAi9PxP86AFoAKACgAPSgCSH/VD8f50AE08VvGZJ5UiQdWdgo/M0m0tyowlN2irsrf2xpf/AEErT/v+v+NLnj3Nvqtf+R/cw/tjS/8AoJWn/f8AX/Gjnj3D6rX/AJH9zKenP4d0oXAsru0i+0zNPMTchi7t1OST/hT9orKN9EL6pX5nLkd35MrT2PhO5OomWe0b+1AouwLvAl2jA4DcfUYpe0jyqN9E7/MPqtfm5uR3tbZ7GnHqmkQxJFHqNoERQqjz14A/GnKopNtsUcJWiklB/cytbSeHrO/u76C8tEuL0qZ3+0g79owvBOBgelHtFy8t9P8AMf1Svzc3I7+jE3+Hf7YOr/a7Q3vk+R5puQcJnOAM4HPtmhVEk0nuDwldtNwenkwuH8O3epWmozXdo11Z7hBILoAqGGGGA2Dn3zRGoo3s9weErySTg9PJmZN4f8Dz3z3kn2IvJKJXQXhETv8A3jGG2k/hThWULWe34EywVad703r5Ms6tp/hLW7iO5vp7Vp40KLLHeGJ9p/hJRgSPY1KqRV7Pcp4Su7e49PJj3s/CUmiLorNp/wDZ6DCwidQF75BzkH3zmqlVUpczlqKODrRXKqbt6MZpun+EtKa4e2mtDJcpsmkmu/OZ1/ukuxOPbpRKqpR5W1YI4OtGXMoO/oyGx0PwXp15FdW0lqJICTCHvi6RE9dqsxC/gKft/wC8L6lV/wCfb+5iXeheCr28lup3tS87h5kW9KxysO7IGCn8RzSjVUVZMcsHWlq4P7mbg1XSBH5Y1CzCAYCiZQAPzqJTjK93uUsLXjtB/czMtrLwnZxWEUE9oiaazPaj7Xnyy2d3Vuep65q3WvLmb1tb5f0ifqda1vZve+z3LSzeH01STU1vLQXcsQheT7SOUBJAxnHUntU88eVxvo/+GG8JXclJwd1ps/UggtvCttoh0WOWxOnkMDA9wHBySTyST1OevFOVRS1bGsLXTbUHr5Mg0nS/CGiXRurGa1WfZ5YkkvDKyp/dUuxwPpVOvdNN7kLBVU0/ZvTyZdsZPD2m2JsrO8tIrcszFPtIPLEluSc8kms5TjKPK3pa3yLWGrqTkoO7d9nuVjZ+FDpNtpRntPsdo6vDF9r+6ynIOd2Tz6mrda81O+q/4YhYKqoOHs3Z+T9SeT/hG5tTOpSXNk901ubYu1yCDETkqVzjr7VPPHlcb6Mv6rXunyPTyZlR+GfAsfl4a2IicPErX7MIiDn5QX+Xn0q1Xs0+bVGbwNVpp03Z+TNCS38Ly63HrTXNoL+NdolW725GCOQGw3BPUGpVSMU0nuXLCVpWvTenkyN9P8ISaJ/YrvYtYhi4ia6ztYsWJDbsg5J5B70e1V077B9Ur6/u3rvow07T/CWlxXSWs9oDdrtnke88x5BjGCzMTjHvRKqpR5W9BRwlaMuZQd/RkskHheXR4dIe5tDZQbPLi+1/d2EFed2eCB3p+2XOp31QvqVbkcPZuz8maP8AbGl/9BK0/wC/6/41PPHuX9Vr/wAj+5h/bGl/9BK0/wC/6/40c8e4fVa/8j+5h/bGl/8AQStP+/6/40c8e4fVa/8AI/uYf2xpf/QStP8Av+v+NHPHuH1Wv/I/uYf2xpf/AEErT/v+v+NHPHuH1Wv/ACP7mH9saX/0ErT/AL/r/jRzx7h9Vr/yP7mH9saX/wBBK0/7/r/jRzx7h9Vr/wAj+5h/bGl/9BK0/wC/6/40c8e4fVa/8j+5h/bGl/8AQStP+/6/40c8e4fVa/8AI/uYf2xpf/QStP8Av+v+NHPHuH1Wv/I/uYf2xpf/AEErT/v+v+NHPHuH1Wv/ACP7mH9saX/0ErT/AL/r/jRzx7h9Vr/yP7mH9saX/wBBK0/7/r/jRzx7h9Vr/wAj+5h/bGl/9BK0/wC/6/40c8e4fVa/8j+5h/bGl/8AQStP+/6/40c8e4fVa/8AI/uYf2xpf/QStP8Av+v+NHPHuH1Wv/I/uYf2xpf/AEErT/v+v+NHPHuH1Wv/ACP7mH9saX/0ErT/AL/r/jRzx7h9Vr/yP7mH9saX/wBBK0/7/r/jRzx7h9Vr/wAj+5h/bGl/9BK0/wC/6/40c8e4fVa/8j+5h/bGl/8AQStP+/6/40c8e4fVa/8AI/uYf2xpf/QStP8Av+v+NHPHuH1Wv/I/uYf2xpf/AEErT/v+v+NHPHuH1Wv/ACP7mH9saX/0ErT/AL/r/jRzx7h9Vr/yP7mH9saX/wBBK0/7/r/jRzx7h9Vr/wAj+5h/bGl/9BK0/wC/6/40c8e4fVa/8j+5h/bGl/8AQStP+/6/40c8e4fVa/8AI/uYf2xpf/QStP8Av+v+NHPHuH1Wv/I/uYf2xpf/AEErT/v+v+NHPHuH1Wv/ACP7mH9saX/0ErT/AL/r/jRzx7h9Vr/yP7mH9saX/wBBK0/7/r/jRzx7h9Vr/wAj+5h/bGl/9BK0/wC/6/40c8e4fVa/8j+5h/bGl/8AQStP+/6/40c8e4fVa/8AI/uYf2xpf/QStP8Av+v+NHPHuH1Wv/I/uYf2xpf/AEErT/v+v+NHPHuH1Wv/ACP7mH9saX/0ErT/AL/r/jRzx7h9Vr/yP7mH9saX/wBBK0/7/r/jRzx7h9Vr/wAj+5h/bGl/9BK0/wC/6/40c8e4fVa/8j+5h/bGl/8AQStP+/6/40c8e4fVa/8AI/uYf2xpf/QStP8Av+v+NHPHuH1Wv/I/uYf2xpf/AEErT/v+v+NHPHuH1Wv/ACP7mH9saX/0ErT/AL/r/jRzx7h9Vr/yP7mH9saX/wBBK0/7/r/jRzx7h9Vr/wAj+5h/bGl/9BK0/wC/6/40c8e4fVa/8j+5h/bGl/8AQStP+/6/40c8e4fVa/8AI/uYf2xpf/QStP8Av+v+NHPHuH1Wv/I/uZLBfWd0xW3u4JmAyRHIGI/KmpJ7MidGpBXnFr1RYpmQUAFABQAUAFABQBzt74B8L6hfSXlxpSmWZt0myV0Vz6lVIB/LmqjNxVkTKKk7su6p4a0fWdOh0++sle1t2DRRIzRhCAQMbSOx6UuZ83N1Hyrl5ehFo3hDQNAna40zTY4ZmGDKzNI4HoCxJH4VTqSas2SqcU72L9tpdlZ393fQQ7Li9Kmd9xO/aMLwTgYHpU3fLy9P8yrLm5upDaaDpdjq11qtraLFeXgAnkVm+f8ADOB+AoUmo8i2BxTlzPfYh1vwtoviKSGTVbM3DQBhGRM6bQcZ+6w9BRFuLbXUJJSVmR6N4O0Dw/eNd6XYmCZkMZYzyPlSQcYZiOwqnUk1yvYlU4p3SI08DeG474Xi6aodZfOEfmv5Qf8AvCPO3P4URnKKsmOUIybb6mrFptnBqVxqMcO26uUVJZNxO4LnaMZwMZPSpTsrfMbV2m+mhVPhvR20y4017FHtLqVpZYnZmDOxyWyTkHPPHTtRd2iu2wJK8n33G6V4Y0jRbmS6srVhcSIEaaWZ5X2j+EFySB7Cqc5NWJUIp3Ld7plnqL2z3cPmG0mE8J3EbXGcHg89TweKmLcXdea+8ppSVn/Vhkei6dFrMuspaqt/NEInmycsoxxjOOw5xnihNqLitnqDSbTfQqSeEdCl0saY1iPswmM6qJX3JITncGzuByT0NCbVrdNF6A0nzX66sbaeD9BspZ5YLIiW4ga3mkaaRmkQ9QSWOT79fem5NxcXsxRioyUlui3LoWmTaXb6XJbZtLUxmKPe3y7Mbec5OMDqaHOTnz9dw5FyOHRlW+8IaFqOoSX9zZFp5QBKVmdFlA6b1UgN+INJNpWWw5JSd2Udb8NxQ+GrfSdK0O0v7OCTJsriZlO3k/I5Jw2T1J6ZqudympSFypQaiVPCnhq4s9cl1OXSYNHtltPssNmkwmZvn3F3YcEn6k1cpLkcW73a/BbGcYvmTSslf5t2/wAjUh8D+HLe8juotOAaKTzY4zK5iR/7wjJ2g/hUKpJbMuUIy3NSLS7OC/ur+OHbcXios77id4UELxnAwCelQ9Y8nQv7Sl1RUHhjRhosOjCz/wBBhcPHF5r8MG3A5znrz1q+eXOp9V/wxPJHlcej3Gap4T0XWbv7XeWjGcp5bSRTPEzr/dbYRuH1qU2r26java/QsDQNKEFhAtmiRadIJLVEJURsARng89T1z1queXNz9dvkyeSPLyW0vf5omOl2Z1U6oYc3Zg+zmTcf9XndtxnHXvjNRf3XHoy+qfYg0fQNM0FJk0y3MCTNuZPMZlB9gSQvXtiqcm0k+hKik3JdTSqSgoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv/ABN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/32/nQBLpv/H/H+P8AI0AfONd5whQB2Pw3XGo6ncQRrJfwafI9opGfn45Hv/jU1XajK3l9xdJXrRT2/Xp+pd8NajqWreG/Eses3E13aRWpkVrli+yYZKgZ6cjpUVFGMIyW91b+v63HBylVcXtZ3/r7/uLh8O6GJf8AhJvsUf8AY39l/aPs+848/wC7s6+v61M5OHPG+t1b0f8AX4jpxU+R+t/lv+f4FmHwz4ZtIbCyvY7A/arQTTTyXMi3G5hnMagbdox6/wD16qN80orpp/w4U7ShGbXxa/8AAXoYl1DoeieDtMu30iG/urt7iPz2kZRhZCA2B14xVNt1EtlaLf3K6KcEqcmujsvx1/A0L7w3otgdT8Qi0R9LbT45bKFidvmycAdc8EZ/4FWcnKMXB73svTe/9dgioycZ20td+vb+upag8N6VeNYXV4iPHa6DFceVPO6oznPLEZIUY5xWlaXLUqW/mt+Y4xUoQX+L8Lf5kUOh+F7vVLCFYrIy6lbzRNHaTO8SSgZR0LYPYj0zWcnO01HtdX/L+uwkoLlb72+X9fmWbXwPo/laT51uhksRnVQWPOYi4z9DgU51LSlLok/vVv8AMUaWkYfabT+Tb/yseX3ckc13NLDEIonkZkjHRVJ4H4VpBNRSluZzs5Pl2IaokKACgAoAKACgAoAsWMVtNfQx3k7QW7NiSRE3FR7DvQxo9Hiv0sYktNNgWCxjBUwMN3ng8Ey/3if07YrG19zW9tjivE9tplvqI/szfGHXdJbsCRE3oG7gjn2rSN7amcrX0MWqJCgD234L/wDIoXf/AGEH/wDRcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFABQBzdn4alaTdduFQH7qHJb8e1W5diFE6CC3htY/LgjCL6CoLINVsP7T0+S08zy95B3bd3Qg9Pwpp2dxNXQs9hFJp89pCqQCZCuUQcZGM4ovrcLaGZceGjM5ZbqP5rdYCZIA5XAxlTn5c1XMLlK95pDT3mm2KRzMtvGEuJ9m1HjGDjPrkdPehPdia2RevdDae+ku7eeKNpkCuJbcS4x0K5PBpKWg2izbaZ9n1A3Ql3ZgWHbsA6HOeOPwxSb0HbUvUhhQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACL0/E/wA6AFoAKACgAPSgCSH/AFQ/H+dAHnPxRnkOp2VvvPlLCXC9sliM/pXDin7yR9fw9CPspy63t+BxtvY3l0pa2tZplBwTHGWAP4VyqLeyPoJ1qdN2nJL1ZL/Y+qf9A27/AO/Df4U+SXYz+tUP5196D+x9U/6Bt3/34b/Cjkl2D61Q/nX3oP7H1T/oG3f/AH4b/Cjkl2D61Q/nX3oP7H1T/oG3f/fhv8KOSXYPrVD+dfeg/sfVP+gbd/8Afhv8KOSXYPrVD+dfeg/sfVP+gbd/9+G/wo5Jdg+tUP5196D+x9U/6Bt3/wB+G/wo5Jdg+tUP5196D+x9U/6Bt3/34b/Cjkl2D61Q/nX3oP7H1T/oG3f/AH4b/Cjkl2D61Q/nX3oP7H1T/oG3f/fhv8KOSXYPrVD+dfeg/sfVP+gbd/8Afhv8KOSXYPrVD+dfeg/sfVP+gbd/9+G/wo5Jdg+tUP5196D+x9U/6Bt3/wB+G/wo5Jdg+tUP5196D+x9U/6Bt3/34b/Cjkl2D61Q/nX3oP7H1T/oG3f/AH4b/Cjkl2D61Q/nX3oP7H1T/oG3f/fhv8KOSXYPrVD+dfeg/sfVP+gbd/8Afhv8KOSXYPrVD+dfeg/sfVP+gbd/9+G/wo5Jdg+tUP5196D+x9U/6Bt3/wB+G/wo5Jdg+tUP5196D+x9U/6Bt3/34b/Cjkl2D61Q/nX3oP7H1T/oG3f/AH4b/Cjkl2D61Q/nX3oP7H1T/oG3f/fhv8KOSXYPrVD+dfeg/sfVP+gbd/8Afhv8KOSXYPrVD+dfeg/sfVP+gbd/9+G/wo5Jdg+tUP5196D+x9U/6Bt3/wB+G/wo5Jdg+tUP5196D+x9U/6Bt3/34b/Cjkl2D61Q/nX3oP7H1T/oG3f/AH4b/Cjkl2D61Q/nX3oP7H1T/oG3f/fhv8KOSXYPrVD+dfeg/sfVP+gbd/8Afhv8KOSXYPrVD+dfeg/sfVP+gbd/9+G/wo5Jdg+tUP5196D+x9U/6Bt3/wB+G/wo5Jdg+tUP5196D+x9U/6Bt3/34b/Cjkl2D61Q/nX3oP7H1T/oG3f/AH4b/Cjkl2D61Q/nX3oP7H1T/oG3f/fhv8KOSXYPrVD+dfeg/sfVP+gbd/8Afhv8KOSXYPrVD+dfeg/sfVP+gbd/9+G/wo5Jdg+tUP5196D+x9U/6Bt3/wB+G/wo5Jdg+tUP5196D+x9U/6Bt3/34b/Cjkl2D61Q/nX3oP7H1T/oG3f/AH4b/Cjkl2D61Q/nX3oP7H1T/oG3f/fhv8KOSXYPrVD+dfeg/sfVP+gbd/8Afhv8KOSXYPrVD+dfeg/sfVP+gbd/9+G/wo5Jdg+tUP5196D+x9U/6Bt3/wB+G/wo5Jdg+tUP5196D+x9U/6Bt3/34b/Cjkl2D61Q/nX3oP7H1T/oG3f/AH4b/Cjkl2D61Q/nX3oP7H1T/oG3f/fhv8KOSXYPrVD+dfeg/sfVP+gbd/8Afhv8KOSXYPrVD+dfeg/sfVP+gbd/9+G/wo5Jdg+tUP5196D+x9U/6Bt3/wB+G/wo5Jdg+tUP5196D+x9U/6Bt3/34b/Cjkl2D61Q/nX3oP7H1T/oG3f/AH4b/Cjkl2D61Q/nX3oP7H1T/oG3f/fhv8KOSXYPrVD+dfeg/sfVP+gbd/8Afhv8KOSXYPrVD+dfeg/sfVP+gbd/9+G/wo5Jdg+tUP5196D+x9U/6Bt3/wB+G/wo5Jdg+tUP5196D+x9U/6Bt3/34b/Cjkl2D61Q/nX3oP7H1T/oG3f/AH4b/Cjkl2D61Q/nX3oP7H1T/oG3f/fhv8KOSXYPrVD+dfeg/sfVP+gbd/8Afhv8KOSXYPrVD+dfeg/sfVP+gbd/9+G/wo5Jdg+tUP5196D+x9U/6Bt3/wB+G/wo5Jdg+tUP5196D+x9U/6Bt3/34b/Cjkl2D61Q/nX3oP7H1T/oG3f/AH4b/Cjkl2D61Q/nX3oP7H1T/oG3f/fhv8KOSXYPrVD+dfeg/sfVP+gbd/8Afhv8KOSXYPrVD+dfeg/sfVP+gbd/9+G/wo5Jdg+tUP5196D+x9U/6Bt3/wB+G/wo5Jdg+tUP5196D+x9U/6Bt3/34b/Cjkl2D61Q/nX3oP7H1T/oG3f/AH4b/Cjkl2D61Q/nX3oP7H1T/oG3f/fhv8KOSXYPrVD+dfeg/sfVP+gbd/8Afhv8KOSXYPrVD+dfehr6VqMaM76fdKiglmaFgAPU8Uckuw1iaLdlNfeiXQZ5bfX7CSFyji4QZHoSAR9MU6bamrEYyEZ4eaktLP8AI90r1j82CgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAK/8TfU0AFABQAUAFABQAUAFABQAUAFAAehoA5q6/4+pv8Afb+dAEum/wDH/H+P8jQB8413nCFAFixv7vTLyO8sp3gnjOVdDyP8fpTCxqav4y17XLQWl/fb4MgtGkaoHI7naBn+VZqnFO5ftJWsVP7f1T+w/wCxPtZ/s/dv8navXOeuM9ecZqnFSab3RKbSaXUvWfjfxDYaeljb3+2KNdkbNGrPGvorEZA/yKU4qe44ycdjMudWvrvT7awuJy9vaFzChUfKWOW5xk5PqappOXN12+4fPLlcb7u/zJZtf1S40WHRpbtmsYG3Rw7V4PPfGT1PBNJpSlzPclNxi4rYnh8V65b3dtdRXxWW1txbRHy1wIh/CRjDD65pvVyb67j5pWSvtsF94s1rUL+1vZ7zEtm263CRqqxHOeFAx271MYqLbXUJSclZ7AfFmus+oOb9t2pqFuj5afvABj04444xRyR5VHotR88ubm6mPVEBQAUAFABQAUAFABQAoJBBHUUAa48T3wH+rgP/AAE/41PKiuZmbd3Ul7ctPLt3N2UYAqkrCZDQIKAPbfgv/wAihd/9hB//AEXHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAIvT8T/OgBaACgAoAD0oAkh/1Q/H+dAHmvxQ/5Ddp/wBe3/sxrgxXxI+x4f8A4E/X9EbHwv8A+QJd/wDXz/7KK1wvws4OIP48PT9WdtXUfOhQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBS1j/kCX/8A17Sf+gmpn8LOjC/x4eq/M8V0f/kN2P8A18x/+hCvKh8SP0PFfwJ+j/I93r1z80CgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAK/8AE31NABQAUAFABQAUAFABQAUAFABQAHoaAOauv+Pqb/fb+dAEum/8f8f4/wAjQB8413nCFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQB7b8F/+RQu/+wg//ouOuat8R00vhPQaxNQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoARen4n+dAC0AFABQAHpQBJD/qh+P86APNfih/yG7T/r2/9mNcGK+JH2PD/wDAn6/ojY+F/wDyBLv/AK+f/ZRWuF+FnBxB/Hh6fqztq6j50zdO1lLyO+M8X2Z7GZ4pVLbsADIbOBwRzQ9IKf8AXoCu5uH9a7EGm65NqKadKbaGBL1JJNjz/vAo+6QuPmyME+matws2n0SJUrq672C78TWENxbW9rPb3cs10lu6RzgmLdnkgZ6Y6cUoxcn5Wb+4JSUb99PzS/UvPq2nR3osnv7ZbokAQmVQ5J6cZzSSb2G2luJcatptpcLbXN/bQzPjbHJKqsc9OCaEnLYG0tw1a/8A7L0m6v8AyvN+zxNJs3bd2B0z2qW7W+RSVx0l2V0trxVQEQmUCR9qj5c8t2HvVVFyNomm+dJ9zOXxNbRXy21+1vaqbSO4M7XA2EsSNoJAz069/Sq5fit0diVLReauX5tW023hjmmv7aOOVS0btKoDgdSDnnqKmzvYpNPVCS61pUEscM2pWsckgBRHmUFgehAJ70+Vt2sHMrXuOl1TT4LkWst7Ak5ZVETSAMS3QY681KV9gbS3Hf2hZfZBd/a4fs5OBL5g2k5xjPTrxTs7pdwurN9iHVdT/sxbQ+T5v2m6jt/vY27u/TnHpRFXlb1/BBJ2i32/zsZa+I9UmuLwWugG4t7OdoXkS6UO23GcIR6HpmhW5VKXUHfmcV/WhtaffQanYQ3tsxMUy7lyMEex9x0pyi4uzFF3VyzUlBQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFLWP+QJf/APXtJ/6Camfws6ML/Hh6r8zxXR/+Q3Y/9fMf/oQryofEj9DxX8Cfo/yPd69c/NAoAKACgAoAKAIbuf7NZzXG3d5UbPtzjOBmk3ZDSu7Fazur2aNJ7mC2hgaPfuWdmIGM8gqB+tXJKLafQiLckmuo6LWNPnSVo7lSIkLvwR8v94Z6j3FS1ZXY003ZE1reW97GZLaTzEBxuAOD9PX8KbTW4Jp7EUOq2M9z9miuFaTJAABwSOoB6Ej2oSurg2k7ENxrtnFKsMUiyymZYioJAyWAODjBIz0FEVe39dAk0ky0L61Nus4mHls/lg4PLZ24x654pdvML7+RHHqtjNdfZY7hWlyRgA4JHUA9CR6CmldXQNpOzEi1jT5p1gjukaRyVAwcEjqM9M+3WhJvYG0nZinVbEXf2U3Kebu245xu/u56Z9utCV9gbS3F/tWx+1/ZPtKedu245xu/u56Z9utCV9gbS3K9/rtnZiVFkWSeMgGPJAySOM4xnBzjrRFczQSainfsX554rWFpp5FjjXqzHAFIZXTVbGS2kuRcoIojhy2VKn0IPIptWEmmIur2DWz3P2lREjBXLArtJ6ZB5HXvRbbzC61ILnXrOLTri6gkEpgGCmCDuxkZ4yAfXpSs9PMaa18h9pqDyNGs8lvgwGViu5SMNjOGHT3JptJX+RMW3bzHw6zp05IjulJClsYIyo6nkcj3os0rjTTdic3tsFiYyjEyl0P94AZJ/Kk9L36DWtrdSuut6c1uZ1ulMYIUMFPzE9AOOT9KbTQk0xs+uWUMVvKHMiTyeWCik4I65GOMenWhJt2DmVrjxqkEUc0tzNEiRzGJdhJJPHGMZ3ewzS7BfccdWsFtkuTdIInbYrf7XPHseDxTs72C63JbS8t76Iy20gdQSp4III7EHkGhqwJpkWpXsljbo8USyvJKkSqz7RljjJOD/KktWl/Ww3omyGLVWjmuIdQijt2gjWVnjkLrtJI67QQePSnZNXXewrtOz9fuLc15b25YSyhCkZlbPZR1NIZDFrGnzCUx3SkQp5j8H7v94eo9xTasrsSabshE1rTpBIUulIiTzGOD931HHI9xRZgmmWTcRCZId48yRSyr6gYyf1FK24XWj7lS6v7gX4sbOCJ5RF5rGaUoMZxgYBJPH4ULW77A3ay7jRrCJPa29zBJBPcKTsI3bCDjqOufX+VNK7dhN2V2SLrOnOsrLdJthHztg4XnGM+ue3Wl0uO+th6arYvavci5QRRnDlsqVPoQeQabVgTTGjWNPNubj7Sqxq4RiwKlWPQEHkUWYXWowa7pjFQLtcs23BUjac4+bj5fxxQk3oJySLk9xDawtNPIsca9WY8CkUUptZtxZm5tiJgJUjZTlSpZgOQRkdc00ndLuS5KzfYWLV4Ps0s9yRAsdw8I53FipxwAMknHQUdIvurjvq/Inh1C0uPK8qdX87dsx3I6j2I9KLMLoI9RtJUjeOdWWWQxoR/EwzkfoaX/AA4XWvkNt9UsrqcwQXCvIMnABw2OuD0P4U7O1wuk7E4uIjcG33jzVUOV/wBknGf0pdLjKsmsafFFHK9yu2QEpgE5A6nAHT36U7a2C5YS7t5JVijlVmePzFCnOV6Zz6UWYroQXcDWhulfdEATuAJ6VLdlca1ZVh1uxk0+K9eQxpLjarKdxOM4Axk/hVSVnYlSTVy7BcQ3UKzQSLJG3RlPBoasNO5S/t7SySBeJ0PY84OMDjk+w5otpcLpOxIdXsBaJdfaV8p22qQCST6bcZz7Yos72C6tcV9WsEgina5QRzEhDz8xHUfX2otrYLq1w/taw+xrd/aV8lm2g4OS3pjrn2xmhprQE0wbVbFbQXRuF8pm2g4OS3pjrn2xmi2tgTT1FXVbF7aS5W5TyojtdvQ8cfXkcUmrBdElreW97GZLeUOAcNwQVPoQeRTaaBNMz5vENskdw6KT9nmWJ9+VGCVBbOO279KEr28/+D/kEna67F2DU7K4ilkjuF2w/wCsLfLs9znt70norsE7uyFtNQtL7d9mmDlPvDBBA7HB7e9OzC6Y83UAeZTIN0ChpB/dBGf6Uulx9bFebWtOgOJbpVO0PjBOFPQ9OnvTs72FdWuPudTsrRkWa4VTINygZPHrx0HueKWuwXVrkEWt2n2C3urlxCZ1yqDLH36DOPem1Z2BO/3sml1awhMQa5UmZd0YXLbx6jHWizvYOZWuNs9TiuXaNwI5POkiRc537Dgn/wCtQleKfdXC+rX9bXHNqEZu4oYpImBd0fJOQVGSBxg+9Lpd9v1H5f1tcS21jT7uZYre6V3ddygA4Yd8HufanZi5kCaxp7z+Qt0pkL7AMHDN6A9D+FCTewNpaMu0hhQAUAFABQAUAV/4m+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/wAfU3++386AJdN/4/4/x/kaAPnPy29V/wC+hXecIeW3qv8A30KADy29V/76FAB5beq/99CgA8tvVf8AvoUAHlt6r/30KADy29V/76FAB5beq/8AfQoAPLb1X/voUAHlt6r/AN9CgA8tvVf++hQAeW3qv/fQoAPLb1X/AL6FAB5beq/99CgA8tvVf++hQAeW3qv/AH0KADy29V/76FAB5beq/wDfQoAPLb1X/voUAHlt6r/30KADy29V/wC+hQAeW3qv/fQoAPLb1X/voUAHlt6r/wB9CgD2z4MDHhC7HH/IQfof+mcdc1b4jppfCegViahQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAi9PxP86AFoAKACgAPSgCSH/VD8f50Aea/FD/AJDdp/17f+zGuDFfEj7Hh/8AgT9f0RsfC/8A5Al3/wBfP/sorXC/Czg4g/jw9P1Z21dR86ch4ksL9dVmjsIJXi1qFIJ5I1JETKwBdj2GxmH4VVOz92W17/5r8ETNtLnjvZr/ACfy1LeradO2s6bFZROkcdncRLIqnbESqhcnt/8AWpNuSqN9UvzGko+zS2T/AEMqKN5bLw7ZR6LdxT6fdRfaGa3IWPGQxDdGBPORn1NbXTquaejT/LRGVmqfI1rdfnuQNpl3tvdNvG1PfPetIFt7NHWTL5VxKV4wMdWBGKim9IeRc959n+XYu3cUlqmv2Vzplzdz6g5a3kjgLrIpUBQWHC7SO+Mdai3NBRWjT/W9yk+WfM9VZfgtUa2q2d0PA1xZFXnuhY+WQgLF3C449eaKrUp3XdfmKinGFn2f5FeXUvt/h26sIrDUVn+wOoEtnIgJ2YwCRyc9qqsuaTa7/qFB8vKn5FC1V9O1y1u7vS7uSJdHihMiWzSeW+eVwBnPY+nerk03UXeX36GcE1Gn5L7thmk6Tcpe6C1xYOkKS3kwjaPIt1blA3ZT7Uk7XTeqilfzuN66paOV/lZ/qM8Rpf3B1q2W1uYzIu2KO0sA4ugFGGeXB6HIxwRjjms4/CvX7tdzR/E/T9NjX0aykXxLf3U9s4JtLZUldCMnadwBPvjNaTa9638z/JGcU/cv/L+pnx2Mv/CU/wBhbP8AQYrk6nnsAeif9/Mn8Kmn8PN/Lp9+33K5VRa2/ms/u3+9pfebPiWCadNM8mJ5Nmowu+xSdqgnJOOg96UNJp+T/IqfwNen5ozdO1KbSJtWibSdSnlmv5JIhFattcEAA7z8oHHXNFm4RS3/AOCxOym2/L8kbHhvT59M0K3tbnaJhueQKchWZixA+mcU52ukuiS+5BG7vJ9Xc1KgoKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoApax/yBL//AK9pP/QTUz+FnRhf48PVfmeK6P8A8hux/wCvmP8A9CFeVD4kfoeK/gT9H+R7vXrn5oFABQAUAFABQBX1CJ59OuYoxueSJlUZxkkHFTJXRUXZozB4fgTR5IYIhDdS23lsxckZIGQefWtJy97Ta9/xMqcbJX3t+hHe2t9qaE/YWtjFaSxhXdD5jMoAUYJ446nHak+r72/O443XKu3+RtWyNHaxRsMMqAEehxTqO8m0EE1FJmDDZ6pLe2MlzFcFoZi0rtJGIgNrD5FU5xz3GaFb8PmKV3p5/qKlnfrZWen/AGEn7Nco7T702sofO4c5zjqCPWmmm0/L9LDadpLv/ncsrptwNa5UfYVkN0pyP9aRjGPrlvqamLsvNaL5/wBWCSu/W1/l/S+4qpZ6pNeWbXEVwzQ3JeRjJGIguGGUUHJ6jqM1ULJ38vxsKabuvP8AC5Yh065TS7SFocSR3vmsNw4XzCc/kaSesfJfpb8ymr83m/1Q+zju7QfYm0/zl+0M/nl12bSxbJ53bhnpjqOtJbLyQnu33KaaVdq5tZIrqWP7SZQ6zosWN+4H+9kemOvenB25fIU1fm8x1xZ340+505LEymS4Mqz70ClS+7nJzuHTp260Qt7l+lgkn71ut/yNTVrea4giaBPMeCdJfLyBvAPTJ7+nuKSdpJ/1sU1eLX9b3Kt1Hd3sQmXT/JaGeOVY3dd8wXqDgkDrxz27ULRp+v5WE9U1/W9yC6sby+kuLn7I0PmNbqsTsu4hH3MxwSOh9e1OPutet/wsKack/SxNqNhczvqZii3faLRI4/mA3MC+R+opR0+9P8inq/k0JqunzXNxcPuWKFrBojK7AKrbs8+2O9F7XfmvwuCWy8n+NivI82oalaRvbJblrSZRiRXzkKMjb/D6H9KbXx+n6kxduTyf6PYdHbahKljE9i0Qtbd43ZpEO5im0YwenHfFE2pczXVfqhwvHlT6NfkyZ7e/g0jToYklBiRVnSAp5gwmPlLcdetOTTm30FFNQt1K9tp99Dah2tZWdNQNwI2lVnZNuOpOM8+tCavH0f43Czal8vwt/kPWwvLe7N4LYy7LyWTygy7mRlADDJxkY6EjvSTtZeTX43G1e780/wALCjT7uWeO5a38vfqAnaIspMaBCuTzjJODxnrRH3WvR/iKSbu/T8C0rNp93eTSxMVurmNYtuCWyqrnr6g/lSj8Kj6/5jejcvJfn/wRdetJLyxjjjtzcBZ43eIEDcoOT1IHSkviT/rZlP4Wv63Rnf2RPJDfx2tibCGa32rC8infJnhsKSBxx1/lVXsu+qf+ZKWvbRr7/wDIkvLbUNQNy/2Bod1g8Kq8iElyQccEjHv/ACpNLX1X4XHG+l+if6E2pafczj91Fu/4l80P3gPnbbgfoaJauXm1+bFFWUE+n+RM1g73Nl5kQMUdrJFLyOMhOP0NOVnKfn/mKCajHuv8iv4ehlYy3E7B/J/0SF+u5EJy34n+VNu8b9Xr/X4v5glaVui/r8rIn1SAzzBZ9KF9Bt+Ro2USRtnnliMDpyDUL8SmQ21pfwnTZZ43maLzFkAkDMgYjbkkjdgDBPX61d1d+n46E2dvnf5akZ0u7OhRQhWSaG5M2xHUFhvY8HpnByM1KdnHyX6WKavzeb/W4LaX6w3NxBDdJNI0YPnSxtKyKecD7oPJxkn8Kemi/rYWuvoQR6ZfPPNKbeYK9zbyDz5VZyqk7icHA+lNNK3z/Kwmm0/RfmW7rT7qWPWAkWTdFDF8w+bCqD345B60ou0Yrs7/AIobV2/S35l/VFumsiLPcZN6khdu7bnnbu4zj1qeqK6Mxl0y/kF4xt5h501uyefKrOQrZYnBwPpVppOPk3+RDTal6W/MnjsLy2ljuvs5lMV5PJ5Ssu5kfOGGTjPsSOppRdoxXlb8bjau36p/hYbPp9+9tcXkEHl3bXXnQwlxlRtCHJzjJGT1pWVlH1v8/wDLQe7b9Pw/z2JLHR5bPVFAUfY4E3xHPWQqqnj6KT/wKm3dS/rR6/mSotW/H12DTLa9t7yJEgnt7VVbzI5pUkRfQRkfNj6447U7q2v/AARu99O47xAkyvbTWrBbiQm2HPJVx1/AgH8DURScuV7Pf5a/ldfMcnZcy3W35f5fcP8Ass2mX3m2tm9zCbZIVWNlDJtJx94jg5/Sm3fmv1dxKNuXy/q5XtLC90yW0lFsbjFs0TrG6jYS+4feIyO34dKbe69Pw0DXR+v46mhpNtPb6PFBOgSUK25QcgEk96morqy7foVHR3fd/mULW2vbWPTpmsZHa0ga3eIOm7kL86/NjHy45IPNW2nJvuRyu1uzZoaTbzQQTPOnlvPO8vl5zsB7ZHGe5x3NS9kuxS3b/raxQtdNu47TSo2hw1vcu8o3D5VO/B689R0pp+8n5W/BCkrp+t/xEktdRhZzHHN5T3cjuLdo/MKkDaQW4A656GkraJ9n+f8AkN3u2vL8v8xmn6ZeRSWbSwMoju55W3SBiqsDgk55PNVdWXpb8SbOz9U/wJJbXUIfOMMcojkvGkcQFPMKFAARu4HPXoaldE/P8/8AIp9beX5IrW1nd2Lw3MkJMgvJGSCWdS8iuoGQc4LDB4z61V9l5P8AO5LW781+VhEtrm/jvJIkKSR6ispjicZOEUEBjxu5+mR+NJaKL9fxbB6yl6L8DU0m1kilubiWK4jaYqM3Eqs7ADqQvA6+poe1hre5VurG7kF5CtszCW8inR9y7SoKZHXORtPalDRxb6N/r/mE1fmt1Q/UtMubuXUPKAUTQRBG3AbmVmJHt2/OlF2187/ghyV38mh+m2s39oNdTQ3aEReWGuZkYnnJAC5446k/hVaJMnW6uMvLe9ju9QMFo063sCqrB1UIwBHzZIOOR0zU7xa/rZf5Fp2kpf1u/wDMLTT7mM3fmRY82ziiXkHLBWBH61VR8ylbq3+SFTVnC/RL8xttbXunyJILJrjzLOKIhXUGNlByDk9DnqM9KJ2lzLuyYppRfZWKsGl39pHZyGO4ylr5Lx2siBkIbP8AEcEc+vYU202/l+CBJ2+b/FlzTdNmtb21kMBjjS1dW3SByrM4bGeM9+gxSvv8vwuO23q/xILm3msdKnunULNBevcRAsPnBY8ceqkjHvSV7QS3tb7/AOkwt8V/X7kv8rE0Wl3ELaZhNxiErXDZH33U5P8A30aJ2s0u1l+ARvo33v8Agwt9OuUsNHiaPa9sf3uGHyfu2H48kdKc7Sk/S35Cimo287/iUo2lW20izMMRSG5RVnSVWWTbkZUDn3OcYqk7z5vJ/l+X/AE1aLXn+v5nUVmaBQAUAFABQAUAV/4m+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/x9Tf77fzoAl03/j/AI/x/kaAPnGu84QoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPbfgv/yKF3/2EH/9Fx1zVviOml8J6DWJqFABQAUAFABQAUAFABQAUAVNSv1061ExjLksFC5xz/kU0ribsZX/AAlX/Tl/5F/+tVcpPMS2viRbi6jha1KeYwXcJM4J/ChxGpG3UFFWx1Oz1Eyi1m8zym2vwRg/jTaaEmmSXF3BaGITPt86QRpwTlj0FCVwuTUhhQA2SRIYmlkYKiDLMegFAEQu42lhRFdxMpdZFUlMe57U7CuSyOI42chmCgnCjJP0FIYkMomhSUKyhwDtdcEfUUAPoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoARen4n+dAC0AFABQAHpQBJD/qh+P86APNfih/yG7T/r2/9mNcGK+JH2PD/wDAn6/ojY+F/wDyBLv/AK+f/ZRWuF+FnBxB/Hh6fqztq6j50KACgAoAKACgAoAKACgAoAKACgCpaaZaWM888EbCW4bdK7yM7NjoMsTgDPAHFO+nKK2ty3SGFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAUtY/wCQJf8A/XtJ/wCgmpn8LOjC/wAeHqvzPFdH/wCQ3Y/9fMf/AKEK8qHxI/Q8V/An6P8AI93r1z80CgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEIBGDyKAIbextLRma2tYYC/3jHGFz9cU7vYVluT0hhQAUAFABQA0qrY3KDg5GR0NADqACgAoAKAGuiyIyOoZWGCpGQRQARxpFGscaKiKMKqjAA+lDdwStsOoAKACgAoAKACgAoAKACgAoAKACgCMwQtMszRIZVGFcqNwHoDQBJQAUAFABQAUAFABQAUAFAEc9vDcxGK4hjmjPVZFDD8jQAQwxW8QigiSKNeiIoUD8BTbb3EklsSUhhQAUAFABQAUAFABQAUARyQQzFGliRzG25Cyg7T6j0NGwb6ElABQBXSxs4rg3EdpAkzZzIsYDH8etF7KwrXdyxQMKACgAoAKACgCv8AxN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/32/nQBLpv/AB/x/j/I0AfONd5whQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAe2/Bf/AJFC7/7CD/8AouOuat8R00vhPQaxNQoAKACgAoAKACgAoAKACgDH8T/8g2P/AK7D+Rqo7ky2Mx59MOnx2xZy0ZViQmNxz8wz9D+lVrcnSw6Sa1l1HTktNu1JACApGMvnvRrZh1Rta5eGx0ieVP8AWFdkY9WPAqIq7LbsjCsYrvRtRtUltkhW4t/IBWXfukXkE8DBNW7NEK6ZTga0YaW3mytqDXi/alZmPOT1B4HtT11FpoX1Sb+0/wCwSX8sXP2jdk/6rrj/AL64pdLldbFOIzNqJaW7jhvhd7cMZDIVzwu0cbSPbFPoLqW006G70zWLiRZJZllnVPnbgDnAGcdRSvZodtGJYtAG0tbSZlQ2cu4oSxD4GePUHtQ+oLoQaZKkQniiZJ2e0kZp4JXPQdZFbo1NiRLbWkeoSCO5aRkXTI3CiQj5ueeDzSvYLXI450nTSn1eWY2htSVYM2DKDxkrznFHewdrmx4VYvooJZ2/fScuefvHrUy3KjsbNSUFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACL0/E/zoAWgAoAKAA9KAJIf9UPx/nQB5r8UP+Q3af9e3/sxrgxXxI+x4f/gT9f0RsfC//kCXf/Xz/wCyitcL8LODiD+PD0/VnbV1HzohYKMkgfWgBvmR/wB9fzoAPMj/AL6/nQAeZH/fX86ADzI/76/nQAeZH/fX86ADzI/76/nQAeZH/fX86ADzI/76/nQAeZH/AH1/OgA8yP8Avr+dAB5kf99fzoAPMj/vr+dAB5kf99fzoAPMj/vr+dAB5kf99fzoAPMj/vr+dAB5kf8AfX86ADzI/wC+v50AHmR/31/OgA8yP++v50AHmR/31/OgA8yP++v50AHmR/31/OgA8yP++v50AHmR/wB9fzoAPMj/AL6/nQAeZH/fX86ADzI/76/nQAeZH/fX86ADzI/76/nQAeZH/fX86ADzI/76/nQAeZH/AH1/OgA8yP8Avr+dAB5kf99fzoAPMj/vr+dAB5kf99fzoAPMj/vr+dAB5kf99fzoAPMj/vr+dAB5kf8AfX86ADzI/wC+v50AHmR/31/OgA8yP++v50AHmR/31/OgA8yP++v50AHmR/31/OgA8yP++v50AHmR/wB9fzoAPMj/AL6/nQAeZH/fX86ADzI/76/nQAeZH/fX86ADzI/76/nQAeZH/fX86ADzI/76/nQAeZH/AH1/OgA8yP8Avr+dAB5kf99fzoAPMj/vr+dAB5kf99fzoAPMj/vr+dAEdzdxW1rNcMwIiRnIB5OBmk3ZXLpw55qC6ux5XP8AETxBJMzxzRQoTwixAgD6nmvPeImfbQyTCKNmm36kf/CwPEf/AD9x/wDflP8ACl9Yqdy/7FwX8v4sP+FgeI/+fuP/AL8p/hR9Yqdw/sXBfy/iw/4WB4j/AOfuP/vyn+FH1ip3D+xcF/L+LNHQ/iBq76vbwXzxzwTSLGwEYUrk4yMVcMRPmSZy4vJcOqMpUtGlfc9OrvPjSlrH/IEv/wDr2k/9BNTP4WdGF/jw9V+Z4ro//Ibsf+vmP/0IV5UPiR+h4r+BP0f5Hu9eufmgUAFABQAUAFAFbUJXh065ljba6RMyn0IBxUydkVFXaMex1BzcWCw6qb5px+/hPlnyxtzu+UAjBwOfWtZ2TlpormKbcU766GjBqyzWljcCIgXrhQM/d4J/9lpONpcvlcq+jfnb8bFLR9Qu7m5tUml3q9vK7DaBkiTaD+VFtPlH8Uxt6r1l+Bb1cvBCbhb66iPCJDCI/wB456AblJyalX2XUb7sat1d2UNtZuDfX8iF2OQigDGSTjpyAOOap2bdtkSrpa7sadcLC3SGzd5pneMxFwvlsnUE9Me9K3btcd+/e36gddH2dP8ARiLl5Wi8lpAAGXrlumPf3HFFtrev6Bfe/wDXUt6ffrfwuwTy3icxyJuDYYc8EdRgihrRME9bGdc6zcyRRy29s6W8lzHEk+4HcPMAPy9geQD/ACoirtX6/wCQpO0ZW6Dk1d48RxQTXMk11LEoeRRgrnvj7vH1+tCV0vS/4jbtf1S/AdN4gELyFrbMMBCzv5q5VuM4XqwGeTx7ZppXfr/wwm2iaTVJftEqW1jJcxwMFldXAOcA4UfxYBHpSSvuNvsUr7VdQjj1QLGsS2xTy5AwJGcdiO4P4U4pNJvvb8hSbV7dr/mXptXSCO8LxN5lq6qIweZN2NuPqTj8KSV7W6u39fLUbdm79Fc0BnAyMGkNC0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBX/AIm+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/x9Tf77fzoAl03/j/j/H+RoA+ca7zhCgDpPBGnadqGoX51Oz+1w2thLcCLzGTLLjupz60qj5aTl1uv1NKMOerGHcuT6bofiDw3eanomnS6bd6e8YktvPaZZVc4BBbnOalqcXHW6bsOPLJSVrWV/u3ILvwHeWtvcgajYzXtnD59xZRyEyRpjJPTBIBGf/1ZTqLdbXtcUabk0ur6G9P4X02FpBaafblToAupDNI52uc5devPHTgUTdnNXslJIdGPNGk7Xck/nt/mYH/CCX3/AAkH9lfa7fb9k+1/aufL8rHXpnrxQ52jKTXwkqDfJy68w628A3txDbqdRsYr27i863spHIkkTqD0wCRnj/6+HOXLdWvbcIw5rO+j28yBfB0i+H4tZutTtLSKUSbYpiRIzISCoGOTwapySmo97fc/8rg4SSb7Eh8C3y69Npb3UCpDa/a2ujny/Lx19fb8Kj2iUJSa20+Y1BuUYrXmOYrQgKBBQAUAFABQAUAFABQAUAaWn6JNfW5uHmitoidkTTHAlf8Auj/Gk3YpK5RngltpnhmRo5EOGVhyDTJI6ACgD234L/8AIoXf/YQf/wBFx1zVviOml8J6DWJqFABQAUAFABQAUAFABQAUAR3FtDdxeVOgdM5waL2Ap/2Dpn/Pt/4+3+NVzMXKh8Oj2EEqyx24DqcglmOPzNK7CyLtIYUAFABQAY5zQAUAFABgCgAoAq3lh9rZHW7ubdkBGYZMA/UEEU07CaH2VlDp9qttADsXJyxySTyST60N3BKxPSGFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACL0/E/zoAWgAoAKAA9KAJIf9UPx/nQB5r8UP+Q3af9e3/sxrgxXxI+x4f/gT9f0RsfC//kCXf/Xz/wCyitcL8LODiD+PD0/VnbV1HzpVzvO49/0piFoGFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFPV/8AkDX3/XvJ/wCgmon8LN8L/Hh6r8zxnT4UuNStYJBlJJkRgD2JANeVFXkkfo9ebhSlJbpP8j0//hA/D3/Po/8A3+b/ABr0Pq9PsfEf21jf5vwQf8IH4e/59H/7/N/jR9Xp9g/trG/zfgivqPgjQoNMuporZ1eOF2U+axwQpI70pUKai3Y2oZxi51YxlLRtdF3PPNH/AOQ3Y/8AXzH/AOhCuCHxI+uxX8Cfo/yPd69c/NClrH/IEv8A/r2k/wDQTUz+FnRhf48PVfmeK6P/AMhux/6+Y/8A0IV5UPiR+h4r+BP0f5Hu9eufmgUAFABQAUAFAEN1B9qtJrfdt82Nk3YzjIxmk1dDTs7iWtslpbRwoF+RApIXG7Axmqm+ZvzIiuVJGfb6LPCbSM3qtb2cpeJBDhiMEAE55xnqAKalrd72sDje6Xe/43JNP0f7DNDJ5+/yonjxsxnc+7PX8KV9Pu/AbV/vb+8de6fd3GoQ3UN3FGIVISOSAuAx6tww5xx+frRHS4NXsElhdvJDdLdxLdxKyF/IOx1JBxt3Z7DvRezfmFm9xsGj+TNbTG4LyQySSSEpjzGcYPfgD8ad+i7W/G4rfnf8LEc+hLITIJYzKLh5k82HenzDBUrnn65FJO1v663G1e/y/KxdsLRrOAo7xszMWPlxCNR7AD+pJobuCVij/YlwIo7Vb5VtIp1lRPJ+bht20tnkfhnp+LT1TfT/ACsKSuml1JYdH8q4il8/Pl3Ms+NnXeDx17Z60k7JLsrfjcbV7+qf4WIpdCzczSQyW6xzyeY/mWwkdTxnaxOBnHcGiLtZdgkr6omfTrqO4nazvVgjuGDyKYdzK2ACVOcDIA6g0J9GDXVDbvR3uTeKt0qR3aruBjyVZccg5HGB0x+NOLtbyd/yE1f7rfn/AJkdxZm78RwyqkixwJmYspCuw5QA98FieKUNLv8Ars/wCWtl/Xf8/wBTTgSZDJ50wl3OSmE27F7L7/Wl0K6ktABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAV/4m+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/wAfU3++386AJdN/4/4/x/kaAPnGu84QoA3/AAjrVhot9ePqKXDQXVnJbH7Oqlxuxz8xA6A0TXNTcPNF0p+zqRn2L0vibR9I0d9P8M214GuJo5bi4vtm47DuVQF4xn+v4SuZyjzbLULxUZct7tW9EbOrfEKwvrG7liu9XSe5hKCzxGIY2IwTuxkr149+3bJ0tOVar9DSNXVSej8u5Wk8daW/m4gu/n0UWA+Rf9Zzz977vP19qupFy57dWmTQmqfsr/ZTv+H+RVPje3PggaV5E39qeR9k+0bV2eRuzjOc5xx0oqQ5p8y62v8AK4qc+Va7q9vna/8AXoalt8RLF9PtWubrVba4trcRNbWoj8uVgMBtx5HbP9aKkW5SlHr+AUpKMIw7fkcvrOvwan4a0rT1Sb7TZyTvM7gbW3vuGCDz78CqcffTW1kvuSRbqJ05R6t3/P8AzOr1vULnSPhta29/B5Gq3cQtOSN5t1JIP0wQPxrOpaday9X6r/g6iptqld+dvnb+vuPNa2MQoAKACgAoAKACgAoAKACgCe5vbi8ESzyblhQJGoAAUD0AoSsO4XN5PeGNriTzGjQIrEDOB0ye/wCNCVguQUCCgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAi9PxP86AFoAKACgAPSgCSH/VD8f50Aea/FD/AJDdp/17f+zGuDFfEj7Hh/8AgT9f0RsfC/8A5Al3/wBfP/sorXC/Czg4g/jw9P1Z21dR86VV+6PpTELQMge9tI7gW73UKzN0jaQBj+HWhK+wm7bj2niRirSopHYsBQBF9stv+fmL/v4KQx/2u2/5+Iv++xTERfaov+fhP++xRYLol+2Wv/PzF/32KLMLiG9tBc/ZjdQif/nl5g3fl1oSvsDdtyegYUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFPV/+QNff9e8n/oJqJ/CzfC/x4eq/M8c0j/kM2X/AF8R/wDoQryofEj9ExX8Cfo/yPb69g/NDmdU8faPpOpyafPHdNJEQHeOMFQcZ7kH9KtQbVyHNJ2NW8uoL7w5c3VrKssMtq7I69CNprKorRZ1YV3rw9V+Z5Fo/wDyG7H/AK+Y/wD0IV5MPiR+iYr+BP0f5Hu9eufmhS1j/kCX/wD17Sf+gmpn8LOjC/x4eq/M8V0f/kN2P/XzH/6EK8qHxI/Q8V/An6P8j3evXPzQKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAr/AMTfU0AFABQAUAFABQAUAFABQAUAFAAehoA5q6/4+pv99v50AS6b/wAf8f4/yNAHzjXecIUAFABQAUAFABQAUAFACszMcsxJAxye1ACUAFABQAUAFABQAUAFABQAUAFABQAUAFAHtvwX/wCRQu/+wg//AKLjrmrfEdNL4T0GsTUKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/ADoA81+KH/IbtP8Ar2/9mNcGK+JH2PD/APAn6/ojY+F//IEu/wDr5/8AZRWuF+FnBxB/Hh6fqztq6j50qr90fSmIWgZganaWs8kum2cCtdXTCSaU8+SP7xPY8cCnDddkTLr3ZJfIxvHwGI4GcewoTTFa2hkYPoaYFz7Jc/8APvL/AN8GkMd9luP+feX/AL4NO5NmQfZp/wDnjJ/3yaq4EN3FLb6JdoLSOWQTs63yyIQTvyDwd27tipj9i3kN7zv5nXpu2Lu+9jn61L30HG9lcdQUFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFPV/wDkDX3/AF7yf+gmon8LN8L/AB4eq/M8c0j/AJDNl/18R/8AoQryofEj9ExX8Cfo/wAj07xeZWt9Mt47iaBbrUYoZGhcoxQhsjI+le1DqfmMuh5j4vh+z+Kb2EbiEZQCxySNoxk1vD4TGW53/hYEfDM5GMwXH83rmr9TuwX8an6r8zgdH/5Ddj/18x/+hCvHh8SP0bFfwJ+j/I93r1z80KWsf8gS/wD+vaT/ANBNTP4WdGF/jw9V+Z4ro/8AyG7H/r5j/wDQhXlQ+JH6Hiv4E/R/ke7165+aBQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8AH1N/vt/OgCXTf+P+P8f5GgD5xrvOEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/APIoXf8A2EH/APRcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFABQAhZVxuYDJwMnqaAFoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/OgDzX4of8hu0/69v/ZjXBiviR9jw/8AwJ+v6I2Phf8A8gS7/wCvn/2UVrhfhZwcQfx4en6s7auo+dKq/dH0piFoGZz6DpzzSTGKQPK25ys8i5P4NQnZWE0m7j5raQyHYuVwAOfane4rWMv+yr3/AJ4/+PD/ABqroVmdFUFhQBW8p/7v60CIf7E077X9q+zDzN/mfebbu/vbc4z+FNNrYTSe5fpFBQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAU9X/AOQNff8AXvJ/6Caifws3wv8AHh6r8zxzSP8AkM2X/XxH/wChCvKh8SP0TFfwJ+j/ACPW9d0h9YtrdIbv7LNbXC3Ecvlh8MoIGQSM9a9mLsfmTVynBoGrHUILnUNf+1RQsSYVtFi38YAJB5HtT5lbRCs76s1NWAGi3oAwBbSYA/3TWU/hZ1YX+PD1X5njuj/8hux/6+Y//QhXlQ+JH6Jiv4E/R/ke7165+aFLWP8AkCX/AP17Sf8AoJqZ/Czowv8AHh6r8zxXR/8AkN2P/XzH/wChCvKh8SP0PFfwJ+j/ACPd69c/NAoAKACgAoAKAIL26FnaSXBUvtHCjqxJwB+JIFJuyuaU4c8lEoiwknG+8u7h5DyVhmeJF9gFIOPrmp5b7s29qo6QireaTf4i/wBlwf8APa9/8Dpv/iqOVf02Ht5dl/4DH/IP7Lg/57Xv/gdN/wDFUcq/psPby7L/AMBj/kH9lwf89r3/AMDpv/iqOVf02Ht5dl/4DH/IP7Lg/wCe17/4HTf/ABVHKv6bD28uy/8AAY/5B/ZcH/Pa9/8AA6b/AOKo5V/TYe3l2X/gMf8AIP7Lg/57Xv8A4HTf/FUcq/psPby7L/wGP+Qf2XB/z2vf/A6b/wCKo5V/TYe3l2X/AIDH/IP7Lg/57Xv/AIHTf/FUcq/psPby7L/wGP8AkH9lwf8APa9/8Dpv/iqOVf02Ht5dl/4DH/IP7Lg/57Xv/gdN/wDFUcq/psPby7L/AMBj/kH9lwf89r3/AMDpv/iqOVf02Ht5dl/4DH/IP7Lg/wCe17/4HTf/ABVHKv6bD28uy/8AAY/5B/ZcH/Pa9/8AA6b/AOKo5V/TYe3l2X/gMf8AIP7Lg/57Xv8A4HTf/FUcq/psPby7L/wGP+Qf2XB/z2vf/A6b/wCKo5V/TYe3l2X/AIDH/IP7Lg/57Xv/AIHTf/FUcq/psPby7L/wGP8AkH9lwf8APa9/8Dpv/iqOVf02Ht5dl/4DH/IP7Lg/57Xv/gdN/wDFUcq/psPby7L/AMBj/kH9lwf89r3/AMDpv/iqOVf02Ht5dl/4DH/IP7Lg/wCe17/4HTf/ABVHKv6bD28uy/8AAY/5B/ZcH/Pa9/8AA6b/AOKo5V/TYe3l2X/gMf8AIP7Lg/57Xv8A4HTf/FUcq/psPby7L/wGP+Qf2XB/z2vf/A6b/wCKo5V/TYe3l2X/AIDH/IP7Lg/57Xv/AIHTf/FUcq/psPby7L/wGP8AkH9lwf8APa9/8Dpv/iqOVf02Ht5dl/4DH/IP7Lg/57Xv/gdN/wDFUcq/psPby7L/AMBj/kH9lwf89r3/AMDpv/iqOVf02Ht5dl/4DH/IP7Lg/wCe17/4HTf/ABVHKv6bD28uy/8AAY/5B/ZcH/Pa9/8AA6b/AOKo5V/TYe3l2X/gMf8AIP7Lg/57Xv8A4HTf/FUcq/psPby7L/wGP+Qf2XB/z2vf/A6b/wCKo5V/TYe3l2X/AIDH/IP7Lg/57Xv/AIHTf/FUcq/psPby7L/wGP8AkH9lwf8APa9/8Dpv/iqOVf02Ht5dl/4DH/IP7Lg/57Xv/gdN/wDFUcq/psPby7L/AMBj/kH9lwf89r3/AMDpv/iqOVf02Ht5dl/4DH/IP7Lg/wCe17/4HTf/ABVHKv6bD28uy/8AAY/5B/ZcH/Pa9/8AA6b/AOKo5V/TYe3l2X/gMf8AIP7Lg/57Xv8A4HTf/FUcq/psPby7L/wGP+Qf2XB/z2vf/A6b/wCKo5V/TYe3l2X/AIDH/IP7Lg/57Xv/AIHTf/FUcq/psPby7L/wGP8AkH9lwf8APa9/8Dpv/iqOVf02Ht5dl/4DH/IP7Lg/57Xv/gdN/wDFUcq/psPby7L/AMBj/kH9lwf89r3/AMDpv/iqOVf02Ht5dl/4DH/IP7Lg/wCe17/4HTf/ABVHKv6bD28uy/8AAY/5B/ZcH/Pa9/8AA6b/AOKo5V/TYe3l2X/gMf8AIP7Lg/57Xv8A4HTf/FUcq/psPby7L/wGP+Qf2XB/z2vf/A6b/wCKo5V/TYe3l2X/AIDH/IP7Lg/57Xv/AIHTf/FUcq/psPby7L/wGP8AkH9lwf8APa9/8Dpv/iqOVf02Ht5dl/4DH/IP7Lg/57Xv/gdN/wDFUcq/psPby7L/AMBj/kH9lwf89r3/AMDpv/iqOVf02Ht5dl/4DH/IP7Lg/wCe17/4HTf/ABVHKv6bD28uy/8AAY/5B/ZcH/Pa9/8AA6b/AOKo5V/TYe3l2X/gMf8AIP7Lg/57Xv8A4HTf/FUcq/psPby7L/wGP+Qf2XB/z2vf/A6b/wCKo5V/TYe3l2X/AIDH/IP7Lg/57Xv/AIHTf/FUcq/psPby7L/wGP8AkH9lwf8APa9/8Dpv/iqOVf02Ht5dl/4DH/IP7Lg/57Xv/gdN/wDFUcq/psPby7L/AMBj/kH9lwf89r3/AMDpv/iqOVf02Ht5dl/4DH/IP7Lg/wCe17/4HTf/ABVHKv6bD28uy/8AAY/5B/ZcH/Pa9/8AA6b/AOKo5V/TYe3l2X/gMf8AIP7Lg/57Xv8A4HTf/FUcq/psPby7L/wGP+Qf2XB/z2vf/A6b/wCKo5V/TYe3l2X/AIDH/IP7Lg/57Xv/AIHTf/FUcq/psPby7L/wGP8AkH9lwf8APa9/8Dpv/iqOVf02Ht5dl/4DH/IP7Lg/57Xv/gdN/wDFUcq/psPby7L/AMBj/kIdNCfNb3l3FIOjNcPIPxVyQaOXsw9tf4opr0S/Kxb0+6a6gbzVCzROY5VXpuHcexBB/GnF3MqsFB6bPVFqqMgoAKAK/wDE31NABQAUAFABQAUAFABQAUAFABQAHoaAOauv+Pqb/fb+dAEum/8AH/H+P8jQB8413nCFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQB7b8F/8AkULv/sIP/wCi465q3xHTS+E9BrE1CgAoAKACgAoAKACgAoAKAK1/fR2FsZn+Y5GFzgmmlcTdjDl1B5tuWLBL3zF9kHSqsTct2Osr9oaGdyfMnfYxOAq8YpNDTLHiG6mstFmuLeQxyKVwwAOMsAetEVdhJ2RSttWjgtbq7Go3F+IIwxjkg8vHPY7RTaFcsJr6rLKl5aSWoSEzoWYNvQfTofaly9h83cfbazI6tJdafNaw+UZVlJDKVHPOOh9qLBcZba/5ksQubKS1iuFLwSMwO8AZ5A6HFDiHMVH127uZdPeK1ltre5uQqyMVPmpz1HVafKtRcxJba08cNvFFb3F3LcPKEDyLn5T3OAMUOIXJh4hVrKKWO0ka5lmMC2+4A7x1GemPely6j5izpupm/muYXtnt5LZlV1ZgeSM9qTVhp3L9IYUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAi9PxP86AFoAKACgAPSgCSH/VD8f50Aea/FD/AJDdp/17f+zGuDFfEj7Hh/8AgT9f0RsfC/8A5Al3/wBfP/sorXC/Czg4g/jw9P1Z21dR86VQMDB6jimIWgYUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAU9X/wCQNff9e8n/AKCaifws3wv8eHqvzPFrSf7LeQXG3f5MivtzjODnFeTF2aZ+kVYe0pyh3TR3f/CzYf8AoFP/AN/h/hXb9aXY+X/1dl/z8/D/AIIf8LNh/wCgU/8A3+H+FH1pdg/1dl/z8/D/AIJDefEaK6sZ7caY6mWNkB84cZGPSpliU01Y0pZBKnUjP2mzT2/4JyOj/wDIbsf+vmP/ANCFcsPiR9Biv4E/R/ke7165+aFLWP8AkCX/AP17Sf8AoJqZ/Czowv8AHh6r8zxXR/8AkN2P/XzH/wChCvKh8SP0PFfwJ+j/ACPd69c/NAoAKACgAoAKAM/Wv+PBP+vm3/8ARyVE9vu/M6MP8b9Jf+kssVRkFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFbS/+PrU/wDr6H/omOpju/66Gtb4Yen/ALczRqznCgAoAr/xN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/wB9v50AS6b/AMf8f4/yNAHzjXecIUAFAEv2afyvN8l/L/vbTigZFQIKALR0vUBa/ajYXIt8bvNMLbMeucYobSdmNJvYWDSdSuoRPb6ddTRHo8cLMp/EChtLcEm9iKK0uZ5Hjht5ZHjBZ1RCSoHUkDpRdWv0CzvYakE0sUkscTvHEAZGVSQmeBk9qASvsR0CCgAoAKACgAoAKACgAoAKACgAoAKACgD234L/APIoXf8A2EH/APRcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFAEc9vHcRsrqpJUqCRyMjHFAGIdHkjd02lwLMgEDgvnpV3IsW9P0lYXWaZVYtCqlWXJDdTSbGkWNWsDqenSWgl8ouQd+3djBB6ZHpSTs7jauirJpV/c2Vxa3eqLKkybVxbBdpz16807rohWY+60SO8uvNllOw2ptygXk5PXNClYGriQaTdeWYbzUDPB5JhEaRhMg8ZPJycUXXQLdyODQZA9uLy9+0RWqFIUEezqMZJzzxx2o5uwcpHD4euIzZo+pb4LKUPFH5IBwOxOf1p8wcpPZ6H9kntZftO/wCztKcbMbt5+vGKTlcEipeaQbK0DxyXDzLdtOkkEIcx7uuVzyPpTTuJqxN4et7lJr+5uBLi4kUq0ybGbAwTt7D0pSHE2qkoKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoARen4n+dAC0AFABQAHpQBJD/qh+P86APNfih/yG7T/r2/8AZjXBiviR9jw//An6/ojY+F//ACBLv/r5/wDZRWuF+FnBxB/Hh6fqztq6j50Y0asc8g+ooAb5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lAB5A/vt+lADZbSOaJ4pCzI6lWHHIPWh66DjJxkpLdHCT/CwmZjBqoEZPyh4ckD3IPNcTwvZn1MOIfd96nr6/8AAI/+FWT/APQWj/78n/Gj6q+5X+sUf+ff4/8AAD/hVk//AEFo/wDvyf8AGj6q+4f6xR/59/j/AMAP+FWT/wDQWj/78n/Gj6q+4f6xR/59/j/wC9o/w3TT9ShvLq/89YHDrGse3LDkZOemaqGG5ZXbObFZ66tJ04QtfS9zuK6z5wpax/yBL/8A69pP/QTUz+FnRhf48PVfmeK6P/yG7H/r5j/9CFeVD4kfoeK/gT9H+R7vXrn5oFABQAUAFABQBn61/wAeCf8AX1b/APo5Kie33fmdGH+N+kv/AElliqMgoAr3d/aWPl/ap1i819ibu5pOSW5pTpTqX5FexYpmYUAVW1OwS6+ytewCfOPLMg3Z9MetSpJuyZr7Gpy8/K7d7FqqMgoAr3d/a2IT7TOsXmNtQHqx9hSckml3NIUpzvyq9h8FzDchzBIsgjco2OzDqKE01dEyhKGkkS0yQoAKAELKGClhuPQZ5oHYjtrmG7hE1vIskZJAZenBwaSd1dDnCUJcslZktMkKAK/2+zFstz9qh8hjhZN42k9OtK608zT2c+Zxs7khnhE4gMqeaV3BM/MR649KL62J5Xy81tCSmSFAEUtzDDLFFJIqvMSI1P8AEQMmldXsUoSacktES0yQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCtpf/H1qf/X0P/RMdTHd/wBdDWt8MPT/ANuZo1ZzhQAUAV/4m+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/wAfU3++386AJdN/4/4/x/kaAPnGu84QoAdGVEilxlQRkeooA7DfD9l3bTu3bvM3/L5e3pj685rM0OPkKmVigwpJwPatDMt6NHDLrdlHcY8lp0Dg9CMjrVw3Jlsbc+q+IP8AhMLiK3eWWbznjW2YnYU5wNucYx/jWEEnT17am9RtT06bDb+8u7Lwrov2a4lt2L3G4QyFejj0NU9anyQaqLv3NyK5ltNTk1EqBff2F50wIxmQEcsPUgCh2UZLpzL/AIKBaqL62f8AwGUp7K3TQNZ1KxGLK/hidF/55sJPmT8D+hqGnG0H0a+7UqD5pc67O/qcVWpgFABQAUAFABQAUAFABQAUAFABQAUAFAHtvwX/AORQu/8AsIP/AOi465q3xHTS+E9BrE1CgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgBF6fif50ALQAUAFAAelAEkP+qH4/zoA81+KH/IbtP+vb/wBmNcGK+JH2PD/8Cfr+iNj4X/8AIEu/+vn/ANlFa4X4WcHEH8eHp+rO2rqPnQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoApax/wAgS/8A+vaT/wBBNTP4WdGF/jw9V+Z4ro//ACG7H/r5j/8AQhXlQ+JH6Hiv4E/R/ke7165+aBQAUAFABQAUAZ+tf8eCf9fVv/6OSont935nRh/jfpL/ANJZYqjIQkAZJwBQB5zq2q22t6teSTOBBb27i1y23LjGD9Se30rjlJTk7n0tChPD0opbtq/odT4S1n+1dLEcrZuLYBX/ANodj/n0relPmR5WPw/sal1szcfd5bbPvYOM+tXO/K7bnBG11c5bTX0RfDOzUPK8zLfaFb/WmTdz/tZrNez5I28vvPUrLEfWb0/l2t+ViS9uZpbzUFOozWSWMCPboGC78rnLZ5bnjFKcn70r6rp/XcmlCKhTtBS5m7/f07CLLfapcEPe3Fr/AMS6OcrCQvznPr2onf33fa35By06SVop+81r2IYxNqN/4fuprqdZJoZCxRgMFQOnHGe9Ul+8v5Jly5adKtBJWTX5v8ug57+5kkS2lvpLaCbULiN51YKVVfuqGPTNRFuSim+j/MPZRinKMbtRjp67sbHqc8cUrf2i8sUeqRxeczDBj4zkjjFOE21Ft/aa/AJUYt2UbPkbt5kmoancl9a+zXjBYWtliZGyEyQGx/WhSb6/asTTow/dc0d1K/y2JNTaW2l+ww31/LJFC07N5yRgZJ5ZiOQPQDFKbaTs9v6+YqKUlzyikm7bN/cv1K9q0l9q2iXdxdSrJLaszbWCgkEcdO/cVcf4t/7qZdRKnRqQitFL/P8AIdbXl1eQ6ZazX8tvHcGcvMjBXYq5woY9KiDcuVN/ZTFOnCnKpOMU7W06K6Fgvb28+xWwvpQrXk0H2hMZlRVOD0xn3pxbny3e6YTp06fPLl6RduzZqeH5Z2S9tpp3n+y3TRI8hyxUAYye55rSm24692vuOXFRipRlFWukzAls3urmbw6vCwzzTj2UplP/AB5/0rnSbjZfZv8A8A9BVFBLE91Ffjr+CJLbUTcxXWrPJLGwihtI2iA3BjgsBu4HJ6mtOa95L7T0InR5HGiktLyd/uW3kKdRv4LHWYPPmVrZI2jLyiR0LHkFhS5pcrV9ml+QKlTlUpOy9699LJ28jRuLa5TU7KwGqXgSeOV5XDjcT8vTjAH4Vdm5uN9Lfqc0JwdKVTkV01+pXsL+8c6bHJcO5F1PC7Hq4UHGahTk4xfeLNK1KC9o0ukX6XsR2E99Hb6NfPqFxK13L5UkbkFNpz2x1461cbqcdd1+hdWFNurBRS5dV3ILjUbg2c94dWlju/tflfZQ4AVQ+MBeucd6zhJtQd9W9S1Sjz8nJ7tr3+Xc7Ouk8YKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAK2l/8AH1qf/X0P/RMdTHd/10Na3ww9P/bmaNWc4UAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/wCP8f5GgD5xrvOEKACgCz9un+xfZd3yZ698en0osO5WoEFMDXbxVrbWxtzfHaU2F9i7yvpvxu/WpcU9ylJrYbZ+JdWsLWO2trlUiiJKAwxsVycnBKk02ru7Em1sVhq1/wCfczm5ZpbuMxzOwDF1PUc9Og6UrLl5eg+Zt3Eh1S9t9On0+Kcra3BBkjwCCR9RkdB0ptXtfoKLcW2ipQIKACgAoAKACgAoAKACgAoAKACgAoAKAPbfgv8A8ihd/wDYQf8A9Fx1zVviOml8J6DWJqFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACL0/E/wA6AFoAKACgAPSgCSH/AFQ/H+dAHmvxQ/5Ddp/17f8AsxrgxXxI+x4f/gT9f0RsfC//AJAl3/18/wDsorXC/Czg4g/jw9P1Z21dR86FABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFLWP8AkCX/AP17Sf8AoJqZ/Czowv8AHh6r8zxXR/8AkN2P/XzH/wChCvKh8SP0PFfwJ+j/ACPd69c/NAoAKACgAoAKAM/Wv+PBP+vq3/8ARyVE9vu/M6MP8b9Jf+kssVRkVdSs2v8ATp7RJ2gMy7fMUZx68fpUyV1Y1o1FTqKbV7HMweA5rbzPJ1jZ5sZjf/Rhyp6j71Yqg1sz1JZpGduantrv/wAAuaF4RbRdRF2NRaUbCpjEW0Nn15NVClyu9zHE49V6fJy2+f8AwDpK2PMK7afZPci5a0gM4OfNMY3fn1pKKTukae1qcvJzO3a4s9hZ3TrJcWsMzp91pIwxH50cqvewRqzgrRk0SeRD5jSeUm9l2s20ZK+mfSiy18yeaVrXGLaWyGIpbxL5IIjwgGwHrj0osNzk73e+5WvtMFzb+VbtDADJ5jq1usiSE9dynv75qZQvZI1p1uWV5XfzaaG2GjQ2lrPDOUuTcPvl3RgIemAF6ADApqKUbPXr8wq4iU5KUdLKy/4csrp9kqNGtnAEbaGURLg46Z47dqdkZurUbvzP7++4s9laXTpJcWsMzp91pIwxX6ZpOKbu0Eak4K0W0BsLMrEptISsBzEPLGIz/s+n4U7K9w9pPXV67+Yj6fZSW4t3tIGhU5EZjG0H1x+JpcsbWsCq1FLmUncetrbqIgsEQEP+rAQfJ9PSnbW4nOTvrvuOjhiiLmOJEMjbnKqBuPqfU0JW2E5N7sQW8CztcCGMTMNpkCjcR6Z60JJA5SceW+gwWNoIHgFrCIZDl4xGNrH1I70uVWtbQr2k+bmu7jU02wjjeNLK3VHADKIlwwHQHjmnZDdWo2m5O68yYwxNKspjQyICFcqMqD1wadtbmak0uW+gxbO1QqVtolKMWUhAMMepHuaXKuxTqTe7AWlsqRoLeIJCd0ahBhD6j0osg9pNtu++5l3Ph97u6d5rtDE8gdgLZRIQCCF3jtkDtmoULNNvbU6o4pQjaMdbW3dvWxtVocQUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAVtL/4+tT/AOvof+iY6mO7/roa1vhh6f8AtzNGrOcKACgCv/E31NABQAUAFABQAUAFABQAUAFABQAHoaAOauv+Pqb/AH2/nQBLpv8Ax/x/j/I0AfONd5whQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAe2/Bf8A5FC7/wCwg/8A6LjrmrfEdNL4T0GsTUKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/OgDzX4of8hu0/69v/AGY1wYr4kfY8P/wJ+v6I2Phf/wAgS7/6+f8A2UVrhfhZwcQfx4en6s7auo+dOT0/R7HxJc6le6vEbmRLuS3iRnIEKLgAKAeCeuapaU4tbtX/AK9CXrNp7L/L9SG/0m1uL7w9pl3P/acCvcKXkbJbC5AJB5I4H4VUXzScvL9UKStG3979HoNv7dNGn1XSrJnWym0iW48guWETjI+XPQHPT2qJNyg79Gvx6fgXFKM4W63/AAtqZs9xLp/gu60a7csklilxZSN/Eh2lk+qk/kR6VtPWp5qS+6+j/RmVHSKfRp/fbX/M6rxb/wAibqP/AF7GsJfEvVfmjSl8Hyf5GT4g1G6n0O2ik0i7t0Nxb/vZGiKj51/uuT+lbJL28Xfr/mYt/wCzyVun+RcuNb1eSLVL6xFoLXTZHjMUqMXm2DL/ADBgF9uDWSsoxlLr+V7G2rk4x6fna4zUvEl5DcRtFJb2NpLbJLDPd28kiSM38JZSAmOOuetVy2k4vdO3/BJ5rxjJbNXEW71MeLLlxeQtbrpqzCFQzIeuMHdjOf4scjjHek/dpTfVP9P6v5lRvKcF3X6r+kFjr2sGLRby8Fm1vqbLGY4o2DxkqSDuLEHp0xx79atwSm4eTf3Gam3Dn87fjYZJ4puodRhX7RZXMUl6tu0VvBK2xWOAfO+6WHGRiphHmSv1X9eqKnLlv5f18gvPEOsQw6pexCz+z6beeSYmRt0q/L/Fn5T83XB/xUVfl89PxaHJtSkl0V/wuS3PiDUdGk1BNSFtceRZrcxGBGTksV2nJPfHNFk4u290vvBN3V9mm/uH6Pr97c6pDZ3BjuEmiLGSGzmhETjnad/UHnB46dKrlWtun4kqT08zpazNAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoApax/wAgS/8A+vaT/wBBNTP4WdGF/jw9V+Z4ro//ACG7H/r5j/8AQhXlQ+JH6Hiv4E/R/ke7165+aBQAUAFABQAUAZ+tf8eCf9fVv/6OSont935nRh/jfpL/ANJZYqjIKACgAoAKTdgKOm6tb6nZtdRBo0RiGEmAVxz/AC5pKacOfob1qEqU+R7hp+rW+oWBvV3QxBiCZcLjHfrQpJxUmFWhKnPk3fkWvtEPkef50flYz5m4bcfWm2lqzLllfltqVhqcTyMkK+bskRCwdQpDDOQSef50ubX52/C5p7JpXfZ/gNttWhurueJDGI4WC+YZV+ZuOg9OevrRGXMOdCUIpvdlm5uRbpwA75HybwpwSBnk+9O+tjOMeYU3VuJBGZ4w7HaF3jJPpii62FyStewSXMEUgjknjRyCQrOASB1OKLoFCTV0h7SIqhmdQCQASeuelMSTewGRFYqXUEDcQT29aVwsxiXNvJF5yTxtH03q4I/Oi43CSdmtRzyxx53yKuBk5OMD1piSb2COWOVS0ciuASCVOeR1FS5JLmBxadmZ1vriTx28z2VxDBckLHK+wqSemcMSM/ShS1Sa3/4c6J4dxckpJtbrXp6o0fNj27vMXbu25zxnOMfXNUc9mVIdVhmnjhVJA0kksYJAxmM4Pf8AKpjJSt5q/wCNjaVGUU2+lvxJrm5mgKiKymuQepjZBt/76YUNtdCIQjLeSX3/AKJkdnqcV1Ym8dGtogSMzMoGAcZyCRj3oUlyqXcqpRlCfItX5Fg3EIjWQzIEblW3DB78Gm2luZ8sr2sAuIGg88TRmLGfMDDbj60NpK7DllzcttR0ciSoJI3V0boynINMTTTsxrXEKzLC00YlYZCFhuI+lK6vYfLK3NbQDcQrMsLTRiVhkIWG4j6UXV7ByytzW0EN1biQRmeMOx2hd4yT6Youtg5JWvYpy6wi3s1rDGsrQRl3PmqvODwMn256Yqefe3Q2VB8qk3a/ky4bmFPLEsqRtJ91WcAk+g9fwq20nYxUZO7S2HLLG5wkisSobg54PQ/SgTTW41rq3UKWuIgGwVJcc56YpXWw+ST6ALmBpWhE8ZkQZZA4yo9xRdBySsnbQgi1OC5WNrYiZXlMbEOo24zzgnnp2+tJO9rdTSVGUbqWliwLiEzmATIZQMmPcNwH0p3TM+WVua2ggubdpREJ4zI2cIHGTjrxQmmHJJK9tB0kscS7pJFQHuxx70NpbiSb2GLeWrtGq3MTNKMxgOCXHqPWi6vYpwkk21sIl2hjlkl2wpE5UszrjA75B4/Hmi6tdjcHdJa3GT6jbwrE28SLLIsYKEEAkZBPtik5JNL+trjjSlK/lqEupWUMCTtcxmJ3CK6sCCScUOSVvMI0pybSWqLBkjVA5dQhxhieOelUZ2ewxLm3kjaRJ42RMhmVwQuOuTSurXG4STs1qIby1WNpGuYgittZi4wD6E+tF0NQm3ZIkWRGbarqTgNgHse9MmzGPdW8cYkeeJUJ2hmcAE+maV0UoSbskEtzbwDM08cYxn53A4obS3FGEpbK4xr+1S8jtGmUSyIXVc9RkD+tF1exXs58nPbQbeXwtXiiSCSeabOyOPAJA6kkkADkfnSctbJDp0+ZNt2SIhq9ssaNch7Vml8rZNgEN+eCPcHFHMtPMr2E7tR10voW/tEHmiLzo/MPATcMnjPT6U7mXLK17aBFcQz7vJmjk2nDbGBwfehNNXQSjKO6ES6tpUd47iJ1T77K4IX6+lF1a43CSdmhpvrNVZmuoQqtsYmQYDen1ougVOb0sySaaOCFppXCooySTgUpSUVdijFyaSKllqkNzZLdStHAj8rulU8Yzz6Hnp2p3SV2aVKMozcFr8i0bmASrEZo/McZVNwyR6gU+tjPllbmtoIbm3WURNPGJCcBC4yT1xildBySte2gsM8NwpaCVJVBwSjBgD6cUJ3V0Eoyi7SViSmSFABQAUAFABQAUAFAFbS/+PrU/wDr6H/omOpju/66Gtb4Yen/ALczRqznCgAoAr/xN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/wB9v50AS6b/AMf8f4/yNAHzjXecIUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHtvwX/AORQu/8AsIP/AOi465q3xHTS+E9BrE1CgAoAKACgAoAKACgAoAKABmCqWY4AGSaAMT/hJ7f7Rs8h/Kzjfnn8qrlJ5jUtr61vCwt5lcr1A4pNNDvcW6uorOHzpt+3OPkQsfyAoSuNuxWstbsdQmEVs8jNzyYXA468kYocWhJpl+kMKACgAoAKAKs2pW9v5pmEkaxMql2jOGLdMHvTsK5NcTi2gaZkkcL/AAxqWY/QCkMkByAfWgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgBF6fif50ALQAUAFAAelAEkP+qH4/zoA81+KH/IbtP+vb/wBmNcGK+JH2PD/8Cfr+iNj4X/8AIEu/+vn/ANlFa4X4WcHEH8eHp+rO2rqPnTHu/DkM95NdW1/e2D3H+uFrKFWQ9MkEHBx3GDTTsrdBNXd+o2bwvZtDYx2s9zZfYN3ktbsufmGGyWBzn+tPmfM38hcqtbzuPg8N2cNreRPNczy3sZimuZpN0pUgjAOMADPQDFJu65eg4q0ubqJqfhnT9W0aDS7kyiO3CiORGAkXAx1xjkdeKrnftPadRRilDk6F3UdPh1PTJtPmZ1imTYxQgMB7ZFQ9XcqPuqy7WG3+lwajYpZzPIsaOjgoQDlCCOo9qrmfOp9U7k8q5HDo1YpXfhi2uprki7u4ILxg1zbxOAkp7k5BIyBg4IzSi7JLew2ru+zJL7QEvWfZf3trFJEIZIYXXYy9MYYHbwcZGKL3vfW4Wta2lgPh60F1FPBLPB5dt9lKRsCrxjoDkE8eoxRJ8ykn9oIrl5bdBy6BaLZ6baiSbZprq8J3DLFQQN3HPXtim5Nz5/Jr7yVBKPL8/wAblVfCVqohj+33pt7e4FxDb712Iwbdj7uSM+pNCk1Z9Vp+FhyjzXXcsTeHLOay1C0aScJqE3nSkMMq3y/d46fKOuaSduXy/wA7jau2+6t+FiW60Ozvbmee4DyfaLb7M6E/KUyT9c5PXNLo13af3DWjXlf8f+GEsNHNjOsr6nfXeyPy0SeQbVH0UDJ9zk1Tle+m5Kja3kaVSUFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFLWP8AkCX/AP17Sf8AoJqZ/Czowv8AHh6r8zxXR/8AkN2P/XzH/wChCvKh8SP0PFfwJ+j/ACPd69c/NAoAKACgAoAKAM/Wv+PBP+vq3/8ARyVE9vu/M6MP8b9Jf+kssVRkFABQAUAB6UpbMDlbawvIrO2t0glVL+ERXGVI8raeSfTKEj6gVlGL0i9nZ/ctV89F956k6sHKU76xbt53/wAnqWFtXiRHltZHt4tQld4xGWO05CsF7gEjp9e1EdFFy8/z/r7zNyTuovVxXX0urjTbsZTdCzl+wfbRIYPKO4jy8b9mM43YOMZ4zQlaza01+X9a+lx82nJze9y2vfzva/pp+Agt2kuZZbeymiie/gdQYiuQBy2McDNEVqtOr/8ASf6/IHJKNpSTfK1v+Bdj00T2+qQGLyjNMfLbbj+FcEfQj9KfK+TTe7/N2MnV5Zwle9kr/jcpBbjUtMl1BoWM00sCKgGSqo65/wDHt5+lC1cZLq0/l0/DX5mr5aVT2d9Epfe0/wBLEkunlrPVX+yEztd7428v5iBtwR39f1pKNorTr/7d/l+AlV9+Cvpy/wCZHqcSxQawtxYyTSTAvFKI8rtCDHzfw7SD1/DrUTVoNW1/r9C6LvOm4yslpbzv263Nme1F7pBt84LxDa391sZB/A4NdNZNt23OGnPkqKRjKk+p6fJqMkDOZJIg0IGS0SEbgB3y24478Vlo0pdG7/Lp/mdjcaU/ZJ7J6+b/AOBb0HXVu12moS2VrIkLQxjaYjGZXViThSAemBnv+FK2jfS6f3b/ANeQQkoOEZvXXreya7+omp+bqH2x4bS5KNZqi74WUsd+SACM0NXb0/l/NhRtT5FJrd9V2OhjijhiEcUaooHCqMAVpP4Wefdt3Zi6NpMx0yx+23M5WJVcWzIqhWHTPGTj60KOzb6foduIrx9pPkS1vr/TtqRATJbCx+y3BlXURIWETbNhm3bt3TGD9fyqIbQXb/glOzk6l1Zx79eW1rD7K2nTULZmgkVVurtiSpwAWOD+PaimmlH0f5oVWcXCVn0j+Rb1q4cJFaLHceXOSJpYYXfYg6j5QcE9Pzpzd3yvb+tP66GWHitZ3V1sm0tfn2IbkwytYzraTNZ27MrRG3cFTtwrbCMkDkcDvQ37yk+z/T/glQTSnG65nbqvnr/wSslk0txbt9kcWrag0qRvGRsXyyMlSPlBbJ59aUY6xuu//ANZVLRl72vKl6u/46CXVlMhlMcLLbx6h5hUQlxtMY+YJ/EAxzx357UrNW+f56f15hGpF7vVxtvbrtf0NHRIfLW5kHmbZZdwDweUCcAEheoB98c1pBWic+Ildpdl3v8AiVY44Yp7iG70+We4kujIjrCSGXI2nf0G0Y6kdKmFkkra3/Xf+vQ1k5NKUZWVrb+Wqtvr6EFzbnyb22azle+muC8MwhJHJGxt+MDaMd+1TFaJW1v+t7/d/kXGS5oz5vdS1V/LVW8x8unlrLVHNoTO11ujby/mIG3BHf1/Wmo2S06/+3f5fgSqvvwXNpy/5kt/aOx1pktyWktAsZVOWba+QPU8ipnF8krLr/kKlNJ0rvZ/qhksIinuTdWMlx59uixER7gMLgqT/Dzzk4HNVV+3pv8A5foOErxhyytZ6/5+YzTHe0+yXDQTSJNpsKIYoy/zLk4OOn3hyeKJ3XOu9v1HVSnzRutJS69/+GHaTYsLmxe4tT+605FzJH9x88jnoapL3m/JfqKvUXLNRe8n9xXgSeS/sWNs0TpcsZY47MosYKtnLn72fUHB/Kopr3o+j6W6bfeaTcVCavfRW1u3qunQngt3UWcS20itDqMjSfuiAFPmYOcYIwRz704J3h5J/kROSfO77xVtf8IyG3IgtrUWkq38d0Hkm8kgffyz78YIK5GM55xSgvhstt/u1+9jnLWUub3WtFfy0VvJj4tPK6er/ZCJ/wC0vMz5fzbfO6+uNvf0pwjaMNP6sxTq3nJX05bf+S/5/iX9XtzcTacphMqLdhnG3IA2NyfxxVWvUj8/yMKM+WM9bafqjPOn7be7ZLPEg1FHjIj5270yR7fe/WpjG3L6v83+hu6t5K8tOR/fZ/8AAFNtKr+bLaySwR6jJI8YQkkEYVgv8QB9P6Uoq1m13/N/18w501yxdm4r/gogW3S6uJljsmWI6jE7RGPouwZJHYd+fXmiK20+0/8A0ktzcUry15X+ZYu7IpJelLRjELq3lCpGTkAruIAHPA5xTSt06/ov1M4VLqKvryyW/rYteItr6C2IyymSH5MYJHmLxg9KdTeN+6M8JdVt+j/JlG8h+0pqEljZyxxtYmMr5DRmR+cAKQCcDPPvUSV1Jrrb/gm9KXI4Kctea+97L1JtQszBc2ckcQS2jiZcJamXYxxztHPIGM/41c1777ehnSnzQkm/euutvxIRbXVjZW91ZQzPIRJFsaLaVVySp2jOAGx9ATU8rSSXVW9Oz+SuXzwqTlGbVtH92j+9fex11YNZXVuuGNtHaiJWFqZ8Nn5sgcjPHPtTkveemmltPwFCpzwfe997f1YfpumgXtuJ7d5I0stqmeIfLlz8vcA47Z6U1HV37JfmKrV9x8r15unoGnW7W82mNNbSALbPFnyidjbl2g8ccA8minfS+9l+WoVpKUZqL+1ffyf3l3VlgZoPtFvcMgLYnt92+I4/2fmwfy45ola+pjQcrPla9Haz+/QoEXEtpFLcRXE8MN6DG0sJMpixjJUDPU+mcUtfdcu7/J2NvdUnGLSbj30vfv6D5LCWWPW2hg2zzNiJ2XBYeWowCfxFLlfI/V/dcI1YqVK70S/VkEUT5mmt7eSRo7Rk8prIwo2cYU5xuPHb355oe0n+n6FXXuxk7a3vzXfr5fMryW88ovfJhmdH090G2zaFS2eFCkZJpSTal8vzZrGUYuHM18Xe/wCJp/2bF/ap/wBCTyvsO3/VfLuz06dcVVSOs7Lp/n/wPwOWNWXsl72vN3LVnE58PQRSxtv+yqGRl5zt6EeuaqtrGVjOUl9YbT05n+ZSisdx0RZLXKxRMZA0fCtsHX0OacknUv5P80aupZVbPd/qyC4tz5F7amzka+muC8MohJHUbG34wNox37Vmlol1v+t7/d/kaRkuaM+b3UtVfy1VvMW809pYNXY2heSS4jMZ8vJYAJ09R1/Wjl93b7X4X/yFTq2lTXNoov8AU07S3EGs3jJD5cTwxYKrhSQXz+OMfpWkdL+v6I56kualC711/Q0Ko5woAKACgAoAKACgAoAraX/x9an/ANfQ/wDRMdTHd/10Na3ww9P/AG5mjVnOFABQBX/ib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/H1N/vt/OgCXTf8Aj/j/AB/kaAPnGu84QoAUKWICgknsKAH/AGef/njJ/wB8mgBhBUkMCCOxoASgC1NpmoW0AuJ7G5ihOMSPEyqc9OSMUXV7Ds2rlYgjGQRnkZoEJQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQB7b8F/+RQu/+wg//ouOuat8R00vhPQaxNQoAKACgAoAKACgAoAKACgDI8RXc1vaJHFwJiVZvbHT8aqKJkzDaxgHyrc5crkAmMD8Tv4q7k2JIJjpN2kkDibeNrA7Txkf3WNLcNjr6zNDlYyV8IamVJBE8uCP96tPtIz+yx2pw2lotpZ+WAkwaVpLi4cRlsDrjlm9BxQrvUbsitpynUV0eC6kkdGFwrAOw3AdATnND0uJa2GkBtKSGS7VIob2SNUuGfy3UdFZh0x2zT6h0JfPjnsdOF0ssGmmWRJcysVbH3fm4O3PSl1YdiUw2l3LpdvBNcyWck0wG9yMqF6A9StGquPTQh1RRHFq8SlxHHNbKoUklRgdKF0E+pFdPAkepDSpZGs/s6mQ72IEu8dz3x1prpcH1sWL62S4fW55Gk32yo8W2RgEbZnOAetJPYGtyO5likuZJNUknDmzjazKFwCxX5iNvfPrR6B6nQaAS2gWRYkkwjJNTLcuOxoVIwoAKACgAoAKACgAoAKACgAoAKACgAoAKACgBF6fif50ALQAUAFAAelAEkP+qH4/zoA81+KH/IbtP+vb/wBmNcGK+JH2PD/8Cfr+iNj4X/8AIEu/+vn/ANlFa4X4WcHEH8eHp+rO2rqPnQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoApax/wAgS/8A+vaT/wBBNTP4WdGF/jw9V+Z4ro//ACG7H/r5j/8AQhXlQ+JH6Hiv4E/R/ke7165+aBQAUAFABQAUAZ+tf8eCf9fVv/6OSont935nRh/jfpL/ANJZYqjIKACgAoAKACgAoAKACgBksSzxNE+7awwdrFT+Y5pNJqzKjJxd0EUUcEKRRIEjQbVUdAKYm3J3Y+gRTn0myuZWlliYl8bwJGVXx03KDhvxFTyq9zaNepFWT/L8HuizLEk0TRPu2sMHaxU/mORTaTVmZxk4u6CKKOCFIokCRoNqqOgFMTbk7sfQIKACgAoAKACgAoAKACgAoAKACgAoAKACgCpc6ZaXchkmjbcy7WKSMm4eh2kZH1qXBM2hWnBWT/Bfh2LSKqIERQqqMADoBVGW4tAgoAKACgAoAKACgCG5tIbyMJOhYK25SGKlT6gjkH6UnFMuE5Qd4ha2kFnGUgQqGbcxLFix9STyT9aErKyCc5Td5E1Mgjnt4rmLypk3puDYzjkEEfqBStqn2KjJxd0SUyQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCtpf8Ax9an/wBfQ/8ARMdTHd/10Na3ww9P/bmaNWc4UAFAFf8Aib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/H1N/vt/OgCXTf+P+P8f5GgD5xrvOEKANTw5azXmsxQQJvkZWwM47UpOyKirs7J/D2pRjLwoo9TKo/rWXMi+VnGeIIJLbV5I5VAYKp4IIIIyDkdeK1jsRLcqae8keo20kUJnkSVWWIDJcg5xj3q4uzuRJXVjqrm4bVf7Um07U7yKYwu9zYXibhtB+YKeQMdBwDWKXLFX1V0b3cpdmWLu3s9W1HRoJ7REiXTROyxswZlAJEYyenH196cnyyqS3t/wCV70YR7spadYaZrMFpef2fHakaglvJGkjFZUYZ7knI9qpXUlfqn+CJdmnbpb8XYZHbWNzqd+ItItIrax3R77i5dI1O7AZ+7E44AxURb5FJvexUkuflS2uWptC0uK8a8Fuk0KaZ9r+zxSP5bvnHBPzbe9NyaUvVL7xqKfL8/wGWej6ZrEOjSiyFp9ruJVmCOxDBFzhckkA4/U023GXla/wCP9fIle9F+qRT1mz0j+yZJoGsYrqOYBEtJpHDoezb+49RSvK6/Eppe8vuOaqzIKACgAoAKACgAoAKACgAoAKAPbfgv/wAihd/9hB//AEXHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAFABQBHPbw3MZjmjDqexoAp/2Dpn/Pt/4+3+NVzMXKiSHSLC3lEkdsAy9CWJx+ZpXYWRcpDCgAoAKAAjPWgAxxigAoAKACgAoAo3uli9kLG8u4Qy7GSKTCsPoQcfhimnYTVy1bwR2tvHBCu2ONQqj0ApDJKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/OgDzX4of8hu0/69v/ZjXBiviR9jw/8AwJ+v6I2Phf8A8gS7/wCvn/2UVrhfhZwcQfx4en6s7auo+dI3lCnAGTQA3zm/uD/vr/61AB5zf3B/31/9agA85v7g/wC+v/rUAHnN/cH/AH1/9agA85v7g/76/wDrUAHnN/cH/fX/ANagA85v7g/76/8ArUAHnN/cH/fX/wBagA85v7g/76/+tQAec39wf99f/WoAPOb+4P8Avr/61AB5zf3B/wB9f/WoAPOb+4P++v8A61AB5zf3B/31/wDWoAPOb+4P++v/AK1AB5zf3B/31/8AWoAPOb+4P++v/rUAHnN/cH/fX/1qADzm/uD/AL6/+tQAec39wf8AfX/1qADzm/uD/vr/AOtQAec39wf99f8A1qADzm/uD/vr/wCtQAec39wf99f/AFqADzm/uD/vr/61AB5zf3B/31/9agA85v7g/wC+v/rUAHnN/cH/AH1/9agA85v7g/76/wDrUAHnN/cH/fX/ANagA85v7g/76/8ArUAHnN/cH/fX/wBagA85v7g/76/+tQAec39wf99f/WoAPOb+4P8Avr/61AB5zf3B/wB9f/WoAPOb+4P++v8A61AB5zf3B/31/wDWoAPOb+4P++v/AK1AB5zf3B/31/8AWoAPOb+4P++v/rUAHnN/cH/fX/1qADzm/uD/AL6/+tQAec39wf8AfX/1qADzm/uD/vr/AOtQAec39wf99f8A1qADzm/uD/vr/wCtQAec39wf99f/AFqADzm/uD/vr/61AB5zf3B/31/9agA85v7g/wC+v/rUAHnN/cH/AH1/9agA85v7g/76/wDrUAHnN/cH/fX/ANagA85v7g/76/8ArUAHnN/cH/fX/wBagA85v7g/76/+tQAec39wf99f/WoAPOb+4P8Avr/61AB5zf3B/wB9f/WoAPOb+4P++v8A61AB5zf3B/31/wDWoAPOb+4P++v/AK1AHmOpfEPWnv5RZvFBArEIvlhjgdyT3rz5Yid9D7XD5JhlTXtE2/Uqf8LA8R/8/cf/AH5T/Cp+sVO5v/YuC/l/Fh/wsDxH/wA/cf8A35T/AAo+sVO4f2Lgv5fxYf8ACwPEf/P3H/35T/Cj6xU7h/YuC/l/FmjofxA1d9Xt4L5454JpFjYCMKVycZGKuGInzJM5cXkuHVGUqWjSvuenV3nxpS1j/kCX/wD17Sf+gmpn8LOjC/x4eq/M8V0f/kN2P/XzH/6EK8qHxI/Q8V/An6P8j3evXPzQKACgAoAKACgDP1r/AI8E/wCvq3/9HJUT2+78zow/xv0l/wCkssVRkFABQAUANdtiM20tgZwvU0mNK7sZOm6rJJD5935iie48qJPLAC8kDnPPTmphK8Vfd/5XOqtRSk4w6K7/AALdxq1tatIsgkJjkSMhUySWGRgDrRzr8bfhcyjQnLbtf7hq6xbeRNLIssJgYK8bp8+T90ADOc54xT5la/y+Y/YS5klrfr0IrnWxDaPKtpceYkiK0TpggMcZ9CPp3pc+2nWxUcPeVnJWs3f0HjU44nunndgkQj/d+V8ylhwOCdxJNHNa/rb8EL2Laiore/Xt+QNrdtHBLJNHPE0JQPG8fzgMcKQB1GfSjnX6AsPNtJWd7+mm42bV0NrclfNtpYNpYSxZIDHAOM8g896Oa/3pDjQfMr6p32fYdNrdtBLMjRzlbdws0ix5WPIByT6c9qFNP8hRw85Jba7eY651i3tZJVaOaRYFzM8aZWPjPJ+n/wBehzSu+woUJTSs1rt5ll7uGKzN3I+yEJvJI6Cqk+XczjCUpcq3K6atbmOV5o5rYRJvYTRkZX1HXP06+1LmVrs0dCV0otO/YaNZt/LmaWKeBoYjMUlTDFB3HrSc0k2+g/YSbSTTu7fMRtahVImNtdZnYrEvlfM+BnIHp9cU3KztbUFQk76rTfUV9Zto5CrRzbEIWSXZ8kbHHBP4jOMgd6OZXt8hKhJq+np1HTatBDO8XlzSCIgSyRxlljJ55P0I6ZxRzK9gjQk4p3Wu3mVLnW5o1vxHbMptXVVdx8rZ2+/vxU87av5pfl/maQw8W4Xe6f6/5F59Tt44bmV94Fq+x1xznjGPXORj61XMrX87foZKjJySXXUkuruKzg86bdgkKFUZZiegAHU027EQg5uyKza1bJbySypNG0TqjxNH86ljgcDrn2zU86/Q1WHm5WVtbu/TQtLdJ9kNzKrwIqlmEowVA9aptJXZlyNy5Y6lT+27cJI0kNxFsjMoV48F0HUj6Z6dfap50t+hr9Xk2rNO7tv1Jp9StbdwsjnHlGYsBkBRgZ/HPHrTckm0+hEaU5K672Iv7Zt1ineWKeEwRmVkkTDFPUetJzSTb6F/V5NpRad9PmSWupw3VwYBHNE+zevmpt3r6j8x15qk73RE6TjHmvdfqF1qUVrMIRFNNLt3lIU3FV9T/nNS5pMcKTkua6S8xs+rQwojrDcTI0fmFo4iQq+pz/Lr7U5SUdxxoylpdJ7b9f6+RNFfQTXBhjYs3lLNnHBViQP5Gm2lfyIdOSjzPu19xXOtW5jheKKeYzRCYLHHkqnqf8OtJySdjT6vK7TaVnb5jp9Wggfb5c8u1A8hjjJ8tT0Lf4dfahySbv0FChKSvdeWu/8AX3Fl7mGO1N00gEITeX7bcZzTk+XczjCUpcqWpQTWPNv4YBBLEjxPIwljIYgYwR+Z461Klq0+iv8AibOhaDle+qWj9R66xGyyAW1wkixGVEkj2mRR3H5jrg0pTtFu2wvYO61Vr2CLV99lbzmzuWknTcI44844GTnpjn15qnK3QHQtJx5loWPtiS6a15bncpiLpkY6DuKU5Wg5LtchU2qnJLvYrR6wotrcvDLNPJAszpAm7aCOv0znjrTlJJtdi/YO71srtaj5NYtlERhSW58yPzQIU3YT1P8Ah19qHJJ2EqEne+lnbXuLPqsMMojEU8rbBI/lxk7FOcEjr2PA546UOWthRoykr3S+e5eByM1RiZr3F7d3s8FlJDDHbEK7yRlyzkA4ABGAARz71CcpXaOlRpwgnNNt/LT7mNi1kJAgu4mFx57W5SFSwLgE8exHP40KadvO/wCG4Sw7u+V6Wvr2YNq/mG18hCpkuvImSVcMnyM2PrwPXrQpXkkut/wD2Fubm6K6+9IsJqdu8FvKu/8A0iTy0XHO7nII9sHP0pqSdrdf+HM3RknJPoTSXUcVzDbtnfPu2YHHAyad9bf1/WpKg3Fy7EEmq28aFgksjec0KxouWZxkkD8AetTzLS3n+Ghaoyb7aX+8R9VhWKJhDcNJLnbCIzv465B6AevSm5IFRbb1Vl16E8F5Fc2v2iEMy8/LtwwI4Iwe+RinfS6IlBxlyyMxddle2sZ/sroLiYoybdxI2sRtx7gdfeoU78um6udLwyTnG+3+fUsjVI5/s5jZ4S1z5LxyRfMG2k7TzxwM55qlK7Vut/wM3Rcea+ul9/PcktdUiu5QkcU+xs7JTH8j464P+OKIy5tiZ0XBateg2+vmtblVUs/7l5PKWPJbBXnOeMZ6VMpuN/JDp01OOvdK/wB4aPPcXOmR3FyWaSQBsFAvUA4GD0+tXshV4xjUcY7Iemp2zwW0qlsXLbUGOQcEnPpjBzS5lp56g6Mk5LsMt9YtriWNFSZVmz5MrphJe/B+nPOM0KV9BzoSim3bTfyJI9St5Le3nXdsuH8tMjnPPX8jQpJ28/8AK5LpSUnF9C3VGQUAFABQAUAFABQAUAFAFbS/+PrU/wDr6H/omOpju/66Gtb4Yen/ALczRqznCgAoAr/xN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/wB9v50AS6b/AMf8f4/yNAHzjXecIUAW9M1O50i/S9tGCypkDcMggjByKTV1Yadjcl8f6zOAssdnIB0DwZ7Y9fSp5EVzswtR1GfVLxrq42byAoCLtVQBgACqSsS3crxyPFIskbFHQgqwOCCO9UnYT1NS68T6veW8kE1yu2YYlKRIrSD3IAJqOVFczIV17UlS1VbnBsz+4cIu5B6bsZI5PB4qutxdLD5/EWqTywSNcKptpPMiWOJFUP8A3sAYJ+tJJJ3XoDbasyO11q/s57iaKVSbnmZXjVlfnPKkY60WSjyhd83N1Ltn4juX1aK81G9uVMURiSS2RAVHYFcYZcnpRypJ26j5nonsibWfEhuYbKO0ubiSa1kaU3MiLGdxxgKqkgAAUkrS5vKw204uPd3M6/13UdSg8i5mXyy+9ljiVAzf3jtAyfrT5VcXMzOpkhQAUAFABQAUAFABQAUAFABQB7b8F/8AkULv/sIP/wCi465q3xHTS+E9BrE1CgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgBF6fif50ALQAUAFAAelAEkP+qH4/wA6APNfih/yG7T/AK9v/ZjXBiviR9jw/wDwJ+v6I2Phf/yBLv8A6+f/AGUVrhfhZwcQfx4en6s7auo+dKq/dB9aYhaBhQAUAFACZA7igQ3zI/76/nQAu5f7w/OgB1AyPz4f+eyf99CgQvmx/wDPRf8AvoUWC4nnRf8APVP++hQMkoAKACgBNy+o/OgRH9qt/wDnvF/32KLBdB9og/57R/8AfQoC5LQMKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA8In/wCPiT/fP868Z7n6hD4Ueow+BfD7QozWrklQT++b0+teisPTtsfESznGKTSl+CH/APCB+Hv+fR/+/wA3+NH1en2J/trG/wA34Ir6j4I0KDTLqaK2dXjhdlPmscEKSO9KVCmot2NqGcYudWMZS0bXRdzzzR/+Q3Y/9fMf/oQrgh8SPrsV/An6P8j3evXPzQpax/yBL/8A69pP/QTUz+FnRhf48PVfmeK6P/yG7H/r5j/9CFeVD4kfoeK/gT9H+R7vXrn5oFABQAUAFABQBn61/wAeCf8AX1b/APo5Kie33fmdGH+N+kv/AElliqMgoAKACgAoAyTplwumwxI0RnguDOu4na3zk4JxkcH0rPlaUfL/ACsdftoupJvZq34IY2l3s07zzGBWe5im2oxIVUGCM45NCi07vvf8LD9tTUeVX2a+8lutLmmmuZo3QMzxSRbs43J2b2NHK07+d/wsTCtFRUX2afzHXFvqN7ZTRzC2icsjRIrsw+Vg3LYHXHpx702m7PqmmKMqUJpq9tb/ADVtv+CRS6XdTSXM5aJJZHhljXcWUMg5BOBwemfxpcrTuu9/wSKVaCSj0s194240u9vmlnn8iKVvKVURyyhUkDkk4GSfpQovmUn3T+7/AIcca0IJRjdrX72rdyTUdLnu5Lpo3jAmhijXcTwVcsc8eho5Xr6p/cTSrRgop9L/AIpIJtLnkttWiDx5vSTHknA+QLzx6ihRfLbzv+NxxrRU6cv5f82yhqcxsm1K2jubdftS79ku4Sbim3CDHz5wOnQ1nP4ZQXn669P+CbUI8/s5NP3dPLR9e36mtNZNdaMLQt5chjXBIzhhgjP4iuioru673/E5IVFCpzdCKe21DULWaC6+zwBlHl+WzP8AODnJJA44HGPxqGpNfd+BcZ06ck43ffp/mRXOnX2oLO9wLeKQ2kkESpIWBL9WJKjA4HGD3qZQck/OxcKtOm4qN2rpv5fMtSWUr3Wnyhk22u7fycnK44rWWtTm9fzRjGaUJR72/MoTaHKbicLDbzRXEpkLyzOCueo2Dhu+ORWUYW08/wBbnQsQrJ3aaVtEvz6fcy0LXULW4uPsYt2juJPM3yswMZwAflA+bpnqKpJrTpcy56UornvdK2nX59PuZHeaZdTm/jjMOy6KOrMxBUrtGMY6YXrn8KXK9vNP8v8AIqFaEeRvdXX5/wCZHcQLc+I0SFw0YVZLpB2ZPuZ9zuz9FFEVebfRfnt+RSly4fXfZej3/L8TQ1G1kuoojCyiWCVZUD52kjscexNVJO6a6f8ADGFKai2pbNWKM2l3l28lxN5Mc0kkOEVyyqkb7uuBknJ7elSou6fnf8LGyrQiuWN7Wl97VjRvrUX1hPaliomjKbh2yKqceZWOelU9nNT7FCx0uWO5ElxbWyBYymVleQsTjP3sBR7c0lG97rc2qVVy2i39yX5EUWgSnT7q2mmUu4WOFxk7Y0OUB/HrU8j5dd9H91v6+Zo8TH2kZRWmt/V7/wDAEOjXEttdqYLaCSW3aFCJpJDk9ckgYHA4waHBtP5AsRGMou7aTvsl/X3ml9kk/tKC5yuyO3eMjPOSVP5fKa0+033/AOCc3OvZcnW6f4P/ADIp7a8h1CS7slhk86JUdJXKbSpOCCAc/ePFTaSbt1LjOnKCjO6tfbz+a7FW/wBMv7t23mC4DwBMPK6JG/OWCDIbOR19KmcHK67mtKtTglurPsnf56WHxadfWkkMkH2d2+yJbyb2YbSucMMDnqeOPrTlFtyt1/4JLq05pqV9218/y/EhfR7oWNpAsNtJJBAI/M854nRvUMoyR7cUSi3t23/rctV4c8pNuzd7WTT+T6/eJLot0JWkAiu3liRXaWZ48Oq43YUHIPpx9aHDV26hHEQsk7qzeyT0vfqaVxp4m0dtPVhGDF5alRwuBxxnp+NVNXWhz06vLV9o9dSnJZapdzrNK1vbtHbyRKYnZiGYDDcgenSpcZNt7XVvxNY1KMI8qu9U9eyvpuR2mj3KXy3EscMQFu8TFZnlZiccksB6Hik4X5ul1YqdePJypt6p7Jd+wHTNQMFpHIkEqQQ+U0P2l0QkYw/C88A8EfjTknJ3f/Df5h7WmnJq6u73sr+m+nqW7HT5bbQhYO0ZkEbJlc7cnP8AjRKLdPl8rfgZVKsZV/aLa5DDYX1gY5LYW8rm2jhkWSRlAKZwwIByOTxgU3zXdupcqlOppO61bVvP5kUuizpa28MUdvM0UZUSmV4XRickgqDxz04qXB7R7WuXHERcnKTau9rJr8fzHXulXsyx7RBJOsAjF15rxSK3c/KDuGeccfrTlFuTa0/r8RU61OO97Xvaya/Hb1NSEXKysspjaIIoVhncW/iyOnpWnVnK+WytuVHtr21vZp7FYJUuMM8czlNrgAZBAORgDj2qLSV0jZTpzilO6a7a6feiKLSZ0a1keVHlS5a4nbkAllIwo9sgc9hQo2a8r/iOVeLUklo0kvk0K2lzm8E2+Pb9uFxjJzt8rZjp1zRGLUk+1/xD20eW3923/k1yHToFl1u6micPawuxjx0Ejgb/AMsf+PGlTW76dPTd/j+RdaVqUYvd7+i2/ryRdv7W4kubW6tRE0luzfJKxUMGGDyAcHp2ptPmTX9bf5GNOcVGUJbPt5FQ6XdGyeOWK0uHe5aYozMoAPTawGVI9cVPK7Jev4ts19tDnum1ol0f3rqRHRbvZbyyMlxLF5imJ53ACMQQA+MnGB1HNHI9HvoV9YhrFaJ26Lou22pqabamztBGyRIxYswiLFck+p5P1rRKySOarPnldFK30y6jjsI5DDiznZsqxO9SrAHGOD83T9aiEWuW/RW/BG060HztX97/ADTHNpc5vBMHj2/bhcYyc7fK2Y6dc04xakn2v+IvbR5bf3bf+TXGWmm3cGopNsgt4wWMgglfbNnp+7IwvrnJpQi1/X9WHUqwlC2rfmlp892Wrqyln1CO4VkCLbyREEnOWK4/DiiUG+bzVjOFRRhyvun91yeyga2sLeByC0USoSOmQMVq3dmc5c03JdWzJ0+0S51O8dJA9mhYQlegZwDJg+xH6msIx5ovtsvTf+vQ66tRxhFW97S/y2/r0JoNPvsWVvceQILJgwkRiWlwpVcgjC9cnk1oruSlLoRKpT95xveX4a3+f4DIdMv40tbYm38i1uPMDhm3OvzYGMYB59TUxi1y36f5NDnWpvmlreS/yNqtDjCgAoAKACgAoAKACgAoAraX/wAfWp/9fQ/9Ex1Md3/XQ1rfDD0/9uZo1ZzhQAUAV/4m+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/x9Tf77fzoAl03/j/AI/x/kaAPnGu84QoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPbfgv/yKF3/2EH/9Fx1zVviOml8J6DWJqFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACL0/E/zoAWgAoAKAA9KAJIf9UPx/nQB5r8UP8AkN2n/Xt/7Ma4MV8SPseH/wCBP1/RGx8L/wDkCXf/AF8/+yitcL8LODiD+PD0/VnbV1HzpVX7o+lMQtAyH7XbeQ0/nx+UhIZ9wwCDg5NAiGTVtOhkMUl/bo44KtKARQk3sF0XKAK0s8KyFWlQEdiwoQFTzE/vr+dMkl+123/PxF/32KLMd0WvtNv/AM94/wDvsUrMd0Y2D6UATeYn99fzqyCHz4f+eqf99Cpsy7o2ftMH/PeP/vsUgG/bbT/n6h/7+CiwXJsj1oAqfaIf+e0f/fQoAxdj/wBxvyq7mdh3mJ/fX86AOiDoxwrAn2NZmpnw63atNcRXEsVs0U5iUPKAXwByM49apK6ViW7NpmlSGV5tQsreYQzXcMcjdEeQAn8KEm9gbS3C4vrS0YJPcxRuw+VXcKW+maT2dh+pWtNatZtPhuriWK1Myb9jyDgZx1OKqUbOxKd1cvRTRTxLLDIskbdGQ5B/Gk1bcad9iA6nYLL5TXtuJC23YZBnPTGPWhJvYG0tx09/Z2six3F3DC7chXkCk/nQlfYG7bkT6taJqi6c0gEzJuHzDHsOvU9aaTd7CbSt5l2kUFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQB4RP8A8fEn++f514z3P1CHwo9nvNWstH02G4vpTGjbY1whYsxHAAH0NezFN7H5hUaUnc898Q+OtctdfnjsroRWyFdkZhXkFQecjOea3jBW1OeU3fQ7Oz1Ztc8Ey6g8QieW2lDqDxkBgce3Fc9VWTR24N3rU35r8zzDR/8AkN2P/XzH/wChCvIh8SP0XFfwJ+j/ACPd69c/NClrH/IEv/8Ar2k/9BNTP4WdGF/jw9V+Z4ro/wDyG7H/AK+Y/wD0IV5UPiR+h4r+BP0f5Hu9eufmgUAFABQAUAFAGfrX/Hgn/X1b/wDo5Kie33fmdGH+N+kv/SWWKoyCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCtpf/AB9an/19D/0THUx3f9dDWt8MPT/25mjVnOFABQBX/ib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/H1N/vt/OgCXTf+P8Aj/H+RoA8a+IVpa2WvQR2ltFbobVWKxIFBO5ucD6CscpqTnQbm23fr6I0zKEYVUoq2n6s5avVPNCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFABQAySaKLHmSImeBuYDNAD6ACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgBF6fif50ALQAUAFAAelAEkP8Aqh+P86APNfih/wAhu0/69v8A2Y1wYr4kfY8P/wACfr+iNj4X/wDIEu/+vn/2UVrhfhZwcQfx4en6s7auo+dKq/dH0piFoGc7cWFwdWewWFzZXM63LuF+UYHzKT7sF/Oqg9r/AGb/APA+7Uia7df6/Idf3BudWEVzZXZs7YhgEtmYTP2JIH3R+ppQXXr/AFqOf8vT+tDXa1le4EwvbhFyD5QCbfpyuf1pLQe5gtaXMMsqyKzMZXbIGcgsSP0Ipw0ikKesiz9nn/54yf8AfJoGZ32K7/59Zv8Av2au6MrMu/Zp/wDnhJ/3yaLodmWMH0NQWVMH0qiSn9luP+feX/vg1V0TZmj9mn/54Sf98GszUofZLn/n3l/74NVdEWOswfSpKMD7Lcf88JP++DQBZ2N/dP5UhmX9muP+eEn/AHwa0uZWNxZWtHVmt55A7BP3aZ25PU+1ZRV2bSdlcyGUwrrUMmm3Ej3UrCJlhLB+BjnsAecmqteKS/rUm9ptvayNi3sLhbe2D39xG0cSK6JsKkgc9VJ/WnJrmbFFPlSM/wD4859SiutOmu2uZd8e2IssikABS3QY96S1il2/z3G9JN+Q51Nrq1489jLMl1CixeXHvAwMFCR059eKT1g11uC0kn5fcV9HspkuNKM9q6iK0kB3ofkbd056HFaSavL0RCWkfVlzSWewt3je0nxJfSKgSPhVJ4Y+i+9QtYxXkVs5PzKU1hKdC1lRaOZpLt2QeWdzDcMEetEXZQ8rfmO2sr/1oJeW1xHqN+0xu/LuUXZ5FsJd424KkkHBz9KFrG3mSrqz8kW4bd7PV9PZop2iFn5G8puKtkY3Yzjjv0qr3cv67ha0Ym7UGgUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHhE//AB8Sf75/nXjPc/UIfCj1HxRIkVroMkjqiJqcDMzHAUBWySa9unt8j8urfF8zj/Eegf2t4ollsdV06X7bIPKRZ9zE7RnIUHHQ1rGVlqjGUbvQ7TTdKn0XwLLYXLI0sdvMWKEkc7j/AFrnqu6bO3Bq1amvNfmeZ6P/AMhux/6+Y/8A0IV5EPiR+i4r+BP0f5Hu9eufmhS1j/kCX/8A17Sf+gmpn8LOjC/x4eq/M8V0f/kN2P8A18x/+hCvKh8SP0PFfwJ+j/I93r1z80CgAoAKACgAoAz9a/48E/6+rf8A9HJUT2+78zow/wAb9Jf+kssVRkFABQAUAB4FTJ2TYGZb6pJNZ6ZOY1BvWAYD+H5Gbj/vmi+qXdX/AAOmdFRlUV/h/wA0iG01a+lS0uJoYBb3MhiwhO5Tzg+mOOlTCbfK31X6XLqUacXKMW7oin1C/uba3ukWOO1muolTaxEgXzAMnsc+nv3oTbcW+v8AkUqVOLlHqk/Tb9BT4hbzyyiAwifyvLBbzSN20t6decenelGfNbzB4Wys73tfy2vb+upMNSv2S+nS3ieK1d41RdxeQjp9P1o53y839b2uR7GneMb6uz8iCbVLybSZ5oLm0Z43Qb4SeASAQVPKn6023ZNd1+aLjRgqiUk7We/+fUk1LWLjT92XsyYot7x7mLv64A+6Pc5pSqcrJo4eNS2+r36f8EfNqd8090trFAUtoklzITlsgnHHTp1pyk48z7f5XFClT5Y8zd5XHjUbu7n2WMUWEhSWTzSed2SFGOnA6/pTk3eVuhPsoQjeb3b28uoafNO/hqGZXzMbfdukyecd6U21Suuy/IdSMViHFrS/6lKC41OSfTNssTSy2bu24sE/gwSB1PPt1pvm52l2/U1lGkozutFL59SV9ek8m3TEEM8vmb2kJKLsbacY5OT06VPPe1u1yfqyTk9WlbbzVzR0y9N/ZiZkCMGZGAOQSDjI9j1rRO6TOerT9nPlMxdQurqztbq4ihEctyioqOwI+YjJOfbpWcZN8rfX/JnTKlCEpRi9k+39fMsQarNLqjWz/Z4gJGQQyFllIGcMM8MD6DsetVCTk9f+CZzoxjT5ld7a9PTyINC1OS7RbaNvMaEubiSRiSMs21R6njr0FTTk5QT8l99jTFUVBuT0vt9yuT6Xqs19cFJfs6HaSYMsJYvYg9fqMVUJcyM69GNNaX9ej/rsS6pqEtpJGkUtqhYE/vixZvYKvP4/pSnNxJo0lNNtP5f5leHVry/e3WzigTzrQTkzEnaScY4602220uyf33NJUIU03NvRtaDodVur77PHaRRJK8PnSmUkhRnGBjrkg8+1Ck5fDtZP7xSowp3c31srE2izySaV51wTv82Xdlt23EjcZ9ulClampPsRiIpVXGPl+SEsr2/uI4ruSGFbSZd4AY741xkE9j+HTPei7iryHUp04twi3daeTI7fVLxhaXM0MS2t4wVApO9NwypPY5/TPehNppS6/wDDjnRh70YvWP49GMttWvpUtriSGAW88xhwpO8HJAb07dP17UoybUW+v+Vyp0aacopu6V/yKY86OK+u7kRyv9rSLKs6kfOgwOeAM9KmH2b9X+rNXytxjHT3W+nZly51W+WC6vLeGBre3do9rk72KnBPoBnPHtVKTspdG/1sZQoU3KMJN3evl3JpdVkjttUlEak2RIQf3vkDc/nTUtL+dvxsRGipTpxv8X+bQq3t3JqVzAiwLBbBS7OTk5XOPQfWlzPV9F/lcXs4KnGTvd/5lSLWrieR7dXtXeSB5I3h3MqFccE9G69R+VS5vllbdK5s8PGNpWe6Wvn+QkGoSQrZ3F7h2+wSTs6FhwAh6ZwSc1Upcrk30X6g6SlzRh/Ml+Zai1C9jlgF5DCEulJj8sklGC7tpz14B5GOlOUnC6e6Tf3GbpU5JuDenf1tcjsdUvZvsEtxDAsN8vyiMncjbS3OeoIB+nvTTd7Ptf8AIdSjCPOot3i/1sT3ct4utWcMMkYheNy6sDk4K/0PH40k3z26W/VERjD2Mm1rdfqUdMvr+O1tXmEckE07RZLEycs2DnpjjGP/ANVTTk7Rv1X6XN61Om5yUdGlfy6Era1KmopButXSSbyQsTMzIecFj07dKFNt27kfV1yN66K+v6f5lnRZruezZ7uRHbzZFBUEdHYf04q4NuKbM8RGEZ2h2X5IYNVlKiHy0+1fa/IK84A+9u/745pRle34/Lf+vMbopXd9LX/S336Ef9rXXlfbvJi+xed5eMnzMbtu7069vTvSjJuzez/XYp0YX5L+9a/lte3/AASQarJ9gkuPLXcl35AHbHmhM/XHNOMrqL7/APBJdFc/Lfpf/wAluWr66a0WGQKCjTLHIT/CG4B/Mim3ZpdzOnBTv5K/3f8AAKEGuSztsEKh3uRHEM/eiOTv/JWqYT5ref5Wv+q+ZvPDqOt9Evx2t99iobqQ+SYmeIFrwECRjkrnB5P4+1ZOT5Lr+V/mjZQV3fX4PxLlxNKPB7TCRxL9i3bwx3Z2dc+tbVm0nb+tTCnFPFcrWnN+o4aldWboL+OLy5IWkUxEkrtGSDnrx39qJz5b36aiVGM1+7et0tfPqR2GtyXN3BFIIGW4BKiEsTEQM4bPXjuMc0RbvZlVcOoxbV9O/X0Ld1d3JvlsrNYvM8vzXeXOAM4AwO55+mKLttpdP6/QyhCHJzz720Kkk2pPq8McaxRytaFnSRyyKdw546/p/SleXM7dl+pqo0lSbevvfPYV9YlaytZla1geYNuEzFjkHBCqOW570Od7NdVcFQSlJO7t2/XsEWr3d6LJbWKFGuoHkJlJIQqQO3Xr7UKTk9Oyf3hKhCnzOb2dtPmOi1W7ult4YIoUuZBIZC5JRAjbTjHJyelCk5Wt2v8AeKVGEOZyeitb5q/5DIdQluLy0FxAqSC4mj+SRsDap598+4pc/wBryf4Ow5UlGEuV6Wj+Itjq17MlhPcQwLDe/KAhO5DtLA89Qdp+nvVKTur9VcKtGnHnjFu8f87Amq3zxW12IYPst1MiIMneqscBj2OfTt70k5e7fr/lcJUaaco3d4p+mhs1ocYUAFABQAUAFABQAUAFABQBW0v/AI+tT/6+h/6JjqY7v+uhrW+GHp/7czRqznCgAoAr/wATfU0AFABQAUAFABQAUAFABQAUAFAAehoA5q6/4+pv99v50AS6b/x/x/j/ACNAHj/xJOfEMH/Xov8A6G9c+T/wH6/ojfNf469P1ZyNeueUFAEv2afZv8l9vXO2p543tcv2c7XsRVRAUAWJNPvYYRNLZzxxHo7RkL+eKzVWm3yqSv6m0sPWjHmcHbvZkBUjGQRnkZrS5k01uJQIKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA9t+C//IoXf/YQf/0XHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAFABQBBfvJHYTvCcOqEg4prcT2OPW3vL6RHIeQyEgOxyOOuT2rTRGerNXQZJl1GS2W4M0CKeecfh6VMtio7mtq8t3Bpc8lihe4A+UBdx68kDvxUq19Sne2hmafqio08z6sbqCGIvLFNFslRh6DA4qmvIlPzJrTxHDPKY54fIzGZUPmK+VHJzjocdqTiNSH22tzTr5r6ZPHbvG0kUpIYMAM/Nj7ufejlC5IutIy6c3kt/p4JHzfcwufxotuO5Sk1uW70r7X9luLaEugSRJV3MS2COh4/nT5bMm90Og1u+87VDLZbo7M5UK4zgDOPfjmjlWg7vUvw6rHcXsFtChcSweeXzwqnp+dTbQdy9SGFABQAUAFABQAUAFABQAUAFABQAUANmZ0hd44/MdVJVM43HsM0AU9L1aDVIGdAYpYztlhf70Z96bVhJ3EstVTULyeK2iZ4IeDcZ+Vn/uj1+tDVgTuX6QwoAKACgBF6fif50ALQAUAFAAelAEkP8Aqh+P86APNfih/wAhu0/69v8A2Y1wYr4kfY8P/wACfr+iNj4X/wDIEu/+vn/2UVrhfhZwcQfx4en6s7auo+dKq/dH0piFoGFABQAUAU50czMQrEewoEXKBhQAzBpAZ/lSf882/wC+TVkFX7PP/wA8ZP8Avk0DNLY/90/lUjLdAyDa3ofypAT0wCgCj5b/ANxvyoEP2N/dP5UxFukUFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAeET/wDHxJ/vn+deM9z9Qh8KPbjaW15Yxw3VvFPGVU7JUDLnHoa9hOyPzGoryZHb6NpdpMs9tptpBKucPHAqsPxAqrtkWQur/wDIGvv+veT/ANBNZz+FnRhf48PVfmeO6P8A8hux/wCvmP8A9CFeVD4kfomK/gT9H+R7vXrn5oUtY/5Al/8A9e0n/oJqZ/Czowv8eHqvzPFdH/5Ddj/18x/+hCvKh8SP0PFfwJ+j/I93r1z80CgAoAKACgAoAz9a/wCPBP8Ar6t//RyVE9vu/M6MP8b9Jf8ApLLFUZBQAUAFABQBnQ6LDBJARc3DJbOXhiZl2pkEY6ZI57k1EY2trtodEsQ5J6LXckj0uCK2trdXk220nmISRknnrx701FLl8v8AKxMq0nKUu5D/AGHDlF+03AgjlE0cAZdqsG3emcZ7E9/pSUEreRbxEtdFdqzf4ehKulKkxaO7uY4jJ5hgRgFLZyecbsE84zimo26kutdaxV9r9f8AL8CRdPjSC4iSWVPtEjSFlbDKT6EUctlZf1rcl1W5JtLTQg/saJ47gT3E80lwqq0rbQwCnK4wAODz0pcunzv9xft3dWSSV9Neu/W42fRFuBMrXt0q3KBJwuweZgYyfl4OPTA9qTpppq+jHDEuLTUVptvp17lhdOhRrhgz5uI1jbkcAAgY496qUVJST6/8MZ+1l7vkRNpEe5GhuZ4CIlicxlf3ijpnIPPJ5GDzRKN2/MtV3azSfX0/rzLFrZxWtjHZpuaKNNg3Hkim0nHlfaxnKo5Tc3ve5FbaXHbSQP580ht4miTft+6cccAdNooSs7lTrOaasld3+ev+Yw6REqx+TPNDLG0jLKhUt87bmHIIIz7dhU8lrWfkV7dtvmSadtPRWLdtB9nhEfmySkZJeVssSf8AParWisYylzO9rFddKgSzt7UPJst5BIpyMkg55496lRSUV2/ysaOtJylLvoIdKVrlJZLu4kSOXzUhdgVVue+N2OemcUKNnfsP2z5Wkkr6X/rT8BItHt4Ps5iklV4C2HDDLKxJKnjkZP6UlBK3pYJV5S5r9f06oWDS1iuY55Lu4uDCpWISlTsB68gAnp3JpqNncJVuaLiklfe39fkOudOE9yLhLma3kKeW5i2/Ouc4OQcdTyMHmk4Xv5ihV5Y8rSfXUSy0qCxaJonkJigEC7iPug5yeOtUlZ39F9wVK0ql79XcjGjRxrD9nuZ4HhQoJEKkspOcHII6+1SoWtZ9EvuK+sN35knfXr/mWbKyisLQW0RdkBY5c5PJJPP41VlblM6lR1Jub3/pENtpS2zxhbq4aGLPlwFhsXPbgZIHYEmko231LnWc76K73fX+vQbBo8UEkP8ApE7w253QwOV2RnoMcZOM8ZJxQo21uOVdyT0Sb3ff+vIfHpcEdrDbh5NkMvmqSRknJPPHTmhRSS8v8rEutJycu+gSaXBJBLCXk2yzidiCM7gQeOOnyihRSt5O/wCNwVaSaflb8LGZqGmXM73NvDb3Cx3DhsrOvk54yxH3gfYcGoUXdLz+W9/68zqpVoxSk2rpdnf07fPcvXWiw3TXGbm4jS6AE0cbKFYgYzyCQcAdD25quRfjcwp4iUOXRNrZlg6fAXu2bcwu1CyKTxgDHH4UOCaa7/8ADfoZqrJKNvs7EEOjpHPHNLd3FwYo2iQSFQApxn7qj060ON7t63Vi5V21aMUtb9f1bFi0eCMRB5ZZhFC0CiTbgo2ODgD+6Kbine/VWFKvJ3sra3+f9MWDSUikR5LmecRKUiWQriMEY4wBk44yc0nG97vfQJV21ZJK+9uv9eQ+LTIYYrKNWkIsv9Xkjn5SvPHoaq2tyZVZScn/ADf53JJ7NZ7iC482SOSAnBTHzA4yDkHg4HvRb3rijU5YuNtyKPS4I7WG3DybIZfNUkjJOSeeOnNJRSS8v8rFOtJycu+hEuiRK8X+lXBihm86OHK7VbJP93JHJ6mlGFreX+Vi3iG09Fdqzev+ZatLNbMSKksjI7s4RsYQkknGBnqe+aqKsrGVSpzu7WpUgsXfXZtQkhMSiMRoCwO855fjpxgetTBWbff+vx0+41nUXsVTTv1/4H5j/wCxovMx58/2fzfN+zZXZuzn0zjPOM4zQo2t5C9u7bK9rX69vTbTYa+iwu7f6TcLE0wn8kMu0OCGz0zyR0zjmhQtbyD6w7bK9rX8rWLl3bJeWsltIWCyLglTgj3HvTlFSVmZU5uElJdCCLSbWK6t7hA263h8lBnjA6E+/X8zTsuZy7lutNwcX1dxg0a2AQb5fkMpHI/5aZ3dvfio9muXl8rfeV9Yldv0/DYmfT4pNLOnFn8ow+VkEbsYx6dauaU1ZkRqyjU9ot73IotJiSUPNPNchYzGizFSEU9RwBnpjJyaTine+tynXdrRSXXTuOtdNNrIh+23Msca7Y4nYbVH4AFvxJppNat3FOrzr4Ur/wBfL5WHXVgLidJ47iW3mVSm+LbkqexDAik463TFCryrlaTXn/wLBBp0UFxHOJJXeOHygXbdkZzk985ppJO/p+ASquUXHzuQjRo4/KMF1cQPGrJvTaSyk7iDlSOvpUqCWz6JfcX9YbvzJO+vX/MfaaTb2bW5jeUm3jaNNxByGIJzx14pxio7dkvuFUryne/V3K11pxgWA2sVw7RvI3mQyosi7zuIw3ykZ9emBUuNrW7WNIVVJvna1tunbTTpqLpmkmKOKW4DpKk0kqpv3Eb+MMe5x6d6FD3Un2a+93FWr3bUdnZfcWotLght7OBWkK2RBjJIyflK88ejGrtqn2VjOVaUnJv7W/33MsaZctcQQrb3EUMNyJQGnVoUAOflA+Y59CMDNZwi7q/T/K2n/BOl1o8sndNtW2d/n0+7c24ITCHBlkk3uX/eHO3PYewrRKyscUpc3SxLTJCgAoAKACgAoAKACgAoAraX/wAfWp/9fQ/9Ex1Md3/XQ1rfDD0/9uZo1ZzhQAUAV/4m+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/x9Tf77fzoAl03/j/AI/x/kaAPHfiMc+IIP8Ar1X/ANDesMo/gP1/RHTm/wDHXp+rOTr1jyCzp6JJexq+COTg9+KzqtqDsbUEnUSZ172tmNJin8/bcNnKdd3JHTtXkqc/aONtD6B06XsFK/vdjkNQRI72RU4HBx6cV61JtwVz5+ukqjSGWjOl5A8cRldZFKxgZ3HPT8aqaTi03Yim2pppX1OknmbU3v5LG+uoZzEzT2dymRtH3gD0GO3Ga82MVSUFOKaurNH0E6jxE5ulNxlZ3i1p5ry/rYsSJaX9/osE9nH5b2e8hS3ACsQvXpms0504VZRlqn+qNLU608NCUVZr9HoUrK20+70+fUja2cO2QQxxzSOI14zkkcknP6VtUnUhNU7t9dLXOahToVacq3IlaySbdvV+Yf2dYDULiW2itprZIUYtNcMsULt26bm6cU/a1ORKTad3stWvyQPDUFWcoJNcqer91N/i/Ink0rTormSc28csR003AjR22bwRyCecGs1WquPLez5rdL2NZYWhGfPyppwbsr2uuzEt4NMnl0zdpcQ/tJWEmHbCYJGV549ac5VYqfv/AA/1qTTWHmqUnSX7y6e+lnbT1OXmQRzOg6KxAzXpxd0meHWgoVJQXRtDKZkFABQAUAFABQAUAFABQAUAFAHtvwX/AORQu/8AsIP/AOi465q3xHTS+E9BrE1CgAoAKACgAoAKACgAoAKAAgEEEZBoA5m80m/tXkis9728x+6p/Q/41omnuQ0+hq6Ppn9nQMXIM0n3iOw9Klu5SVi1fWz3do8MdxJbucFZIzgqR/Me1JOwPUzf7BkuppJdSvftDNAYV8uIRhQep6nJp83YXL3HWmhNDlLieGSPyjFiO2WMkEYyW5OcemKHIEh1ppF1AiQTak0ttHGY1jWMKSCMDccnOB9KG0CRDb+H54pLMy6j5sdlkRJ5IXgjGCc9enPtRzByk39if8SOLTPtH+rZW8zZ1w27pn+tHNrcLaWHpYtY3d9eeYZYbgb3gWLLZAxwc8/TFF76DtbUreGdOezt5p5UkRpWxGsgwyxj7oI7USdxRVjbqSgoAKACgAoAKACgAoAKACgAoAKACgAoAydT8PQ6hci5jnktZGGyZouPNT0P+NUpWJcbmlb28Npbpb28YjijGFUdqncokoAKACgAoARen4n+dAC0AFABQAHpQBJD/qh+P86APNfih/yG7T/r2/8AZjXBiviR9jw//An6/ojY+F//ACBLv/r5/wDZRWuF+FnBxB/Hh6fqztq6j50rMvl8Hp2NMQm5f7w/OgA3L/eH50AG5f7w/OgA3L/eH50AG5f7w/OgA3L/AHh+dABuX+8PzoANy/3h+dABuX+8PzoANy/3h+dABuX+8PzoANy/3h+dABuX+8PzoANy/wB4fnQAbl/vD86ADcv94fnQAbl/vD86ADcv94fnQAbl/vD86ADcv94fnQAbl/vD86ADcv8AeH50AG5f7w/OgA3L/eH50AG5f7w/OgA3L/eH50AG5f7w/OgA3L/eH50AG5f7w/OgA3L/AHh+dABuX+8PzoANy/3h+dABuX+8PzoANy/3h+dABuX+8PzoANy/3h+dABuX+8PzoANy/wB4fnQAbl/vD86ADcv94fnQAbl/vD86ADcv94fnQAbl/vD86ADcv94fnQAbl/vD86ADcv8AeH50AG5f7w/OgA3L/eH50AG5f7w/OgA3L/eH50AG5f7w/OgA3L/eH50AG5f7w/OgA3L/AHh+dABuX+8PzoANy/3h+dABuX+8PzoANy/3h+dABuX+8PzoANy/3h+dABuX+8PzoANy/wB4fnQAbl/vD86APD9RtprPUJ4J0KOkhBB+vWvHkmpNM/TsPUjVpRnB3TRCJpQABK4A6DcaV2ackewefN/z1f8A76NF2Lkj2AzSkEGVyD1G40XY+SPYv+HbSe88QWMcEbOwnRmwPuqGBJPtiqppuasc2OqRp4abk+j/ACPca9Y/NylrH/IEv/8Ar2k/9BNTP4WdGF/jw9V+Z4ro/wDyG7H/AK+Y/wD0IV5UPiR+h4r+BP0f5Hu9eufmgUAFABQAUAFAGfrX/Hgn/X1b/wDo5Kie33fmdGH+N+kv/SWWKoyCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCtpf/AB9an/19D/0THUx3f9dDWt8MPT/25mjVnOFABQBX/ib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/H1N/vt/OgCXTf+P8Aj/H+RoA8b+IZzr8H/Xqv/oT1jlX8B+v6I6s4/jr0/VnK16p44qsUYMpwQcg0NXGm07ovf2vcbNu1N397FYewjc6frU7WKLMXYsxJJOSTW6Vjmbbd2CsyOHRirKcgg4INDV9GCbTujRuPEOp3MDwyzrtkGJCsaqzj0JAya5o4WlGSaWx3TzHEzg4uW+j0V2Mj1vUIkgRJwPs4IiYxqSoIIxkjpgmqeHpybbW+5EMbXgopP4dtFp/VyOy1O608OsDjZJjejoGVsdOCKqpRhUtzdDOhiatC/I9910JV13UVuZZzOHaYBZA6KysB0G0jHFQ8NS5VG2xqsfiFNz5tXp5W9BJtb1GdmaW43F4TCfkUfITnHSnHD0o6Jdb/ADFLHYibu5dGtls91sRx6neRG2KTYNpnyflHyZOT25/GqdGD5rr4tzKOIqxUEn8N7eV9yqzF2LMcljkmtUrKyMpSc5OUt2JQSFABQAUAFABQAUAFABQAUAFAHtvwX/5FC7/7CD/+i465q3xHTS+E9BrE1CgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgBF6fif50ALQAUAFAAelAEkP+qH4/zoA81+KH/IbtP+vb/2Y1wYr4kfY8P/AMCfr+iNj4X/APIEu/8Ar5/9lFa4X4WcHEH8eHp+rO2rqPnQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAY8ccn30VseozRYak1sxv2eD/njH/wB8ilZFc8u4fZ4P+eMf/fIosg55dw+zwf8APGP/AL5FFkHPLuPSNI87EVc+gxTJcm92OoEUtY/5Al//ANe0n/oJqZ/Czowv8eHqvzPFdH/5Ddj/ANfMf/oQryofEj9DxX8Cfo/yPd69c/NAoAKACgAoAKAKmp28lzYOkIBlVlkQE4BZWDAfiRUyV1oa0ZqM03tqvvViO2vIbtMxt8y8PG3DIfQjsaE0yp05QepPTMwoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAIp7mG1jMk8qxqO7Hr9PWk2luXGEpu0VcTS4pFinuJUMbXUpl2N1UbQq598KPzoiuo68ldRXRW/X9S9VGAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/wCP+P8AH+RoA8a+IJzrsH/Xqv8A6E1Z5X/Bfr+iOvOf94Xp+rOWr0zxgoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA9t+C/wDyKF3/ANhB/wD0XHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAIvT8T/ADoAWgAoAKAA9KAJIf8AVD8f50Aea/FAH+2bM44NvjP/AAI1wYr4kfY8P/wJ+v6HP6R4m1XQ4HhsJ1jjkbcwMatzjHcVjCrKCsj1MTgMPiZKVVXa82X/APhYHiP/AJ+4/wDvyn+FX9Yqdzm/sXBfy/iw/wCFgeI/+fuP/vyn+FH1ip3D+xcF/L+LD/hYHiP/AJ+4/wDvyn+FH1ip3D+xcF/L+LD/AIWB4j/5+4/+/Kf4UfWKncP7FwX8v4sP+FgeI/8An7j/AO/Kf4UfWKncP7FwX8v4sP8AhYHiP/n7j/78p/hR9Yqdw/sXBfy/iw/4WB4j/wCfuP8A78p/hR9Yqdw/sXBfy/iw/wCFgeI/+fuP/vyn+FH1ip3D+xcF/L+LD/hYHiP/AJ+4/wDvyn+FH1ip3D+xcF/L+LD/AIWB4j/5+4/+/Kf4UfWKncP7FwX8v4sP+FgeI/8An7j/AO/Kf4UfWKncP7FwX8v4sP8AhYHiP/n7j/78p/hR9Yqdw/sXBfy/iw/4WB4j/wCfuP8A78p/hR9Yqdw/sXBfy/iw/wCFgeI/+fuP/vyn+FH1ip3D+xcF/L+LD/hYHiP/AJ+4/wDvyn+FH1ip3D+xcF/L+LD/AIWB4j/5+4/+/Kf4UfWKncP7FwX8v4sP+FgeI/8An7j/AO/Kf4UfWKncP7FwX8v4sP8AhYHiP/n7j/78p/hR9Yqdw/sXBfy/iw/4WB4j/wCfuP8A78p/hR9Yqdw/sXBfy/iw/wCFgeI/+fuP/vyn+FH1ip3D+xcF/L+LD/hYHiP/AJ+4/wDvyn+FH1ip3D+xcF/L+LD/AIWB4j/5+4/+/Kf4UfWKncP7FwX8v4sP+FgeI/8An7j/AO/Kf4UfWKncP7FwX8v4sP8AhYHiP/n7j/78p/hR9Yqdw/sXBfy/iw/4WB4j/wCfuP8A78p/hR9Yqdw/sXBfy/iw/wCFgeI/+fuP/vyn+FH1ip3D+xcF/L+LD/hYHiP/AJ+4/wDvyn+FH1ip3D+xcF/L+LD/AIWB4j/5+4/+/Kf4UfWKncP7FwX8v4sP+FgeI/8An7j/AO/Kf4UfWKncP7FwX8v4sP8AhYHiP/n7j/78p/hR9Yqdw/sXBfy/iw/4WB4j/wCfuP8A78p/hR9Yqdw/sXBfy/iw/wCFgeI/+fuP/vyn+FH1ip3D+xcF/L+LD/hYHiP/AJ+4/wDvyn+FH1ip3D+xcF/L+LD/AIWB4j/5+4/+/Kf4UfWKncP7FwX8v4sP+FgeI/8An7j/AO/Kf4UfWKncP7FwX8v4sP8AhYHiP/n7j/78p/hR9Yqdw/sXBfy/iw/4WB4j/wCfuP8A78p/hR9Yqdw/sXBfy/iw/wCFgeI/+fuP/vyn+FH1ip3D+xcF/L+LD/hYHiP/AJ+4/wDvyn+FH1ip3D+xcF/L+LD/AIWB4j/5+4/+/Kf4UfWKncP7FwX8v4sP+FgeI/8An7j/AO/Kf4UfWKncP7FwX8v4sP8AhYHiP/n7j/78p/hR9Yqdw/sXBfy/iw/4WB4j/wCfuP8A78p/hR9Yqdw/sXBfy/iw/wCFgeI/+fuP/vyn+FH1ip3D+xcF/L+LD/hYHiP/AJ+4/wDvyn+FH1ip3D+xcF/L+LD/AIWB4j/5+4/+/Kf4UfWKncP7FwX8v4sP+FgeI/8An7j/AO/Kf4UfWKncP7FwX8v4sP8AhYHiP/n7j/78p/hR9Yqdw/sXBfy/iw/4WB4j/wCfuP8A78p/hR9Yqdw/sXBfy/iw/wCFgeI/+fuP/vyn+FH1ip3D+xcF/L+LD/hYHiP/AJ+4/wDvyn+FH1ip3D+xcF/L+LD/AIWB4j/5+4/+/Kf4UfWKncP7FwX8v4sP+FgeI/8An7j/AO/Kf4UfWKncP7FwX8v4sP8AhYHiP/n7j/78p/hR9Yqdw/sXBfy/iw/4WB4j/wCfuP8A78p/hR9Yqdw/sXBfy/iw/wCFgeI/+fuP/vyn+FH1ip3D+xcF/L+LD/hYHiP/AJ+4/wDvyn+FH1ip3D+xcF/L+LD/AIWB4j/5+4/+/Kf4UfWKncP7FwX8v4sP+FgeI/8An7j/AO/Kf4UfWKncP7FwX8v4sP8AhYHiP/n7j/78p/hR9Yqdw/sXBfy/iw/4WB4j/wCfuP8A78p/hR9Yqdw/sXBfy/iw/wCFgeI/+fuP/vyn+FH1ip3D+xcF/L+LD/hYHiP/AJ+4/wDvyn+FH1ip3D+xcF/L+LD/AIWB4j/5+4/+/Kf4UfWKncP7FwX8v4sP+FgeI/8An7j/AO/Kf4UfWKncP7FwX8v4sP8AhYHiP/n7j/78p/hR9Yqdw/sXBfy/iw/4WB4j/wCfuP8A78p/hR9Yqdw/sXBfy/iw/wCFgeI/+fuP/vyn+FH1ip3D+xcF/L+LD/hYHiP/AJ+4/wDvyn+FH1ip3D+xcF/L+LD/AIWB4j/5+4/+/Kf4UfWKncP7FwX8v4sP+FgeI/8An7j/AO/Kf4UfWKncP7FwX8v4sZP468QXNvJBJdoUlQowEKjgjB7UnXm1a5UMnwcJKSjqvNmXowLa5YADJNzHgf8AAhWcPiR24rTDz9H+R7tXrn5oFABQAUAFABQAUAVrjT7G7YNc2dvOw6GSJWP6ik4p7o0hVqQ0jJr5kP8AYekf9Aqy/wDAdP8AClyR7F/Wa/8AO/vYf2HpH/QKsv8AwHT/AAo5I9g+s1/5397D+w9I/wCgVZf+A6f4UckewfWa/wDO/vYf2HpH/QKsv/AdP8KOSPYPrNf+d/ew/sPSP+gVZf8AgOn+FHJHsH1mv/O/vYf2HpH/AECrL/wHT/Cjkj2D6zX/AJ397D+w9I/6BVl/4Dp/hRyR7B9Zr/zv72H9h6R/0CrL/wAB0/wo5I9g+s1/5397D+w9I/6BVl/4Dp/hRyR7B9Zr/wA7+9h/Yekf9Aqy/wDAdP8ACjkj2D6zX/nf3sP7D0j/AKBVl/4Dp/hRyR7B9Zr/AM7+9h/Yekf9Aqy/8B0/wo5I9g+s1/5397D+w9I/6BVl/wCA6f4UckewfWa/87+9h/Yekf8AQKsv/AdP8KOSPYPrNf8Anf3sP7D0j/oFWX/gOn+FHJHsH1mv/O/vYf2HpH/QKsv/AAHT/Cjkj2D6zX/nf3sP7D0j/oFWX/gOn+FHJHsH1mv/ADv72H9h6R/0CrL/AMB0/wAKOSPYPrNf+d/ew/sPSP8AoFWX/gOn+FHJHsH1mv8Azv72H9h6R/0CrL/wHT/Cjkj2D6zX/nf3sP7D0j/oFWX/AIDp/hRyR7B9Zr/zv72H9h6R/wBAqy/8B0/wo5I9g+s1/wCd/ew/sPSP+gVZf+A6f4UckewfWa/87+9h/Yekf9Aqy/8AAdP8KOSPYPrNf+d/ew/sPSP+gVZf+A6f4UckewfWa/8AO/vYf2HpH/QKsv8AwHT/AAo5I9g+s1/5397D+w9I/wCgVZf+A6f4UckewfWa/wDO/vYf2HpH/QKsv/AdP8KOSPYPrNf+d/ew/sPSP+gVZf8AgOn+FHJHsH1mv/O/vYf2HpH/AECrL/wHT/Cjkj2D6zX/AJ397D+w9I/6BVl/4Dp/hRyR7B9Zr/zv72H9h6R/0CrL/wAB0/wo5I9g+s1/5397D+w9I/6BVl/4Dp/hRyR7B9Zr/wA7+9h/Yekf9Aqy/wDAdP8ACjkj2D6zX/nf3sP7D0j/AKBVl/4Dp/hRyR7B9Zr/AM7+9h/Yekf9Aqy/8B0/wo5I9g+s1/5397D+w9I/6BVl/wCA6f4UckewfWa/87+9h/Yekf8AQKsv/AdP8KOSPYPrNf8Anf3sP7D0j/oFWX/gOn+FHJHsH1mv/O/vYf2HpH/QKsv/AAHT/Cjkj2D6zX/nf3sP7D0j/oFWX/gOn+FHJHsH1mv/ADv72H9h6R/0CrL/AMB0/wAKOSPYPrNf+d/ew/sPSP8AoFWX/gOn+FHJHsH1mv8Azv72H9h6R/0CrL/wHT/Cjkj2D6zX/nf3sP7D0j/oFWX/AIDp/hRyR7B9Zr/zv72H9h6R/wBAqy/8B0/wo5I9g+s1/wCd/ew/sPSP+gVZf+A6f4UckewfWa/87+9h/Yekf9Aqy/8AAdP8KOSPYPrNf+d/ew/sPSP+gVZf+A6f4UckewfWa/8AO/vYf2HpH/QKsv8AwHT/AAo5I9g+s1/5397D+w9I/wCgVZf+A6f4UckewfWa/wDO/vYf2HpH/QKsv/AdP8KOSPYPrNf+d/ew/sPSP+gVZf8AgOn+FHJHsH1mv/O/vYf2HpH/AECrL/wHT/Cjkj2D6zX/AJ397D+w9I/6BVl/4Dp/hRyR7B9Zr/zv72H9h6R/0CrL/wAB0/wo5I9g+s1/5397D+w9I/6BVl/4Dp/hRyR7B9Zr/wA7+9h/Yekf9Aqy/wDAdP8ACjkj2D6zX/nf3sP7D0j/AKBVl/4Dp/hRyR7B9Zr/AM7+9h/Yekf9Aqy/8B0/wo5I9g+s1/5397D+w9I/6BVl/wCA6f4UckewfWa/87+9h/Yekf8AQKsv/AdP8KOSPYPrNf8Anf3sP7D0j/oFWX/gOn+FHJHsH1mv/O/vYf2HpH/QKsv/AAHT/Cjkj2D6zX/nf3sP7D0j/oFWX/gOn+FHJHsH1mv/ADv72H9h6R/0CrL/AMB0/wAKOSPYPrNf+d/eyWDS9PtpBJb2FtC46NHCqn8wKFGK2RMq1WatKTfzLVUZBQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/wCP+P8AH+RoA+dri6uLuQSXM8kzgYDSOWIHpk12xhGCtFWOSdSdR3m235kVUQFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHtvwX/5FC7/AOwg/wD6LjrmrfEdNL4T0GsTUKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEXp+J/nQAtABQAUAB6UASQ/wCqH4/zoAqaromna3EseoWwlCHKHJUr9CKicIz+I6cNi62GbdKVrmT/AMK+8Of8+kn/AH+b/Gs/q9Psd39tY3+b8EH/AAr7w5/z6Sf9/m/xo+r0+wf21jf5vwQf8K+8Of8APpJ/3+b/ABo+r0+wf21jf5vwQf8ACvvDn/PpJ/3+b/Gj6vT7B/bWN/m/BB/wr7w5/wA+kn/f5v8AGj6vT7B/bWN/m/BB/wAK+8Of8+kn/f5v8aPq9PsH9tY3+b8EH/CvvDn/AD6Sf9/m/wAaPq9PsH9tY3+b8EH/AAr7w5/z6Sf9/m/xo+r0+wf21jf5vwQf8K+8Of8APpJ/3+b/ABo+r0+wf21jf5vwQf8ACvvDn/PpJ/3+b/Gj6vT7B/bWN/m/BB/wr7w5/wA+kn/f5v8AGj6vT7B/bWN/m/BB/wAK+8Of8+kn/f5v8aPq9PsH9tY3+b8EH/CvvDn/AD6Sf9/m/wAaPq9PsH9tY3+b8EH/AAr7w5/z6Sf9/m/xo+r0+wf21jf5vwQf8K+8Of8APpJ/3+b/ABo+r0+wf21jf5vwQf8ACvvDn/PpJ/3+b/Gj6vT7B/bWN/m/BB/wr7w5/wA+kn/f5v8AGj6vT7B/bWN/m/BB/wAK+8Of8+kn/f5v8aPq9PsH9tY3+b8EH/CvvDn/AD6Sf9/m/wAaPq9PsH9tY3+b8EH/AAr7w5/z6Sf9/m/xo+r0+wf21jf5vwQf8K+8Of8APpJ/3+b/ABo+r0+wf21jf5vwQf8ACvvDn/PpJ/3+b/Gj6vT7B/bWN/m/BB/wr7w5/wA+kn/f5v8AGj6vT7B/bWN/m/BB/wAK+8Of8+kn/f5v8aPq9PsH9tY3+b8EH/CvvDn/AD6Sf9/m/wAaPq9PsH9tY3+b8EH/AAr7w5/z6Sf9/m/xo+r0+wf21jf5vwQf8K+8Of8APpJ/3+b/ABo+r0+wf21jf5vwQf8ACvvDn/PpJ/3+b/Gj6vT7B/bWN/m/BB/wr7w5/wA+kn/f5v8AGj6vT7B/bWN/m/BB/wAK+8Of8+kn/f5v8aPq9PsH9tY3+b8EH/CvvDn/AD6Sf9/m/wAaPq9PsH9tY3+b8EH/AAr7w5/z6Sf9/m/xo+r0+wf21jf5vwQf8K+8Of8APpJ/3+b/ABo+r0+wf21jf5vwQf8ACvvDn/PpJ/3+b/Gj6vT7B/bWN/m/BB/wr7w5/wA+kn/f5v8AGj6vT7B/bWN/m/BB/wAK+8Of8+kn/f5v8aPq9PsH9tY3+b8EH/CvvDn/AD6Sf9/m/wAaPq9PsH9tY3+b8EH/AAr7w5/z6Sf9/m/xo+r0+wf21jf5vwQf8K+8Of8APpJ/3+b/ABo+r0+wf21jf5vwQf8ACvvDn/PpJ/3+b/Gj6vT7B/bWN/m/BB/wr7w5/wA+kn/f5v8AGj6vT7B/bWN/m/BB/wAK+8Of8+kn/f5v8aPq9PsH9tY3+b8EH/CvvDn/AD6Sf9/m/wAaPq9PsH9tY3+b8EH/AAr7w5/z6Sf9/m/xo+r0+wf21jf5vwQf8K+8Of8APpJ/3+b/ABo+r0+wf21jf5vwQf8ACvvDn/PpJ/3+b/Gj6vT7B/bWN/m/BB/wr7w5/wA+kn/f5v8AGj6vT7B/bWN/m/BB/wAK+8Of8+kn/f5v8aPq9PsH9tY3+b8EH/CvvDn/AD6Sf9/m/wAaPq9PsH9tY3+b8EH/AAr7w5/z6Sf9/m/xo+r0+wf21jf5vwQf8K+8Of8APpJ/3+b/ABo+r0+wf21jf5vwQf8ACvvDn/PpJ/3+b/Gj6vT7B/bWN/m/BB/wr7w5/wA+kn/f5v8AGj6vT7B/bWN/m/BB/wAK+8Of8+kn/f5v8aPq9PsH9tY3+b8EH/CvvDn/AD6Sf9/m/wAaPq9PsH9tY3+b8EH/AAr7w5/z6Sf9/m/xo+r0+wf21jf5vwQf8K+8Of8APpJ/3+b/ABo+r0+wf21jf5vwQf8ACvvDn/PpJ/3+b/Gj6vT7B/bWN/m/BB/wr7w5/wA+kn/f5v8AGj6vT7B/bWN/m/BB/wAK+8Of8+kn/f5v8aPq9PsH9tY3+b8EH/CvvDn/AD6Sf9/m/wAaPq9PsH9tY3+b8EH/AAr7w5/z6Sf9/m/xo+r0+wf21jf5vwQf8K+8Of8APpJ/3+b/ABo+r0+wf21jf5vwQf8ACvvDn/PpJ/3+b/Gj6vT7B/bWN/m/BB/wr7w5/wA+kn/f5v8AGj6vT7B/bWN/m/BB/wAK+8Of8+kn/f5v8aPq9PsH9tY3+b8EH/CvvDn/AD6Sf9/m/wAaPq9PsH9tY3+b8EH/AAr7w5/z6Sf9/m/xo+r0+wf21jf5vwQf8K+8Of8APpJ/3+b/ABo+r0+wf21jf5vwQf8ACvvDn/PpJ/3+b/Gj6vT7B/bWN/m/BB/wr7w5/wA+kn/f5v8AGj6vT7B/bWN/m/BB/wAK+8Of8+kn/f5v8aPq9PsH9tY3+b8EH/CvvDn/AD6Sf9/m/wAaPq9PsH9tY3+b8EWtO8IaHpd0t1a2eJk+6zuzbfoCcVUaMIu6RjXzPFV4ck5afJG3Wp5wUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBX/AIm+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/x9Tf77fzoAl03/j/j/H+RoA+ca7zhCgBQCzBQMk8ACgAIKsVIwRwQaAEoAciPLIscaM7scKqjJJ9AKYFm50rUbOPzbqwuoEzjdLCyj8yKm6HZkL2txHbpcPBIsMhISQoQrEdcHoaezsFtLim0uQ8SG2l3TgNEuw5kB6FfX8KPIXS466sLyxKi7tJ7ct90SxlM/TNJNPYbTRXpiCgAoAKACgAoAKACgAoAKACgAoAKACgD234L/wDIoXf/AGEH/wDRcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFABQBhXPiGXz3SztxIkfViCc+/HQVaj3I5uxo6ZqKajbmQLsdThl9KlqxSdya8vILC2a5uXKRJjJAJ6nHQUJXBuxBaavY30xghlPmgbtjoyNj1AIGaGmgTTLtIZVg1K3uWjEAkkWQsA4jO0FeuT2p2FctUhhQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAIvT8T/OgBaACgAoAD0oAkh/1Q/H+dAElABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8AH1N/vt/OgCXTf+P+P8f5GgD5xrvOEKAJ7N2jvIipwd4H60MaPS9G8L2N/pUN1PJP5km4nawA+8R6Vg5NM1UU0cF4mtBY+Ibu1UuViYBd/XGAR/OtYu6M5KzINE/5Dth/18x/+hCtYb/f+REtjp9Pvb248dXljLPLLZPLMk0TsWQR/N2PAxxXOkvYtvsbzbVVW8h9vJaz+GdI0e6KrDfLOI5T/wAs5RJ8jfTkg/WrqJym7bpR/LVCvGP+G7/SzC5ln0TVdJMtnNM1vpeycQjLxDLBmB7Y9alNSU+zt+g7OMYdWmzK1RXm8PG4stWnvNPW5G+G6jxJE5HHzc54z0P4U3pJXJWqlZ+pzlWZhQAUAFABQAUAFABQAUAFABQAUAFABQB7b8F/+RQu/wDsIP8A+i465q3xHTS+E9BrE1CgAoAKACgAoAKACgAoAKACgDkpJLnQ7y4hi27ZOhYZyOxrTRmexr+HbR7eyaVxgzEED2HSpk9SooTxUQPD85PQMn/oQojuEtipNew6vqli2mN5zWu95JQpCqCuAMn1Panay1Fe70M7RjI1/aObuNbtpD9oTMjSP1yGHQe3QVT2EtyfS18y406JidkjXYYA9eaT6gug6wN3cXUenksW0pZCxP8AG3SP9OaHbfuNX2K2jF2vLV/tca3TFvtCbpGkfg5Dg8DH4U2JFmy0wS+FRdwGQ3hXzA5ckkoxIGP0/Gk371hpe6aOgytqM1zqzZCTERxKeyqOfzOfyqZaaDjrqbNSUFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACL0/E/zoAWgAoAKAA9KAJIf9UPx/nQBJQAUAFAHnfi3Xp4/EM72up/Z10iOJvs/n7PtLlgWXbn5sLWlG3xNXTdvlrf8SKt/hTs7N/PovuLviXUbaXXNIabUr210+4tXkJtHcFjwV4TJ/SlGNpTT3SX5sUpXhBrq3+SK2n3mqqmjLcXN55MmqukLTsVklg2/Lv8AXv1q0rzV9+V39SZO0XbbmVv67Gx4kjlvPE2iaeLy6t4Z1nMn2aYxlsKCOlZ095+SX5mlT4Y+v6FCPXbnwzLrVlPPPqUdl5TWxnfL5k/hZvr+lUv3kVbduwnam229LX/QuS+Lb3SGvbfW7OAXFvai6jNq5KSKW27fmGQckc1Nk17u90vvGm7rm2d/w6Ezaz4gstMvLzUdNtQkVqbiKSCUlQf7jA859xxRNKOl9bpfiEG5a9LN/hcJfE9xG+lqLeM/brGS5fk/KVQMAPbmiceV1F/Kv1sEJc3s/wC87fgUbPxZrt42nqmn2IOqQs1tmZgFZfvF+OnoBz71bgk2u1n95Cm2lLu2hJPHcqaNZStBbQ3t1LJETKzeTHsOCxwCSOmB71PKm1y7WuVzNJ826dgh8b3d3DZLbWdu9zPdvatmRhGSFBDKcZ2nPpmnyXat1Tf3C57J36NL7yDU/E2uPos+xLe1vbO/S2naNiVbJGNuR0Oec9qIxTlBrZtr5r9AnJxjNPdJP5P9S9r3iq/0VkRhpnmRQiSaNp2Lu2OQigZA9C1SrNvsU7peYy01rVr3xUyoYf7PfTkuREzHKqw68D72ePTHvROKjTqX6O34CjJyqQt1X66/8Ar6H4gvJdL0rTdGs7cXM0Ekx+0yuUjRXK9eWJJ/KtJx959kl+RMJe6vNssR+Mb+9bTYLKwgFzeNPE6TSHbHJH7gcjv0qFG92npZP7ynK2+6djZ8N6vPrFjM91AkNxbXD28qxtlSy9SPbmlJKyktmrjTd3F9DXqSgoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAr/wATfU0AFABQAUAFABQAUAFABQAUAFAAehoA5q6/4+pv99v50AS6b/x/x/j/ACNAHzjXecIUAOjcxyK45KkEZoAc08rOzb2XcScA8c0AMJJOSck0APgmktp454m2yRsHRsZwQcimnYHqaV14o1m8t5IJrz93N/rBHEiF/qVAJqORF88ihNe3M9rb2skm6G23eUuANu45PPU8+tX9rm6/5E9LFxvEervfQ3rXrG4gj8tH2rnb6Hjnr3zU2WvmF3ZLsM1DXNQ1OFILmZfJRtwjjjVF3euFAyaOVXuPmdrGfTJCgAoAKACgAoAKACgAoAKACgAoAKACgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFABQBWu9Ptr4oZ0yUOQR39vpTTsJq5ZAwMCkMKACgAx3oAKACgAxQBDd2/2q3aHzpYd38cTYYfjTWgMW1tYrK1jtoF2xxjCihu4LQlpAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACL0/E/zoAWgAoAKAA9KAJIf9UPx/nQBJQAUAFAGNb+FtLhS8WSL7S97I8ksk4VnBbsDjgDtQ/hUewL4+cLDwxZ6fNYSx3FzI1hC8MXmMpyrHvgDp0FW5ttvukvuIUEkl2bf3lu/0qDUbmynmeRWspvNjCEAE4xzkdKmL5Zcy7NfeVJc0eV90/uK2s+HYNauLa4e8vLSa1DCN7WQIfmxnkg+lEXytvuEldWIovCOlppV1p7iacXh3TzyybpXYdGLeo7U3Ju1tLbCUUm29biQeEbBVuvtc91fyXUIgeW6kDMEHQDAGOefrQ5XVttb/MIxs7/ILXwnZwLOtxd3t6Jrf7N/pMu7bH6DAH59aJS5k/PUIx5WvIhtfBVjbSwym+1CdoIXgj86YMFRl24A28YHTH60Sk5KSfXcIxUXFro7lu08M2Vm+mNHLOTpaOkO5h8wYYO7jn8MU3Ntt90l9wlBKKj2dyH/AIRCwWzhgiuLqKS3neeG4RwJEZj8wzjGD6EUlJq1uit8imk+a/V3+ZKvhm2Jsnmvb24kspzOkk028sx9cjp7DFNSs7pdLfeJxurN9U/uG3PhSwure/heW4AvpxcOyuAUcYxt446d81KbSjbo2/vG0m231SX3ENx4NtLmSd31DUAbqBYbnbIv74KMAt8vX6YHt1p30tbrcVtn8iePwvaQ3ttdw3N1G9vbC1IVxtljA43DHP4YolLm5k/tBGKjy2+z/wAOV08GWMNpZw213e20tkrJHcRSKJCrEkqflwRk+lNzbbb6qwlBJW87k9r4U06zm06WBplOneYY8sD5hcYYvxkn6Yo53dvurByK1vO5d0zSoNKW5WB5GFzcPcPvIOGbqBgDjipv7qj20Kt7zl3L1IYUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBS1meW10S+uIW2SxW8jo2M4IUkGpk7L7ioq8kjjtJ8Q6iL7Rh/bseq/b0JubVY4w0Hy5JyvIx6H0rokknJW0Sbv6f5nOpNpO+rdrG7b+LYbjStMvxaOF1G6+zKm8ZQ7iMn1+7U8nv8vlcvn91vs7GLZ+ItWlvrSN7slJNZmtmGxeY1AwvT9etFOKahfrFv5iqNpyt0kl8jofEn2iCya+TWpNNgt0Jk2Qo+/wBPvd+w+tZXs+5pa+mxm6dq+qaT4fgutaaa9vb+YJa2wVEcbvuqcAAepJ6VtNLmUI79f1+4zi9HNvTp/XmSy+NY7azne606aG7tZ44Z7berFd/QgjhhUqN3Hl1u7fcNyspc2llckTxhFDHqX9p2E1jLp6LI8bMrl1b7uCOMk8Y9+tK3uprXW3zKT96z7X+RLoniiPVb57Ca1NrciPzkUTJKrJnHVTwfUU3DRvsSp3a8zeqCwoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv/E31NABQAUAFABQAUAFABQAUAFABQAHoaAOauv+Pqb/AH2/nQBLpv8Ax/x/j/I0AfONd5whQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAe2/Bf8A5FC7/wCwg/8A6LjrmrfEdNL4T0GsTUKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/OgCSgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAK2oWn2/Tbmz3+X9ohaPfjO3cCM479aTVxxdncg0nR7bStOgtY44y8cKxPKsYQyYGMn6/WrqPnv2ZEI8phW3gi4thZQf2072djdi5ggNuBjkkgtnJ69frx6Uqmqk1rawpQvdLZu5Nb+DfIuYJvt+7ydRkvceTjO4D5fvdsdf0pRly8vlGwSjzc3m0/uLXiXw9da8bQQ6mLRLaTzNhtxKHbsSCQOOeOetTB8suYqa5o8pDceG9RvrJEvtcM15b3Cz21ytqqeUR2Kg4YVXMk1KK7/cxcraak9P1XUgl8FvdQXDXWpmS8urmKeWfyMLiP7qhc8fXNOM1FxstncUouSkm91b0LWo+FIdTu9TluLk7NQgji2KnMZQ5DZzzz2xUJ2Vl3v+Fi3rJPya+8foXhx9JumuJri1lbyxGogsY4MepJGSSfrj2q3O6M1C1vI3azNAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv8AxN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/32/nQBLpv/AB/x/j/I0AfONd5whQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAe2/Bf/AJFC7/7CD/8AouOuat8R00vhPQaxNQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoARen4n+dAC0AFABQAHpQBJD/qh+P8AOgCSgAoAKAGJNHIGKSKwRirYOcEdQaNlcOtgjkjmjWSJ1dGGVZTkEUNWC9x9ACEgDJOAKAG+dF5oi8xd7LuC55I9fpQA+gAoAjE8JuDbiVDMq7jHuG4D1x6UeYeRBJqunQzmCW+t0lBwUaVQQfpTSb2E2luWBLG0rRB1MigFlB5APQ4/A0hjtwJK5GR1FAC0AFABQAUAFABQAUAFABQAx5UjVmdwoVdzZPQetAb6BHIk0SyxsGRwGVh0INNqzsxJ3V0PpDIZLq3iLiSeNCihm3MBtBOATQtQ2JqACgAoAZLLHBGZJXWNF6sxwBQA+gAoAazKiF2IVVGST0AoAFZXUOpDKwyCOhFDVtATvqh1ABQAUAFABQAUAFABQAUAFADEkjlBMbq21ipwc4I6igAkkSIAyOqAkKCxxkngCgBIZ4rhS0MiuqsVJB6EHBFHS4eRJQAxpY1lWJnUO4JVSeTjrj86AH0AFABQBGJ4jcNbiRTKqhimeQD0P6UeYeQpkQSiIuvmEFgueSB3x+IoAfQAUAFADJZY4ImlmkWONRlmY4AH1oArQ6vptxKsUF/bSSN91ElBJ/CnyvsK6LlIYzzYzMYd6+YF3FM849cUAPoAKACgAoAZFLHNGJInV0PRlOQaAH0AFABQAgYMMqQR6igBaACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv/ABN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/32/nQBLpv/H/H+P8AI0AfONd5whQA5EaRwiKWY9AoyTQBe/sDWBbfaf7NufK/veWfXHSlzIfKyi6NG5R1KspwVYYINMQIjyyLHGjO7HCqoySfQCmBZudK1Gzi8260+6gjzjdLCyj8yKm6HZlSmIKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPbfgv/wAihd/9hB//AEXHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAIvT8T/OgBaACgAoAD0oAkh/1Q/H+dAElABQAUAY+mSxwxaossioY7qRnDHG0HkE+xFKf8Jej/NhH+I/l+SKEK3X9laYkby+WtoGkhgmEco6YbnqBzxkda0qO0pNkQ1irdW/mOkvbm/uESCS6aFbRJUZJUiZic5Zs9eg46Umrcz7ME78qRouZbrwyzXEg81rYl3icYJ29QRxg1NVJXsXSu2rmdbWXm32nwi5uEU6cWLJJhj8y8Z6gfStJfFP5fqZx+CHz/JDReX1zHYWxeeTekpZopFjaQo20fMfbk461O7v5J/eU9Fbza+42NHlnfTg11Irsjsu8OrZAJxkjjOOv0pSasn5BG92jDhuZRdR6y1pOqS3B3Tnbs8lsKv8AFnsp6etVFWtF9V+O/wDwCZO95Lp+S3/VllVvbifWbS3tYZI5pyrSSy4CkxqPu7TmoSvBJ+f5stu1Rtdl+Rb06H7PrVzDuL+XaW67j1ON4zVN8yk/P9ETblcV5fqU74yWd/q13BLIJEt4iMtlVyWBOPbrSjtbz/yKl8V/L/Mu22+01eO1S7luYpoGkYSvvKkEAMD2ByeOnHFNa38rf8MLazvv/VyO633PiFrNr6aCIWiyBIn2kncRnNKPwyfZ/oN7pev6FaxmutSurNJbyZUNvI7GJtnm7ZAFY49RzxVbXdu343JfRX6tfcEdxcfZIdS+2Sm4kuhE1uW+TBfaU29iBznrxSjvFd1+l7hLaT7f5/qRXV1KbG6vjqUsVwlyYhCHAVQHwF2+pHOevPpRDeHnb+vkE38fl/l+paWZ0/tW9nvLkJbSuiIhBCDavQHgnJ78Uvsrz/zKfxvy/wAim93e2n2+DzLhMWDTL50wkdWBxnI6fTOOKb2+aFH4l5pln7PO2ofZDqN5se088kS4O/OODjgc9BxRP3VJrp/wf8hQ15b9f+B/mQyXtxd2MLrLdGaOySaQxyrEikg/MT1PQ8YxRP3XJroOOtov+tbCxNJNcNftNKJm0pZflfA3EHt+v1omuVTS7/5hD3nC/wDWxNbPNqDxxT301usdlFKDG+0uzA7mJ74wOOlOVk5PsxRbaiu6E1C5klG23urmZoLUStJFKkUfOcOT1OcHjkVL0uylraJRvJ3ubS7nkOXk022ZsepYk1oklJpfzL9DO7cU3/KzRuLq6jvJtKWZxLcTo0MmeViPLY+m1h+IqIa28t/0+/YuTtfz29dv+CXtYmkt7eB0kMY+0xB2zj5SwBz7Uo6yS9fyY5aQb/rdGbqt/NG+oiK7MQhe2XcD/q9zfN+lEVdx82/yFN2Tt2/VkOrF7aG+sluZbiE2yynzW3FG3gdfQjt7cVUNWvJoUtE/NS/Is3cs0h1S5a+lt3sTiJFYBQAgYFh/Fknv+FQnaKfn+uxTV5cvT+tSvql9ctFcXMLXUclrCrOBKqRxuV3Yx1bqOCMVVknptexKfMl6XJLuSS8i1SWa9kt/sseEjVsLgxg5I75JI59OKUlaPzaHBtyXon/XobWnH/iW2o/6Yp/IVVT436ip/AvQyNRe4a61V0vJ4hZ2ySxJG2Buwx59enTpUXtG/n/kW1eSXl+rD7RJp7yPJeXLxyWJncsQxV8gZUHgdenSrkrNxXRpffciLuoyfVN/dYqvdXtp9vg8y4TFg0y+dMJHVgcZyOn0zjik9vmhx+Jeaf6Ft5pNMm3yXtzJFJZSSyFiGKsu3lR0H3jx0olvKK8vxuKN7Rl3/wArlX7bf2Et0imckWLTqs8qysGBA3YHA6ngccUO1mvNfiNbp97/APALBmezvrdbbUJbzfbSymN5N+4gDB+h9OnpQ9FPTZfqKOvLru/0YmlT3zXFjM8sjJdKTJ51wjB/lzlFHTB7Dt1qmkm0JNtJlrVpHku0tonut6xGVlilWJQM4yzHn8B+NZbJvsaPou5TsprnVX09JryaNZbEySeS20swYDOe34VrKKTl8vxuQnovV/gOtZ7i+NhaT3csavHKWkjbY0rI+0DI9uTip3u/JP7xvTTza+4ueHjmyuCJfO/0qX95x83zdeKUn7kX5fqwXxS9f0RmMzz2NjfTXsplnvYw0Jb5ARJ90L2Ix9eOapJKUUtdP0FLWMv66/0ybzb25tUVJ3c/a5w0STCOSRQxACk+nHpUraL8v6Y3vJef6CQXB1C9s7cX90kT28mQXCu7K4GCR3HPI64p23fkv1E3ay82hsF45u7OaeZpFgW7UTYBLqpADehOBQnpJ94r8x295R8/0YtpLdtfw2/n3SJeW0jbpplZs4GHAXhevbj8qHF2kuq/zEpaxfR/5FvS7241G6hDMy/ZYSLlR0aUnbg/TaT+Ip6ayWz2/P8AyQaq0Xut/wAl9+47VL6bTLtpdzPHcQFYk6gTD7oH+9n9KhLmvFb/ANJ/doy20rSe3X8/8ypc3V7p4uovtLu8NnDmRudrFiGf+v4VatJ+XMl8rEXkrd7N/MZeNJpl/K9tdS3MkWnSSKJW3sp3Lzn04zj2qb6P1X6lW1j13/JfmAudQsklljaRwbR5Qs9wkhZgAQygdvUDjpTfVeny1JjdtPv+JZV5bO5tli1F51uoHd2mcMq4XIkHoM8enNEl8S7BB35ZPr/kGkTyQXHlXs04kaDzSZJlkicAjLqeqjnpwKbtZ+QK+l+puKwZQykFSMgjoagvcwhcS2tvr1xAMyRzFl4zg+WnNH2I+v8A7cH/AC8fovyJrYvaapawx3st1Hcws8gkfdjGMOPQHOMdKv8AmVtiE9Iu+/8AkVtXuZrPUr2eDiRbGPB4+XMjAnnjgHNTDVNd5L8hy3T8n+gRXNzYG6M8s6QLbGTEkySyq2cbl9j78ZFN6q3mgW6fqVLi7vrNb6AS3EeLPzl82YSOrbgM5HTOemcU0k/vX4iW/wAn+Bo3FvKmoWNkL668uVJWkbzPmYjb37de2KS1cvJL8w1SXm/0Zc0aSV7JlmlaVoppIg7feYKxAz74FJ6pPuhrRtGPpiTW1hp1zHdTfvLkxNEW+TaWbjHr3z1ql0Xl+lxPq/P/ANusSR3Fx9kh1L7ZKbiS6ETW5b5MF9pTb2IHOevFKO8V3X6XuEtpPt/n+oya/vIZ2gE7/wCgTNLOT1eIspAP/AWb/vmiNtG/T57X/C/zHO+qXr8ktvv0NbSmlutOM80j/wCks7pzyqE/KB6cYpNWST3Gndt+f5aGRYK6WGm2i3U0cV1JJ5jh+eM4UHtnHb0NVu16J/kTtf1a/FmtpMsjG7geZp0t5/LjkY5JG0HBPcgkjNTvFP8Arce0mjRpFBQAUAFABQAUAFABQAUANZtqlvSgCAszHJY/gcUxBz/eb/vo0AHP95v++jQAc/3m/wC+jQAc/wB5v++jQAc/3m/76NABz/eb/vo0AHP95v8Avo0AHP8Aeb/vo0AHP95v++jQAc/3m/76NABz/eb/AL6NABz/AHm/76NABz/eb/vo0AHP95v++jQAc/3m/wC+jQAc/wB5v++jQAc/3m/76NABz/eb/vo0AHP95v8Avo0AHP8Aeb/vo0AHP95v++jQAc/3m/76NABz/eb/AL6NABz/AHm/76NABz/eb/vo0AHP95v++jQAc/3m/wC+jQAc/wB5v++jQAc/3m/76NABz/eb/vo0AHP95v8Avo0AHP8Aeb/vo0AHP95v++jQAc/3m/76NABz/eb/AL6NABz/AHm/76NABz/eb/vo0AHP95v++jQAc/3m/wC+jQAc/wB5v++jQAc/3m/76NABz/eb/vo0AHP95v8Avo0AHP8Aeb/vo0AHP95v++jQAc/3m/76NABz/eb/AL6NABz/AHm/76NABz/eb/vo0AHP95v++jQAc/3m/wC+jQAc/wB5v++jQAc/3m/76NABz/eb/vo0AHP95v8Avo0ANeRYxmSXYPVnxUSnGCvJ2KjGUnaKuR/bLf8A5+k/7+//AF6z+sUf5196L9jV/lf3B9st/wDn6T/v7/8AXo+sUf5196D2NX+V/cH2y3/5+0/7+/8A16PrFH+dfeg9jV/lf3B9stv+ftP+/v8A9ej6xR/nX3ofsav8r+4Ptlt/z9p/39/+vR9Yo/zr70HsKv8AK/uYn2y2/wCftP8Av7/9ej6xR/nX3oPYVf5X9zD7bbf8/af9/f8A69H1ij/OvvQewq/yv7mH222/5+4/+/v/ANej6xR/nX3oPYVf5X9zD7bbf8/cf/f3/wCvT+sUf5196D2FX+V/cxyXUEjbUuVZj2WTJ/nTjWpydoyT+ZMqVSKu4tEoLDozfnmtTMmjfeue/Q0hj6ACgAoAr/xN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/AI+pv99v50AS6b/x/wAf4/yNAHzjXecIUAT2Ujw30EkTsjrIpDKcEc+tD2GjrP7b1POPt1x97H+tb+/t9fSs7Iu7OTvZHmvp5JXZ3aRiWY5J59a0WxDJ9E/5Dth/18x/+hCrhv8Af+RMtjqNR1CCwudcFzrJu/tCyxRWSh2CMW4J3DaNvtXMlemlbtqdMnapd/cQLounnxhFZC2BtmsxIU3HBPl5znPrVyk1Gq+234GUUn7Lztf8SAWWnLpWiw/Yo/tGpkpJcs7ZQeZjIGcZ5/SravU5eiSf4X/ElO1Pm66kzWmlTy65appCwHToJDFIJHJypxlsnGe4/HrWd24KV92vxNGkp8luj/Is3Gh6HaP9guJLGMC3BM5mk8/zCud23G3b7elOTb5mum3/AARQirRv13/4BxFWZhQAUAFABQAUAFABQAUAFABQAUAFAHtvwX/5FC7/AOwg/wD6LjrmrfEdNL4T0GsTUKACgAoAKACgAoAKACgAoApaz5h0qYRbi52gBep+YU1uJ7HJ/wBn3v8Az5z/APfpv8K0ujOzL+i291b6tCZIZY0bcDuQgH5TSlaw1e5vavLdwaXPJYoXuAPlAXcevJA78VCtfUt3toY8GpzpBdS22o/bjFAWaGeMRyI/rjA4qrE3LMGu3JsrMNYtLe3SbliV1AKgAls9h7UuXUdxx8RBooDDZSyTSytCYdwBR1HIJ6fjRyhzC3mvSWDKbmwaOMBd7GZcgn+6OrY9aFG4OVhbrXmgmuVgsZbiK0XM0iuAFOM4APWhRByGT+JI4/LWK28x2hWZwZVTYpHAGep9qOUOY0Yr+CbTRfoT5Jj8zpzjGfzqXoKU1GLk9kUtH1+PVp5IRA0TIu4ZbORnH9RUp3OPC46OIk42tY1qo7woAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgBF6fif50ALQAUAFAAelAEkP+qH4/zoAkoAKACgCtPp9ldSiW4s4JZF6O8YYj8TQnbYGr7jrmxtLwKLq1hn2fd8xA2PpmjZ3DyEnsLO6VFuLSCYR/cEkYbb9M07u9xWVrE4VQu0ABQMYxxik9dxrTYhhs7W2x5FtDFtBA2IFwCckce9O7FZCS2NnNAIJbWF4gchGjBUH1x+NIZIsMSQiBIkWIDaECgLj0xQ9dwWmwGCFoPIaJDDt2+WVG3Hpj0o3dwWmiFSKOMsY41QudzFRjccYyfyFAWARRrI0oRRIwAZgOSB0BP4mgBrW1u8wmeCNpQpUOUBYD0z6UANtrK0s932W2hg3/AHvLQLn64p3YrLcrz6RbXWoNdXMcc6mJYxFJGGAIJOefrRF2T8wau0W1ghV1dYkDKuxSFGQvoPbjpSuOxGLGzW6N0LWEXB6yiMbvz6007Kwmr7lG60R7u5d5J4TG7Ak/Zh5u0YO0OD049M+9OL5RSXMaXkQhZF8pNspJkG0Ycng59anyK63IYtMsIVZYrG3RXUqwWJRuB6g8cim22JJIn8mLzPM8pN4XZu2jO30z6UnruNaEEmm2Evl+ZZW7+UNse6JTsHoOOBTu9xWQ9rK0by91rCfKUrHmMfICMYHoMUr7+Y7DZtPsrhI0ns4JViGEV4wQo9vSnd3uKytYWfT7K5dHntIJWQYUvGGKj2zSuO3QU2dqVKG2h2lQhHljBUdB9B6U7sVkRLYk6mb6aQOVQxxKExsBOTk55JwPShOyfmDV2vIsyxRzxtFLGsiMMMrjIP1FIZTudItZbT7PBFFbKXRj5cYAIVt2MDHv+dO+qb/rSwmlZpdSaPTrKGF4YrOBI5Dl0WMAN9R3ouwshZbGzuJknmtYZJU+67xgsv0NCdtgavuJPp1jcy+bPZwSyY273jDHHpk0lpsN67iy6fZTyLJNaQSOgwrPGCQPQUXFZCQ2UcN5JcrjLxpGFAwFVc8D86d9H63CyuvIla3hYyFoYyZV2yZUfOPQ+o5NIfmIbeBvvQxn5NnKj7v936e1D13BabEUWmWEKssVjborqVYLEo3A9QeORTbbEkkTNBC5BaJGIUoCVH3T1H04HFIa0IY9Ns7dW+yW0Ns7KVDxRKCM/h9PyobbVgSSd7FWx0c212lxJLATGpCrBbiIEnGWbk5PHtVc29ieUuQ2FnbzNPDaQxSv950jAY/jSvpYdtbi3FlaXbI1zbQzFPumRA236ZpLQb1VmOjtreIqY4I0KLsXagG1fQe1O7CwyWws5oRBLaQyRKdwRowVB9cfiaQEsUMUCbIYkjXOdqKAM/hTbbEklsQ/2dY+e1x9jg85iCZPLG4kHOc/UChO2wNJ7iy2FnPF5MtpA8e4vsaMEbj1OPX3pDK8ujWk13HJJDE0McJiEBiBUcg5/T0p33+X6/5ia2Xr+JbW2gXy9sEY8tSqYQfKD1A9BxSet79QSsRQ6bZWpL2tpbwSYOGSIDGfpTu7bhZXuJYWP2KOTc4klmkMkrhdoZj6DsMAUN6JILatssSQxTbfNjR9jBl3KDtI6Ee9IYhhiZ2cxIWddrEqMsPQ+3Jo6WDrcjt7Cztebe0gh6j93GF69en0H5U229xWQW9hZ2jM1taQwl/vGOMLn64ou7WCyvcILCztWdre1hhL/eMcYXd9cUr6WHbW4kOnWNusiw2dvGJRhwkQG4eh9abbasFrO5OiLGioihVUYCgYAFJu4JWEWKNC5SNVMhy5AxuOMZPrwKOlg63I7extLQsba1hhL/eMcYXP1xTu7WFZXuPMMTOzmJC7LsZioyV9PpzS6WH5kUOn2VsjxwWkESScOqRgBvr60229GJJJ3Qkel6fCjJHY2yKw2sFiUAj0PFF2FkTmKNpFkMal0BCsRyoPXB/CkMVI0jBEaKgJLEKMZJ5JoAYLaBUSNYIwiNuVQowp9R6GgBgsbNbo3QtYRcHrKIxu/PrTTsrCavuSG3gZpGaGMmVdshKj5x6H1HJpeQ+txyqqIERQqqMAAYAFDdwSsQtp9k0ckTWcBSVtzqYxhm9T6n3o7B5kkMMVvEsUESRRr0RFAA/AU229xJJbElIYUAFABQAUAFABQAUAFAEc3+rP1H86AIqYBQAUAFACEgDJOBQBF9stf+fmL/vsUCE+22n/AD8w/wDfwUWYXQfbbT/n6h/7+CizC6H+dF/z1T/voUhi+bH/AM9F/wC+hTEPoGJketIBN6/3h+dMQz7RB/z2j/76FAD/ADE/vr+dADfPh/56p/30KLMLh58X/PVP++hQAz7baf8AP1D/AN/BRZhdE9AwoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAwtcc/a0XPATIH4mvAzRt1UvL9Wexl6Xs2/MzN1eXY9Cwm6iw7Bup2Cwm6iw7CbqdgsG6iw7CbqdgsG6iw7CbqdgsCuVYMpwQcg01dO6BxTVmdoOlfXHyZLB0b/AHv6CkBLQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8AH1N/vt/OgCXTf+P+P8f5GgD5xrvOEKAHI5jdXXqpBFAGl/bsv/PvF+v1pcpVzNdzI7O3ViSaZI6CaS2njnibbJGwdGxnBByKadgeoXE8t1cSXEzbpZWLu2AMk8npUpJKyG227s04vFWtQQRwx3uFiTy1JiQnbjGMkZIolFSvfqOMnG1uhRkv7ieK1gnkZobXIiVQFKgnJwcfzzVL4uZ+X4Ev4eU6S88VW72F3El5f3bXEPkxx3ESIIwcZLMpy544OKzlFtW87milb7v61MZfEmrLai2F0Noj8oP5a+YE/uh8bsfjVSipbkxk47GXTJCgAoAKACgAoAKACgAoAKACgAoAKAPbfgv/AMihd/8AYQf/ANFx1zVviOml8J6DWJqFABQAUAFABQAUAFABQAUAVdThmuNPmigOJGAxzjvTW4nsc0mhaisil7TcoIJXzFGR6davmRHKzS0vTbq3vo5TbfZ0XdvPmht4OcDHtSbVhpamtfWz3do8MdxJbucFZIzgqR/Me1SnYp6mcuhzTXDz39958hgaFdkQQKD1PU5NPm7Ct3ETQ7mOKzaO/UXNmpRJPJ+VkIxgrn265o5gsPt9BED20huS8kUzzSMU/wBYzDB78frRzByle98MG7lu2F1Gq3LhyzW4aRenAbPTjpTUrCcSrq1rcRXF7HaC+AuoxuSO3DpI2McP/D75ppg0W/8AhH5GWCZJoophbpFKJYBKOB1GSMEUuYfKbEEAhtUgYhwq7SSoAb8BxUMdtLMjtNNs7Bna1gWMv94gk/zpJWMaWHpUruCtcs0zcKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoARen4n+dAC0AFABQAHpQBJD/qh+P8AOgCSgAoAKAGedFtLeYm0NtJ3DAOcY+uaAGm4gE4gM0fnEZEe4bsfSgBftEHn+R50fnYz5e4bseuKAI7q/trIxC4mWPzX2ruOOaEruyB6K5HBqdrPLJF5ipIkrRBXYAuRjOBnkc07Cuv6+8sPcQRypFJNGkj/AHEZgC30HeluPYf0o2ApWGrQahBNNErqIjghhgkYyCPYjpRL3Y8zCPvS5UQ2+trMts8llcQRXRAilfYVJIyAdrEjPuKpxs7dSVK6uXLK7S+thPGrKpZlw3Xgkf0qexXVrsTb03+XuG/GduecetADHureKMySTxoinaWZwAD6ZoAcJYyVAdSXGVGfvD1FACq6uCVYMASDg55FADBcQNOYBNGZVGTGGG4D6UAC3MDTtAs0ZlUZaMMNw/CjzARLq3kkESXETSEZChwSR64oAZc30NpNBHKSPPLANwAuFJJJ/CgHorkn2m3Fv9oM8fk4z5m8bcfXpQ9NwWuwqTwybNkqN5gymGB3D1HrRYV0JJc28SM8k8aKhwzM4AU+hoGSKyuoZSGUjIIPBoAjS5glleKOeN5E+8isCV+o7UdLh1sMku0ivYLQqxedXZSOg24zn86FrfyE3axJHcQTO6RTRu8Zw6qwJU+/pR0uPrYRbmB5XiSaNpE+8isCy/UUm7K4dbEdpfw3lpBcKdgnGUVyAxq3Fp2EmSzXENsm+eZIlzjc7BRn8akZE+oWqXcdo06CWVSyLkcjj/Gmle/kJtK3mTSzRQRmSaVI0HVnYAD8TSGAljOzEi/vPuc/e78etADWuIEBLzRqAcElgMHGcflQA4SRtEJQ6mMjcHB4x65otYFrsUYdbs7jVxp0Dea7QeeJUIZCu7bjIPXNaujJQc3pZ2Mvax51BdS5DdW9wXEE8UpQ4cI4baffHSocZLVo0Uk3ZMRLy2kkkjS5iZ4v9YocEp9R2o5ZJXtoHMr2vqKLm3YRkTxkS8RkOPn+nrS5X2DmVr3Gre2juEW6hZmBIAkBJA6n8KfLK17BzK9ripd20lv9oS4iaEf8tA4K/n0ocZJ2a1BSTV0wW7tmgWdbiIxOcLIHG1j7GhxknZrUSlFq6ehDcatY21lNePcxtDBkOyMGwfTjv7U1Tm5KKWrBzik3fbccup2LWkV0buFIZQNju4UH2570OnNScbaolVIOPPfQjn1ixttQt7GWdVnuATGM8ED37e3rTjSnKLkloglVhFpN7hZ6ks9nJc3CpapHIyEtKrDAOM5BwM+lEoWaS1uOMr3vpZlgXVuY0kFxFskOEbeMMfY96jladrFKSaumOhuIbmPzIJo5UzjcjBhn6ihxcdGgUk9mSUhhQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBHN/qz9R/OgCKmBFdSyQ2sssUfmuiFlTON2O2aTdlcEruxSj1cXEtnHbRCQ3UJmJLY8tQO/HqcVbi02uxCldJ9/6Y231K8k1X7DLaQjYm6V4pi3l+gOVHJ9KWlmxttNInGo2V0rpb3cMrKMlUkBIGaVnuO6vYwvsd1/z7S/8AfBpgR/Yrr/n2m/79mrujOzE+xXf/AD6zf9+zRdBZmpuHqKxNSTI9RVkGp5kf99fzpFEP2mD/AJ7x/wDfYpWKuhuR6irMzG3p/eH50hmr5b/3G/KkMp+XJ/cb8q0ICsyzL+xXf/PrN/37NaXRnZnX1mahQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBz2vHF8v/XMfzNeDmS/fL0/Vnt5d/Cfr/kZm6vNsehY2NKsoLvTpt6DzWcojHsduRXpYehCpQd17zbS+6552JrTp1VZ6dfvCOwiTRJZZY/35UuCeqjOBSlQhHC832tH97/yCVeTxCjF6FaTStto88dwJDGoZgEIXHs3es6mE5YOcXe3l+Xc2jirzUJRtfz/AEHTaQsQmVbtHlhTzDHsI+XHrV1MGoqVpXcdxQxblytx0btcauk+ZamWO4Duse8qEO3Hpu6ZpPCWpualeyv/AEyniuWfK42V7b/oOj0UM8cL3iJO6b/L2E4H19atYJX5ebW17WJljGk5KN4rS4230WSeCNzLseUZjXYSCPcjgUo4JyinfV67fqOpjIwk0ldLfX9OpmMCjlWGGU4Irisdys1dDd1Ow7HcjoK+rPkCWDo3+9/QUgJaACgAoAr/AMTfU0AFABQAUAFABQAUAFABQAUAFAAehoA5q6/4+pv99v50AS6b/wAf8f4/yNAHzjXecIUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHtvwX/wCRQu/+wg//AKLjrmrfEdNL4T0GsTUKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/ADoAkoAKACgDm5BNHa3Nj9luWla/EoKwsVKGVW3bunT8aqH2PL/gkS05vP8AyHPE0OsEwW0kpkuld45rQkDpl1lHAAHY59OKIbL5/qOfV+n6fcVkspvPMEwmE/2zzA0dnkn58hvNzjGOOuccYoh9ny/p/eKa1l5/0vuNjWYgy2kphaVYbhWcLGXIXBHQAk9R0pR0mvn+RUtYv5fmjOk08tYapJ9jJna83xt5fzkArgjv6/rVRdnH1/X/ACJkrqXp/wC2/wCZFqFnK15qCTrKftLDyjHZmUsu0AAP0Ugg9SPWpjsu9/1HLe/Sxs6p9pGktDbh3nlAiDBc7d3BY46YGTQ0pSt0HFuMb9UUYbK9sL5d3lywz2xhPkQsoQoPlJyx7ZGfpSm+aMl31CC5ZRfbT+v66jtI0mY6fp7Xt1O4gRHW3ZFQIwXjPGTj3NaTfvNoiCfLZ/1qT6NILWyt7WdXjmlkmKIykE4dj+HFRul6L9C9m35sTXWezSHVIkLvbMVZR1ZW4x+e0/hSV72XXT/L+vMbta76a/5/gVfsQ0+TT2uoXuIY4nEhSIybZmIJbaATz8wzjiqurtLyS+X9IjVpN97v5/5EdrFLZT2d29rOtsJLjbGkRZokcgrlQMgcHtxmmnbR72X5/wCQNdV3/S35mnoqyCzlaSJ4me4lcLIuDguSKlr3UvIa3b/rZFHTI4YVt7afTpmvY5WZ5fJIAbnL7+hB+pPPSnfROPb9Nge7v3/UqQpcSX9k/wBleKRLotLHHZlFjBDZJkP3s+oOOacLK3a36Cn19f13J7PTzFpumuLQpOt5uc+XhgCzZJ74xihPVen6f5jkrqXr/wC3f5Ghqdt9p1LTN0HmxpK7PlcqvyHBP44qY7v0/VDlrG3mv1M6WGS2SSMWgEP292DG2aXyxsBDKg9TkZ6DNC1t6P8AP/IGvit5fkv1GWlvcw6e92kE7S2t80saGHY0kZADYXHcEnHqKbdrejX4v/gEpX5vv/Bf8FBLYXMC2E8oOCJJJyLczbJXwc7Rz6jPajRNx8rf5/eGrV/O/wDl9xq6LA1vphVVk5d2RJI/Lxk9AueB7e9Kd+X5FQ3fqZGnxztqemyfZni2F/ORLJokiyp43H73PfOKpW19P8iXd+t/8zS1a3uZ9Qtzbqwb7NcKJAOFYhduT2rNbT9F+ZfWPr+jKltCJJdPSyspbWW3jYTO0JQKNmNuSPm+bB4z0zVz15mtmv8AhvuIjooprVP/AIf7xlpb5TTIIrKWG7tnzcSNCVAG0hvnxhtx9CfWiet2trP/AICsKzSs97/rv9wvh61urFrY3kEknmw7Y3MZBt8dUI7A9c9zwe1XJp3Xp89P0HbW/m/z3+Zc1kv9stwYR5exv3wtTOytx8oA+7kdyO1ZLdlPZFLSLeSA6U9xaygrDLGSYSSjFxtzgfLwDz0q76v0X5akW0Xq/wBTQ1NAupWdzPA89tGrghIzJsc4w20AnoCOnGamO7Llql6lCGCW2+yXf2WZbdLyV1iWIlo42UgfKOQM84xxmmuifb9b/kJ6p27r8rP8QW2ku54nls5fKbU2kKyxH7vl8MQegzjrRHRr0f5ilqn6r8kWfFtnc3fhq4t7JCz/ACny04LKCMgfhW2GlGNaMp7EV4ylRlGG7Rzv9nzXWqXcmkaRcabHLpbRpvh8oGTcOPYkcfrXY5qNO1SSl7ye99DkjC9ROnHl0a7a/wBdf8h+n2E897ZHS9Ln0x4LGSK5lkh8oO5XCj/aO7nNKrNKM+eXMm1ZXv119NNBUYPmppRs1e7t5fjqP0exiMFraDw9cQ38UEqS3boY1VipGS38ec++KK8370lNcrtp/wADoVh4qLipQfMnv+t+pFpiXzJ4es30q9iNhO3nSSQkIOuMHuPfpVVXC9SaktVoZ01NU4U3F3UtfvZDaaA5sdMaXS5POOqHzy0B3eUSfvcfd+vFVKuud2lpy9+v+Y5Um03y68/4dfkOvNHvks76K2s5Utk1bzTCsG4NHgcqnAYA9qmnWheDk9eVq9+vm+nqVVpStNQWl4v1XWwyXSLptDu/Igu5FnvYmEX2LyBx95lQEkDpzgdKqNWPtIczWifW/wB7M5U5eyqON9bdLdeiL2oaEVutegs9N2wS2SGJEiwjSDP3e276VlCv7kHKWql87f5HRKilUkox0cX6X6fMrXUEtxb6fBFojwwrZlQzacZHEmcMu08LnruI71SklKcnPW/e2n/A7IyinyU48vrpfXTp592Fhp00B8NXV7pU8vlJLHN/o5ZkOT5e4YyAOoJ6VU6icqsYyte1tfvIhTap0pSjezlfTW3QbDpt5Hp1rJdadcTWsOpyyXFt5RLOp+620/eA5pe0jz6S15Uk+zLlCVp6ac97d1+ojaTdTwqY9NnisZ9YjkjtjEQUjwQzFf4VNONWKkryu1F6+fRX6kzptxk4Rsm1Zem7sbmlW50fWdceOwmS0LQmJIYTtbjDbR0PJ5xXJVnz0qd3d6/n1OqEOStNpWVkdLXIdQUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUARzf6s/UfzoAipgFIDL0/RRp0tzJHPuaUFYsp/qVyTjrzyad3y8v9dhWXNzf15iaZpV5p7ndqEcyO5eXNvh5Ce5bcf5VV1a1ibO97l+6UtbMFBJ44H1qCyamAlABQBifZ5/+eMn/fJoJH+RN/zyf/vk1dyLMteXJ/cb8qg0Mr7Lcf8APCX/AL4NUSa3lv8A3G/KkMxPsd1/z7S/98GmI6mpLKuxv7p/KmSUPIm/55P/AN8mmI2aksKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgDnPEBxfp/1zH8zXh5iv3q9P1Z7mW/wn6/ojK3V51j0rFy21NrW08lE+bzhIH3enbFdNOs4Riktnf8AC1jnqYZVJ8zfSxPNrrStcHyABKioq7shQOfTnrWksS5c2m9vlZ3MoYJRUfe2v8x1xryzRTqLdwZ02nMpIX6DFXUxSnGStv5kwwLi4vm28vzK76tuurqfycfaITHt3fd4Az056VLxN3N2+I2WFtCEL/C7lg+IFKH/AEd9zReWR5p2DjqFxVzxXOpK26tvt6IxWBd/i6321+8u215bZivLh7UyJDgyCY7+nTZjrXUqkNakrXt0f6HNUpVNacE7N7W0+8zYdbVLaKOWGRmhXapSYoCPcCuVYn3UmtUrbs7J4NublF7+V/uMtnLMWPUnNcVjvSsrDd1Ow7HejoK+oPjSWDo3+9/QUgJaACgAoAr/AMTfU0AFABQAUAFABQAUAFABQAUAFAAehoA5q6/4+pv99v50AS6b/wAf8f4/yNAHzjXecIUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHtvwX/wCRQu/+wg//AKLjrmrfEdNL4T0GsTUKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/ADoAkoAKACgAoAKACgAoAKACgAoAKACgBhhjaZZioLoCqt6A4z/IUAMntILl4mmQuYm3KNxxn1I6H8aFo7g9VYmoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAjm/1R+o/nQBFTAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAMDX7OeW4SaKNnXZtO0ZI5P+NeVjqM5yUoq57GX16cIOEnbUyPsl1/z7Tf8Afs15/sKv8r+49P29H+dfeg+yXf8Az7Tf9+zT9hV/lf3B7ej/ADr70J9ku/8An1m/79mj2FX+V/cHt6P86+9B9ju/+fWb/v2afsKn8r+4ft6P86+9CfY7v/n1m/79mj2FT+V/cH1ij/OvvQn2O7/59Zv+/Zo9hU/lf3D+sUf5196D7Hd/8+s3/fs0/YVP5X9wfWKP86+9CfY7v/n1m/79mj2FT+V/cP6xR/nX3oPsd3/z6zf9+zT9jU/lf3B9Yo/zr70Ph068mlWMW8i5PVkIA/Oqjh6knazIniqEIt8yfzO2HSvfPlCWD7rf739KQEtABQAUAV/4m+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/wAfU3++386AJdN/4/4/x/kaAPnPMf8Adb/vr/61d5whmP8Aut/31/8AWoAMx/3W/wC+v/rUAGY/7rf99f8A1qADMf8Adb/vr/61ABmP+63/AH1/9agAzH/db/vr/wCtQAZj/ut/31/9agAzH/db/vr/AOtQAZj/ALrf99f/AFqADMf91v8Avr/61ABmP+63/fX/ANagAzH/AHW/76/+tQAZj/ut/wB9f/WoAMx/3W/76/8ArUAGY/7rf99f/WoAMx/3W/76/wDrUAGY/wC63/fX/wBagAzH/db/AL6/+tQAZj/ut/31/wDWoAMx/wB1v++v/rUAGY/7rf8AfX/1qADMf91v++v/AK1ABmP+63/fX/1qAPbPgxj/AIRC7wCB/aD9f+ucdc1b4jppfCegViahQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAi9PxP8AOgBaACgAoAD0oAkh/wBUPx/nQBJQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACEAjB6GgCEwsD8pBHvQAeVJ/s/n/9agA8qT/Z/P8A+tQAeVJ/s/n/APWoAPKk/wBn8/8A61AB5Un+z+f/ANagA8qT/Z/P/wCtQAeVJ/s/n/8AWoAPKk/2fz/+tQAeVJ/s/n/9agA8qT/Z/P8A+tQAeVJ/s/n/APWoAPKk/wBn8/8A61AB5Un+z+f/ANagA8qT/Z/P/wCtQAeVJ/s/n/8AWoAPKk/2fz/+tQAeVJ/s/n/9agA8qT/Z/P8A+tQAeVJ/s/n/APWoAPKk/wBn8/8A61AB5Un+z+f/ANagA8qT/Z/P/wCtQAeVJ/s/n/8AWoAPKk/2fz/+tQAeVJ/s/n/9agA8qT/Z/P8A+tQAeVJ/s/n/APWoAPKk/wBn8/8A61AB5Un+z+f/ANagA8qT/Z/P/wCtQAeVJ/s/n/8AWoAPKk/2fz/+tQAeVJ/s/n/9agA8qT/Z/P8A+tQAeVJ/s/n/APWoAPKk/wBn8/8A61AB5Un+z+f/ANagA8qT/Z/P/wCtQAeVJ/s/n/8AWoAPKk/2fz/+tQAeVJ/s/n/9agA8qT/Z/P8A+tQAeVJ/s/n/APWoAPKk/wBn8/8A61AB5Un+z+f/ANagA8qT/Z/P/wCtQAeVJ/s/n/8AWoAPKk/2fz/+tQAeVJ/s/n/9agA8qT/Z/P8A+tQAeVJ/s/n/APWoAPKk/wBn8/8A61AB5Un+z+f/ANagA8qT/Z/P/wCtQAeVJ/s/n/8AWoAPKf0X8/8A61ACeS/ov5//AFqADyX9F/P/AOtQAeS/ov5//WoAPJf0X8//AK1AB5L+i/n/APWoAPJf0X8//rUAHkv6L+f/ANagA8l/Rfz/APrUAHkv6L+f/wBagA8l/Rfz/wDrUAKInPUqP1oAmVQq4FAC0AFABQBX/ib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/H1N/vt/OgCXTf+P8Aj/H+RoA+ca7zhCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA9t+C//IoXf/YQf/0XHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAFABQBBfXQsrR7goXCY4BxnJA/rTSuJuxOSBjJxnpSGRi4ha4NuJAZVXcV9BQAXFxDaQPPPII40GWY9qNwKtvrVjcl1SVkaNPMYSxsh2/3uRyKdmK6LkciTRLLGwZHGVYdCKQxslxDDJHHJIqtKdqAn7x9qAEguBcByI5E2OU/eIVzjuM9R70ALLcQwvGksio0rbUBP3j6CgBIbgTPKojkXym2kuhUN7j1HvQBLQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACL0/E/zoAWgAoAKAA9KAJIf9UPx/nQBJQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBX/ib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/H1N/vt/OgCXTf8Aj/j/AB/kaAPnGu84QoAsWdheajMYbG0nupAu4pDGXYD1wO1HS4El7pGp6aivf6ddWqucKZ4WQMfbIpKUW7XK5WlexCtndPaPdrbStbxsFeYISik9AW6A0NpWv1ElchpiCgCa0s7q/nEFnbTXMpBIjhQuxH0FHmF9bE1zo+qWckUd1pt3A8zbY1lgZS59ACOTSUk3ZMbTSuyvcW89pO8FzDJDKhw0cilWU+4PShNNXQNNbjVjdlZ1Riq/eIHA+tMRcl0XU4NKj1SWzljs5W2pMwwGPt+RpOSTt1KUXJNrZFGmSFABQAUAFABQAUAFABQAUAFABQB7b8F/+RQu/wDsIP8A+i465q3xHTS+E9BrE1CgAoAKACgAoAKACgAoAKAM/Xv+QNP/AMB/9CFOO4pbDZ9LkvZZJbi4IIP7jyzxH6H3NO9hWuWrOzjs4iqku7HLyN1c0m7jSsQa4LdtImF1HM8PG7yRll56/h1ojuD2MH7Qb77VZpcrqkP2RmEwi2vER0UsOuavbUjchEtidL021QRmNoyzvNO6xhwBkEDkt6DinrdhpZDEEU9ho1zfuzRrO8byM7DC84BOaOrsHRXLE+JNNmEl0sS/2lIMSlvLcf3WZegpdQ6EEotLi006eeJo7eK8aNnMzMm3HVW4O3PSnrqHYnuZG3XQkkkFkdSC3DKxGE2jqRyBmkgJrgWJ0WVLG9ljtRcqAZS5iPqoYchPfNGt9R6W0NDw1KklnMkcWxI5SoKSmSNuP4CecVMhxNipKCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/OgCSgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv/ABN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/32/nQBLpv/H/H+P8AI0AfONd5whQB2Xw0ZE1fU2kmkgRdMmLSx/eQZXJHuKVT+DL1X6mtC7rRsr6mjY2mjeJfEunWI17VNXtlEks0V47fwrwFz698elZq8VKbjsv1FJp8sLvV/o3/AMD5lm2On674JuobXTBpUU2qwQOiOWHLKM89Dg8/SolF+0pXd9W//JWU2kqllay/XqOm0rw9JqHiDSovDwhbSrF3iuTK5LEKMFgT17j6GlzSdJ1L9bfi/wDI0hCPto02v6/pky+F/DFktnpt4thie0Ektw9zILkuQTuRQNu0Y9fX050qSbc7aW2/4JlTS5Yyet9f+GOc+Gq7PGuxZB8sEwDg8dOtVN3oye2n6ozkksRBLVcz/Jm0uq2ltp1lo9x4g/t6+n1SCVJAWcQKGXPzN9D+dRbmnFpWsW3ywld3uXr/AEayk1/VL7UNNsHSa/WKOe+u3QONoyqIoyW9/wDCs6HwRj3cvX4mVV+KUuyW+2yIli0vw3beMLGPS0uLa0eB9kkjfOr4IQn0U5IPvWjblSg33a/4P9djSEUqsktPdf5fqT3kOneJNR8N6TcWCw28lgt1iOVshArfuh7dOevFOScJ1JPVx/Ehtezgv5m16W1/HYxINM0TX9Ii1WHR1017fVIbZ4lkZlmjZlBBz3+btReUZQ1vzf1oTLlcZpK1v61NCLS/Dlz44vtFXQYo4LC2ldmErEyn5CPpjJxWHtX7GVXtf8Ga8sfaKnbdr8v6+4ito/DEsGgXr+GYQdZla1aMTsViAbbuHqTkc+1dThJ1HTv0v+FzNJez57bNL7zg9ds4tP16/s4M+VBcPGmTk4DECppScoJsVaChNpFCtDIKACgAoA14dFGpwxSaUxduFuIpGAMR/vZ/u+/apvbcq19inqMVnBciGymeZUUB5T0du5UelNX6idipTEFAHtvwX/5FC7/7CD/+i465q3xHTS+E9BrE1CgAoAKACgAoAKAMu88TaLYXDW9zqESSrwyjLEfXArN1YRdmzupZfiqseeEG0Qf8Jl4e/wCgmn/fDf4UvbU+5p/ZWN/59/l/mH/CZeHv+gmn/fDf4Ue2p9w/srG/8+/y/wAxsvi7w3NG0cmoxsjDBBRuf0o9vT7h/ZON/wCff5f5lH+1fBf/AD9R/nJT+sQ7i/sjGf8APv8AFf5ktvrvhG1mEsF4iOOAf3h/nR9Yg+of2RjP+ff4r/Mt/wDCZeHv+gmn/fDf4UvbU+4/7Kxv/Pv8v8wHjHw6OmpR/wDfDf4Ue2p9w/srG/8APv8AL/MP+Ey8O/8AQSj/AO+G/wAKPb0+4f2Vjf8An3+X+Yf8Jl4e/wCgnH/3w3+FHtqfcP7Kxv8Az7/L/MP+Ey8PHrqUf/fDf4Ue2p9w/srG/wDPv8v8w/4TLw9/0Eo/++G/wo9tT7h/ZWN/59/l/mH/AAmXh7/oJx/98N/hR7an3D+ysb/z7/L/ADD/AITLw7jH9pR/98N/hR7an3D+ysb/AM+/y/zD/hMvDw/5iUf/AHw3+FHtqfcP7Kxv/Pv8v8w/4TLw9/0E0/74b/Cj21PuH9lY3/n3+X+Yf8Jl4e/6Caf98N/hR7an3D+ysb/z7/L/ADD/AITLw9/0E0/74b/Cj21PuH9lY3/n3+X+Yf8ACZeHv+gmn/fDf4Ue2p9w/srG/wDPv8v8w/4TLw9/0E0/74b/AAo9tT7h/ZWN/wCff5f5h/wmXh7/AKCaf98N/hR7an3D+ysb/wA+/wAv8w/4TLw9/wBBNP8Avhv8KPbU+4f2Vjf+ff5f5h/wmXh7/oJp/wB8N/hR7an3D+ysb/z7/L/MP+Ey8Pf9BNP++G/wo9tT7h/ZWN/59/l/mH/CZeHv+gmn/fDf4Ue2p9w/srG/8+/y/wAw/wCEy8Pf9BNP++G/wo9tT7h/ZWN/59/l/mH/AAmXh7/oJp/3w3+FHtqfcP7Kxv8Az7/L/MP+Ey8Pf9BNP++G/wAKPbU+4f2Vjf8An3+X+Yf8Jl4e/wCgmn/fDf4Ue2p9w/srG/8APv8AL/MP+Ey8Pf8AQTT/AL4b/Cj21PuH9lY3/n3+X+Yf8Jl4e/6Caf8AfDf4Ue2p9w/srG/8+/y/zD/hMvD3/QTT/vhv8KPbU+4f2Vjf+ff5f5jo/F/h+WQIupxZY4G4Mo/MjFCrU31FLK8ZFXdN/gbIIIyORWp5wi9PxP8AOgBaACgAoAKAJICDHjuDQBJQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACUAV1OST6nNAC0AFABQAUAFABQAUAFABQAUAB6GgDmrr/AI+pv99v50AS6b/x/wAf4/yNAHzjXecIUAX9I1vUdCumutNuPImdDGzbFfKkgkYYEdhQ9VyvYadndF658aeIbu4tribUP3tq5eFkhjQqSMH7qjPHY1KhFO69BubasxdQ8aa5q0Btr6832zurvFHGkfIOcghcg+9JU4KSfYJTk4tdzqLzx/Yf2TeRRX+qXslzam3jguoo1EWRgszrgsfT/wCvWcqbellvua06vI0+35nMWvjfxDZ6ctjBf7Y408uNjGpdF9AxGQK1nBTd5GUZOOxmabqt7o959rsJ/Jn2ld+0NweDwQRTaTi4vZk/aUuq1K9vPLa3MVxC22WJw6NgHDA5B5phubsfjrxHH5/+nKxnk81meFDtfAG5ePlOB2qFTikkun66svnd2+5DD4x16DULu/S+BnvVC3BaFCJMDAyuMcfSnyR5eXoLnfNzdSs3iHVmurK6+2Ms1hGsVs6qqmNR0HA56nrmq6uXV7g5NxUXstS1qPjLXdUa3NzeDFtKJo1SJVUSDoxAHJ+tQoRTuhucnHlZBH4m1iLVrjVUvMXl0hSWXy0+ZTjIxjA6DoKXsocjhbR3/EOeXMpdSJNd1KOGwhS5wmnSGW1Gxf3bE7ienPI75rW/vc3W1vlsLmfLy9Nyrd3U19dy3dy++aZy8jYAyxOScDipjFRVkEpOTuyGmSFABQAUAOV3TOx2XcMHBxkelADaACgAoA9t+C//ACKF3/2EH/8ARcdc1b4jppfCeg1iahQAUAFABQAUAFAHhN0zPdzOxJZpGJJ7nNeO9z9QppKCS7Gqvg/xAyhl02QgjI+df8a09jU7HC81wadnP8/8hf8AhDfEP/QMk/77X/Gj2NTsL+1cF/z8/P8AyD/hDfEP/QMk/wC+1/xo9jU7B/auC/5+fn/kH/CG+If+gZJ/32v+NHsanYP7VwX/AD8/P/IP+EN8Q/8AQMk/77X/ABo9jU7B/auC/wCfn5/5B/whviH/AKBkn/fa/wCNHsanYP7VwX/Pz8/8g/4Q3xD/ANAyT/vtf8aPY1Owf2rgv+fn5/5B/wAIb4h/6Bkn/fa/40exqdg/tXBf8/Pz/wAg/wCEN8Q/9AyT/vtf8aPY1Owf2rgv+fn5/wCQf8Ib4h/6Bkn/AH2v+NHsanYP7VwX/Pz8/wDIP+EN8Q/9AyT/AL7X/Gj2NTsH9q4L/n5+f+Qf8Ib4h/6Bkn/fa/40exqdg/tXBf8APz8/8g/4Q3xD/wBAyT/vtf8AGj2NTsH9q4L/AJ+fn/kH/CG+If8AoGSf99r/AI0exqdg/tXBf8/Pz/yD/hDfEP8A0DJP++1/xo9jU7B/auC/5+fn/kH/AAhviH/oGSf99r/jR7Gp2D+1cF/z8/P/ACD/AIQ3xD/0DJP++1/xo9jU7B/auC/5+fn/AJB/whviH/oGSf8Afa/40exqdg/tXBf8/Pz/AMg/4Q3xD/0DJP8Avtf8aPY1Owf2rgv+fn5/5B/whviH/oGSf99r/jR7Gp2D+1cF/wA/Pz/yD/hDfEP/AEDJP++1/wAaPY1Owf2rgv8An5+f+Qf8Ib4h/wCgZJ/32v8AjR7Gp2D+1cF/z8/P/IP+EN8Q/wDQMk/77X/Gj2NTsH9q4L/n5+f+Qf8ACG+If+gZJ/32v+NHsanYP7VwX/Pz8/8AIP8AhDfEP/QMk/77X/Gj2NTsH9q4L/n5+f8AkH/CG+If+gZJ/wB9r/jR7Gp2D+1cF/z8/P8AyD/hDfEP/QMk/wC+1/xo9jU7B/auC/5+fn/kH/CG+If+gZJ/32v+NHsanYP7VwX/AD8/P/IP+EN8Q/8AQMk/77X/ABo9jU7B/auC/wCfn5/5B/whviH/AKBkn/fa/wCNHsanYP7VwX/Pz8/8g/4Q3xD/ANAyT/vtf8aPY1Owf2rgv+fn5/5GRPBLa3ElvOhSWJirqexHWs2mnZnfCcakVOLumey+G2ZvDenFmLH7OnJ+lepS+BH53j0liqlu7NFen4n+daHGLQAUAFABQA0hg25Dg0AL5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAPNn/2PyP+NAB5s/8Asfkf8aADzZ/9j8j/AI0AHmz/AOx+R/xoAPNn/wBj8j/jQAebP/sfkf8AGgA82f8A2PyP+NAB5s/+x+R/xoAQmSThyMegFADgMCgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/AB9Tf77fzoAl03/j/j/H+RoA+ca7zhCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA9t+C/wDyKF3/ANhB/wD0XHXNW+I6aXwnoNYmoUAFABQAUAFABQB4Rcf8fEn++f51473P1CHwo90thugiH+wP5V662PzKfxMshFHYUyBdq+g/KgA2r6D8qADavoPyoANq+g/KgA2r6D8qADavoPyoANq+g/KgA2r6D8qADavoPyoANq+g/KgA2r6D8qADavoPyoANq+g/KgA2r6D8qADavoPyoANq+g/KgA2r6D8qADavoPyoANq+g/KgA2r6D8qADavoPyoANq+g/KgA2r6D8qADavoPyoANq+g/KgA2r6D8qADavoPyoANq+goAiddp46GgDxXxL/yMuo/9fD/zryqvxs/Rsv8A90p+iPVfDX/Itad/17p/KvRpfAj4bMP97qerNJen4n+daHELQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/wB9v50AS6b/AMf8f4/yNAHzn5beq/8AfQrvOEPLb1X/AL6FAB5beq/99CgA8tvVf++hQAeW3qv/AH0KADy29V/76FAB5beq/wDfQoAPLb1X/voUAHlt6r/30KADy29V/wC+hQAeW3qv/fQoAPLb1X/voUAHlt6r/wB9CgA8tvVf++hQAeW3qv8A30KADy29V/76FAB5beq/99CgA8tvVf8AvoUAHlt6r/30KADy29V/76FAB5beq/8AfQoAPLb1X/voUAHlt6r/AN9CgA8tvVf++hQB7Z8GBjwhdjj/AJCD9D/0zjrmrfEdNL4T0CsTUKACgAoAKACgAoA8IuP+PiT/AHz/ADrx3ufqEPhR7rZ/6qL/AK5j+leutj8yn8TLVMgKAI5poreMyzSpEi9WdgAPxNADba7tryPzLW4inTON0Thhn6ii1gvcmoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAjl+6PrQB4n4l/5GXUf+vh/wCdeVV+Nn6Nl/8AulP0R6r4a/5FrTv+vdP5V6NL4EfDZh/vdT1ZpL0/E/zrQ4haACgAoAKACgBcH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoAMH+6fyoATp1BFABQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/AI+pv99v50AS6b/x/wAf4/yNAHzjXecIUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHtvwX/5FC7/AOwg/wD6LjrmrfEdNL4T0GsTUKACgAoAKACgAoA8IuP+PiT/AHz/ADrx3ufqEPhR7rZ/6qL/AK5j+leutj8yn8TLVMgKAPKfirqTTaxbaelwrRQRb3jU/dkJPX324x9fet6S0uYVHrYTwDeI/jCGPS7aW3tmtCLlGkLhmA+/7fNj8/eia93UIP3tD1C9u4rCynvJ22xQRtI59ABk1ilc3bscj4K17V7rUHs9cm3yXtql/aDYF2RsSCnA5x8vX1q5xVtDODd9TBtfFeqDTYL9fFCXWoNfeSdIMcJLp5hXGFAcfLzmrcVe1ieZ2vc7TwzqV3f3uux3U3mLa6i8MI2gbECqQOBz1PWs5JKxpF3ub9QUFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBHL90fWgDxPxL/AMjLqP8A18P/ADryqvxs/Rsv/wB0p+iPVfDX/Itad/17p/KvRpfAj4bMP97qerNJen4n+daHELQAUAFABQBJEPl3dzQBJQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACEBhg0AQDuPQ4oAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/x9Tf77fzoAl03/j/AI/x/kaAPnGu84QoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPbfgv/yKF3/2EH/9Fx1zVviOml8J6DWJqFABQAUAFABQAUAeEXH/AB8Sf75/nXjvc/UIfCj3Wz/1UX/XMf0r11sfmU/iZapkGV4ludQtPD13NpUTS3iqBEqJvblgCQO5AJP4VUbX1Jle2hxXhL4fG9U6p4iSUtK25IHZlcnLBjICM88EYP1rSVS2iM4wvqzu9K0PTNEiaPTrOO3DfeIyWb6sck1k5N7mqSWxF4j0d9f0WbTBdG2ScqJHCbiUBBK9RjIGM04uzuEldWM5fA+l2er6fqWjxQ6bJaO3mCKLInRlwVPIx655p87asyeRXui34b8NW3h6wEA8qecSSObjyQjEMxbHc8Zx1pSldjjGxLo2i/2RcanN9o87+0LtrnGzb5eQBt6nPTrxQ3ewJWuatSUFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBHL90fWgDxPxL/yMuo/9fD/AM68qr8bP0bL/wDdKfoj1Xw1/wAi1p3/AF7p/KvRpfAj4bMP97qerNJen4n+daHELQAUAFAAelAEkP8Aqh+P86AOe8e39zp/hp3tZWieWVYy6nBAOScH8KwrycYaHr5NRhVxSU1dJNnkpuZycmaQn/eNeddn3Ps4dg+0T/8APaT/AL6NF2HJHsH2if8A57Sf99Gi7Dkj2D7RP/z2k/76NF2HJHsH2if/AJ7Sf99Gi7Dkj2D7RP8A89pP++jRdhyR7B9on/57Sf8AfRouw5I9g+0T/wDPaT/vo0XYckewfaJ/+e0n/fRouw5I9g+0T/8APaT/AL6NF2HJHsH2if8A57Sf99Gi7Dkj2D7RP/z2k/76NF2HJHsH2if/AJ7Sf99Gi7Dkj2D7RP8A89pP++jRdhyR7B9on/57Sf8AfRouw5I9g+0T/wDPaT/vo0XYckewfaJ/+e0n/fRouw5I9g+0T/8APaT/AL6NF2HJHsH2if8A57Sf99Gi7Dkj2D7RP/z2k/76NF2HJHsH2if/AJ7Sf99Gi7Dkj2D7RP8A89pP++jRdhyR7B9on/57Sf8AfRouw5I9g+0T/wDPaT/vo0XYckewfaJ/+e0n/fRouw5I9g+0T/8APaT/AL6NF2HJHsH2if8A57Sf99Gi7Dkj2D7RP/z2k/76NF2HJHsH2if/AJ7Sf99Gi7Dkj2D7RP8A89pP++jRdhyR7B9on/57Sf8AfRouw5I9g+0T/wDPaT/vo0XYckewfaJ/+e0n/fRouw5I9g+0T/8APaT/AL6NF2HJHsH2if8A57Sf99Gi7Dkj2D7RP/z2k/76NF2HJHsH2if/AJ7Sf99Gi7Dkj2D7RP8A89pP++jRdhyR7B9on/57Sf8AfRouw5I9g+0T/wDPaT/vo0XYckewfaJ/+e0n/fRouw5I9g+0T/8APaT/AL6NF2HJHsH2if8A57Sf99Gi7Dkj2D7RP/z2k/76NF2HJHsH2if/AJ7Sf99Gi7Dkj2D7RP8A89pP++jRdhyR7B9on/57Sf8AfRouw5I9g+0T/wDPaT/vo0XYckewfaJ/+e0n/fRouw5I9g+0T/8APaT/AL6NF2HJHsH2if8A57Sf99Gi7Dkj2D7RP/z2k/76NF2HJHsH2if/AJ7Sf99Gi7Dkj2D7RP8A89pP++jRdhyR7B9on/57Sf8AfRouw5I9g+0T/wDPaT/vo0XYckewfaJ/+e0n/fRouw5I9g+0T/8APaT/AL6NF2HJHsH2if8A57Sf99Gi7Dkj2D7RP/z2k/76NF2HJHsH2if/AJ7Sf99Gi7Dkj2D7RP8A89pP++jRdhyR7B9on/57Sf8AfRouw5I9g+0T/wDPaT/vo0XYckewfaJ/+e0n/fRouw5I9g+0T/8APaT/AL6NF2HJHsH2if8A57Sf99Gi7Dkj2D7RP/z2k/76NF2HJHsH2if/AJ7Sf99Gi7Dkj2D7RP8A89pP++jRdhyR7B9on/57Sf8AfRouw5I9g+0T/wDPaT/vo0XYckewfaJ/+e0n/fRouw5I9g+0T/8APaT/AL6NF2HJHsH2if8A57Sf99Gi7Dkj2D7RP/z2k/76NF2HJHsH2if/AJ7Sf99Gi7Dkj2D7RP8A89pP++jRdhyR7B9on/57Sf8AfRouw5I9g+0T/wDPaT/vo0XYckewfaJ/+e0n/fRouw5I9g+0T/8APaT/AL6NF2HJHsH2if8A57Sf99Gi7Dkj2D7RP/z2k/76NF2HJHsH2if/AJ7Sf99Gi7Dkj2D7RP8A89pP++jRdhyR7B9on/57Sf8AfRouw5I9g+0T/wDPaT/vo0XYckewfaJ/+e0n/fRouw5I9g+0T/8APaT/AL6NF2HJHsH2if8A57Sf99Gi7Dkj2D7RP/z2k/76NF2HJHsH2if/AJ7Sf99Gi7Dkj2D7RP8A89pP++jRdhyR7B9on/57Sf8AfRouw5I9g+0T/wDPaT/vo0XYckewfaJ/+e0n/fRouw5I9gFzcKQRPICOhDmi7D2cH0R7F4LvrjUfC9rPdOZJRuQuTksAxAJ98V6VGTlBNnwOa0YUcXKMFZafkbtbHmhQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAV/4m+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/x9Tf77fzoAl03/AI/4/wAf5GgD5xrvOEKAOq+H2k6Xq+tXMerwedbQ2jzEb2XBBXnKkHoTTkv3ba3ul95UFeaRuaF4Dsv+Ex1W21WAyadZsqxLvZd5kYeXyCCcD3rGE26V+u33b/15lygva2W1r/5fj+Riv4LNxdajdG9tNL02G+ktoXunb5iGICjqTgdz/jTjJ8seraE43lK2yGw+ANQNzqUF3eWln/ZvlmWSVzsKvnDA46YFP2i5FLu2vut/mHs3e3lcv6T4NlsfEDWtwlhqUM2nPcwSl28tl4+YEDORn9azqVLQmno1+BUYe/B7psbrHgSBI9Fi0i9iuLu/RQU3n94SCTIvHCACrjJuo10S+7/h+hPKvZqXX+v6ZRuvAl1EiS2up2V9ELpLWZoHJ8l2YKNwI6ZPaiNRNrs9hShyp66rc1NL8EjT/EbWFzPpmpzCCYvbmRv3WAME4HB5yBUSq3pya7b/ADLVO043fXb5Mo2fw8uru3sJP7WsIZNQgEtvDK5DucZxjHb1rRzs2ktiIxuk29yrY+B724sWu7u+s9OUztbxLcyEGWQEggYB7gjNHOny21vr8g5bXvokZmv6LN4f1ibTJ5UlkhCksmcHIB7/AFohNTV0OcHC1+pm1ZmFABQAUAFABQAUAT3NnPaCMzR7VlQOjAghgfQii9x2C6sriyaNbmMxtIgdVJGcHpkdvxoTuFrEFAgoA9t+C/8AyKF3/wBhB/8A0XHXNW+I6aXwnoNYmoUAFABQAUAFABQB4Rcf8fEn++f51473P1CHwo91s/8AVRf9cx/SvXWx+ZT+JlqmQFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAEcvQfWgDxPxL/yMuo/9fD/AM68qr8bP0bL/wDdKfoj1Xw1/wAi1p3/AF7p/KvRpfAj4bMP97qerNJen4n+daHELQAUAFAAelAEkP8Aqh+P86AOW+JX/IsL/wBfKfyaubE/Ae7kP+9v0f6HKfDhEfxMwdQw+zvwRnutc+G+M9rPW1hdO6/U9T+zwf8APGP/AL5FehZHxfPLuH2eD/njH/3yKLIOeXcPs8H/ADxj/wC+RRZBzy7h9ng/54x/98iiyDnl3D7PB/zxj/75FFkHPLuH2eD/AJ4x/wDfIosg55dw+zwf88Y/++RRZBzy7h9ng/54x/8AfIosg55dw+zwf88Y/wDvkUWQc8u4fZ4P+eMf/fIosg55dw+zwf8APGP/AL5FFkHPLuH2eD/njH/3yKLIOeXcPs8H/PGP/vkUWQc8u4fZ4P8AnjH/AN8iiyDnl3D7PB/zxj/75FFkHPLuH2eD/njH/wB8iiyDnl3D7PB/zxj/AO+RRZBzy7h9ng/54x/98iiyDnl3D7PB/wA8Y/8AvkUWQc8u4fZ4P+eMf/fIosg55dw+zwf88Y/++RRZBzy7h9ng/wCeMf8A3yKLIOeXcPs8H/PGP/vkUWQc8u4fZ4P+eMf/AHyKLIOeXcPs8H/PGP8A75FFkHPLuH2eD/njH/3yKLIOeXcPs8H/ADxj/wC+RRZBzy7h9ng/54x/98iiyDnl3D7PB/zxj/75FFkHPLuH2eD/AJ4x/wDfIosg55dw+zwf88Y/++RRZBzy7h9ng/54x/8AfIosg55dw+zwf88Y/wDvkUWQc8u4fZ4P+eMf/fIosg55dw+zwf8APGP/AL5FFkHPLuH2eD/njH/3yKLIOeXcPs8H/PGP/vkUWQc8u4fZ4P8AnjH/AN8iiyDnl3D7PB/zxj/75FFkHPLuH2eD/njH/wB8iiyDnl3D7PB/zxj/AO+RRZBzy7h9ng/54x/98iiyDnl3D7PB/wA8Y/8AvkUWQc8u4fZ4P+eMf/fIosg55dw+zwf88Y/++RRZBzy7h9ng/wCeMf8A3yKLIOeXcPs8H/PGP/vkUWQc8u4fZ4P+eMf/AHyKLIOeXcPs8H/PGP8A75FFkHPLuH2eD/njH/3yKLIOeXcPs8H/ADxj/wC+RRZBzy7h9ng/54x/98iiyDnl3D7PB/zxj/75FFkHPLuH2eD/AJ4x/wDfIosg55dw+zwf88Y/++RRZBzy7h9ng/54x/8AfIosg55dw+zwf88Y/wDvkUWQc8u4fZ4P+eMf/fIosg55dw+zwf8APGP/AL5FFkHPLuH2eD/njH/3yKLIOeXcPs8H/PGP/vkUWQc8u4fZ4P8AnjH/AN8iiyDnl3D7PB/zxj/75FFkHPLuH2eD/njH/wB8iiyDnl3D7PB/zxj/AO+RRZBzy7h9ng/54x/98iiyDnl3D7PB/wA8Y/8AvkUWQc8u4fZ4P+eMf/fIosg55dw+zwf88Y/++RRZBzy7h9ng/wCeMf8A3yKLIOeXcPs8H/PGP/vkUWQc8u4fZ4P+eMf/AHyKLIOeXcPs8H/PGP8A75FFkHPLuH2eD/njH/3yKLIOeXcPs8H/ADxj/wC+RRZBzy7h9ng/54x/98iiyDnl3D7PB/zxj/75FFkHPLuH2eD/AJ4x/wDfIosg55dw+zwf88Y/++RRZBzy7h9ng/54x/8AfIosg55dw+zwf88Y/wDvkUWQc8u4fZ4P+eMf/fIosg55dw+zwf8APGP/AL5FFkHPLuH2eD/njH/3yKLIOeXcPs8H/PGP/vkUWQc8u4fZ4P8AnjH/AN8iiyDnl3D7PB/zxj/75FFkHPLuH2eD/njH/wB8iiyDnl3D7PB/zxj/AO+RRZBzy7h9ng/54x/98iiyDnl3D7PB/wA8Y/8AvkUWQc8u4fZ4P+eMf/fIosg55dw+zwf88Y/++RRZBzy7h9ng/wCeMf8A3yKLIOeXcPs8H/PGP/vkUWQc8u4fZ4P+eMf/AHyKLIOeXc8k8fIieLrkIoUbI+AMfwivOxH8Rn3WTNvBxv5/md38Pv8AkULb/fk/9CNdeH/ho+Zzr/fZfL8jpa3PICgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAr/xN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/wB9v50AS6b/AMf8f4/yNAHzjXecIUAbfhjWrbRZtQe5SVxdWEtsnlgHDNjBOSOOKU1zU3Bd0a0ZqFWM3smdL/wsa3ez0WKSC4822mjkv5Aq/vhGMLt559eccip5F7Vz6a/e1Yzv+65eun3J3+8qHxPoOsWF1puspfRW/wDaEl5bSW6qWwxJ2sCevzHp/Skocqi1ulb1L5k3JPZu/oLq3jmz1O31+P7NPH9vjgitRgHasZJ+c56nPbNL2b5V35m39yX6GsasYy8uVr8/8yaw8c6XayaczwXZFppLWT7UXlzt5Hzfd4+vtWdWjKaqW+0kiITUeS/Rt/eR2/jTTLYeHr1YLo3ukx/Z5IyF8t4ypBIOc5544rbl9+XaSSfy/wCCQpfu0nundff/AJCr4p8PaPZva6NFfyLd3sVzcNcBQY0Rw2xQDyeO/r1qVGXup7R/EqU05Tmt5f8AB/zIrPxlp1v491DXnhuTbXUToiBV3gkAcjdjt61EaUlRlT6u/wCLuNzTqxn0VvysM/4S/T/tvhebybnbo0QS4G1csRj7vzc9O+K0jBqrKfdW/P8AzMZ+9TjFdHf8U/0Nyw8vxboW2fSL+5t4NSllt2tJYsnexbbICcqPm60RTpzpyvZpW8tLf5f1c15ufnXRu/n/AF/XQ5n4jTRT+OL9onV1XYpKnIBCAEfgamh8N/Nl138K7I5itjnCgAoAKACgAoAKANLTtalsIjE0MVzGp3xLMMiJ/wC8P8KTVyk7FGeeW6neeeRpJHOWZjyTTJI6ACgD234L/wDIoXf/AGEH/wDRcdc1b4jppfCeg1iahQAUAFABQAUAFAHhFx/x8Sf75/nXjvc/UIfCj3ODP2eIjqEH8q9dbH5lP4mT+f6oc+1MgPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xv0oAPPH9xqAGEljk8egoA8X8S/8AIy6j/wBfD/zryqvxs/Rsv/3Sn6I9V8Nf8i1p3/Xun8q9Gl8CPhsw/wB7qerNJen4n+daHELQAUAFAAelAEkP+qH4/wA6AOW+JX/IsL/18p/Jq5sT8B7uQ/72/R/oct8Nf+Rnb/r2f+a1hhvjPaz7/dF6r9T1avQPiAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPIPiB/wAjfc/7kf8A6CK83EfxGfeZL/uUfn+Z3Xw+/wCRQtv9+T/0I114f+Gj5rOv99l8vyOlrc8gKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv/E31NABQAUAFABQAUAFABQAUAFABQAHoaAOauv+Pqb/AH2/nQBLpv8Ax/x/j/I0AfONd5whQAUAFABQAUAFABQAUAFABQA+OWWLPlyOmRg7WIyKHroHmMoAKACgAoAKACgAoAKACgAoAKACgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFAHhupWs1lqM9vcRlJEkIII9+v0ryJJptM/TcPUjVpRnB3TRCJ5QABK4A6AMaV2ackewv2ib/ns/8A30aLsXJHsH2ib/ns/wD30aLsOSPYPtE3/PZ/++jRdhyR7B9om/57P/30aLsOSPYPtE3/AD2f/vo0XYckewfaJv8Ans//AH0aLsOSPYPtE3/PZ/8Avo0XYckewfaJv+ez/wDfRouw5I9g+0Tf89n/AO+jRdhyR7B9om/57P8A99Gi7Dkj2D7RN/z2f/vo0XYckewfaJv+ez/99Gi7Dkj2D7RN/wA9n/76NF2HJHsH2ib/AJ7P/wB9Gi7Dkj2D7RN/z2f/AL6NF2HJHsH2ib/ns/8A30aLsOSPYPtE3/PZ/wDvo0XYckewfaJv+ez/APfRouw5I9g+0Tf89n/76NF2HJHsH2ib/ns//fRouw5I9g+0Tf8APZ/++jRdhyR7B9om/wCez/8AfRouw5I9g+0Tf89n/wC+jRdhyR7B9om/57P/AN9Gi7Dkj2D7RN/z2f8A76NF2HJHsH2ib/ns/wD30aLsOSPYPtE3/PZ/++jRdhyR7B9om/57P/30aLsOSPYPtE3/AD2f/vo0XYckewfaJv8Ans//AH0aLsOSPYYA8jgAF3Y8AckmkVdRXke2aFbyWuhWMEy7ZI4EDKexx0r1qaagkz83xk41MROUdm2XV6fif51Zyi0AFABQAHpQBJD/AKofj/OgDlviV/yLC/8AXyn8mrmxPwHu5D/vb9H+hy3w1/5Gdv8Ar2f+a1hhvjPaz7/dF6r9T1avQPiDiPHE+p6lqlvoOi3txaXEdrLfTPbyFGO0ERqSOxbqKqD5eao9o2+bv/kKWvLDrJ/cv+HJdX1+XUvhTPrdnO8E8loG3xMVZHBAYAjkYORTrx5J2W119za/QmhJyhruk/vSZmanHN4bt9H1Gw8Q6ncXlxPDGbK6vDOs6vjcAp6Eeo6Vtp7f2dtLv5LuY6+w9pfWyfq+xvaBd3M3jXxPby3EskMD2/lRs5Kx5jydo6DJ9KyS/cRfW8jZv97byRS8U+Ik8P8AjHTZ7y9lhsFsp3kiVztkYY2jb0LelTT/AOXml3ZW+8Kn/Lvpq7/cT+HJ7y5tZ/F+tXzxW80Jkgs45iYbeEDOSBwzkckkcdPYVUSpR5d31/yX9a/mqbdWXMtF0/zf9afkQeNrr/RLy+8P3FnpN7IqQXjTozDd9wvGOVB9cmn7L3uRv3u36eonU93nS91df19C/Z+KYZrbWZbuD7K+jyus6F92VC7lccDhh0rKWlNTXX89rGsdajh2t9z6l/RNQl1bRrTUJrU2rXMYk8kvuKg8jnA7YNXUhyScexFOfPHmL9QWFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHkHxA/5G+5/wByP/0EV5uI/iM+8yX/AHKPz/M7r4ff8ihbf78n/oRrrw/8NHzWdf77L5fkdLW55AUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/wCP8f5GgD5xrvOEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFADWjjf76K2PUZosNSa2Y0wQAZMUf/AHyKVkVzy7ieREekEf4gUWQuefcPIj/54Rfl/wDWosg559w8iP8A54Rfl/8AWosg559w8iP/AJ4Rfl/9aiyDnn3DyI/+eEX5f/Wosg559w8iP/nhF+X/ANaiyDnn3DyI/wDnhF+X/wBaiyDnn3DyI/8AnhF+X/1qLIOefcPIj/54Rfl/9aiyDnn3DyI/+eEX5f8A1qLIOefcPIj/AOeEX5f/AFqLIOefcPIj/wCeEX5f/Wosg559w8iP/nhF+X/1qLIOefcPIj/54Rfl/wDWosg559w8iP8A54Rfl/8AWosg559w8iP/AJ4Rfl/9aiyDnn3DyI/+eEX5f/Wosg559w8iP/nhF+X/ANaiyDnn3DyI/wDnhF+X/wBaiyDnn3DyI/8AnhF+X/1qLIOefcPIj/54Rfl/9aiyDnn3DyI/+eEX5f8A1qLIOefcPIj/AOeEX5f/AFqLIOefcPIj/wCeEX5f/Wosg559w8iP/nhF+X/1qLIOefcPIj/54Rfl/wDWosg559w8iP8A54Rfl/8AWosg559w8iP/AJ4Rfl/9aiyDnn3DyI/+eEX5D/CiyDnn3FEEB/5Yp/3yKLIOeXccsMSHKxop9QoosgcpPdjqZIi9PxP86AFoAKACgAPSgCSH/VD8f50Act8Sv+RYX/r5T+TVzYn4D3ch/wB7fo/0OW+Gv/Izt/17P/Naww3xntZ9/ui9V+p6tXoHxBxNt4OutW17VtZ1ee/0+WafyrZbS72EwKAFJKk9euKuLUaaXV6v9PuREk5VG+i0X6/eyn/wiusWXhbxL4ctbeSe2lbfpzvMhMgbBZTk8YI6nGc0TlzwhfdP8E7oIx5Zyts1+NrHT6N4V0XSlguINItILtIwDIsS7gcc4P59KupUbk+V6E04WhHmWv6kGiaXe2fi3xFfTw7Le9aAwPuB37Uw3AORg+tQmvYqPW7/ABKaftebpZEeraDLqPjrR9Rks0nsrS3lDu5UhHONvyk5P5UU2lz36pL8dfwConLkt0bb+7T8SjB4Yv7Mav4chQnQdRgka2l3rmzdgcptJyVzyMDj9aTfPTs/ija3mv8Agf12Gly1LrZ7+X/D/mZOmeEpYxYWc/gm1SeF1W4vnvMxFV/jVQ27JxkAgYNb+0Tnzp262MHTtDlav0/4cm8Y6VNP4ytbC0cCLxDGsd6oOCEhYMW/FcrWdC12ntG0vzVvm7Gte/KnHd3j9+t/lr8j0JVVFCKAFUYAHYVm227stJJWQ6kMKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPIPiB/yN9z/uR/+givNxH8Rn3mS/7lH5/md18Pv+RQtv8Afk/9CNdeH/ho+azr/fZfL8jpa3PICgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAr/xN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/AI+pv99v50AS6b/x/wAf4/yNAHzn5jei/wDfIrvOEPMb0X/vkUAHmN6L/wB8igA8xvRf++RQAeY3ov8A3yKADzG9F/75FAB5jei/98igA8xvRf8AvkUAHmN6L/3yKADzG9F/75FAB5jei/8AfIoAPMb0X/vkUAHmN6L/AN8igA8xvRf++RQAeY3ov/fIoAPMb0X/AL5FAB5jei/98igA8xvRf++RQAeY3ov/AHyKADzG9F/75FAB5jei/wDfIoAPMb0X/vkUAHmN6L/3yKADzG9F/wC+RQB7Z8GDnwhdnj/kIP0H/TOOuat8R00vhPQKxNQoAKACgAoAKACgAoARuq/WgBaACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgBP4x9KAFoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/OgDlviV/wAiwv8A18p/Jq5sT8B7uQ/72/R/oct8Nf8AkZ2/69n/AJrWGG+M9rPv90Xqv1PVq9A+ICgAoAKACgAoAKACgDPtdC0uy1S51S3so0vbr/WznJZvbJ6DgcD0pqTUeVbCaTlzPc0KQwoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPIPiB/yN9z/uR/+givNxH8Rn3mS/7lH5/md18Pv+RQtv8Afk/9CNdeH/ho+azr/fZfL8jpa3PICgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAr/xN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/AI+pv99v50AS6b/x/wAf4/yNAHzjXecIUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHtvwX/5FC7/AOwg/wD6LjrmrfEdNL4T0GsTUKACgAoAKACgAoAKAEbqv1/pQAtABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAjMFUsc4AzxQBg6Fda1d6jNNdrIunurGESIqsDuGM4GemauSSWhEW7m/UFiH74+h/pQAtABQAi9PxP86AFoAKACgAPSgCSH/VD8f50Act8Sv8AkWF/6+U/k1c2J+A93If97fo/0OW+Gv8AyM7f9ez/AM1rDDfGe1n3+6L1X6nq1egfEBQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAeQfED/kb7n/cj/wDQRXm4j+Iz7zJf9yj8/wAzuvh9/wAihbf78n/oRrrw/wDDR81nX++y+X5HS1ueQFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBX/ib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/H1N/vt/OgCXTf8Aj/j/AB/kaAPnGu84QoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPbfgv/AMihd/8AYQf/ANFx1zVviOml8J6DWJqFABQAUAFABQAUAFACN1X6/wBKAFoAKAKCMF8QThiButkIBPXDNn+Yp9BdShHdXMdlE1ux8omZ2ZFV2xvODtJGV55xz0qrak3Hz6rOJllt5DLCHjRsRBU+bHUlt2cEEYH1pWHcP7Quy9vP9oj2TXRhMGwZABI69c8c/WiyC7H6Zf39zNBJLGRDcKxw2wBcdNuGLH0OR+VDSBNjtXsbSW6spJLaJ3kuArsyAlhtbg/lQmwaIZ2ns7i+ltZEjjt1iPlbMhhjp7celPcNhzXFynmrbKFBuZN/lKpfAA5AJGeevekBJqri78NM/mbxKqfMqlc5Yc47ULRg9jOu55rqG2t3Y77KVPPPq28Kv5jJ/KqQmaEV9dM8M5lRo5rhofICcqASM5654yamyHcgF3fvZxu90P8ASYJD8sYBjKjIINOyFdiD7YriSO7/AHiWCyFnQHcck4NGgam5BIZreOUjBdA2PqKgsfQAUAFABQAUAFABQAUAFABQBz1paa1L4ieW/eVbKF5Gt9kigHJ4DAHJ49attW0ISd9ToagsKAEP3x9D/SgBaACgBF6fif50ALQAUAFAAelAEkP+qH4/zoA5b4lf8iwv/Xyn8mrmxPwHu5D/AL2/R/oct8Nf+Rnb/r2f+a1hhvjPaz7/AHReq/U9Wr0D4ggaViflOB6+tACb3/vn8hTAN7/3z+QoAN7/AN8/kKADe/8AfP5CgA3v/fP5CgA3v/fP5CgA3v8A3z+QoAN7/wB8/kKADe/98/kKADe/98/kKADe/wDfP5CgA3v/AHz+QoAN7/3z+QoAN7/3z+QoAN7/AN8/kKADe/8AfP5CgA3v/fP5CgA3v/fP5CgA3v8A3z+QoAN7/wB8/kKADe/98/kKADe/98/kKADe/wDfP5CgA3v/AHz+QoAN7/3z+QoAN7/3z+QoAN7/AN8/kKADe/8AfP5CgA3v/fP5CgA3v/fP5CgA3v8A3z+QoAN7/wB8/kKADe/98/kKADe/98/kKADe/wDfP5CgA3v/AHz+QoAN7/3z+QoAN7/3z+QoAN7/AN8/kKADe/8AfP5CgA3v/fP5CgA3v/fP5CgA3v8A3z+QoAN7/wB8/kKADe/98/kKADe/98/kKADe/wDfP5CgA3v/AHz+QoAN7/3z+QoAN7/3z+QoAN7/AN8/kKADe/8AfP5CgA3v/fP5CgA3v/fP5CgA3v8A3z+QoAN7/wB8/kKADe/98/kKADe/98/kKADe/wDfP5CgA3v/AHz+QoAN7/3z+QoAN7/3z+QoAN7/AN8/kKADe/8AfP5CgA3v/fP5CgA3v/fP5CgA3v8A3z+QoAN7/wB8/kKADe/98/kKADe/98/kKADe/wDfP5CgA3v/AHz+QoAN7/3z+QoAN7/3z+QoAN7/AN8/kKADe/8AfP5CgA3v/fP5CgA3v/fP5CgA3v8A3z+QoAN7/wB8/kKADe/98/kKADe/98/kKAGTXBggkmkkISNSzHA6AZNJuyuVCLnJRW7PPZvidqJlbyLSFY8/KHyTj3xiuF4p9EfWw4epcvvTd/KxH/ws3Vv+fW2/I/40vrUuxX+r9D+d/h/kH/CzdW/59bb8j/jR9al2D/V+h/O/w/yD/hZurf8APrbfkf8AGj61LsH+r9D+d/h/kOj+J2piQGS0t2TPIXIP5801ipdhS4eo292bv8j0CyvRfWUN3C7eXMgdcgZAIrti1JXR8nWpSpVJU5bp2J97/wB8/kKozDe/98/kKADe/wDfP5CgB8chJ2t17GkBLQB5B8QP+Rvuf9yP/wBBFebiP4jPvMl/3KPz/M7r4ff8ihbf78n/AKEa68P/AA0fNZ1/vsvl+R0tbnkBQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAV/wCJvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/4/x/kaAPnGu84QoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPbfgv/wAihd/9hB//AEXHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAI3Vfr/SgBaACgCG4s7W7Ci5t4pgvTzEDY/OndoLBNY2lwqJNawyLH9wPGCF+npRdishGsLN5hM9pC0gxhzGCeOnNF2FkVjpCtfi6klDbX3gCJQxPYFgMkCnfQLalqOztYZmmitoklf7zqgDH6mldhYkaNHKl0Vih3LkZwfUUhiNBE+/dEjeZ9/Kj5vr60ARy2NpOu2a1hkXduw0YIz6/WndisiRoYmi8po0MYwNhUY46cUhiG3gJYmGMlyGbKj5iOhP0oAatnarcG5W3iEzdZAg3H8ad2Fh4ghUIBEgCAhQFHyg9celIBsdpbRLtjt4kXbtwqADHp9OTRcLEqqFUKoAAGAB2oAKACgAoAKACgAoAKACgAoAKACgAoAKAEP3x9D/SgBaACgBF6fif50ALQAUAFAAelAEkP+qH4/wA6AOW+JX/IsL/18p/Jq5sT8B7uQ/72/R/oct8Nf+Rnb/r2f+a1hhvjPaz7/dF6r9T1avQPiCqv3R9KYhaBhQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFPV/wDkDX3/AF7yf+gmon8LN8L/AB4eq/M8XsoFur+3t2JCyyqhI6gE4ryYq7SP0etN06cpromz0L/hWumf8/t1/wCO/wCFd31WPc+S/wBYK/8AIvx/zD/hWumf8/t1/wCO/wCFH1WPcP8AWCv/ACL8f8w/4Vrpn/P7df8Ajv8AhR9Vj3D/AFgr/wAi/H/M4LVbNdP1W6s0YusErIrN1IBrinHlk0fV4aq61GNR9UmeueGv+Ra07/r3T+VepS+BHwGYf73U9WadaHEFABQAqf6xPr/SgCxSA8g+IH/I33P+5H/6CK83EfxGfeZL/uUfn+Z3Xw+/5FC2/wB+T/0I114f+Gj5rOv99l8vyOlrc8gKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv/E31NABQAUAFABQAUAFABQAUAFABQAHoaAOauv8Aj6m/32/nQBLpv/H/AB/j/I0AfONd5whQB6L8HfDthrGrXt9fQpOLBY/LjcZXcxb5iO+Nv61jVk0rI1pRTd2e4ABQAAAB0ArmOkWgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA87+LvhzT7jwxNrawJHeWjJmVFAMiswXa3r94H8K2pSd7GVWKtc8NrpOYKAPbfgv/yKF3/2EH/9Fx1zVviOml8J6DWJqFABQAUAFABQAUAFACN1X6/0oAWgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAQ/fH0P9KAFoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/ADoA5b4lf8iwv/Xyn8mrmxPwHu5D/vb9H+hy3w1/5Gdv+vZ/5rWGG+M9rPv90Xqv1PVq9A+IKq/dH0piFoGFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAU9X/AOQNff8AXvJ/6Caifws3wv8AHh6r8zxzSP8AkM2X/XxH/wChCvKh8SP0TFfwJ+j/ACPb69g/NAoAKAPGPEn/ACMuo/8AXw/868mr8bP0bL/90p+iPVPDX/Itad/17p/KvSpfAj4bMP8Ae6nqzTrQ4goAKAFT/WJ9f6GgCxSA8g+IH/I33P8AuR/+givNxH8Rn3mS/wC5R+f5ndfD7/kULb/fk/8AQjXXh/4aPms6/wB9l8vyOlrc8gKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv/ABN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/32/nQBLpv/H/H+P8AI0AfONd5whQB638Cv+Y7/wBu/wD7UrCt0N6PU9brnNwoAKACgAoAKACgBsciSxrJG6ujDIZTkH8aACSRIo2kkdURAWZmOAAOpNAbjLa6t7yBZ7WeOeJvuyRsGU9uoptNbiTT2BrmBbhLZpkEzqWWMsNzAdSB6UlqN6BJcwQyxRSzIkkxIjVmALkDJAHfihag9NSWgAoAKACgAoAKAOR+Kf8AyTnVP+2P/o5K0p/EiKnws+d66zkCgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFABQAjdV+v9KAFoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEP3x9D/SgBaACgBF6fif50ALQAUAFAAelAEkP+qH4/wA6AOW+JX/IsL/18p/Jq5sT8B7uQ/72/R/oct8Nf+Rnb/r2f+a1hhvjPaz7/dF6r9T1avQPiCqv3R9KYhaBhQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBi654ns9FkitvLkur2Yjy7WEZcj19v61UYtkuSRRi8Ztb3UUGt6RPpYnOElZw8efQkAYp8nZk8/dG5qxzot6R/z7yf8AoJrGfws68L/Hh6r8zxzSP+QzZf8AXxH/AOhCvKh8SP0TFfwJ+j/I9rnuIbWBp7iVIYkGWd2CgfUmvYPzM4bxN8QbnTNRjh0uO0uLdog/mvubdkkcYI9PetY07rUzlOz0Ok8L+IE8R6SLwReVIjmOVM5AYAHg+mCKiUeV2LjK6PMfEn/Iy6j/ANfD/wA68er8bP0jL/8AdKfoj1Tw1/yLWnf9e6fyr0qXwI+GzD/e6nqypceJLiW6mt9F0mXU/s7FJpRKsUasOqhj94j0rbl7s8/m7ITTfFttqOqppZtJ4Lza5ljkA/dlccZ7555FDjZXBSu7G/Ulip/rE+v9DQBYpAeQfED/AJG+5/3I/wD0EV5uI/iM+8yX/co/P8zuvh9/yKFt/vyf+hGuvD/w0fNZ1/vsvl+R0tbnkBQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAV/4m+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/wAfU3++386AJdN/4/4/x/kaAPnGu84QoA9b+BX/ADHf+3f/ANqVhW6G9Hqet1zm4UAFABQAUAFAGZq0usR4Gm2trMhU72nmZCD7AA5qlbqJ36GP4Il1c6JpySWtqth5PEomJk74+XGOvvVTtdkwvYseN7qRNEWwgR3n1GVbdUj5YqeWxn2BH41EEpVIp7bv0RUnywbW+y9WYVvqtzomm+ILO2tZrN4V+12cUyruRHOGOASMA5NW/ejG762fzehMVyzato1f5pajmc2HiGCW11WXVZI9KnmQyushDYBHIHQ46UN2VSytovz/AEFH3nSu92/yG2jeZqfhe4fWZb+W6Z5ZI5HVhGxj52gDKjPGParso1JRS0Sf9fMltypqTe7X9fI9ArA2CgAoAKACgAoA5H4p/wDJOdU/7Y/+jkrSn8SIqfCz53rrOQKAPbfgv/yKF3/2EH/9Fx1zVviOml8J6DWJqFABQAUAFABQAUAFACN1X6/0oAWgAoAozXrWl9Ks7/uDAZU46FfvD9QadroV9SvFqE9sgN2ZJJTAj+WoUDczEADjr0HWnYVxja1JbXNyLyMRBfLWONnUDc27nd6cd/Sjl7Bcmi1pbmNBbQ+dMzsuxZAVG3GTu6Y5H50WC4PrcYWHbCd8u75ZJFTBU4KgngtntRyhc0wcgHGPY1JQUAFABQAUAFABQBV1KWa3s2uIT/qiHcYzuQH5h+WaaEyrc30pmnaKVlggEakoASzsw7kHsR+dNITYh1+D7YbdVVv3hiH71dxcf7PXGeM0cocwf2/BjIib/j384c9T/c+vIo5Q5iePU/N1BrQQjchw2ZFDDjOdvUr2zStpcd9S9SGFABQAUAFABQAUAFABQAUAIfvj6H+lAC0AFACL0/E/zoAWgAoAKAA9KAJIf9UPx/nQBy3xK/5Fhf8Ar5T+TVzYn4D3ch/3t+j/AEOW+Gv/ACM7f9ez/wA1rDDfGe1n3+6L1X6nq1egfEFVfuj6UxC0DCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAw20a/PicakL7/AEbH+ryc4xjbjpjPNVBqMWmRNNtNA2jX58TjUhff6Nj/AFeTnGMbcdMZ5og1GLTCabaaBtGvz4nGpC+/0bH+ryc4xjbjpjPNEGoxaYTTbTQNo1+fE41IX3+jY/1eTnGMbcdMZ5og1GLTCabaaBtGvz4nGpC+/wBGx/q8nOMY246YzzRBqMWmE0200DaNfnxONSF9/o2P9Xk5xjG3HTGeaINRi0wmm2mgbRr8+JxqQvv9Gx/q8nOMY246YzzRBqMWmE0200DaNfnxONSF9/o2P9Xk5xjG3HTGeaINRi0wmm2mgbRr8+JxqQvv9Gx/q8nOMY246YzzRBqMWmE0200DaNfnxONSF9/o2P8AV5OcYxtx0xnmiDUYtMJptpoG0a/PicakL7/Rsf6vJzjGNuOmM80QajFphNNtNA2jX58TjUhff6Nj/V5OcYxtx0xnmiDUYtMJptpoG0a/PicakL7/AEbH+ryc4xjbjpjPNEGoxaYTTbTQNo1+fE41IX3+jY/1eTnGMbcdMZ5og1GLTCabaaBtGvz4nGpC+/0bH+ryc4xjbjpjPNEGoxaYTTbTQNo1+fE41IX3+jY/1eTnGMbcdMZ5og1GLTCabaaBtGvz4nGpC+/0bH+ryc4xjbjpjPNEGoxaYTTbTQNo1+fE41IX3+jY/wBXk5xjG3HTGeaINRi0wmm2mgbRr8+JxqQvv9Gx/q8nOMY246YzzRBqMWmE0200DaNfnxONSF9/o2P9Xk5xjG3HTGeaINRi0wmm2mgbRr8+JxqQvv8ARsf6vJzjGNuOmM80QajFphNNtNA2jX58TjUhff6Nj/V5OcYxtx0xnmiDUYtMJptpoG0a/PicakL7/Rsf6vJzjGNuOmM80QajFphNNtNA2jX58TjUhff6Nj/V5OcYxtx0xnmiDUYtMJptpoG0a/PicakL7/Rsf6vJzjGNuOmM80QajFphNNtNA2jX58TjUhff6Nj/AFeTnGMbcdMZ5og1GLTCabaaBtGvz4nGpC+/0bH+ryc4xjbjpjPNEGoxaYTTbTQNo1+fE41IX3+jY/1eTnGMbcdMZ5og1GLTCabaaBtGvz4nGpC+/wBGx/q8nOMY246YzzRBqMWmE0200DaNfnxONSF9/o2P9Xk5xjG3HTGeaINRi0wmm2mgbRr8+JxqQvv9Gx/q8nOMY246YzzRBqMWmE0200DaNfnxONSF9/o2P9Xk5xjG3HTGeaINRi0wmm2mgbRr8+JxqQvv9Gx/q8nOMY246YzzRBqMWmE0200DaNfnxONSF9/o2P8AV5OcYxtx0xnmiDUYtMJptpoG0a/PicakL7/Rsf6vJzjGNuOmM80QajFphNNtNA2jX58TjUhff6Nj/V5OcYxtx0xnmiDUYtMJptpoG0a/PicakL7/AEbH+ryc4xjbjpjPNEGoxaYTTbTQNo1+fE41IX3+jY/1eTnGMbcdMZ5og1GLTCabaaBtGvz4nGpC+/0bH+ryc4xjbjpjPNEGoxaYTTbTQNo1+fE41IX3+jY/1eTnGMbcdMZ5og1GLTCabaaBtGvz4nGpC+/0bH+ryc4xjbjpjPNEGoxaYTTbTRuVJYUAFAHnGqQ3fhzxvPq11IRb3quIbwxlxAxGFBHtjGP7tbK0o2MXpK5kXSzXFpc6et9FrGo6ldJKFtQWWPGctkgAE5AwOABzVLvsS+x6JHZTad4MaznlMssNkysxOedp4HsOg+lctR3TZ3YRWrU/VfmeVaR/yGbL/r4j/wDQhXkw+JH6Liv4E/R/keneOxnwfeg+sX/o1a9qHxH5jP4TlPHvhu/n1pLmztEFr5SRqQ6IobJ+Xkj/ACa0hJW1InF30Oj8AaRfaPok0OoQeTJJcF1UsCcbVGePoaio03oVBNLU4HxJ/wAjLqP/AF8P/OvGq/Gz9Ky//dKfoj0/Q5fs/hCzmA3eXaBseuFzXpUvgR8LmH+9VPVmJ4S8WW80csN7HY6VEB5kUZcxltxyW+bgg57H8K6JR7HnxkXfD66Vda1eXelaXClvENi3qjHmuT8wX26c0pXtqxxtfQ6aoLFT/WJ9f6GgCxSA8g+IH/I33P8AuR/+givNxH8Rn3mS/wC5R+f5ndfD7/kULb/fk/8AQjXXh/4aPms6/wB9l8vyOlrc8gKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv/ABN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/32/nQBLpv/H/H+P8AI0AfONd5whQB638Cv+Y7/wBu/wD7UrCt0N6PU9brnNwoAKACgAoAKAEIBBB6GgCK1tYLK2jtraNYoYxhEXoBQ3cNhZLaCWaOaSGN5Yc+W7KCyZ4OD2zQtA3Ee0tpJvPkt4nl2GPzGQFtp6rn09qOlg7eRDbaTptk4e10+1gZcgNFCqkZ68gd8Cm22KyEh0fS7aUTQadaRSBt4dIVBDdM5A680XewNJ6su0hhQAUAFABQAUAcj8U/+Sc6p/2x/wDRyVpT+JEVPhZ8711nIFAHtvwX/wCRQu/+wg//AKLjrmrfEdNL4T0GsTUKACgAoAKACgAoAKAEbqv1/pQAtABQBWvdPhv1jWYsPLfcNpxn1B9jTTsJq4lzp0N07u7OGdFTKnG3B3Aj3zQnYLEP9jIXeV7q4edyrCUlcqVzjAC46E9qdwsPbTdyxt9suPPjJImypbnqMY246cY7UrhYbJpEb2y263M6R7WVwCp8zJyScg857jHWi4WLyIscaov3VAA+lIYtABQAUAFABQAUAIyhlKsMgjBFAFOHSbeGwNkryFCwYsSCxIII5x7AfSnfW4raWHR6eIpzJHczrGXMhhBGzcevbOM84zii4WIhodoMcycXHn9R19On3fanzMLIkfTVlu0uJLiZgj+YsR2lVbGODjP4ZxSuFi5SGFABQAUAFABQAUAFABQAUAIfvj6H+lAC0AFACL0/E/zoAWgAoAKAA9KAJIf9UPx/nQBy3xK/5Fhf+vlP5NXNifgPdyH/AHt+j/Q5b4a/8jO3/Xs/81rDDfGe1n3+6L1X6nq1egfEFVfuj6UxC0DCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgBkkUcyGOWNZEPVWGQaBEVtYWVmSbW0ggLdTFGFz+VF2wskR6v/wAga+/695P/AEE1E/hZ0YX+PD1X5njmkf8AIZsv+viP/wBCFeVD4kfomK/gT9H+R7Pe2VtqNnJaXcQlhkADISRnByORz1FewnY/M2rmVD4K8PQTxzx6f88TB0LTSMAR04LYNVzyJ5EbtSWeMeJP+Rl1H/r4f+deTV+Nn6Nl/wDulP0R6n4bGfDWnA/8+6fyr0qXwI+GzD/e6nqy3Pp9ldIkdxZwTIgwiyRKwX6ZHFaXZw2RPHGkSCONFRFGAqjAFADqBip/rE+v9DQBYpAeQfED/kb7n/cj/wDQRXm4j+Iz7zJf9yj8/wAzuvh9/wAihbf78n/oRrrw/wDDR81nX++y+X5HS1ueQFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBX/ib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/H1N/vt/OgCXTf8Aj/j/AB/kaAPnGu84QoA9F+DviKw0fVr2xvpkgF+sflyOcLuUt8pPbO4/lWNWLaujalJJ2Z7gCGAIIIPQiuY6BaACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgDzv4u+I9Pt/DE2iLOkl7dsmYkYExqrBtzen3QPxralF3uZVZK1jw2uk5goA9t+C//IoXf/YQf/0XHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAI3Vfr/SgBaACgDP1GfUo5VWzjtkiC7nnuW+UH+6ADn8aat1E79Ctb6rqN9pVvNaWkZnmcozMT5aAHlvUg44p2SeortoLbVr94L6NrWOa8tHCAQkhHJ+vTHehpBdj7LUNQGrf2fqCW5dofNV7fdhecYINDStdAm72ZrVJQUAFABQAUAFABQAUAQXktxFblrWATTEgKpbaPqT6CmhMwhr+qPoBvo7WBpEMnmNkhFCnHTOSTVcqvYnmdrm/aStPZwzMAGkjViB0yRmpZaJaQBQAUAFABQAUAFABQAUAFABQAUAIfvj6H+lAC0AFACL0/E/zoAWgAoAKAA9KAJIf9UPx/nQBy3xK/wCRYX/r5T+TVzYn4D3ch/3t+j/Q5b4a/wDIzt/17P8AzWsMN8Z7Wff7ovVfqerV6B8QVV+6PpTELQMKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAp6v/AMga+/695P8A0E1E/hZvhf48PVfmeOaR/wAhmy/6+I//AEIV5UPiR+iYr+BP0f5Ht9ewfmgUAFAHjHiT/kZdR/6+H/nXk1fjZ+jZf/ulP0R6p4a/5FrTv+vdP5V6VL4EfDZh/vdT1Zp1ocQUAFACp/rE+v8AQ0AWKQHkHxA/5G+5/wByP/0EV5uI/iM+8yX/AHKPz/M7r4ff8ihbf78n/oRrrw/8NHzWdf77L5fkdLW55AUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/wCP8f5GgD5xrvOEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFABQAjdV+v9KAFoAKAMvVvtrSCNdMh1CzdfmjLBWDZ6/NwRVKxLuUEt9dsdBFvbQ77iSRsDzQTboegBJ5Ip6Ni1SLFiL6x0maK20ho5kGUEk6MZWPViQfxpOze41dLYTQob63mdr3TpFmm+aa6eZGyewAB4HtTlboEb9TcqCgoAKACgAoAKACgAoAKAOft9LvY/Cd1YtDi4k8zam4c5PHOcVd1zXIs+WxtWUbw2NvFIMOkSqw9CBUvcpE1IYUAFABQAUAFABQAUAFABQAUAFACH74+h/pQAtABQAi9PxP86AFoAKACgAPSgCSH/VD8f50Act8Sv+RYX/r5T+TVzYn4D3ch/wB7fo/0OW+Gv/Izt/17P/Naww3xntZ9/ui9V+p6tXoHxBVAwMHqOKYhaBhQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFbUIXuNNuoYxl5IXVR7kECpkrxaNaElCrGT2TX5niEkbwyNHKjI6nDKwwQa8dqx+mxkpK8XdC+fN/z1f/AL6NO7J5I9g8+b/nq/8A30aLsOSPYPPm/wCer/8AfRouw5I9hoDSOAAWdjwBySaRV1FeR7VodvJa6FYwTLtkjgQMp7HHSvWppqCTPzfGTjUxE5x2bZfrQ5QoAKAFQZlX25oAsUgPIPiB/wAjfc/7kf8A6CK83EfxGfeZL/uUfn+Z3Xw+/wCRQtv9+T/0I114f+Gj5rOv99l8vyOlrc8gKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv/E31NABQAUAFABQAUAFABQAUAFABQAHoaAOauv+Pqb/AH2/nQBLpv8Ax/x/j/I0AfONd5whQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAe2/Bf8A5FC7/wCwg/8A6LjrmrfEdNL4T0GsTUKACgAoAKACgAoAKAEbqv1/pQAtABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAh++Pof6UALQAUAIvT8T/OgBaACgAoAD0oAkh/1Q/H+dAHLfEr/kWF/wCvlP5NXNifgPdyH/e36P8AQ5b4a/8AIzt/17P/ADWsMN8Z7Wff7ovVfqerV6B8QMaNWOeQfUUAN8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgA8gf32/SgBrWcTnLDcfUgH+lA1KS2Y37DB/cH/AHyP8KLIfPLuH2GD+4P++R/hRZBzy7h9hg/uD/vkf4UWQc8u4q2cKnKgA+oUf4UaA5Se7H+QP77fpQSHkD++36UAHkD++36UAHkD++36UAPVAg4oAdQB5B8QP+Rvuf8Acj/9BFebiP4jPvMl/wByj8/zO6+H3/IoW3+/J/6Ea68P/DR81nX++y+X5HS1ueQFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBX/ib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/H1N/vt/OgCXTf+P8Aj/H+RoA+ca7zhCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA9t+C//IoXf/YQf/0XHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAI3Vfr/SgBaACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgBD98fQ/0oAWgAoARen4n+dAC0AFABQAHpQBJD/qh+P8AOgDlviV/yLC/9fKfyaubE/Ae7kP+9v0f6HLfDX/kZ2/69n/mtYYb4z2s+/3Req/U9Wr0D4gKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgDyD4gf8AI33P+5H/AOgivNxH8Rn3mS/7lH5/md18Pv8AkULb/fk/9CNdeH/ho+azr/fZfL8jpa3PICgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAr/xN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/wB9v50AS6b/AMf8f4/yNAHzjXecIUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHtvwX/AORQu/8AsIP/AOi465q3xHTS+E9BrE1CgAoAKACgAoAKACgBG6r9f6UALQAUAQy3trBKIprmGORuivIAT+Bp2Yrk1IYUAIzohUM6qWOFycZPoKAFoAakkchYI6sUO1sHOD6GgASRHBKOrYJBwc8jqKAFR1kQOjBlPQg5BoAWgAoAKACgBGZUUszBVAySTgCgBsNxDcR+ZBNHKmcbkYEfmKAH0AFABQAUAFABQAUAFABQAUAFABQAUAIfvj6H+lAC0AFACL0/E/zoAWgAoAKAA9KAJIf9UPx/nQBy3xK/5Fhf+vlP5NXNifgPdyH/AHt+j/Q5b4a/8jO3/Xs/81rDDfGe1n3+6L1X6nq1egfEBQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAeQfED/AJG+5/3I/wD0EV5uI/iM+8yX/co/P8zuvh9/yKFt/vyf+hGuvD/w0fNZ1/vsvl+R0tbnkBQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAV/4m+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/wAfU3++386AJdN/4/4/x/kaAPnGu84QoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPbfgv8A8ihd/wDYQf8A9Fx1zVviOml8J6DWJqFABQAUAFABQAUAFACN1X6/0oAWgAoAwNTlVNXuEe8tLcPaqMXC538twPmH8jVrYh7le41GSG3iEMrwPDBGRFLOFz9F25f3zj8KdguXd9ws5uPtUvF95Plk/LsJAxj8akZUaYXFzZiS9c3TXTCSDcP3fDAcdscc96YhBf6gwH7x8t/oX0l7v/OiyC7LU1w6TvHNdPBb/aijy7tuAIwQN3bJoGVbARGezla6cobqcK5faHOePqT+tNiRa0oSQDTsTyMk8bhkY5UY5GB2pPqNG5UFBQAUAFAFPVlhfT3E8pijypL7dwUgggkemetNbiexjzyx3NtOTLCRHNCz3VqdiON3fk8ge57VRJN9sf7T8t6xuvtIjW23DBjz129xt+bdRYdwad4rATS3c26e4ZNzTCNEAZsAtg7Rx169KOouhHb3sk0UAu714YP3oEqP99g2FG7AzxntzRbsFyAahdta2/mXixA2+9ZJZ/K3vuP+ydxGB8vvTsguzpoC7QRmQguVG4gcZxz1rMsfQAUAFABQAUAFABQAUAIfvj6H+lAC0AFACL0/E/zoAWgAoAKACgB0LjGw9R096AOa+I8bv4W3KpISdGbHYcjP5kVz4le4e3kUksXZ9Uzy20vbqwm860uJIJMY3RsVOPSvPUnF3R9pUpU6seWorrzL3/CT67/0F7v/AL+mr9rPuc39n4T/AJ9r7g/4SfXf+gvd/wDf00e1n3D+z8J/z7X3B/wk+u/9Be7/AO/po9rPuH9n4T/n2vuD/hJ9d/6C93/39NHtZ9w/s/Cf8+19wf8ACT67/wBBe7/7+mj2s+4f2fhP+fa+4P8AhJ9d/wCgvd/9/TR7WfcP7Pwn/PtfcH/CT67/ANBe7/7+mj2s+4f2fhP+fa+4P+En13/oL3f/AH9NHtZ9w/s/Cf8APtfcH/CT67/0F7v/AL+mj2s+4f2fhP8An2vuD/hJ9d/6C93/AN/TR7WfcP7Pwn/PtfcH/CT67/0F7v8A7+mj2s+4f2fhP+fa+4P+En13/oL3f/f00e1n3D+z8J/z7X3B/wAJPrv/AEF7v/v6aPaz7h/Z+E/59r7g/wCEn13/AKC93/39NHtZ9w/s/Cf8+19wf8JPrv8A0F7v/v6aPaz7h/Z+E/59r7g/4SfXf+gvd/8Af00e1n3D+z8J/wA+19wf8JPrv/QXu/8Av6aPaz7h/Z+E/wCfa+4P+En13/oL3f8A39NHtZ9w/s/Cf8+19wf8JPrv/QXu/wDv6aPaz7h/Z+E/59r7g/4SfXf+gvd/9/TR7WfcP7Pwn/PtfcH/AAk+u/8AQXu/+/po9rPuH9n4T/n2vuD/AISfXf8AoL3f/f00e1n3D+z8J/z7X3B/wk+u/wDQXu/+/po9rPuH9n4T/n2vuD/hJ9d/6C93/wB/TR7WfcP7Pwn/AD7X3B/wk+u/9Be7/wC/po9rPuH9n4T/AJ9r7g/4SfXf+gvd/wDf00e1n3D+z8J/z7X3B/wk+u/9Be7/AO/po9rPuH9n4T/n2vuD/hJ9d/6C93/39NHtZ9w/s/Cf8+19wf8ACT67/wBBe7/7+mj2s+4f2fhP+fa+4P8AhJ9d/wCgvd/9/TR7WfcP7Pwn/PtfcH/CT67/ANBe7/7+mj2s+4f2fhP+fa+4P+En13/oL3f/AH9NHtZ9w/s/Cf8APtfcH/CT67/0F7v/AL+mj2s+4f2fhP8An2vuD/hJ9d/6C93/AN/TR7WfcP7Pwn/PtfcH/CT67/0F7v8A7+mj2s+4f2fhP+fa+4P+En13/oL3f/f00e1n3D+z8J/z7X3B/wAJPrv/AEF7v/v6aPaz7h/Z+E/59r7g/wCEn13/AKC93/39NHtZ9w/s/Cf8+19wf8JPrv8A0F7v/v6aPaz7h/Z+E/59r7g/4SfXf+gvd/8Af00e1n3D+z8J/wA+19wf8JPrv/QXu/8Av6aPaz7h/Z+E/wCfa+4P+En13/oL3f8A39NHtZ9w/s/Cf8+19wf8JPrv/QXu/wDv6aPaz7h/Z+E/59r7g/4SfXf+gvd/9/TR7WfcP7Pwn/PtfcH/AAk+u/8AQXu/+/po9rPuH9n4T/n2vuD/AISfXf8AoL3f/f00e1n3D+z8J/z7X3B/wk+u/wDQXu/+/po9rPuH9n4T/n2vuD/hJ9d/6C93/wB/TR7WfcP7Pwn/AD7X3B/wk+u/9Be7/wC/po9rPuH9n4T/AJ9r7g/4SfXf+gvd/wDf00e1n3D+z8J/z7X3B/wk+u/9Be7/AO/po9rPuH9n4T/n2vuD/hJ9d/6C93/39NHtZ9w/s/Cf8+19wf8ACT67/wBBe7/7+mj2s+4f2fhP+fa+4P8AhJ9d/wCgvd/9/TR7WfcP7Pwn/PtfcH/CT67/ANBe7/7+mj2s+4f2fhP+fa+4P+En13/oL3f/AH9NHtZ9w/s/Cf8APtfcH/CT67/0F7v/AL+mj2s+4f2fhP8An2vuD/hJ9d/6C93/AN/TR7WfcP7Pwn/PtfcH/CT67/0F7v8A7+mj2s+4f2fhP+fa+4P+En13/oL3f/f00e1n3D+z8J/z7X3B/wAJPrv/AEF7v/v6aPaz7h/Z+E/59r7g/wCEn13/AKC93/39NHtZ9w/s/Cf8+19wf8JPrv8A0F7v/v6aPaz7h/Z+E/59r7g/4SfXf+gvd/8Af00e1n3D+z8J/wA+19wf8JPrv/QXu/8Av6aPaz7h/Z+E/wCfa+4P+En13/oL3f8A39NHtZ9w/s/Cf8+19wf8JPrv/QXu/wDv6aPaz7h/Z+E/59r7g/4SfXf+gvd/9/TR7WfcP7Pwn/PtfcH/AAk+u/8AQXu/+/po9rPuH9n4T/n2vuD/AISfXf8AoL3f/f00e1n3D+z8J/z7X3B/wk+u/wDQXu/+/po9rPuH9n4T/n2vuD/hJ9d/6C93/wB/TR7WfcP7Pwn/AD7X3B/wk+u/9Be7/wC/po9rPuH9n4T/AJ9r7g/4SfXf+gvd/wDf00e1n3D+z8J/z7X3B/wk+u/9Be7/AO/po9rPuH9n4T/n2vuD/hJ9d/6C93/39NHtZ9w/s/Cf8+19wf8ACT67/wBBe7/7+mj2s+4f2fhP+fa+4P8AhJ9d/wCgvd/9/TR7WfcP7Pwn/PtfcH/CT67/ANBe7/7+mj2s+4f2fhP+fa+4P+En13/oL3f/AH9NHtZ9w/s/Cf8APtfcH/CT67/0F7v/AL+mj2s+4f2fhP8An2vuD/hJ9d/6C93/AN/TR7WfcP7Pwn/PtfcH/CT67/0F7v8A7+mj2s+4f2fhP+fa+4P+En13/oL3f/f00e1n3D+z8J/z7X3B/wAJPrv/AEF7v/v6aPaz7h/Z+E/59r7g/wCEn13/AKC93/39NHtZ9w/s/Cf8+19wf8JPrv8A0F7v/v6aPaz7h/Z+E/59r7g/4SfXf+gvd/8Af00e1n3D+z8J/wA+19wf8JPrv/QXu/8Av6aPaz7h/Z+E/wCfa+4P+En13/oL3f8A39NHtZ9w/s/Cf8+19wf8JPrv/QXu/wDv6aPaz7h/Z+E/59r7g/4SfXf+gvd/9/TR7WfcP7Pwn/PtfcH/AAk+u/8AQXu/+/po9rPuH9n4T/n2vuD/AISfXf8AoL3f/f00e1n3D+z8J/z7X3B/wk+u/wDQXu/+/po9rPuH9n4T/n2vuD/hJ9d/6C93/wB/TR7WfcP7Pwn/AD7X3FC6u7i9nae6meaVsZd2yTiobbd2dVOnClHlgrI9b8BRvH4QtN6ldxdhn0LHBr0aC/do+FzmSeNlby/I6OtzyQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAazBF3McCgCBcnJPc5oAWgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8AH1N/vt/OgCXTf+P+P8f5GgD5xrvOEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/APIoXf8A2EH/APRcdc1b4jppfCeg1iahQAUAFABQAUAFABQAjdV+v9KAFoAKAI5rm3tygnnjiLnC73C7j6DPWiwEhwBk4GO5oAht7y1u932a5hm2/e8tw2PrinZoLgl7aSXBt0uYWmHWNZAWH4daLMV0Ssyopd2CqoySTgCkMigvLS7DfZ7mGfb97y3DY+uKdmhXGR6np80oiivraSQnAVZVJP4ZoswuizSGFABQAUAFAAzBVLMQABkk9BQBVOqackSyG+tljfIVjMoDY64OadmK6HJf2UsLzx3cDxJw0iyKVX6ntRZhdEkFxb3Ue+3mjmTON0bBh+lLYZX1E2qqjXN8bTkhWE/l59ueDTVxMkQ2ljZJiSOK3RRtdn+XHbk0athoiWGeK4jEkEqSoejIwYH8RSGMuL20tNv2m5hh3dPMkC5/OnZsVwmvbW3jWWe5hiR/us8gUN9CaLMLjoLmC6TfbzRzJnG6Ngw/SkMkoAKACgAoAKAEP3x9D/SgBaACgBF6fif50ALQAUAFABQAjIG60ARyQCWNo5CXRhhlY5BHpijccZOLunqZx8LaIT/yDLb/AL9is/ZQ7HZ/aGL/AOfj+8P+EW0T/oGW3/fsUeyh2D+0MX/z8f3h/wAIton/AEDLb/v2KPZQ7B/aGL/5+P7w/wCEW0T/AKBlt/37FHsodg/tDF/8/H94f8Iton/QMtv+/Yo9lDsH9oYv/n4/vD/hFtE/6Blt/wB+xR7KHYP7Qxf/AD8f3h/wi2if9Ay2/wC/Yo9lDsH9oYv/AJ+P7w/4RbRP+gZbf9+xR7KHYP7Qxf8Az8f3h/wi2if9Ay2/79ij2UOwf2hi/wDn4/vD/hFtE/6Blt/37FHsodg/tDF/8/H94f8ACLaJ/wBAy2/79ij2UOwf2hi/+fj+8P8AhFtE/wCgZbf9+xR7KHYP7Qxf/Px/eH/CLaJ/0DLb/v2KPZQ7B/aGL/5+P7w/4RbRP+gZbf8AfsUeyh2D+0MX/wA/H94f8Iton/QMtv8Av2KPZQ7B/aGL/wCfj+8P+EW0T/oGW3/fsUeyh2D+0MX/AM/H94f8Iton/QMtv+/Yo9lDsH9oYv8A5+P7w/4RbRP+gZbf9+xR7KHYP7Qxf/Px/eH/AAi2if8AQMtv+/Yo9lDsH9oYv/n4/vD/AIRbRP8AoGW3/fsUeyh2D+0MX/z8f3h/wi2if9Ay2/79ij2UOwf2hi/+fj+8P+EW0T/oGW3/AH7FHsodg/tDF/8APx/eH/CLaJ/0DLb/AL9ij2UOwf2hi/8An4/vD/hFtE/6Blt/37FHsodg/tDF/wDPx/eH/CLaJ/0DLb/v2KPZQ7B/aGL/AOfj+8P+EW0T/oGW3/fsUeyh2D+0MX/z8f3h/wAIton/AEDLb/v2KPZQ7B/aGL/5+P7w/wCEW0T/AKBlt/37FHsodg/tDF/8/H94f8Iton/QMtv+/Yo9lDsH9oYv/n4/vD/hFtE/6Blt/wB+xR7KHYP7Qxf/AD8f3h/wi2if9Ay2/wC/Yo9lDsH9oYv/AJ+P7w/4RbRP+gZbf9+xR7KHYP7Qxf8Az8f3h/wi2if9Ay2/79ij2UOwf2hi/wDn4/vD/hFtE/6Blt/37FHsodg/tDF/8/H94f8ACLaJ/wBAy2/79ij2UOwf2hi/+fj+8P8AhFtE/wCgZbf9+xR7KHYP7Qxf/Px/eH/CLaJ/0DLb/v2KPZQ7B/aGL/5+P7w/4RbRP+gZbf8AfsUeyh2D+0MX/wA/H94f8Iton/QMtv8Av2KPZQ7B/aGL/wCfj+8P+EW0T/oGW3/fsUeyh2D+0MX/AM/H94f8Iton/QMtv+/Yo9lDsH9oYv8A5+P7w/4RbRP+gZbf9+xR7KHYP7Qxf/Px/eH/AAi2if8AQMtv+/Yo9lDsH9oYv/n4/vD/AIRbRP8AoGW3/fsUeyh2D+0MX/z8f3h/wi2if9Ay2/79ij2UOwf2hi/+fj+8P+EW0T/oGW3/AH7FHsodg/tDF/8APx/eH/CLaJ/0DLb/AL9ij2UOwf2hi/8An4/vD/hFtE/6Blt/37FHsodg/tDF/wDPx/eH/CLaJ/0DLb/v2KPZQ7B/aGL/AOfj+8P+EW0T/oGW3/fsUeyh2D+0MX/z8f3h/wAIton/AEDLb/v2KPZQ7B/aGL/5+P7w/wCEW0T/AKBlt/37FHsodg/tDF/8/H94f8Iton/QMtv+/Yo9lDsH9oYv/n4/vD/hFtE/6Blt/wB+xR7KHYP7Qxf/AD8f3h/wi2if9Ay2/wC/Yo9lDsH9oYv/AJ+P7w/4RbRP+gZbf9+xR7KHYP7Qxf8Az8f3h/wi2if9Ay2/79ij2UOwf2hi/wDn4/vD/hFtE/6Blt/37FHsodg/tDF/8/H94f8ACLaJ/wBAy2/79ij2UOwf2hi/+fj+8P8AhFtE/wCgZbf9+xR7KHYP7Qxf/Px/eH/CLaJ/0DLb/v2KPZQ7B/aGL/5+P7w/4RbRP+gZbf8AfsUeyh2D+0MX/wA/H94f8Iton/QMtv8Av2KPZQ7B/aGL/wCfj+8P+EW0T/oGW3/fsUeyh2D+0MX/AM/H94f8Iton/QMtv+/Yo9lDsH9oYv8A5+P7w/4RbRP+gZbf9+xR7KHYP7Qxf/Px/eH/AAi2if8AQMtv+/Yo9lDsH9oYv/n4/vD/AIRbRP8AoGW3/fsUeyh2D+0MX/z8f3h/wi2if9Ay2/79ij2UOwf2hi/+fj+8P+EW0T/oGW3/AH7FHsodg/tDF/8APx/eH/CLaJ/0DLb/AL9ij2UOwf2hi/8An4/vD/hFtE/6Blt/37FHsodg/tDF/wDPx/eH/CLaJ/0DLb/v2KPZQ7B/aGL/AOfj+8P+EW0T/oGW3/fsUeyh2D+0MX/z8f3h/wAIton/AEDLb/v2KPZQ7B/aGL/5+P7w/wCEW0T/AKBlt/37FHsodg/tDF/8/H94f8Iton/QMtv+/Yo9lDsH9oYv/n4/vD/hFtE/6Blt/wB+xR7KHYP7Qxf/AD8f3h/wi2if9Ay2/wC/Yo9lDsH9oYv/AJ+P7w/4RbRP+gZbf9+xR7KHYP7Qxf8Az8f3h/wi2if9Ay2/79ij2UOwf2hi/wDn4/vD/hFtE/6Blt/37FHsodg/tDF/8/H94f8ACLaJ/wBAy2/79ij2UOwf2hi/+fj+8P8AhFtE/wCgZbf9+xR7KHYP7Qxf/Px/eH/CLaJ/0DLb/v2KPZQ7B/aGL/5+P7w/4RbRP+gZbf8AfsUeyh2D+0MX/wA/H94f8Iton/QMtv8Av2KPZQ7B/aGL/wCfj+8P+EW0T/oGW3/fsUeyh2D+0MX/AM/H94f8Iton/QMtv+/Yo9lDsH9oYv8A5+P7w/4RbRP+gZbf9+xR7KHYP7Qxf/Px/eH/AAi2if8AQMtv+/Yo9lDsH9oYv/n4/vD/AIRbRP8AoGW3/fsUeyh2D+0MX/z8f3h/wi2if9Ay2/79ij2UOwf2hi/+fj+8P+EW0T/oGW3/AH7FHsodg/tDF/8APx/eH/CLaJ/0DLb/AL9ij2UOwf2hi/8An4/vD/hFtE/6Blt/37FHsodg/tDF/wDPx/eH/CLaJ/0DLb/v2KPZQ7B/aGL/AOfj+8B4X0QHI0y24/6Zij2UOwfX8X/z8f3mksWxQqsyqBgAMQAK0ONtt3Yuxv8Ano//AH0aBBsb/no//fRoANjf89H/AO+jQAbG/wCej/8AfRoANjf89H/76NABsb/no/8A30aADY3/AD0f/vo0AGxv+ej/APfRoANjf89H/wC+jQAbG/56P/30aADY3/PR/wDvo0AGxv8Ano//AH0aADY3/PR/++jQAbG/56P/AN9GgA2N/wA9H/76NABsb/no/wD30aADY3/PR/8Avo0AGxv+ej/99GgA2N/z0f8A76NABsb/AJ6P/wB9GgA2N/z0f/vo0AGxv+ej/wDfRoANjf8APR/++jQAbG/56P8A99GgA2N/z0f/AL6NABsb/no//fRoANjf89H/AO+jQAbG/wCej/8AfRoANjf89H/76NABsb/no/8A30aADY3/AD0f/vo0AGxv+ej/APfRoANjf89H/wC+jQAbG/56P/30aADY3/PR/wDvo0AGxv8Ano//AH0aADY3/PR/++jQAbG/56P/AN9GgA2N/wA9H/76NABsb/no/wD30aADY3/PR/8Avo0AGxv+ej/99GgA2N/z0f8A76NABsb/AJ6P/wB9GgA2N/z0f/vo0AGxv+ej/wDfRoANjf8APR/++jQAbG/56P8A99GgA2N/z0f/AL6NABsb/no//fRoANjf89H/AO+jQAbG/wCej/8AfRoANjf89H/76NACiPnJJJ9zmgB1ABQAUAFABQAUAFABQAUAFABQAHoaAOauv+Pqb/fb+dAEum/8f8f4/wAjQB8413nCFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQB7b8F/+RQu/+wg//ouOuat8R00vhPQaxNQoAKACgAoAKACgAoARuq/X+lAC0AFAHP8AiezgAtrzZmc3USbyc4XJ4HpVxfQiSLHiuR00GbZ0ZkVwDj5SwyM0o7jlsZzCTTb9la1tEneykaGS0DLtwM4YZwfY1W6FsytYxm1tNJuprS0aKSVQrR7hMGP8RYHnnqKb6iXQ1/EuHWwhmOLaW6VZucAjsD7ZqIlSIJVhs/ElrHHpa2+8MkcsMqqHXGTuQDoPenutxbMxktiPDkNzJZW6wJNue5Q5nxv7DA+nU1XUnod0pDKGHQjIrI1FoAKACgAoAhurSG9h8m4TfGSCVzwcevtTTsJq5zuk/YYPCr3N5bQzLBJKVV0Dc7uAM+vFW782hKtYgn04Weh2cTxr9surtZfK2gIzn+Fh2UCi92K1kaGiKYNb1COeOOC4dUfy4f8AV7emQfX8BSlshrcgu4bi98UXUSRWshit12falLKoPXA9z3prSIPVlFHN4mjW8FtCiFpf3UrFot69+TkjqQKe1xb2Nrw+RHPqFs1vDFNFKPMMGRG+RwQCeD61EuhUSrbQx3Wo6xLPZx3t3FIFjhlx9zHGM8DPrTeyF1ZnKyz2lhFDZAKmoMggmm3ofl5GcdM+xqhGrocYttd1CGSCO3mdEcRQf6sL0yOnP4Cplshrc6CoLCgAoAKACgBD98fQ/wBKAFoAKAEXp+J/nQAtABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAHoaAOauv+Pqb/fb+dAEum/8AH/H+P8jQB8413nCFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQB7b8F/8AkULv/sIP/wCi465q3xHTS+E9BrE1CgAoAKACgAoAKACgBG6r9f6UALQAUAQ3Vnb3qIlxHvVHDqMkYYdDxTTsJq5H/Zlnm5JgB+1484Ekh/wouwshllo9hp8jSW0G12XaWZixx6DJOBQ22CSQyDQtMt7kXEVqFkUll+Ziqk9SFJwPwo5mHKi3c20F5A0FxEskb9VaknYe5WstE07TpTLbW4WQjbuZixA9BknFNybEkkQp4Z0dHVhZ52tuAaR2GfoTinzMXKjUqSgoAKACgAoAKAKQ0ewW2S2EH7qOTzVTe2N2c568/Q07sVkTXllbX8Pk3UQkTORyQQfUEcihOwNXK6aFpqW80At8pcY80s7Fmx/tE5o5mFkOu9GsL3y/PgyY12Kyuynb6ZB5FCbQNJiy6RYTWcdo9svkxcxqpKlD6gjkUXYWRJZWFrp8JitYhGpO48kkn1JPJobuCViG90TTtRmE1zbBpAMb1YqSPQ4IzQpNA0mE2iadPaxWr2wEMJzGqsy7T68EUczCyH2OlWWm7zaQCMyfeYsWJ/EkmhtsEki3SGFABQAUAFACH74+h/pQAtABQAi9PxP86AFoAKACgAoAACTgDNADvLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAPLf2oAQqyjJHHtQAlABQAUAFABQAUAFABQAUAFABQAHoaAOauv8Aj6m/32/nQBLpv/H/AB/j/I0AfONd5whQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAe2/Bf/kULv8A7CD/APouOuat8R00vhPQaxNQoAKACgAoAKACgAoARuq/X+lAC0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAEcNzDcb/JkV/LYo2OxHagiFSM78rvbQkoLCgAoAKACgAoAKACgBD98fQ/0oAWgAoARen4n+dAC0AFABQAUASQ/wCrz6mgCSgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCuOpHocUAFABQAUAFABQAUAFABQAUAFAAehoA5q6/wCPqb/fb+dAEum/8f8AH+P8jQB8413nCFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQB7b8F/+RQu/wDsIP8A+i465q3xHTS+E9BrE1CgAoAKACgAoAKACgBG6r9f6UALQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBHcS+RbSzH/lmhbn2GaCKkuSDl2MLwuTHJNEx/wBZFHL+ec1ETy8u91uL6pM6GrPXCgAoAKACgAoAKACgBD98fQ/0oAWgAoARen4n+dAC0AFABQAHpQBJD/qh+P8AOgCSgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv/E31NABQAUAFABQAUAFABQAUAFABQAHoaAOauv8Aj6m/32/nQBLpv/H/AB/j/I0AfONd5whQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAe2/Bf/kULv8A7CD/APouOuat8R00vhPQaxNQoAKACgAoAKACgAoARuq/X+lAC0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAZ+vyeVod03qm38yB/Wk9jkxsuXDyZR05PI15Y/WzA/EMKlbnNQXJiUv7v6m9VnqBQAUAFABQAUAFABQAh++Pof6UALQAUAIvT8T/OgBaACgAoAD0oAkh/1Q/H+dAElABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBHJJswANzN0WgBPKduZJG+iHAH9aAD7OnrJ/38b/ABoAPs6esn/fxv8AGgA+zp6yf9/G/wAaAD7OnrJ/38b/ABoAPs6esn/fxv8AGgA+zp6yf9/G/wAaAD7OnrJ/38b/ABoAPs6f3pP+/jf40AIVli5VjIv91uv4GgCRHWRAyng0AOoAKAK/8TfU0AFABQAUAFABQAUAFABQAUAFAAehoA5q6/4+pv8Afb+dAEum/wDH/H+P8jQB8413nCFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQB7b8F/wDkULv/ALCD/wDouOuat8R00vhPQaxNQoAKACgAoAKACgAoARuq/X+lAC0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAZXiI5sYIv+e1yifrn+lTI4Mf8Aw4x7tIgHyeIrM/345F/IZpdTPbFQ80zcqz0woAKACgAoAKACgAoAQ/fH0P8ASgBaACgBF6fif50ALQAUAFAAelAEkP8Aqh+P86AJKACgAoAgt7y1u0d7a5hmSNyjtHIGCsOoOOhHpQ9Fd7AtXZbiW+oWV3aG8tryCe2GczRyqycdfmBxxTknHcE+Z2Q+3uILuBLi2mjnhkGUkjYMrD1BHBoaa0Yk09UE91b2oQ3E8UIkcRoZHC7mPRRnqT6UkruyG9FdktAEVtdW95AJ7WeKeJiQJInDKSDg8j3GKbTQeRLSAKACgCK3ure6Dm2nimEbmNzG4baw6qcdCPSi2ifcL62JCQBknAFDdgIra6tr23W4tLiK4hf7skThlbtwRxTaa3EmnsV5Nb0mKyW9k1SzS1Z9iztcIELc8bs4zwePaiz2HffyHWOsaXqjOun6laXhQZYW86ybfrg8U3FpXaJUk3ZMmt7u2uxIba4inETmN/LcNsYdVOOhHpSton3KvrYmpAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAEMPzvJKe52j2A/8Ar5oAmoA4vxB8Qjpl/Pp2n6PcXNxAP3s1x/o9vHkkAl27cHngHHBNaRp3V2zOU7aJHL2fxourW9a31SwtbyMHAl09mXHsA/3vTt+NaOj2IVXuen6TqcWsabFfQw3ECSjIS4iMbj6g/wAxxWDVnY2TurjdF1I6vpq3hi8rMkibd277rsuc++3NDVkn3Sf3q4X1a7Nr7mNt9f0q7vjZQXsck+WAUZwxH3grdGI7gE470KLa5l/X/A8wcknZ/wBf8HyC28QaVd3xsre9SSfLAAA4Yj7wVsYYjByATjFNRbXMv6/4AOSTsyJfFOhvDLONRj8mEgSSkEIhLbQC2MZz27UlFtJ9/wDhwbSbXb9Czp+r2GqiX7FcCUwttkXaVZT2yCAcHsehpuLSuxKSbsi7UlEK/Jcso6ON349/6UATUAFAFf8Aib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/H1N/vt/OgCXTf+P+P8f5GgD5xrvOEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/8AIoXf/YQf/wBFx1zVviOml8J6DWJqFABQAUAFABQAUAFACN1X6/0oAWgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgDI1k79Q02H1kZ/++RUs8/F61aUfNv7kR3Xyaxpkno7r+a0upFTSvSfm/wAUbdWemFABQAUAFABQAUAFACH74+h/pQAtABQAi9PxP86AFoAKACgAPSgCSH/VD8f50ASUAFABQB5vf3z+GrjxnYx5U3KJd2iju837tsf8DxVxj7WlGmt+bl+T1/K5LkqdZzf8t/8AwHT8XYonzPCvhjxJ4YjJMuYFth3fz1VGx+IatZWruKX8zXyvzL8DGH7m8pfy3+ez/Gxpalrsmk6lF4XtNYGj22m2cQa4WxNy8jEcKBggDHJJ5qb+1lKp56L+vuHZ04wh5XbKuo69qGt+FbCV1jkvbXXoYUkMbRpcEHKPtPKg5GR9aqMbVYNaXT87aO/+YOX7qonrZffqvxOghvde0PxRYadq2px6na6qJBG4tlhaCRBuwMHlSPXn+uS5ZRkktUr+pcuaNpN6N2fz2scxpE3iXTfh/wD21p+qQQ21jJM4smtg/nqJW3bnJyO/A9PerlKMXDmV7qP5Jf1/VxxlKdTldrNnUahq2r6v4gt9D0e8TTf9CF7cXLQiVwGOFRVbj6k0uSzm3tF2+YvaXjC28lf0X/DmfL4w1fS9N1axuvIu9WsLqG2hn2bEm83GxmUHgjnIFCiqnI46cza+4HJ0+fm15Vf7/wDgl1bzxB4d1zS7bVtWi1W11SQwki2WFoJNuRjb1U9OeaI8k24Ja2bXy3uEnKEVNvql95z+ieIbhb+/8M6RNHDqd3rF07TygFYIw3JAP3mODhfxNVCPPTpt7KKv970/4IpS5JzXVvT7lqelFWS0KNI0jKmC7AAscdTgAfkK5arvGXzN6as1c5v4af8AJP8ATfpJ/wCjGrpxXxfJfkjGjs/V/mcVvSP4d6A8sLToviAFokTezjzJMgL3J9O9VH+JD/D+gT2rev6o27GW01v4g2EuiaNNph0xHOoPNALdmV1wilOp555FKCcYyk3o1b53FNpuMUtb3+X9f1ua/gD/AFOvf9hq5/mKh/wqX+H9WUv4s/X9DrazNAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAhtzgOndXP6nP9aAJqAPLPGUfiS/l1iTS9ImkjhvohiS2DmaNYipwrAh13EnjPXNbw5Va7MZczvZGD4Q0/wAVf8JTYNF4cbTbcXCNcuLMxAoD83zPz0z8oP4VUnG25EVK+x7jXMdJzOgHVNPsl0u40O8QGebNyssBRVeRmDY8zd0I7ZpySnBK9vdS+5WJTcZt2vq397M/RdB1C3bS7G8tb9105wfPe6iFv8qkBkUZc5z0IHU8+urndua0dv6Xp/ViOVr3d9b/AI3/AK/yC107X7jVdJmv7a9Z7S6aS5lkmhEABRxmNEOSMkfeGfrzSi4rXyt530+Q5pu687+Vr/5FlND1AeCrXTTbD7Sl4krx714UXO8nOcfd5pRaU6b7JfhG35hJNwqLvzfi3b8DZt7KePxRfXrR4gmtII0fI+ZlaQkY68Bl/OpT9xrzv+C/yLkryT8n+ZqVIyEnddjH8CHP4n/61AE1ABQBX/ib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/AB9Tf77fzoAl03/j/j/H+RoA+ca7zhCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA9t+C/wDyKF3/ANhB/wD0XHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAI3Vfr/SgBaACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAMe6/e+JYV/542xf8ScVL3POq+9i4rsv1GaoNs+nP6XaD880MnE6Spv+8jbqj0woAKACgAoAKACgAoAQ/fH0P8ASgBaACgBF6fif50ALQAUAFAAelAEkP8Aqh+P86AJKACgAoA5zXvB8WueINN1Zrsw/YiPNiEeROoYOqk5GMMM9DV058jb/q9mr/iRUjzxUf66XX4Cax4Pi1fxRp2ttdmMWe3zIBHkTbSWTJzxgk9jRTnyN+f+TV/uCpHnSX9Wunb8CXUvDt3Jrf8AbOj6oNPu5IhDOskAmjmUfdJGQQRnrmlF2TXR/mOS5mn1X5Fa/wDB9zqehW2nXuu3E08V4t1JdGMBiQSdqgHCDnjrj3pqSU1KKtYXK3CUZPcksvDF8deg1fWtY/tGWzjaO1RLYQrGWGGY4JyxHHYUcyUZJLVg4ttXei/rUIfCPleCJ/DX27PnLKv2jyum9y33c9s461M3zcvlb8Lf5FrSUn3v+KFv/C9xJfWep6Xqn2G/trcWzyNAJEmj64ZcjvyCDVupeUn0l0M1TtCMesepAvgaCbRtQtNQv5bq91GUTT3oUIwkX7hVRwAuOB9aTnbl5NOXVevUahdyc9ebR+nQltPC+oSatZ6hrut/2kbAH7NGlsIVDkYLtgnccfQCnzpXcVq9Pl5C5G0k3otf8iCTwJDJpd3b/bmS6k1CS/truOLD20jEEY55Axg8jPtSU3Hkt9lW9RuCfPf7WvppodRAkq28aXEiyyhQHdU2hj3OMnH0yamVm3ZaFRulqzk4/Bmr6dHNZ6H4oksNNldmW3a0WVodxywRyQQOeOOPrVcylFKavb8hOLUnKLtf8y3L4KtV0bSNKs7hoIdLvI7oM672lKkkg8jBJJ5/Sq9q/ac77NfhYnk/dyhffqXLrw/5nim01+1uvs8sUTQXEfl7hcRnkAnIwQec81EJcqkuj/PuVOPNZ9V+XYxoPB3iDT7m9bS/Fq2kF5dSXJiOmpJtZjn7xbntTUlyRi1eysKUW5OSdrnXW6Sx28STS+dKqAPJt272xycds+lTJpttKyHFNJJu7JKRQUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBDIrJJ5sYyejL6igByTxycBsN/dPBFAElABQAUAFABQAUAFACUARPcKDtj/eP6DoPqaAHQxlFJY5djljQBJQAUAV/wCJvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/4/x/kaAPnGu84QoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPbfgv/wAihd/9hB//AEXHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAI3Vfr/SgBaACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAMe3/AHviDUJO0axxg/hk1PU86HvYmo+1kN10bbKKT/nnOjfrQxY3Smpdmjaqj0goAKACgAoAKACgAoAQ/fH0P9KAFoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/OgCSgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAI3hjk+8gP1FADPsdv8A88l/IUAH2O3/AOeS/kKAD7Hb/wDPJfyFAB9jt/8Ankv5CgA+x2//ADyX8hQAfY7f/nkv5CgA+x2//PJfyFAB9jt/+eS/lQBKqKgwoAoAdQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/wCP+P8AH+RoA+ca7zhCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA9t+C/8AyKF3/wBhB/8A0XHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAI3Vfr/AEoAWgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgDI0T98l3ddfOuXKn/ZHAqUedhPeU592xfEKE6JcY6jafyYUPYMcr4eX9dTVRt6K3qM1R6Cd1cWgYUAFABQAUAFABQAh++Pof6UALQAUAIvT8T/OgBaACgAoAD0oAkh/1Q/H+dAElABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8AH1N/vt/OgCXTf+P+P8f5GgD5xrvOEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/APIoXf8A2EH/APRcdc1b4jppfCeg1iahQAUAFABQAUAFABQAjdV+v9KAFoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCrqdz9k024nzgpGdp9zwP1xSexhiKns6UpeQ3SrT7HplvARgqgLfU8n9TQtiMNT9nRjETVo/M0m7UDJ8pj+lD2FiY3ozXkyXTn8zTbZ853Qqf0FC2NaDvSi/JFimbBQAUAFABQAUAFACH74+h/pQAtABQAi9PxP86AFoAKACgAPSgCSH/VD8f50ASUAFABQBRuNYs7aZ4nMrNGMyGOF3EY6/MQDiha6g9NC5HIksayRsHRwCrA5BHrTatoxJpq6K9xqNratKs0m0xRiV/lJwpOM/mKSV9u9vvH/X3EsVzFPJLHG2WhYK4weCQD/IijpcV9bEtAwoAiS5ikuZLdWzJEFLjB4Bzj+Ro6XDrYloAKAGyOkUbSOwVEBLE9gKAIjdRh9uH2+X5nmbDsx9emfah6Xv0Ba2t1I7XUY7tYmSG4VZgSjPGQCBg5J7Zzxmm01oxJp6ot0hiEhQSTgDk0N21BK5Et1HI8Qj3OsyF1dVJXHHfoM5p2d2uwrrRk1IYUAFABQAyaQQwvKVdggJ2opZj9AOtAFc6naKzK0hDLIkbAoeGYAqOnuKdn+f4CurE01zFA8SSNhpn2IME5OCf5A0lq7DeiuS0AFABQAUAMSWORnVHDGNtrgfwnAOPyIo8w62H0AFABQBE1xGrSJu3PGm9kUZbBzjj8DR0uHWw6NxLEsgVlDAHDDBH1Ham1Z2EndXH0hlWbUrSB5VkkwYdm/wCUnG84X9aaV2ku9hN239S1SGFABQAUAMklji2+Y4XewVc9yegoAJZY4VDSOEBYKCfUnAH50eQdLj6AGSyxwRNLK4REGWY9AKAGi5iN0bUN+9VBIVwfukkA5/A0LVNiuL5w+0CDY+Sm7dsO3rjGemfagZJQBFHcxSzzQI2ZIcbxg8ZGRR0uHWxWk1iyjRG3yPvkaNRHEzksucjAGeMGhK9vvFe1/uFTVrKSPzBKwHmiEq0bKyuegIIyOtOz08wutfIu0hhQAUAFABQAyWWOCMySuERerHoKAGpcxSXMlurZkiClxg8A5x/I0dLh1sS0AFADJpBDC8pV2CAnailmP0A60ALvHl+YcgYzyORRL3b3CPvWsNgmjuII54m3RyKGU4xkHkU2mnZiTTV0SUhhQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/wCP8f5GgD5xrvOEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFABQAjdV+v9KAFoAKACgAoAKACgAoAKACgAoAKACgAoAKACgDHaa91aeb7BceRb252rIAD5snp/uip32POc6uIk/ZO0V17v/IuaZf/AG63PmL5dxEdk0f91v8AA007nRh6/tY66SW6LlM6TK1L/TdStNOU5VW8+cf7I6A/U1L3scGJ/e1YUV6v5GviqO4bLGJInjPRlI/OgmUeZNFDQmLaNbBuqqUP4Ej+lJbHPgnfDxv/AFYv0zrCgAoAKACgAoAKAEP3x9D/AEoAWgAoARen4n+dAC0AFABQAHpQBJD/AKofj/OgCSgAoAKAMOz1C00v7Zb38ywTfaJJMPwZVY5BX+9xxx6U94JLWysLaTv1/wAirqcto5t4XtobVPs/mRrdSGMLk9FReCw+uRmh39531QrrTs7lKSWSfTZpZXLu2kRFmPUne1aWtJ/4okR2+Uie4OnC91g3cpS4VlNv85Vt3lrjYB1bOOnPSs1fkXLvd/n+RStze9tZDNYuN0cv2nyYryC1Vg00zBy+3OY0HfPGfam9G3Hv/XyBaqKl2/r5luaSzlu5G1mbYv2eNrctIV7fMVx/Fn056U5Kzko73/4YUXdR5trfj/ViG7aVdUuXzIbERQG6IyJSmG9s4/vd8UK2vN3+V7Ibvpy9v1f4mprpRtBPkvhGaLa0ZxwXXoR7Ukv3kU+42/cbXZlK8hawk1GCw8yNDbRSFUYkjLsGYe+0fpSi0172119wNNP3d7P7+hFJFZTC7g0sia1aycyrG5dPM/g7/e6/pmiV+V38rfqONuaNvmLElpO6xQlJLY6WxwjZXcGGfxzVVvtv+upNHeC+/wD8lFSN7eHSlsl2yNYSuqju+xMH86J/FU9P1FTtaHqvyZLp0mlxxrLaSyy3f2dmmjjkZmcgDO/0bPTODSqaKVth09XG+5RsWgmv4ooTbtHc20hljhmaUk4UjeT1b8M9aJp8s12Wn39Ag1zRfn+nUksmCwaeunMpkGnzfKjZ/e4Tg++adTefy/Nih9hPvr9xLZNaC4sjp0xeZ0Y3g8wscbOrjPDbsdeetKptK21v+GHD7N/iuv8AgiaZbxwQaJdRlxNP8sr7yS6+WxwfxAx6VU/ia8v8hL4b9b/qLokkEWpxxJJFdSSK+6eKVt/H/PVD0Pbn8qS+H+rDfxfP+vkWtdM0F1E0JYfbYzacfwsSNp/AbqmKTbi/X7t/wKk2kpLp+u34pfeZ585rHUVdnxptpJbqSerZJz/3yE/Ohu6Uu7X4b/iJK0uXtd/ft+A+T/j5n/6/7T/0FatdPWX5MzXwP/DH8y/4jMAbTvtLFYftXzkEjA2N1I6D19qiHx/J/oaz+D5ozZn221yunyA6YLmMFvMbywuPnAYchc7c445PvT7c3n/wPxv+BL68vZfnr+Bp+HwAboQzwSW4ZdiQMzohxzhjx6cDpTeyuC+LQytTuo/t0s0ZhhuYrpEG6ZmmI3KOF6KpH1BopLWPm/8APcVV6PyX6dCe6vY7e01W1kn23LXe5I8/MVJXBA9OvNEFflt3/Uc3bn9P/bRJkht31cQ/u5jcI0mwkSCEhN7Adcfe5qY/DFPa+v42/rsOV+aTW9tCO8a2S21JdKlDWYtAXMT7kWTdxg564649qpJ6X7r/AIP6Bp07P/gfqTz6Zaf2jd2/lt5S2YmC+Y2PMyw39fvcDmpbahJro9PuCKTlFPrv+H+ZV1C5jmto/tBiWZLFHWS4nYFmKk5jQdWyOuc9KqWkpNd/6+Qoaxin2J4hB501xKVFzNpkbozHDO219xHrxjNKpoppd3/X3hT1lTb7DYmsmC/2xNsRbOE2xaQr/D8xX1bPpz0qpfFK29/+GFD4Y32t/X6C63NA0jxuY1eK1DRSXUzqzEg8ogxluOT1qNdWu/T+tilb3V0/r8SKWR5ba6kkYs7w2LMT3JatLWqr/E/yRm9Yf9u/5l25WVdRk0hSwjvJVnDA/dTrIPzUf991ENbf3f6X4/kaT0+en+f4F7Xgh07D3CwL5i5MgOxufusR0U+tT1RXRmI84ksoERIY7Jbl0lJuGNux2grhv7mc8dMirtqr9v1/qxHRpd1+X9XJIoxNDZQm4WW3e/YIIXfaF8tvlDHGRnPTjtQviV+zE9nbuguLa1iWSKUAWttqSAb2+WJCikjJ6DJ/WlF35W/P9bDkrcyXk/xNTxBFBJpcbSqpijniYsTwq7xk59MZpL41f+tBvWm7djNu2sDJfG6n2yoq/YNshB27BtMeDyd2entR71tPiv8A8N8v+CHu3V/ht/w5o6tE8/haYXKbpRb7nGOjAc/rTlZTVtrr8whdw13t+hUWx0+/1gxqFlthYpsCOdv3254PNJtqE31uvyJVvd+f6FaKWSaCIy3ckRbSMtMAWKncPm45q5rV+sf1KjpZf4v0L/h6WHzbmCBIMIFJktZjJExOemejeo57UnsJb2Hrd2+m63fm9mS3WcRvE0h2q4C4OD6g9qlfDbs3+hT+K/l+rM+FLhv7MaBhC815cSRtLGWG0hiDtyDyPeqStZPpH9US9U2usv0Y2WTyoppr6VVuk1GH7QcbVVQRtI9ivPPvRG3u28/vswlf3r9l91/+HOjtb60vQxtbmKcJ97y3DY/KpaaKumc9ePD/AKc8srLqyzEWq7zvxxsCr3U9+3XNOG0bfP79fwFK13zdtPu6edwuLdGttWvWL/aLe6zE4c/IQE6f55px05bd/wD24Ulfmv2/9tJ7g2B1C9OqztHOsi/ZgHIcJtGDGB1Oc5xSheytvf8AX8rDla7vtb/h/mVNTZmv737RPBDMrD7M8sriRV2jBjUDnnOcc54NEL2Vt7/r+Vgla+u1v6+Zr6/EJdAl85Q5QKxOOmCMn8s0ac69V+YauD72f5FA2Vjd3uolQHijtYjCY5DtHDYIwevoaUm4wb63/RFJRlOK6W/Vle5laZ4Gv5YBE1lG8TXMzICxB3FcdW6e/TFVJe9K29/wM46xjfa34m7b273egx29xMZGkgCtLgqTx15wc96mpu7f0yqb011/yMV57i/02+uZtytZWbwEdP3uPnP6L+Zpyt8S6tfd/wAP+QRTuovpf/gfhr8yS6a0a5uv7SlKOsCfYwXIONvJQd23enPSlPaVt7v/AIHyCn9m+1l/wfnsVCwMVot49ukAsIjCbiZkXOPmK4/i6e/TFXP4pW3uTH4Y9i2DbmSBdcuQ0Is0MTyM0au+TuPODuxt96T3lbf/AIHT5jW0e2v/AAPwNjRmnbSLdrguZCvV/vEZ4J98YpS3/r5jjtptr93QvVJQUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAV/4m+poAKACgAoAKACgAoAKACgAoAKAA9DQBzV1/wAfU3++386AJdN/4/4/x/kaAPnGu84QoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPbfgv8A8ihd/wDYQf8A9Fx1zVviOml8J6DWJqFABQAUAFABQAUAFACN1X6/0oAWgAoAoXP9s/aG+yfYfJ42+bv3dOc4460tTlqfWuZ+z5bed7kX/FQ/9Q3/AMiUamf+2/3fxD/iof8AqG/+RKNQ/wBt/u/iH/FQ/wDUN/8AIlGof7b/AHfxD/iof+ob/wCRKNQ/23+7+If8VD/1Df8AyJRqH+2/3fxD/iof+ob/AORKNQ/23+7+If8AFQ/9Q3/yJRqH+2/3fxD/AIqH/qG/+RKNQ/23+7+If8VD/wBQ3/yJRqH+2/3fxD/iof8AqG/+RKNQ/wBt/u/iH/FQ/wDUN/8AIlGof7b/AHfxGvb65dIYJ5rOGJ+HeANvx3xnilqJwxdRcsnFJ9r3/E1LeGK0t0ghTbGgwozVHZCnGnFRjsije2Exuxfae6RXGNrhwdkg98d/ek12OarQnz+1pO0ut9mR/wDFQ/8AUN/8iUak/wC2/wB38Szp1k9qZZ7hxLdTnMjjoAOgHsKEjWhRcLym7ye/+SLu72pnSG72oAyTbarayyrYtZmB5DIBNv3KTyRx2zU69Dh9niKbapctm7636h/xUP8A1Df/ACJT1D/bf7v4h/xUP/UN/wDIlGof7b/d/EP+Kh/6hv8A5Eo1D/bf7v4h/wAVD/1Df/IlGof7b/d/EP8Aiof+ob/5Eo1D/bf7v4mpTO4KAEP3x9D/AEoAWgAoARen4n+dAC0AFABQAHpQBJD/AKofj/OgCSgAoAKAEoAMUALQAlABigAoAWgAoAKAE6UALQAUAJQAYxQAtACUALQAmKAFoAKACgAoASgA6dKADHOaAFoAKAE6UALQAmKAFoASgAxQAtAFZLJFvnvGkkkkZdihiMIvUgYHc+uaForCau7ligYYGMdqAFoAKACgBKAFoAKACgBMY6UAGM0ALQAUAFACe9AC0AJQAYoAWgAoATGaAFoAKAEoAMZoAKAFoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv/ABN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/32/nQBLpv/H/H+P8AI0AfONd5whQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAe2/Bf/kULv/sIP/6LjrmrfEdNL4T0GsTUKACgAoAKACgAoAKAEbqv1oAWgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAT+MfQ0ALQAUAIvT8T/OgBaACgAoAD0oAkh/1Q/H+dAElABQAUAVP7VsftRtftC+aDtxg4z6Z6Z9utG6uF7OxBBrtjNaPctIYkSQx/OpyTkgYGOc46CnbbzFdXfkLPrllDBDMHMiTS+WCqk7T3yMZGPTrRZ3sF1a5ZN9aiKaUzDZA22Q4Pyng/1FFv6/AL/wBfiMl1SyhuhayXCrKSBjBwCegJ6An3oSvsDaW4+6uDA9uoMY82UId5IzwTxgdeO9JauwPRXGRapZTXRtY7hWlBIxg4JHUA9CR6CmldXBtJ2J2niWdIGcCR1LKvqBjP8xSWo3oVpdXsIVVpLlRvLBRgksVOGAHcg0LUV7DjqdkLMXhuU8hjgMOcn0x1z7dabVnYE09SCHXLSQXMjSKkEDKokJPzEjOMYznPGOtFtLhdX/rzCbXrGKGGZZGkSWXyvlU5U98jGR9OtFnewXVrk0mq2MVyLeS5VZDjg5wM9AT0BPvQk3sDaSuR3+s2dgJUeVTNHGX8vn04BOMDPvS9B6XSZdhk82COTGN6hsemRVSXLJomL5opj6koKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAr/wATfU0AFABQAUAFABQAUAFABQAUAFAAehoA5q6/4+pv99v50AS6b/x/x/j/ACNAHzjXecIUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAHtvwX/5FC7/7CD/+i465q3xHTS+E9BrE1CgAoAKACgAoAKACgAIyMUAJ8w9DQAZb0H50AGW9B+dABlvQfnQAZb0H50AGW9B+dABlvQfnQAZb0H50AGW9B+dABlvQfnQAZb0H50AGW9B+dABlvQfnQAZb0H50AGW9B+dABlvQfnQAZb0H50AGW9B+dABlvQfnQAZb0H50AGW9B+dABlvQfnQAZb0H50AGW9B+dABlvQfnQAZb0H50AGW9B+dABlvQfnQAfN6D86AADHJ5NAC0AFACL0/E/wA6AFoAKACgAPSgCSH/AFQ/H+dAElABQAUAYaW19FqYNtbzwxtcF5d0qPCynOWAPzBj6AAZqo2tZkyvfTyG+RqUNr5McEyhbqR3aJo9zoxYjZuPHUZzg+lJbRv2sN3vK3V/18yO30++itXdraVmGoC4EbSqzsmAOucZ/Gquly/P8b/5k2b5vl+Fv8h13aah5GpWsNk0gu5PMSTzECgELkHJznj0x70o292/R/rccrvma6r9LEl3bXy6jJJY288bySIS4lRoZAMZLK3IOBj5R2HNELbPb+tgnfdb/wBbl7UraW4lsWiTcIbkSPyBhdrDP6ilHSd32Y5K8ben5lG0tr6DUEENvPBb+Y7SpJKjxYOeU/iBJIPYdacbW17Cle913LV/FcJqdpewW7XCxpJG6IyhhuwQRuIB+7696UdG/McldLyZlRpd2d/ppksy8267cxI6kgMwPBJA6EdxTh1X91Eyve/n+hYWxvUKX32bLi9ac2wddwUrt65xu79e55oWll5P8Xf/AIA2nK/qvw0EaDVN93cR2skHn3COURozIUCYOMkqGyB/Q0KyST8/xB3bb8l+YyHT75ElmNrMx+3RzqkkqNIyhQDznGfbNNNJJev43E0238vwYlxpd20l5C0N3LFdS7x5c0aR4OMhs8gj2B6ClGyt5f53G76vv/lYmurW9jj1S2isjci9y0cm9QBlAuGyQeMcYB69qneKXb/O41pK/oaloZ02wSW5RI4kxJvB3NjkY9v61c2nJvzJgmopeRaqCwoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv8AxN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/j6m/32/nQBLpv/AB/x/j/I0AfONd5whQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAe2/Bf/AJFC7/7CD/8AouOuat8R00vhPQaxNQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoARen4n+dAC0AFABQAHpQBJD/qh+P8AOgCSgAoAKACgAoAKACgAoAKACgAoAaY0aRZCil1BCsRyM9cGgB1ABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/wCP8f5GgD5xrvOEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAi9PxP86AFoAKACgAPSgCSH/VD8f50ASUAFABQA0sF4J59KAE8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgBwIYZBzQAtABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAV/wCJvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/4/x/kaAPnGu84QoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPbfgv/wAihd/9hB//AEXHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAIvT8T/OgBaACgAoAD0oAkh/1Q/H+dAElABQAUAMj+4G7tyaAH0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFADDw6kd+DQA+gAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAK/8TfU0AFABQAUAFABQAUAFABQAUAFAAehoA5q6/4+pv8Afb+dAEum/wDH/H+P8jQB8413nCFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQB7b8F/wDkULv/ALCD/wDouOuat8R00vhPQaxNQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoARen4n+dAC0AFABQAHpQBJD/qh+P86AJKACgAoAZH/qk/3RQA+gAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAinuIbaPfM4RenNZ1KsKUeabsi4U5Tdoq5W/tnT/+fj/xxv8ACub6/hv5vwf+Rv8AVK38v5B/bOn/APPx/wCON/hR9fw/834P/IPqlf8Al/IT+2tP/wCfj/xxv8KPr+H/AJvwf+QfU6/8v4oP7a0//n4/8cb/AAo+v4f+b8H/AJB9Tr/y/ig/trTv+fj/AMcb/Cn9ew/834P/ACD6nX/l/FB/benf8/H/AI43+FH17D/zfg/8g+p1/wCX8UH9t6d/z8f+ON/hR9ew/wDN+D/yD6nX/l/FFyKaOeMSROHQ9CK6oTjNc0XdHPKMoO0lqD/eT/e/oaokfQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8fU3++386AJdN/4/wCP8f5GgD5xrvOEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAi9PxP86AFoAKACgAPSgCSH/VD8f50ASUAFABQAyP/VJ/uigB9ABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBheJGINuM8fN/SvGzX7Hz/Q9TLl8Xy/Uwt1eNY9WwbqdgsJuosOwm6nYLBup2HYTdRYLCbqdh2Om8NEnT5Oekp/kK93Lv4T9f8AI8PMV+9Xp/mar/eT/e/oa9E88fQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8AH1N/vt/OgCXTf+P+P8f5GgD5z8xvRf8AvkV3nCHmN6L/AN8igA8xvRf++RQAeY3ov/fIoAPMb0X/AL5FAB5jei/98igA8xvRf++RQAeY3ov/AHyKADzG9F/75FAB5jei/wDfIoAPMb0X/vkUAHmN6L/3yKADzG9F/wC+RQAeY3ov/fIoAPMb0X/vkUAHmN6L/wB8igA8xvRf++RQAeY3ov8A3yKADzG9F/75FAB5jei/98igA8xvRf8AvkUAHmN6L/3yKADzG9F/75FAB5jei/8AfIoA9s+DBz4Quzx/yEH6D/pnHXNW+I6aXwnoFYmoUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAIvT8T/OgBaACgAoAD0oAkh/1Q/H+dAElABQAUAMj/1Sf7ooAfQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAc/wCJzg23/Av6V5GZ/Y+f6HrZb9r5fqYO6vIsetY0tKlt1jmDPFHcHHlvMuVHr9K78K4KDV0peexxYqM21ZNx623JpLL7Tf7ZoCn7rd/owBEnuOw/GrdBTqvmjbTp18+yM41uSleMr69en+Y2bR40eVFeTf5HmxqcZ46g4/pU1MJGPMk9Uk/l1HDFyaTaVr2YRaNG7qrPJuSESSquM5PQDP8AWrjg4czV3olfbdhLFySuktXZfLqU9UshYyR7GYpIuQGxuX1BxXNiKHsp2Wx04as6qd90Ud1YWOqx1Hhc50+T/rqf5Cvby/8AhP1/yPCzL+MvT9Wa7/eT/e/oa9A80fQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAFf+JvqaACgAoAKACgAoAKACgAoAKACgAPQ0Ac1df8AH1N/vt/OgCXTf+P+P8f5GgD5xrvOEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAm+zSf883/wC+adgIsH0pAP8As8//ADxk/wC+TQA/7Def8+k//fs0XGJ9juv+fab/AL4NK6DlfYT7Lc/8+8v/AHwaYiKgAoA9t+C//IoXf/YQf/0XHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAIvT8T/OgBaACgAoAD0oAkh/1Q/H+dAElABQAUAMj/1Sf7ooAfQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAc74qODa/8D/pXk5l9n5/oevln2/l+pz+6vKsexYtWmpPaxvCYo5onOSkgyM+tdFOs4R5Wk15mFXDqo1K7TXYl/tycu26KIxMgj8rBCgDpir+sybfMk07aemxn9ShZWbve9+oxtZnN1DcCOJTCuxVVTtx6EZo+sT9oqlltbyKWEhyShd6jV1ecXU07LG/njEkbD5SKUa8lKTet9ynhYOEYLS2z6kF1d/apA3lRRBRgLGuBj+tZ1Jc8r2t6GtKl7NWu36lfdU2NbHV+FTnTZf8Arsf5CvYwH8J+v+R4GZ/xl6fqzZf7yf739DXeeYPoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgCv/E31NABQAUAFABQAUAFABQAUAFABQAHoaAOauv+Pqb/AH2/nQBLpv8Ax/x/j/I0AfONd5whQB0vg20guZbp5vDVxrnlhQFilKCLOeTjrnHH0NRN+di4ryudV/Z9j/0S+8/8CGqLv+Yuy/lOI8U28dvrTrFo8ukKyKwtZXLFfcE9jitI7bmct9j0Gx0+3eXQ7NdK8PPa3GnwyXPnRp9qclTuKgfMT05x1zSrW9pUTvo3sUrqMbW17+pyul+E9P1a4mVZ9RQteNAkMFg8n2dc8GVjgDtkdR/KYuXJHu0OUVzy8mPutBt7Pwu1pcGGO4i19rV7wQlmCCP2G4jPO31rS/M6bWl4v77hUg6akn5firjrrwHCttDc21zeiL7ZHayfa7Mwlg5ADpk8jnvWaqe9FPr/AFqS4+7Jrp+JHqPgzToYdWTT9YkuLzSfmmieDarLnBw2eo/nSVRtRklo2l83ovxLdNKXI3ra5Ff+FdI03zLG713ydVigErRtD+53EZ8vfnOcEc4qnN6uKul+PoSorTmdr/h6l6z+HDXFvaxSXF2l7dwechWzZrePIyFeTPBP6fzdSfK5JdP60FTipRUns/y7nESRtFI0bqVZCVYHsRVJpq6FKLjJxfQbTJCgAoA6P7Lc/wDPvL/3wau4zn6gRvYqCjY3L6j86LMLoo/a7b/n4i/77FRZm/Mu4vlSf882/KrujCzOTqyQoA9t+C//ACKF3/2EH/8ARcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAi9PxP86AFoAKACgAPSgCSH/VD8f50ASUAFABQAyP/AFSf7ooAfQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAY/iDTZ76KJoAGeMn5ScZBx/hXFi6EqqTj0PQwOIhRk1PZmB/Yep/8APqf++1/xrzvqdb+X8j1fr2G/m/B/5B/Yep/8+p/77X/Gn9Trfy/kP69hv5vwf+Qn9han/wA+p/77X/Gj6nW/l/IPr2G/m/B/5B/YWqf8+p/77X/Gj6pW7fkP6/hv5vwf+Qn9hap/z6n/AL7X/Gn9UrdvyD6/hv5vwf8AkH9hap/z6n/vtf8AGj6pW7fkH1/Dfzfg/wDIT+wdU/59T/32v+NP6pW7fkP6/hv5vwf+R0+hWEmn2HlzEb3cuQO3Qf0r08NSdKFmeHja8a9XmjtsaD/eT/e/oa6DjH0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBX/ib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/H1N/vt/OgCXTf+P8Aj/H+RoA+ca7zhCgDr/AXiyy8MrqUd79qVbxY9ktsqsyFd3ZuP4vfpWc4uVrGkJKJ2MfxU0BLkTNNrMihQvlNDDt6YzwQc9+ves/Zsv2iPP8Axv4gtvEviJ9QtI5I4fLWNRKAGOOpIBPc1tCPKrGc5czuXk8Y6Sz6bc3Xhxp7vTYIoYpftzKp8voSoX15xmqlzOcpxdrtv7xXVkmtieD4go1vH9u06aWaC6e4QQXbRRuXfcQ6gHOD0rPktZrorFyqOV79f8rECePGjuPOTTVz/azajhpcjlduz7vvnd+lUo2UV2TX3u4VantHe3b8ETXPj22MDwW2mXJD3cV00lzemRiUbdt5Xgdh6e9ZqlrDX4X+lhSmnzd5f53M0eK8XevXH2L/AJDKMuPN/wBTls+nzfpVcjVNQT2af3O4TnzVvaW6W/BL9CzeeLdM1ASXt34fjm1aWAQvO82YiQuPM2Y+9x60Sg9VF2T/AK0BTWnMr2/rUnj8dwPaW5vdOuJry2gEKtHevHFIAMAug7j2PPtTnByba6ihJRiotaL+rHHMxdixOSTk81aVlYlu7uJQIKAHKjOcKpY+gGaAO8/tKw/5/bf/AL+r/jQM4fyZf+eT/wDfJpDNzcPUUCLX2y1/5+Yf++xVGVmctketI0Oz+32f/P3B/wB/BWFmbXRxNbmIUAe2/Bf/AJFC7/7CD/8AouOuat8R00vhPQaxNQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoARen4n+dAC0AFABQAHpQBJD/qh+P8AOgCSgAoAKAGR/wCqT/dFAD6ACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgBj/eT/e/oaAH0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBX/ib6mgAoAKACgAoAKACgAoAKACgAoAD0NAHNXX/H1N/vt/OgCXTf8Aj/j/AB/kaAPnGu84QoAsWlhdXzMttEZCgy3IGPzobsNK5a/4R7Vf+fX/AMiL/jS5kPlYf8I9qv8Az6/+RF/xo5kHKw/4R7Vf+fX/AMiL/jRzIOVh/wAI9qv/AD6/+RF/xo5kHKw/4R7Vf+fX/wAiL/jRzIOVh/wj2q/8+v8A5EX/ABo5kHKw/wCEe1X/AJ9f/Ii/40cyDlYf8I9qv/Pr/wCRF/xo5kHKw/4R7Vf+fX/yIv8AjRzIOVh/wj2q/wDPr/5EX/GjmQcrD/hHtV/59f8AyIv+NHMg5WH/AAj2q/8APr/5EX/GjmQcrJrbRdVt5C/2PdkYx5qj+tJtBZkP/CPar/z6/wDkRf8AGnzIOVl/7Dqv/QP/APIy1N0OzD7Dqv8A0D//ACMtF0FmUP8AhHtV/wCfX/yIv+NVzIXKw/4R7Vf+fX/yIv8AjRzIOVkVzpF/Zwmae3KRg4LbgcfkaLpisylTEFAHtvwX/wCRQu/+wg//AKLjrmrfEdNL4T0GsTUKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/ADoAkoAKACgBgJTggkdiBmgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5i+jf98mgA8xfRv++TQAeYvo3/fJoAPMX0b/AL5NAB5i+jf98mgA8xfRv++TQAeYvo3/AHyaADzF9G/75NAB5g9G/wC+TQADLMGIwB0FAD6ACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAr/wATfU0AFABQAUAFABQAUAFABQAUAFAAehoA5q6/4+pv99v50AS6b/x/x/j/ACNAHzjXecIUAWLS/urFma2lMZcYbgHP50NXGnYtf8JDqv8Az9f+Q1/wpcqHzMP+Eh1X/n6/8hr/AIUcqDmYf8JDqv8Az9f+Q1/wo5UHMw/4SHVf+fr/AMhr/hRyoOZh/wAJDqv/AD9f+Q1/wo5UHMw/4SHVf+fr/wAhr/hRyoOZh/wkOq/8/X/kNf8ACjlQczD/AISHVf8An6/8hr/hRyoOZh/wkOq/8/X/AJDX/CjlQczD/hIdV/5+v/Ia/wCFHKg5mH/CQ6r/AM/X/kNf8KOVBzMP+Eh1X/n6/wDIa/4UcqDmYf8ACQ6r/wA/X/kNf8KOVBzMP+Eh1X/n6/8AIa/4UcqDmYf8JDqv/P1/5DX/AAo5UHMw/wCEh1X/AJ+v/Ia/4UcqDmYf8JDqv/P1/wCQ1/wo5UHMw/4SHVf+fr/yGv8AhRyoOZkVzq9/eQmGe4Lxk5K7QM/kKLJCuylTEFAHtvwX/wCRQu/+wg//AKLjrmrfEdNL4T0GsTUKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAEXp+J/nQAtABQAUAB6UASQ/6ofj/ADoAkoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAr/xN9TQAUAFABQAUAFABQAUAFABQAUAB6GgDmrr/AI+pv99v50AS6b/x/wAf4/yNAHzniP8AvN/3z/8AXrvOEMR/3m/75/8Ar0AGI/7zf98//XoAMR/3m/75/wDr0AGI/wC83/fP/wBegAxH/eb/AL5/+vQAYj/vN/3z/wDXoAMR/wB5v++f/r0AGI/7zf8AfP8A9egAxH/eb/vn/wCvQAYj/vN/3z/9egAxH/eb/vn/AOvQAYj/ALzf98//AF6ADEf95v8Avn/69ABiP+83/fP/ANegAxH/AHm/75/+vQAYj/vN/wB8/wD16ADEf95v++f/AK9ABiP+83/fP/16ADEf95v++f8A69ABiP8AvN/3z/8AXoAMR/3m/wC+f/r0AGI/7zf98/8A16ADEf8Aeb/vn/69AHtnwYx/wiF3gkj+0H6/9c465q3xHTS+E9ArE1CgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgBF6fif50ALQAUAFAAelAEkP8Aqh+P86AJKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAK/wDE31NABQAUAFABQAUAFABQAUAFABQAHoaAMabS55J5HDx4ZiRkn1+lAD7TTpoLlJXZCFznBOen0oA+Z67zhCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA9t+C//IoXf/YQf/0XHXNW+I6aXwnoNYmoUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAIvT8T/OgBaACgAoAD0oAkh/1Q+poAkoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoArD7zfU0ALQAUAFABQAUAFABQAUAFABQAHoaAI6ACgD5VrvOEKAHxRSTSLFFG0jscKqjJJ9AKANx/AniiO1Ny2i3HlgZwMFv++Qc/pU88e5fJLsYJBUkEEEdQaogSgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAi9PxP86AFoAKACgAoAQM0RJAyD1FADvtI/55v+n+NAB9pH/PN/0/xoAPtI/55v8Ap/jQAfaR/wA83/T/ABoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/wCeb/p/jQAfaR/zzf8AT/GgA+0j/nm/6f40AH2kf883/T/GgA+0j/nm/wCn+NAB9pH/ADzf9P8AGgA+0j/nm/6f40AH2kf883/T/GgA+0j/AJ5v+n+NAB9pH/PN/wBP8aAD7SP+eb/p/jQAfaR/zzf9P8aAD7SP+eb/AKf40AH2kf8APN/0/wAaAD7SP+eb/p/jQAfaR/zzf9P8aAD7SP8Anm/6f40AH2kf883/AE/xoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/55v8Ap/jQAfaR/wA83/T/ABoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/wCeb/p/jQAfaR/zzf8AT/GgA+0j/nm/6f40AH2kf883/T/GgA+0j/nm/wCn+NAB9pH/ADzf9P8AGgA+0j/nm/6f40AH2kf883/T/GgA+0j/AJ5v+n+NAB9pH/PN/wBP8aAD7SP+eb/p/jQAfaR/zzf9P8aAD7SP+eb/AKf40AH2kf8APN/0/wAaAD7SP+eb/p/jQAfaR/zzf9P8aAD7SP8Anm/6f40AH2kf883/AE/xoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/55v8Ap/jQAfaR/wA83/T/ABoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/wCeb/p/jQAfaR/zzf8AT/GgA+0j/nm/6f40AH2kf883/T/GgA+0j/nm/wCn+NAB9pH/ADzf9P8AGgA+0j/nm/6f40AH2kf883/T/GgA+0j/AJ5v+n+NAB9pH/PN/wBP8aAD7SP+eb/p/jQAfaR/zzf9P8aAD7SP+eb/AKf40AH2kf8APN/0/wAaAD7SP+eb/p/jQAfaR/zzf9P8aAD7SP8Anm/6f40AH2kf883/AE/xoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/55v8Ap/jQAfaR/wA83/T/ABoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/wCeb/p/jQAfaR/zzf8AT/GgA+0j/nm/6f40AH2kf883/T/GgA+0j/nm/wCn+NAB9pH/ADzf9P8AGgA+0j/nm/6f40AH2kf883/T/GgA+0j/AJ5v+n+NAB9pH/PN/wBP8aAD7SP+eb/p/jQAfaR/zzf9P8aAD7SP+eb/AKf40AH2kf8APN/0/wAaAD7SP+eb/p/jQAfaR/zzf9P8aAD7SP8Anm/6f40AH2kf883/AE/xoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/55v8Ap/jQAfaR/wA83/T/ABoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/wCeb/p/jQAfaR/zzf8AT/GgA+0j/nm/6f40AH2kf883/T/GgA+0j/nm/wCn+NAB9pH/ADzf9P8AGgA+0j/nm/6f40AH2kf883/T/GgA+0j/AJ5v+n+NAB9pH/PN/wBP8aAD7SP+eb/p/jQAfaR/zzf9P8aAD7SP+eb/AKf40AH2kf8APN/0/wAaAD7SP+eb/p/jQAfaR/zzf9P8aAD7SP8Anm/6f40AH2kf883/AE/xoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/55v8Ap/jQAfaR/wA83/T/ABoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/wCeb/p/jQAfaR/zzf8AT/GgA+0j/nm/6f40AH2kf883/T/GgA+0j/nm/wCn+NAB9pH/ADzf9P8AGgA+0j/nm/6f40AH2kf883/T/GgA+0j/AJ5v+n+NAB9pH/PN/wBP8aAD7SP+eb/p/jQAfaR/zzf9P8aAD7SP+eb/AKf40AH2kf8APN/0/wAaAD7SP+eb/p/jQAfaR/zzf9P8aAD7SP8Anm/6f40AH2kf883/AE/xoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/55v8Ap/jQAfaR/wA83/T/ABoAPtI/55v+n+NAB9pH/PN/0/xoAPtI/wCeb/p/jQAfaR/zzf8AT/GgA+0j/nm/6f40AI07OMIpX3NACKMDFAC0AFABQAUAFABQAUAFABQAUAB6GgCOgAoA+Va7zhCgDvvhXodlq93qb3YJaKFFjx1XcTlh7jaPzrKo2rGtNJ3NPT/F+rat4m/4Ra5mUWZmaE3CjEroucZbOPm4H4jr3lxSXMNSbfKc58TdMs9L8WmOyQIktukjIDwrcr/JQfxq6bbjqTUSTNDxDpFlqFjoMtzrlpYMulQqI51ckjnngGnN2rVPUrejFepo6v4Zg1vxhrFzcLJPFY29vtghlWIysyAD5n4A4NQm4wcu8n/wTSUeZU1fTl/VkMXh630NtVktWdY7vQLh2gklSR4WBXKll4I5GDVOTdOUe0o6/eZqKVnto/yKp8M+F01XTNGlW/F1qVrHIJlkXbEzDjjHOSD9OKcuZynGPRv8DKLiqcJz+1b8dDn/AAxYTJ43tLUW63TW91+8UkbcIfmJz2GM1VKopQ9psrX9LoVWFpci7/fZ/qdN8Q7a7v7G3ngDahbWqvO2pkoFZHfCouDyF6etc9P3Za6aJevmdUvei1HW7b9Eun9b/li+CtYstNi1GGW+GmXlyiLbX5g83ysH5hjtnjmuiacoJLv95zwaUrvt9xtz6Pda9q0A12WzvIxp80sGoWDYNzsxjee5XOOg69655y9nGckrNJadPX5msVzShFu6b+foZnhvwrpuq6bpNxc+dvu9Re2k2vgbBGWGOOuRW83aSX91v7mYR1Un2kl96El0DQL6x1FtLF7FNpU8aSGZ1ZZ0Z9hIAHynOf8APSaUnLkk9pW/E0qRSU4rdJv7ty9eeFfDcmu6j4eshfR31vA0sU7yKYywUNtIxnGD1rN1JKk6nRflcrlgqkYP7X4aXILfwtoEV9puhXpvTqOoW6y/aY3URxMwJVduORxyc/8A1tZOTlOMPs/ormUZQUIzl9q34uyK8ujaBo3hq1vdUgu7m8nmng2QyhUyjbd3Tt+uaiNRz5eXZpM2dNRUm+jsN+Ikemw6jYx2No1u5s43c5G0qR8vAA565PeiF/aVE+j/AERmnF0YNLdL7vPzOQrYgKACgAoAKAPbfgv/AMihd/8AYQf/ANFx1zVviOml8J6DWJqFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACL0/E/zoAWgAoAKACgAoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABigAxQAYoAMUAGKADFABQAUAFABQAUAFABQAUAFABQAUAFAAehoAjoAKAPlWu84QoA0dF1m40W6eWEtslTy5kV9u9CQSM9ulJq407He3nxL8PT6J9jj0KcOFAVNyqqkdDv5Pr2/nWSpyve5q6itseeapqVzq+oSXt3I0ksmASxycAYA/IVqlZWMm7kuqazcautmtwkSiztlto/LBGVXoTknnmm1eTl3HzPlUe36mn/AMJtqD6nd3k9raTR3sSRXFq6ExOqgAd8gjHXNTyKzT73+ZXtJe75K3yI5PFtyZrhrfT7G1insmsvKiiICxsck5zktx1OfpRy+603u0/uFzWtZd/xNzVfHcFvcWEmlWtldTW1jHGl3LC3mQPghgM4zjtwepqZRcpzd7Xb+4VOXLThF9EvvOU0rWrzSNWXU7dlecFt3mjcrhuoYdwc1fKuVwtpawm25c3W9zVvvGtxd6JLosWl2FrYyHd5cSuCrZzuB3evbpUOndpt7F89k0lvuUtE8Rz6NBcWptLa9s7raZbe5QspI6EYIwauSUkk+hnH3XdF1vHOorqdpeW9tZ28VlG8UNokR8oK33gRnJz357UuRPm5tb6MpvaytbU0NH8cq2raZDeWljp2mWl0Z/8ARoWG0lGXsTnr6ZpcnW+tmgctLJdUynf+MWuWmtbezs7S3uboSXM8ERV7gK2QWyePXAHWijGzg59Ladn1HXleM1Drdf1+pf8AEnjtJNX1F9HtrM/aE8ldQETLMYyoyOcc54zjOBWcaV4Wl/Wpo6tpJrpsZtr45vba3t82NjNe2kXk297JGTLGmCB3wSM8EitZx5m3e19zKMuVJWvbYyrzW7q+0m002YRmO0eR0cA72LnJ3HPPPtQoJO67WK9pJxcX1dyTWfEE2uQ2i3VrbrNbRiLz41IeRQMANzjj2FHL77kuv5kJ2godtvTsZVUIKACgAoAKAPbfgv8A8ihd/wDYQf8A9Fx1zVviOml8J6DWJqFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACL0/E/wA6AFoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAA9DQBHQAUAfKtd5whQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAe2/Bf/kULv8A7CD/APouOuat8R00vhPQaxNQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoARen4n+dAC0AFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAAehoAx9f1W70awN7b6d9tjjyZgJdjIv97G05Hr6fTOACxpV1d3tglxe2P2KSTkQmTewXtu4GD7dvrwAD5hrvOEKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD234L/8ihd/9hB//Rcdc1b4jppfCeg1iahQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAi9PxP86AFoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAA9DQBHQAUAf/9k=";
function Ji(A) {
  return BA({ attr: { viewBox: "0 0 15 15", fill: "none" }, child: [{ tag: "path", attr: { fillRule: "evenodd", clipRule: "evenodd", d: "M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z", fill: "currentColor" }, child: [] }] })(A);
}
const { Item: So } = j, Zi = ({ url: A }) => {
  const [o] = j.useForm(), { handleSave: e, mutation: t } = us({ form: o, url: A }), { isLoading: n } = t, { isLoading: r } = Us({ form: o });
  return /* @__PURE__ */ C(j, { layout: "vertical", form: o, children: /* @__PURE__ */ h("div", { className: "at-flex at-flex-col md:at-flex-row at-gap-8", children: [
    /* @__PURE__ */ C("div", { className: "at-w-full at-max-w-[400px]", children: /* @__PURE__ */ h(Br, { spinning: r, children: [
      /* @__PURE__ */ C(
        So,
        {
          className: "at-mt-4",
          name: ["powerhouse_settings", "bunny_library_id"],
          label: "Bunny Library ID",
          children: /* @__PURE__ */ C(J, { allowClear: !0, placeholder: "xxxxxxx" })
        }
      ),
      /* @__PURE__ */ C(
        So,
        {
          name: ["powerhouse_settings", "bunny_cdn_hostname"],
          label: "Bunny CDN Hostname",
          children: /* @__PURE__ */ C(J, { allowClear: !0, placeholder: "xx-xxxxxxxx-xxx.b-cdn.net" })
        }
      ),
      /* @__PURE__ */ C(
        So,
        {
          name: ["powerhouse_settings", "bunny_stream_api_key"],
          label: "Bunny Stream API Key",
          children: /* @__PURE__ */ C(
            J,
            {
              allowClear: !0,
              placeholder: "xxxxxxxx-xxxx-xxxx-xxxxxxxxxxxx-xxxx-xxxx"
            }
          )
        }
      ),
      /* @__PURE__ */ C(So, { label: null, children: /* @__PURE__ */ C(
        D,
        {
          type: "primary",
          onClick: e,
          loading: n,
          children: "儲存"
        }
      ) })
    ] }) }),
    /* @__PURE__ */ h("div", { className: "at-flex-1", children: [
      /* @__PURE__ */ C("p", { className: "at-font-bold at-mb-4", children: "說明" }),
      /* @__PURE__ */ C(
        to,
        {
          message: "沒有 Bunny 帳號？",
          className: "mb-4",
          description: /* @__PURE__ */ h(k, { children: [
            "若還沒有 Bunny 帳號，可以",
            /* @__PURE__ */ h(
              "a",
              {
                href: "https://bunny.net?ref=wd7c7lcrv4",
                target: "_blank",
                rel: "noopener noreferrer",
                className: "at-ml-2 at-font-bold",
                children: [
                  "點此申請 ",
                  /* @__PURE__ */ C(Ji, { className: "at-relative at-top-0.5" })
                ]
              }
            )
          ] }),
          type: "info",
          showIcon: !0
        }
      ),
      /* @__PURE__ */ h("div", { className: "at-mb-4", children: [
        /* @__PURE__ */ C("p", { children: "1. 前往 Bunny 後台，選擇 「Stream」 並進入 「Library」" }),
        /* @__PURE__ */ C(
          Yo,
          {
            src: Ei,
            ratio: "aspect-[2.1]",
            className: "at-w-full"
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "at-mb-4", children: [
        /* @__PURE__ */ C("p", { children: "2. 進入「API」分頁，複製 Library ID 、 CDN Hostname 和 Stream API Key" }),
        /* @__PURE__ */ C(
          Yo,
          {
            src: qi,
            ratio: "aspect-[2.1]",
            className: "at-w-full"
          }
        )
      ] })
    ] })
  ] }) });
}, Yi = x(Zi), _i = (A) => {
  const { uploadProps: o, tabsProps: e } = A, t = hr(null), [n, r] = L(!1), { uploadProps: a } = Oi(o);
  $(() => {
    if (t.current) {
      const K = (f) => {
        var U;
        f.preventDefault(), f.stopPropagation();
        const c = f.relatedTarget;
        (U = t.current) != null && U.contains(c) || r(!0);
      }, F = (f) => {
        var U;
        f.preventDefault(), f.stopPropagation();
        const c = f.relatedTarget;
        (U = t.current) != null && U.contains(c) || r(!1);
      }, Q = (f) => {
        r(!1);
      };
      return t.current.addEventListener("dragenter", K), t.current.addEventListener("dragleave", F), t.current.addEventListener("drop", Q), () => {
        var f, c, U;
        (f = t.current) == null || f.removeEventListener("dragenter", K), (c = t.current) == null || c.removeEventListener("dragleave", F), (U = t.current) == null || U.removeEventListener("drop", Q);
      };
    }
  }, []);
  const { bunny_library_id: g, bunny_stream_api_key: s, bunny_cdn_hostname: i } = FA(), l = !g || !s || !i, B = [
    {
      key: "bunny-media-library",
      label: "Bunny 媒體庫",
      children: /* @__PURE__ */ C(Mi, {}),
      icon: /* @__PURE__ */ C(Et, {}),
      disabled: l
    },
    {
      key: "bunny-settings",
      label: "Bunny 設定",
      children: /* @__PURE__ */ C(Yi, {}),
      icon: /* @__PURE__ */ C(Ir, {})
    }
  ];
  return /* @__PURE__ */ C(fs.Provider, { value: A, children: /* @__PURE__ */ C("div", { className: "at-relative", children: /* @__PURE__ */ h("div", { ref: t, className: "at-relative", children: [
    /* @__PURE__ */ C(
      "div",
      {
        className: `at-absolute at-top-0 at-left-0 at-size-full ${n ? "at-opacity-100 at-z-50" : "at-opacity-0 -at-z-50"}`,
        children: /* @__PURE__ */ C(ds, { uploadProps: a })
      }
    ),
    /* @__PURE__ */ C(
      dg,
      {
        className: n ? "at-opacity-0" : "at-opacity-100",
        tabBarExtraContent: /* @__PURE__ */ C(Qe, { ...a, children: /* @__PURE__ */ C(D, { disabled: l, icon: /* @__PURE__ */ C(kt, {}), children: "上傳影片" }) }),
        defaultActiveKey: l ? "bunny-settings" : "bunny-media-library",
        items: B,
        type: "card",
        ...e
      }
    )
  ] }) }) });
}, $i = x(
  _i
), { stringify: Bo } = St, AC = (A, o) => ({
  getList: async ({ resource: e, pagination: t, filters: n, sorters: r, meta: a }) => {
    var d;
    const g = `${A}/${e}`, { current: s = 1, pageSize: i = 20, mode: l = "server" } = t ?? {}, { headers: B, method: K } = a ?? {}, F = K ?? "get", Q = Ao(n), f = {};
    l === "server" && (f.page = s, f.itemsPerPage = i);
    const { data: c } = await o[F](
      `${g}?${Bo(f)}&${Bo(Q, { arrayFormat: "bracket" })}`,
      {
        headers: B
      }
    ), U = (c == null ? void 0 : c.totalItems) || ((d = c == null ? void 0 : c.items) == null ? void 0 : d.length) || 0;
    return {
      data: (c == null ? void 0 : c.items) || [],
      total: U
    };
  },
  getMany: async ({ resource: e, ids: t, meta: n }) => {
    const { headers: r, method: a } = n ?? {}, g = a ?? "get", { data: s } = await o[g](
      `${A}/${e}?${Bo({ id: t }, { arrayFormat: "bracket" })}`,
      { headers: r }
    );
    return {
      data: s
    };
  },
  create: async ({ resource: e, variables: t, meta: n }) => {
    const r = `${A}/${e}`, { headers: a, method: g } = n ?? {}, s = g ?? "post", { data: i } = await o[s](r, t, {
      headers: a
    });
    return {
      data: i
    };
  },
  update: async ({ resource: e, id: t, variables: n, meta: r }) => {
    const a = `${A}/${e}/${t}`, { headers: g, method: s } = r ?? {}, i = s ?? "post", { data: l } = await o[i](a, n, {
      headers: g
    });
    return {
      data: l
    };
  },
  getOne: async ({ resource: e, id: t, meta: n }) => {
    const r = `${A}/${e}/${t}`, { headers: a, method: g } = n ?? {}, s = g ?? "get", { data: i } = await o[s](r, { headers: a });
    return {
      data: i
    };
  },
  deleteOne: async ({ resource: e, id: t, variables: n, meta: r }) => {
    const a = `${A}/${e}/${t}`, { headers: g, method: s } = r ?? {}, i = s ?? "delete";
    return {
      data: (await (o == null ? void 0 : o[i](a, {
        data: n,
        headers: g
      }))).data
    };
  },
  getApiUrl: () => A,
  custom: async ({
    url: e,
    method: t,
    filters: n,
    sorters: r,
    payload: a,
    query: g,
    headers: s
  }) => {
    let i = `${e}?`;
    if (r) {
      const K = Jo(r);
      i = `${i}&${K}`;
    }
    if (n) {
      const K = Ao(n);
      i = `${i}&${Bo(K, { arrayFormat: "bracket" })}`;
    }
    g && (i = `${i}&${Bo(g, { arrayFormat: "bracket" })}`), s && (o.defaults.headers = {
      ...o.defaults.headers,
      ...s
    });
    let l;
    switch (t) {
      case "put":
      case "post":
      case "patch":
        l = await o[t](e, a);
        break;
      case "delete":
        l = await o.delete(e, {
          data: a
        });
        break;
      default:
        l = await o.get(i);
        break;
    }
    const { data: B } = l;
    return Promise.resolve({ data: B });
  }
}), FA = () => Nt(st), Un = "https://video.bunnycdn.com/library", st = pr({
  bunny_library_id: "",
  bunny_stream_api_key: "",
  bunny_cdn_hostname: "",
  bunny_stream_axios: bt,
  bunny_data_provider_result: {}
}), Vf = ({
  children: A,
  bunny_library_id: o,
  bunny_stream_api_key: e,
  bunny_cdn_hostname: t
}) => {
  const n = Nt(st), r = vg(() => {
    const a = bt.create({
      baseURL: Un,
      headers: {
        AccessKey: e
      }
    });
    return {
      ...n,
      bunny_library_id: o,
      bunny_stream_api_key: e,
      bunny_cdn_hostname: t,
      bunny_stream_axios: a,
      bunny_data_provider_result: AC(
        Un,
        a
      )
    };
  }, [
    o,
    e,
    t,
    n
  ]);
  return /* @__PURE__ */ C(st.Provider, { value: r, children: A });
}, Vr = ls([]), oC = 3e4, Mf = () => {
  const { colorPrimary: A } = Yg(), { bunny_library_id: o } = FA(), e = kA(), [t, n] = Dr(Vr), r = t.some((i) => i.isEncoding) && t.every((i) => i.encodeProgress !== 100) && !!t.length, { data: a, isFetching: g } = Li({
    queryOptions: {
      enabled: r,
      refetchInterval: oC
    }
  }), s = (a == null ? void 0 : a.data) || [];
  return $(() => {
    const i = t.every(
      (B) => B.isEncoding
    );
    let l = null;
    return i ? () => {
      clearInterval(l);
    } : (l = setInterval(() => {
      n((B) => B.map((K) => {
        const { file: F } = K, f = 100 / cs(
          (F == null ? void 0 : F.size) || 11907162
        ) * 3, c = K.uploadProgress + f;
        return c < 100 ? {
          ...K,
          uploadProgress: Number(c.toFixed(1))
        } : K;
      }));
    }, 3e3), () => {
      clearInterval(l);
    });
  }, [t]), $(() => {
    t != null && t.length ? Mo.open({
      key: "bunny-files-uploading",
      icon: /* @__PURE__ */ C(kt, { style: { color: A } }),
      message: "檔案上傳中",
      description: /* @__PURE__ */ C(k, { children: t == null ? void 0 : t.map((i) => /* @__PURE__ */ C(
        Vg,
        {
          fileInQueue: i
        },
        `${i == null ? void 0 : i.key}-${(/* @__PURE__ */ new Date()).getTime()}`
      )) }),
      duration: null,
      onClose: () => {
        n && n([]);
      }
    }) : Mo.destroy("bunny-files-uploading");
  }, [t]), $(() => {
    g || n((i) => {
      const l = i.map((B) => {
        const K = s.find(
          (F) => F.guid === B.videoId
        );
        return K ? {
          ...B,
          encodeProgress: K.encodeProgress
        } : B;
      }).filter((B) => B.encodeProgress !== 100);
      return l.length < i.length && e({
        dataProviderName: "bunny-stream",
        resource: `${o}/videos`,
        invalidates: ["list"]
      }), l;
    });
  }, [g]), /* @__PURE__ */ C(k, {});
}, eC = ({
  modalProps: A,
  mediaLibraryProps: o
}) => /* @__PURE__ */ C(wr, { ...A, children: /* @__PURE__ */ C($i, { ...o }) }), Mr = x(eC), { Item: tC } = j, nC = (A) => {
  const { bunny_library_id: o } = FA(), e = j.useFormInstance(), t = A == null ? void 0 : A.name, n = j.useWatch(t, e), { show: r, close: a, modalProps: g, ...s } = Nr({
    onConfirm: (K) => {
      var F;
      e.setFieldValue(t, {
        type: "bunny-stream-api",
        id: ((F = K == null ? void 0 : K[0]) == null ? void 0 : F.guid) || "",
        meta: {}
      });
    }
  });
  if ($(() => {
    n != null && n.id || r();
  }, []), !t)
    throw new Error("VideoInput name is required");
  const i = (n == null ? void 0 : n.id) === "", l = `https://iframe.mediadelivery.net/embed/${o}/${n == null ? void 0 : n.id}?autoplay=false&loop=false&muted=false&preload=true&responsive=true`, B = () => {
    e.setFieldValue(t, {
      type: "none",
      id: "",
      meta: {}
    });
  };
  return /* @__PURE__ */ h("div", { className: "at-relative", children: [
    /* @__PURE__ */ C(
      D,
      {
        size: "small",
        type: "link",
        className: "at-ml-0 at-mb-2 at-pl-0",
        onClick: r,
        children: "開啟 Bunny 媒體庫"
      }
    ),
    /* @__PURE__ */ C(tC, { hidden: !0, ...A }),
    !i && /* @__PURE__ */ C("div", { className: "at-relative at-aspect-video at-rounded-lg at-border at-border-dashed at-border-gray-300", children: /* @__PURE__ */ C("div", { className: "at-absolute at-size-full at-top-0 at-left-0 at-p-2", children: /* @__PURE__ */ C("div", { className: "at-size-full at-rounded-xl at-overflow-hidden", children: /* @__PURE__ */ h(
      "div",
      {
        className: `at-rounded-xl at-bg-gray-200 ${i ? "at-tw-hidden" : "at-tw-block"}`,
        style: {
          position: "relative",
          paddingTop: "56.25%"
        },
        children: [
          /* @__PURE__ */ C(
            "iframe",
            {
              className: "at-border-0 at-absolute at-top-0 at-left-0 at-size-full at-rounded-xl",
              src: l,
              loading: "lazy",
              allow: "encrypted-media;picture-in-picture;",
              allowFullScreen: !0
            }
          ),
          /* @__PURE__ */ C(
            "div",
            {
              onClick: B,
              className: "at-group at-absolute at-top-4 at-right-4 at-rounded-md at-size-12 at-bg-white at-shadow-lg at-flex at-justify-center at-items-center at-transition at-duration-300 hover:at-bg-red-500 at-cursor-pointer",
              children: /* @__PURE__ */ C(fe, { className: "at-text-red-500 group-hover:at-text-white" })
            }
          )
        ]
      }
    ) }) }) }),
    /* @__PURE__ */ C(
      Mr,
      {
        modalProps: g,
        mediaLibraryProps: {
          ...s
        }
      }
    )
  ] });
}, { Item: rC } = j, aC = [
  {
    value: "none",
    label: "無影片",
    url: "https://e7.pngegg.com/pngimages/990/965/png-clipart-prohibition-in-the-united-states-computer-icons-symbol-none-angle-sign-thumbnail.png"
  },
  {
    value: "wordpress",
    label: "Wordpress 媒體庫",
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/WordPress_logo.svg/2560px-WordPress_logo.svg.png"
  },
  {
    value: "youtube",
    label: "Youtube 嵌入",
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Logo_of_YouTube_%282015-2017%29.svg/2560px-Logo_of_YouTube_%282015-2017%29.svg.png"
  },
  {
    value: "vimeo",
    label: "Vimeo 嵌入",
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Vimeo_Logo.svg/2560px-Vimeo_Logo.svg.png"
  },
  {
    value: "bunny-stream-api",
    label: "Bunny Stream API",
    url: "https://img.perfops.net/img/cdn-provider/11.png"
  },
  {
    value: "code",
    label: "自訂代碼",
    url: "https://as1.ftcdn.net/jpg/01/16/06/44/1000_F_116064418_tEuuAaPygdFyrt1vUIDGhdtN0bwlsfoc.jpg"
  }
], gC = ({ formItemProps: A }) => {
  var a;
  const { name: o, ...e } = A, t = j.useFormInstance(), n = ((a = j.useWatch(o, t)) == null ? void 0 : a.type) || "none";
  return /* @__PURE__ */ h(k, { children: [
    /* @__PURE__ */ C("div", { className: "at-grid at-grid-cols-3 at-gap-3", children: aC.map(({ value: g, url: s }) => {
      const i = n === g;
      return /* @__PURE__ */ h(
        "div",
        {
          onClick: () => {
            t.setFieldValue(o, {
              type: g,
              id: "",
              meta: {}
            });
          },
          className: `at-rounded-md at-border at-cursor-pointer at-border-solid at-border-gray-200 at-aspect-video at-w-full at-flex at-justify-center at-items-center at-relative ${i ? "at-outline at-outline-4 at-outline-yellow-300 at-outline-offset-1" : ""}`,
          children: [
            /* @__PURE__ */ C("img", { src: s, className: "at-size-4/5 at-object-contain" }),
            i && /* @__PURE__ */ C("div", { className: "at-bg-white at-absolute -at-top-2 -at-right-2 at-z-[15] at-size-6 at-rounded-full at-flex at-items-center at-justify-center", children: /* @__PURE__ */ C(Tt, { className: "at-size-5 [&_path]:at-fill-yellow-300" }) })
          ]
        },
        g
      );
    }) }),
    /* @__PURE__ */ C(
      rC,
      {
        ...e,
        name: o,
        className: "at-mb-1",
        initialValue: "none",
        hidden: !0
      }
    ),
    n === "youtube" && /* @__PURE__ */ C(Ui, { ...A }),
    n === "vimeo" && /* @__PURE__ */ C(ui, { ...A }),
    n === "bunny-stream-api" && /* @__PURE__ */ C(nC, { ...A }),
    n === "code" && /* @__PURE__ */ C(Hs, { ...A })
  ] });
}, Ef = x(gC), { Item: sC } = j, iC = ({ formItemProps: A, datePickerProps: o }) => /* @__PURE__ */ C(
  sC,
  {
    getValueProps: (e) => ({
      value: rs(e)
    }),
    normalize: (e) => e == null ? void 0 : e.unix(),
    ...A,
    children: /* @__PURE__ */ C(
      Ke,
      {
        placeholder: "選擇日期",
        className: "at-w-full",
        showTime: { defaultValue: qo() },
        format: "YYYY-MM-DD HH:mm",
        ...o
      }
    )
  }
), CC = x(iC), { Item: lC } = j, { RangePicker: BC } = Ke, KC = ({ formItemProps: A, rangePickerProps: o }) => /* @__PURE__ */ C(
  lC,
  {
    getValueProps: (e) => ({
      value: as(e)
    }),
    ...A,
    children: /* @__PURE__ */ C(
      BC,
      {
        className: "at-w-full",
        allowEmpty: [!0, !0],
        format: "YYYY-MM-DD HH:mm",
        placeholder: ["開始日期", "結束日期"],
        showTime: !0,
        ...o
      }
    )
  }
), qf = x(KC), { Item: vA } = j, QC = ({
  formItemProps: A,
  radioGroupProps: o,
  limitTypeName: e = ["limit_type"],
  limitValueName: t = ["limit_value"],
  limitUnitName: n = ["limit_unit"]
}) => {
  const r = j.useFormInstance(), a = j.useWatch(e, r), g = (s) => {
    s === "unlimited" && (r.setFieldValue(t, ""), r.setFieldValue(n, "")), s === "fixed" && (r.setFieldValue(t, 1), r.setFieldValue(n, "day")), s === "assigned" && (r.setFieldValue(t, void 0), r.setFieldValue(n, "timestamp")), s === "follow_subscription" && (r.setFieldValue(t, ""), r.setFieldValue(n, ""));
  };
  return /* @__PURE__ */ h("div", { style: { contain: "layout paint style" }, children: [
    /* @__PURE__ */ C(
      vA,
      {
        label: "觀看期限",
        initialValue: "unlimited",
        ...A,
        name: e,
        children: /* @__PURE__ */ C(
          yt.Group,
          {
            className: "at-w-full w-avg",
            options: [
              { label: "無期限", value: "unlimited" },
              { label: "固定天數", value: "fixed" },
              { label: "指定時間", value: "assigned" },
              {
                label: "跟隨訂閱",
                value: "follow_subscription"
              }
            ],
            optionType: "button",
            buttonStyle: "solid",
            onChange: (s) => {
              var l;
              const i = ((l = s == null ? void 0 : s.target) == null ? void 0 : l.value) || "";
              g(i);
            },
            ...o
          }
        )
      }
    ),
    a === "unlimited" && /* @__PURE__ */ h(k, { children: [
      /* @__PURE__ */ C(vA, { name: t, initialValue: "", hidden: !0 }),
      /* @__PURE__ */ C(vA, { name: n, initialValue: "", hidden: !0 })
    ] }),
    a === "fixed" && /* @__PURE__ */ h(IA.Compact, { block: !0, children: [
      /* @__PURE__ */ C(vA, { name: t, initialValue: 1, className: "at-w-full", children: /* @__PURE__ */ C(Eo, { className: "at-w-full", min: 1 }) }),
      /* @__PURE__ */ C(vA, { name: n, initialValue: "day", children: /* @__PURE__ */ C(
        tA,
        {
          options: [
            { label: "日", value: "day" },
            { label: "月", value: "month" },
            { label: "年", value: "year" }
          ],
          className: "at-w-16"
        }
      ) })
    ] }),
    a === "assigned" && /* @__PURE__ */ h(k, { children: [
      /* @__PURE__ */ C(
        CC,
        {
          formItemProps: {
            name: t,
            className: "at-mb-0",
            rules: [
              {
                required: !0,
                message: "請填寫指定時間"
              }
            ]
          }
        }
      ),
      /* @__PURE__ */ C(vA, { name: n, initialValue: "timestamp", hidden: !0 })
    ] }),
    a === "follow_subscription" && /* @__PURE__ */ h(k, { children: [
      /* @__PURE__ */ C(vA, { name: t, initialValue: "", hidden: !0 }),
      /* @__PURE__ */ C(vA, { name: n, initialValue: "", hidden: !0 })
    ] })
  ] });
}, Jf = x(QC);
function FC(A) {
  return BA({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM10.9999 16.0002V18.0002H12.9999V16.0002H10.9999ZM10.9999 9.00017V14.0002H12.9999V9.00017H10.9999Z" }, child: [] }] })(A);
}
const Uo = {
  type: "alert",
  propSchema: {
    type: {
      default: "info",
      values: ["warning", "error", "info", "success"]
    }
  },
  content: "inline"
}, cC = [
  {
    label: "資訊",
    value: "info"
  },
  {
    label: "成功",
    value: "success"
  },
  {
    label: "警告",
    value: "warning"
  },
  {
    label: "錯誤",
    value: "error"
  }
], fC = (A) => ({
  key: Uo.type,
  title: "Alert",
  subtext: "可製作醒目提醒、注意事項",
  // 說明文字
  onItemClick: () => {
    ce(A, {
      type: Uo.type
    });
  },
  aliases: [
    "alert",
    "notification",
    "emphasize",
    "warning",
    "error",
    "info",
    "success"
  ],
  group: "Other",
  icon: /* @__PURE__ */ C(FC, {})
}), UC = [
  {
    title: "Warning",
    value: "warning",
    icon: Mg,
    color: "#e69819",
    backgroundColor: {
      light: "#fff6e6",
      dark: "#805d20"
    }
  },
  {
    title: "Error",
    value: "error",
    icon: Eg,
    color: "#d80d0d",
    backgroundColor: {
      light: "#ffe6e6",
      dark: "#802020"
    }
  },
  {
    title: "Info",
    value: "info",
    icon: qg,
    color: "#507aff",
    backgroundColor: {
      light: "#e6ebff",
      dark: "#203380"
    }
  },
  {
    title: "Success",
    value: "success",
    icon: Jg,
    color: "#0bc10b",
    backgroundColor: {
      light: "#e6ffe6",
      dark: "#208020"
    }
  }
], uC = Fe(Uo, {
  render: (A) => {
    const o = A.editor.getBlock(A.block), e = (o == null ? void 0 : o.props) || A.block.props;
    UC.find(
      (r) => {
        var a;
        return r.value === ((a = A.block.props) == null ? void 0 : a.type);
      }
    );
    const [t, n] = L(!1);
    return /* @__PURE__ */ h(
      "div",
      {
        className: "at-w-full",
        onMouseEnter: () => n(!0),
        onMouseLeave: () => n(!1),
        style: {
          contain: "layout paint paint"
        },
        children: [
          /* @__PURE__ */ C(
            to,
            {
              className: "at-w-full",
              message: /* @__PURE__ */ C("div", { className: "bn-inline-content", ref: A.contentRef }),
              type: e == null ? void 0 : e.type,
              showIcon: !0
            }
          ),
          /* @__PURE__ */ C(
            "div",
            {
              className: Z(
                "at-py-1 at-px-2 at-bg-gray-100 at-rounded-md at-transition-opacity at-duration-300",
                t ? "at-opacity-100" : "at-opacity-30"
              ),
              children: /* @__PURE__ */ C("div", { className: "at-flex at-justify-center", children: /* @__PURE__ */ C(
                tA,
                {
                  size: "small",
                  defaultValue: e.type,
                  onChange: (r) => {
                    A.editor.updateBlock(A.block, {
                      props: {
                        ...e,
                        type: r
                      }
                    });
                  },
                  className: "at-w-24",
                  options: cC
                }
              ) })
            }
          )
        ]
      }
    );
  },
  // @ts-ignore
  parse: (A) => {
    if (jt(A))
      return dC(A);
    const o = A.getAttribute("data-block-key");
    return Uo.type !== o ? void 0 : {
      type: A.getAttribute("data-alert-type") || "warning" || "warning"
    };
  },
  toExternalHTML: ({ block: A, editor: o, contentRef: e }) => {
    var n, r, a;
    const t = (n = A.props) == null ? void 0 : n.type;
    return /* @__PURE__ */ h(
      "div",
      {
        "data-block-key": A == null ? void 0 : A.type,
        className: "alert",
        "data-alert-type": t,
        children: [
          /* @__PURE__ */ h("div", { className: "alert-icon-wrapper", children: [
            t === "info" && /* @__PURE__ */ C(Or, { className: "alert-icon" }),
            t === "warning" && /* @__PURE__ */ C(Wt, { className: "alert-icon" }),
            t === "error" && /* @__PURE__ */ C(ws, { className: "alert-icon" }),
            t === "success" && /* @__PURE__ */ C(As, { className: "alert-icon" })
          ] }),
          /* @__PURE__ */ C("div", { className: "bn-inline-content", children: ((a = (r = A == null ? void 0 : A.content) == null ? void 0 : r[0]) == null ? void 0 : a.text) || "" })
        ]
      }
    );
  }
});
function dC(A) {
  var t;
  const o = A.getAttribute("data-content-type");
  return Uo.type !== o ? void 0 : {
    type: ((t = A.querySelector(".alert")) == null ? void 0 : t.getAttribute("data-alert-type")) || "warning"
  };
}
function pC(A) {
  return BA({ attr: { version: "1.1", viewBox: "0 0 20 16" }, child: [{ tag: "path", attr: { d: "M13 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5z" }, child: [] }, { tag: "path", attr: { d: "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5z" }, child: [] }, { tag: "path", attr: { d: "M10.958 2.352l1.085 0.296-3 11-1.085-0.296 3-11z" }, child: [] }] })(A);
}
const _o = {
  type: "customHTML",
  propSchema: {
    html: {
      default: ""
    }
  },
  content: "none"
}, hC = (A) => ({
  key: _o.type,
  title: "自訂 HTML",
  // 選單中文
  subtext: "支援 HTML、CSS、JavaScript、iframe 等...",
  // 說明文字
  onItemClick: () => {
    ce(A, {
      type: _o.type
    });
  },
  aliases: ["html"],
  group: "Advanced",
  icon: /* @__PURE__ */ C(pC, { className: "at-size-[1.125rem]" })
}), mC = Fe(_o, {
  render: (A) => {
    var e;
    const o = A.block.props.html;
    return /* @__PURE__ */ C(
      "div",
      {
        "data-block-key": (e = A.block) == null ? void 0 : e.type,
        className: "at-w-full",
        style: {
          contain: "layout paint paint"
        },
        children: /* @__PURE__ */ C(
          "textarea",
          {
            className: "at-w-full at-text-sm at-rounded-md at-outline-none at-border-2 at-border-solid at-border-gray-100 at-bg-gray-100 at-p-2 at-whitespace-pre-wrap",
            rows: 6,
            onChange: (t) => {
              A.editor.updateBlock(A.block, {
                type: "customHTML",
                props: { html: t.target.value }
              });
            },
            value: o
          }
        )
      }
    );
  },
  // ❗parse 是例如，將剪貼簿複製到編輯器時，要怎麼解析 HTML 轉換為 BLOCK
  // @ts-ignore
  parse: (A) => {
    const o = A.getAttribute("data-block-key");
    if (_o.type !== o) return;
    const e = A.querySelector(":scope > div");
    return e ? {
      html: e.innerHTML
    } : {
      html: A.innerHTML
    };
  },
  // ❗toExternalHTML 是例如，將區塊複製到剪貼簿到外部時，會複製的 內容，如果沒有定義就使用 render
  toExternalHTML: ({ block: A }) => {
    var e;
    const o = (e = A == null ? void 0 : A.props) == null ? void 0 : e.html;
    return /* @__PURE__ */ C("div", { "data-block-key": A == null ? void 0 : A.type, children: Ht(o, !0) });
  }
});
function Er(A) {
  return BA({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M16 3l4 4l-4 4" }, child: [] }, { tag: "path", attr: { d: "M10 7l10 0" }, child: [] }, { tag: "path", attr: { d: "M8 13l-4 4l4 4" }, child: [] }, { tag: "path", attr: { d: "M4 17l9 0" }, child: [] }] })(A);
}
const qr = ({ block: A, editor: o, contentRef: e }) => {
  var Q, f, c, U, u, d;
  const { bunny_library_id: t = "", bunny_cdn_hostname: n = "" } = FA();
  if (!t || !n)
    return console.error("bunny_library_id or bunny_cdn_hostname is not set", {
      bunny_library_id: t,
      bunny_cdn_hostname: n
    }), null;
  const r = (Q = A == null ? void 0 : A.props) == null ? void 0 : Q.vId, a = `https://iframe.mediadelivery.net/embed/${t}/${r}?autoplay=false&loop=false&muted=false&preload=true&responsive=true`, g = `https://${n}/${r}/playlist.m3u8`, s = ((f = A == null ? void 0 : A.props) == null ? void 0 : f.widthValue) || 100, i = ((c = A == null ? void 0 : A.props) == null ? void 0 : c.widthUnit) || "%", l = ((U = A == null ? void 0 : A.props) == null ? void 0 : U.align) || "start", B = ((u = A == null ? void 0 : A.props) == null ? void 0 : u.aspectRatio) || 1.7778, K = ((d = A == null ? void 0 : A.props) == null ? void 0 : d.player) || "video", F = {
    "data-block-key": A == null ? void 0 : A.type,
    "data-width-value": s,
    "data-width-unit": i,
    "data-align": l,
    "data-player": K,
    "data-aspect-ratio": B,
    "data-v-id": r
  };
  return /* @__PURE__ */ h(
    "div",
    {
      ...F,
      style: {
        display: "flex",
        width: "100%",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: l
      },
      children: [
        K === "video" && /* @__PURE__ */ C(
          "iframe",
          {
            style: {
              border: "none",
              outline: "none",
              borderRadius: "0.75rem",
              width: `${s}${i}`,
              maxWidth: "100%",
              aspectRatio: B
            },
            src: a,
            loading: "lazy",
            allow: "encrypted-media;picture-in-picture;",
            allowFullScreen: !0
          }
        ),
        K === "audio" && /* @__PURE__ */ C(
          "audio",
          {
            preload: "metadata",
            style: {
              width: `${s}${i}`,
              maxWidth: "100%"
            },
            src: g,
            controls: !0
          }
        )
      ]
    }
  );
}, PC = [
  {
    label: /* @__PURE__ */ C(di, { className: "at-relative at-top-0.5" }),
    value: "video"
  },
  {
    label: /* @__PURE__ */ C(pi, { className: "at-relative at-top-0.5" }),
    value: "audio"
  }
], vC = (A) => {
  const [o, e] = L(0), t = A ? A == null ? void 0 : A.block : null, n = (t == null ? void 0 : t.props) || null, { show: r, close: a, modalProps: g, setModalProps: s, ...i } = Nr({
    onConfirm: (Q) => {
      const f = Q == null ? void 0 : Q[0];
      A.editor.updateBlock(A.block, {
        type: "bunnyVideo",
        props: {
          ...n,
          vId: f == null ? void 0 : f.guid
        }
      }), e((c) => c + 1);
    }
  }), l = xt((Q, f) => {
    A && A.editor.updateBlock(A.block, {
      type: "bunnyVideo",
      props: {
        ...n,
        [Q]: f
      }
    });
  }, 500), [B, K] = L(!1), F = n == null ? void 0 : n.vId;
  return $(() => {
    !F && t && r();
  }, [F]), /* @__PURE__ */ h(k, { children: [
    /* @__PURE__ */ C(
      "div",
      {
        className: "at-w-full",
        onMouseEnter: () => K(!0),
        onMouseLeave: () => K(!1),
        style: {
          contain: "layout paint paint"
        },
        children: !!F && /* @__PURE__ */ h(k, { children: [
          /* @__PURE__ */ C(
            "div",
            {
              className: "[&_*]:at-pointer-events-none at-cursor-pointer",
              onClick: r,
              children: /* @__PURE__ */ C(
                qr,
                {
                  block: A.block,
                  editor: A.editor,
                  contentRef: A.contentRef
                }
              )
            }
          ),
          /* @__PURE__ */ C(
            "div",
            {
              className: Z(
                "at-py-1 at-px-2 at-bg-gray-100 at-rounded-md at-transition-opacity at-duration-300",
                B ? "at-opacity-100" : "at-opacity-30"
              ),
              children: /* @__PURE__ */ h("div", { className: "at-flex at-items-center at-justify-center at-gap-x-2", children: [
                /* @__PURE__ */ C(
                  yt.Group,
                  {
                    options: PC,
                    size: "small",
                    defaultValue: n.player,
                    optionType: "button",
                    buttonStyle: "solid",
                    onChange: (Q) => l("player", Q.target.value)
                  }
                ),
                /* @__PURE__ */ h(IA.Compact, { children: [
                  /* @__PURE__ */ C(
                    Eo,
                    {
                      addonBefore: "寬",
                      size: "small",
                      className: "at-w-32",
                      defaultValue: n.widthValue,
                      onChange: (Q) => l("widthValue", Q)
                    }
                  ),
                  ["px", "%"].map((Q) => /* @__PURE__ */ C(
                    D,
                    {
                      type: n.widthUnit === Q ? "primary" : "default",
                      size: "small",
                      onClick: () => l("widthUnit", Q),
                      children: Q
                    },
                    Q
                  ))
                ] }),
                n.player === "video" && /* @__PURE__ */ C(
                  Eo,
                  {
                    addonBefore: /* @__PURE__ */ C(W, { title: "可自由填入影片長寬比，例如 16/9 為 1.7778", children: "比例" }),
                    className: "at-w-32",
                    size: "small",
                    defaultValue: n.aspectRatio,
                    onChange: (Q) => l("aspectRatio", Q)
                  }
                ),
                /* @__PURE__ */ h(IA.Compact, { children: [
                  Object.entries({
                    start: /* @__PURE__ */ C(It, {}),
                    center: /* @__PURE__ */ C(zt, {}),
                    end: /* @__PURE__ */ C(Gt, {})
                  }).map(([Q, f]) => /* @__PURE__ */ C(
                    D,
                    {
                      type: n.align === Q ? "primary" : "default",
                      size: "small",
                      icon: f,
                      onClick: () => l("align", Q)
                    },
                    Q
                  )),
                  /* @__PURE__ */ C(W, { title: "換一個", children: /* @__PURE__ */ C(
                    D,
                    {
                      size: "small",
                      icon: /* @__PURE__ */ C(Er, {}),
                      onClick: r
                    }
                  ) }),
                  /* @__PURE__ */ C(W, { title: "刪除", children: /* @__PURE__ */ C(
                    D,
                    {
                      danger: !0,
                      type: "primary",
                      size: "small",
                      icon: /* @__PURE__ */ C(fe, {}),
                      onClick: () => {
                        A.editor.removeBlocks([A.block]);
                      }
                    }
                  ) })
                ] })
              ] })
            },
            o
          )
        ] })
      }
    ),
    /* @__PURE__ */ C(
      Mr,
      {
        modalProps: g,
        mediaLibraryProps: i
      }
    )
  ] });
}, wC = x(vC), uo = {
  type: "bunnyVideo",
  propSchema: {
    widthValue: {
      default: 100
    },
    widthUnit: {
      default: "%"
    },
    align: {
      values: ["start", "center", "end"],
      default: "start"
    },
    player: {
      values: ["video", "audio"],
      default: "video"
    },
    aspectRatio: {
      default: 1.7778
      // 16/9
    },
    vId: {
      default: ""
    }
  },
  content: "none"
}, yC = (A) => ({
  key: uo.type,
  title: "Bunny 媒體庫",
  // 選單中文
  subtext: "可放置 Bunny 影片、音訊檔案",
  // 說明文字
  onItemClick: () => {
    ce(A, {
      type: uo.type
    });
  },
  aliases: ["bunny"],
  group: "Advanced",
  icon: /* @__PURE__ */ C(Et, { className: "at-size-[1.125rem]" })
}), bC = Fe(uo, {
  render: (A) => /* @__PURE__ */ C(wC, { ...A }),
  // ❗parse 是例如，將剪貼簿複製到編輯器時，要怎麼解析 HTML 轉換為 BLOCK
  // @ts-ignore
  parse: (A) => {
    if (jt(A))
      return HC(A);
    const o = A.getAttribute("data-block-key");
    if (uo.type === o)
      return {
        widthValue: A.getAttribute("data-width-value") || 100,
        widthUnit: A.getAttribute("data-width-unit") || "%",
        align: A.getAttribute("data-align") || "start",
        player: A.getAttribute("data-player") || "video",
        aspectRatio: A.getAttribute("data-aspect-ratio") || 1.7778,
        vId: A.getAttribute("data-v-id") || ""
      };
  },
  toExternalHTML: ({ block: A, editor: o, contentRef: e }) => (
    // @ts-ignore
    /* @__PURE__ */ C(qr, { block: A, editor: o, contentRef: e })
  )
});
function HC(A) {
  const o = A.getAttribute("data-content-type");
  return [uo.type, "bunnyAudio"].includes(o || "") ? {
    widthValue: 100,
    widthUnit: "%",
    player: o === "bunnyAudio" ? "audio" : "video",
    aspectRatio: 1.7778,
    vId: A.getAttribute("data-v-id") || ""
  } : void 0;
}
const DC = ({ block: A, editor: o, contentRef: e }) => {
  var s, i, l, B;
  const t = ((s = A == null ? void 0 : A.props) == null ? void 0 : s.url) || "", n = yo(t), r = ((i = A == null ? void 0 : A.props) == null ? void 0 : i.widthValue) || 100, a = ((l = A == null ? void 0 : A.props) == null ? void 0 : l.widthUnit) || "%", g = ((B = A == null ? void 0 : A.props) == null ? void 0 : B.title) || "";
  return /* @__PURE__ */ h(k, { children: [
    !!g && /* @__PURE__ */ C(
      "p",
      {
        style: {
          fontSize: "0.875rem",
          color: "#9ca3af",
          marginBottom: "0.5rem"
        },
        children: g
      }
    ),
    /* @__PURE__ */ h(
      "audio",
      {
        controls: !0,
        preload: "metadata",
        style: { width: `${r}${a}`, maxWidth: "100%" },
        children: [
          /* @__PURE__ */ C("source", { src: t, type: `audio/${n}` }),
          "您的瀏覽器不支援音頻播放。"
        ]
      }
    )
  ] });
}, NC = ({ block: A, editor: o, contentRef: e }) => {
  var s, i, l, B;
  const t = ((s = A == null ? void 0 : A.props) == null ? void 0 : s.url) || "", n = yo(t), r = ((i = A == null ? void 0 : A.props) == null ? void 0 : i.widthValue) || 100, a = ((l = A == null ? void 0 : A.props) == null ? void 0 : l.widthUnit) || "%", g = ((B = A == null ? void 0 : A.props) == null ? void 0 : B.title) || "";
  return /* @__PURE__ */ h(k, { children: [
    !!g && /* @__PURE__ */ C(
      "p",
      {
        style: {
          fontSize: "0.875rem",
          color: "#9ca3af",
          marginBottom: "0.5rem"
        },
        children: g
      }
    ),
    /* @__PURE__ */ h(
      "video",
      {
        controls: !0,
        preload: "metadata",
        style: { width: `${r}${a}`, maxWidth: "100%" },
        playsInline: !0,
        children: [
          /* @__PURE__ */ C("source", { src: t, type: `video/${n}` }),
          "您的瀏覽器不支援影片播放。"
        ]
      }
    )
  ] });
}, xC = ({ block: A, editor: o, contentRef: e }) => {
  var g, s, i;
  const t = ((g = A == null ? void 0 : A.props) == null ? void 0 : g.url) || "", n = yo(t), r = ((s = A == null ? void 0 : A.props) == null ? void 0 : s.target) || "_self", a = ((i = A == null ? void 0 : A.props) == null ? void 0 : i.title) || "";
  return /* @__PURE__ */ h(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        columnGap: "0.5rem"
      },
      children: [
        /* @__PURE__ */ C(Xt, { ext: n, style: { width: "1.5rem", height: "1.5rem" } }),
        /* @__PURE__ */ C(
          "a",
          {
            href: t,
            target: r,
            rel: "noopener noreferrer",
            style: {
              display: "contents",
              fontSize: "0.875rem"
            },
            children: a
          }
        )
      ]
    }
  );
}, Jr = ({ block: A, editor: o, contentRef: e }) => {
  var a, g, s, i, l, B, K, F, Q, f, c, U;
  const t = (a = A == null ? void 0 : A.props) == null ? void 0 : a.url;
  if (!t) return null;
  const n = ((g = A == null ? void 0 : A.props) == null ? void 0 : g.fileType) || "image", r = {
    "data-block-key": A == null ? void 0 : A.type,
    "data-url": t,
    "data-width-value": (s = A == null ? void 0 : A.props) == null ? void 0 : s.widthValue,
    "data-width-unit": (i = A == null ? void 0 : A.props) == null ? void 0 : i.widthUnit,
    "data-align": ((l = A == null ? void 0 : A.props) == null ? void 0 : l.align) || "start",
    "data-link": ((B = A == null ? void 0 : A.props) == null ? void 0 : B.link) || "",
    "data-target": ((K = A == null ? void 0 : A.props) == null ? void 0 : K.target) || "_self",
    "data-alt": ((F = A == null ? void 0 : A.props) == null ? void 0 : F.alt) || "",
    "data-title": ((Q = A == null ? void 0 : A.props) == null ? void 0 : Q.title) || "",
    "data-caption": ((f = A == null ? void 0 : A.props) == null ? void 0 : f.caption) || "",
    "data-file-type": ((c = A == null ? void 0 : A.props) == null ? void 0 : c.fileType) || "image"
  };
  return /* @__PURE__ */ h(
    "div",
    {
      ...r,
      style: {
        display: "flex",
        width: "100%",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: ((U = A == null ? void 0 : A.props) == null ? void 0 : U.align) || "start"
      },
      children: [
        n === "image" && // @ts-ignore
        /* @__PURE__ */ C(ys, { block: A, editor: o, contentRef: e }),
        n === "audio" && // @ts-ignore
        /* @__PURE__ */ C(DC, { block: A, editor: o, contentRef: e }),
        n === "video" && // @ts-ignore
        /* @__PURE__ */ C(NC, { block: A, editor: o, contentRef: e }),
        n === "other" && // @ts-ignore
        /* @__PURE__ */ C(xC, { block: A, editor: o, contentRef: e })
      ]
    }
  );
};
function $o(A) {
  return Dt(A) ? "image" : ur(A) ? "audio" : dr(A) ? "video" : "other";
}
const jC = (A) => {
  const [o, e] = L(0), t = A ? A == null ? void 0 : A.block : null, n = (t == null ? void 0 : t.props) || null, r = n == null ? void 0 : n.url, { show: a, close: g, modalProps: s, setModalProps: i, ...l } = ps({
    onConfirm: (U) => {
      if (!t)
        return;
      const u = U == null ? void 0 : U[0], d = $o(u == null ? void 0 : u.url);
      A.editor.updateBlock(t, {
        type: "mediaLibrary",
        props: {
          ...n,
          url: u == null ? void 0 : u.url,
          title: u == null ? void 0 : u.title,
          widthValue: d === "image" ? u == null ? void 0 : u.width : 100,
          widthUnit: d === "image" ? "px" : "%",
          alt: (u == null ? void 0 : u._wp_attachment_image_alt) || (u == null ? void 0 : u.title),
          fileType: d
        }
      }), e((P) => P + 1);
    }
  });
  $(() => {
    !r && t && a();
  }, [r]);
  const B = xt((U, u) => {
    A && A.editor.updateBlock(A.block, {
      type: "mediaLibrary",
      props: {
        ...n,
        [U]: u
      }
    });
  }, 500), [K, F] = L(null), [Q, f] = L(!1), c = (n == null ? void 0 : n.fileType) || $o(r || "");
  return /* @__PURE__ */ h(k, { children: [
    /* @__PURE__ */ C(
      "div",
      {
        className: "at-w-full",
        onMouseEnter: () => f(!0),
        onMouseLeave: () => f(!1),
        style: {
          contain: "layout paint paint"
        },
        children: r && /* @__PURE__ */ h(k, { children: [
          /* @__PURE__ */ C(
            "div",
            {
              className: "[&_*]:at-pointer-events-none at-cursor-pointer",
              onClick: a,
              children: /* @__PURE__ */ C(
                Jr,
                {
                  block: A.block,
                  editor: A.editor,
                  contentRef: A.contentRef
                }
              )
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: Z(
                "at-py-1 at-px-2 at-bg-gray-100 at-rounded-md at-transition-opacity at-duration-300",
                Q ? "at-opacity-100" : "at-opacity-30"
              ),
              children: [
                /* @__PURE__ */ h("div", { className: "at-flex at-items-center at-justify-center at-gap-x-2", children: [
                  c !== "other" && /* @__PURE__ */ h(IA.Compact, { children: [
                    /* @__PURE__ */ C(
                      Eo,
                      {
                        addonBefore: "寬",
                        className: "at-w-32",
                        size: "small",
                        defaultValue: n.widthValue,
                        onChange: (U) => B("widthValue", U)
                      }
                    ),
                    ["px", "%"].map((U) => /* @__PURE__ */ C(
                      D,
                      {
                        type: n.widthUnit === U ? "primary" : "default",
                        size: "small",
                        onClick: () => B("widthUnit", U),
                        children: U
                      },
                      U
                    ))
                  ] }),
                  /* @__PURE__ */ h(IA.Compact, { children: [
                    Object.entries({
                      start: /* @__PURE__ */ C(It, {}),
                      center: /* @__PURE__ */ C(zt, {}),
                      end: /* @__PURE__ */ C(Gt, {})
                    }).map(([U, u]) => /* @__PURE__ */ C(
                      D,
                      {
                        type: n.align === U ? "primary" : "default",
                        size: "small",
                        icon: u,
                        onClick: () => B("align", U)
                      },
                      U
                    )),
                    c === "image" && /* @__PURE__ */ C(W, { title: "設定圖片連結", children: /* @__PURE__ */ C(
                      D,
                      {
                        type: K === "link" ? "primary" : "default",
                        size: "small",
                        icon: /* @__PURE__ */ C(zr, {}),
                        onClick: () => F(K === "link" ? null : "link")
                      }
                    ) }),
                    /* @__PURE__ */ C(
                      W,
                      {
                        title: c === "image" ? "設定 alt 文字" : "設定文字",
                        children: /* @__PURE__ */ C(
                          D,
                          {
                            type: K === "alt" ? "primary" : "default",
                            size: "small",
                            icon: /* @__PURE__ */ C(bs, { color: K === "alt" ? "#fff" : "#444" }),
                            onClick: () => F(K === "alt" ? null : "alt")
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ C(W, { title: "換一個", children: /* @__PURE__ */ C(
                      D,
                      {
                        size: "small",
                        icon: /* @__PURE__ */ C(Er, {}),
                        onClick: a
                      }
                    ) }),
                    /* @__PURE__ */ C(W, { title: "刪除", children: /* @__PURE__ */ C(
                      D,
                      {
                        danger: !0,
                        type: "primary",
                        size: "small",
                        icon: /* @__PURE__ */ C(fe, {}),
                        onClick: () => {
                          A.editor.removeBlocks([A.block]);
                        }
                      }
                    ) })
                  ] })
                ] }),
                /* @__PURE__ */ h("div", { className: Z("at-mt-1", K ? "at-block" : "at-hidden"), children: [
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: Z(
                        "at-flex at-items-center at-gap-x-2",
                        K === "link" ? "at-block" : "at-hidden"
                      ),
                      children: [
                        /* @__PURE__ */ C(
                          J,
                          {
                            defaultValue: n.link,
                            placeholder: "請輸入包含 https:// 的連結，例如  https://www.google.com",
                            size: "small",
                            onChange: (U) => B("link", U.target.value),
                            allowClear: !0
                          }
                        ),
                        /* @__PURE__ */ C(
                          pg,
                          {
                            defaultChecked: n.target === "_blank",
                            onChange: (U) => B("target", U.target.checked ? "_blank" : "_self"),
                            className: "at-text-xs at-text-nowrap",
                            children: "新視窗開啟"
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: Z(
                        "at-flex at-flex-col at-gap-1",
                        K === "alt" ? "at-block" : "at-hidden"
                      ),
                      children: [
                        c === "image" && /* @__PURE__ */ C(
                          J,
                          {
                            defaultValue: n.alt,
                            placeholder: "請輸入圖片 alt 替代文字",
                            size: "small",
                            onChange: (U) => B("alt", U.target.value),
                            allowClear: !0
                          }
                        ),
                        /* @__PURE__ */ C(
                          J,
                          {
                            defaultValue: n.title,
                            placeholder: "請輸入圖片 title 文字",
                            size: "small",
                            onChange: (U) => B("title", U.target.value),
                            allowClear: !0
                          }
                        ),
                        c === "image" && /* @__PURE__ */ C(
                          J,
                          {
                            defaultValue: n.caption,
                            placeholder: "請輸入圖片 caption 文字",
                            size: "small",
                            onChange: (U) => B("caption", U.target.value),
                            allowClear: !0
                          }
                        )
                      ]
                    }
                  )
                ] })
              ]
            },
            o
          )
        ] })
      }
    ),
    /* @__PURE__ */ C(
      WF,
      {
        modalProps: s,
        mediaLibraryProps: l
      }
    )
  ] });
}, kC = x(jC), Ae = {
  type: "mediaLibrary",
  propSchema: {
    widthValue: {
      default: 100
    },
    widthUnit: {
      default: "%"
    },
    align: {
      values: ["start", "center", "end"],
      default: "start"
    },
    url: {
      default: ""
    },
    link: {
      default: ""
    },
    target: {
      values: ["_blank", "_self"],
      default: "_self"
    },
    alt: {
      default: ""
    },
    title: {
      default: ""
    },
    caption: {
      default: ""
    },
    fileType: {
      values: ["image", "audio", "video", "other"],
      default: "image"
    }
  },
  content: "none"
}, SC = (A) => ({
  key: Ae.type,
  title: "媒體庫",
  // 選單中文
  subtext: "WordPress 媒體庫",
  // 說明文字
  onItemClick: () => {
    ce(A, {
      type: Ae.type
    });
  },
  aliases: ["media", "媒體庫"],
  group: "Media",
  icon: /* @__PURE__ */ C(Et, { className: "at-size-[1.125rem]" })
}), RC = Fe(Ae, {
  render: (A) => /* @__PURE__ */ C(kC, { ...A }),
  // ❗parse 是例如，將剪貼簿複製到編輯器時，要怎麼解析 HTML 轉換為 BLOCK
  // @ts-ignore
  parse: (A) => {
    if (jt(A))
      return LC(A);
    const o = A.getAttribute("data-block-key");
    if (Ae.type === o)
      return {
        widthValue: A.getAttribute("data-width-value") || 100,
        widthUnit: A.getAttribute("data-width-unit") || "%",
        align: A.getAttribute("data-align") || "start",
        url: A.getAttribute("data-url") || "",
        link: A.getAttribute("data-link") || "",
        target: A.getAttribute("data-target") || "_self",
        alt: A.getAttribute("data-alt") || "",
        title: A.getAttribute("data-title") || "",
        caption: A.getAttribute("data-caption") || "",
        fileType: A.getAttribute("data-file-type") || "image"
      };
  },
  toExternalHTML: ({ block: A, editor: o, contentRef: e }) => (
    // @ts-ignore
    /* @__PURE__ */ C(Jr, { block: A, editor: o, contentRef: e })
  )
});
function LC(A) {
  var e;
  const o = A.getAttribute("data-content-type");
  if (o === "image") {
    const t = A.querySelector(".bn-file-block-content-wrapper"), n = t == null ? void 0 : t.querySelector("img"), r = t == null ? void 0 : t.getAttribute("style");
    return {
      widthValue: Number((e = r == null ? void 0 : r.match(/width: (\d+)px/)) == null ? void 0 : e[1]) || 100,
      widthUnit: "px",
      align: Zg(
        A.getAttribute("data-text-alignment")
      ),
      url: A.getAttribute("data-url") || "",
      alt: (n == null ? void 0 : n.getAttribute("alt")) || "",
      title: (n == null ? void 0 : n.getAttribute("title")) || "",
      caption: A.getAttribute("data-caption") || "",
      fileType: "image"
    };
  }
  if (o === "file")
    return {
      url: A.getAttribute("data-url") || "",
      title: A.getAttribute("data-name") || "",
      fileType: "other"
    };
}
let X = class extends Error {
  constructor(o) {
    super(o), this.name = "ShikiError";
  }
};
function TC(A) {
  return qt(A);
}
function qt(A) {
  return Array.isArray(A) ? OC(A) : A instanceof RegExp ? A : typeof A == "object" ? XC(A) : A;
}
function OC(A) {
  let o = [];
  for (let e = 0, t = A.length; e < t; e++)
    o[e] = qt(A[e]);
  return o;
}
function XC(A) {
  let o = {};
  for (let e in A)
    o[e] = qt(A[e]);
  return o;
}
function Zr(A, ...o) {
  return o.forEach((e) => {
    for (let t in e)
      A[t] = e[t];
  }), A;
}
function Yr(A) {
  const o = ~A.lastIndexOf("/") || ~A.lastIndexOf("\\");
  return o === 0 ? A : ~o === A.length - 1 ? Yr(A.substring(0, A.length - 1)) : A.substr(~o + 1);
}
var be = /\$(\d+)|\${(\d+):\/(downcase|upcase)}/g, Ro = class {
  static hasCaptures(A) {
    return A === null ? !1 : (be.lastIndex = 0, be.test(A));
  }
  static replaceCaptures(A, o, e) {
    return A.replace(be, (t, n, r, a) => {
      let g = e[parseInt(n || r, 10)];
      if (g) {
        let s = o.substring(g.start, g.end);
        for (; s[0] === "."; )
          s = s.substring(1);
        switch (a) {
          case "downcase":
            return s.toLowerCase();
          case "upcase":
            return s.toUpperCase();
          default:
            return s;
        }
      } else
        return t;
    });
  }
};
function _r(A, o) {
  return A < o ? -1 : A > o ? 1 : 0;
}
function $r(A, o) {
  if (A === null && o === null)
    return 0;
  if (!A)
    return -1;
  if (!o)
    return 1;
  let e = A.length, t = o.length;
  if (e === t) {
    for (let n = 0; n < e; n++) {
      let r = _r(A[n], o[n]);
      if (r !== 0)
        return r;
    }
    return 0;
  }
  return e - t;
}
function un(A) {
  return !!(/^#[0-9a-f]{6}$/i.test(A) || /^#[0-9a-f]{8}$/i.test(A) || /^#[0-9a-f]{3}$/i.test(A) || /^#[0-9a-f]{4}$/i.test(A));
}
function Aa(A) {
  return A.replace(/[\-\\\{\}\*\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, "\\$&");
}
var oa = class {
  constructor(A) {
    p(this, "cache", /* @__PURE__ */ new Map());
    this.fn = A;
  }
  get(A) {
    if (this.cache.has(A))
      return this.cache.get(A);
    const o = this.fn(A);
    return this.cache.set(A, o), o;
  }
}, oe = class {
  constructor(A, o, e) {
    p(this, "_cachedMatchRoot", new oa(
      (A) => this._root.match(A)
    ));
    this._colorMap = A, this._defaults = o, this._root = e;
  }
  static createFromRawTheme(A, o) {
    return this.createFromParsedTheme(GC(A), o);
  }
  static createFromParsedTheme(A, o) {
    return VC(A, o);
  }
  getColorMap() {
    return this._colorMap.getColorMap();
  }
  getDefaults() {
    return this._defaults;
  }
  match(A) {
    if (A === null)
      return this._defaults;
    const o = A.scopeName, t = this._cachedMatchRoot.get(o).find(
      (n) => zC(A.parent, n.parentScopes)
    );
    return t ? new ea(
      t.fontStyle,
      t.foreground,
      t.background
    ) : null;
  }
}, He = class Io {
  constructor(o, e) {
    this.parent = o, this.scopeName = e;
  }
  static push(o, e) {
    for (const t of e)
      o = new Io(o, t);
    return o;
  }
  static from(...o) {
    let e = null;
    for (let t = 0; t < o.length; t++)
      e = new Io(e, o[t]);
    return e;
  }
  push(o) {
    return new Io(this, o);
  }
  getSegments() {
    let o = this;
    const e = [];
    for (; o; )
      e.push(o.scopeName), o = o.parent;
    return e.reverse(), e;
  }
  toString() {
    return this.getSegments().join(" ");
  }
  extends(o) {
    return this === o ? !0 : this.parent === null ? !1 : this.parent.extends(o);
  }
  getExtensionIfDefined(o) {
    const e = [];
    let t = this;
    for (; t && t !== o; )
      e.push(t.scopeName), t = t.parent;
    return t === o ? e.reverse() : void 0;
  }
};
function zC(A, o) {
  if (o.length === 0)
    return !0;
  for (let e = 0; e < o.length; e++) {
    let t = o[e], n = !1;
    if (t === ">") {
      if (e === o.length - 1)
        return !1;
      t = o[++e], n = !0;
    }
    for (; A && !IC(A.scopeName, t); ) {
      if (n)
        return !1;
      A = A.parent;
    }
    if (!A)
      return !1;
    A = A.parent;
  }
  return !0;
}
function IC(A, o) {
  return o === A || A.startsWith(o) && A[o.length] === ".";
}
var ea = class {
  constructor(A, o, e) {
    this.fontStyle = A, this.foregroundId = o, this.backgroundId = e;
  }
};
function GC(A) {
  if (!A)
    return [];
  if (!A.settings || !Array.isArray(A.settings))
    return [];
  let o = A.settings, e = [], t = 0;
  for (let n = 0, r = o.length; n < r; n++) {
    let a = o[n];
    if (!a.settings)
      continue;
    let g;
    if (typeof a.scope == "string") {
      let B = a.scope;
      B = B.replace(/^[,]+/, ""), B = B.replace(/[,]+$/, ""), g = B.split(",");
    } else Array.isArray(a.scope) ? g = a.scope : g = [""];
    let s = -1;
    if (typeof a.settings.fontStyle == "string") {
      s = 0;
      let B = a.settings.fontStyle.split(" ");
      for (let K = 0, F = B.length; K < F; K++)
        switch (B[K]) {
          case "italic":
            s = s | 1;
            break;
          case "bold":
            s = s | 2;
            break;
          case "underline":
            s = s | 4;
            break;
          case "strikethrough":
            s = s | 8;
            break;
        }
    }
    let i = null;
    typeof a.settings.foreground == "string" && un(a.settings.foreground) && (i = a.settings.foreground);
    let l = null;
    typeof a.settings.background == "string" && un(a.settings.background) && (l = a.settings.background);
    for (let B = 0, K = g.length; B < K; B++) {
      let Q = g[B].trim().split(" "), f = Q[Q.length - 1], c = null;
      Q.length > 1 && (c = Q.slice(0, Q.length - 1), c.reverse()), e[t++] = new WC(
        f,
        c,
        n,
        s,
        i,
        l
      );
    }
  }
  return e;
}
var WC = class {
  constructor(A, o, e, t, n, r) {
    this.scope = A, this.parentScopes = o, this.index = e, this.fontStyle = t, this.foreground = n, this.background = r;
  }
}, M = /* @__PURE__ */ ((A) => (A[A.NotSet = -1] = "NotSet", A[A.None = 0] = "None", A[A.Italic = 1] = "Italic", A[A.Bold = 2] = "Bold", A[A.Underline = 4] = "Underline", A[A.Strikethrough = 8] = "Strikethrough", A))(M || {});
function VC(A, o) {
  A.sort((s, i) => {
    let l = _r(s.scope, i.scope);
    return l !== 0 || (l = $r(s.parentScopes, i.parentScopes), l !== 0) ? l : s.index - i.index;
  });
  let e = 0, t = "#000000", n = "#ffffff";
  for (; A.length >= 1 && A[0].scope === ""; ) {
    let s = A.shift();
    s.fontStyle !== -1 && (e = s.fontStyle), s.foreground !== null && (t = s.foreground), s.background !== null && (n = s.background);
  }
  let r = new MC(o), a = new ea(e, r.getId(t), r.getId(n)), g = new qC(new it(0, null, -1, 0, 0), []);
  for (let s = 0, i = A.length; s < i; s++) {
    let l = A[s];
    g.insert(0, l.scope, l.parentScopes, l.fontStyle, r.getId(l.foreground), r.getId(l.background));
  }
  return new oe(r, a, g);
}
var MC = class {
  constructor(A) {
    p(this, "_isFrozen");
    p(this, "_lastColorId");
    p(this, "_id2color");
    p(this, "_color2id");
    if (this._lastColorId = 0, this._id2color = [], this._color2id = /* @__PURE__ */ Object.create(null), Array.isArray(A)) {
      this._isFrozen = !0;
      for (let o = 0, e = A.length; o < e; o++)
        this._color2id[A[o]] = o, this._id2color[o] = A[o];
    } else
      this._isFrozen = !1;
  }
  getId(A) {
    if (A === null)
      return 0;
    A = A.toUpperCase();
    let o = this._color2id[A];
    if (o)
      return o;
    if (this._isFrozen)
      throw new Error(`Missing color in color map - ${A}`);
    return o = ++this._lastColorId, this._color2id[A] = o, this._id2color[o] = A, o;
  }
  getColorMap() {
    return this._id2color.slice(0);
  }
}, EC = Object.freeze([]), it = class ta {
  constructor(o, e, t, n, r) {
    p(this, "scopeDepth");
    p(this, "parentScopes");
    p(this, "fontStyle");
    p(this, "foreground");
    p(this, "background");
    this.scopeDepth = o, this.parentScopes = e || EC, this.fontStyle = t, this.foreground = n, this.background = r;
  }
  clone() {
    return new ta(this.scopeDepth, this.parentScopes, this.fontStyle, this.foreground, this.background);
  }
  static cloneArr(o) {
    let e = [];
    for (let t = 0, n = o.length; t < n; t++)
      e[t] = o[t].clone();
    return e;
  }
  acceptOverwrite(o, e, t, n) {
    this.scopeDepth > o ? console.log("how did this happen?") : this.scopeDepth = o, e !== -1 && (this.fontStyle = e), t !== 0 && (this.foreground = t), n !== 0 && (this.background = n);
  }
}, qC = class Ct {
  constructor(o, e = [], t = {}) {
    p(this, "_rulesWithParentScopes");
    this._mainRule = o, this._children = t, this._rulesWithParentScopes = e;
  }
  static _cmpBySpecificity(o, e) {
    if (o.scopeDepth !== e.scopeDepth)
      return e.scopeDepth - o.scopeDepth;
    let t = 0, n = 0;
    for (; o.parentScopes[t] === ">" && t++, e.parentScopes[n] === ">" && n++, !(t >= o.parentScopes.length || n >= e.parentScopes.length); ) {
      const r = e.parentScopes[n].length - o.parentScopes[t].length;
      if (r !== 0)
        return r;
      t++, n++;
    }
    return e.parentScopes.length - o.parentScopes.length;
  }
  match(o) {
    if (o !== "") {
      let t = o.indexOf("."), n, r;
      if (t === -1 ? (n = o, r = "") : (n = o.substring(0, t), r = o.substring(t + 1)), this._children.hasOwnProperty(n))
        return this._children[n].match(r);
    }
    const e = this._rulesWithParentScopes.concat(this._mainRule);
    return e.sort(Ct._cmpBySpecificity), e;
  }
  insert(o, e, t, n, r, a) {
    if (e === "") {
      this._doInsertHere(o, t, n, r, a);
      return;
    }
    let g = e.indexOf("."), s, i;
    g === -1 ? (s = e, i = "") : (s = e.substring(0, g), i = e.substring(g + 1));
    let l;
    this._children.hasOwnProperty(s) ? l = this._children[s] : (l = new Ct(this._mainRule.clone(), it.cloneArr(this._rulesWithParentScopes)), this._children[s] = l), l.insert(o + 1, i, t, n, r, a);
  }
  _doInsertHere(o, e, t, n, r) {
    if (e === null) {
      this._mainRule.acceptOverwrite(o, t, n, r);
      return;
    }
    for (let a = 0, g = this._rulesWithParentScopes.length; a < g; a++) {
      let s = this._rulesWithParentScopes[a];
      if ($r(s.parentScopes, e) === 0) {
        s.acceptOverwrite(o, t, n, r);
        return;
      }
    }
    t === -1 && (t = this._mainRule.fontStyle), n === 0 && (n = this._mainRule.foreground), r === 0 && (r = this._mainRule.background), this._rulesWithParentScopes.push(new it(o, e, t, n, r));
  }
}, oo = class eA {
  static toBinaryStr(o) {
    return o.toString(2).padStart(32, "0");
  }
  static print(o) {
    const e = eA.getLanguageId(o), t = eA.getTokenType(o), n = eA.getFontStyle(o), r = eA.getForeground(o), a = eA.getBackground(o);
    console.log({
      languageId: e,
      tokenType: t,
      fontStyle: n,
      foreground: r,
      background: a
    });
  }
  static getLanguageId(o) {
    return (o & 255) >>> 0;
  }
  static getTokenType(o) {
    return (o & 768) >>> 8;
  }
  static containsBalancedBrackets(o) {
    return (o & 1024) !== 0;
  }
  static getFontStyle(o) {
    return (o & 30720) >>> 11;
  }
  static getForeground(o) {
    return (o & 16744448) >>> 15;
  }
  static getBackground(o) {
    return (o & 4278190080) >>> 24;
  }
  /**
   * Updates the fields in `metadata`.
   * A value of `0`, `NotSet` or `null` indicates that the corresponding field should be left as is.
   */
  static set(o, e, t, n, r, a, g) {
    let s = eA.getLanguageId(o), i = eA.getTokenType(o), l = eA.containsBalancedBrackets(o) ? 1 : 0, B = eA.getFontStyle(o), K = eA.getForeground(o), F = eA.getBackground(o);
    return e !== 0 && (s = e), t !== 8 && (i = t), n !== null && (l = n ? 1 : 0), r !== -1 && (B = r), a !== 0 && (K = a), g !== 0 && (F = g), (s << 0 | i << 8 | l << 10 | B << 11 | K << 15 | F << 24) >>> 0;
  }
};
function ee(A, o) {
  const e = [], t = JC(A);
  let n = t.next();
  for (; n !== null; ) {
    let s = 0;
    if (n.length === 2 && n.charAt(1) === ":") {
      switch (n.charAt(0)) {
        case "R":
          s = 1;
          break;
        case "L":
          s = -1;
          break;
        default:
          console.log(`Unknown priority ${n} in scope selector`);
      }
      n = t.next();
    }
    let i = a();
    if (e.push({ matcher: i, priority: s }), n !== ",")
      break;
    n = t.next();
  }
  return e;
  function r() {
    if (n === "-") {
      n = t.next();
      const s = r();
      return (i) => !!s && !s(i);
    }
    if (n === "(") {
      n = t.next();
      const s = g();
      return n === ")" && (n = t.next()), s;
    }
    if (dn(n)) {
      const s = [];
      do
        s.push(n), n = t.next();
      while (dn(n));
      return (i) => o(s, i);
    }
    return null;
  }
  function a() {
    const s = [];
    let i = r();
    for (; i; )
      s.push(i), i = r();
    return (l) => s.every((B) => B(l));
  }
  function g() {
    const s = [];
    let i = a();
    for (; i && (s.push(i), n === "|" || n === ","); ) {
      do
        n = t.next();
      while (n === "|" || n === ",");
      i = a();
    }
    return (l) => s.some((B) => B(l));
  }
}
function dn(A) {
  return !!A && !!A.match(/[\w\.:]+/);
}
function JC(A) {
  let o = /([LR]:|[\w\.:][\w\.:\-]*|[\,\|\-\(\)])/g, e = o.exec(A);
  return {
    next: () => {
      if (!e)
        return null;
      const t = e[0];
      return e = o.exec(A), t;
    }
  };
}
function na(A) {
  typeof A.dispose == "function" && A.dispose();
}
var po = class {
  constructor(A) {
    this.scopeName = A;
  }
  toKey() {
    return this.scopeName;
  }
}, ZC = class {
  constructor(A, o) {
    this.scopeName = A, this.ruleName = o;
  }
  toKey() {
    return `${this.scopeName}#${this.ruleName}`;
  }
}, YC = class {
  constructor() {
    p(this, "_references", []);
    p(this, "_seenReferenceKeys", /* @__PURE__ */ new Set());
    p(this, "visitedRule", /* @__PURE__ */ new Set());
  }
  get references() {
    return this._references;
  }
  add(A) {
    const o = A.toKey();
    this._seenReferenceKeys.has(o) || (this._seenReferenceKeys.add(o), this._references.push(A));
  }
}, _C = class {
  constructor(A, o) {
    p(this, "seenFullScopeRequests", /* @__PURE__ */ new Set());
    p(this, "seenPartialScopeRequests", /* @__PURE__ */ new Set());
    p(this, "Q");
    this.repo = A, this.initialScopeName = o, this.seenFullScopeRequests.add(this.initialScopeName), this.Q = [new po(this.initialScopeName)];
  }
  processQueue() {
    const A = this.Q;
    this.Q = [];
    const o = new YC();
    for (const e of A)
      $C(e, this.initialScopeName, this.repo, o);
    for (const e of o.references)
      if (e instanceof po) {
        if (this.seenFullScopeRequests.has(e.scopeName))
          continue;
        this.seenFullScopeRequests.add(e.scopeName), this.Q.push(e);
      } else {
        if (this.seenFullScopeRequests.has(e.scopeName) || this.seenPartialScopeRequests.has(e.toKey()))
          continue;
        this.seenPartialScopeRequests.add(e.toKey()), this.Q.push(e);
      }
  }
};
function $C(A, o, e, t) {
  const n = e.lookup(A.scopeName);
  if (!n) {
    if (A.scopeName === o)
      throw new Error(`No grammar provided for <${o}>`);
    return;
  }
  const r = e.lookup(o);
  A instanceof po ? Go({ baseGrammar: r, selfGrammar: n }, t) : lt(
    A.ruleName,
    { baseGrammar: r, selfGrammar: n, repository: n.repository },
    t
  );
  const a = e.injections(A.scopeName);
  if (a)
    for (const g of a)
      t.add(new po(g));
}
function lt(A, o, e) {
  if (o.repository && o.repository[A]) {
    const t = o.repository[A];
    te([t], o, e);
  }
}
function Go(A, o) {
  A.selfGrammar.patterns && Array.isArray(A.selfGrammar.patterns) && te(
    A.selfGrammar.patterns,
    { ...A, repository: A.selfGrammar.repository },
    o
  ), A.selfGrammar.injections && te(
    Object.values(A.selfGrammar.injections),
    { ...A, repository: A.selfGrammar.repository },
    o
  );
}
function te(A, o, e) {
  for (const t of A) {
    if (e.visitedRule.has(t))
      continue;
    e.visitedRule.add(t);
    const n = t.repository ? Zr({}, o.repository, t.repository) : o.repository;
    Array.isArray(t.patterns) && te(t.patterns, { ...o, repository: n }, e);
    const r = t.include;
    if (!r)
      continue;
    const a = ra(r);
    switch (a.kind) {
      case 0:
        Go({ ...o, selfGrammar: o.baseGrammar }, e);
        break;
      case 1:
        Go(o, e);
        break;
      case 2:
        lt(a.ruleName, { ...o, repository: n }, e);
        break;
      case 3:
      case 4:
        const g = a.scopeName === o.selfGrammar.scopeName ? o.selfGrammar : a.scopeName === o.baseGrammar.scopeName ? o.baseGrammar : void 0;
        if (g) {
          const s = { baseGrammar: o.baseGrammar, selfGrammar: g, repository: n };
          a.kind === 4 ? lt(a.ruleName, s, e) : Go(s, e);
        } else
          a.kind === 4 ? e.add(new ZC(a.scopeName, a.ruleName)) : e.add(new po(a.scopeName));
        break;
    }
  }
}
var Al = class {
  constructor() {
    p(this, "kind", 0);
  }
}, ol = class {
  constructor() {
    p(this, "kind", 1);
  }
}, el = class {
  constructor(A) {
    p(this, "kind", 2);
    this.ruleName = A;
  }
}, tl = class {
  constructor(A) {
    p(this, "kind", 3);
    this.scopeName = A;
  }
}, nl = class {
  constructor(A, o) {
    p(this, "kind", 4);
    this.scopeName = A, this.ruleName = o;
  }
};
function ra(A) {
  if (A === "$base")
    return new Al();
  if (A === "$self")
    return new ol();
  const o = A.indexOf("#");
  if (o === -1)
    return new tl(A);
  if (o === 0)
    return new el(A.substring(1));
  {
    const e = A.substring(0, o), t = A.substring(o + 1);
    return new nl(e, t);
  }
}
var rl = /\\(\d+)/, pn = /\\(\d+)/g, al = -1, aa = -2;
var No = class {
  constructor(A, o, e, t) {
    p(this, "$location");
    p(this, "id");
    p(this, "_nameIsCapturing");
    p(this, "_name");
    p(this, "_contentNameIsCapturing");
    p(this, "_contentName");
    this.$location = A, this.id = o, this._name = e || null, this._nameIsCapturing = Ro.hasCaptures(this._name), this._contentName = t || null, this._contentNameIsCapturing = Ro.hasCaptures(this._contentName);
  }
  get debugName() {
    const A = this.$location ? `${Yr(this.$location.filename)}:${this.$location.line}` : "unknown";
    return `${this.constructor.name}#${this.id} @ ${A}`;
  }
  getName(A, o) {
    return !this._nameIsCapturing || this._name === null || A === null || o === null ? this._name : Ro.replaceCaptures(this._name, A, o);
  }
  getContentName(A, o) {
    return !this._contentNameIsCapturing || this._contentName === null ? this._contentName : Ro.replaceCaptures(this._contentName, A, o);
  }
}, gl = class extends No {
  constructor(o, e, t, n, r) {
    super(o, e, t, n);
    p(this, "retokenizeCapturedWithRuleId");
    this.retokenizeCapturedWithRuleId = r;
  }
  dispose() {
  }
  collectPatterns(o, e) {
    throw new Error("Not supported!");
  }
  compile(o, e) {
    throw new Error("Not supported!");
  }
  compileAG(o, e, t, n) {
    throw new Error("Not supported!");
  }
}, sl = class extends No {
  constructor(o, e, t, n, r) {
    super(o, e, t, null);
    p(this, "_match");
    p(this, "captures");
    p(this, "_cachedCompiledPatterns");
    this._match = new ho(n, this.id), this.captures = r, this._cachedCompiledPatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null);
  }
  get debugMatchRegExp() {
    return `${this._match.source}`;
  }
  collectPatterns(o, e) {
    e.push(this._match);
  }
  compile(o, e) {
    return this._getCachedCompiledPatterns(o).compile(o);
  }
  compileAG(o, e, t, n) {
    return this._getCachedCompiledPatterns(o).compileAG(o, t, n);
  }
  _getCachedCompiledPatterns(o) {
    return this._cachedCompiledPatterns || (this._cachedCompiledPatterns = new mo(), this.collectPatterns(o, this._cachedCompiledPatterns)), this._cachedCompiledPatterns;
  }
}, hn = class extends No {
  constructor(o, e, t, n, r) {
    super(o, e, t, n);
    p(this, "hasMissingPatterns");
    p(this, "patterns");
    p(this, "_cachedCompiledPatterns");
    this.patterns = r.patterns, this.hasMissingPatterns = r.hasMissingPatterns, this._cachedCompiledPatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null);
  }
  collectPatterns(o, e) {
    for (const t of this.patterns)
      o.getRule(t).collectPatterns(o, e);
  }
  compile(o, e) {
    return this._getCachedCompiledPatterns(o).compile(o);
  }
  compileAG(o, e, t, n) {
    return this._getCachedCompiledPatterns(o).compileAG(o, t, n);
  }
  _getCachedCompiledPatterns(o) {
    return this._cachedCompiledPatterns || (this._cachedCompiledPatterns = new mo(), this.collectPatterns(o, this._cachedCompiledPatterns)), this._cachedCompiledPatterns;
  }
}, Bt = class extends No {
  constructor(o, e, t, n, r, a, g, s, i, l) {
    super(o, e, t, n);
    p(this, "_begin");
    p(this, "beginCaptures");
    p(this, "_end");
    p(this, "endHasBackReferences");
    p(this, "endCaptures");
    p(this, "applyEndPatternLast");
    p(this, "hasMissingPatterns");
    p(this, "patterns");
    p(this, "_cachedCompiledPatterns");
    this._begin = new ho(r, this.id), this.beginCaptures = a, this._end = new ho(g || "￿", -1), this.endHasBackReferences = this._end.hasBackReferences, this.endCaptures = s, this.applyEndPatternLast = i || !1, this.patterns = l.patterns, this.hasMissingPatterns = l.hasMissingPatterns, this._cachedCompiledPatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null);
  }
  get debugBeginRegExp() {
    return `${this._begin.source}`;
  }
  get debugEndRegExp() {
    return `${this._end.source}`;
  }
  getEndWithResolvedBackReferences(o, e) {
    return this._end.resolveBackReferences(o, e);
  }
  collectPatterns(o, e) {
    e.push(this._begin);
  }
  compile(o, e) {
    return this._getCachedCompiledPatterns(o, e).compile(o);
  }
  compileAG(o, e, t, n) {
    return this._getCachedCompiledPatterns(o, e).compileAG(o, t, n);
  }
  _getCachedCompiledPatterns(o, e) {
    if (!this._cachedCompiledPatterns) {
      this._cachedCompiledPatterns = new mo();
      for (const t of this.patterns)
        o.getRule(t).collectPatterns(o, this._cachedCompiledPatterns);
      this.applyEndPatternLast ? this._cachedCompiledPatterns.push(this._end.hasBackReferences ? this._end.clone() : this._end) : this._cachedCompiledPatterns.unshift(this._end.hasBackReferences ? this._end.clone() : this._end);
    }
    return this._end.hasBackReferences && (this.applyEndPatternLast ? this._cachedCompiledPatterns.setSource(this._cachedCompiledPatterns.length() - 1, e) : this._cachedCompiledPatterns.setSource(0, e)), this._cachedCompiledPatterns;
  }
}, ne = class extends No {
  constructor(o, e, t, n, r, a, g, s, i) {
    super(o, e, t, n);
    p(this, "_begin");
    p(this, "beginCaptures");
    p(this, "whileCaptures");
    p(this, "_while");
    p(this, "whileHasBackReferences");
    p(this, "hasMissingPatterns");
    p(this, "patterns");
    p(this, "_cachedCompiledPatterns");
    p(this, "_cachedCompiledWhilePatterns");
    this._begin = new ho(r, this.id), this.beginCaptures = a, this.whileCaptures = s, this._while = new ho(g, aa), this.whileHasBackReferences = this._while.hasBackReferences, this.patterns = i.patterns, this.hasMissingPatterns = i.hasMissingPatterns, this._cachedCompiledPatterns = null, this._cachedCompiledWhilePatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null), this._cachedCompiledWhilePatterns && (this._cachedCompiledWhilePatterns.dispose(), this._cachedCompiledWhilePatterns = null);
  }
  get debugBeginRegExp() {
    return `${this._begin.source}`;
  }
  get debugWhileRegExp() {
    return `${this._while.source}`;
  }
  getWhileWithResolvedBackReferences(o, e) {
    return this._while.resolveBackReferences(o, e);
  }
  collectPatterns(o, e) {
    e.push(this._begin);
  }
  compile(o, e) {
    return this._getCachedCompiledPatterns(o).compile(o);
  }
  compileAG(o, e, t, n) {
    return this._getCachedCompiledPatterns(o).compileAG(o, t, n);
  }
  _getCachedCompiledPatterns(o) {
    if (!this._cachedCompiledPatterns) {
      this._cachedCompiledPatterns = new mo();
      for (const e of this.patterns)
        o.getRule(e).collectPatterns(o, this._cachedCompiledPatterns);
    }
    return this._cachedCompiledPatterns;
  }
  compileWhile(o, e) {
    return this._getCachedCompiledWhilePatterns(o, e).compile(o);
  }
  compileWhileAG(o, e, t, n) {
    return this._getCachedCompiledWhilePatterns(o, e).compileAG(o, t, n);
  }
  _getCachedCompiledWhilePatterns(o, e) {
    return this._cachedCompiledWhilePatterns || (this._cachedCompiledWhilePatterns = new mo(), this._cachedCompiledWhilePatterns.push(this._while.hasBackReferences ? this._while.clone() : this._while)), this._while.hasBackReferences && this._cachedCompiledWhilePatterns.setSource(0, e || "￿"), this._cachedCompiledWhilePatterns;
  }
}, ga = class V {
  static createCaptureRule(o, e, t, n, r) {
    return o.registerRule((a) => new gl(e, a, t, n, r));
  }
  static getCompiledRuleId(o, e, t) {
    return o.id || e.registerRule((n) => {
      if (o.id = n, o.match)
        return new sl(
          o.$vscodeTextmateLocation,
          o.id,
          o.name,
          o.match,
          V._compileCaptures(o.captures, e, t)
        );
      if (typeof o.begin > "u") {
        o.repository && (t = Zr({}, t, o.repository));
        let r = o.patterns;
        return typeof r > "u" && o.include && (r = [{ include: o.include }]), new hn(
          o.$vscodeTextmateLocation,
          o.id,
          o.name,
          o.contentName,
          V._compilePatterns(r, e, t)
        );
      }
      return o.while ? new ne(
        o.$vscodeTextmateLocation,
        o.id,
        o.name,
        o.contentName,
        o.begin,
        V._compileCaptures(o.beginCaptures || o.captures, e, t),
        o.while,
        V._compileCaptures(o.whileCaptures || o.captures, e, t),
        V._compilePatterns(o.patterns, e, t)
      ) : new Bt(
        o.$vscodeTextmateLocation,
        o.id,
        o.name,
        o.contentName,
        o.begin,
        V._compileCaptures(o.beginCaptures || o.captures, e, t),
        o.end,
        V._compileCaptures(o.endCaptures || o.captures, e, t),
        o.applyEndPatternLast,
        V._compilePatterns(o.patterns, e, t)
      );
    }), o.id;
  }
  static _compileCaptures(o, e, t) {
    let n = [];
    if (o) {
      let r = 0;
      for (const a in o) {
        if (a === "$vscodeTextmateLocation")
          continue;
        const g = parseInt(a, 10);
        g > r && (r = g);
      }
      for (let a = 0; a <= r; a++)
        n[a] = null;
      for (const a in o) {
        if (a === "$vscodeTextmateLocation")
          continue;
        const g = parseInt(a, 10);
        let s = 0;
        o[a].patterns && (s = V.getCompiledRuleId(o[a], e, t)), n[g] = V.createCaptureRule(e, o[a].$vscodeTextmateLocation, o[a].name, o[a].contentName, s);
      }
    }
    return n;
  }
  static _compilePatterns(o, e, t) {
    let n = [];
    if (o)
      for (let r = 0, a = o.length; r < a; r++) {
        const g = o[r];
        let s = -1;
        if (g.include) {
          const i = ra(g.include);
          switch (i.kind) {
            case 0:
            case 1:
              s = V.getCompiledRuleId(t[g.include], e, t);
              break;
            case 2:
              let l = t[i.ruleName];
              l && (s = V.getCompiledRuleId(l, e, t));
              break;
            case 3:
            case 4:
              const B = i.scopeName, K = i.kind === 4 ? i.ruleName : null, F = e.getExternalGrammar(B, t);
              if (F)
                if (K) {
                  let Q = F.repository[K];
                  Q && (s = V.getCompiledRuleId(Q, e, F.repository));
                } else
                  s = V.getCompiledRuleId(F.repository.$self, e, F.repository);
              break;
          }
        } else
          s = V.getCompiledRuleId(g, e, t);
        if (s !== -1) {
          const i = e.getRule(s);
          let l = !1;
          if ((i instanceof hn || i instanceof Bt || i instanceof ne) && i.hasMissingPatterns && i.patterns.length === 0 && (l = !0), l)
            continue;
          n.push(s);
        }
      }
    return {
      patterns: n,
      hasMissingPatterns: (o ? o.length : 0) !== n.length
    };
  }
}, ho = class sa {
  constructor(o, e) {
    p(this, "source");
    p(this, "ruleId");
    p(this, "hasAnchor");
    p(this, "hasBackReferences");
    p(this, "_anchorCache");
    if (o && typeof o == "string") {
      const t = o.length;
      let n = 0, r = [], a = !1;
      for (let g = 0; g < t; g++)
        if (o.charAt(g) === "\\" && g + 1 < t) {
          const i = o.charAt(g + 1);
          i === "z" ? (r.push(o.substring(n, g)), r.push("$(?!\\n)(?<!\\n)"), n = g + 2) : (i === "A" || i === "G") && (a = !0), g++;
        }
      this.hasAnchor = a, n === 0 ? this.source = o : (r.push(o.substring(n, t)), this.source = r.join(""));
    } else
      this.hasAnchor = !1, this.source = o;
    this.hasAnchor ? this._anchorCache = this._buildAnchorCache() : this._anchorCache = null, this.ruleId = e, typeof this.source == "string" ? this.hasBackReferences = rl.test(this.source) : this.hasBackReferences = !1;
  }
  clone() {
    return new sa(this.source, this.ruleId);
  }
  setSource(o) {
    this.source !== o && (this.source = o, this.hasAnchor && (this._anchorCache = this._buildAnchorCache()));
  }
  resolveBackReferences(o, e) {
    if (typeof this.source != "string")
      throw new Error("This method should only be called if the source is a string");
    let t = e.map((n) => o.substring(n.start, n.end));
    return pn.lastIndex = 0, this.source.replace(pn, (n, r) => Aa(t[parseInt(r, 10)] || ""));
  }
  _buildAnchorCache() {
    if (typeof this.source != "string")
      throw new Error("This method should only be called if the source is a string");
    let o = [], e = [], t = [], n = [], r, a, g, s;
    for (r = 0, a = this.source.length; r < a; r++)
      g = this.source.charAt(r), o[r] = g, e[r] = g, t[r] = g, n[r] = g, g === "\\" && r + 1 < a && (s = this.source.charAt(r + 1), s === "A" ? (o[r + 1] = "￿", e[r + 1] = "￿", t[r + 1] = "A", n[r + 1] = "A") : s === "G" ? (o[r + 1] = "￿", e[r + 1] = "G", t[r + 1] = "￿", n[r + 1] = "G") : (o[r + 1] = s, e[r + 1] = s, t[r + 1] = s, n[r + 1] = s), r++);
    return {
      A0_G0: o.join(""),
      A0_G1: e.join(""),
      A1_G0: t.join(""),
      A1_G1: n.join("")
    };
  }
  resolveAnchors(o, e) {
    return !this.hasAnchor || !this._anchorCache || typeof this.source != "string" ? this.source : o ? e ? this._anchorCache.A1_G1 : this._anchorCache.A1_G0 : e ? this._anchorCache.A0_G1 : this._anchorCache.A0_G0;
  }
}, mo = class {
  constructor() {
    p(this, "_items");
    p(this, "_hasAnchors");
    p(this, "_cached");
    p(this, "_anchorCache");
    this._items = [], this._hasAnchors = !1, this._cached = null, this._anchorCache = {
      A0_G0: null,
      A0_G1: null,
      A1_G0: null,
      A1_G1: null
    };
  }
  dispose() {
    this._disposeCaches();
  }
  _disposeCaches() {
    this._cached && (this._cached.dispose(), this._cached = null), this._anchorCache.A0_G0 && (this._anchorCache.A0_G0.dispose(), this._anchorCache.A0_G0 = null), this._anchorCache.A0_G1 && (this._anchorCache.A0_G1.dispose(), this._anchorCache.A0_G1 = null), this._anchorCache.A1_G0 && (this._anchorCache.A1_G0.dispose(), this._anchorCache.A1_G0 = null), this._anchorCache.A1_G1 && (this._anchorCache.A1_G1.dispose(), this._anchorCache.A1_G1 = null);
  }
  push(A) {
    this._items.push(A), this._hasAnchors = this._hasAnchors || A.hasAnchor;
  }
  unshift(A) {
    this._items.unshift(A), this._hasAnchors = this._hasAnchors || A.hasAnchor;
  }
  length() {
    return this._items.length;
  }
  setSource(A, o) {
    this._items[A].source !== o && (this._disposeCaches(), this._items[A].setSource(o));
  }
  compile(A) {
    if (!this._cached) {
      let o = this._items.map((e) => e.source);
      this._cached = new mn(A, o, this._items.map((e) => e.ruleId));
    }
    return this._cached;
  }
  compileAG(A, o, e) {
    return this._hasAnchors ? o ? e ? (this._anchorCache.A1_G1 || (this._anchorCache.A1_G1 = this._resolveAnchors(A, o, e)), this._anchorCache.A1_G1) : (this._anchorCache.A1_G0 || (this._anchorCache.A1_G0 = this._resolveAnchors(A, o, e)), this._anchorCache.A1_G0) : e ? (this._anchorCache.A0_G1 || (this._anchorCache.A0_G1 = this._resolveAnchors(A, o, e)), this._anchorCache.A0_G1) : (this._anchorCache.A0_G0 || (this._anchorCache.A0_G0 = this._resolveAnchors(A, o, e)), this._anchorCache.A0_G0) : this.compile(A);
  }
  _resolveAnchors(A, o, e) {
    let t = this._items.map((n) => n.resolveAnchors(o, e));
    return new mn(A, t, this._items.map((n) => n.ruleId));
  }
}, mn = class {
  constructor(A, o, e) {
    p(this, "scanner");
    this.regExps = o, this.rules = e, this.scanner = A.createOnigScanner(o);
  }
  dispose() {
    typeof this.scanner.dispose == "function" && this.scanner.dispose();
  }
  toString() {
    const A = [];
    for (let o = 0, e = this.rules.length; o < e; o++)
      A.push("   - " + this.rules[o] + ": " + this.regExps[o]);
    return A.join(`
`);
  }
  findNextMatchSync(A, o, e) {
    const t = this.scanner.findNextMatchSync(A, o, e);
    return t ? {
      ruleId: this.rules[t.index],
      captureIndices: t.captureIndices
    } : null;
  }
}, De = class {
  constructor(A, o) {
    this.languageId = A, this.tokenType = o;
  }
}, pA, il = (pA = class {
  constructor(o, e) {
    p(this, "_defaultAttributes");
    p(this, "_embeddedLanguagesMatcher");
    p(this, "_getBasicScopeAttributes", new oa((o) => {
      const e = this._scopeToLanguage(o), t = this._toStandardTokenType(o);
      return new De(e, t);
    }));
    this._defaultAttributes = new De(
      o,
      8
      /* NotSet */
    ), this._embeddedLanguagesMatcher = new Cl(Object.entries(e || {}));
  }
  getDefaultAttributes() {
    return this._defaultAttributes;
  }
  getBasicScopeAttributes(o) {
    return o === null ? pA._NULL_SCOPE_METADATA : this._getBasicScopeAttributes.get(o);
  }
  /**
   * Given a produced TM scope, return the language that token describes or null if unknown.
   * e.g. source.html => html, source.css.embedded.html => css, punctuation.definition.tag.html => null
   */
  _scopeToLanguage(o) {
    return this._embeddedLanguagesMatcher.match(o) || 0;
  }
  _toStandardTokenType(o) {
    const e = o.match(pA.STANDARD_TOKEN_TYPE_REGEXP);
    if (!e)
      return 8;
    switch (e[1]) {
      case "comment":
        return 1;
      case "string":
        return 2;
      case "regex":
        return 3;
      case "meta.embedded":
        return 0;
    }
    throw new Error("Unexpected match for standard token type!");
  }
}, p(pA, "_NULL_SCOPE_METADATA", new De(0, 0)), p(pA, "STANDARD_TOKEN_TYPE_REGEXP", /\b(comment|string|regex|meta\.embedded)\b/), pA), Cl = class {
  constructor(A) {
    p(this, "values");
    p(this, "scopesRegExp");
    if (A.length === 0)
      this.values = null, this.scopesRegExp = null;
    else {
      this.values = new Map(A);
      const o = A.map(
        ([e, t]) => Aa(e)
      );
      o.sort(), o.reverse(), this.scopesRegExp = new RegExp(
        `^((${o.join(")|(")}))($|\\.)`,
        ""
      );
    }
  }
  match(A) {
    if (!this.scopesRegExp)
      return;
    const o = A.match(this.scopesRegExp);
    if (o)
      return this.values.get(o[1]);
  }
};
typeof process < "u" && process.env.VSCODE_TEXTMATE_DEBUG;
var Pn = class {
  constructor(A, o) {
    this.stack = A, this.stoppedEarly = o;
  }
};
function ia(A, o, e, t, n, r, a, g) {
  const s = o.content.length;
  let i = !1, l = -1;
  if (a) {
    const F = ll(
      A,
      o,
      e,
      t,
      n,
      r
    );
    n = F.stack, t = F.linePos, e = F.isFirstLine, l = F.anchorPosition;
  }
  const B = Date.now();
  for (; !i; ) {
    if (g !== 0 && Date.now() - B > g)
      return new Pn(n, !0);
    K();
  }
  return new Pn(n, !1);
  function K() {
    const F = Bl(
      A,
      o,
      e,
      t,
      n,
      l
    );
    if (!F) {
      r.produce(n, s), i = !0;
      return;
    }
    const Q = F.captureIndices, f = F.matchedRuleId, c = Q && Q.length > 0 ? Q[0].end > t : !1;
    if (f === al) {
      const U = n.getRule(A);
      r.produce(n, Q[0].start), n = n.withContentNameScopesList(n.nameScopesList), Qo(
        A,
        o,
        e,
        n,
        r,
        U.endCaptures,
        Q
      ), r.produce(n, Q[0].end);
      const u = n;
      if (n = n.parent, l = u.getAnchorPos(), !c && u.getEnterPos() === t) {
        n = u, r.produce(n, s), i = !0;
        return;
      }
    } else {
      const U = A.getRule(f);
      r.produce(n, Q[0].start);
      const u = n, d = U.getName(o.content, Q), P = n.contentNameScopesList.pushAttributed(
        d,
        A
      );
      if (n = n.push(
        f,
        t,
        l,
        Q[0].end === s,
        null,
        P,
        P
      ), U instanceof Bt) {
        const v = U;
        Qo(
          A,
          o,
          e,
          n,
          r,
          v.beginCaptures,
          Q
        ), r.produce(n, Q[0].end), l = Q[0].end;
        const y = v.getContentName(
          o.content,
          Q
        ), w = P.pushAttributed(
          y,
          A
        );
        if (n = n.withContentNameScopesList(w), v.endHasBackReferences && (n = n.withEndRule(
          v.getEndWithResolvedBackReferences(
            o.content,
            Q
          )
        )), !c && u.hasSameRuleAs(n)) {
          n = n.pop(), r.produce(n, s), i = !0;
          return;
        }
      } else if (U instanceof ne) {
        const v = U;
        Qo(
          A,
          o,
          e,
          n,
          r,
          v.beginCaptures,
          Q
        ), r.produce(n, Q[0].end), l = Q[0].end;
        const y = v.getContentName(
          o.content,
          Q
        ), w = P.pushAttributed(
          y,
          A
        );
        if (n = n.withContentNameScopesList(w), v.whileHasBackReferences && (n = n.withEndRule(
          v.getWhileWithResolvedBackReferences(
            o.content,
            Q
          )
        )), !c && u.hasSameRuleAs(n)) {
          n = n.pop(), r.produce(n, s), i = !0;
          return;
        }
      } else if (Qo(
        A,
        o,
        e,
        n,
        r,
        U.captures,
        Q
      ), r.produce(n, Q[0].end), n = n.pop(), !c) {
        n = n.safePop(), r.produce(n, s), i = !0;
        return;
      }
    }
    Q[0].end > t && (t = Q[0].end, e = !1);
  }
}
function ll(A, o, e, t, n, r) {
  let a = n.beginRuleCapturedEOL ? 0 : -1;
  const g = [];
  for (let s = n; s; s = s.pop()) {
    const i = s.getRule(A);
    i instanceof ne && g.push({
      rule: i,
      stack: s
    });
  }
  for (let s = g.pop(); s; s = g.pop()) {
    const { ruleScanner: i, findOptions: l } = Fl(s.rule, A, s.stack.endRule, e, t === a), B = i.findNextMatchSync(o, t, l);
    if (B) {
      if (B.ruleId !== aa) {
        n = s.stack.pop();
        break;
      }
      B.captureIndices && B.captureIndices.length && (r.produce(s.stack, B.captureIndices[0].start), Qo(A, o, e, s.stack, r, s.rule.whileCaptures, B.captureIndices), r.produce(s.stack, B.captureIndices[0].end), a = B.captureIndices[0].end, B.captureIndices[0].end > t && (t = B.captureIndices[0].end, e = !1));
    } else {
      n = s.stack.pop();
      break;
    }
  }
  return { stack: n, linePos: t, anchorPosition: a, isFirstLine: e };
}
function Bl(A, o, e, t, n, r) {
  const a = Kl(A, o, e, t, n, r), g = A.getInjections();
  if (g.length === 0)
    return a;
  const s = Ql(g, A, o, e, t, n, r);
  if (!s)
    return a;
  if (!a)
    return s;
  const i = a.captureIndices[0].start, l = s.captureIndices[0].start;
  return l < i || s.priorityMatch && l === i ? s : a;
}
function Kl(A, o, e, t, n, r) {
  const a = n.getRule(A), { ruleScanner: g, findOptions: s } = Ca(a, A, n.endRule, e, t === r), i = g.findNextMatchSync(o, t, s);
  return i ? {
    captureIndices: i.captureIndices,
    matchedRuleId: i.ruleId
  } : null;
}
function Ql(A, o, e, t, n, r, a) {
  let g = Number.MAX_VALUE, s = null, i, l = 0;
  const B = r.contentNameScopesList.getScopeNames();
  for (let K = 0, F = A.length; K < F; K++) {
    const Q = A[K];
    if (!Q.matcher(B))
      continue;
    const f = o.getRule(Q.ruleId), { ruleScanner: c, findOptions: U } = Ca(f, o, null, t, n === a), u = c.findNextMatchSync(e, n, U);
    if (!u)
      continue;
    const d = u.captureIndices[0].start;
    if (!(d >= g) && (g = d, s = u.captureIndices, i = u.ruleId, l = Q.priority, g === n))
      break;
  }
  return s ? {
    priorityMatch: l === -1,
    captureIndices: s,
    matchedRuleId: i
  } : null;
}
function Ca(A, o, e, t, n) {
  return {
    ruleScanner: A.compileAG(o, e, t, n),
    findOptions: 0
    /* None */
  };
}
function Fl(A, o, e, t, n) {
  return {
    ruleScanner: A.compileWhileAG(o, e, t, n),
    findOptions: 0
    /* None */
  };
}
function Qo(A, o, e, t, n, r, a) {
  if (r.length === 0)
    return;
  const g = o.content, s = Math.min(r.length, a.length), i = [], l = a[0].end;
  for (let B = 0; B < s; B++) {
    const K = r[B];
    if (K === null)
      continue;
    const F = a[B];
    if (F.length === 0)
      continue;
    if (F.start > l)
      break;
    for (; i.length > 0 && i[i.length - 1].endPos <= F.start; )
      n.produceFromScopes(i[i.length - 1].scopes, i[i.length - 1].endPos), i.pop();
    if (i.length > 0 ? n.produceFromScopes(i[i.length - 1].scopes, F.start) : n.produce(t, F.start), K.retokenizeCapturedWithRuleId) {
      const f = K.getName(g, a), c = t.contentNameScopesList.pushAttributed(f, A), U = K.getContentName(g, a), u = c.pushAttributed(U, A), d = t.push(K.retokenizeCapturedWithRuleId, F.start, -1, !1, null, c, u), P = A.createOnigString(g.substring(0, F.end));
      ia(
        A,
        P,
        e && F.start === 0,
        F.start,
        d,
        n,
        !1,
        /* no time limit */
        0
      ), na(P);
      continue;
    }
    const Q = K.getName(g, a);
    if (Q !== null) {
      const c = (i.length > 0 ? i[i.length - 1].scopes : t.contentNameScopesList).pushAttributed(Q, A);
      i.push(new cl(c, F.end));
    }
  }
  for (; i.length > 0; )
    n.produceFromScopes(i[i.length - 1].scopes, i[i.length - 1].endPos), i.pop();
}
var cl = class {
  constructor(A, o) {
    p(this, "scopes");
    p(this, "endPos");
    this.scopes = A, this.endPos = o;
  }
};
function fl(A, o, e, t, n, r, a, g) {
  return new ul(
    A,
    o,
    e,
    t,
    n,
    r,
    a,
    g
  );
}
function vn(A, o, e, t, n) {
  const r = ee(o, re), a = ga.getCompiledRuleId(e, t, n.repository);
  for (const g of r)
    A.push({
      debugSelector: o,
      matcher: g.matcher,
      ruleId: a,
      grammar: n,
      priority: g.priority
    });
}
function re(A, o) {
  if (o.length < A.length)
    return !1;
  let e = 0;
  return A.every((t) => {
    for (let n = e; n < o.length; n++)
      if (Ul(o[n], t))
        return e = n + 1, !0;
    return !1;
  });
}
function Ul(A, o) {
  if (!A)
    return !1;
  if (A === o)
    return !0;
  const e = o.length;
  return A.length > e && A.substr(0, e) === o && A[e] === ".";
}
var ul = class {
  constructor(A, o, e, t, n, r, a, g) {
    p(this, "_rootId");
    p(this, "_lastRuleId");
    p(this, "_ruleId2desc");
    p(this, "_includedGrammars");
    p(this, "_grammarRepository");
    p(this, "_grammar");
    p(this, "_injections");
    p(this, "_basicScopeAttributesProvider");
    p(this, "_tokenTypeMatchers");
    if (this._rootScopeName = A, this.balancedBracketSelectors = r, this._onigLib = g, this._basicScopeAttributesProvider = new il(
      e,
      t
    ), this._rootId = -1, this._lastRuleId = 0, this._ruleId2desc = [null], this._includedGrammars = {}, this._grammarRepository = a, this._grammar = wn(o, null), this._injections = null, this._tokenTypeMatchers = [], n)
      for (const s of Object.keys(n)) {
        const i = ee(s, re);
        for (const l of i)
          this._tokenTypeMatchers.push({
            matcher: l.matcher,
            type: n[s]
          });
      }
  }
  get themeProvider() {
    return this._grammarRepository;
  }
  dispose() {
    for (const A of this._ruleId2desc)
      A && A.dispose();
  }
  createOnigScanner(A) {
    return this._onigLib.createOnigScanner(A);
  }
  createOnigString(A) {
    return this._onigLib.createOnigString(A);
  }
  getMetadataForScope(A) {
    return this._basicScopeAttributesProvider.getBasicScopeAttributes(A);
  }
  _collectInjections() {
    const A = {
      lookup: (n) => n === this._rootScopeName ? this._grammar : this.getExternalGrammar(n),
      injections: (n) => this._grammarRepository.injections(n)
    }, o = [], e = this._rootScopeName, t = A.lookup(e);
    if (t) {
      const n = t.injections;
      if (n)
        for (let a in n)
          vn(
            o,
            a,
            n[a],
            this,
            t
          );
      const r = this._grammarRepository.injections(e);
      r && r.forEach((a) => {
        const g = this.getExternalGrammar(a);
        if (g) {
          const s = g.injectionSelector;
          s && vn(
            o,
            s,
            g,
            this,
            g
          );
        }
      });
    }
    return o.sort((n, r) => n.priority - r.priority), o;
  }
  getInjections() {
    return this._injections === null && (this._injections = this._collectInjections()), this._injections;
  }
  registerRule(A) {
    const o = ++this._lastRuleId, e = A(o);
    return this._ruleId2desc[o] = e, e;
  }
  getRule(A) {
    return this._ruleId2desc[A];
  }
  getExternalGrammar(A, o) {
    if (this._includedGrammars[A])
      return this._includedGrammars[A];
    if (this._grammarRepository) {
      const e = this._grammarRepository.lookup(A);
      if (e)
        return this._includedGrammars[A] = wn(
          e,
          o && o.$base
        ), this._includedGrammars[A];
    }
  }
  tokenizeLine(A, o, e = 0) {
    const t = this._tokenize(A, o, !1, e);
    return {
      tokens: t.lineTokens.getResult(t.ruleStack, t.lineLength),
      ruleStack: t.ruleStack,
      stoppedEarly: t.stoppedEarly
    };
  }
  tokenizeLine2(A, o, e = 0) {
    const t = this._tokenize(A, o, !0, e);
    return {
      tokens: t.lineTokens.getBinaryResult(t.ruleStack, t.lineLength),
      ruleStack: t.ruleStack,
      stoppedEarly: t.stoppedEarly
    };
  }
  _tokenize(A, o, e, t) {
    this._rootId === -1 && (this._rootId = ga.getCompiledRuleId(
      this._grammar.repository.$self,
      this,
      this._grammar.repository
    ), this.getInjections());
    let n;
    if (!o || o === Kt.NULL) {
      n = !0;
      const i = this._basicScopeAttributesProvider.getDefaultAttributes(), l = this.themeProvider.getDefaults(), B = oo.set(
        0,
        i.languageId,
        i.tokenType,
        null,
        l.fontStyle,
        l.foregroundId,
        l.backgroundId
      ), K = this.getRule(this._rootId).getName(
        null,
        null
      );
      let F;
      K ? F = co.createRootAndLookUpScopeName(
        K,
        B,
        this
      ) : F = co.createRoot(
        "unknown",
        B
      ), o = new Kt(
        null,
        this._rootId,
        -1,
        -1,
        !1,
        null,
        F,
        F
      );
    } else
      n = !1, o.reset();
    A = A + `
`;
    const r = this.createOnigString(A), a = r.content.length, g = new pl(
      e,
      A,
      this._tokenTypeMatchers,
      this.balancedBracketSelectors
    ), s = ia(
      this,
      r,
      n,
      0,
      o,
      g,
      !0,
      t
    );
    return na(r), {
      lineLength: a,
      lineTokens: g,
      ruleStack: s.stack,
      stoppedEarly: s.stoppedEarly
    };
  }
};
function wn(A, o) {
  return A = TC(A), A.repository = A.repository || {}, A.repository.$self = {
    $vscodeTextmateLocation: A.$vscodeTextmateLocation,
    patterns: A.patterns,
    name: A.scopeName
  }, A.repository.$base = o || A.repository.$self, A;
}
var co = class QA {
  /**
   * Invariant:
   * ```
   * if (parent && !scopePath.extends(parent.scopePath)) {
   * 	throw new Error();
   * }
   * ```
   */
  constructor(o, e, t) {
    this.parent = o, this.scopePath = e, this.tokenAttributes = t;
  }
  static fromExtension(o, e) {
    let t = o, n = (o == null ? void 0 : o.scopePath) ?? null;
    for (const r of e)
      n = He.push(n, r.scopeNames), t = new QA(t, n, r.encodedTokenAttributes);
    return t;
  }
  static createRoot(o, e) {
    return new QA(null, new He(null, o), e);
  }
  static createRootAndLookUpScopeName(o, e, t) {
    const n = t.getMetadataForScope(o), r = new He(null, o), a = t.themeProvider.themeMatch(r), g = QA.mergeAttributes(
      e,
      n,
      a
    );
    return new QA(null, r, g);
  }
  get scopeName() {
    return this.scopePath.scopeName;
  }
  toString() {
    return this.getScopeNames().join(" ");
  }
  equals(o) {
    return QA.equals(this, o);
  }
  static equals(o, e) {
    do {
      if (o === e || !o && !e)
        return !0;
      if (!o || !e || o.scopeName !== e.scopeName || o.tokenAttributes !== e.tokenAttributes)
        return !1;
      o = o.parent, e = e.parent;
    } while (!0);
  }
  static mergeAttributes(o, e, t) {
    let n = -1, r = 0, a = 0;
    return t !== null && (n = t.fontStyle, r = t.foregroundId, a = t.backgroundId), oo.set(
      o,
      e.languageId,
      e.tokenType,
      null,
      n,
      r,
      a
    );
  }
  pushAttributed(o, e) {
    if (o === null)
      return this;
    if (o.indexOf(" ") === -1)
      return QA._pushAttributed(this, o, e);
    const t = o.split(/ /g);
    let n = this;
    for (const r of t)
      n = QA._pushAttributed(n, r, e);
    return n;
  }
  static _pushAttributed(o, e, t) {
    const n = t.getMetadataForScope(e), r = o.scopePath.push(e), a = t.themeProvider.themeMatch(r), g = QA.mergeAttributes(
      o.tokenAttributes,
      n,
      a
    );
    return new QA(o, r, g);
  }
  getScopeNames() {
    return this.scopePath.getSegments();
  }
  getExtensionIfDefined(o) {
    var n;
    const e = [];
    let t = this;
    for (; t && t !== o; )
      e.push({
        encodedTokenAttributes: t.tokenAttributes,
        scopeNames: t.scopePath.getExtensionIfDefined(((n = t.parent) == null ? void 0 : n.scopePath) ?? null)
      }), t = t.parent;
    return t === o ? e.reverse() : void 0;
  }
}, nA, Kt = (nA = class {
  /**
   * Invariant:
   * ```
   * if (contentNameScopesList !== nameScopesList && contentNameScopesList?.parent !== nameScopesList) {
   * 	throw new Error();
   * }
   * if (this.parent && !nameScopesList.extends(this.parent.contentNameScopesList)) {
   * 	throw new Error();
   * }
   * ```
   */
  constructor(o, e, t, n, r, a, g, s) {
    p(this, "_stackElementBrand");
    /**
     * The position on the current line where this state was pushed.
     * This is relevant only while tokenizing a line, to detect endless loops.
     * Its value is meaningless across lines.
     */
    p(this, "_enterPos");
    /**
     * The captured anchor position when this stack element was pushed.
     * This is relevant only while tokenizing a line, to restore the anchor position when popping.
     * Its value is meaningless across lines.
     */
    p(this, "_anchorPos");
    /**
     * The depth of the stack.
     */
    p(this, "depth");
    this.parent = o, this.ruleId = e, this.beginRuleCapturedEOL = r, this.endRule = a, this.nameScopesList = g, this.contentNameScopesList = s, this.depth = this.parent ? this.parent.depth + 1 : 1, this._enterPos = t, this._anchorPos = n;
  }
  equals(o) {
    return o === null ? !1 : nA._equals(this, o);
  }
  static _equals(o, e) {
    return o === e ? !0 : this._structuralEquals(o, e) ? co.equals(o.contentNameScopesList, e.contentNameScopesList) : !1;
  }
  /**
   * A structural equals check. Does not take into account `scopes`.
   */
  static _structuralEquals(o, e) {
    do {
      if (o === e || !o && !e)
        return !0;
      if (!o || !e || o.depth !== e.depth || o.ruleId !== e.ruleId || o.endRule !== e.endRule)
        return !1;
      o = o.parent, e = e.parent;
    } while (!0);
  }
  clone() {
    return this;
  }
  static _reset(o) {
    for (; o; )
      o._enterPos = -1, o._anchorPos = -1, o = o.parent;
  }
  reset() {
    nA._reset(this);
  }
  pop() {
    return this.parent;
  }
  safePop() {
    return this.parent ? this.parent : this;
  }
  push(o, e, t, n, r, a, g) {
    return new nA(
      this,
      o,
      e,
      t,
      n,
      r,
      a,
      g
    );
  }
  getEnterPos() {
    return this._enterPos;
  }
  getAnchorPos() {
    return this._anchorPos;
  }
  getRule(o) {
    return o.getRule(this.ruleId);
  }
  toString() {
    const o = [];
    return this._writeString(o, 0), "[" + o.join(",") + "]";
  }
  _writeString(o, e) {
    var t, n;
    return this.parent && (e = this.parent._writeString(o, e)), o[e++] = `(${this.ruleId}, ${(t = this.nameScopesList) == null ? void 0 : t.toString()}, ${(n = this.contentNameScopesList) == null ? void 0 : n.toString()})`, e;
  }
  withContentNameScopesList(o) {
    return this.contentNameScopesList === o ? this : this.parent.push(
      this.ruleId,
      this._enterPos,
      this._anchorPos,
      this.beginRuleCapturedEOL,
      this.endRule,
      this.nameScopesList,
      o
    );
  }
  withEndRule(o) {
    return this.endRule === o ? this : new nA(
      this.parent,
      this.ruleId,
      this._enterPos,
      this._anchorPos,
      this.beginRuleCapturedEOL,
      o,
      this.nameScopesList,
      this.contentNameScopesList
    );
  }
  // Used to warn of endless loops
  hasSameRuleAs(o) {
    let e = this;
    for (; e && e._enterPos === o._enterPos; ) {
      if (e.ruleId === o.ruleId)
        return !0;
      e = e.parent;
    }
    return !1;
  }
  toStateStackFrame() {
    var o, e, t;
    return {
      ruleId: this.ruleId,
      beginRuleCapturedEOL: this.beginRuleCapturedEOL,
      endRule: this.endRule,
      nameScopesList: ((e = this.nameScopesList) == null ? void 0 : e.getExtensionIfDefined(((o = this.parent) == null ? void 0 : o.nameScopesList) ?? null)) ?? [],
      contentNameScopesList: ((t = this.contentNameScopesList) == null ? void 0 : t.getExtensionIfDefined(this.nameScopesList)) ?? []
    };
  }
  static pushFrame(o, e) {
    const t = co.fromExtension((o == null ? void 0 : o.nameScopesList) ?? null, e.nameScopesList);
    return new nA(
      o,
      e.ruleId,
      e.enterPos ?? -1,
      e.anchorPos ?? -1,
      e.beginRuleCapturedEOL,
      e.endRule,
      t,
      co.fromExtension(t, e.contentNameScopesList)
    );
  }
}, // TODO remove me
p(nA, "NULL", new nA(
  null,
  0,
  0,
  0,
  !1,
  null,
  null,
  null
)), nA), dl = class {
  constructor(A, o) {
    p(this, "balancedBracketScopes");
    p(this, "unbalancedBracketScopes");
    p(this, "allowAny", !1);
    this.balancedBracketScopes = A.flatMap(
      (e) => e === "*" ? (this.allowAny = !0, []) : ee(e, re).map((t) => t.matcher)
    ), this.unbalancedBracketScopes = o.flatMap(
      (e) => ee(e, re).map((t) => t.matcher)
    );
  }
  get matchesAlways() {
    return this.allowAny && this.unbalancedBracketScopes.length === 0;
  }
  get matchesNever() {
    return this.balancedBracketScopes.length === 0 && !this.allowAny;
  }
  match(A) {
    for (const o of this.unbalancedBracketScopes)
      if (o(A))
        return !1;
    for (const o of this.balancedBracketScopes)
      if (o(A))
        return !0;
    return this.allowAny;
  }
}, pl = class {
  constructor(A, o, e, t) {
    p(this, "_emitBinaryTokens");
    /**
     * defined only if `false`.
     */
    p(this, "_lineText");
    /**
     * used only if `_emitBinaryTokens` is false.
     */
    p(this, "_tokens");
    /**
     * used only if `_emitBinaryTokens` is true.
     */
    p(this, "_binaryTokens");
    p(this, "_lastTokenEndIndex");
    p(this, "_tokenTypeOverrides");
    this.balancedBracketSelectors = t, this._emitBinaryTokens = A, this._tokenTypeOverrides = e, this._lineText = null, this._tokens = [], this._binaryTokens = [], this._lastTokenEndIndex = 0;
  }
  produce(A, o) {
    this.produceFromScopes(A.contentNameScopesList, o);
  }
  produceFromScopes(A, o) {
    var t;
    if (this._lastTokenEndIndex >= o)
      return;
    if (this._emitBinaryTokens) {
      let n = (A == null ? void 0 : A.tokenAttributes) ?? 0, r = !1;
      if ((t = this.balancedBracketSelectors) != null && t.matchesAlways && (r = !0), this._tokenTypeOverrides.length > 0 || this.balancedBracketSelectors && !this.balancedBracketSelectors.matchesAlways && !this.balancedBracketSelectors.matchesNever) {
        const a = (A == null ? void 0 : A.getScopeNames()) ?? [];
        for (const g of this._tokenTypeOverrides)
          g.matcher(a) && (n = oo.set(
            n,
            0,
            g.type,
            null,
            -1,
            0,
            0
          ));
        this.balancedBracketSelectors && (r = this.balancedBracketSelectors.match(a));
      }
      if (r && (n = oo.set(
        n,
        0,
        8,
        r,
        -1,
        0,
        0
      )), this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 1] === n) {
        this._lastTokenEndIndex = o;
        return;
      }
      this._binaryTokens.push(this._lastTokenEndIndex), this._binaryTokens.push(n), this._lastTokenEndIndex = o;
      return;
    }
    const e = (A == null ? void 0 : A.getScopeNames()) ?? [];
    this._tokens.push({
      startIndex: this._lastTokenEndIndex,
      endIndex: o,
      // value: lineText.substring(lastTokenEndIndex, endIndex),
      scopes: e
    }), this._lastTokenEndIndex = o;
  }
  getResult(A, o) {
    return this._tokens.length > 0 && this._tokens[this._tokens.length - 1].startIndex === o - 1 && this._tokens.pop(), this._tokens.length === 0 && (this._lastTokenEndIndex = -1, this.produce(A, o), this._tokens[this._tokens.length - 1].startIndex = 0), this._tokens;
  }
  getBinaryResult(A, o) {
    this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 2] === o - 1 && (this._binaryTokens.pop(), this._binaryTokens.pop()), this._binaryTokens.length === 0 && (this._lastTokenEndIndex = -1, this.produce(A, o), this._binaryTokens[this._binaryTokens.length - 2] = 0);
    const e = new Uint32Array(this._binaryTokens.length);
    for (let t = 0, n = this._binaryTokens.length; t < n; t++)
      e[t] = this._binaryTokens[t];
    return e;
  }
}, hl = class {
  constructor(A, o) {
    p(this, "_grammars", /* @__PURE__ */ new Map());
    p(this, "_rawGrammars", /* @__PURE__ */ new Map());
    p(this, "_injectionGrammars", /* @__PURE__ */ new Map());
    p(this, "_theme");
    this._onigLib = o, this._theme = A;
  }
  dispose() {
    for (const A of this._grammars.values())
      A.dispose();
  }
  setTheme(A) {
    this._theme = A;
  }
  getColorMap() {
    return this._theme.getColorMap();
  }
  /**
   * Add `grammar` to registry and return a list of referenced scope names
   */
  addGrammar(A, o) {
    this._rawGrammars.set(A.scopeName, A), o && this._injectionGrammars.set(A.scopeName, o);
  }
  /**
   * Lookup a raw grammar.
   */
  lookup(A) {
    return this._rawGrammars.get(A);
  }
  /**
   * Returns the injections for the given grammar
   */
  injections(A) {
    return this._injectionGrammars.get(A);
  }
  /**
   * Get the default theme settings
   */
  getDefaults() {
    return this._theme.getDefaults();
  }
  /**
   * Match a scope in the theme.
   */
  themeMatch(A) {
    return this._theme.match(A);
  }
  /**
   * Lookup a grammar.
   */
  grammarForScopeName(A, o, e, t, n) {
    if (!this._grammars.has(A)) {
      let r = this._rawGrammars.get(A);
      if (!r)
        return null;
      this._grammars.set(A, fl(
        A,
        r,
        o,
        e,
        t,
        n,
        this,
        this._onigLib
      ));
    }
    return this._grammars.get(A);
  }
}, ml = class {
  constructor(o) {
    p(this, "_options");
    p(this, "_syncRegistry");
    p(this, "_ensureGrammarCache");
    this._options = o, this._syncRegistry = new hl(
      oe.createFromRawTheme(o.theme, o.colorMap),
      o.onigLib
    ), this._ensureGrammarCache = /* @__PURE__ */ new Map();
  }
  dispose() {
    this._syncRegistry.dispose();
  }
  /**
   * Change the theme. Once called, no previous `ruleStack` should be used anymore.
   */
  setTheme(o, e) {
    this._syncRegistry.setTheme(oe.createFromRawTheme(o, e));
  }
  /**
   * Returns a lookup array for color ids.
   */
  getColorMap() {
    return this._syncRegistry.getColorMap();
  }
  /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */
  loadGrammarWithEmbeddedLanguages(o, e, t) {
    return this.loadGrammarWithConfiguration(o, e, { embeddedLanguages: t });
  }
  /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */
  loadGrammarWithConfiguration(o, e, t) {
    return this._loadGrammar(
      o,
      e,
      t.embeddedLanguages,
      t.tokenTypes,
      new dl(
        t.balancedBracketSelectors || [],
        t.unbalancedBracketSelectors || []
      )
    );
  }
  /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   */
  loadGrammar(o) {
    return this._loadGrammar(o, 0, null, null, null);
  }
  _loadGrammar(o, e, t, n, r) {
    const a = new _C(this._syncRegistry, o);
    for (; a.Q.length > 0; )
      a.Q.map((g) => this._loadSingleGrammar(g.scopeName)), a.processQueue();
    return this._grammarForScopeName(
      o,
      e,
      t,
      n,
      r
    );
  }
  _loadSingleGrammar(o) {
    this._ensureGrammarCache.has(o) || (this._doLoadSingleGrammar(o), this._ensureGrammarCache.set(o, !0));
  }
  _doLoadSingleGrammar(o) {
    const e = this._options.loadGrammar(o);
    if (e) {
      const t = typeof this._options.getInjections == "function" ? this._options.getInjections(o) : void 0;
      this._syncRegistry.addGrammar(e, t);
    }
  }
  /**
   * Adds a rawGrammar.
   */
  addGrammar(o, e = [], t = 0, n = null) {
    return this._syncRegistry.addGrammar(o, e), this._grammarForScopeName(o.scopeName, t, n);
  }
  /**
   * Get the grammar for `scopeName`. The grammar must first be created via `loadGrammar` or `addGrammar`.
   */
  _grammarForScopeName(o, e = 0, t = null, n = null, r = null) {
    return this._syncRegistry.grammarForScopeName(
      o,
      e,
      t,
      n,
      r
    );
  }
}, Qt = Kt.NULL;
const Pl = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
];
class xo {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(o, e, t) {
    this.normal = e, this.property = o, t && (this.space = t);
  }
}
xo.prototype.normal = {};
xo.prototype.property = {};
xo.prototype.space = void 0;
function la(A, o) {
  const e = {}, t = {};
  for (const n of A)
    Object.assign(e, n.property), Object.assign(t, n.normal);
  return new xo(e, t, o);
}
function Ft(A) {
  return A.toLowerCase();
}
class Y {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(o, e) {
    this.attribute = e, this.property = o;
  }
}
Y.prototype.attribute = "";
Y.prototype.booleanish = !1;
Y.prototype.boolean = !1;
Y.prototype.commaOrSpaceSeparated = !1;
Y.prototype.commaSeparated = !1;
Y.prototype.defined = !1;
Y.prototype.mustUseProperty = !1;
Y.prototype.number = !1;
Y.prototype.overloadedBoolean = !1;
Y.prototype.property = "";
Y.prototype.spaceSeparated = !1;
Y.prototype.space = void 0;
let vl = 0;
const H = WA(), O = WA(), ct = WA(), m = WA(), R = WA(), _A = WA(), _ = WA();
function WA() {
  return 2 ** ++vl;
}
const ft = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: H,
  booleanish: O,
  commaOrSpaceSeparated: _,
  commaSeparated: _A,
  number: m,
  overloadedBoolean: ct,
  spaceSeparated: R
}, Symbol.toStringTag, { value: "Module" })), Ne = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(ft)
);
class Jt extends Y {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(o, e, t, n) {
    let r = -1;
    if (super(o, e), yn(this, "space", n), typeof t == "number")
      for (; ++r < Ne.length; ) {
        const a = Ne[r];
        yn(this, Ne[r], (t & ft[a]) === ft[a]);
      }
  }
}
Jt.prototype.defined = !0;
function yn(A, o, e) {
  e && (A[o] = e);
}
function no(A) {
  const o = {}, e = {};
  for (const [t, n] of Object.entries(A.properties)) {
    const r = new Jt(
      t,
      A.transform(A.attributes || {}, t),
      n,
      A.space
    );
    A.mustUseProperty && A.mustUseProperty.includes(t) && (r.mustUseProperty = !0), o[t] = r, e[Ft(t)] = t, e[Ft(r.attribute)] = t;
  }
  return new xo(o, e, A.space);
}
const Ba = no({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: O,
    ariaAutoComplete: null,
    ariaBusy: O,
    ariaChecked: O,
    ariaColCount: m,
    ariaColIndex: m,
    ariaColSpan: m,
    ariaControls: R,
    ariaCurrent: null,
    ariaDescribedBy: R,
    ariaDetails: null,
    ariaDisabled: O,
    ariaDropEffect: R,
    ariaErrorMessage: null,
    ariaExpanded: O,
    ariaFlowTo: R,
    ariaGrabbed: O,
    ariaHasPopup: null,
    ariaHidden: O,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: R,
    ariaLevel: m,
    ariaLive: null,
    ariaModal: O,
    ariaMultiLine: O,
    ariaMultiSelectable: O,
    ariaOrientation: null,
    ariaOwns: R,
    ariaPlaceholder: null,
    ariaPosInSet: m,
    ariaPressed: O,
    ariaReadOnly: O,
    ariaRelevant: null,
    ariaRequired: O,
    ariaRoleDescription: R,
    ariaRowCount: m,
    ariaRowIndex: m,
    ariaRowSpan: m,
    ariaSelected: O,
    ariaSetSize: m,
    ariaSort: null,
    ariaValueMax: m,
    ariaValueMin: m,
    ariaValueNow: m,
    ariaValueText: null,
    role: null
  },
  transform(A, o) {
    return o === "role" ? o : "aria-" + o.slice(4).toLowerCase();
  }
});
function Ka(A, o) {
  return o in A ? A[o] : o;
}
function Qa(A, o) {
  return Ka(A, o.toLowerCase());
}
const wl = no({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: _A,
    acceptCharset: R,
    accessKey: R,
    action: null,
    allow: null,
    allowFullScreen: H,
    allowPaymentRequest: H,
    allowUserMedia: H,
    alt: null,
    as: null,
    async: H,
    autoCapitalize: null,
    autoComplete: R,
    autoFocus: H,
    autoPlay: H,
    blocking: R,
    capture: null,
    charSet: null,
    checked: H,
    cite: null,
    className: R,
    cols: m,
    colSpan: null,
    content: null,
    contentEditable: O,
    controls: H,
    controlsList: R,
    coords: m | _A,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: H,
    defer: H,
    dir: null,
    dirName: null,
    disabled: H,
    download: ct,
    draggable: O,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: H,
    formTarget: null,
    headers: R,
    height: m,
    hidden: ct,
    high: m,
    href: null,
    hrefLang: null,
    htmlFor: R,
    httpEquiv: R,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: H,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: H,
    itemId: null,
    itemProp: R,
    itemRef: R,
    itemScope: H,
    itemType: R,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: H,
    low: m,
    manifest: null,
    max: null,
    maxLength: m,
    media: null,
    method: null,
    min: null,
    minLength: m,
    multiple: H,
    muted: H,
    name: null,
    nonce: null,
    noModule: H,
    noValidate: H,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: H,
    optimum: m,
    pattern: null,
    ping: R,
    placeholder: null,
    playsInline: H,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: H,
    referrerPolicy: null,
    rel: R,
    required: H,
    reversed: H,
    rows: m,
    rowSpan: m,
    sandbox: R,
    scope: null,
    scoped: H,
    seamless: H,
    selected: H,
    shadowRootClonable: H,
    shadowRootDelegatesFocus: H,
    shadowRootMode: null,
    shape: null,
    size: m,
    sizes: null,
    slot: null,
    span: m,
    spellCheck: O,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: m,
    step: null,
    style: null,
    tabIndex: m,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: H,
    useMap: null,
    value: O,
    width: m,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: R,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: m,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: m,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: H,
    // Lists. Use CSS to reduce space between items instead
    declare: H,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: m,
    // `<img>` and `<object>`
    leftMargin: m,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: m,
    // `<body>`
    marginWidth: m,
    // `<body>`
    noResize: H,
    // `<frame>`
    noHref: H,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: H,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: H,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: m,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: O,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: m,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: m,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: H,
    disableRemotePlayback: H,
    prefix: null,
    property: null,
    results: m,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: Qa
}), yl = no({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: _,
    accentHeight: m,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: m,
    amplitude: m,
    arabicForm: null,
    ascent: m,
    attributeName: null,
    attributeType: null,
    azimuth: m,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: m,
    by: null,
    calcMode: null,
    capHeight: m,
    className: R,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: m,
    diffuseConstant: m,
    direction: null,
    display: null,
    dur: null,
    divisor: m,
    dominantBaseline: null,
    download: H,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: m,
    enableBackground: null,
    end: null,
    event: null,
    exponent: m,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: m,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: _A,
    g2: _A,
    glyphName: _A,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: m,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: m,
    horizOriginX: m,
    horizOriginY: m,
    id: null,
    ideographic: m,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: m,
    k: m,
    k1: m,
    k2: m,
    k3: m,
    k4: m,
    kernelMatrix: _,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: m,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: m,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: m,
    overlineThickness: m,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: m,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: R,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: m,
    pointsAtY: m,
    pointsAtZ: m,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: _,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: _,
    rev: _,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: _,
    requiredFeatures: _,
    requiredFonts: _,
    requiredFormats: _,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: m,
    specularExponent: m,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: m,
    strikethroughThickness: m,
    string: null,
    stroke: null,
    strokeDashArray: _,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: m,
    strokeOpacity: m,
    strokeWidth: null,
    style: null,
    surfaceScale: m,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: _,
    tabIndex: m,
    tableValues: null,
    target: null,
    targetX: m,
    targetY: m,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: _,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: m,
    underlineThickness: m,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: m,
    values: null,
    vAlphabetic: m,
    vMathematical: m,
    vectorEffect: null,
    vHanging: m,
    vIdeographic: m,
    version: null,
    vertAdvY: m,
    vertOriginX: m,
    vertOriginY: m,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: m,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: Ka
}), Fa = no({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(A, o) {
    return "xlink:" + o.slice(5).toLowerCase();
  }
}), ca = no({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: Qa
}), fa = no({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(A, o) {
    return "xml:" + o.slice(3).toLowerCase();
  }
}), bl = /[A-Z]/g, bn = /-[a-z]/g, Hl = /^data[-\w.:]+$/i;
function Dl(A, o) {
  const e = Ft(o);
  let t = o, n = Y;
  if (e in A.normal)
    return A.property[A.normal[e]];
  if (e.length > 4 && e.slice(0, 4) === "data" && Hl.test(o)) {
    if (o.charAt(4) === "-") {
      const r = o.slice(5).replace(bn, xl);
      t = "data" + r.charAt(0).toUpperCase() + r.slice(1);
    } else {
      const r = o.slice(4);
      if (!bn.test(r)) {
        let a = r.replace(bl, Nl);
        a.charAt(0) !== "-" && (a = "-" + a), o = "data" + a;
      }
    }
    n = Jt;
  }
  return new n(t, o);
}
function Nl(A) {
  return "-" + A.toLowerCase();
}
function xl(A) {
  return A.charAt(1).toUpperCase();
}
const jl = la([Ba, wl, Fa, ca, fa], "html"), Ua = la([Ba, yl, Fa, ca, fa], "svg"), Hn = {}.hasOwnProperty;
function kl(A, o) {
  const e = o || {};
  function t(n, ...r) {
    let a = t.invalid;
    const g = t.handlers;
    if (n && Hn.call(n, A)) {
      const s = String(n[A]);
      a = Hn.call(g, s) ? g[s] : t.unknown;
    }
    if (a)
      return a.call(this, n, ...r);
  }
  return t.handlers = e.handlers || {}, t.invalid = e.invalid, t.unknown = e.unknown, t;
}
const Sl = /["&'<>`]/g, Rl = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, Ll = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), Tl = /[|\\{}()[\]^$+*?.]/g, Dn = /* @__PURE__ */ new WeakMap();
function Ol(A, o) {
  if (A = A.replace(
    o.subset ? Xl(o.subset) : Sl,
    t
  ), o.subset || o.escapeOnly)
    return A;
  return A.replace(Rl, e).replace(Ll, t);
  function e(n, r, a) {
    return o.format(
      (n.charCodeAt(0) - 55296) * 1024 + n.charCodeAt(1) - 56320 + 65536,
      a.charCodeAt(r + 2),
      o
    );
  }
  function t(n, r, a) {
    return o.format(
      n.charCodeAt(0),
      a.charCodeAt(r + 1),
      o
    );
  }
}
function Xl(A) {
  let o = Dn.get(A);
  return o || (o = zl(A), Dn.set(A, o)), o;
}
function zl(A) {
  const o = [];
  let e = -1;
  for (; ++e < A.length; )
    o.push(A[e].replace(Tl, "\\$&"));
  return new RegExp("(?:" + o.join("|") + ")", "g");
}
const Il = /[\dA-Fa-f]/;
function Gl(A, o, e) {
  const t = "&#x" + A.toString(16).toUpperCase();
  return e && o && !Il.test(String.fromCharCode(o)) ? t : t + ";";
}
const Wl = /\d/;
function Vl(A, o, e) {
  const t = "&#" + String(A);
  return e && o && !Wl.test(String.fromCharCode(o)) ? t : t + ";";
}
const Ml = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], xe = {
  nbsp: " ",
  iexcl: "¡",
  cent: "¢",
  pound: "£",
  curren: "¤",
  yen: "¥",
  brvbar: "¦",
  sect: "§",
  uml: "¨",
  copy: "©",
  ordf: "ª",
  laquo: "«",
  not: "¬",
  shy: "­",
  reg: "®",
  macr: "¯",
  deg: "°",
  plusmn: "±",
  sup2: "²",
  sup3: "³",
  acute: "´",
  micro: "µ",
  para: "¶",
  middot: "·",
  cedil: "¸",
  sup1: "¹",
  ordm: "º",
  raquo: "»",
  frac14: "¼",
  frac12: "½",
  frac34: "¾",
  iquest: "¿",
  Agrave: "À",
  Aacute: "Á",
  Acirc: "Â",
  Atilde: "Ã",
  Auml: "Ä",
  Aring: "Å",
  AElig: "Æ",
  Ccedil: "Ç",
  Egrave: "È",
  Eacute: "É",
  Ecirc: "Ê",
  Euml: "Ë",
  Igrave: "Ì",
  Iacute: "Í",
  Icirc: "Î",
  Iuml: "Ï",
  ETH: "Ð",
  Ntilde: "Ñ",
  Ograve: "Ò",
  Oacute: "Ó",
  Ocirc: "Ô",
  Otilde: "Õ",
  Ouml: "Ö",
  times: "×",
  Oslash: "Ø",
  Ugrave: "Ù",
  Uacute: "Ú",
  Ucirc: "Û",
  Uuml: "Ü",
  Yacute: "Ý",
  THORN: "Þ",
  szlig: "ß",
  agrave: "à",
  aacute: "á",
  acirc: "â",
  atilde: "ã",
  auml: "ä",
  aring: "å",
  aelig: "æ",
  ccedil: "ç",
  egrave: "è",
  eacute: "é",
  ecirc: "ê",
  euml: "ë",
  igrave: "ì",
  iacute: "í",
  icirc: "î",
  iuml: "ï",
  eth: "ð",
  ntilde: "ñ",
  ograve: "ò",
  oacute: "ó",
  ocirc: "ô",
  otilde: "õ",
  ouml: "ö",
  divide: "÷",
  oslash: "ø",
  ugrave: "ù",
  uacute: "ú",
  ucirc: "û",
  uuml: "ü",
  yacute: "ý",
  thorn: "þ",
  yuml: "ÿ",
  fnof: "ƒ",
  Alpha: "Α",
  Beta: "Β",
  Gamma: "Γ",
  Delta: "Δ",
  Epsilon: "Ε",
  Zeta: "Ζ",
  Eta: "Η",
  Theta: "Θ",
  Iota: "Ι",
  Kappa: "Κ",
  Lambda: "Λ",
  Mu: "Μ",
  Nu: "Ν",
  Xi: "Ξ",
  Omicron: "Ο",
  Pi: "Π",
  Rho: "Ρ",
  Sigma: "Σ",
  Tau: "Τ",
  Upsilon: "Υ",
  Phi: "Φ",
  Chi: "Χ",
  Psi: "Ψ",
  Omega: "Ω",
  alpha: "α",
  beta: "β",
  gamma: "γ",
  delta: "δ",
  epsilon: "ε",
  zeta: "ζ",
  eta: "η",
  theta: "θ",
  iota: "ι",
  kappa: "κ",
  lambda: "λ",
  mu: "μ",
  nu: "ν",
  xi: "ξ",
  omicron: "ο",
  pi: "π",
  rho: "ρ",
  sigmaf: "ς",
  sigma: "σ",
  tau: "τ",
  upsilon: "υ",
  phi: "φ",
  chi: "χ",
  psi: "ψ",
  omega: "ω",
  thetasym: "ϑ",
  upsih: "ϒ",
  piv: "ϖ",
  bull: "•",
  hellip: "…",
  prime: "′",
  Prime: "″",
  oline: "‾",
  frasl: "⁄",
  weierp: "℘",
  image: "ℑ",
  real: "ℜ",
  trade: "™",
  alefsym: "ℵ",
  larr: "←",
  uarr: "↑",
  rarr: "→",
  darr: "↓",
  harr: "↔",
  crarr: "↵",
  lArr: "⇐",
  uArr: "⇑",
  rArr: "⇒",
  dArr: "⇓",
  hArr: "⇔",
  forall: "∀",
  part: "∂",
  exist: "∃",
  empty: "∅",
  nabla: "∇",
  isin: "∈",
  notin: "∉",
  ni: "∋",
  prod: "∏",
  sum: "∑",
  minus: "−",
  lowast: "∗",
  radic: "√",
  prop: "∝",
  infin: "∞",
  ang: "∠",
  and: "∧",
  or: "∨",
  cap: "∩",
  cup: "∪",
  int: "∫",
  there4: "∴",
  sim: "∼",
  cong: "≅",
  asymp: "≈",
  ne: "≠",
  equiv: "≡",
  le: "≤",
  ge: "≥",
  sub: "⊂",
  sup: "⊃",
  nsub: "⊄",
  sube: "⊆",
  supe: "⊇",
  oplus: "⊕",
  otimes: "⊗",
  perp: "⊥",
  sdot: "⋅",
  lceil: "⌈",
  rceil: "⌉",
  lfloor: "⌊",
  rfloor: "⌋",
  lang: "〈",
  rang: "〉",
  loz: "◊",
  spades: "♠",
  clubs: "♣",
  hearts: "♥",
  diams: "♦",
  quot: '"',
  amp: "&",
  lt: "<",
  gt: ">",
  OElig: "Œ",
  oelig: "œ",
  Scaron: "Š",
  scaron: "š",
  Yuml: "Ÿ",
  circ: "ˆ",
  tilde: "˜",
  ensp: " ",
  emsp: " ",
  thinsp: " ",
  zwnj: "‌",
  zwj: "‍",
  lrm: "‎",
  rlm: "‏",
  ndash: "–",
  mdash: "—",
  lsquo: "‘",
  rsquo: "’",
  sbquo: "‚",
  ldquo: "“",
  rdquo: "”",
  bdquo: "„",
  dagger: "†",
  Dagger: "‡",
  permil: "‰",
  lsaquo: "‹",
  rsaquo: "›",
  euro: "€"
}, El = [
  "cent",
  "copy",
  "divide",
  "gt",
  "lt",
  "not",
  "para",
  "times"
], ua = {}.hasOwnProperty, Ut = {};
let Lo;
for (Lo in xe)
  ua.call(xe, Lo) && (Ut[xe[Lo]] = Lo);
const ql = /[^\dA-Za-z]/;
function Jl(A, o, e, t) {
  const n = String.fromCharCode(A);
  if (ua.call(Ut, n)) {
    const r = Ut[n], a = "&" + r;
    return e && Ml.includes(r) && !El.includes(r) && (!t || o && o !== 61 && ql.test(String.fromCharCode(o))) ? a : a + ";";
  }
  return "";
}
function Zl(A, o, e) {
  let t = Gl(A, o, e.omitOptionalSemicolons), n;
  if ((e.useNamedReferences || e.useShortestReferences) && (n = Jl(
    A,
    o,
    e.omitOptionalSemicolons,
    e.attribute
  )), (e.useShortestReferences || !n) && e.useShortestReferences) {
    const r = Vl(A, o, e.omitOptionalSemicolons);
    r.length < t.length && (t = r);
  }
  return n && (!e.useShortestReferences || n.length < t.length) ? n : t;
}
function $A(A, o) {
  return Ol(A, Object.assign({ format: Zl }, o));
}
const Yl = /^>|^->|<!--|-->|--!>|<!-$/g, _l = [">"], $l = ["<", ">"];
function AB(A, o, e, t) {
  return t.settings.bogusComments ? "<?" + $A(
    A.value,
    Object.assign({}, t.settings.characterReferences, {
      subset: _l
    })
  ) + ">" : "<!--" + A.value.replace(Yl, n) + "-->";
  function n(r) {
    return $A(
      r,
      Object.assign({}, t.settings.characterReferences, {
        subset: $l
      })
    );
  }
}
function oB(A, o, e, t) {
  return "<!" + (t.settings.upperDoctype ? "DOCTYPE" : "doctype") + (t.settings.tightDoctype ? "" : " ") + "html>";
}
function Nn(A, o) {
  const e = String(A);
  if (typeof o != "string")
    throw new TypeError("Expected character");
  let t = 0, n = e.indexOf(o);
  for (; n !== -1; )
    t++, n = e.indexOf(o, n + o.length);
  return t;
}
function eB(A, o) {
  const e = o || {};
  return (A[A.length - 1] === "" ? [...A, ""] : A).join(
    (e.padRight ? " " : "") + "," + (e.padLeft === !1 ? "" : " ")
  ).trim();
}
function tB(A) {
  return A.join(" ").trim();
}
const nB = /[ \t\n\f\r]/g;
function Zt(A) {
  return typeof A == "object" ? A.type === "text" ? xn(A.value) : !1 : xn(A);
}
function xn(A) {
  return A.replace(nB, "") === "";
}
const I = pa(1), da = pa(-1), rB = [];
function pa(A) {
  return o;
  function o(e, t, n) {
    const r = e ? e.children : rB;
    let a = (t || 0) + A, g = r[a];
    if (!n)
      for (; g && Zt(g); )
        a += A, g = r[a];
    return g;
  }
}
const aB = {}.hasOwnProperty;
function ha(A) {
  return o;
  function o(e, t, n) {
    return aB.call(A, e.tagName) && A[e.tagName](e, t, n);
  }
}
const Yt = ha({
  body: sB,
  caption: je,
  colgroup: je,
  dd: BB,
  dt: lB,
  head: je,
  html: gB,
  li: CB,
  optgroup: KB,
  option: QB,
  p: iB,
  rp: jn,
  rt: jn,
  tbody: cB,
  td: kn,
  tfoot: fB,
  th: kn,
  thead: FB,
  tr: UB
});
function je(A, o, e) {
  const t = I(e, o, !0);
  return !t || t.type !== "comment" && !(t.type === "text" && Zt(t.value.charAt(0)));
}
function gB(A, o, e) {
  const t = I(e, o);
  return !t || t.type !== "comment";
}
function sB(A, o, e) {
  const t = I(e, o);
  return !t || t.type !== "comment";
}
function iB(A, o, e) {
  const t = I(e, o);
  return t ? t.type === "element" && (t.tagName === "address" || t.tagName === "article" || t.tagName === "aside" || t.tagName === "blockquote" || t.tagName === "details" || t.tagName === "div" || t.tagName === "dl" || t.tagName === "fieldset" || t.tagName === "figcaption" || t.tagName === "figure" || t.tagName === "footer" || t.tagName === "form" || t.tagName === "h1" || t.tagName === "h2" || t.tagName === "h3" || t.tagName === "h4" || t.tagName === "h5" || t.tagName === "h6" || t.tagName === "header" || t.tagName === "hgroup" || t.tagName === "hr" || t.tagName === "main" || t.tagName === "menu" || t.tagName === "nav" || t.tagName === "ol" || t.tagName === "p" || t.tagName === "pre" || t.tagName === "section" || t.tagName === "table" || t.tagName === "ul") : !e || // Confusing parent.
  !(e.type === "element" && (e.tagName === "a" || e.tagName === "audio" || e.tagName === "del" || e.tagName === "ins" || e.tagName === "map" || e.tagName === "noscript" || e.tagName === "video"));
}
function CB(A, o, e) {
  const t = I(e, o);
  return !t || t.type === "element" && t.tagName === "li";
}
function lB(A, o, e) {
  const t = I(e, o);
  return !!(t && t.type === "element" && (t.tagName === "dt" || t.tagName === "dd"));
}
function BB(A, o, e) {
  const t = I(e, o);
  return !t || t.type === "element" && (t.tagName === "dt" || t.tagName === "dd");
}
function jn(A, o, e) {
  const t = I(e, o);
  return !t || t.type === "element" && (t.tagName === "rp" || t.tagName === "rt");
}
function KB(A, o, e) {
  const t = I(e, o);
  return !t || t.type === "element" && t.tagName === "optgroup";
}
function QB(A, o, e) {
  const t = I(e, o);
  return !t || t.type === "element" && (t.tagName === "option" || t.tagName === "optgroup");
}
function FB(A, o, e) {
  const t = I(e, o);
  return !!(t && t.type === "element" && (t.tagName === "tbody" || t.tagName === "tfoot"));
}
function cB(A, o, e) {
  const t = I(e, o);
  return !t || t.type === "element" && (t.tagName === "tbody" || t.tagName === "tfoot");
}
function fB(A, o, e) {
  return !I(e, o);
}
function UB(A, o, e) {
  const t = I(e, o);
  return !t || t.type === "element" && t.tagName === "tr";
}
function kn(A, o, e) {
  const t = I(e, o);
  return !t || t.type === "element" && (t.tagName === "td" || t.tagName === "th");
}
const uB = ha({
  body: hB,
  colgroup: mB,
  head: pB,
  html: dB,
  tbody: PB
});
function dB(A) {
  const o = I(A, -1);
  return !o || o.type !== "comment";
}
function pB(A) {
  const o = /* @__PURE__ */ new Set();
  for (const t of A.children)
    if (t.type === "element" && (t.tagName === "base" || t.tagName === "title")) {
      if (o.has(t.tagName)) return !1;
      o.add(t.tagName);
    }
  const e = A.children[0];
  return !e || e.type === "element";
}
function hB(A) {
  const o = I(A, -1, !0);
  return !o || o.type !== "comment" && !(o.type === "text" && Zt(o.value.charAt(0))) && !(o.type === "element" && (o.tagName === "meta" || o.tagName === "link" || o.tagName === "script" || o.tagName === "style" || o.tagName === "template"));
}
function mB(A, o, e) {
  const t = da(e, o), n = I(A, -1, !0);
  return e && t && t.type === "element" && t.tagName === "colgroup" && Yt(t, e.children.indexOf(t), e) ? !1 : !!(n && n.type === "element" && n.tagName === "col");
}
function PB(A, o, e) {
  const t = da(e, o), n = I(A, -1);
  return e && t && t.type === "element" && (t.tagName === "thead" || t.tagName === "tbody") && Yt(t, e.children.indexOf(t), e) ? !1 : !!(n && n.type === "element" && n.tagName === "tr");
}
const To = {
  // See: <https://html.spec.whatwg.org/#attribute-name-state>.
  name: [
    [`	
\f\r &/=>`.split(""), `	
\f\r "&'/=>\``.split("")],
    [`\0	
\f\r "&'/<=>`.split(""), `\0	
\f\r "&'/<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
  unquoted: [
    [`	
\f\r &>`.split(""), `\0	
\f\r "&'<=>\``.split("")],
    [`\0	
\f\r "&'<=>\``.split(""), `\0	
\f\r "&'<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
  single: [
    ["&'".split(""), "\"&'`".split("")],
    ["\0&'".split(""), "\0\"&'`".split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
  double: [
    ['"&'.split(""), "\"&'`".split("")],
    ['\0"&'.split(""), "\0\"&'`".split("")]
  ]
};
function vB(A, o, e, t) {
  const n = t.schema, r = n.space === "svg" ? !1 : t.settings.omitOptionalTags;
  let a = n.space === "svg" ? t.settings.closeEmptyElements : t.settings.voids.includes(A.tagName.toLowerCase());
  const g = [];
  let s;
  n.space === "html" && A.tagName === "svg" && (t.schema = Ua);
  const i = wB(t, A.properties), l = t.all(
    n.space === "html" && A.tagName === "template" ? A.content : A
  );
  return t.schema = n, l && (a = !1), (i || !r || !uB(A, o, e)) && (g.push("<", A.tagName, i ? " " + i : ""), a && (n.space === "svg" || t.settings.closeSelfClosing) && (s = i.charAt(i.length - 1), (!t.settings.tightSelfClosing || s === "/" || s && s !== '"' && s !== "'") && g.push(" "), g.push("/")), g.push(">")), g.push(l), !a && (!r || !Yt(A, o, e)) && g.push("</" + A.tagName + ">"), g.join("");
}
function wB(A, o) {
  const e = [];
  let t = -1, n;
  if (o) {
    for (n in o)
      if (o[n] !== null && o[n] !== void 0) {
        const r = yB(A, n, o[n]);
        r && e.push(r);
      }
  }
  for (; ++t < e.length; ) {
    const r = A.settings.tightAttributes ? e[t].charAt(e[t].length - 1) : void 0;
    t !== e.length - 1 && r !== '"' && r !== "'" && (e[t] += " ");
  }
  return e.join("");
}
function yB(A, o, e) {
  const t = Dl(A.schema, o), n = A.settings.allowParseErrors && A.schema.space === "html" ? 0 : 1, r = A.settings.allowDangerousCharacters ? 0 : 1;
  let a = A.quote, g;
  if (t.overloadedBoolean && (e === t.attribute || e === "") ? e = !0 : (t.boolean || t.overloadedBoolean) && (typeof e != "string" || e === t.attribute || e === "") && (e = !!e), e == null || e === !1 || typeof e == "number" && Number.isNaN(e))
    return "";
  const s = $A(
    t.attribute,
    Object.assign({}, A.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: To.name[n][r]
    })
  );
  return e === !0 || (e = Array.isArray(e) ? (t.commaSeparated ? eB : tB)(e, {
    padLeft: !A.settings.tightCommaSeparatedLists
  }) : String(e), A.settings.collapseEmptyAttributes && !e) ? s : (A.settings.preferUnquoted && (g = $A(
    e,
    Object.assign({}, A.settings.characterReferences, {
      attribute: !0,
      subset: To.unquoted[n][r]
    })
  )), g !== e && (A.settings.quoteSmart && Nn(e, a) > Nn(e, A.alternative) && (a = A.alternative), g = a + $A(
    e,
    Object.assign({}, A.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: (a === "'" ? To.single : To.double)[n][r],
      attribute: !0
    })
  ) + a), s + (g && "=" + g));
}
const bB = ["<", "&"];
function ma(A, o, e, t) {
  return e && e.type === "element" && (e.tagName === "script" || e.tagName === "style") ? A.value : $A(
    A.value,
    Object.assign({}, t.settings.characterReferences, {
      subset: bB
    })
  );
}
function HB(A, o, e, t) {
  return t.settings.allowDangerousHtml ? A.value : ma(A, o, e, t);
}
function DB(A, o, e, t) {
  return t.all(A);
}
const NB = kl("type", {
  invalid: xB,
  unknown: jB,
  handlers: { comment: AB, doctype: oB, element: vB, raw: HB, root: DB, text: ma }
});
function xB(A) {
  throw new Error("Expected node, not `" + A + "`");
}
function jB(A) {
  const o = (
    /** @type {Nodes} */
    A
  );
  throw new Error("Cannot compile unknown node `" + o.type + "`");
}
const kB = {}, SB = {}, RB = [];
function LB(A, o) {
  const e = o || kB, t = e.quote || '"', n = t === '"' ? "'" : '"';
  if (t !== '"' && t !== "'")
    throw new Error("Invalid quote `" + t + "`, expected `'` or `\"`");
  return {
    one: TB,
    all: OB,
    settings: {
      omitOptionalTags: e.omitOptionalTags || !1,
      allowParseErrors: e.allowParseErrors || !1,
      allowDangerousCharacters: e.allowDangerousCharacters || !1,
      quoteSmart: e.quoteSmart || !1,
      preferUnquoted: e.preferUnquoted || !1,
      tightAttributes: e.tightAttributes || !1,
      upperDoctype: e.upperDoctype || !1,
      tightDoctype: e.tightDoctype || !1,
      bogusComments: e.bogusComments || !1,
      tightCommaSeparatedLists: e.tightCommaSeparatedLists || !1,
      tightSelfClosing: e.tightSelfClosing || !1,
      collapseEmptyAttributes: e.collapseEmptyAttributes || !1,
      allowDangerousHtml: e.allowDangerousHtml || !1,
      voids: e.voids || Pl,
      characterReferences: e.characterReferences || SB,
      closeSelfClosing: e.closeSelfClosing || !1,
      closeEmptyElements: e.closeEmptyElements || !1
    },
    schema: e.space === "svg" ? Ua : jl,
    quote: t,
    alternative: n
  }.one(
    Array.isArray(A) ? { type: "root", children: A } : A,
    void 0,
    void 0
  );
}
function TB(A, o, e) {
  return NB(A, o, e, this);
}
function OB(A) {
  const o = [], e = A && A.children || RB;
  let t = -1;
  for (; ++t < e.length; )
    o[t] = this.one(e[t], t, A);
  return o.join("");
}
function ae(A, o) {
  const e = typeof A == "string" ? {} : { ...A.colorReplacements }, t = typeof A == "string" ? A : A.name;
  for (const [n, r] of Object.entries((o == null ? void 0 : o.colorReplacements) || {}))
    typeof r == "string" ? e[n] = r : n === t && Object.assign(e, r);
  return e;
}
function NA(A, o) {
  return A && ((o == null ? void 0 : o[A == null ? void 0 : A.toLowerCase()]) || A);
}
function XB(A) {
  return Array.isArray(A) ? A : [A];
}
async function Pa(A) {
  return Promise.resolve(typeof A == "function" ? A() : A).then((o) => o.default || o);
}
function _t(A) {
  return !A || ["plaintext", "txt", "text", "plain"].includes(A);
}
function va(A) {
  return A === "ansi" || _t(A);
}
function $t(A) {
  return A === "none";
}
function wa(A) {
  return $t(A);
}
function ya(A, o) {
  var t;
  if (!o)
    return A;
  A.properties || (A.properties = {}), (t = A.properties).class || (t.class = []), typeof A.properties.class == "string" && (A.properties.class = A.properties.class.split(/\s+/g)), Array.isArray(A.properties.class) || (A.properties.class = []);
  const e = Array.isArray(o) ? o : o.split(/\s+/g);
  for (const n of e)
    n && !A.properties.class.includes(n) && A.properties.class.push(n);
  return A;
}
function Ue(A, o = !1) {
  var r;
  const e = A.split(/(\r?\n)/g);
  let t = 0;
  const n = [];
  for (let a = 0; a < e.length; a += 2) {
    const g = o ? e[a] + (e[a + 1] || "") : e[a];
    n.push([g, t]), t += e[a].length, t += ((r = e[a + 1]) == null ? void 0 : r.length) || 0;
  }
  return n;
}
function zB(A) {
  const o = Ue(A, !0).map(([n]) => n);
  function e(n) {
    if (n === A.length)
      return {
        line: o.length - 1,
        character: o[o.length - 1].length
      };
    let r = n, a = 0;
    for (const g of o) {
      if (r < g.length)
        break;
      r -= g.length, a++;
    }
    return { line: a, character: r };
  }
  function t(n, r) {
    let a = 0;
    for (let g = 0; g < n; g++)
      a += o[g].length;
    return a += r, a;
  }
  return {
    lines: o,
    indexToPos: e,
    posToIndex: t
  };
}
const An = "light-dark()", IB = ["color", "background-color"];
function GB(A, o) {
  let e = 0;
  const t = [];
  for (const n of o)
    n > e && t.push({
      ...A,
      content: A.content.slice(e, n),
      offset: A.offset + e
    }), e = n;
  return e < A.content.length && t.push({
    ...A,
    content: A.content.slice(e),
    offset: A.offset + e
  }), t;
}
function WB(A, o) {
  const e = Array.from(o instanceof Set ? o : new Set(o)).sort((t, n) => t - n);
  return e.length ? A.map((t) => t.flatMap((n) => {
    const r = e.filter((a) => n.offset < a && a < n.offset + n.content.length).map((a) => a - n.offset).sort((a, g) => a - g);
    return r.length ? GB(n, r) : n;
  })) : A;
}
function VB(A, o, e, t, n = "css-vars") {
  const r = {
    content: A.content,
    explanation: A.explanation,
    offset: A.offset
  }, a = o.map((l) => ge(A.variants[l])), g = new Set(a.flatMap((l) => Object.keys(l))), s = {}, i = (l, B) => {
    const K = B === "color" ? "" : B === "background-color" ? "-bg" : `-${B}`;
    return e + o[l] + (B === "color" ? "" : K);
  };
  return a.forEach((l, B) => {
    for (const K of g) {
      const F = l[K] || "inherit";
      if (B === 0 && t && IB.includes(K))
        if (t === An && a.length > 1) {
          const Q = o.findIndex((u) => u === "light"), f = o.findIndex((u) => u === "dark");
          if (Q === -1 || f === -1)
            throw new X('When using `defaultColor: "light-dark()"`, you must provide both `light` and `dark` themes');
          const c = a[Q][K] || "inherit", U = a[f][K] || "inherit";
          s[K] = `light-dark(${c}, ${U})`, n === "css-vars" && (s[i(B, K)] = F);
        } else
          s[K] = F;
      else
        n === "css-vars" && (s[i(B, K)] = F);
    }
  }), r.htmlStyle = s, r;
}
function ge(A) {
  const o = {};
  if (A.color && (o.color = A.color), A.bgColor && (o["background-color"] = A.bgColor), A.fontStyle) {
    A.fontStyle & M.Italic && (o["font-style"] = "italic"), A.fontStyle & M.Bold && (o["font-weight"] = "bold");
    const e = [];
    A.fontStyle & M.Underline && e.push("underline"), A.fontStyle & M.Strikethrough && e.push("line-through"), e.length && (o["text-decoration"] = e.join(" "));
  }
  return o;
}
function ut(A) {
  return typeof A == "string" ? A : Object.entries(A).map(([o, e]) => `${o}:${e}`).join(";");
}
const ba = /* @__PURE__ */ new WeakMap();
function ue(A, o) {
  ba.set(A, o);
}
function Po(A) {
  return ba.get(A);
}
class ro {
  constructor(...o) {
    /**
     * Theme to Stack mapping
     */
    p(this, "_stacks", {});
    p(this, "lang");
    if (o.length === 2) {
      const [e, t] = o;
      this.lang = t, this._stacks = e;
    } else {
      const [e, t, n] = o;
      this.lang = t, this._stacks = { [n]: e };
    }
  }
  get themes() {
    return Object.keys(this._stacks);
  }
  get theme() {
    return this.themes[0];
  }
  get _stack() {
    return this._stacks[this.theme];
  }
  /**
   * Static method to create a initial grammar state.
   */
  static initial(o, e) {
    return new ro(
      Object.fromEntries(XB(e).map((t) => [t, Qt])),
      o
    );
  }
  /**
   * Get the internal stack object.
   * @internal
   */
  getInternalStack(o = this.theme) {
    return this._stacks[o];
  }
  getScopes(o = this.theme) {
    return MB(this._stacks[o]);
  }
  toJSON() {
    return {
      lang: this.lang,
      theme: this.theme,
      themes: this.themes,
      scopes: this.getScopes()
    };
  }
}
function MB(A) {
  const o = [], e = /* @__PURE__ */ new Set();
  function t(n) {
    var a;
    if (e.has(n))
      return;
    e.add(n);
    const r = (a = n == null ? void 0 : n.nameScopesList) == null ? void 0 : a.scopeName;
    r && o.push(r), n.parent && t(n.parent);
  }
  return t(A), o;
}
function EB(A, o) {
  if (!(A instanceof ro))
    throw new X("Invalid grammar state");
  return A.getInternalStack(o);
}
function qB() {
  const A = /* @__PURE__ */ new WeakMap();
  function o(e) {
    if (!A.has(e.meta)) {
      let t = function(a) {
        if (typeof a == "number") {
          if (a < 0 || a > e.source.length)
            throw new X(`Invalid decoration offset: ${a}. Code length: ${e.source.length}`);
          return {
            ...n.indexToPos(a),
            offset: a
          };
        } else {
          const g = n.lines[a.line];
          if (g === void 0)
            throw new X(`Invalid decoration position ${JSON.stringify(a)}. Lines length: ${n.lines.length}`);
          if (a.character < 0 || a.character > g.length)
            throw new X(`Invalid decoration position ${JSON.stringify(a)}. Line ${a.line} length: ${g.length}`);
          return {
            ...a,
            offset: n.posToIndex(a.line, a.character)
          };
        }
      };
      const n = zB(e.source), r = (e.options.decorations || []).map((a) => ({
        ...a,
        start: t(a.start),
        end: t(a.end)
      }));
      JB(r), A.set(e.meta, {
        decorations: r,
        converter: n,
        source: e.source
      });
    }
    return A.get(e.meta);
  }
  return {
    name: "shiki:decorations",
    tokens(e) {
      var a;
      if (!((a = this.options.decorations) != null && a.length))
        return;
      const n = o(this).decorations.flatMap((g) => [g.start.offset, g.end.offset]);
      return WB(e, n);
    },
    code(e) {
      var l;
      if (!((l = this.options.decorations) != null && l.length))
        return;
      const t = o(this), n = Array.from(e.children).filter((B) => B.type === "element" && B.tagName === "span");
      if (n.length !== t.converter.lines.length)
        throw new X(`Number of lines in code element (${n.length}) does not match the number of lines in the source (${t.converter.lines.length}). Failed to apply decorations.`);
      function r(B, K, F, Q) {
        const f = n[B];
        let c = "", U = -1, u = -1;
        if (K === 0 && (U = 0), F === 0 && (u = 0), F === Number.POSITIVE_INFINITY && (u = f.children.length), U === -1 || u === -1)
          for (let P = 0; P < f.children.length; P++)
            c += Ha(f.children[P]), U === -1 && c.length === K && (U = P + 1), u === -1 && c.length === F && (u = P + 1);
        if (U === -1)
          throw new X(`Failed to find start index for decoration ${JSON.stringify(Q.start)}`);
        if (u === -1)
          throw new X(`Failed to find end index for decoration ${JSON.stringify(Q.end)}`);
        const d = f.children.slice(U, u);
        if (!Q.alwaysWrap && d.length === f.children.length)
          g(f, Q, "line");
        else if (!Q.alwaysWrap && d.length === 1 && d[0].type === "element")
          g(d[0], Q, "token");
        else {
          const P = {
            type: "element",
            tagName: "span",
            properties: {},
            children: d
          };
          g(P, Q, "wrapper"), f.children.splice(U, d.length, P);
        }
      }
      function a(B, K) {
        n[B] = g(n[B], K, "line");
      }
      function g(B, K, F) {
        var c;
        const Q = K.properties || {}, f = K.transform || ((U) => U);
        return B.tagName = K.tagName || "span", B.properties = {
          ...B.properties,
          ...Q,
          class: B.properties.class
        }, (c = K.properties) != null && c.class && ya(B, K.properties.class), B = f(B, F) || B, B;
      }
      const s = [], i = t.decorations.sort((B, K) => K.start.offset - B.start.offset || B.end.offset - K.end.offset);
      for (const B of i) {
        const { start: K, end: F } = B;
        if (K.line === F.line)
          r(K.line, K.character, F.character, B);
        else if (K.line < F.line) {
          r(K.line, K.character, Number.POSITIVE_INFINITY, B);
          for (let Q = K.line + 1; Q < F.line; Q++)
            s.unshift(() => a(Q, B));
          r(F.line, 0, F.character, B);
        }
      }
      s.forEach((B) => B());
    }
  };
}
function JB(A) {
  for (let o = 0; o < A.length; o++) {
    const e = A[o];
    if (e.start.offset > e.end.offset)
      throw new X(`Invalid decoration range: ${JSON.stringify(e.start)} - ${JSON.stringify(e.end)}`);
    for (let t = o + 1; t < A.length; t++) {
      const n = A[t], r = e.start.offset <= n.start.offset && n.start.offset < e.end.offset, a = e.start.offset < n.end.offset && n.end.offset <= e.end.offset, g = n.start.offset <= e.start.offset && e.start.offset < n.end.offset, s = n.start.offset < e.end.offset && e.end.offset <= n.end.offset;
      if (r || a || g || s) {
        if (r && a || g && s)
          continue;
        throw new X(`Decorations ${JSON.stringify(e.start)} and ${JSON.stringify(n.start)} intersect.`);
      }
    }
  }
}
function Ha(A) {
  return A.type === "text" ? A.value : A.type === "element" ? A.children.map(Ha).join("") : "";
}
const ZB = [
  /* @__PURE__ */ qB()
];
function se(A) {
  return [
    ...A.transformers || [],
    ...ZB
  ];
}
var TA = [
  "black",
  "red",
  "green",
  "yellow",
  "blue",
  "magenta",
  "cyan",
  "white",
  "brightBlack",
  "brightRed",
  "brightGreen",
  "brightYellow",
  "brightBlue",
  "brightMagenta",
  "brightCyan",
  "brightWhite"
], ke = {
  1: "bold",
  2: "dim",
  3: "italic",
  4: "underline",
  7: "reverse",
  8: "hidden",
  9: "strikethrough"
};
function YB(A, o) {
  const e = A.indexOf("\x1B", o);
  if (e !== -1 && A[e + 1] === "[") {
    const t = A.indexOf("m", e);
    if (t !== -1)
      return {
        sequence: A.substring(e + 2, t).split(";"),
        startPosition: e,
        position: t + 1
      };
  }
  return {
    position: A.length
  };
}
function Sn(A) {
  const o = A.shift();
  if (o === "2") {
    const e = A.splice(0, 3).map((t) => Number.parseInt(t));
    return e.length !== 3 || e.some((t) => Number.isNaN(t)) ? void 0 : {
      type: "rgb",
      rgb: e
    };
  } else if (o === "5") {
    const e = A.shift();
    if (e)
      return { type: "table", index: Number(e) };
  }
}
function _B(A) {
  const o = [];
  for (; A.length > 0; ) {
    const e = A.shift();
    if (!e)
      continue;
    const t = Number.parseInt(e);
    if (!Number.isNaN(t))
      if (t === 0)
        o.push({ type: "resetAll" });
      else if (t <= 9)
        ke[t] && o.push({
          type: "setDecoration",
          value: ke[t]
        });
      else if (t <= 29) {
        const n = ke[t - 20];
        n && (o.push({
          type: "resetDecoration",
          value: n
        }), n === "dim" && o.push({
          type: "resetDecoration",
          value: "bold"
        }));
      } else if (t <= 37)
        o.push({
          type: "setForegroundColor",
          value: { type: "named", name: TA[t - 30] }
        });
      else if (t === 38) {
        const n = Sn(A);
        n && o.push({
          type: "setForegroundColor",
          value: n
        });
      } else if (t === 39)
        o.push({
          type: "resetForegroundColor"
        });
      else if (t <= 47)
        o.push({
          type: "setBackgroundColor",
          value: { type: "named", name: TA[t - 40] }
        });
      else if (t === 48) {
        const n = Sn(A);
        n && o.push({
          type: "setBackgroundColor",
          value: n
        });
      } else t === 49 ? o.push({
        type: "resetBackgroundColor"
      }) : t === 53 ? o.push({
        type: "setDecoration",
        value: "overline"
      }) : t === 55 ? o.push({
        type: "resetDecoration",
        value: "overline"
      }) : t >= 90 && t <= 97 ? o.push({
        type: "setForegroundColor",
        value: { type: "named", name: TA[t - 90 + 8] }
      }) : t >= 100 && t <= 107 && o.push({
        type: "setBackgroundColor",
        value: { type: "named", name: TA[t - 100 + 8] }
      });
  }
  return o;
}
function $B() {
  let A = null, o = null, e = /* @__PURE__ */ new Set();
  return {
    parse(t) {
      const n = [];
      let r = 0;
      do {
        const a = YB(t, r), g = a.sequence ? t.substring(r, a.startPosition) : t.substring(r);
        if (g.length > 0 && n.push({
          value: g,
          foreground: A,
          background: o,
          decorations: new Set(e)
        }), a.sequence) {
          const s = _B(a.sequence);
          for (const i of s)
            i.type === "resetAll" ? (A = null, o = null, e.clear()) : i.type === "resetForegroundColor" ? A = null : i.type === "resetBackgroundColor" ? o = null : i.type === "resetDecoration" && e.delete(i.value);
          for (const i of s)
            i.type === "setForegroundColor" ? A = i.value : i.type === "setBackgroundColor" ? o = i.value : i.type === "setDecoration" && e.add(i.value);
        }
        r = a.position;
      } while (r < t.length);
      return n;
    }
  };
}
var AK = {
  black: "#000000",
  red: "#bb0000",
  green: "#00bb00",
  yellow: "#bbbb00",
  blue: "#0000bb",
  magenta: "#ff00ff",
  cyan: "#00bbbb",
  white: "#eeeeee",
  brightBlack: "#555555",
  brightRed: "#ff5555",
  brightGreen: "#00ff00",
  brightYellow: "#ffff55",
  brightBlue: "#5555ff",
  brightMagenta: "#ff55ff",
  brightCyan: "#55ffff",
  brightWhite: "#ffffff"
};
function oK(A = AK) {
  function o(g) {
    return A[g];
  }
  function e(g) {
    return `#${g.map((s) => Math.max(0, Math.min(s, 255)).toString(16).padStart(2, "0")).join("")}`;
  }
  let t;
  function n() {
    if (t)
      return t;
    t = [];
    for (let i = 0; i < TA.length; i++)
      t.push(o(TA[i]));
    let g = [0, 95, 135, 175, 215, 255];
    for (let i = 0; i < 6; i++)
      for (let l = 0; l < 6; l++)
        for (let B = 0; B < 6; B++)
          t.push(e([g[i], g[l], g[B]]));
    let s = 8;
    for (let i = 0; i < 24; i++, s += 10)
      t.push(e([s, s, s]));
    return t;
  }
  function r(g) {
    return n()[g];
  }
  function a(g) {
    switch (g.type) {
      case "named":
        return o(g.name);
      case "rgb":
        return e(g.rgb);
      case "table":
        return r(g.index);
    }
  }
  return {
    value: a
  };
}
function eK(A, o, e) {
  const t = ae(A, e), n = Ue(o), r = oK(
    Object.fromEntries(
      TA.map((g) => {
        var s;
        return [
          g,
          (s = A.colors) == null ? void 0 : s[`terminal.ansi${g[0].toUpperCase()}${g.substring(1)}`]
        ];
      })
    )
  ), a = $B();
  return n.map(
    (g) => a.parse(g[0]).map((s) => {
      let i, l;
      s.decorations.has("reverse") ? (i = s.background ? r.value(s.background) : A.bg, l = s.foreground ? r.value(s.foreground) : A.fg) : (i = s.foreground ? r.value(s.foreground) : A.fg, l = s.background ? r.value(s.background) : void 0), i = NA(i, t), l = NA(l, t), s.decorations.has("dim") && (i = tK(i));
      let B = M.None;
      return s.decorations.has("bold") && (B |= M.Bold), s.decorations.has("italic") && (B |= M.Italic), s.decorations.has("underline") && (B |= M.Underline), s.decorations.has("strikethrough") && (B |= M.Strikethrough), {
        content: s.value,
        offset: g[1],
        // TODO: more accurate offset? might need to fork ansi-sequence-parser
        color: i,
        bgColor: l,
        fontStyle: B
      };
    })
  );
}
function tK(A) {
  const o = A.match(/#([0-9a-f]{3})([0-9a-f]{3})?([0-9a-f]{2})?/);
  if (o)
    if (o[3]) {
      const t = Math.round(Number.parseInt(o[3], 16) / 2).toString(16).padStart(2, "0");
      return `#${o[1]}${o[2]}${t}`;
    } else return o[2] ? `#${o[1]}${o[2]}80` : `#${Array.from(o[1]).map((t) => `${t}${t}`).join("")}80`;
  const e = A.match(/var\((--[\w-]+-ansi-[\w-]+)\)/);
  return e ? `var(${e[1]}-dim)` : A;
}
function on(A, o, e = {}) {
  const {
    lang: t = "text",
    theme: n = A.getLoadedThemes()[0]
  } = e;
  if (_t(t) || $t(n))
    return Ue(o).map((s) => [{ content: s[0], offset: s[1] }]);
  const { theme: r, colorMap: a } = A.setTheme(n);
  if (t === "ansi")
    return eK(r, o, e);
  const g = A.getLanguage(t);
  if (e.grammarState) {
    if (e.grammarState.lang !== g.name)
      throw new X(`Grammar state language "${e.grammarState.lang}" does not match highlight language "${g.name}"`);
    if (!e.grammarState.themes.includes(r.name))
      throw new X(`Grammar state themes "${e.grammarState.themes}" do not contain highlight theme "${r.name}"`);
  }
  return rK(o, g, r, a, e);
}
function nK(...A) {
  if (A.length === 2)
    return Po(A[1]);
  const [o, e, t = {}] = A, {
    lang: n = "text",
    theme: r = o.getLoadedThemes()[0]
  } = t;
  if (_t(n) || $t(r))
    throw new X("Plain language does not have grammar state");
  if (n === "ansi")
    throw new X("ANSI language does not have grammar state");
  const { theme: a, colorMap: g } = o.setTheme(r), s = o.getLanguage(n);
  return new ro(
    ie(e, s, a, g, t).stateStack,
    s.name,
    a.name
  );
}
function rK(A, o, e, t, n) {
  const r = ie(A, o, e, t, n), a = new ro(
    ie(A, o, e, t, n).stateStack,
    o.name,
    e.name
  );
  return ue(r.tokens, a), r.tokens;
}
function ie(A, o, e, t, n) {
  const r = ae(e, n), {
    tokenizeMaxLineLength: a = 0,
    tokenizeTimeLimit: g = 500
  } = n, s = Ue(A);
  let i = n.grammarState ? EB(n.grammarState, e.name) ?? Qt : n.grammarContextCode != null ? ie(
    n.grammarContextCode,
    o,
    e,
    t,
    {
      ...n,
      grammarState: void 0,
      grammarContextCode: void 0
    }
  ).stateStack : Qt, l = [];
  const B = [];
  for (let K = 0, F = s.length; K < F; K++) {
    const [Q, f] = s[K];
    if (Q === "") {
      l = [], B.push([]);
      continue;
    }
    if (a > 0 && Q.length >= a) {
      l = [], B.push([{
        content: Q,
        offset: f,
        color: "",
        fontStyle: 0
      }]);
      continue;
    }
    let c, U, u;
    n.includeExplanation && (c = o.tokenizeLine(Q, i, g), U = c.tokens, u = 0);
    const d = o.tokenizeLine2(Q, i, g), P = d.tokens.length / 2;
    for (let v = 0; v < P; v++) {
      const y = d.tokens[2 * v], w = v + 1 < P ? d.tokens[2 * v + 2] : Q.length;
      if (y === w)
        continue;
      const N = d.tokens[2 * v + 1], gA = NA(
        t[oo.getForeground(N)],
        r
      ), sA = oo.getFontStyle(N), cA = {
        content: Q.substring(y, w),
        offset: f + y,
        color: gA,
        fontStyle: sA
      };
      if (n.includeExplanation) {
        const PA = [];
        if (n.includeExplanation !== "scopeName")
          for (const fA of e.settings) {
            let VA;
            switch (typeof fA.scope) {
              case "string":
                VA = fA.scope.split(/,/).map((Pe) => Pe.trim());
                break;
              case "object":
                VA = fA.scope;
                break;
              default:
                continue;
            }
            PA.push({
              settings: fA,
              selectors: VA.map((Pe) => Pe.split(/ /))
            });
          }
        cA.explanation = [];
        let sn = 0;
        for (; y + sn < w; ) {
          const fA = U[u], VA = Q.substring(
            fA.startIndex,
            fA.endIndex
          );
          sn += VA.length, cA.explanation.push({
            content: VA,
            scopes: n.includeExplanation === "scopeName" ? aK(
              fA.scopes
            ) : gK(
              PA,
              fA.scopes
            )
          }), u += 1;
        }
      }
      l.push(cA);
    }
    B.push(l), l = [], i = d.ruleStack;
  }
  return {
    tokens: B,
    stateStack: i
  };
}
function aK(A) {
  return A.map((o) => ({ scopeName: o }));
}
function gK(A, o) {
  const e = [];
  for (let t = 0, n = o.length; t < n; t++) {
    const r = o[t];
    e[t] = {
      scopeName: r,
      themeMatches: iK(A, r, o.slice(0, t))
    };
  }
  return e;
}
function Rn(A, o) {
  return A === o || o.substring(0, A.length) === A && o[A.length] === ".";
}
function sK(A, o, e) {
  if (!Rn(A[A.length - 1], o))
    return !1;
  let t = A.length - 2, n = e.length - 1;
  for (; t >= 0 && n >= 0; )
    Rn(A[t], e[n]) && (t -= 1), n -= 1;
  return t === -1;
}
function iK(A, o, e) {
  const t = [];
  for (const { selectors: n, settings: r } of A)
    for (const a of n)
      if (sK(a, o, e)) {
        t.push(r);
        break;
      }
  return t;
}
function Da(A, o, e) {
  const t = Object.entries(e.themes).filter((s) => s[1]).map((s) => ({ color: s[0], theme: s[1] })), n = t.map((s) => {
    const i = on(A, o, {
      ...e,
      theme: s.theme
    }), l = Po(i), B = typeof s.theme == "string" ? s.theme : s.theme.name;
    return {
      tokens: i,
      state: l,
      theme: B
    };
  }), r = CK(
    ...n.map((s) => s.tokens)
  ), a = r[0].map(
    (s, i) => s.map((l, B) => {
      const K = {
        content: l.content,
        variants: {},
        offset: l.offset
      };
      return "includeExplanation" in e && e.includeExplanation && (K.explanation = l.explanation), r.forEach((F, Q) => {
        const {
          content: f,
          explanation: c,
          offset: U,
          ...u
        } = F[i][B];
        K.variants[t[Q].color] = u;
      }), K;
    })
  ), g = n[0].state ? new ro(
    Object.fromEntries(n.map((s) => {
      var i;
      return [s.theme, (i = s.state) == null ? void 0 : i.getInternalStack(s.theme)];
    })),
    n[0].state.lang
  ) : void 0;
  return g && ue(a, g), a;
}
function CK(...A) {
  const o = A.map(() => []), e = A.length;
  for (let t = 0; t < A[0].length; t++) {
    const n = A.map((s) => s[t]), r = o.map(() => []);
    o.forEach((s, i) => s.push(r[i]));
    const a = n.map(() => 0), g = n.map((s) => s[0]);
    for (; g.every((s) => s); ) {
      const s = Math.min(...g.map((i) => i.content.length));
      for (let i = 0; i < e; i++) {
        const l = g[i];
        l.content.length === s ? (r[i].push(l), a[i] += 1, g[i] = n[i][a[i]]) : (r[i].push({
          ...l,
          content: l.content.slice(0, s)
        }), g[i] = {
          ...l,
          content: l.content.slice(s),
          offset: l.offset + s
        });
      }
    }
  }
  return o;
}
function Ce(A, o, e) {
  let t, n, r, a, g, s;
  if ("themes" in e) {
    const {
      defaultColor: i = "light",
      cssVariablePrefix: l = "--shiki-",
      colorsRendering: B = "css-vars"
    } = e, K = Object.entries(e.themes).filter((U) => U[1]).map((U) => ({ color: U[0], theme: U[1] })).sort((U, u) => U.color === i ? -1 : u.color === i ? 1 : 0);
    if (K.length === 0)
      throw new X("`themes` option must not be empty");
    const F = Da(
      A,
      o,
      e
    );
    if (s = Po(F), i && An !== i && !K.find((U) => U.color === i))
      throw new X(`\`themes\` option must contain the defaultColor key \`${i}\``);
    const Q = K.map((U) => A.getTheme(U.theme)), f = K.map((U) => U.color);
    r = F.map((U) => U.map((u) => VB(u, f, l, i, B))), s && ue(r, s);
    const c = K.map((U) => ae(U.theme, e));
    n = Ln(K, Q, c, l, i, "fg", B), t = Ln(K, Q, c, l, i, "bg", B), a = `shiki-themes ${Q.map((U) => U.name).join(" ")}`, g = i ? void 0 : [n, t].join(";");
  } else if ("theme" in e) {
    const i = ae(e.theme, e);
    r = on(
      A,
      o,
      e
    );
    const l = A.getTheme(e.theme);
    t = NA(l.bg, i), n = NA(l.fg, i), a = l.name, s = Po(r);
  } else
    throw new X("Invalid options, either `theme` or `themes` must be provided");
  return {
    tokens: r,
    fg: n,
    bg: t,
    themeName: a,
    rootStyle: g,
    grammarState: s
  };
}
function Ln(A, o, e, t, n, r, a) {
  return A.map((g, s) => {
    const i = NA(o[s][r], e[s]) || "inherit", l = `${t + g.color}${r === "bg" ? "-bg" : ""}:${i}`;
    if (s === 0 && n) {
      if (n === An && A.length > 1) {
        const B = A.findIndex((f) => f.color === "light"), K = A.findIndex((f) => f.color === "dark");
        if (B === -1 || K === -1)
          throw new X('When using `defaultColor: "light-dark()"`, you must provide both `light` and `dark` themes');
        const F = NA(o[B][r], e[B]) || "inherit", Q = NA(o[K][r], e[K]) || "inherit";
        return `light-dark(${F}, ${Q});${l}`;
      }
      return i;
    }
    return a === "css-vars" ? l : null;
  }).filter((g) => !!g).join(";");
}
function le(A, o, e, t = {
  meta: {},
  options: e,
  codeToHast: (n, r) => le(A, n, r),
  codeToTokens: (n, r) => Ce(A, n, r)
}) {
  var Q, f;
  let n = o;
  for (const c of se(e))
    n = ((Q = c.preprocess) == null ? void 0 : Q.call(t, n, e)) || n;
  let {
    tokens: r,
    fg: a,
    bg: g,
    themeName: s,
    rootStyle: i,
    grammarState: l
  } = Ce(A, n, e);
  const {
    mergeWhitespaces: B = !0,
    mergeSameStyleTokens: K = !1
  } = e;
  B === !0 ? r = BK(r) : B === "never" && (r = KK(r)), K && (r = QK(r));
  const F = {
    ...t,
    get source() {
      return n;
    }
  };
  for (const c of se(e))
    r = ((f = c.tokens) == null ? void 0 : f.call(F, r)) || r;
  return lK(
    r,
    {
      ...e,
      fg: a,
      bg: g,
      themeName: s,
      rootStyle: i
    },
    F,
    l
  );
}
function lK(A, o, e, t = Po(A)) {
  var Q, f, c;
  const n = se(o), r = [], a = {
    type: "root",
    children: []
  }, {
    structure: g = "classic",
    tabindex: s = "0"
  } = o;
  let i = {
    type: "element",
    tagName: "pre",
    properties: {
      class: `shiki ${o.themeName || ""}`,
      style: o.rootStyle || `background-color:${o.bg};color:${o.fg}`,
      ...s !== !1 && s != null ? {
        tabindex: s.toString()
      } : {},
      ...Object.fromEntries(
        Array.from(
          Object.entries(o.meta || {})
        ).filter(([U]) => !U.startsWith("_"))
      )
    },
    children: []
  }, l = {
    type: "element",
    tagName: "code",
    properties: {},
    children: r
  };
  const B = [], K = {
    ...e,
    structure: g,
    addClassToHast: ya,
    get source() {
      return e.source;
    },
    get tokens() {
      return A;
    },
    get options() {
      return o;
    },
    get root() {
      return a;
    },
    get pre() {
      return i;
    },
    get code() {
      return l;
    },
    get lines() {
      return B;
    }
  };
  if (A.forEach((U, u) => {
    var v, y;
    u && (g === "inline" ? a.children.push({ type: "element", tagName: "br", properties: {}, children: [] }) : g === "classic" && r.push({ type: "text", value: `
` }));
    let d = {
      type: "element",
      tagName: "span",
      properties: { class: "line" },
      children: []
    }, P = 0;
    for (const w of U) {
      let N = {
        type: "element",
        tagName: "span",
        properties: {
          ...w.htmlAttrs
        },
        children: [{ type: "text", value: w.content }]
      };
      const gA = ut(w.htmlStyle || ge(w));
      gA && (N.properties.style = gA);
      for (const sA of n)
        N = ((v = sA == null ? void 0 : sA.span) == null ? void 0 : v.call(K, N, u + 1, P, d, w)) || N;
      g === "inline" ? a.children.push(N) : g === "classic" && d.children.push(N), P += w.content.length;
    }
    if (g === "classic") {
      for (const w of n)
        d = ((y = w == null ? void 0 : w.line) == null ? void 0 : y.call(K, d, u + 1)) || d;
      B.push(d), r.push(d);
    }
  }), g === "classic") {
    for (const U of n)
      l = ((Q = U == null ? void 0 : U.code) == null ? void 0 : Q.call(K, l)) || l;
    i.children.push(l);
    for (const U of n)
      i = ((f = U == null ? void 0 : U.pre) == null ? void 0 : f.call(K, i)) || i;
    a.children.push(i);
  }
  let F = a;
  for (const U of n)
    F = ((c = U == null ? void 0 : U.root) == null ? void 0 : c.call(K, F)) || F;
  return t && ue(F, t), F;
}
function BK(A) {
  return A.map((o) => {
    const e = [];
    let t = "", n = 0;
    return o.forEach((r, a) => {
      const s = !(r.fontStyle && (r.fontStyle & M.Underline || r.fontStyle & M.Strikethrough));
      s && r.content.match(/^\s+$/) && o[a + 1] ? (n || (n = r.offset), t += r.content) : t ? (s ? e.push({
        ...r,
        offset: n,
        content: t + r.content
      }) : e.push(
        {
          content: t,
          offset: n
        },
        r
      ), n = 0, t = "") : e.push(r);
    }), e;
  });
}
function KK(A) {
  return A.map((o) => o.flatMap((e) => {
    if (e.content.match(/^\s+$/))
      return e;
    const t = e.content.match(/^(\s*)(.*?)(\s*)$/);
    if (!t)
      return e;
    const [, n, r, a] = t;
    if (!n && !a)
      return e;
    const g = [{
      ...e,
      offset: e.offset + n.length,
      content: r
    }];
    return n && g.unshift({
      content: n,
      offset: e.offset
    }), a && g.push({
      content: a,
      offset: e.offset + n.length + r.length
    }), g;
  }));
}
function QK(A) {
  return A.map((o) => {
    const e = [];
    for (const t of o) {
      if (e.length === 0) {
        e.push({ ...t });
        continue;
      }
      const n = e[e.length - 1], r = ut(n.htmlStyle || ge(n)), a = ut(t.htmlStyle || ge(t)), g = n.fontStyle && (n.fontStyle & M.Underline || n.fontStyle & M.Strikethrough), s = t.fontStyle && (t.fontStyle & M.Underline || t.fontStyle & M.Strikethrough);
      !g && !s && r === a ? n.content += t.content : e.push({ ...t });
    }
    return e;
  });
}
const FK = LB;
function cK(A, o, e) {
  var r;
  const t = {
    meta: {},
    options: e,
    codeToHast: (a, g) => le(A, a, g),
    codeToTokens: (a, g) => Ce(A, a, g)
  };
  let n = FK(le(A, o, e, t));
  for (const a of se(e))
    n = ((r = a.postprocess) == null ? void 0 : r.call(t, n, e)) || n;
  return n;
}
const Tn = { light: "#333333", dark: "#bbbbbb" }, On = { light: "#fffffe", dark: "#1e1e1e" }, Xn = "__shiki_resolved";
function en(A) {
  var g, s, i, l, B;
  if (A != null && A[Xn])
    return A;
  const o = {
    ...A
  };
  o.tokenColors && !o.settings && (o.settings = o.tokenColors, delete o.tokenColors), o.type || (o.type = "dark"), o.colorReplacements = { ...o.colorReplacements }, o.settings || (o.settings = []);
  let { bg: e, fg: t } = o;
  if (!e || !t) {
    const K = o.settings ? o.settings.find((F) => !F.name && !F.scope) : void 0;
    (g = K == null ? void 0 : K.settings) != null && g.foreground && (t = K.settings.foreground), (s = K == null ? void 0 : K.settings) != null && s.background && (e = K.settings.background), !t && ((i = o == null ? void 0 : o.colors) != null && i["editor.foreground"]) && (t = o.colors["editor.foreground"]), !e && ((l = o == null ? void 0 : o.colors) != null && l["editor.background"]) && (e = o.colors["editor.background"]), t || (t = o.type === "light" ? Tn.light : Tn.dark), e || (e = o.type === "light" ? On.light : On.dark), o.fg = t, o.bg = e;
  }
  o.settings[0] && o.settings[0].settings && !o.settings[0].scope || o.settings.unshift({
    settings: {
      foreground: o.fg,
      background: o.bg
    }
  });
  let n = 0;
  const r = /* @__PURE__ */ new Map();
  function a(K) {
    var Q;
    if (r.has(K))
      return r.get(K);
    n += 1;
    const F = `#${n.toString(16).padStart(8, "0").toLowerCase()}`;
    return (Q = o.colorReplacements) != null && Q[`#${F}`] ? a(K) : (r.set(K, F), F);
  }
  o.settings = o.settings.map((K) => {
    var c, U;
    const F = ((c = K.settings) == null ? void 0 : c.foreground) && !K.settings.foreground.startsWith("#"), Q = ((U = K.settings) == null ? void 0 : U.background) && !K.settings.background.startsWith("#");
    if (!F && !Q)
      return K;
    const f = {
      ...K,
      settings: {
        ...K.settings
      }
    };
    if (F) {
      const u = a(K.settings.foreground);
      o.colorReplacements[u] = K.settings.foreground, f.settings.foreground = u;
    }
    if (Q) {
      const u = a(K.settings.background);
      o.colorReplacements[u] = K.settings.background, f.settings.background = u;
    }
    return f;
  });
  for (const K of Object.keys(o.colors || {}))
    if ((K === "editor.foreground" || K === "editor.background" || K.startsWith("terminal.ansi")) && !((B = o.colors[K]) != null && B.startsWith("#"))) {
      const F = a(o.colors[K]);
      o.colorReplacements[F] = o.colors[K], o.colors[K] = F;
    }
  return Object.defineProperty(o, Xn, {
    enumerable: !1,
    writable: !1,
    value: !0
  }), o;
}
async function Na(A) {
  return Array.from(new Set((await Promise.all(
    A.filter((o) => !va(o)).map(async (o) => await Pa(o).then((e) => Array.isArray(e) ? e : [e]))
  )).flat()));
}
async function xa(A) {
  return (await Promise.all(
    A.map(
      async (e) => wa(e) ? null : en(await Pa(e))
    )
  )).filter((e) => !!e);
}
let fK = 3;
function UK(A, o = 3) {
  o > fK || console.trace(`[SHIKI DEPRECATE]: ${A}`);
}
class ZA extends Error {
  constructor(o) {
    super(o), this.name = "ShikiError";
  }
}
class uK extends ml {
  constructor(e, t, n, r = {}) {
    super(e);
    p(this, "_resolvedThemes", /* @__PURE__ */ new Map());
    p(this, "_resolvedGrammars", /* @__PURE__ */ new Map());
    p(this, "_langMap", /* @__PURE__ */ new Map());
    p(this, "_langGraph", /* @__PURE__ */ new Map());
    p(this, "_textmateThemeCache", /* @__PURE__ */ new WeakMap());
    p(this, "_loadedThemesCache", null);
    p(this, "_loadedLanguagesCache", null);
    this._resolver = e, this._themes = t, this._langs = n, this._alias = r, this._themes.map((a) => this.loadTheme(a)), this.loadLanguages(this._langs);
  }
  getTheme(e) {
    return typeof e == "string" ? this._resolvedThemes.get(e) : this.loadTheme(e);
  }
  loadTheme(e) {
    const t = en(e);
    return t.name && (this._resolvedThemes.set(t.name, t), this._loadedThemesCache = null), t;
  }
  getLoadedThemes() {
    return this._loadedThemesCache || (this._loadedThemesCache = [...this._resolvedThemes.keys()]), this._loadedThemesCache;
  }
  // Override and re-implement this method to cache the textmate themes as `TextMateTheme.createFromRawTheme`
  // is expensive. Themes can switch often especially for dual-theme support.
  //
  // The parent class also accepts `colorMap` as the second parameter, but since we don't use that,
  // we omit here so it's easier to cache the themes.
  setTheme(e) {
    let t = this._textmateThemeCache.get(e);
    t || (t = oe.createFromRawTheme(e), this._textmateThemeCache.set(e, t)), this._syncRegistry.setTheme(t);
  }
  getGrammar(e) {
    if (this._alias[e]) {
      const t = /* @__PURE__ */ new Set([e]);
      for (; this._alias[e]; ) {
        if (e = this._alias[e], t.has(e))
          throw new ZA(`Circular alias \`${Array.from(t).join(" -> ")} -> ${e}\``);
        t.add(e);
      }
    }
    return this._resolvedGrammars.get(e);
  }
  loadLanguage(e) {
    var a, g, s, i;
    if (this.getGrammar(e.name))
      return;
    const t = new Set(
      [...this._langMap.values()].filter((l) => {
        var B;
        return (B = l.embeddedLangsLazy) == null ? void 0 : B.includes(e.name);
      })
    );
    this._resolver.addLanguage(e);
    const n = {
      balancedBracketSelectors: e.balancedBracketSelectors || ["*"],
      unbalancedBracketSelectors: e.unbalancedBracketSelectors || []
    };
    this._syncRegistry._rawGrammars.set(e.scopeName, e);
    const r = this.loadGrammarWithConfiguration(e.scopeName, 1, n);
    if (r.name = e.name, this._resolvedGrammars.set(e.name, r), e.aliases && e.aliases.forEach((l) => {
      this._alias[l] = e.name;
    }), this._loadedLanguagesCache = null, t.size)
      for (const l of t)
        this._resolvedGrammars.delete(l.name), this._loadedLanguagesCache = null, (g = (a = this._syncRegistry) == null ? void 0 : a._injectionGrammars) == null || g.delete(l.scopeName), (i = (s = this._syncRegistry) == null ? void 0 : s._grammars) == null || i.delete(l.scopeName), this.loadLanguage(this._langMap.get(l.name));
  }
  dispose() {
    super.dispose(), this._resolvedThemes.clear(), this._resolvedGrammars.clear(), this._langMap.clear(), this._langGraph.clear(), this._loadedThemesCache = null;
  }
  loadLanguages(e) {
    for (const r of e)
      this.resolveEmbeddedLanguages(r);
    const t = Array.from(this._langGraph.entries()), n = t.filter(([r, a]) => !a);
    if (n.length) {
      const r = t.filter(([a, g]) => {
        var s;
        return g && ((s = g.embeddedLangs) == null ? void 0 : s.some((i) => n.map(([l]) => l).includes(i)));
      }).filter((a) => !n.includes(a));
      throw new ZA(`Missing languages ${n.map(([a]) => `\`${a}\``).join(", ")}, required by ${r.map(([a]) => `\`${a}\``).join(", ")}`);
    }
    for (const [r, a] of t)
      this._resolver.addLanguage(a);
    for (const [r, a] of t)
      this.loadLanguage(a);
  }
  getLoadedLanguages() {
    return this._loadedLanguagesCache || (this._loadedLanguagesCache = [
      .../* @__PURE__ */ new Set([...this._resolvedGrammars.keys(), ...Object.keys(this._alias)])
    ]), this._loadedLanguagesCache;
  }
  resolveEmbeddedLanguages(e) {
    if (this._langMap.set(e.name, e), this._langGraph.set(e.name, e), e.embeddedLangs)
      for (const t of e.embeddedLangs)
        this._langGraph.set(t, this._langMap.get(t));
  }
}
class dK {
  constructor(o, e) {
    p(this, "_langs", /* @__PURE__ */ new Map());
    p(this, "_scopeToLang", /* @__PURE__ */ new Map());
    p(this, "_injections", /* @__PURE__ */ new Map());
    p(this, "_onigLib");
    this._onigLib = {
      createOnigScanner: (t) => o.createScanner(t),
      createOnigString: (t) => o.createString(t)
    }, e.forEach((t) => this.addLanguage(t));
  }
  get onigLib() {
    return this._onigLib;
  }
  getLangRegistration(o) {
    return this._langs.get(o);
  }
  loadGrammar(o) {
    return this._scopeToLang.get(o);
  }
  addLanguage(o) {
    this._langs.set(o.name, o), o.aliases && o.aliases.forEach((e) => {
      this._langs.set(e, o);
    }), this._scopeToLang.set(o.scopeName, o), o.injectTo && o.injectTo.forEach((e) => {
      this._injections.get(e) || this._injections.set(e, []), this._injections.get(e).push(o.scopeName);
    });
  }
  getInjections(o) {
    const e = o.split(".");
    let t = [];
    for (let n = 1; n <= e.length; n++) {
      const r = e.slice(0, n).join(".");
      t = [...t, ...this._injections.get(r) || []];
    }
    return t;
  }
}
let Ko = 0;
function pK(A) {
  Ko += 1, A.warnings !== !1 && Ko >= 10 && Ko % 10 === 0 && console.warn(`[Shiki] ${Ko} instances have been created. Shiki is supposed to be used as a singleton, consider refactoring your code to cache your highlighter instance; Or call \`highlighter.dispose()\` to release unused instances.`);
  let o = !1;
  if (!A.engine)
    throw new ZA("`engine` option is required for synchronous mode");
  const e = (A.langs || []).flat(1), t = (A.themes || []).flat(1).map(en), n = new dK(A.engine, e), r = new uK(n, t, e, A.langAlias);
  let a;
  function g(u) {
    c();
    const d = r.getGrammar(typeof u == "string" ? u : u.name);
    if (!d)
      throw new ZA(`Language \`${u}\` not found, you may need to load it first`);
    return d;
  }
  function s(u) {
    if (u === "none")
      return { bg: "", fg: "", name: "none", settings: [], type: "dark" };
    c();
    const d = r.getTheme(u);
    if (!d)
      throw new ZA(`Theme \`${u}\` not found, you may need to load it first`);
    return d;
  }
  function i(u) {
    c();
    const d = s(u);
    a !== u && (r.setTheme(d), a = u);
    const P = r.getColorMap();
    return {
      theme: d,
      colorMap: P
    };
  }
  function l() {
    return c(), r.getLoadedThemes();
  }
  function B() {
    return c(), r.getLoadedLanguages();
  }
  function K(...u) {
    c(), r.loadLanguages(u.flat(1));
  }
  async function F(...u) {
    return K(await Na(u));
  }
  function Q(...u) {
    c();
    for (const d of u.flat(1))
      r.loadTheme(d);
  }
  async function f(...u) {
    return c(), Q(await xa(u));
  }
  function c() {
    if (o)
      throw new ZA("Shiki instance has been disposed");
  }
  function U() {
    o || (o = !0, r.dispose(), Ko -= 1);
  }
  return {
    setTheme: i,
    getTheme: s,
    getLanguage: g,
    getLoadedThemes: l,
    getLoadedLanguages: B,
    loadLanguage: F,
    loadLanguageSync: K,
    loadTheme: f,
    loadThemeSync: Q,
    dispose: U,
    [Symbol.dispose]: U
  };
}
async function hK(A) {
  A.engine || UK("`engine` option is required. Use `createOnigurumaEngine` or `createJavaScriptRegexEngine` to create an engine.");
  const [
    o,
    e,
    t
  ] = await Promise.all([
    xa(A.themes || []),
    Na(A.langs || []),
    A.engine
  ]);
  return pK({
    ...A,
    themes: o,
    langs: e,
    engine: t
  });
}
async function mK(A) {
  const o = await hK(A);
  return {
    getLastGrammarState: (...e) => nK(o, ...e),
    codeToTokensBase: (e, t) => on(o, e, t),
    codeToTokensWithThemes: (e, t) => Da(o, e, t),
    codeToTokens: (e, t) => Ce(o, e, t),
    codeToHast: (e, t) => le(o, e, t),
    codeToHtml: (e, t) => cK(o, e, t),
    getBundledLanguages: () => ({}),
    getBundledThemes: () => ({}),
    ...o,
    getInternalContext: () => o
  };
}
function PK(A) {
  const o = A.langs, e = A.themes, t = A.engine;
  async function n(r) {
    function a(B) {
      var K;
      if (typeof B == "string") {
        if (va(B))
          return [];
        B = ((K = r.langAlias) == null ? void 0 : K[B]) || B;
        const F = o[B];
        if (!F)
          throw new X(`Language \`${B}\` is not included in this bundle. You may want to load it from external source.`);
        return F;
      }
      return B;
    }
    function g(B) {
      if (wa(B))
        return "none";
      if (typeof B == "string") {
        const K = e[B];
        if (!K)
          throw new X(`Theme \`${B}\` is not included in this bundle. You may want to load it from external source.`);
        return K;
      }
      return B;
    }
    const s = (r.themes ?? []).map((B) => g(B)), i = (r.langs ?? []).map((B) => a(B)), l = await mK({
      engine: r.engine ?? t(),
      ...r,
      themes: s,
      langs: i
    });
    return {
      ...l,
      loadLanguage(...B) {
        return l.loadLanguage(...B.map(a));
      },
      loadTheme(...B) {
        return l.loadTheme(...B.map(g));
      },
      getBundledLanguages() {
        return o;
      },
      getBundledThemes() {
        return e;
      }
    };
  }
  return n;
}
function ao(A) {
  if ([...A].length !== 1) throw new Error(`Expected "${A}" to be a single code point`);
  return A.codePointAt(0);
}
function vK(A, o, e) {
  return A.has(o) || A.set(o, e), A.get(o);
}
const tn = /* @__PURE__ */ new Set(["alnum", "alpha", "ascii", "blank", "cntrl", "digit", "graph", "lower", "print", "punct", "space", "upper", "word", "xdigit"]), G = String.raw;
function go(A, o) {
  if (A == null) throw new Error(o ?? "Value expected");
  return A;
}
const ja = G`\[\^?`, ka = `c.? | C(?:-.?)?|${G`[pP]\{(?:\^?[-\x20_]*[A-Za-z][-\x20\w]*\})?`}|${G`x[89A-Fa-f]\p{AHex}(?:\\x[89A-Fa-f]\p{AHex})*`}|${G`u(?:\p{AHex}{4})? | x\{[^\}]*\}? | x\p{AHex}{0,2}`}|${G`o\{[^\}]*\}?`}|${G`\d{1,3}`}`, nn = /[?*+][?+]?|\{(?:\d+(?:,\d*)?|,\d+)\}\??/, Oo = new RegExp(G`
  \\ (?:
    ${ka}
    | [gk]<[^>]*>?
    | [gk]'[^']*'?
    | .
  )
  | \( (?:
    \? (?:
      [:=!>({]
      | <[=!]
      | <[^>]*>
      | '[^']*'
      | ~\|?
      | #(?:[^)\\]|\\.?)*
      | [^:)]*[:)]
    )?
    | \*[^\)]*\)?
  )?
  | (?:${nn.source})+
  | ${ja}
  | .
`.replace(/\s+/g, ""), "gsu"), Se = new RegExp(G`
  \\ (?:
    ${ka}
    | .
  )
  | \[:(?:\^?\p{Alpha}+|\^):\]
  | ${ja}
  | &&
  | .
`.replace(/\s+/g, ""), "gsu");
function wK(A, o = {}) {
  const e = { flags: "", ...o, rules: { captureGroup: !1, singleline: !1, ...o.rules } };
  if (typeof A != "string") throw new Error("String expected as pattern");
  const t = VK(e.flags), n = [t.extended], r = { captureGroup: e.rules.captureGroup, getCurrentModX() {
    return n.at(-1);
  }, numOpenGroups: 0, popModX() {
    n.pop();
  }, pushModX(B) {
    n.push(B);
  }, replaceCurrentModX(B) {
    n[n.length - 1] = B;
  }, singleline: e.rules.singleline };
  let a = [], g;
  for (Oo.lastIndex = 0; g = Oo.exec(A); ) {
    const B = yK(r, A, g[0], Oo.lastIndex);
    B.tokens ? a.push(...B.tokens) : B.token && a.push(B.token), B.lastIndex !== void 0 && (Oo.lastIndex = B.lastIndex);
  }
  const s = [];
  let i = 0;
  a.filter((B) => B.type === "GroupOpen").forEach((B) => {
    B.kind === "capturing" ? B.number = ++i : B.raw === "(" && s.push(B);
  }), i || s.forEach((B, K) => {
    B.kind = "capturing", B.number = K + 1;
  });
  const l = i || s.length;
  return { tokens: a.map((B) => B.type === "EscapedNumber" ? EK(B, l) : B).flat(), flags: t };
}
function yK(A, o, e, t) {
  const [n, r] = e;
  if (e === "[" || e === "[^") {
    const a = bK(o, e, t);
    return { tokens: a.tokens, lastIndex: a.lastIndex };
  }
  if (n === "\\") {
    if ("AbBGyYzZ".includes(r)) return { token: zn(e, e) };
    if (/^\\g[<']/.test(e)) {
      if (!/^\\g(?:<[^>]+>|'[^']+')$/.test(e)) throw new Error(`Invalid group name "${e}"`);
      return { token: TK(e) };
    }
    if (/^\\k[<']/.test(e)) {
      if (!/^\\k(?:<[^>]+>|'[^']+')$/.test(e)) throw new Error(`Invalid group name "${e}"`);
      return { token: Ra(e) };
    }
    if (r === "K") return { token: La("keep", e) };
    if (r === "N" || r === "R") return { token: OA("newline", e, { negate: r === "N" }) };
    if (r === "O") return { token: OA("any", e) };
    if (r === "X") return { token: OA("text_segment", e) };
    const a = Sa(e, { inCharClass: !1 });
    return Array.isArray(a) ? { tokens: a } : { token: a };
  }
  if (n === "(") {
    if (r === "*") return { token: IK(e) };
    if (e === "(?{") throw new Error(`Unsupported callout "${e}"`);
    if (e.startsWith("(?#")) {
      if (o[t] !== ")") throw new Error('Unclosed comment group "(?#"');
      return { lastIndex: t + 1 };
    }
    if (/^\(\?[-imx]+[:)]$/.test(e)) return { token: zK(e, A) };
    if (A.pushModX(A.getCurrentModX()), A.numOpenGroups++, e === "(" && !A.captureGroup || e === "(?:") return { token: qA("group", e) };
    if (e === "(?>") return { token: qA("atomic", e) };
    if (e === "(?=" || e === "(?!" || e === "(?<=" || e === "(?<!") return { token: qA(e[2] === "<" ? "lookbehind" : "lookahead", e, { negate: e.endsWith("!") }) };
    if (e === "(" && A.captureGroup || e.startsWith("(?<") && e.endsWith(">") || e.startsWith("(?'") && e.endsWith("'")) return { token: qA("capturing", e, { ...e !== "(" && { name: e.slice(3, -1) } }) };
    if (e.startsWith("(?~")) {
      if (e === "(?~|") throw new Error(`Unsupported absence function kind "${e}"`);
      return { token: qA("absence_repeater", e) };
    }
    throw e === "(?(" ? new Error(`Unsupported conditional "${e}"`) : new Error(`Invalid or unsupported group option "${e}"`);
  }
  if (e === ")") {
    if (A.popModX(), A.numOpenGroups--, A.numOpenGroups < 0) throw new Error('Unmatched ")"');
    return { token: SK(e) };
  }
  if (A.getCurrentModX()) {
    if (e === "#") {
      const a = o.indexOf(`
`, t);
      return { lastIndex: a === -1 ? o.length : a };
    }
    if (/^\s$/.test(e)) {
      const a = /\s+/y;
      return a.lastIndex = t, { lastIndex: a.exec(o) ? a.lastIndex : t };
    }
  }
  if (e === ".") return { token: OA("dot", e) };
  if (e === "^" || e === "$") {
    const a = A.singleline ? { "^": G`\A`, $: G`\Z` }[e] : e;
    return { token: zn(a, e) };
  }
  return e === "|" ? { token: DK(e) } : nn.test(e) ? { tokens: qK(e) } : { token: hA(ao(e), e) };
}
function bK(A, o, e) {
  const t = [In(o[1] === "^", o)];
  let n = 1, r;
  for (Se.lastIndex = e; r = Se.exec(A); ) {
    const a = r[0];
    if (a[0] === "[" && a[1] !== ":") n++, t.push(In(a[1] === "^", a));
    else if (a === "]") {
      if (t.at(-1).type === "CharacterClassOpen") t.push(hA(93, a));
      else if (n--, t.push(NK(a)), !n) break;
    } else {
      const g = HK(a);
      Array.isArray(g) ? t.push(...g) : t.push(g);
    }
  }
  return { tokens: t, lastIndex: Se.lastIndex || A.length };
}
function HK(A) {
  if (A[0] === "\\") return Sa(A, { inCharClass: !0 });
  if (A[0] === "[") {
    const o = /\[:(?<negate>\^?)(?<name>[a-z]+):\]/.exec(A);
    if (!o || !tn.has(o.groups.name)) throw new Error(`Invalid POSIX class "${A}"`);
    return OA("posix", A, { value: o.groups.name, negate: !!o.groups.negate });
  }
  return A === "-" ? xK(A) : A === "&&" ? jK(A) : hA(ao(A), A);
}
function Sa(A, { inCharClass: o }) {
  const e = A[1];
  if (e === "c" || e === "C") return XK(A);
  if ("dDhHsSwW".includes(e)) return GK(A);
  if (A.startsWith(G`\o{`)) throw new Error(`Incomplete, invalid, or unsupported octal code point "${A}"`);
  if (/^\\[pP]\{/.test(A)) {
    if (A.length === 3) throw new Error(`Incomplete or invalid Unicode property "${A}"`);
    return WK(A);
  }
  if (new RegExp("^\\\\x[89A-Fa-f]\\p{AHex}", "u").test(A)) try {
    const t = A.split(/\\x/).slice(1).map((a) => parseInt(a, 16)), n = new TextDecoder("utf-8", { ignoreBOM: !0, fatal: !0 }).decode(new Uint8Array(t)), r = new TextEncoder();
    return [...n].map((a) => {
      const g = [...r.encode(a)].map((s) => `\\x${s.toString(16)}`).join("");
      return hA(ao(a), g);
    });
  } catch {
    throw new Error(`Multibyte code "${A}" incomplete or invalid in Oniguruma`);
  }
  if (e === "u" || e === "x") return hA(MK(A), A);
  if (Gn.has(e)) return hA(Gn.get(e), A);
  if (/\d/.test(e)) return kK(o, A);
  if (A === "\\") throw new Error(G`Incomplete escape "\"`);
  if (e === "M") throw new Error(`Unsupported meta "${A}"`);
  if ([...A].length === 2) return hA(A.codePointAt(1), A);
  throw new Error(`Unexpected escape "${A}"`);
}
function DK(A) {
  return { type: "Alternator", raw: A };
}
function zn(A, o) {
  return { type: "Assertion", kind: A, raw: o };
}
function Ra(A) {
  return { type: "Backreference", raw: A };
}
function hA(A, o) {
  return { type: "Character", value: A, raw: o };
}
function NK(A) {
  return { type: "CharacterClassClose", raw: A };
}
function xK(A) {
  return { type: "CharacterClassHyphen", raw: A };
}
function jK(A) {
  return { type: "CharacterClassIntersector", raw: A };
}
function In(A, o) {
  return { type: "CharacterClassOpen", negate: A, raw: o };
}
function OA(A, o, e = {}) {
  return { type: "CharacterSet", kind: A, ...e, raw: o };
}
function La(A, o, e = {}) {
  return A === "keep" ? { type: "Directive", kind: A, raw: o } : { type: "Directive", kind: A, flags: go(e.flags), raw: o };
}
function kK(A, o) {
  return { type: "EscapedNumber", inCharClass: A, raw: o };
}
function SK(A) {
  return { type: "GroupClose", raw: A };
}
function qA(A, o, e = {}) {
  return { type: "GroupOpen", kind: A, ...e, raw: o };
}
function RK(A, o, e, t) {
  return { type: "NamedCallout", kind: A, tag: o, arguments: e, raw: t };
}
function LK(A, o, e, t) {
  return { type: "Quantifier", kind: A, min: o, max: e, raw: t };
}
function TK(A) {
  return { type: "Subroutine", raw: A };
}
const OK = /* @__PURE__ */ new Set(["COUNT", "CMP", "ERROR", "FAIL", "MAX", "MISMATCH", "SKIP", "TOTAL_COUNT"]), Gn = /* @__PURE__ */ new Map([["a", 7], ["b", 8], ["e", 27], ["f", 12], ["n", 10], ["r", 13], ["t", 9], ["v", 11]]);
function XK(A) {
  const o = A[1] === "c" ? A[2] : A[3];
  if (!o || !/[A-Za-z]/.test(o)) throw new Error(`Unsupported control character "${A}"`);
  return hA(ao(o.toUpperCase()) - 64, A);
}
function zK(A, o) {
  let { on: e, off: t } = /^\(\?(?<on>[imx]*)(?:-(?<off>[-imx]*))?/.exec(A).groups;
  t ?? (t = "");
  const n = (o.getCurrentModX() || e.includes("x")) && !t.includes("x"), r = Vn(e), a = Vn(t), g = {};
  if (r && (g.enable = r), a && (g.disable = a), A.endsWith(")")) return o.replaceCurrentModX(n), La("flags", A, { flags: g });
  if (A.endsWith(":")) return o.pushModX(n), o.numOpenGroups++, qA("group", A, { ...(r || a) && { flags: g } });
  throw new Error(`Unexpected flag modifier "${A}"`);
}
function IK(A) {
  const o = /\(\*(?<name>[A-Za-z_]\w*)?(?:\[(?<tag>(?:[A-Za-z_]\w*)?)\])?(?:\{(?<args>[^}]*)\})?\)/.exec(A);
  if (!o) throw new Error(`Incomplete or invalid named callout "${A}"`);
  const { name: e, tag: t, args: n } = o.groups;
  if (!e) throw new Error(`Invalid named callout "${A}"`);
  if (t === "") throw new Error(`Named callout tag with empty value not allowed "${A}"`);
  const r = n ? n.split(",").filter((l) => l !== "").map((l) => /^[+-]?\d+$/.test(l) ? +l : l) : [], [a, g, s] = r, i = OK.has(e) ? e.toLowerCase() : "custom";
  switch (i) {
    case "fail":
    case "mismatch":
    case "skip":
      if (r.length > 0) throw new Error(`Named callout arguments not allowed "${r}"`);
      break;
    case "error":
      if (r.length > 1) throw new Error(`Named callout allows only one argument "${r}"`);
      if (typeof a == "string") throw new Error(`Named callout argument must be a number "${a}"`);
      break;
    case "max":
      if (!r.length || r.length > 2) throw new Error(`Named callout must have one or two arguments "${r}"`);
      if (typeof a == "string" && !/^[A-Za-z_]\w*$/.test(a)) throw new Error(`Named callout argument one must be a tag or number "${a}"`);
      if (r.length === 2 && (typeof g == "number" || !/^[<>X]$/.test(g))) throw new Error(`Named callout optional argument two must be '<', '>', or 'X' "${g}"`);
      break;
    case "count":
    case "total_count":
      if (r.length > 1) throw new Error(`Named callout allows only one argument "${r}"`);
      if (r.length === 1 && (typeof a == "number" || !/^[<>X]$/.test(a))) throw new Error(`Named callout optional argument must be '<', '>', or 'X' "${a}"`);
      break;
    case "cmp":
      if (r.length !== 3) throw new Error(`Named callout must have three arguments "${r}"`);
      if (typeof a == "string" && !/^[A-Za-z_]\w*$/.test(a)) throw new Error(`Named callout argument one must be a tag or number "${a}"`);
      if (typeof g == "number" || !/^(?:[<>!=]=|[<>])$/.test(g)) throw new Error(`Named callout argument two must be '==', '!=', '>', '<', '>=', or '<=' "${g}"`);
      if (typeof s == "string" && !/^[A-Za-z_]\w*$/.test(s)) throw new Error(`Named callout argument three must be a tag or number "${s}"`);
      break;
    case "custom":
      throw new Error(`Undefined callout name "${e}"`);
    default:
      throw new Error(`Unexpected named callout kind "${i}"`);
  }
  return RK(i, t ?? null, (n == null ? void 0 : n.split(",")) ?? null, A);
}
function Wn(A) {
  let o = null, e, t;
  if (A[0] === "{") {
    const { minStr: n, maxStr: r } = /^\{(?<minStr>\d*)(?:,(?<maxStr>\d*))?/.exec(A).groups, a = 1e5;
    if (+n > a || r && +r > a) throw new Error("Quantifier value unsupported in Oniguruma");
    if (e = +n, t = r === void 0 ? +n : r === "" ? 1 / 0 : +r, e > t && (o = "possessive", [e, t] = [t, e]), A.endsWith("?")) {
      if (o === "possessive") throw new Error('Unsupported possessive interval quantifier chain with "?"');
      o = "lazy";
    } else o || (o = "greedy");
  } else e = A[0] === "+" ? 1 : 0, t = A[0] === "?" ? 1 : 1 / 0, o = A[1] === "+" ? "possessive" : A[1] === "?" ? "lazy" : "greedy";
  return LK(o, e, t, A);
}
function GK(A) {
  const o = A[1].toLowerCase();
  return OA({ d: "digit", h: "hex", s: "space", w: "word" }[o], A, { negate: A[1] !== o });
}
function WK(A) {
  const { p: o, neg: e, value: t } = /^\\(?<p>[pP])\{(?<neg>\^?)(?<value>[^}]+)/.exec(A).groups;
  return OA("property", A, { value: t, negate: o === "P" && !e || o === "p" && !!e });
}
function Vn(A) {
  const o = {};
  return A.includes("i") && (o.ignoreCase = !0), A.includes("m") && (o.dotAll = !0), A.includes("x") && (o.extended = !0), Object.keys(o).length ? o : null;
}
function VK(A) {
  const o = { ignoreCase: !1, dotAll: !1, extended: !1, digitIsAscii: !1, posixIsAscii: !1, spaceIsAscii: !1, wordIsAscii: !1, textSegmentMode: null };
  for (let e = 0; e < A.length; e++) {
    const t = A[e];
    if (!"imxDPSWy".includes(t)) throw new Error(`Invalid flag "${t}"`);
    if (t === "y") {
      if (!/^y{[gw]}/.test(A.slice(e))) throw new Error('Invalid or unspecified flag "y" mode');
      o.textSegmentMode = A[e + 2] === "g" ? "grapheme" : "word", e += 3;
      continue;
    }
    o[{ i: "ignoreCase", m: "dotAll", x: "extended", D: "digitIsAscii", P: "posixIsAscii", S: "spaceIsAscii", W: "wordIsAscii" }[t]] = !0;
  }
  return o;
}
function MK(A) {
  if (new RegExp("^(?:\\\\u(?!\\p{AHex}{4})|\\\\x(?!\\p{AHex}{1,2}|\\{\\p{AHex}{1,8}\\}))", "u").test(A)) throw new Error(`Incomplete or invalid escape "${A}"`);
  const o = A[2] === "{" ? new RegExp("^\\\\x\\{\\s*(?<hex>\\p{AHex}+)", "u").exec(A).groups.hex : A.slice(2);
  return parseInt(o, 16);
}
function EK(A, o) {
  const { raw: e, inCharClass: t } = A, n = e.slice(1);
  if (!t && (n !== "0" && n.length === 1 || n[0] !== "0" && +n <= o)) return [Ra(e)];
  const r = [], a = n.match(/^[0-7]+|\d/g);
  for (let g = 0; g < a.length; g++) {
    const s = a[g];
    let i;
    if (g === 0 && s !== "8" && s !== "9") {
      if (i = parseInt(s, 8), i > 127) throw new Error(G`Octal encoded byte above 177 unsupported "${e}"`);
    } else i = ao(s);
    r.push(hA(i, (g === 0 ? "\\" : "") + s));
  }
  return r;
}
function qK(A) {
  const o = [], e = new RegExp(nn, "gy");
  let t;
  for (; t = e.exec(A); ) {
    const n = t[0];
    if (n[0] === "{") {
      const r = /^\{(?<min>\d+),(?<max>\d+)\}\??$/.exec(n);
      if (r) {
        const { min: a, max: g } = r.groups;
        if (+a > +g && n.endsWith("?")) {
          e.lastIndex--, o.push(Wn(n.slice(0, -1)));
          continue;
        }
      }
    }
    o.push(Wn(n));
  }
  return o;
}
function Ta(A, o) {
  if (!Array.isArray(A.body)) throw new Error("Expected node with body array");
  if (A.body.length !== 1) return !1;
  const e = A.body[0];
  return !o || Object.keys(o).every((t) => o[t] === e[t]);
}
function JK(A) {
  return ZK.has(A.type);
}
const ZK = /* @__PURE__ */ new Set(["AbsenceFunction", "Backreference", "CapturingGroup", "Character", "CharacterClass", "CharacterSet", "Group", "Quantifier", "Subroutine"]);
function Oa(A, o = {}) {
  const e = { flags: "", normalizeUnknownPropertyNames: !1, skipBackrefValidation: !1, skipLookbehindValidation: !1, skipPropertyNameValidation: !1, unicodePropertyMap: null, ...o, rules: { captureGroup: !1, singleline: !1, ...o.rules } }, t = wK(A, { flags: e.flags, rules: { captureGroup: e.rules.captureGroup, singleline: e.rules.singleline } }), n = (K, F) => {
    const Q = t.tokens[r.nextIndex];
    switch (r.parent = K, r.nextIndex++, Q.type) {
      case "Alternator":
        return GA();
      case "Assertion":
        return YK(Q);
      case "Backreference":
        return _K(Q, r);
      case "Character":
        return de(Q.value, { useLastValid: !!F.isCheckingRangeEnd });
      case "CharacterClassHyphen":
        return $K(Q, r, F);
      case "CharacterClassOpen":
        return AQ(Q, r, F);
      case "CharacterSet":
        return oQ(Q, r);
      case "Directive":
        return gQ(Q.kind, { flags: Q.flags });
      case "GroupOpen":
        return eQ(Q, r, F);
      case "NamedCallout":
        return iQ(Q.kind, Q.tag, Q.arguments);
      case "Quantifier":
        return tQ(Q, r);
      case "Subroutine":
        return nQ(Q, r);
      default:
        throw new Error(`Unexpected token type "${Q.type}"`);
    }
  }, r = { capturingGroups: [], hasNumberedRef: !1, namedGroupsByName: /* @__PURE__ */ new Map(), nextIndex: 0, normalizeUnknownPropertyNames: e.normalizeUnknownPropertyNames, parent: null, skipBackrefValidation: e.skipBackrefValidation, skipLookbehindValidation: e.skipLookbehindValidation, skipPropertyNameValidation: e.skipPropertyNameValidation, subroutines: [], tokens: t.tokens, unicodePropertyMap: e.unicodePropertyMap, walk: n }, a = lQ(sQ(t.flags));
  let g = a.body[0];
  for (; r.nextIndex < t.tokens.length; ) {
    const K = n(g, {});
    K.type === "Alternative" ? (a.body.push(K), g = K) : g.body.push(K);
  }
  const { capturingGroups: s, hasNumberedRef: i, namedGroupsByName: l, subroutines: B } = r;
  if (i && l.size && !e.rules.captureGroup) throw new Error("Numbered backref/subroutine not allowed when using named capture");
  for (const { ref: K } of B) if (typeof K == "number") {
    if (K > s.length) throw new Error("Subroutine uses a group number that's not defined");
    K && (s[K - 1].isSubroutined = !0);
  } else if (l.has(K)) {
    if (l.get(K).length > 1) throw new Error(G`Subroutine uses a duplicate group name "\g<${K}>"`);
    l.get(K)[0].isSubroutined = !0;
  } else throw new Error(G`Subroutine uses a group name that's not defined "\g<${K}>"`);
  return a;
}
function YK({ kind: A }) {
  return dt(go({ "^": "line_start", $: "line_end", "\\A": "string_start", "\\b": "word_boundary", "\\B": "word_boundary", "\\G": "search_start", "\\y": "text_segment_boundary", "\\Y": "text_segment_boundary", "\\z": "string_end", "\\Z": "string_end_newline" }[A], `Unexpected assertion kind "${A}"`), { negate: A === G`\B` || A === G`\Y` });
}
function _K({ raw: A }, o) {
  const e = /^\\k[<']/.test(A), t = e ? A.slice(3, -1) : A.slice(1), n = (r, a = !1) => {
    const g = o.capturingGroups.length;
    let s = !1;
    if (r > g) if (o.skipBackrefValidation) s = !0;
    else throw new Error(`Not enough capturing groups defined to the left "${A}"`);
    return o.hasNumberedRef = !0, pt(a ? g + 1 - r : r, { orphan: s });
  };
  if (e) {
    const r = /^(?<sign>-?)0*(?<num>[1-9]\d*)$/.exec(t);
    if (r) return n(+r.groups.num, !!r.groups.sign);
    if (/[-+]/.test(t)) throw new Error(`Invalid backref name "${A}"`);
    if (!o.namedGroupsByName.has(t)) throw new Error(`Group name not defined to the left "${A}"`);
    return pt(t);
  }
  return n(+t);
}
function $K(A, o, e) {
  const { tokens: t, walk: n } = o, r = o.parent, a = r.body.at(-1), g = t[o.nextIndex];
  if (!e.isCheckingRangeEnd && a && a.type !== "CharacterClass" && a.type !== "CharacterClassRange" && g && g.type !== "CharacterClassOpen" && g.type !== "CharacterClassClose" && g.type !== "CharacterClassIntersector") {
    const s = n(r, { ...e, isCheckingRangeEnd: !0 });
    if (a.type === "Character" && s.type === "Character") return r.body.pop(), aQ(a, s);
    throw new Error("Invalid character class range");
  }
  return de(ao("-"));
}
function AQ({ negate: A }, o, e) {
  const { tokens: t, walk: n } = o, r = t[o.nextIndex], a = [Wo()];
  let g = qn(r);
  for (; g.type !== "CharacterClassClose"; ) {
    if (g.type === "CharacterClassIntersector") a.push(Wo()), o.nextIndex++;
    else {
      const i = a.at(-1);
      i.body.push(n(i, e));
    }
    g = qn(t[o.nextIndex], r);
  }
  const s = Wo({ negate: A });
  return a.length === 1 ? s.body = a[0].body : (s.kind = "intersection", s.body = a.map((i) => i.body.length === 1 ? i.body[0] : i)), o.nextIndex++, s;
}
function oQ({ kind: A, negate: o, value: e }, t) {
  const { normalizeUnknownPropertyNames: n, skipPropertyNameValidation: r, unicodePropertyMap: a } = t;
  if (A === "property") {
    const g = pe(e);
    if (tn.has(g) && !(a != null && a.has(g))) A = "posix", e = g;
    else return JA(e, { negate: o, normalizeUnknownPropertyNames: n, skipPropertyNameValidation: r, unicodePropertyMap: a });
  }
  return A === "posix" ? CQ(e, { negate: o }) : ht(A, { negate: o });
}
function eQ(A, o, e) {
  const { tokens: t, capturingGroups: n, namedGroupsByName: r, skipLookbehindValidation: a, walk: g } = o, s = BQ(A), i = s.type === "AbsenceFunction", l = En(s), B = l && s.negate;
  if (s.type === "CapturingGroup" && (n.push(s), s.name && vK(r, s.name, []).push(s)), i && e.isInAbsenceFunction) throw new Error("Nested absence function not supported by Oniguruma");
  let K = Jn(t[o.nextIndex]);
  for (; K.type !== "GroupClose"; ) {
    if (K.type === "Alternator") s.body.push(GA()), o.nextIndex++;
    else {
      const F = s.body.at(-1), Q = g(F, { ...e, isInAbsenceFunction: e.isInAbsenceFunction || i, isInLookbehind: e.isInLookbehind || l, isInNegLookbehind: e.isInNegLookbehind || B });
      if (F.body.push(Q), (l || e.isInLookbehind) && !a) {
        const f = "Lookbehind includes a pattern not allowed by Oniguruma";
        if (B || e.isInNegLookbehind) {
          if (Mn(Q) || Q.type === "CapturingGroup") throw new Error(f);
        } else if (Mn(Q) || En(Q) && Q.negate) throw new Error(f);
      }
    }
    K = Jn(t[o.nextIndex]);
  }
  return o.nextIndex++, s;
}
function tQ({ kind: A, min: o, max: e }, t) {
  const n = t.parent, r = n.body.at(-1);
  if (!r || !JK(r)) throw new Error("Quantifier requires a repeatable token");
  const a = za(A, o, e, r);
  return n.body.pop(), a;
}
function nQ({ raw: A }, o) {
  const { capturingGroups: e, subroutines: t } = o;
  let n = A.slice(3, -1);
  const r = /^(?<sign>[-+]?)0*(?<num>[1-9]\d*)$/.exec(n);
  if (r) {
    const g = +r.groups.num, s = e.length;
    if (o.hasNumberedRef = !0, n = { "": g, "+": s + g, "-": s + 1 - g }[r.groups.sign], n < 1) throw new Error("Invalid subroutine number");
  } else n === "0" && (n = 0);
  const a = Ia(n);
  return t.push(a), a;
}
function rQ(A, o) {
  return { type: "AbsenceFunction", kind: A, body: jo(o == null ? void 0 : o.body) };
}
function GA(A) {
  return { type: "Alternative", body: Ga(A == null ? void 0 : A.body) };
}
function dt(A, o) {
  const e = { type: "Assertion", kind: A };
  return (A === "word_boundary" || A === "text_segment_boundary") && (e.negate = !!(o != null && o.negate)), e;
}
function pt(A, o) {
  const e = !!(o != null && o.orphan);
  return { type: "Backreference", ref: A, ...e && { orphan: e } };
}
function Xa(A, o) {
  const e = { name: void 0, isSubroutined: !1, ...o };
  if (e.name !== void 0 && !KQ(e.name)) throw new Error(`Group name "${e.name}" invalid in Oniguruma`);
  return { type: "CapturingGroup", number: A, ...e.name && { name: e.name }, ...e.isSubroutined && { isSubroutined: e.isSubroutined }, body: jo(o == null ? void 0 : o.body) };
}
function de(A, o) {
  const e = { useLastValid: !1, ...o };
  if (A > 1114111) {
    const t = A.toString(16);
    if (e.useLastValid) A = 1114111;
    else throw A > 1310719 ? new Error(`Invalid code point out of range "\\x{${t}}"`) : new Error(`Invalid code point out of range in JS "\\x{${t}}"`);
  }
  return { type: "Character", value: A };
}
function Wo(A) {
  const o = { kind: "union", negate: !1, ...A };
  return { type: "CharacterClass", kind: o.kind, negate: o.negate, body: Ga(A == null ? void 0 : A.body) };
}
function aQ(A, o) {
  if (o.value < A.value) throw new Error("Character class range out of order");
  return { type: "CharacterClassRange", min: A, max: o };
}
function ht(A, o) {
  const e = !!(o != null && o.negate), t = { type: "CharacterSet", kind: A };
  return (A === "digit" || A === "hex" || A === "newline" || A === "space" || A === "word") && (t.negate = e), (A === "text_segment" || A === "newline" && !e) && (t.variableLength = !0), t;
}
function gQ(A, o = {}) {
  if (A === "keep") return { type: "Directive", kind: A };
  if (A === "flags") return { type: "Directive", kind: A, flags: go(o.flags) };
  throw new Error(`Unexpected directive kind "${A}"`);
}
function sQ(A) {
  return { type: "Flags", ...A };
}
function lA(A) {
  const o = A == null ? void 0 : A.atomic, e = A == null ? void 0 : A.flags;
  if (o && e) throw new Error("Atomic group cannot have flags");
  return { type: "Group", ...o && { atomic: o }, ...e && { flags: e }, body: jo(A == null ? void 0 : A.body) };
}
function LA(A) {
  const o = { behind: !1, negate: !1, ...A };
  return { type: "LookaroundAssertion", kind: o.behind ? "lookbehind" : "lookahead", negate: o.negate, body: jo(A == null ? void 0 : A.body) };
}
function iQ(A, o, e) {
  return { type: "NamedCallout", kind: A, tag: o, arguments: e };
}
function CQ(A, o) {
  const e = !!(o != null && o.negate);
  if (!tn.has(A)) throw new Error(`Invalid POSIX class "${A}"`);
  return { type: "CharacterSet", kind: "posix", value: A, negate: e };
}
function za(A, o, e, t) {
  if (o > e) throw new Error("Invalid reversed quantifier range");
  return { type: "Quantifier", kind: A, min: o, max: e, body: t };
}
function lQ(A, o) {
  return { type: "Regex", body: jo(o == null ? void 0 : o.body), flags: A };
}
function Ia(A) {
  return { type: "Subroutine", ref: A };
}
function JA(A, o) {
  var n;
  const e = { negate: !1, normalizeUnknownPropertyNames: !1, skipPropertyNameValidation: !1, unicodePropertyMap: null, ...o };
  let t = (n = e.unicodePropertyMap) == null ? void 0 : n.get(pe(A));
  if (!t) {
    if (e.normalizeUnknownPropertyNames) t = QQ(A);
    else if (e.unicodePropertyMap && !e.skipPropertyNameValidation) throw new Error(G`Invalid Unicode property "\p{${A}}"`);
  }
  return { type: "CharacterSet", kind: "property", value: t ?? A, negate: e.negate };
}
function BQ({ flags: A, kind: o, name: e, negate: t, number: n }) {
  switch (o) {
    case "absence_repeater":
      return rQ("repeater");
    case "atomic":
      return lA({ atomic: !0 });
    case "capturing":
      return Xa(n, { name: e });
    case "group":
      return lA({ flags: A });
    case "lookahead":
    case "lookbehind":
      return LA({ behind: o === "lookbehind", negate: t });
    default:
      throw new Error(`Unexpected group kind "${o}"`);
  }
}
function jo(A) {
  if (A === void 0) A = [GA()];
  else if (!Array.isArray(A) || !A.length || !A.every((o) => o.type === "Alternative")) throw new Error("Invalid body; expected array of one or more Alternative nodes");
  return A;
}
function Ga(A) {
  if (A === void 0) A = [];
  else if (!Array.isArray(A) || !A.every((o) => !!o.type)) throw new Error("Invalid body; expected array of nodes");
  return A;
}
function Mn(A) {
  return A.type === "LookaroundAssertion" && A.kind === "lookahead";
}
function En(A) {
  return A.type === "LookaroundAssertion" && A.kind === "lookbehind";
}
function KQ(A) {
  return /^[\p{Alpha}\p{Pc}][^)]*$/u.test(A);
}
function QQ(A) {
  return A.trim().replace(/[- _]+/g, "_").replace(/[A-Z][a-z]+(?=[A-Z])/g, "$&_").replace(/[A-Za-z]+/g, (o) => o[0].toUpperCase() + o.slice(1).toLowerCase());
}
function pe(A) {
  return A.replace(/[- _]+/g, "").toLowerCase();
}
function qn(A, o) {
  return go(A, `${(o == null ? void 0 : o.type) === "Character" && o.value === 93 ? "Empty" : "Unclosed"} character class`);
}
function Jn(A) {
  return go(A, "Unclosed group");
}
function fo(A, o, e = null) {
  function t(r, a) {
    for (let g = 0; g < r.length; g++) {
      const s = n(r[g], a, g, r);
      g = Math.max(-1, g + s);
    }
  }
  function n(r, a = null, g = null, s = null) {
    var U, u;
    let i = 0, l = !1;
    const B = { node: r, parent: a, key: g, container: s, root: A, remove() {
      Xo(s).splice(Math.max(0, MA(g) + i), 1), i--, l = !0;
    }, removeAllNextSiblings() {
      return Xo(s).splice(MA(g) + 1);
    }, removeAllPrevSiblings() {
      const d = MA(g) + i;
      return i -= d, Xo(s).splice(0, Math.max(0, d));
    }, replaceWith(d, P = {}) {
      const v = !!P.traverse;
      s ? s[Math.max(0, MA(g) + i)] = d : go(a, "Can't replace root node")[g] = d, v && n(d, a, g, s), l = !0;
    }, replaceWithMultiple(d, P = {}) {
      const v = !!P.traverse;
      if (Xo(s).splice(Math.max(0, MA(g) + i), 1, ...d), i += d.length - 1, v) {
        let y = 0;
        for (let w = 0; w < d.length; w++) y += n(d[w], a, MA(g) + w + y, s);
      }
      l = !0;
    }, skip() {
      l = !0;
    } }, { type: K } = r, F = o["*"], Q = o[K], f = typeof F == "function" ? F : F == null ? void 0 : F.enter, c = typeof Q == "function" ? Q : Q == null ? void 0 : Q.enter;
    if (f == null || f(B, e), c == null || c(B, e), !l) switch (K) {
      case "AbsenceFunction":
      case "CapturingGroup":
      case "Group":
        t(r.body, r);
        break;
      case "Alternative":
      case "CharacterClass":
        t(r.body, r);
        break;
      case "Assertion":
      case "Backreference":
      case "Character":
      case "CharacterSet":
      case "Directive":
      case "Flags":
      case "NamedCallout":
      case "Subroutine":
        break;
      case "CharacterClassRange":
        n(r.min, r, "min"), n(r.max, r, "max");
        break;
      case "LookaroundAssertion":
        t(r.body, r);
        break;
      case "Quantifier":
        n(r.body, r, "body");
        break;
      case "Regex":
        t(r.body, r), n(r.flags, r, "flags");
        break;
      default:
        throw new Error(`Unexpected node type "${K}"`);
    }
    return (U = Q == null ? void 0 : Q.exit) == null || U.call(Q, B, e), (u = F == null ? void 0 : F.exit) == null || u.call(F, B, e), i;
  }
  return n(A), A;
}
function Xo(A) {
  if (!Array.isArray(A)) throw new Error("Container expected");
  return A;
}
function MA(A) {
  if (typeof A != "number") throw new Error("Numeric key expected");
  return A;
}
const FQ = String.raw`\(\?(?:[:=!>A-Za-z\-]|<[=!]|\(DEFINE\))`;
function cQ(A, o) {
  for (let e = 0; e < A.length; e++)
    A[e] >= o && A[e]++;
}
function fQ(A, o, e, t) {
  return A.slice(0, o) + t + A.slice(o + e.length);
}
const aA = Object.freeze({
  DEFAULT: "DEFAULT",
  CHAR_CLASS: "CHAR_CLASS"
});
function rn(A, o, e, t) {
  const n = new RegExp(String.raw`${o}|(?<$skip>\[\^?|\\?.)`, "gsu"), r = [!1];
  let a = 0, g = "";
  for (const s of A.matchAll(n)) {
    const { 0: i, groups: { $skip: l } } = s;
    if (!l && (!t || t === aA.DEFAULT == !a)) {
      e instanceof Function ? g += e(s, {
        context: a ? aA.CHAR_CLASS : aA.DEFAULT,
        negated: r[r.length - 1]
      }) : g += e;
      continue;
    }
    i[0] === "[" ? (a++, r.push(i[1] === "^")) : i === "]" && a && (a--, r.pop()), g += i;
  }
  return g;
}
function Wa(A, o, e, t) {
  rn(A, o, e, t);
}
function UQ(A, o, e = 0, t) {
  if (!new RegExp(o, "su").test(A))
    return null;
  const n = new RegExp(`${o}|(?<$skip>\\\\?.)`, "gsu");
  n.lastIndex = e;
  let r = 0, a;
  for (; a = n.exec(A); ) {
    const { 0: g, groups: { $skip: s } } = a;
    if (!s && (!t || t === aA.DEFAULT == !r))
      return a;
    g === "[" ? r++ : g === "]" && r && r--, n.lastIndex == a.index && n.lastIndex++;
  }
  return null;
}
function zo(A, o, e) {
  return !!UQ(A, o, 0, e);
}
function uQ(A, o) {
  const e = /\\?./gsu;
  e.lastIndex = o;
  let t = A.length, n = 0, r = 1, a;
  for (; a = e.exec(A); ) {
    const [g] = a;
    if (g === "[")
      n++;
    else if (n)
      g === "]" && n--;
    else if (g === "(")
      r++;
    else if (g === ")" && (r--, !r)) {
      t = a.index;
      break;
    }
  }
  return A.slice(o, t);
}
const Zn = new RegExp(String.raw`(?<noncapturingStart>${FQ})|(?<capturingStart>\((?:\?<[^>]+>)?)|\\?.`, "gsu");
function dQ(A, o) {
  const e = (o == null ? void 0 : o.hiddenCaptures) ?? [];
  let t = (o == null ? void 0 : o.captureTransfers) ?? /* @__PURE__ */ new Map();
  if (!/\(\?>/.test(A))
    return {
      pattern: A,
      captureTransfers: t,
      hiddenCaptures: e
    };
  const n = "(?>", r = "(?:(?=(", a = [0], g = [];
  let s = 0, i = 0, l = NaN, B;
  do {
    B = !1;
    let K = 0, F = 0, Q = !1, f;
    for (Zn.lastIndex = Number.isNaN(l) ? 0 : l + r.length; f = Zn.exec(A); ) {
      const { 0: c, index: U, groups: { capturingStart: u, noncapturingStart: d } } = f;
      if (c === "[")
        K++;
      else if (K)
        c === "]" && K--;
      else if (c === n && !Q)
        l = U, Q = !0;
      else if (Q && d)
        F++;
      else if (u)
        Q ? F++ : (s++, a.push(s + i));
      else if (c === ")" && Q) {
        if (!F) {
          i++;
          const P = s + i;
          if (A = `${A.slice(0, l)}${r}${A.slice(l + n.length, U)}))<$$${P}>)${A.slice(U + 1)}`, B = !0, g.push(P), cQ(e, P), t.size) {
            const v = /* @__PURE__ */ new Map();
            t.forEach((y, w) => {
              v.set(
                w >= P ? w + 1 : w,
                y.map((N) => N >= P ? N + 1 : N)
              );
            }), t = v;
          }
          break;
        }
        F--;
      }
    }
  } while (B);
  return e.push(...g), A = rn(
    A,
    String.raw`\\(?<backrefNum>[1-9]\d*)|<\$\$(?<wrappedBackrefNum>\d+)>`,
    ({ 0: K, groups: { backrefNum: F, wrappedBackrefNum: Q } }) => {
      if (F) {
        const f = +F;
        if (f > a.length - 1)
          throw new Error(`Backref "${K}" greater than number of captures`);
        return `\\${a[f]}`;
      }
      return `\\${Q}`;
    },
    aA.DEFAULT
  ), {
    pattern: A,
    captureTransfers: t,
    hiddenCaptures: e
  };
}
const Va = String.raw`(?:[?*+]|\{\d+(?:,\d*)?\})`, Re = new RegExp(String.raw`
\\(?: \d+
  | c[A-Za-z]
  | [gk]<[^>]+>
  | [pPu]\{[^\}]+\}
  | u[A-Fa-f\d]{4}
  | x[A-Fa-f\d]{2}
  )
| \((?: \? (?: [:=!>]
  | <(?:[=!]|[^>]+>)
  | [A-Za-z\-]+:
  | \(DEFINE\)
  ))?
| (?<qBase>${Va})(?<qMod>[?+]?)(?<invalidQ>[?*+\{]?)
| \\?.
`.replace(/\s+/g, ""), "gsu");
function pQ(A) {
  if (!new RegExp(`${Va}\\+`).test(A))
    return {
      pattern: A
    };
  const o = [];
  let e = null, t = null, n = "", r = 0, a;
  for (Re.lastIndex = 0; a = Re.exec(A); ) {
    const { 0: g, index: s, groups: { qBase: i, qMod: l, invalidQ: B } } = a;
    if (g === "[")
      r || (t = s), r++;
    else if (g === "]")
      r ? r-- : t = null;
    else if (!r)
      if (l === "+" && n && !n.startsWith("(")) {
        if (B)
          throw new Error(`Invalid quantifier "${g}"`);
        let K = -1;
        if (/^\{\d+\}$/.test(i))
          A = fQ(A, s + i.length, l, "");
        else {
          if (n === ")" || n === "]") {
            const F = n === ")" ? e : t;
            if (F === null)
              throw new Error(`Invalid unmatched "${n}"`);
            A = `${A.slice(0, F)}(?>${A.slice(F, s)}${i})${A.slice(s + g.length)}`;
          } else
            A = `${A.slice(0, s - n.length)}(?>${n}${i})${A.slice(s + g.length)}`;
          K += 4;
        }
        Re.lastIndex += K;
      } else g[0] === "(" ? o.push(s) : g === ")" && (e = o.length ? o.pop() : null);
    n = g;
  }
  return {
    pattern: A
  };
}
const rA = String.raw, hQ = rA`\\g<(?<gRNameOrNum>[^>&]+)&R=(?<gRDepth>[^>]+)>`, mt = rA`\(\?R=(?<rDepth>[^\)]+)\)|${hQ}`, he = rA`\(\?<(?![=!])(?<captureName>[^>]+)>`, Ma = rA`${he}|(?<unnamed>\()(?!\?)`, RA = new RegExp(rA`${he}|${mt}|\(\?|\\?.`, "gsu"), Le = "Cannot use multiple overlapping recursions";
function mQ(A, o) {
  const { hiddenCaptures: e, mode: t } = {
    hiddenCaptures: [],
    mode: "plugin",
    ...o
  };
  let n = (o == null ? void 0 : o.captureTransfers) ?? /* @__PURE__ */ new Map();
  if (!new RegExp(mt, "su").test(A))
    return {
      pattern: A,
      captureTransfers: n,
      hiddenCaptures: e
    };
  if (t === "plugin" && zo(A, rA`\(\?\(DEFINE\)`, aA.DEFAULT))
    throw new Error("DEFINE groups cannot be used with recursion");
  const r = [], a = zo(A, rA`\\[1-9]`, aA.DEFAULT), g = /* @__PURE__ */ new Map(), s = [];
  let i = !1, l = 0, B = 0, K;
  for (RA.lastIndex = 0; K = RA.exec(A); ) {
    const { 0: F, groups: { captureName: Q, rDepth: f, gRNameOrNum: c, gRDepth: U } } = K;
    if (F === "[")
      l++;
    else if (l)
      F === "]" && l--;
    else if (f) {
      if (Yn(f), i)
        throw new Error(Le);
      if (a)
        throw new Error(
          // When used in `external` mode by transpilers other than Regex+, backrefs might have
          // gone through conversion from named to numbered, so avoid a misleading error
          `${t === "external" ? "Backrefs" : "Numbered backrefs"} cannot be used with global recursion`
        );
      const u = A.slice(0, K.index), d = A.slice(RA.lastIndex);
      if (zo(d, mt, aA.DEFAULT))
        throw new Error(Le);
      const P = +f - 1;
      A = _n(
        u,
        d,
        P,
        !1,
        e,
        r,
        B
      ), n = Ar(
        n,
        u,
        P,
        r.length,
        0,
        B
      );
      break;
    } else if (c) {
      Yn(U);
      let u = !1;
      for (const PA of s)
        if (PA.name === c || PA.num === +c) {
          if (u = !0, PA.hasRecursedWithin)
            throw new Error(Le);
          break;
        }
      if (!u)
        throw new Error(rA`Recursive \g cannot be used outside the referenced group "${t === "external" ? c : rA`\g<${c}&R=${U}>`}"`);
      const d = g.get(c), P = uQ(A, d);
      if (a && zo(P, rA`${he}|\((?!\?)`, aA.DEFAULT))
        throw new Error(
          // When used in `external` mode by transpilers other than Regex+, backrefs might have
          // gone through conversion from named to numbered, so avoid a misleading error
          `${t === "external" ? "Backrefs" : "Numbered backrefs"} cannot be used with recursion of capturing groups`
        );
      const v = A.slice(d, K.index), y = P.slice(v.length + F.length), w = r.length, N = +U - 1, gA = _n(
        v,
        y,
        N,
        !0,
        e,
        r,
        B
      );
      n = Ar(
        n,
        v,
        N,
        r.length - w,
        w,
        B
      );
      const sA = A.slice(0, d), cA = A.slice(d + P.length);
      A = `${sA}${gA}${cA}`, RA.lastIndex += gA.length - F.length - v.length - y.length, s.forEach((PA) => PA.hasRecursedWithin = !0), i = !0;
    } else if (Q)
      B++, g.set(String(B), RA.lastIndex), g.set(Q, RA.lastIndex), s.push({
        num: B,
        name: Q
      });
    else if (F[0] === "(") {
      const u = F === "(";
      u && (B++, g.set(String(B), RA.lastIndex)), s.push(u ? { num: B } : {});
    } else F === ")" && s.pop();
  }
  return e.push(...r), {
    pattern: A,
    captureTransfers: n,
    hiddenCaptures: e
  };
}
function Yn(A) {
  const o = `Max depth must be integer between 2 and 100; used ${A}`;
  if (!/^[1-9]\d*$/.test(A))
    throw new Error(o);
  if (A = +A, A < 2 || A > 100)
    throw new Error(o);
}
function _n(A, o, e, t, n, r, a) {
  const g = /* @__PURE__ */ new Set();
  t && Wa(A + o, he, ({ groups: { captureName: i } }) => {
    g.add(i);
  }, aA.DEFAULT);
  const s = [
    e,
    t ? g : null,
    n,
    r,
    a
  ];
  return `${A}${$n(`(?:${A}`, "forward", ...s)}(?:)${$n(`${o})`, "backward", ...s)}${o}`;
}
function $n(A, o, e, t, n, r, a) {
  const s = (l) => o === "forward" ? l + 2 : e - l + 2 - 1;
  let i = "";
  for (let l = 0; l < e; l++) {
    const B = s(l);
    i += rn(
      A,
      rA`${Ma}|\\k<(?<backref>[^>]+)>`,
      ({ 0: K, groups: { captureName: F, unnamed: Q, backref: f } }) => {
        if (f && t && !t.has(f))
          return K;
        const c = `_$${B}`;
        if (Q || F) {
          const U = a + r.length + 1;
          return r.push(U), PQ(n, U), Q ? K : `(?<${F}${c}>`;
        }
        return rA`\k<${f}${c}>`;
      },
      aA.DEFAULT
    );
  }
  return i;
}
function PQ(A, o) {
  for (let e = 0; e < A.length; e++)
    A[e] >= o && A[e]++;
}
function Ar(A, o, e, t, n, r) {
  if (A.size && t) {
    let a = 0;
    Wa(o, Ma, () => a++, aA.DEFAULT);
    const g = r - a + n, s = /* @__PURE__ */ new Map();
    return A.forEach((i, l) => {
      const B = (t - a * e) / e, K = a * e, F = l > g + a ? l + t : l, Q = [];
      for (const f of i)
        if (f <= g)
          Q.push(f);
        else if (f > g + a + B)
          Q.push(f + t);
        else if (f <= g + a)
          for (let c = 0; c <= e; c++)
            Q.push(f + a * c);
        else
          for (let c = 0; c <= e; c++)
            Q.push(f + K + B * c);
      s.set(F, Q);
    }), s;
  }
  return A;
}
var z = String.fromCodePoint, b = String.raw, mA = {
  flagGroups: (() => {
    try {
      new RegExp("(?i:)");
    } catch {
      return !1;
    }
    return !0;
  })(),
  unicodeSets: (() => {
    try {
      new RegExp("", "v");
    } catch {
      return !1;
    }
    return !0;
  })()
};
mA.bugFlagVLiteralHyphenIsRange = mA.unicodeSets ? (() => {
  try {
    new RegExp(b`[\d\-a]`, "v");
  } catch {
    return !0;
  }
  return !1;
})() : !1;
mA.bugNestedClassIgnoresNegation = mA.unicodeSets && new RegExp("[[^a]]", "v").test("a");
function Be(A, { enable: o, disable: e }) {
  return {
    dotAll: !(e != null && e.dotAll) && !!(o != null && o.dotAll || A.dotAll),
    ignoreCase: !(e != null && e.ignoreCase) && !!(o != null && o.ignoreCase || A.ignoreCase)
  };
}
function vo(A, o, e) {
  return A.has(o) || A.set(o, e), A.get(o);
}
function Pt(A, o) {
  return or[A] >= or[o];
}
function vQ(A, o) {
  if (A == null)
    throw new Error(o ?? "Value expected");
  return A;
}
var or = {
  ES2025: 2025,
  ES2024: 2024,
  ES2018: 2018
}, wQ = (
  /** @type {const} */
  {
    auto: "auto",
    ES2025: "ES2025",
    ES2024: "ES2024",
    ES2018: "ES2018"
  }
);
function Ea(A = {}) {
  if ({}.toString.call(A) !== "[object Object]")
    throw new Error("Unexpected options");
  if (A.target !== void 0 && !wQ[A.target])
    throw new Error(`Unexpected target "${A.target}"`);
  const o = {
    // Sets the level of emulation rigor/strictness.
    accuracy: "default",
    // Disables advanced emulation that relies on returning a `RegExp` subclass, resulting in
    // certain patterns not being emulatable.
    avoidSubclass: !1,
    // Oniguruma flags; a string with `i`, `m`, `x`, `D`, `S`, `W`, `y{g}` in any order (all
    // optional). Oniguruma's `m` is equivalent to JavaScript's `s` (`dotAll`).
    flags: "",
    // Include JavaScript flag `g` (`global`) in the result.
    global: !1,
    // Include JavaScript flag `d` (`hasIndices`) in the result.
    hasIndices: !1,
    // Delay regex construction until first use if the transpiled pattern is at least this length.
    lazyCompileLength: 1 / 0,
    // JavaScript version used for generated regexes. Using `auto` detects the best value based on
    // your environment. Later targets allow faster processing, simpler generated source, and
    // support for additional features.
    target: "auto",
    // Disables minifications that simplify the pattern without changing the meaning.
    verbose: !1,
    ...A,
    // Advanced options that override standard behavior, error checking, and flags when enabled.
    rules: {
      // Useful with TextMate grammars that merge backreferences across patterns.
      allowOrphanBackrefs: !1,
      // Use ASCII `\b` and `\B`, which increases search performance of generated regexes.
      asciiWordBoundaries: !1,
      // Allow unnamed captures and numbered calls (backreferences and subroutines) when using
      // named capture. This is Oniguruma option `ONIG_OPTION_CAPTURE_GROUP`; on by default in
      // `vscode-oniguruma`.
      captureGroup: !1,
      // Change the recursion depth limit from Oniguruma's `20` to an integer `2`–`20`.
      recursionLimit: 20,
      // `^` as `\A`; `$` as`\Z`. Improves search performance of generated regexes without changing
      // the meaning if searching line by line. This is Oniguruma option `ONIG_OPTION_SINGLELINE`.
      singleline: !1,
      ...A.rules
    }
  };
  return o.target === "auto" && (o.target = mA.flagGroups ? "ES2025" : mA.unicodeSets ? "ES2024" : "ES2018"), o;
}
var yQ = "[	-\r ]", bQ = /* @__PURE__ */ new Set([
  z(304),
  // İ
  z(305)
  // ı
]), UA = b`[\p{L}\p{M}\p{N}\p{Pc}]`;
function qa(A) {
  if (bQ.has(A))
    return [A];
  const o = /* @__PURE__ */ new Set(), e = A.toLowerCase(), t = e.toUpperCase(), n = NQ.get(e), r = HQ.get(e), a = DQ.get(e);
  return [...t].length === 1 && o.add(t), a && o.add(a), n && o.add(n), o.add(e), r && o.add(r), [...o];
}
var an = /* @__PURE__ */ new Map(
  `C Other
Cc Control cntrl
Cf Format
Cn Unassigned
Co Private_Use
Cs Surrogate
L Letter
LC Cased_Letter
Ll Lowercase_Letter
Lm Modifier_Letter
Lo Other_Letter
Lt Titlecase_Letter
Lu Uppercase_Letter
M Mark Combining_Mark
Mc Spacing_Mark
Me Enclosing_Mark
Mn Nonspacing_Mark
N Number
Nd Decimal_Number digit
Nl Letter_Number
No Other_Number
P Punctuation punct
Pc Connector_Punctuation
Pd Dash_Punctuation
Pe Close_Punctuation
Pf Final_Punctuation
Pi Initial_Punctuation
Po Other_Punctuation
Ps Open_Punctuation
S Symbol
Sc Currency_Symbol
Sk Modifier_Symbol
Sm Math_Symbol
So Other_Symbol
Z Separator
Zl Line_Separator
Zp Paragraph_Separator
Zs Space_Separator
ASCII
ASCII_Hex_Digit AHex
Alphabetic Alpha
Any
Assigned
Bidi_Control Bidi_C
Bidi_Mirrored Bidi_M
Case_Ignorable CI
Cased
Changes_When_Casefolded CWCF
Changes_When_Casemapped CWCM
Changes_When_Lowercased CWL
Changes_When_NFKC_Casefolded CWKCF
Changes_When_Titlecased CWT
Changes_When_Uppercased CWU
Dash
Default_Ignorable_Code_Point DI
Deprecated Dep
Diacritic Dia
Emoji
Emoji_Component EComp
Emoji_Modifier EMod
Emoji_Modifier_Base EBase
Emoji_Presentation EPres
Extended_Pictographic ExtPict
Extender Ext
Grapheme_Base Gr_Base
Grapheme_Extend Gr_Ext
Hex_Digit Hex
IDS_Binary_Operator IDSB
IDS_Trinary_Operator IDST
ID_Continue IDC
ID_Start IDS
Ideographic Ideo
Join_Control Join_C
Logical_Order_Exception LOE
Lowercase Lower
Math
Noncharacter_Code_Point NChar
Pattern_Syntax Pat_Syn
Pattern_White_Space Pat_WS
Quotation_Mark QMark
Radical
Regional_Indicator RI
Sentence_Terminal STerm
Soft_Dotted SD
Terminal_Punctuation Term
Unified_Ideograph UIdeo
Uppercase Upper
Variation_Selector VS
White_Space space
XID_Continue XIDC
XID_Start XIDS`.split(/\s/).map((A) => [pe(A), A])
), HQ = /* @__PURE__ */ new Map([
  ["s", z(383)],
  // s, ſ
  [z(383), "s"]
  // ſ, s
]), DQ = /* @__PURE__ */ new Map([
  [z(223), z(7838)],
  // ß, ẞ
  [z(107), z(8490)],
  // k, K (Kelvin)
  [z(229), z(8491)],
  // å, Å (Angstrom)
  [z(969), z(8486)]
  // ω, Ω (Ohm)
]), NQ = new Map([
  yA(453),
  yA(456),
  yA(459),
  yA(498),
  ...Te(8072, 8079),
  ...Te(8088, 8095),
  ...Te(8104, 8111),
  yA(8124),
  yA(8140),
  yA(8188)
]), xQ = /* @__PURE__ */ new Map([
  ["alnum", b`[\p{Alpha}\p{Nd}]`],
  ["alpha", b`\p{Alpha}`],
  ["ascii", b`\p{ASCII}`],
  ["blank", b`[\p{Zs}\t]`],
  ["cntrl", b`\p{Cc}`],
  ["digit", b`\p{Nd}`],
  ["graph", b`[\P{space}&&\P{Cc}&&\P{Cn}&&\P{Cs}]`],
  ["lower", b`\p{Lower}`],
  ["print", b`[[\P{space}&&\P{Cc}&&\P{Cn}&&\P{Cs}]\p{Zs}]`],
  ["punct", b`[\p{P}\p{S}]`],
  // Updated value from Onig 6.9.9; changed from Unicode `\p{punct}`
  ["space", b`\p{space}`],
  ["upper", b`\p{Upper}`],
  ["word", b`[\p{Alpha}\p{M}\p{Nd}\p{Pc}]`],
  ["xdigit", b`\p{AHex}`]
]);
function jQ(A, o) {
  const e = [];
  for (let t = A; t <= o; t++)
    e.push(t);
  return e;
}
function yA(A) {
  const o = z(A);
  return [o.toLowerCase(), o];
}
function Te(A, o) {
  return jQ(A, o).map((e) => yA(e));
}
var Ja = /* @__PURE__ */ new Set([
  "Lower",
  "Lowercase",
  "Upper",
  "Uppercase",
  "Ll",
  "Lowercase_Letter",
  "Lt",
  "Titlecase_Letter",
  "Lu",
  "Uppercase_Letter"
  // The `Changes_When_*` properties (and their aliases) could be included, but they're very rare.
  // Some other properties include a handful of chars with specific cases only, but these chars are
  // generally extreme edge cases and using such properties case insensitively generally produces
  // undesired behavior anyway
]);
function kQ(A, o) {
  const e = {
    // A couple edge cases exist where options `accuracy` and `bestEffortTarget` are used:
    // - `CharacterSet` kind `text_segment` (`\X`): An exact representation would require heavy
    //   Unicode data; a best-effort approximation requires knowing the target.
    // - `CharacterSet` kind `posix` with values `graph` and `print`: Their complex Unicode
    //   representations would be hard to change to ASCII versions after the fact in the generator
    //   based on `target`/`accuracy`, so produce the appropriate structure here.
    accuracy: "default",
    asciiWordBoundaries: !1,
    avoidSubclass: !1,
    bestEffortTarget: "ES2025",
    ...o
  };
  Za(A);
  const t = {
    accuracy: e.accuracy,
    asciiWordBoundaries: e.asciiWordBoundaries,
    avoidSubclass: e.avoidSubclass,
    flagDirectivesByAlt: /* @__PURE__ */ new Map(),
    jsGroupNameMap: /* @__PURE__ */ new Map(),
    minTargetEs2024: Pt(e.bestEffortTarget, "ES2024"),
    passedLookbehind: !1,
    strategy: null,
    // Subroutines can appear before the groups they ref, so collect reffed nodes for a second pass 
    subroutineRefMap: /* @__PURE__ */ new Map(),
    supportedGNodes: /* @__PURE__ */ new Set(),
    digitIsAscii: A.flags.digitIsAscii,
    spaceIsAscii: A.flags.spaceIsAscii,
    wordIsAscii: A.flags.wordIsAscii
  };
  fo(A, SQ, t);
  const n = {
    dotAll: A.flags.dotAll,
    ignoreCase: A.flags.ignoreCase
  }, r = {
    currentFlags: n,
    prevFlags: null,
    globalFlags: n,
    groupOriginByCopy: /* @__PURE__ */ new Map(),
    groupsByName: /* @__PURE__ */ new Map(),
    multiplexCapturesToLeftByRef: /* @__PURE__ */ new Map(),
    openRefs: /* @__PURE__ */ new Map(),
    reffedNodesByReferencer: /* @__PURE__ */ new Map(),
    subroutineRefMap: t.subroutineRefMap
  };
  fo(A, RQ, r);
  const a = {
    groupsByName: r.groupsByName,
    highestOrphanBackref: 0,
    numCapturesToLeft: 0,
    reffedNodesByReferencer: r.reffedNodesByReferencer
  };
  return fo(A, LQ, a), A._originMap = r.groupOriginByCopy, A._strategy = t.strategy, A;
}
var SQ = {
  AbsenceFunction({ node: A, parent: o, replaceWith: e }) {
    const { body: t, kind: n } = A;
    if (n === "repeater") {
      const r = lA();
      r.body[0].body.push(
        // Insert own alts as `body`
        LA({ negate: !0, body: t }),
        JA("Any")
      );
      const a = lA();
      a.body[0].body.push(
        za("greedy", 0, 1 / 0, r)
      ), e(T(a, o), { traverse: !0 });
    } else
      throw new Error('Unsupported absence function "(?~|"');
  },
  Alternative: {
    enter({ node: A, parent: o, key: e }, { flagDirectivesByAlt: t }) {
      const n = A.body.filter((r) => r.kind === "flags");
      for (let r = e + 1; r < o.body.length; r++) {
        const a = o.body[r];
        vo(t, a, []).push(...n);
      }
    },
    exit({ node: A }, { flagDirectivesByAlt: o }) {
      var e;
      if ((e = o.get(A)) != null && e.length) {
        const t = _a(o.get(A));
        if (t) {
          const n = lA({ flags: t });
          n.body[0].body = A.body, A.body = [T(n, A)];
        }
      }
    }
  },
  Assertion({ node: A, parent: o, key: e, container: t, root: n, remove: r, replaceWith: a }, g) {
    const { kind: s, negate: i } = A, { asciiWordBoundaries: l, avoidSubclass: B, supportedGNodes: K, wordIsAscii: F } = g;
    if (s === "text_segment_boundary")
      throw new Error(`Unsupported text segment boundary "\\${i ? "Y" : "y"}"`);
    if (s === "line_end")
      a(T(LA({ body: [
        GA({ body: [dt("string_end")] }),
        GA({ body: [de(10)] })
        // `\n`
      ] }), o));
    else if (s === "line_start")
      a(T(uA(b`(?<=\A|\n(?!\z))`, { skipLookbehindValidation: !0 }), o));
    else if (s === "search_start")
      if (K.has(A))
        n.flags.sticky = !0, r();
      else {
        const Q = t[e - 1];
        if (Q && GQ(Q))
          a(T(LA({ negate: !0 }), o));
        else {
          if (B)
            throw new Error(b`Uses "\G" in a way that requires a subclass`);
          a(bA(dt("string_start"), o)), g.strategy = "clip_search";
        }
      }
    else if (!(s === "string_end" || s === "string_start")) if (s === "string_end_newline")
      a(T(uA(b`(?=\n?\z)`), o));
    else if (s === "word_boundary") {
      if (!F && !l) {
        const Q = `(?:(?<=${UA})(?!${UA})|(?<!${UA})(?=${UA}))`, f = `(?:(?<=${UA})(?=${UA})|(?<!${UA})(?!${UA}))`;
        a(T(uA(i ? f : Q), o));
      }
    } else
      throw new Error(`Unexpected assertion kind "${s}"`);
  },
  Backreference({ node: A }, { jsGroupNameMap: o }) {
    let { ref: e } = A;
    typeof e == "string" && !Xe(e) && (e = Oe(e, o), A.ref = e);
  },
  CapturingGroup({ node: A }, { jsGroupNameMap: o, subroutineRefMap: e }) {
    let { name: t } = A;
    t && !Xe(t) && (t = Oe(t, o), A.name = t), e.set(A.number, A), t && e.set(t, A);
  },
  CharacterClassRange({ node: A, parent: o, replaceWith: e }) {
    if (o.kind === "intersection") {
      const t = Wo({ body: [A] });
      e(T(t, o), { traverse: !0 });
    }
  },
  CharacterSet({ node: A, parent: o, replaceWith: e }, { accuracy: t, minTargetEs2024: n, digitIsAscii: r, spaceIsAscii: a, wordIsAscii: g }) {
    const { kind: s, negate: i, value: l } = A;
    if (r && (s === "digit" || l === "digit")) {
      e(bA(ht("digit", { negate: i }), o));
      return;
    }
    if (a && (s === "space" || l === "space")) {
      e(T(ze(uA(yQ), i), o));
      return;
    }
    if (g && (s === "word" || l === "word")) {
      e(bA(ht("word", { negate: i }), o));
      return;
    }
    if (s === "any")
      e(bA(JA("Any"), o));
    else if (s === "digit")
      e(bA(JA("Nd", { negate: i }), o));
    else if (s !== "dot") if (s === "text_segment") {
      if (t === "strict")
        throw new Error(b`Use of "\X" requires non-strict accuracy`);
      const B = "\\p{Emoji}(?:\\p{EMod}|\\uFE0F\\u20E3?|[\\x{E0020}-\\x{E007E}]+\\x{E007F})?", K = b`\p{RI}{2}|${B}(?:\u200D${B})*`;
      e(T(uA(
        // Close approximation of an extended grapheme cluster; see: <unicode.org/reports/tr29/>
        b`(?>\r\n|${n ? b`\p{RGI_Emoji}` : K}|\P{M}\p{M}*)`,
        // Allow JS property `RGI_Emoji` through
        { skipPropertyNameValidation: !0 }
      ), o));
    } else if (s === "hex")
      e(bA(JA("AHex", { negate: i }), o));
    else if (s === "newline")
      e(T(uA(i ? `[^
]` : `(?>\r
?|[
\v\f\u2028\u2029])`), o));
    else if (s === "posix")
      if (!n && (l === "graph" || l === "print")) {
        if (t === "strict")
          throw new Error(`POSIX class "${l}" requires min target ES2024 or non-strict accuracy`);
        let B = {
          graph: "!-~",
          print: " -~"
        }[l];
        i && (B = `\0-${z(B.codePointAt(0) - 1)}${z(B.codePointAt(2) + 1)}-􏿿`), e(T(uA(`[${B}]`), o));
      } else
        e(T(ze(uA(xQ.get(l)), i), o));
    else if (s === "property")
      an.has(pe(l)) || (A.key = "sc");
    else if (s === "space")
      e(bA(JA("space", { negate: i }), o));
    else if (s === "word")
      e(T(ze(uA(UA), i), o));
    else
      throw new Error(`Unexpected character set kind "${s}"`);
  },
  Directive({ node: A, parent: o, root: e, remove: t, replaceWith: n, removeAllPrevSiblings: r, removeAllNextSiblings: a }) {
    const { kind: g, flags: s } = A;
    if (g === "flags")
      if (!s.enable && !s.disable)
        t();
      else {
        const i = lA({ flags: s });
        i.body[0].body = a(), n(T(i, o), { traverse: !0 });
      }
    else if (g === "keep") {
      const i = e.body[0], B = e.body.length === 1 && // Not emulatable if within a `CapturingGroup`
      Ta(i, { type: "Group" }) && i.body[0].body.length === 1 ? i.body[0] : e;
      if (o.parent !== B || B.body.length > 1)
        throw new Error(b`Uses "\K" in a way that's unsupported`);
      const K = LA({ behind: !0 });
      K.body[0].body = r(), n(T(K, o));
    } else
      throw new Error(`Unexpected directive kind "${g}"`);
  },
  Flags({ node: A, parent: o }) {
    if (A.posixIsAscii)
      throw new Error('Unsupported flag "P"');
    if (A.textSegmentMode === "word")
      throw new Error('Unsupported flag "y{w}"');
    [
      "digitIsAscii",
      // Flag D
      "extended",
      // Flag x
      "posixIsAscii",
      // Flag P
      "spaceIsAscii",
      // Flag S
      "wordIsAscii",
      // Flag W
      "textSegmentMode"
      // Flag y{g} or y{w}
    ].forEach((e) => delete A[e]), Object.assign(A, {
      // JS flag g; no Onig equiv
      global: !1,
      // JS flag d; no Onig equiv
      hasIndices: !1,
      // JS flag m; no Onig equiv but its behavior is always on in Onig. Onig's only line break
      // char is line feed, unlike JS, so this flag isn't used since it would produce inaccurate
      // results (also allows `^` and `$` to be used in the generator for string start and end)
      multiline: !1,
      // JS flag y; no Onig equiv, but used for `\G` emulation
      sticky: A.sticky ?? !1
      // Note: Regex+ doesn't allow explicitly adding flags it handles implicitly, so leave out
      // properties `unicode` (JS flag u) and `unicodeSets` (JS flag v). Keep the existing values
      // for `ignoreCase` (flag i) and `dotAll` (JS flag s, but Onig flag m)
    }), o.options = {
      disable: {
        // Onig uses different rules for flag x than Regex+, so disable the implicit flag
        x: !0,
        // Onig has no flag to control "named capture only" mode but contextually applies its
        // behavior when named capturing is used, so disable Regex+'s implicit flag for it
        n: !0
      },
      force: {
        // Always add flag v because we're generating an AST that relies on it (it enables JS
        // support for Onig features nested classes, intersection, Unicode properties, etc.).
        // However, the generator might disable flag v based on its `target` option
        v: !0
      }
    };
  },
  Group({ node: A }) {
    if (!A.flags)
      return;
    const { enable: o, disable: e } = A.flags;
    o != null && o.extended && delete o.extended, e != null && e.extended && delete e.extended, o != null && o.dotAll && (e != null && e.dotAll) && delete o.dotAll, o != null && o.ignoreCase && (e != null && e.ignoreCase) && delete o.ignoreCase, o && !Object.keys(o).length && delete A.flags.enable, e && !Object.keys(e).length && delete A.flags.disable, !A.flags.enable && !A.flags.disable && delete A.flags;
  },
  LookaroundAssertion({ node: A }, o) {
    const { kind: e } = A;
    e === "lookbehind" && (o.passedLookbehind = !0);
  },
  NamedCallout({ node: A, parent: o, replaceWith: e }) {
    const { kind: t } = A;
    if (t === "fail")
      e(T(LA({ negate: !0 }), o));
    else
      throw new Error(`Unsupported named callout "(*${t.toUpperCase()}"`);
  },
  Quantifier({ node: A }) {
    if (A.body.type === "Quantifier") {
      const o = lA();
      o.body[0].body.push(A.body), A.body = T(o, A);
    }
  },
  Regex: {
    enter({ node: A }, { supportedGNodes: o }) {
      const e = [];
      let t = !1, n = !1;
      for (const r of A.body)
        if (r.body.length === 1 && r.body[0].kind === "search_start")
          r.body.pop();
        else {
          const a = Ag(r.body);
          a ? (t = !0, Array.isArray(a) ? e.push(...a) : e.push(a)) : n = !0;
        }
      t && !n && e.forEach((r) => o.add(r));
    },
    exit(A, { accuracy: o, passedLookbehind: e, strategy: t }) {
      if (o === "strict" && e && t)
        throw new Error(b`Uses "\G" in a way that requires non-strict accuracy`);
    }
  },
  Subroutine({ node: A }, { jsGroupNameMap: o }) {
    let { ref: e } = A;
    typeof e == "string" && !Xe(e) && (e = Oe(e, o), A.ref = e);
  }
}, RQ = {
  Backreference({ node: A }, { multiplexCapturesToLeftByRef: o, reffedNodesByReferencer: e }) {
    const { orphan: t, ref: n } = A;
    t || e.set(A, [...o.get(n).map(({ node: r }) => r)]);
  },
  CapturingGroup: {
    enter({
      node: A,
      parent: o,
      replaceWith: e,
      skip: t
    }, {
      groupOriginByCopy: n,
      groupsByName: r,
      multiplexCapturesToLeftByRef: a,
      openRefs: g,
      reffedNodesByReferencer: s
    }) {
      const i = n.get(A);
      if (i && g.has(A.number)) {
        const B = bA(er(A.number), o);
        s.set(B, g.get(A.number)), e(B);
        return;
      }
      g.set(A.number, A), a.set(A.number, []), A.name && vo(a, A.name, []);
      const l = a.get(A.name ?? A.number);
      for (let B = 0; B < l.length; B++) {
        const K = l[B];
        if (
          // This group is from subroutine expansion, and there's a multiplex value from either the
          // origin node or a prior subroutine expansion group with the same origin
          i === K.node || i && i === K.origin || // This group is not from subroutine expansion, and it comes after a subroutine expansion
          // group that refers to this group
          A === K.origin
        ) {
          l.splice(B, 1);
          break;
        }
      }
      if (a.get(A.number).push({ node: A, origin: i }), A.name && a.get(A.name).push({ node: A, origin: i }), A.name) {
        const B = vo(r, A.name, /* @__PURE__ */ new Map());
        let K = !1;
        if (i)
          K = !0;
        else
          for (const F of B.values())
            if (!F.hasDuplicateNameToRemove) {
              K = !0;
              break;
            }
        r.get(A.name).set(A, { node: A, hasDuplicateNameToRemove: K });
      }
    },
    exit({ node: A }, { openRefs: o }) {
      o.delete(A.number);
    }
  },
  Group: {
    enter({ node: A }, o) {
      o.prevFlags = o.currentFlags, A.flags && (o.currentFlags = Be(o.currentFlags, A.flags));
    },
    exit(A, o) {
      o.currentFlags = o.prevFlags;
    }
  },
  Subroutine({ node: A, parent: o, replaceWith: e }, t) {
    const { isRecursive: n, ref: r } = A;
    if (n) {
      let l = o;
      for (; (l = l.parent) && !(l.type === "CapturingGroup" && (l.name === r || l.number === r)); )
        ;
      t.reffedNodesByReferencer.set(A, l);
      return;
    }
    const a = t.subroutineRefMap.get(r), g = r === 0, s = g ? er(0) : (
      // The reffed group might itself contain subroutines, which are expanded during sub-traversal
      Ya(a, t.groupOriginByCopy, null)
    );
    let i = s;
    if (!g) {
      const l = _a(XQ(
        a,
        (K) => K.type === "Group" && !!K.flags
      )), B = l ? Be(t.globalFlags, l) : t.globalFlags;
      TQ(B, t.currentFlags) || (i = lA({
        flags: zQ(B)
      }), i.body[0].body.push(s));
    }
    e(T(i, o), { traverse: !g });
  }
}, LQ = {
  Backreference({ node: A, parent: o, replaceWith: e }, t) {
    if (A.orphan) {
      t.highestOrphanBackref = Math.max(t.highestOrphanBackref, A.ref);
      return;
    }
    const r = t.reffedNodesByReferencer.get(A).filter((a) => OQ(a, A));
    if (!r.length)
      e(T(LA({ negate: !0 }), o));
    else if (r.length > 1) {
      const a = lA({
        atomic: !0,
        body: r.reverse().map((g) => GA({
          body: [pt(g.number)]
        }))
      });
      e(T(a, o));
    } else
      A.ref = r[0].number;
  },
  CapturingGroup({ node: A }, o) {
    A.number = ++o.numCapturesToLeft, A.name && o.groupsByName.get(A.name).get(A).hasDuplicateNameToRemove && delete A.name;
  },
  Regex: {
    exit({ node: A }, o) {
      const e = Math.max(o.highestOrphanBackref - o.numCapturesToLeft, 0);
      for (let t = 0; t < e; t++) {
        const n = Xa();
        A.body.at(-1).body.push(n);
      }
    }
  },
  Subroutine({ node: A }, o) {
    !A.isRecursive || A.ref === 0 || (A.ref = o.reffedNodesByReferencer.get(A).number);
  }
};
function Za(A) {
  fo(A, {
    "*"({ node: o, parent: e }) {
      o.parent = e;
    }
  });
}
function TQ(A, o) {
  return A.dotAll === o.dotAll && A.ignoreCase === o.ignoreCase;
}
function OQ(A, o) {
  let e = o;
  do {
    if (e.type === "Regex")
      return !1;
    if (e.type === "Alternative")
      continue;
    if (e === A)
      return !1;
    const t = $a(e.parent);
    for (const n of t) {
      if (n === e)
        break;
      if (n === A || og(n, A))
        return !0;
    }
  } while (e = e.parent);
  throw new Error("Unexpected path");
}
function Ya(A, o, e, t) {
  const n = Array.isArray(A) ? [] : {};
  for (const [r, a] of Object.entries(A))
    r === "parent" ? n.parent = Array.isArray(e) ? t : e : a && typeof a == "object" ? n[r] = Ya(a, o, n, e) : (r === "type" && a === "CapturingGroup" && o.set(n, o.get(A) ?? A), n[r] = a);
  return n;
}
function er(A) {
  const o = Ia(A);
  return o.isRecursive = !0, o;
}
function XQ(A, o) {
  const e = [];
  for (; A = A.parent; )
    (!o || o(A)) && e.push(A);
  return e;
}
function Oe(A, o) {
  if (o.has(A))
    return o.get(A);
  const e = `$${o.size}_${A.replace(/^[^$_\p{IDS}]|[^$\u200C\u200D\p{IDC}]/ug, "_")}`;
  return o.set(A, e), e;
}
function _a(A) {
  const o = ["dotAll", "ignoreCase"], e = { enable: {}, disable: {} };
  return A.forEach(({ flags: t }) => {
    o.forEach((n) => {
      var r, a;
      (r = t.enable) != null && r[n] && (delete e.disable[n], e.enable[n] = !0), (a = t.disable) != null && a[n] && (e.disable[n] = !0);
    });
  }), Object.keys(e.enable).length || delete e.enable, Object.keys(e.disable).length || delete e.disable, e.enable || e.disable ? e : null;
}
function zQ({ dotAll: A, ignoreCase: o }) {
  const e = {};
  return (A || o) && (e.enable = {}, A && (e.enable.dotAll = !0), o && (e.enable.ignoreCase = !0)), (!A || !o) && (e.disable = {}, !A && (e.disable.dotAll = !0), !o && (e.disable.ignoreCase = !0)), e;
}
function $a(A) {
  if (!A)
    throw new Error("Node expected");
  const { body: o } = A;
  return Array.isArray(o) ? o : o ? [o] : null;
}
function Ag(A) {
  const o = A.find((e) => e.kind === "search_start" || WQ(e, { negate: !1 }) || !IQ(e));
  if (!o)
    return null;
  if (o.kind === "search_start")
    return o;
  if (o.type === "LookaroundAssertion")
    return o.body[0].body[0];
  if (o.type === "CapturingGroup" || o.type === "Group") {
    const e = [];
    for (const t of o.body) {
      const n = Ag(t.body);
      if (!n)
        return null;
      Array.isArray(n) ? e.push(...n) : e.push(n);
    }
    return e;
  }
  return null;
}
function og(A, o) {
  const e = $a(A) ?? [];
  for (const t of e)
    if (t === o || og(t, o))
      return !0;
  return !1;
}
function IQ({ type: A }) {
  return A === "Assertion" || A === "Directive" || A === "LookaroundAssertion";
}
function GQ(A) {
  const o = [
    "Character",
    "CharacterClass",
    "CharacterSet"
  ];
  return o.includes(A.type) || A.type === "Quantifier" && A.min && o.includes(A.body.type);
}
function WQ(A, o) {
  const e = {
    negate: null,
    ...o
  };
  return A.type === "LookaroundAssertion" && (e.negate === null || A.negate === e.negate) && A.body.length === 1 && Ta(A.body[0], {
    type: "Assertion",
    kind: "search_start"
  });
}
function Xe(A) {
  return /^[$_\p{IDS}][$\u200C\u200D\p{IDC}]*$/u.test(A);
}
function uA(A, o) {
  const t = Oa(A, {
    ...o,
    // Providing a custom set of Unicode property names avoids converting some JS Unicode
    // properties (ex: `\p{Alpha}`) to Onig POSIX classes
    unicodePropertyMap: an
  }).body;
  return t.length > 1 || t[0].body.length > 1 ? lA({ body: t }) : t[0].body[0];
}
function ze(A, o) {
  return A.negate = o, A;
}
function bA(A, o) {
  return A.parent = o, A;
}
function T(A, o) {
  return Za(A), A.parent = o, A;
}
function VQ(A, o) {
  const e = Ea(o), t = Pt(e.target, "ES2024"), n = Pt(e.target, "ES2025"), r = e.rules.recursionLimit;
  if (!Number.isInteger(r) || r < 2 || r > 20)
    throw new Error("Invalid recursionLimit; use 2-20");
  let a = null, g = null;
  if (!n) {
    const F = [A.flags.ignoreCase];
    fo(A, MQ, {
      getCurrentModI: () => F.at(-1),
      popModI() {
        F.pop();
      },
      pushModI(Q) {
        F.push(Q);
      },
      setHasCasedChar() {
        F.at(-1) ? a = !0 : g = !0;
      }
    });
  }
  const s = {
    dotAll: A.flags.dotAll,
    // - Turn global flag i on if a case insensitive node was used and no case sensitive nodes were
    //   used (to avoid unnecessary node expansion).
    // - Turn global flag i off if a case sensitive node was used (since case sensitivity can't be
    //   forced without the use of ES2025 flag groups)
    ignoreCase: !!((A.flags.ignoreCase || a) && !g)
  };
  let i = A;
  const l = {
    accuracy: e.accuracy,
    appliedGlobalFlags: s,
    captureMap: /* @__PURE__ */ new Map(),
    currentFlags: {
      dotAll: A.flags.dotAll,
      ignoreCase: A.flags.ignoreCase
    },
    inCharClass: !1,
    lastNode: i,
    originMap: A._originMap,
    recursionLimit: r,
    useAppliedIgnoreCase: !!(!n && a && g),
    useFlagMods: n,
    useFlagV: t,
    verbose: e.verbose
  };
  function B(F) {
    return l.lastNode = i, i = F, vQ(EQ[F.type], `Unexpected node type "${F.type}"`)(F, l, B);
  }
  const K = {
    pattern: A.body.map(B).join("|"),
    // Could reset `lastNode` at this point via `lastNode = ast`, but it isn't needed by flags
    flags: B(A.flags),
    options: { ...A.options }
  };
  return t || (delete K.options.force.v, K.options.disable.v = !0, K.options.unicodeSetsPlugin = null), K._captureTransfers = /* @__PURE__ */ new Map(), K._hiddenCaptures = [], l.captureMap.forEach((F, Q) => {
    F.hidden && K._hiddenCaptures.push(Q), F.transferTo && vo(K._captureTransfers, F.transferTo, []).push(Q);
  }), K;
}
var MQ = {
  "*": {
    enter({ node: A }, o) {
      if (nr(A)) {
        const e = o.getCurrentModI();
        o.pushModI(
          A.flags ? Be({ ignoreCase: e }, A.flags).ignoreCase : e
        );
      }
    },
    exit({ node: A }, o) {
      nr(A) && o.popModI();
    }
  },
  Backreference(A, o) {
    o.setHasCasedChar();
  },
  Character({ node: A }, o) {
    gn(z(A.value)) && o.setHasCasedChar();
  },
  CharacterClassRange({ node: A, skip: o }, e) {
    o(), eg(A, { firstOnly: !0 }).length && e.setHasCasedChar();
  },
  CharacterSet({ node: A }, o) {
    A.kind === "property" && Ja.has(A.value) && o.setHasCasedChar();
  }
}, EQ = {
  /**
  @param {AlternativeNode} node
  */
  Alternative({ body: A }, o, e) {
    return A.map(e).join("");
  },
  /**
  @param {AssertionNode} node
  */
  Assertion({ kind: A, negate: o }) {
    if (A === "string_end")
      return "$";
    if (A === "string_start")
      return "^";
    if (A === "word_boundary")
      return o ? b`\B` : b`\b`;
    throw new Error(`Unexpected assertion kind "${A}"`);
  },
  /**
  @param {BackreferenceNode} node
  */
  Backreference({ ref: A }, o) {
    if (typeof A != "number")
      throw new Error("Unexpected named backref in transformed AST");
    if (!o.useFlagMods && o.accuracy === "strict" && o.currentFlags.ignoreCase && !o.captureMap.get(A).ignoreCase)
      throw new Error("Use of case-insensitive backref to case-sensitive group requires target ES2025 or non-strict accuracy");
    return "\\" + A;
  },
  /**
  @param {CapturingGroupNode} node
  */
  CapturingGroup(A, o, e) {
    const { body: t, name: n, number: r } = A, a = { ignoreCase: o.currentFlags.ignoreCase }, g = o.originMap.get(A);
    return g && (a.hidden = !0, r > g.number && (a.transferTo = g.number)), o.captureMap.set(r, a), `(${n ? `?<${n}>` : ""}${t.map(e).join("|")})`;
  },
  /**
  @param {CharacterNode} node
  */
  Character({ value: A }, o) {
    const e = z(A), t = EA(A, {
      escDigit: o.lastNode.type === "Backreference",
      inCharClass: o.inCharClass,
      useFlagV: o.useFlagV
    });
    if (t !== e)
      return t;
    if (o.useAppliedIgnoreCase && o.currentFlags.ignoreCase && gn(e)) {
      const n = qa(e);
      return o.inCharClass ? n.join("") : n.length > 1 ? `[${n.join("")}]` : n[0];
    }
    return e;
  },
  /**
  @param {CharacterClassNode} node
  */
  CharacterClass(A, o, e) {
    const { kind: t, negate: n, parent: r } = A;
    let { body: a } = A;
    if (t === "intersection" && !o.useFlagV)
      throw new Error("Use of class intersection requires min target ES2024");
    mA.bugFlagVLiteralHyphenIsRange && o.useFlagV && a.some(rr) && (a = [de(45), ...a.filter((i) => !rr(i))]);
    const g = () => `[${n ? "^" : ""}${a.map(e).join(t === "intersection" ? "&&" : "")}]`;
    if (!o.inCharClass) {
      if (
        // Already established `kind !== 'intersection'` if `!state.useFlagV`; don't check again
        (!o.useFlagV || mA.bugNestedClassIgnoresNegation) && !n
      ) {
        const l = a.filter(
          (B) => B.type === "CharacterClass" && B.kind === "union" && B.negate
        );
        if (l.length) {
          const B = lA(), K = B.body[0];
          return B.parent = r, K.parent = B, a = a.filter((F) => !l.includes(F)), A.body = a, a.length ? (A.parent = K, K.body.push(A)) : B.body.pop(), l.forEach((F) => {
            const Q = GA({ body: [F] });
            F.parent = Q, Q.parent = B, B.body.push(Q);
          }), e(B);
        }
      }
      o.inCharClass = !0;
      const i = g();
      return o.inCharClass = !1, i;
    }
    const s = a[0];
    if (
      // Already established that the parent is a char class via `inCharClass`; don't check again
      t === "union" && !n && s && // Allows many nested classes to work with `target` ES2018 which doesn't support nesting
      ((!o.useFlagV || !o.verbose) && r.kind === "union" && !(mA.bugFlagVLiteralHyphenIsRange && o.useFlagV) || !o.verbose && r.kind === "intersection" && // JS doesn't allow intersection with union or ranges
      a.length === 1 && s.type !== "CharacterClassRange")
    )
      return a.map(e).join("");
    if (!o.useFlagV && r.type === "CharacterClass")
      throw new Error("Use of nested character class requires min target ES2024");
    return g();
  },
  /**
  @param {CharacterClassRangeNode} node
  */
  CharacterClassRange(A, o) {
    const e = A.min.value, t = A.max.value, n = {
      escDigit: !1,
      inCharClass: !0,
      useFlagV: o.useFlagV
    }, r = EA(e, n), a = EA(t, n), g = /* @__PURE__ */ new Set();
    if (o.useAppliedIgnoreCase && o.currentFlags.ignoreCase) {
      const s = eg(A);
      _Q(s).forEach((l) => {
        g.add(
          Array.isArray(l) ? `${EA(l[0], n)}-${EA(l[1], n)}` : EA(l, n)
        );
      });
    }
    return `${r}-${a}${[...g].join("")}`;
  },
  /**
  @param {CharacterSetNode} node
  */
  CharacterSet({ kind: A, negate: o, value: e, key: t }, n) {
    if (A === "dot")
      return n.currentFlags.dotAll ? n.appliedGlobalFlags.dotAll || n.useFlagMods ? "." : "[^]" : (
        // Onig's only line break char is line feed, unlike JS
        b`[^\n]`
      );
    if (A === "digit")
      return o ? b`\D` : b`\d`;
    if (A === "property") {
      if (n.useAppliedIgnoreCase && n.currentFlags.ignoreCase && Ja.has(e))
        throw new Error(`Unicode property "${e}" can't be case-insensitive when other chars have specific case`);
      return `${o ? b`\P` : b`\p`}{${t ? `${t}=` : ""}${e}}`;
    }
    if (A === "word")
      return o ? b`\W` : b`\w`;
    throw new Error(`Unexpected character set kind "${A}"`);
  },
  /**
  @param {FlagsNode} node
  */
  Flags(A, o) {
    return (
      // The transformer should never turn on the properties for flags d, g, m since Onig doesn't
      // have equivs. Flag m is never used since Onig uses different line break chars than JS
      // (node.hasIndices ? 'd' : '') +
      // (node.global ? 'g' : '') +
      // (node.multiline ? 'm' : '') +
      (o.appliedGlobalFlags.ignoreCase ? "i" : "") + (A.dotAll ? "s" : "") + (A.sticky ? "y" : "")
    );
  },
  /**
  @param {GroupNode} node
  */
  Group({ atomic: A, body: o, flags: e, parent: t }, n, r) {
    const a = n.currentFlags;
    e && (n.currentFlags = Be(a, e));
    const g = o.map(r).join("|"), s = !n.verbose && o.length === 1 && // Single alt
    t.type !== "Quantifier" && !A && (!n.useFlagMods || !e) ? g : `(?${$Q(A, e, n.useFlagMods)}${g})`;
    return n.currentFlags = a, s;
  },
  /**
  @param {LookaroundAssertionNode} node
  */
  LookaroundAssertion({ body: A, kind: o, negate: e }, t, n) {
    return `(?${`${o === "lookahead" ? "" : "<"}${e ? "!" : "="}`}${A.map(n).join("|")})`;
  },
  /**
  @param {QuantifierNode} node
  */
  Quantifier(A, o, e) {
    return e(A.body) + AF(A);
  },
  /**
  @param {SubroutineNode & {isRecursive: true}} node
  */
  Subroutine({ isRecursive: A, ref: o }, e) {
    if (!A)
      throw new Error("Unexpected non-recursive subroutine in transformed AST");
    const t = e.recursionLimit;
    return o === 0 ? `(?R=${t})` : b`\g<${o}&R=${t}>`;
  }
}, qQ = /* @__PURE__ */ new Set([
  "$",
  "(",
  ")",
  "*",
  "+",
  ".",
  "?",
  "[",
  "\\",
  "]",
  "^",
  "{",
  "|",
  "}"
]), JQ = /* @__PURE__ */ new Set([
  "-",
  "\\",
  "]",
  "^",
  // Literal `[` doesn't require escaping with flag u, but this can help work around regex source
  // linters and regex syntax processors that expect unescaped `[` to create a nested class
  "["
]), ZQ = /* @__PURE__ */ new Set([
  "(",
  ")",
  "-",
  "/",
  "[",
  "\\",
  "]",
  "^",
  "{",
  "|",
  "}",
  // Double punctuators; also includes already-listed `-` and `^`
  "!",
  "#",
  "$",
  "%",
  "&",
  "*",
  "+",
  ",",
  ".",
  ":",
  ";",
  "<",
  "=",
  ">",
  "?",
  "@",
  "`",
  "~"
]), tr = /* @__PURE__ */ new Map([
  [9, b`\t`],
  // horizontal tab
  [10, b`\n`],
  // line feed
  [11, b`\v`],
  // vertical tab
  [12, b`\f`],
  // form feed
  [13, b`\r`],
  // carriage return
  [8232, b`\u2028`],
  // line separator
  [8233, b`\u2029`],
  // paragraph separator
  [65279, b`\uFEFF`]
  // ZWNBSP/BOM
]), YQ = new RegExp("^\\p{Cased}$", "u");
function gn(A) {
  return YQ.test(A);
}
function eg(A, o) {
  const e = !!(o != null && o.firstOnly), t = A.min.value, n = A.max.value, r = [];
  if (t < 65 && (n === 65535 || n >= 131071) || t === 65536 && n >= 131071)
    return r;
  for (let a = t; a <= n; a++) {
    const g = z(a);
    if (!gn(g))
      continue;
    const s = qa(g).filter((i) => {
      const l = i.codePointAt(0);
      return l < t || l > n;
    });
    if (s.length && (r.push(...s), e))
      break;
  }
  return r;
}
function EA(A, { escDigit: o, inCharClass: e, useFlagV: t }) {
  if (tr.has(A))
    return tr.get(A);
  if (
    // Control chars, etc.; condition modeled on the Chrome developer console's display for strings
    A < 32 || A > 126 && A < 160 || // Unicode planes 4-16; unassigned, special purpose, and private use area
    A > 262143 || // Avoid corrupting a preceding backref by immediately following it with a literal digit
    o && oF(A)
  )
    return A > 255 ? `\\u{${A.toString(16).toUpperCase()}}` : `\\x${A.toString(16).toUpperCase().padStart(2, "0")}`;
  const n = e ? t ? ZQ : JQ : qQ, r = z(A);
  return (n.has(r) ? "\\" : "") + r;
}
function _Q(A) {
  const o = A.map((n) => n.codePointAt(0)).sort((n, r) => n - r), e = [];
  let t = null;
  for (let n = 0; n < o.length; n++)
    o[n + 1] === o[n] + 1 ? t ?? (t = o[n]) : t === null ? e.push(o[n]) : (e.push([t, o[n]]), t = null);
  return e;
}
function $Q(A, o, e) {
  if (A)
    return ">";
  let t = "";
  if (o && e) {
    const { enable: n, disable: r } = o;
    t = (n != null && n.ignoreCase ? "i" : "") + (n != null && n.dotAll ? "s" : "") + (r ? "-" : "") + (r != null && r.ignoreCase ? "i" : "") + (r != null && r.dotAll ? "s" : "");
  }
  return `${t}:`;
}
function AF({ kind: A, max: o, min: e }) {
  let t;
  return !e && o === 1 ? t = "?" : !e && o === 1 / 0 ? t = "*" : e === 1 && o === 1 / 0 ? t = "+" : e === o ? t = `{${e}}` : t = `{${e},${o === 1 / 0 ? "" : o}}`, t + {
    greedy: "",
    lazy: "?",
    possessive: "+"
  }[A];
}
function nr({ type: A }) {
  return A === "CapturingGroup" || A === "Group" || A === "LookaroundAssertion";
}
function oF(A) {
  return A > 47 && A < 58;
}
function rr({ type: A, value: o }) {
  return A === "Character" && o === 45;
}
var HA, dA, XA, DA, zA, wo, vt, xA, eF = (xA = class extends RegExp {
  /**
  @overload
  @param {string} pattern
  @param {string} [flags]
  @param {EmulatedRegExpOptions} [options]
  */
  /**
  @overload
  @param {EmulatedRegExp} pattern
  @param {string} [flags]
  */
  constructor(e, t, n) {
    var o = (...GU) => (super(...GU), SA(this, wo), /**
    @type {Map<number, {
      hidden?: true;
      transferTo?: number;
    }>}
    */
    SA(this, HA, /* @__PURE__ */ new Map()), /**
    @type {RegExp | EmulatedRegExp | null}
    */
    SA(this, dA, null), /**
    @type {string}
    */
    SA(this, XA), /**
    @type {Map<number, string>?}
    */
    SA(this, DA, null), /**
    @type {string?}
    */
    SA(this, zA, null), /**
    Can be used to serialize the instance.
    @type {EmulatedRegExpOptions}
    */
    p(this, "rawOptions", {}), this);
    const r = !!(n != null && n.lazyCompile);
    if (e instanceof RegExp) {
      if (n)
        throw new Error("Cannot provide options when copying a regexp");
      const a = e;
      o(a, t), iA(this, XA, a.source), a instanceof xA && (iA(this, HA, q(a, HA)), iA(this, DA, q(a, DA)), iA(this, zA, q(a, zA)), this.rawOptions = a.rawOptions);
    } else {
      const a = {
        hiddenCaptures: [],
        strategy: null,
        transfers: [],
        ...n
      };
      o(r ? "" : e, t), iA(this, XA, e), iA(this, HA, nF(a.hiddenCaptures, a.transfers)), iA(this, zA, a.strategy), this.rawOptions = n ?? {};
    }
    r || iA(this, dA, this);
  }
  // Override the getter with one that works with lazy-compiled regexes
  get source() {
    return q(this, XA) || "(?:)";
  }
  /**
  Called internally by all String/RegExp methods that use regexes.
  @override
  @param {string} str
  @returns {RegExpExecArray?}
  */
  exec(e) {
    if (!q(this, dA)) {
      const { lazyCompile: r, ...a } = this.rawOptions;
      iA(this, dA, new xA(q(this, XA), this.flags, a));
    }
    const t = this.global || this.sticky, n = this.lastIndex;
    if (q(this, zA) === "clip_search" && t && n) {
      this.lastIndex = 0;
      const r = we(this, wo, vt).call(this, e.slice(n));
      return r && (tF(r, n, e, this.hasIndices), this.lastIndex += n), r;
    }
    return we(this, wo, vt).call(this, e);
  }
}, HA = new WeakMap(), dA = new WeakMap(), XA = new WeakMap(), DA = new WeakMap(), zA = new WeakMap(), wo = new WeakSet(), /**
Adds support for hidden and transfer captures.
@param {string} str
@returns
*/
vt = function(e) {
  q(this, dA).lastIndex = this.lastIndex;
  const t = ln(xA.prototype, this, "exec").call(q(this, dA), e);
  if (this.lastIndex = q(this, dA).lastIndex, !t || !q(this, HA).size)
    return t;
  const n = [...t];
  t.length = 1;
  let r;
  this.hasIndices && (r = [...t.indices], t.indices.length = 1);
  const a = [0];
  for (let g = 1; g < n.length; g++) {
    const { hidden: s, transferTo: i } = q(this, HA).get(g) ?? {};
    if (s ? a.push(null) : (a.push(t.length), t.push(n[g]), this.hasIndices && t.indices.push(r[g])), i && n[g] !== void 0) {
      const l = a[i];
      if (!l)
        throw new Error(`Invalid capture transfer to "${l}"`);
      if (t[l] = n[g], this.hasIndices && (t.indices[l] = r[g]), t.groups) {
        q(this, DA) || iA(this, DA, rF(this.source));
        const B = q(this, DA).get(i);
        B && (t.groups[B] = n[g], this.hasIndices && (t.indices.groups[B] = r[g]));
      }
    }
  }
  return t;
}, xA);
function tF(A, o, e, t) {
  if (A.index += o, A.input = e, t) {
    const n = A.indices;
    for (let a = 0; a < n.length; a++) {
      const g = n[a];
      g && (n[a] = [g[0] + o, g[1] + o]);
    }
    const r = n.groups;
    r && Object.keys(r).forEach((a) => {
      const g = r[a];
      g && (r[a] = [g[0] + o, g[1] + o]);
    });
  }
}
function nF(A, o) {
  const e = /* @__PURE__ */ new Map();
  for (const t of A)
    e.set(t, {
      hidden: !0
    });
  for (const [t, n] of o)
    for (const r of n)
      vo(e, r, {}).transferTo = t;
  return e;
}
function rF(A) {
  const o = /(?<capture>\((?:\?<(?![=!])(?<name>[^>]+)>|(?!\?)))|\\?./gsu, e = /* @__PURE__ */ new Map();
  let t = 0, n = 0, r;
  for (; r = o.exec(A); ) {
    const { 0: a, groups: { capture: g, name: s } } = r;
    a === "[" ? t++ : t ? a === "]" && t-- : g && (n++, s && e.set(n, s));
  }
  return e;
}
function aF(A, o) {
  const e = gF(A, o);
  return e.options ? new eF(e.pattern, e.flags, e.options) : new RegExp(e.pattern, e.flags);
}
function gF(A, o) {
  const e = Ea(o), t = Oa(A, {
    flags: e.flags,
    normalizeUnknownPropertyNames: !0,
    rules: {
      captureGroup: e.rules.captureGroup,
      singleline: e.rules.singleline
    },
    skipBackrefValidation: e.rules.allowOrphanBackrefs,
    unicodePropertyMap: an
  }), n = kQ(t, {
    accuracy: e.accuracy,
    asciiWordBoundaries: e.rules.asciiWordBoundaries,
    avoidSubclass: e.avoidSubclass,
    bestEffortTarget: e.target
  }), r = VQ(n, e), a = mQ(r.pattern, {
    captureTransfers: r._captureTransfers,
    hiddenCaptures: r._hiddenCaptures,
    mode: "external"
  }), g = pQ(a.pattern), s = dQ(g.pattern, {
    captureTransfers: a.captureTransfers,
    hiddenCaptures: a.hiddenCaptures
  }), i = {
    pattern: s.pattern,
    flags: `${e.hasIndices ? "d" : ""}${e.global ? "g" : ""}${r.flags}${r.options.disable.v ? "u" : "v"}`
  };
  if (e.avoidSubclass) {
    if (e.lazyCompileLength !== 1 / 0)
      throw new Error("Lazy compilation requires subclass");
  } else {
    const l = s.hiddenCaptures.sort((Q, f) => Q - f), B = Array.from(s.captureTransfers), K = n._strategy, F = i.pattern.length >= e.lazyCompileLength;
    (l.length || B.length || K || F) && (i.options = {
      ...l.length && { hiddenCaptures: l },
      ...B.length && { transfers: B },
      ...K && { strategy: K },
      ...F && { lazyCompile: F }
    });
  }
  return i;
}
const ar = 4294967295;
class sF {
  constructor(o, e = {}) {
    p(this, "regexps");
    this.patterns = o, this.options = e;
    const {
      forgiving: t = !1,
      cache: n,
      regexConstructor: r
    } = e;
    if (!r)
      throw new Error("Option `regexConstructor` is not provided");
    this.regexps = o.map((a) => {
      if (typeof a != "string")
        return a;
      const g = n == null ? void 0 : n.get(a);
      if (g) {
        if (g instanceof RegExp)
          return g;
        if (t)
          return null;
        throw g;
      }
      try {
        const s = r(a);
        return n == null || n.set(a, s), s;
      } catch (s) {
        if (n == null || n.set(a, s), t)
          return null;
        throw s;
      }
    });
  }
  findNextMatchSync(o, e, t) {
    const n = typeof o == "string" ? o : o.content, r = [];
    function a(g, s, i = 0) {
      return {
        index: g,
        captureIndices: s.indices.map((l) => l == null ? {
          start: ar,
          end: ar,
          length: 0
        } : {
          start: l[0] + i,
          end: l[1] + i,
          length: l[1] - l[0]
        })
      };
    }
    for (let g = 0; g < this.regexps.length; g++) {
      const s = this.regexps[g];
      if (s)
        try {
          s.lastIndex = e;
          const i = s.exec(n);
          if (!i)
            continue;
          if (i.index === e)
            return a(g, i, 0);
          r.push([g, i, 0]);
        } catch (i) {
          if (this.options.forgiving)
            continue;
          throw i;
        }
    }
    if (r.length) {
      const g = Math.min(...r.map((s) => s[1].index));
      for (const [s, i, l] of r)
        if (i.index === g)
          return a(s, i, l);
    }
    return null;
  }
}
function iF(A, o) {
  return aF(
    A,
    {
      global: !0,
      hasIndices: !0,
      // This has no benefit for the standard JS engine, but it avoids a perf penalty for
      // precompiled grammars when constructing extremely long patterns that aren't always used
      lazyCompileLength: 3e3,
      rules: {
        // Needed since TextMate grammars merge backrefs across patterns
        allowOrphanBackrefs: !0,
        // Improves search performance for generated regexes
        asciiWordBoundaries: !0,
        // Follow `vscode-oniguruma` which enables this Oniguruma option by default
        captureGroup: !0,
        // Oniguruma uses depth limit `20`; lowered here to keep regexes shorter and maybe
        // sometimes faster, but can be increased if issues reported due to low limit
        recursionLimit: 5,
        // Oniguruma option for `^`->`\A`, `$`->`\Z`; improves search performance without any
        // change in meaning since TM grammars search line by line
        singleline: !0
      },
      ...o
    }
  );
}
function CF(A = {}) {
  const o = Object.assign(
    {
      target: "auto",
      cache: /* @__PURE__ */ new Map()
    },
    A
  );
  return o.regexConstructor || (o.regexConstructor = (e) => iF(e, { target: o.target })), {
    createScanner(e) {
      return new sF(e, o);
    },
    createString(e) {
      return {
        content: e
      };
    }
  };
}
const lF = {
  c: () => import("./c-BkjqYDIA.js"),
  cpp: () => import("./cpp-DhkDdXl7.js"),
  "c++": () => import("./cpp-DhkDdXl7.js"),
  css: () => import("./css-BZ0NWh5u.js"),
  glsl: () => import("./glsl-DX0pARhD.js"),
  graphql: () => import("./graphql-B3ta1skT.js"),
  gql: () => import("./graphql-B3ta1skT.js"),
  haml: () => import("./haml-BEAcHK4k.js"),
  html: () => import("./html-CqQN50-r.js"),
  java: () => import("./java-D3rxiTXw.js"),
  javascript: () => import("./javascript-CZRb038s.js"),
  js: () => import("./javascript-CZRb038s.js"),
  json: () => import("./json-Bkan_A9h.js"),
  jsonc: () => import("./jsonc-ysMisuyf.js"),
  jsonl: () => import("./jsonl-C5xsMxOr.js"),
  jsx: () => import("./jsx-DsPQhrM1.js"),
  julia: () => import("./julia-DWQmJB_Y.js"),
  jl: () => import("./julia-DWQmJB_Y.js"),
  less: () => import("./less-DnsPw-NF.js"),
  markdown: () => import("./markdown-CGybACDn.js"),
  md: () => import("./markdown-CGybACDn.js"),
  mdx: () => import("./mdx-DidMLz69.js"),
  php: () => import("./php-C2fPWhT2.js"),
  postcss: () => import("./postcss-DRy5uOsM.js"),
  pug: () => import("./pug-tczQStJU.js"),
  jade: () => import("./pug-tczQStJU.js"),
  python: () => import("./python-97QpKFSt.js"),
  py: () => import("./python-97QpKFSt.js"),
  r: () => import("./r-DWL_aQba.js"),
  regexp: () => import("./regexp-By9I3jVH.js"),
  regex: () => import("./regexp-By9I3jVH.js"),
  sass: () => import("./sass-CslcaSVV.js"),
  scss: () => import("./scss-BLueZLTu.js"),
  shellscript: () => import("./shellscript-Cer8gxCb.js"),
  bash: () => import("./shellscript-Cer8gxCb.js"),
  sh: () => import("./shellscript-Cer8gxCb.js"),
  shell: () => import("./shellscript-Cer8gxCb.js"),
  zsh: () => import("./shellscript-Cer8gxCb.js"),
  sql: () => import("./sql-D1S-PQRA.js"),
  svelte: () => import("./svelte-vk8rcM_Y.js"),
  typescript: () => import("./typescript-CDs19vEa.js"),
  ts: () => import("./typescript-CDs19vEa.js"),
  vue: () => import("./vue-CPzrb0_L.js"),
  "vue-html": () => import("./vue-html-C3TvJyez.js"),
  wasm: () => import("./wasm-XIZoHBut.js"),
  wgsl: () => import("./wgsl-BOV6MXyj.js"),
  xml: () => import("./xml-DCqxYLdL.js"),
  yaml: () => import("./yaml-D0bpJvgo.js"),
  yml: () => import("./yaml-D0bpJvgo.js"),
  tsx: () => import("./tsx-BBWOc1Wb.js"),
  typescriptreact: () => import("./tsx-BBWOc1Wb.js"),
  haskell: () => import("./haskell-D5y4NsBf.js"),
  hs: () => import("./haskell-D5y4NsBf.js"),
  "c#": () => import("./csharp-CQ3SYdzM.js"),
  csharp: () => import("./csharp-CQ3SYdzM.js"),
  cs: () => import("./csharp-CQ3SYdzM.js"),
  latex: () => import("./latex-hxfObxWP.js"),
  lua: () => import("./lua-BklVY0Uq.js"),
  mermaid: () => import("./mermaid-978rjTc2.js"),
  mmd: () => import("./mermaid-978rjTc2.js"),
  ruby: () => import("./ruby-BJ1BzQPX.js"),
  rb: () => import("./ruby-BJ1BzQPX.js"),
  rust: () => import("./rust-JKsadDnp.js"),
  rs: () => import("./rust-JKsadDnp.js"),
  scala: () => import("./scala-zXcxSf6M.js"),
  // Swift does not support pre-compilation right now
  swift: () => import("./swift-Cu-y7Uk9.js"),
  kotlin: () => import("./kotlin-BbCcfkLQ.js"),
  kt: () => import("./kotlin-BbCcfkLQ.js"),
  kts: () => import("./kotlin-BbCcfkLQ.js"),
  "objective-c": () => import("./objective-c-BaBJjT9u.js"),
  objc: () => import("./objective-c-BaBJjT9u.js")
}, BF = {
  "github-dark": () => import("./github-dark-DenFmJkN.js"),
  "github-light": () => import("./github-light-JYsPkUQd.js")
}, KF = /* @__PURE__ */ PK({
  langs: lF,
  themes: BF,
  engine: () => CF()
}), QF = {
  defaultLanguage: "javascript",
  supportedLanguages: {
    text: {
      name: "Plain Text",
      aliases: ["text", "txt", "plain"]
    },
    c: {
      name: "C",
      aliases: ["c"]
    },
    cpp: {
      name: "C++",
      aliases: ["cpp", "c++"]
    },
    css: {
      name: "CSS",
      aliases: ["css"]
    },
    glsl: {
      name: "GLSL",
      aliases: ["glsl"]
    },
    graphql: {
      name: "GraphQL",
      aliases: ["graphql", "gql"]
    },
    haml: {
      name: "Ruby Haml",
      aliases: ["haml"]
    },
    html: {
      name: "HTML",
      aliases: ["html"]
    },
    java: {
      name: "Java",
      aliases: ["java"]
    },
    javascript: {
      name: "JavaScript",
      aliases: ["javascript", "js"]
    },
    json: {
      name: "JSON",
      aliases: ["json"]
    },
    jsonc: {
      name: "JSON with Comments",
      aliases: ["jsonc"]
    },
    jsonl: {
      name: "JSON Lines",
      aliases: ["jsonl"]
    },
    jsx: {
      name: "JSX",
      aliases: ["jsx"]
    },
    julia: {
      name: "Julia",
      aliases: ["julia", "jl"]
    },
    less: {
      name: "Less",
      aliases: ["less"]
    },
    markdown: {
      name: "Markdown",
      aliases: ["markdown", "md"]
    },
    mdx: {
      name: "MDX",
      aliases: ["mdx"]
    },
    php: {
      name: "PHP",
      aliases: ["php"]
    },
    postcss: {
      name: "PostCSS",
      aliases: ["postcss"]
    },
    pug: {
      name: "Pug",
      aliases: ["pug", "jade"]
    },
    python: {
      name: "Python",
      aliases: ["python", "py"]
    },
    r: {
      name: "R",
      aliases: ["r"]
    },
    regexp: {
      name: "RegExp",
      aliases: ["regexp", "regex"]
    },
    sass: {
      name: "Sass",
      aliases: ["sass"]
    },
    scss: {
      name: "SCSS",
      aliases: ["scss"]
    },
    shellscript: {
      name: "Shell",
      aliases: ["shellscript", "bash", "sh", "shell", "zsh"]
    },
    sql: {
      name: "SQL",
      aliases: ["sql"]
    },
    svelte: {
      name: "Svelte",
      aliases: ["svelte"]
    },
    typescript: {
      name: "TypeScript",
      aliases: ["typescript", "ts"]
    },
    vue: {
      name: "Vue",
      aliases: ["vue"]
    },
    "vue-html": {
      name: "Vue HTML",
      aliases: ["vue-html"]
    },
    wasm: {
      name: "WebAssembly",
      aliases: ["wasm"]
    },
    wgsl: {
      name: "WGSL",
      aliases: ["wgsl"]
    },
    xml: {
      name: "XML",
      aliases: ["xml"]
    },
    yaml: {
      name: "YAML",
      aliases: ["yaml", "yml"]
    },
    tsx: {
      name: "TSX",
      aliases: ["tsx", "typescriptreact"]
    },
    haskell: {
      name: "Haskell",
      aliases: ["haskell", "hs"]
    },
    csharp: {
      name: "C#",
      aliases: ["c#", "csharp", "cs"]
    },
    latex: {
      name: "LaTeX",
      aliases: ["latex"]
    },
    lua: {
      name: "Lua",
      aliases: ["lua"]
    },
    mermaid: {
      name: "Mermaid",
      aliases: ["mermaid", "mmd"]
    },
    ruby: {
      name: "Ruby",
      aliases: ["ruby", "rb"]
    },
    rust: {
      name: "Rust",
      aliases: ["rust", "rs"]
    },
    scala: {
      name: "Scala",
      aliases: ["scala"]
    },
    swift: {
      name: "Swift",
      aliases: ["swift"]
    },
    kotlin: {
      name: "Kotlin",
      aliases: ["kotlin", "kt", "kts"]
    },
    "objective-c": {
      name: "Objective C",
      aliases: ["objective-c", "objc"]
    }
  },
  createHighlighter: () => KF({
    themes: ["github-dark", "github-light"],
    langs: []
  })
}, FF = zg.create({
  blockSpecs: {
    ...Ig,
    // Adds all default blocks.
    alert: uC,
    customHTML: mC,
    bunnyVideo: bC,
    // numberedListItem: undefined as any, // undefined = 禁用選單
    checkListItem: void 0,
    // 樣式有問題，禁用
    // file: undefined as any, // 用媒體庫就好，禁用
    video: void 0,
    // 用媒體庫就好，禁用
    audio: void 0,
    // 用媒體庫就好，禁用
    image: void 0,
    // 用媒體庫就好，禁用
    mediaLibrary: RC
  }
}), cF = [], fF = [
  "heading",
  "heading_2",
  "heading_3",
  "paragraph",
  "quote",
  "numbered_list",
  "bullet_list",
  "code_block",
  "mediaLibrary",
  "file",
  "image",
  "alert",
  "table",
  "customHTML",
  "bunnyVideo",
  "bunnyAudio"
], tg = (A) => {
  const o = A == null ? void 0 : A.options, e = (A == null ? void 0 : A.deps) || [], { mutate: t, mutateAsync: n } = eo(), r = jA(), a = Hg(
    {
      codeBlock: QF,
      schema: FF,
      pasteHandler: ({ event: l, editor: B, defaultPasteHandler: K }) => {
        var F, Q, f, c;
        try {
          if ((((Q = (F = l == null ? void 0 : l.clipboardData) == null ? void 0 : F.files) == null ? void 0 : Q.length) || 0) > 0) {
            const U = (c = (f = l == null ? void 0 : l.clipboardData) == null ? void 0 : f.files) == null ? void 0 : c[0], u = UF(
              l,
              B
            );
            if (!u)
              throw new Error("插入區塊失敗，找不到 insertedBlockId");
            return t(
              {
                url: `${r}/upload`,
                method: "post",
                values: {
                  files: [U]
                },
                config: {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }
              },
              {
                onSuccess: (d) => {
                  var y, w;
                  const P = (w = (y = d == null ? void 0 : d.data) == null ? void 0 : y.data) == null ? void 0 : w[0];
                  if (!P)
                    throw new Error("上傳成功但找不到檔案!?");
                  const v = $o(P == null ? void 0 : P.url);
                  B.updateBlock(u, {
                    type: "mediaLibrary",
                    props: {
                      widthValue: v === "image" ? P.width : void 0,
                      widthUnit: v === "image" ? "px" : void 0,
                      align: "start",
                      url: P.url,
                      alt: P.name,
                      title: P.name,
                      fileType: v
                    }
                  });
                },
                onError: (d) => {
                  B.updateBlock(u, {
                    type: "paragraph",
                    props: {
                      textColor: "default",
                      textAlignment: "left"
                    },
                    content: [
                      {
                        type: "text",
                        text: "",
                        styles: {}
                      }
                    ]
                  }), console.log("❌ 上傳失敗", u, d);
                }
              }
            ), !0;
          }
          return K();
        } catch (U) {
          return console.error("❌ 貼上操作失敗", U), K();
        }
      },
      uploadFile: async (l, B) => {
        var K, F;
        try {
          const Q = await n({
            url: `${r}/upload`,
            method: "post",
            values: {
              files: [l]
            },
            config: {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          }), f = (F = (K = Q == null ? void 0 : Q.data) == null ? void 0 : K.data) == null ? void 0 : F[0], c = $o(f == null ? void 0 : f.url);
          return {
            type: "mediaLibrary",
            props: {
              widthValue: c === "image" ? f.width : void 0,
              widthUnit: c === "image" ? "px" : void 0,
              align: "start",
              url: f.url,
              alt: f.name,
              title: f.name,
              fileType: c
            }
          };
        } catch (Q) {
          a.updateBlock(B, {
            type: "paragraph",
            props: {
              textColor: "default",
              textAlignment: "left"
            },
            content: [
              {
                type: "text",
                text: "",
                styles: {}
              }
            ]
          }), console.log("❌ 上傳失敗", B, Q);
        }
      },
      ...o
    },
    e
  ), [g, s] = L([]);
  return {
    blockNoteViewProps: {
      editor: a,
      onChange: xt(async (l) => {
        s(l == null ? void 0 : l.document);
      }, 700),
      theme: "light",
      formattingToolbar: !1,
      // 自訂 toolbar
      linkToolbar: !0,
      sideMenu: !0,
      slashMenu: !1,
      // 自訂選單
      emojiPicker: !0,
      // 啟用 Emoji
      filePanel: !0,
      tableHandles: !0,
      children: /* @__PURE__ */ h(k, { children: [
        /* @__PURE__ */ C(
          Dg,
          {
            triggerCharacter: "/",
            getItems: async (l) => {
              const F = [
                ...Ng(
                  a
                ).filter(
                  ({ key: Q }) => !cF.includes(Q)
                  // 隱藏指定選單
                ),
                fC(a),
                hC(a),
                yC(a),
                SC(a)
              ].sort((Q, f) => {
                const c = (u) => {
                  const d = fF.indexOf(u);
                  return d === -1 ? 1 / 0 : d;
                }, U = c(Q.key) - c(f.key);
                return isNaN(U) ? Q.key.localeCompare(f.key) : U;
              }).filter((Q) => Q.key !== "file");
              return Wg(
                // eslint-disable-next-line lines-around-comment
                // Gets all default slash menu items and `insertAlert` item.
                F,
                l
              );
            }
          }
        ),
        /* @__PURE__ */ C(
          xg,
          {
            formattingToolbar: () => /* @__PURE__ */ h(jg, { children: [
              /* @__PURE__ */ C(kg, {}, "blockTypeSelect"),
              /* @__PURE__ */ C(Sg, {}, "fileCaptionButton"),
              /* @__PURE__ */ C(Rg, {}, "replaceFileButton"),
              /* @__PURE__ */ C(
                so,
                {
                  basicTextStyle: "bold"
                },
                "boldStyleButton"
              ),
              /* @__PURE__ */ C(
                so,
                {
                  basicTextStyle: "italic"
                },
                "italicStyleButton"
              ),
              /* @__PURE__ */ C(
                so,
                {
                  basicTextStyle: "underline"
                },
                "underlineStyleButton"
              ),
              /* @__PURE__ */ C(
                so,
                {
                  basicTextStyle: "strike"
                },
                "strikeStyleButton"
              ),
              /* @__PURE__ */ C(
                so,
                {
                  basicTextStyle: "code"
                },
                "codeStyleButton"
              ),
              /* @__PURE__ */ C(
                ye,
                {
                  textAlignment: "left"
                },
                "textAlignLeftButton"
              ),
              /* @__PURE__ */ C(
                ye,
                {
                  textAlignment: "center"
                },
                "textAlignCenterButton"
              ),
              /* @__PURE__ */ C(
                ye,
                {
                  textAlignment: "right"
                },
                "textAlignRightButton"
              ),
              /* @__PURE__ */ C(Lg, {}, "colorStyleButton"),
              /* @__PURE__ */ C(Tg, {}, "nestBlockButton"),
              /* @__PURE__ */ C(Og, {}, "unnestBlockButton"),
              /* @__PURE__ */ C(Xg, {}, "createLinkButton")
            ] })
          }
        )
      ] })
    },
    blocks: g,
    setBlocks: s
  };
};
function UF(A, o) {
  var n;
  const e = {
    type: "paragraph",
    content: [
      {
        type: "text",
        text: "Loading...",
        styles: {}
      }
    ],
    props: {}
  };
  let t;
  if (A.type === "paste") {
    const r = o.getTextCursorPosition().block;
    t = gr(o, r, e);
  } else if (A.type === "drop") {
    const r = {
      left: A.clientX,
      top: A.clientY
    }, a = (n = o.prosemirrorView) == null ? void 0 : n.posAtCoords(r);
    return a ? (t = o.transact((g) => {
      const s = Gg(g.doc, a.pos);
      return gr(
        o,
        o.getBlock(s.node.attrs.id),
        e
      );
    }), t) : void 0;
  } else
    return;
  return t;
}
function gr(A, o, e) {
  let t;
  return Array.isArray(o.content) && o.content.length === 0 ? t = A.updateBlock(o, e).id : t = A.insertBlocks(
    [e],
    o,
    "after"
  )[0].id, t;
}
const ng = (A) => /* @__PURE__ */ C(bg, { ...A }), { Item: Ie } = j, uF = ({
  name: A = ["description"],
  resource: o = "posts",
  dataProviderName: e = "default",
  editorFormItemProps: t,
  buttonProps: n,
  initialEditor: r,
  parseData: a = (g) => g
}) => {
  const { SITE_URL: g, ELEMENTOR_ENABLED: s } = bo(), i = j.useFormInstance(), { mutate: l, isLoading: B } = wt({
    resource: o,
    dataProviderName: e,
    ...Do
  }), K = j.useWatch(["id"], i) || 0, F = j.useWatch(["editor"], i) || "power-editor", Q = r === void 0 ? !1 : r !== F, { blockNoteViewProps: f } = tg(), { editor: c } = f, { drawerProps: U, show: u, close: d } = jr(), P = U.opacity === 1, v = async () => {
    const N = pF(A), gA = await Pr(c), sA = i.getFieldsValue(), cA = a({
      ...sA,
      [N]: gA
    });
    l(
      {
        id: K,
        values: cA
      },
      {
        onSuccess: () => {
          d();
        }
      }
    );
  };
  $(() => {
    try {
      if (K && P && c) {
        const N = i.getFieldValue(A), gA = typeof N == "string" ? N : "";
        async function sA() {
          const cA = await c.tryParseHTMLToBlocks(gA);
          c.replaceBlocks(c.document, cA);
        }
        sA();
      }
      !K && P && c && c.removeBlocks(c.document);
    } catch (N) {
      console.error(N);
    }
  }, [K, P, c]), $(() => {
    i.setFieldValue(
      ["_elementor_edit_mode"],
      F === "elementor" ? "builder" : ""
    );
  }, [F]);
  const [y, w] = L(!1);
  return /* @__PURE__ */ h(k, { children: [
    /* @__PURE__ */ h("div", { className: "at-max-w-[24rem]", children: [
      /* @__PURE__ */ C("div", { className: "at-min-h-[4.5rem]", children: /* @__PURE__ */ C(
        Ie,
        {
          name: ["editor"],
          label: "編輯內容",
          tooltip: dF(s),
          ...t,
          children: /* @__PURE__ */ C(
            yt.Group,
            {
              block: !0,
              options: [
                {
                  label: "Power 編輯器",
                  value: "power-editor"
                },
                {
                  label: "Elementor 編輯器",
                  value: "elementor",
                  disabled: !s
                }
              ],
              optionType: "button",
              buttonStyle: "solid"
            }
          )
        }
      ) }),
      /* @__PURE__ */ C(
        D,
        {
          disabled: Q,
          className: "at-w-full",
          icon: /* @__PURE__ */ C(Ho, {}),
          iconPosition: "end",
          onClick: () => {
            if (F === "power-editor") {
              u();
              return;
            }
            F === "elementor" && window.open(
              `${g}/wp-admin/post.php?post=${K}&action=elementor`,
              "_blank"
            );
          },
          color: "primary",
          variant: "filled",
          ...n,
          children: "開始編輯"
        }
      ),
      /* @__PURE__ */ h(
        "p",
        {
          className: Z(
            "at-text-red-500 at-text-sm at-my-2",
            Q ? "at-opacity-100" : "at-opacity-0"
          ),
          children: [
            /* @__PURE__ */ C(Wt, {}),
            " 切換編輯器後請務必先儲存再開始編輯"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ C(Ie, { name: A, label: "完整介紹", hidden: !0 }),
    /* @__PURE__ */ C(Ie, { name: ["_elementor_edit_mode"], hidden: !0 }),
    /* @__PURE__ */ h(
      yr,
      {
        ...U,
        closeConfirm: !0,
        title: "編輯內容",
        footer: /* @__PURE__ */ h("div", { className: "at-flex at-gap-x-4", children: [
          /* @__PURE__ */ C(
            D,
            {
              type: "default",
              onClick: () => {
                w((N) => !N);
              },
              children: y ? "退出全螢幕編輯" : "全螢幕編輯"
            }
          ),
          /* @__PURE__ */ C(
            D,
            {
              type: "default",
              danger: !0,
              onClick: () => {
                c.removeBlocks(c.document);
              },
              children: "一鍵清空內容"
            }
          ),
          /* @__PURE__ */ C(
            D,
            {
              type: "primary",
              onClick: v,
              loading: B,
              children: "儲存內容"
            }
          )
        ] }),
        fullWidth: y,
        children: [
          /* @__PURE__ */ C(
            to,
            {
              className: "at-mb-4",
              message: "注意事項",
              description: /* @__PURE__ */ h("ol", { className: "at-pl-4", children: [
                /* @__PURE__ */ C("li", { children: "可以使用 WordPress shortcode" }),
                /* @__PURE__ */ C("li", { children: "未來有新功能持續擴充" })
              ] }),
              type: "warning",
              showIcon: !0,
              closable: !0
            }
          ),
          /* @__PURE__ */ C(ng, { ...f })
        ]
      }
    )
  ] });
};
function dF(A) {
  if (!A)
    return "您必須安裝並啟用 Elementor 外掛才可以使用 Elementor 編輯";
}
function pF(A) {
  if (typeof A == "string")
    return A;
  if (Array.isArray(A)) {
    if (A.length === 1)
      return A[0];
    const [o, ...e] = A;
    return `${o}[${e.join("][")}]`;
  }
  return JSON.stringify(A);
}
const _f = x(uF), { Item: hF } = j, mF = ({
  name: A = ["short_description"],
  resource: o = "posts",
  dataProviderName: e = "default",
  buttonProps: t,
  parseData: n = (r) => r
}) => {
  const r = j.useFormInstance(), { mutate: a, isLoading: g } = wt({
    resource: o,
    dataProviderName: e,
    ...Do
  }), s = j.useWatch(["id"], r), { blockNoteViewProps: i } = tg(), { editor: l } = i, { drawerProps: B, show: K, close: F } = jr(), Q = B.opacity === 1, f = async () => {
    const u = PF(A), d = await Pr(l), P = r.getFieldsValue(), v = n({
      ...P,
      [u]: d
    });
    a(
      {
        id: s,
        values: v
      },
      {
        onSuccess: () => {
          F();
        }
      }
    );
  };
  $(() => {
    try {
      if (s && Q && l) {
        const u = r.getFieldValue(A), d = typeof u == "string" ? u : "";
        async function P() {
          const v = await l.tryParseHTMLToBlocks(d);
          l.replaceBlocks(l.document, v);
        }
        P();
      }
      !s && Q && l && l.removeBlocks(l.document);
    } catch (u) {
      console.error(u);
    }
  }, [s, Q, l]);
  const [c, U] = L(!1);
  return /* @__PURE__ */ h(k, { children: [
    /* @__PURE__ */ C(
      D,
      {
        icon: /* @__PURE__ */ C(Ho, {}),
        iconPosition: "end",
        onClick: K,
        color: "primary",
        variant: "filled",
        ...t,
        children: "開始編輯"
      }
    ),
    /* @__PURE__ */ C(hF, { name: A, hidden: !0 }),
    /* @__PURE__ */ h(
      yr,
      {
        ...B,
        closeConfirm: !0,
        title: "編輯內容",
        footer: /* @__PURE__ */ h("div", { className: "at-flex at-gap-x-4", children: [
          /* @__PURE__ */ C(
            D,
            {
              type: "default",
              onClick: () => {
                U((u) => !u);
              },
              children: c ? "退出全螢幕編輯" : "全螢幕編輯"
            }
          ),
          /* @__PURE__ */ C(
            D,
            {
              type: "default",
              danger: !0,
              onClick: () => {
                l.removeBlocks(l.document);
              },
              children: "一鍵清空內容"
            }
          ),
          /* @__PURE__ */ C(
            D,
            {
              type: "primary",
              onClick: f,
              loading: g,
              children: "儲存內容"
            }
          )
        ] }),
        fullWidth: c,
        children: [
          /* @__PURE__ */ C(
            to,
            {
              className: "at-mb-4",
              message: "注意事項",
              description: /* @__PURE__ */ h("ol", { className: "at-pl-4", children: [
                /* @__PURE__ */ C("li", { children: "可以使用 WordPress shortcode" }),
                /* @__PURE__ */ C("li", { children: "未來有新功能持續擴充" })
              ] }),
              type: "warning",
              showIcon: !0,
              closable: !0
            }
          ),
          /* @__PURE__ */ C(ng, { ...i })
        ]
      }
    )
  ] });
};
function PF(A) {
  if (typeof A == "string")
    return A;
  if (Array.isArray(A)) {
    if (A.length === 1)
      return A[0];
    const [o, ...e] = A;
    return `${o}[${e.join("][")}]`;
  }
  return JSON.stringify(A);
}
const $f = x(mF), sr = ({ name: A, id: o, className: e }) => /* @__PURE__ */ h("div", { className: Z("at-flex at-items-end at-gap-x-1", e), children: [
  /* @__PURE__ */ C("div", { className: "at-name at-min-w-0 at-m-0 [&_*]:at-truncate", children: A }),
  /* @__PURE__ */ C(
    "div",
    {
      className: "at-id at-my-0 at-ml-0 at-text-gray-400 at-text-[0.75em] at-font-light at-shrink-0",
      style: {
        lineHeight: "normal"
      },
      children: o && `#${o}`
    }
  )
] }), vF = ({ name: A, id: o, className: e, tooltipProps: t = null }) => {
  const r = typeof A == "string" ? Ht(A) : A;
  return t === null ? /* @__PURE__ */ C(sr, { name: r, id: o, className: e }) : /* @__PURE__ */ C(k, { children: /* @__PURE__ */ h(W, { title: r, ...t, children: [
    /* @__PURE__ */ C(sr, { name: r, id: o, className: e }),
    " "
  ] }) });
}, me = x(vF), rg = (A) => {
  const { onDone: o, onError: e, onRemoved: t, onUploading: n } = A || {}, { NONCE: r } = bo(), [a, g] = L([]), [s, i] = L(
    void 0
  ), [l, B] = L(!1), K = jA(), F = ({ file: f }) => {
    var U;
    const { status: c } = f;
    if (c === "uploading" && (n && n(f), g([f]), B(!0)), c === "done") {
      const u = (U = f == null ? void 0 : f.response) == null ? void 0 : U.data, d = Number(u == null ? void 0 : u.id) || void 0;
      g([]), i(d), B(!1), o && o(f, u);
    }
    c === "error" && (g([]), B(!1), e && e(f)), c === "removed" && (g([]), B(!1), t && t(f));
  };
  return {
    uploadProps: {
      name: "files",
      // accept: 'image/*',
      action: `${K}/upload`,
      headers: {
        // 'Content-Type': 'multipart/form-data', // 不需要手動設置 multipart/form-data 不然會得到 "Missing boundary in multipart/form-data POST data" 錯誤
        // Authorization: `Basic ${btoa(USERNAME + ':' + PASSWORD)}`, // WP 網站的話用 cookie 驗證就OK
        "X-WP-Nonce": r
      },
      maxCount: 1,
      withCredentials: !0,
      fileList: a,
      onChange: F,
      showUploadList: !1
    },
    fileList: a,
    setFileList: g,
    attachmentId: s,
    isUploading: l
  };
}, { Item: wF } = j, { Dragger: yF } = Qe, bF = () => {
  var a, g;
  const { uploadProps: A, fileList: o, setFileList: e } = rg(), t = j.useFormInstance(), n = j.useWatch(["id"], t);
  $(() => {
    if (n) {
      const s = t.getFieldValue(["files"]);
      e([
        {
          uid: "-1",
          name: "feature_image_url.png",
          status: "done",
          url: s
        }
      ]);
    }
  }, [n]);
  const r = (s) => {
    s.stopPropagation(), e([]);
  };
  return /* @__PURE__ */ h("div", { className: "at-flex at-justify-center at-w-full at-mb-4", children: [
    /* @__PURE__ */ C(
      yg,
      {
        aspect: 1.778,
        quality: 1,
        rotationSlider: !0,
        showReset: !0,
        resetText: "重置",
        showGrid: !0,
        onModalCancel: (s) => {
          s(Qe.LIST_IGNORE);
        },
        modalProps: {
          zIndex: 999999
        },
        children: /* @__PURE__ */ h(yF, { ...A, children: [
          /* @__PURE__ */ C("p", { className: "ant-upload-drag-icon", children: /* @__PURE__ */ C(Ds, {}) }),
          /* @__PURE__ */ C("p", { className: "ant-upload-text", children: "點擊或拖曳文件到這裡上傳" }),
          /* @__PURE__ */ C("p", { className: "ant-upload-hint", children: "僅支持 image/* 類型 文件" }),
          o.length > 0 && ((a = o == null ? void 0 : o[0]) == null ? void 0 : a.url) && /* @__PURE__ */ C("div", { className: "at-size-full at-absolute at-top-0 at-left-0 at-p-2", children: /* @__PURE__ */ h("div", { className: "at-size-full at-rounded-lg at-overflow-hidden", children: [
            /* @__PURE__ */ C(
              "img",
              {
                src: (g = o == null ? void 0 : o[0]) == null ? void 0 : g.url,
                className: "at-size-full at-object-cover"
              }
            ),
            /* @__PURE__ */ C(
              "div",
              {
                onClick: r,
                className: "at-group at-absolute at-top-4 at-right-4 at-rounded-md at-size-12 at-bg-white at-shadow-lg at-flex at-justify-center at-items-center at-transition at-duration-300 hover:at-bg-red-500 at-cursor-pointer",
                children: /* @__PURE__ */ C(fe, { className: "at-text-red-500 group-hover:at-text-white" })
              }
            )
          ] }) })
        ] })
      }
    ),
    /* @__PURE__ */ C(wF, { name: ["files"], hidden: !0, children: /* @__PURE__ */ C(J, {}) })
  ] });
}, AU = x(bF), HF = ({
  iconClassName: A = "",
  collapsed: o = !1,
  href: e = ""
}) => {
  const { SITE_URL: t = "" } = bo();
  return /* @__PURE__ */ C(
    "a",
    {
      href: e || `${t}/wp-admin/`,
      className: "hover:at-opacity-75 at-transition at-duration-300",
      children: /* @__PURE__ */ h("div", { className: "at-flex at-gap-4 at-items-center", children: [
        /* @__PURE__ */ C(k, { children: /* @__PURE__ */ h(
          "svg",
          {
            className: Z("at-size-6", A),
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              /* @__PURE__ */ C(
                "path",
                {
                  opacity: "1",
                  d: "M16.19 2H7.82C4.17 2 2 4.17 2 7.81V16.18C2 19.82 4.17 21.99 7.81 21.99H16.18C19.82 21.99 21.99 19.82 21.99 16.18V7.81C22 4.17 19.83 2 16.19 2Z",
                  fill: "#eee"
                }
              ),
              /* @__PURE__ */ C(
                "path",
                {
                  d: "M13.9195 8.48006H8.76945L9.09945 8.15006C9.38945 7.86006 9.38945 7.38006 9.09945 7.09006C8.80945 6.80006 8.32945 6.80006 8.03945 7.09006L6.46945 8.66006C6.17945 8.95006 6.17945 9.43006 6.46945 9.72006L8.03945 11.2901C8.18945 11.4401 8.37945 11.5101 8.56945 11.5101C8.75945 11.5101 8.94945 11.4401 9.09945 11.2901C9.38945 11.0001 9.38945 10.5201 9.09945 10.2301L8.83945 9.97006H13.9195C15.1995 9.97006 16.2495 11.0101 16.2495 12.3001C16.2495 13.5901 15.2094 14.6301 13.9195 14.6301H8.99945C8.58945 14.6301 8.24945 14.9701 8.24945 15.3801C8.24945 15.7901 8.58945 16.1301 8.99945 16.1301H13.9195C16.0295 16.1301 17.7495 14.4101 17.7495 12.3001C17.7495 10.1901 16.0295 8.48006 13.9195 8.48006Z",
                  fill: "#21759B"
                }
              )
            ]
          }
        ) }),
        !o && /* @__PURE__ */ C("span", { className: "at-text-gray-600 at-font-light", children: "回網站後台" })
      ] })
    }
  );
}, oU = x(HF), { Search: DF } = J, NF = ({
  setSearch: A,
  loading: o,
  ...e
}) => {
  const { selectedItems: t, setSelectedItems: n } = Ot(), { mutate: r, isLoading: a } = Fg(), g = () => {
    const s = t.map((i) => i.id);
    r(
      {
        resource: "posts",
        ids: s,
        // mutationMode: 'undoable',
        ...Do
      },
      {
        onSuccess: () => {
          n([]);
        }
      }
    );
  };
  return /* @__PURE__ */ h("div", { className: "pc-media-library__tabs__filter at-w-full at-flex at-flex-col xl:at-flex-row at-items-center xl:at-justify-between at-sticky at-backdrop-blur-sm at-z-[18] at-top-0 at-py-2 at-mb-4 at-gap-y-2 xl:at-gap-y-0", children: [
    /* @__PURE__ */ C(
      DF,
      {
        placeholder: "搜尋關鍵字，按 ENTER 也能搜",
        className: "at-w-full xl:at-w-[20rem]",
        allowClear: !0,
        onSearch: (s) => A(s),
        enterButton: !0,
        loading: o,
        ...e
      }
    ),
    /* @__PURE__ */ h("div", { className: "at-flex at-items-center at-gap-2", children: [
      /* @__PURE__ */ h("p", { className: "at-hidden xl:at-block at-text-sm at-m-0 at-text-gray-500", children: [
        "已經選取 ",
        (t == null ? void 0 : t.length) ?? 0,
        " 個檔案"
      ] }),
      /* @__PURE__ */ C(D, { onClick: () => n([]), children: "清空選取" }),
      /* @__PURE__ */ C(
        Kr,
        {
          title: "確定要刪除這些檔案嗎？",
          onConfirm: g,
          okText: "刪除",
          cancelText: "取消",
          children: /* @__PURE__ */ h(
            D,
            {
              disabled: !(t != null && t.length),
              loading: a,
              type: "primary",
              danger: !0,
              children: [
                "批量刪除 ",
                t != null && t.length ? `(${t == null ? void 0 : t.length})` : ""
              ]
            }
          )
        }
      )
    ] })
  ] });
}, xF = x(NF), { Item: jF } = j, kF = ({ item: A }) => {
  const [o] = j.useForm(), { SITE_URL: e } = bo(), { id: t, url: n, img_url: r = "", type: a = "", slug: g = "" } = A, { mutate: s, isLoading: i } = wt({
    resource: "posts"
  });
  if (!g)
    return null;
  const l = () => {
    const c = o.getFieldsValue();
    s({
      id: t,
      values: c,
      ...Do
    });
  }, B = yo(n), K = Dt(n), F = dr(n), Q = ur(n);
  return /* @__PURE__ */ h(k, { children: [
    K && /* @__PURE__ */ C(
      "img",
      {
        className: "at-w-full at-rounded-md at-aspect-square at-object-contain",
        src: r
      }
    ),
    F && /* @__PURE__ */ C(
      "video",
      {
        preload: "metadata",
        src: n,
        controls: !0,
        className: "at-w-full at-rounded-md"
      }
    ),
    Q && /* @__PURE__ */ C(
      "audio",
      {
        preload: "metadata",
        src: n,
        controls: !0,
        className: "at-w-full at-rounded-md"
      }
    ),
    !K && !F && !Q && /* @__PURE__ */ C("div", { className: "at-w-full at-rounded-md at-text-center at-object-contain", children: /* @__PURE__ */ C(Xt, { ext: B, className: "at-size-3/4" }) }),
    /* @__PURE__ */ h("div", { className: "at-flex at-gap-2 at-my-4", children: [
      /* @__PURE__ */ C(xr, { text: n, children: /* @__PURE__ */ C(D, { type: "default", icon: /* @__PURE__ */ C(Lt, {}), iconPosition: "end", children: "複製下載連結" }) }),
      /* @__PURE__ */ C(W, { title: "新分頁打開", children: /* @__PURE__ */ C(D, { icon: /* @__PURE__ */ C(Ho, {}), href: n, target: "_blank" }) }),
      /* @__PURE__ */ C(W, { title: "傳統介面檢視", children: /* @__PURE__ */ C(
        D,
        {
          icon: /* @__PURE__ */ C(Ti, { className: "at-text-gray-400" }),
          href: `${e}/wp-admin/upload.php?item=${t}`,
          target: "_blank"
        }
      ) }),
      /* @__PURE__ */ C(W, { title: "刪除檔案", children: /* @__PURE__ */ C(
        Hr,
        {
          hideText: !0,
          resource: "posts",
          recordItemId: t,
          confirmTitle: "確認刪除檔案嗎?",
          confirmOkText: "確認",
          confirmCancelText: "取消"
        }
      ) })
    ] }),
    /* @__PURE__ */ h(j, { form: o, children: [
      /* @__PURE__ */ C("table", { className: "table table-xs table-vertical at-mb-4 [&_th]:at-text-left at-w-full", children: /* @__PURE__ */ C("tbody", { children: Object.entries(A).map(([c, U], u) => {
        if (c === "img_url" || c === "_wp_attachment_image_alt" && K)
          return null;
        const d = {
          _wp_attachment_image_alt: "alt",
          short_description: "caption"
        };
        return /* @__PURE__ */ h("tr", { children: [
          /* @__PURE__ */ C("th", { children: /* @__PURE__ */ C("div", {
            // @ts-ignore
            children: We((d == null ? void 0 : d[c]) || c)
          }) }),
          /* @__PURE__ */ C("td", { className: "at-break-all", children: SF(c, U) })
        ] }, c);
      }) }) }),
      /* @__PURE__ */ C("div", { className: "at-flex at-justify-end", children: /* @__PURE__ */ C(
        D,
        {
          variant: "solid",
          color: "primary",
          onClick: l,
          loading: i,
          children: "儲存"
        }
      ) })
    ] })
  ] });
};
function SF(A, o, e) {
  return A === "author" ? /* @__PURE__ */ h(k, { children: [
    "由 ",
    o == null ? void 0 : o.name,
    " 上傳"
  ] }) : ["_wp_attachment_image_alt", "short_description", "description"].includes(
    A
  ) ? /* @__PURE__ */ C(jF, { name: A, noStyle: !0, children: /* @__PURE__ */ C(J, { size: "small" }) }) : /* @__PURE__ */ C(k, { children: Ur(o) });
}
const RF = x(kF), { Text: LF } = Qr, TF = ({
  item: A,
  allItems: o,
  index: e
}) => {
  const { selectedItems: t, setSelectedItems: n, limit: r, mime: a } = Ot(), g = t == null ? void 0 : t.some(
    (B) => B.id === A.id
  ), s = (B) => {
    var f;
    if (!a.validate((A == null ? void 0 : A.mime) || "")) {
      AA.warning({
        key: "limit",
        content: "不允許選取此類型的檔案"
      });
      return;
    }
    const K = t != null && t.length ? (f = t == null ? void 0 : t.slice(-1)) == null ? void 0 : f[0] : null, F = o.findIndex(
      (c) => c.id === (K == null ? void 0 : K.id)
    ), Q = F === -1 ? 0 : F;
    if (B.shiftKey && Q !== e) {
      n((c) => {
        const U = Math.min(Q, e), u = Math.max(Q, e), d = o.slice(U, u + 1);
        return mr([...c, ...d], "id");
      });
      return;
    }
    if (g)
      n((c) => c.filter((U) => U.id !== A.id));
    else {
      if (r && t.length >= r) {
        AA.warning({
          key: "limit",
          content: `最多只能選取${r}個檔案`
        }), n((c) => [...c.slice(1), A]);
        return;
      }
      n((c) => [...c, A]);
    }
  }, i = Dt(A == null ? void 0 : A.url), l = yo(A == null ? void 0 : A.url);
  return /* @__PURE__ */ h("div", { className: "at-w-full xl:at-w-36 at-relative", children: [
    i && /* @__PURE__ */ C(
      "img",
      {
        onClick: s,
        className: `at-rounded-md at-w-full at-object-contain at-cursor-pointer at-aspect-square ${g ? "at-outline at-outline-4 at-outline-yellow-300 at-outline-offset-1" : ""}`,
        src: A == null ? void 0 : A.img_url
      }
    ),
    !i && /* @__PURE__ */ C(
      "div",
      {
        onClick: s,
        className: `at-cursor-pointer at-rounded-md  ${g ? "at-outline at-outline-4 at-outline-yellow-300 at-outline-offset-1" : ""}`,
        children: /* @__PURE__ */ C(
          Xt,
          {
            ext: l,
            className: "at-w-full at-object-contain at-aspect-square"
          }
        )
      }
    ),
    /* @__PURE__ */ C(LF, { className: "at-text-xs at-text-gray-800", ellipsis: !0, children: A == null ? void 0 : A.title }),
    g && /* @__PURE__ */ C("div", { className: "at-bg-white at-absolute -at-top-2 -at-right-2 at-z-[15] at-size-6 at-rounded-full at-flex at-items-center at-justify-center", children: /* @__PURE__ */ C(Tt, { className: "at-size-5 [&_path]:at-fill-yellow-300" }) })
  ] });
}, OF = x(TF), ir = 50, XF = () => {
  const { SITE_URL: A } = bo(), o = kA(), e = Bs($g), { uploadProps: t, selectedItems: n } = Ot(), { uploadProps: r } = rg({
    onUploading: (d) => {
      e && e((P) => {
        const v = P.findIndex((y) => y.uid === d.uid);
        return v === -1 ? [...P, d] : P.map((y, w) => w === v ? d : y);
      });
    },
    onDone: (d, P) => {
      o({
        resource: "posts",
        invalidates: ["list"]
      }), e && e((v) => {
        const y = v.findIndex((w) => w.uid === d.uid);
        return y !== -1 ? v.map((w, N) => N === y ? d : w) : v;
      });
    },
    onError: (d) => {
      e && e((P) => {
        const v = P.findIndex((y) => y.uid === d.uid);
        return v !== -1 ? P.map((y, w) => w === v ? d : y) : P;
      });
    }
  }), a = hr(null), [g, s] = L(!1);
  $(() => {
    if (a.current) {
      const d = (y) => {
        var N;
        y.preventDefault(), y.stopPropagation();
        const w = y.relatedTarget;
        (N = a.current) != null && N.contains(w) || s(!0);
      }, P = (y) => {
        var N;
        y.preventDefault(), y.stopPropagation();
        const w = y.relatedTarget;
        (N = a.current) != null && N.contains(w) || s(!1);
      }, v = (y) => {
        s(!1);
      };
      return a.current.addEventListener("dragenter", d), a.current.addEventListener("dragleave", P), a.current.addEventListener("drop", v), () => {
        var y, w, N;
        (y = a.current) == null || y.removeEventListener("dragenter", d), (w = a.current) == null || w.removeEventListener("dragleave", P), (N = a.current) == null || N.removeEventListener("drop", v);
      };
    }
  }, []);
  const [i, l] = L(""), {
    data: B,
    isError: K,
    hasNextPage: F,
    fetchNextPage: Q,
    isFetchingNextPage: f,
    isLoading: c
  } = lr({
    resource: "posts",
    pagination: {
      pageSize: ir
    },
    filters: Mt({
      s: i,
      post_type: "attachment",
      post_status: "inherit",
      post_parent: "unset"
    })
  }), U = [].concat(
    ...((B == null ? void 0 : B.pages) ?? []).map((d) => (d == null ? void 0 : d.data) || [])
  ), u = c && !f;
  return K ? /* @__PURE__ */ C(
    Fr,
    {
      status: "error",
      title: "獲取檔案失敗",
      subTitle: "API 回應錯誤，請聯繫網站管理人員或稍候再嘗試"
    }
  ) : /* @__PURE__ */ h("div", { ref: a, className: "at-relative", children: [
    /* @__PURE__ */ C(
      to,
      {
        message: "檔案上傳中可以離開此頁，但不要「重新整理」頁面，「重新整理」會導致上傳中斷",
        banner: !0,
        className: "at-mb-8"
      }
    ),
    /* @__PURE__ */ C(
      "div",
      {
        className: `at-absolute at-top-0 at-left-0 at-size-full ${g ? "at-opacity-100 at-z-10" : "at-opacity-0 -at-z-50"}`,
        children: /* @__PURE__ */ C(
          ms,
          {
            uploadProps: {
              ...r,
              ...t
            }
          }
        )
      }
    ),
    /* @__PURE__ */ h("div", { className: Z(g ? "at-opacity-0" : "at-opacity-100"), children: [
      /* @__PURE__ */ h("div", { className: "at-flex at-justify-end at-mb-8 at-gap-x-2", children: [
        /* @__PURE__ */ C(D, { href: `${A}/wp-admin/upload.php`, target: "_blank", children: "前往傳統媒體庫介面" }),
        /* @__PURE__ */ C(Qe, { ...r, ...t, children: /* @__PURE__ */ C(D, { icon: /* @__PURE__ */ C(kt, {}), children: "上傳檔案" }) })
      ] }),
      /* @__PURE__ */ C(
        xF,
        {
          setSearch: l,
          disabled: c,
          loading: u
        }
      ),
      /* @__PURE__ */ h("div", { className: "at-flex at-flex-col xl:at-flex-row", children: [
        /* @__PURE__ */ C("div", { className: "at-w-full xl:at-w-[28rem] xl:at-order-2 at-mb-8 xl:at-mb-0", children: (n == null ? void 0 : n.length) > 0 && /* @__PURE__ */ C(RF, { item: n.slice(-1)[0] }) }),
        /* @__PURE__ */ h("div", { className: "at-flex-1 xl:at-order-1", children: [
          /* @__PURE__ */ h("div", { className: "at-grid at-px-2 at-grid-cols-3 md:at-grid-cols-4 xl:at-flex xl:at-flex-wrap at-gap-4", children: [
            !u && U.map((d, P) => /* @__PURE__ */ C(
              OF,
              {
                item: d,
                index: P,
                allItems: U
              },
              d.id
            )),
            (c || f) && new Array(ir).fill(0).map((d, P) => /* @__PURE__ */ h("div", { className: "at-w-full xl:at-w-36", children: [
              /* @__PURE__ */ C(Zo, { className: "at-aspect-square" }),
              /* @__PURE__ */ C(Zo, { className: "at-h-3 !at-p-0 at-rounded-sm", children: " " })
            ] }, P))
          ] }),
          !(U != null && U.length) && !c && /* @__PURE__ */ C(Vo, { className: "at-my-24", description: "找不到檔案資料" }),
          F && /* @__PURE__ */ C("div", { className: "at-text-center at-mt-8", children: /* @__PURE__ */ C(
            D,
            {
              type: "link",
              onClick: () => Q(),
              disabled: c,
              loading: f,
              children: "顯示更多"
            }
          ) })
        ] })
      ] })
    ] })
  ] });
}, zF = (A) => /* @__PURE__ */ C(hs.Provider, { value: A, children: /* @__PURE__ */ C(XF, {}) }), IF = x(
  zF
), GF = ({
  modalProps: A,
  mediaLibraryProps: o
}) => /* @__PURE__ */ C(wr, { ...A, children: /* @__PURE__ */ C(IF, { ...o }) }), WF = x(GF), VF = ({ id: A, invalidateProps: o, tooltipProps: e, buttonProps: t, children: n }) => {
  const { mutate: r, isLoading: a } = eo(), g = jA(), s = kA();
  return /* @__PURE__ */ C(k, { children: /* @__PURE__ */ C(W, { title: "複製", ...e, children: /* @__PURE__ */ C(
    D,
    {
      type: "text",
      className: "text-gray-400 m-0",
      icon: /* @__PURE__ */ C(Lt, {}),
      onClick: () => {
        r(
          {
            url: `${g}/copy/${A}`,
            method: "post",
            values: {},
            ...Do
          },
          {
            onSuccess: (l, B, K) => {
              s({ invalidates: ["list"], ...o });
            }
          }
        );
      },
      loading: a,
      ...t,
      children: n
    }
  ) }) });
}, eU = x(VF), MF = ({
  record: A,
  onClick: o,
  renderTitle: e,
  renderBelowTitle: t,
  hideImage: n = !1,
  imageProps: r,
  className: a
}) => {
  var c;
  const {
    id: g = "",
    sku: s = "",
    name: i = "",
    images: l = [],
    attribute_summary: B = ""
  } = A, K = n ? void 0 : ((c = l == null ? void 0 : l[0]) == null ? void 0 : c.url) || YA, f = [s ? `SKU: ${s}` : "", B].filter((U) => !!U).join(", ");
  return /* @__PURE__ */ C(k, { children: /* @__PURE__ */ h("div", { className: Z("at-flex at-items-center", a), children: [
    !n && /* @__PURE__ */ C("div", { className: "at-mr-4", children: /* @__PURE__ */ C(
      cr,
      {
        className: "product-image at-rounded-lg at-object-cover",
        preview: {
          mask: /* @__PURE__ */ C(Vt, {}),
          maskClassName: "at-rounded-lg"
        },
        width: 40,
        height: 40,
        src: K || YA,
        fallback: YA,
        ...r
      }
    ) }),
    /* @__PURE__ */ h(
      "div",
      {
        className: `at-flex-1 at-min-w-0 ${o ? "at-cursor-pointer hover:at-opacity-75" : ""}`,
        onClick: o ? () => o(A) : void 0,
        children: [
          e || /* @__PURE__ */ C(
            me,
            {
              className: "at-text-primary at-text-base",
              name: i,
              id: g
            }
          ),
          t || /* @__PURE__ */ C("div", { className: "product-meta at-flex at-text-[0.625rem] at-text-gray-500", children: f })
        ]
      }
    )
  ] }) });
}, tU = x(
  MF
);
function Cr(A) {
  return BA({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M416 199.5h-91.4V64H187.4v135.5H96l160 158.1 160-158.1zM96 402.8V448h320v-45.2H96z" }, child: [] }] })(A);
}
const EF = ({
  record: A,
  hideDownloadable: o = !0,
  renderBefore: e,
  renderAfter: t
}) => {
  const {
    type: n = "simple",
    featured: r = !1,
    virtual: a = !1,
    downloadable: g = !1
  } = A, { product_types: s } = ko(), i = s == null ? void 0 : s.find((l) => l.value === n);
  return n ? /* @__PURE__ */ h("div", { className: "at-flex at-items-center at-gap-2", children: [
    e,
    /* @__PURE__ */ C(fr, { bordered: !1, color: i == null ? void 0 : i.color, className: "at-m-0", children: i == null ? void 0 : i.label }),
    /* @__PURE__ */ C(W, { zIndex: 1000020, title: `${r ? "" : "非"}精選商品`, children: Fo(r) ? /* @__PURE__ */ C(Gr, { className: "at-text-yellow-400" }) : /* @__PURE__ */ C(Wr, { className: "at-text-gray-400" }) }),
    /* @__PURE__ */ C(W, { zIndex: 1000020, title: `${a ? "" : "非"}虛擬商品`, children: Fo(a) ? /* @__PURE__ */ C(Lr, { className: "at-text-primary" }) : /* @__PURE__ */ C(Tr, { className: "at-text-gray-400" }) }),
    !o && /* @__PURE__ */ C(
      W,
      {
        zIndex: 1000020,
        title: `${g ? "" : "不"}可下載`,
        children: Fo(g) ? /* @__PURE__ */ C(Cr, { className: "at-text-gray-700" }) : /* @__PURE__ */ C(Cr, { className: "at-text-gray-300" })
      }
    ),
    t
  ] }) : null;
}, nU = x(
  EF
), qF = ({
  record: A
}) => {
  const { price_html: o } = A;
  return o ? /* @__PURE__ */ C("div", { className: "at-product-price", children: Ht(o) }) : null;
}, rU = x(
  qF
), Ge = {
  day: "日",
  month: "月",
  year: "年"
}, JF = ({
  items: A,
  className: o,
  hideName: e = !1
}) => A.map(({ id: t, name: n, limit_type: r, limit_value: a, limit_unit: g }) => /* @__PURE__ */ h(
  "div",
  {
    className: Z(
      "at-grid at-grid-cols-[12rem_8rem] at-gap-1 at-my-1",
      o
    ),
    children: [
      /* @__PURE__ */ h("div", { children: [
        e && /* @__PURE__ */ C(W, { title: n || "未知的名稱", children: /* @__PURE__ */ h("span", { className: "at-text-gray-400 at-text-xs", children: [
          "#",
          t
        ] }) }),
        !e && /* @__PURE__ */ C(me, { name: n || "未知的名稱", id: t, tooltipProps: {} })
      ] }),
      /* @__PURE__ */ C("div", { children: /* @__PURE__ */ C(fr, { children: ZF(r, a, g) }) })
    ]
  },
  t
)), aU = x(JF);
function ZF(A, o, e) {
  switch (A) {
    case "unlimited":
      return "無期限";
    case "follow_subscription":
      return "跟隨訂閱";
    case "fixed":
      return `訂單完成後 ${o} ${(Ge == null ? void 0 : Ge[e]) || ""}`;
    case "assigned":
      return `至 ${qo.unix(o).format("YYYY/MM/DD HH:mm")}`;
  }
}
const YF = ({
  record: A,
  onClick: o,
  renderTitle: e,
  renderBelowTitle: t,
  hideImage: n = !1,
  imageProps: r
}) => {
  const { display_name: a, user_email: g, id: s, user_avatar_url: i } = A;
  return /* @__PURE__ */ h("div", { className: "at-flex at-items-center", children: [
    !n && /* @__PURE__ */ C("div", { className: "at-mr-4", children: /* @__PURE__ */ C(
      cr,
      {
        className: "at-rounded-full at-object-cover",
        preview: {
          mask: /* @__PURE__ */ C(Vt, {}),
          maskClassName: "at-rounded-full"
        },
        src: i || YA,
        fallback: YA,
        width: 40,
        height: 40,
        ...r
      }
    ) }),
    /* @__PURE__ */ h(
      "div",
      {
        className: `at-flex-1 at-min-w-0 ${o ? "at-cursor-pointer hover:at-opacity-75" : ""}`,
        onClick: o ? () => o(A) : void 0,
        children: [
          e || /* @__PURE__ */ C(me, { className: "at-text-base", name: a, id: s }),
          t || /* @__PURE__ */ C("p", { className: "at-my-0 at-text-xs at-text-gray-400", children: g })
        ]
      }
    )
  ] });
}, gU = x(YF);
function ag({ selectProps: A, useSelectProps: o }) {
  const [e, t] = L([]), { selectProps: n } = br({
    optionLabel: (a) => a.name,
    optionValue: (a) => a.id,
    debounce: 500,
    pagination: {
      pageSize: 20,
      mode: "server"
    },
    onSearch: (a) => [
      {
        field: "s",
        operator: "contains",
        value: a
      }
    ],
    ...o
  });
  return {
    selectProps: {
      ...wA,
      ...A,
      ...n,
      value: e,
      onChange: (a) => {
        t(a);
      }
    },
    itemIds: e,
    setItemIds: t
  };
}
const ko = () => {
  var n;
  const A = jA(), { data: o, isLoading: e } = cg({
    url: `${A}/woocommerce`,
    method: "get",
    queryOptions: {
      queryKey: ["woocommerce"]
    }
  }), t = ((n = o == null ? void 0 : o.data) == null ? void 0 : n.data) || lg;
  return e || mg(Bg, t), t;
}, sU = () => {
  const A = ko();
  return A == null ? void 0 : A.countries;
}, iU = () => {
  const A = ko(), o = (A == null ? void 0 : A.countries) || [];
  return Object.entries(o).map(([e, t]) => ({
    label: t,
    value: e
  }));
}, CU = () => {
  const A = ko();
  return (A == null ? void 0 : A.product_taxonomies) || [];
};
export {
  FF as $,
  $i as A,
  oU as B,
  eU as C,
  st as D,
  Vf as E,
  gt as F,
  Lf as G,
  FA as H,
  Vr as I,
  Mf as J,
  Mr as K,
  Oi as L,
  IF as M,
  Zo as N,
  bF as O,
  tU as P,
  Bi as Q,
  Tf as R,
  Yo as S,
  xf as T,
  gU as U,
  jf as V,
  Ef as W,
  CC as X,
  qf as Y,
  Jf as Z,
  ng as _,
  AU as a,
  tg as a0,
  _f as a1,
  $f as a2,
  me as a3,
  YA as a4,
  Df as a5,
  Nf as a6,
  yf as a7,
  bf as a8,
  Hf as a9,
  NC as aA,
  xC as aB,
  Jr as aC,
  $o as aD,
  kC as aE,
  rg as aF,
  xF as aG,
  RF as aH,
  OF as aI,
  XF as aJ,
  wA as aa,
  vf as ab,
  wf as ac,
  fC as ad,
  UC as ae,
  uC as af,
  hC as ag,
  mC as ah,
  yC as ai,
  bC as aj,
  SC as ak,
  RC as al,
  eF as am,
  Ui as an,
  ui as ao,
  cn as ap,
  zi as aq,
  Ii as ar,
  Vi as as,
  Mi as at,
  Yi as au,
  AC as av,
  nC as aw,
  qr as ax,
  wC as ay,
  DC as az,
  WF as b,
  nU as c,
  rU as d,
  aU as e,
  ko as f,
  sU as g,
  iU as h,
  CU as i,
  wi as j,
  yi as k,
  kf as l,
  Sf as m,
  Rf as n,
  Xf as o,
  ki as p,
  Ao as q,
  Of as r,
  Mt as s,
  If as t,
  ag as u,
  Gf as v,
  Wf as w,
  Do as x,
  zf as y,
  Li as z
};
